import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	DateTime: { input: string; output: string };
	JSON: { input: any; output: any };
	LowercaseString: { input: string; output: string };
	Password: { input: string; output: string };
	PhoneNumber: { input: string; output: string };
};

export enum AcceptDeadlineTypeV2 {
	Custom = 'CUSTOM',
	/**
	 * No expiration. Stored alongside a null acceptDeadline. The
	 * cron expiry job naturally skips rows with null acceptDeadline
	 * (SQL NULL semantics), so these offers stay alive indefinitely.
	 */
	Never = 'NEVER',
	OneWeek = 'ONE_WEEK',
	ThreeDays = 'THREE_DAYS',
	TwoWeeks = 'TWO_WEEKS',
}

export type AcceptOfferSelectionV2Input = {
	offerId: Scalars['ID']['input'];
	variations: Array<AcceptVariationSelectionV2Input>;
};

export type AcceptOffersV2Input = {
	invoiceRecipient: InvoiceRecipientInputV2;
	quoteV2Id: Scalars['ID']['input'];
	selectedOffers: Array<AcceptOfferSelectionV2Input>;
};

export type AcceptOffersV2Response = {
	__typename?: 'AcceptOffersV2Response';
	errors: Array<ResponseError>;
	message: Scalars['String']['output'];
	order?: Maybe<QuoteOrderV2>;
	success: Scalars['Boolean']['output'];
};

export type AcceptQuantitySelectionV2Input = {
	deliveryId: Scalars['ID']['input'];
	quantity: Scalars['Int']['input'];
	quantityId: Scalars['ID']['input'];
};

export type AcceptVariationSelectionV2Input = {
	quantities: Array<AcceptQuantitySelectionV2Input>;
	sampleChoice?: InputMaybe<SampleChoiceV2>;
	variationId: Scalars['ID']['input'];
};

export type AcquireStudioLockResponse = {
	__typename?: 'AcquireStudioLockResponse';
	lock?: Maybe<StudioLock>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export enum ActorTypeV2 {
	Admin = 'ADMIN',
	Client = 'CLIENT',
	Vetter = 'VETTER',
}

export type AddAdminAdjustmentToVariationV2Input = {
	calculationType: AdjustmentCalculationTypeV2;
	currency: CurrencyEnum;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	type: AdjustmentTypeV2;
	value: Scalars['Float']['input'];
	variationId: Scalars['ID']['input'];
};

export type AddAdminAdjustmentV2Input = {
	calculationType: AdjustmentCalculationTypeV2;
	currency: CurrencyEnum;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	offerId: Scalars['ID']['input'];
	type: AdjustmentTypeV2;
	value: Scalars['Float']['input'];
};

export type AddOfferToBatchV2Input = {
	batchId: Scalars['ID']['input'];
	productOffer: CreateProductOfferV2Input;
};

export type AddQuoteItemV2Input = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	productId: Scalars['ID']['input'];
	quantities: Array<Scalars['Int']['input']>;
	quoteV2Id?: InputMaybe<Scalars['ID']['input']>;
};

export type AddStudioFileVersionMetadataInput = {
	canvasHeight: Scalars['Float']['input'];
	canvasWidth: Scalars['Float']['input'];
	comment?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	points?: InputMaybe<Array<PolygonPointInput>>;
	type: MetadataType;
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export enum AddressType {
	Billing = 'BILLING',
	Branch = 'BRANCH',
	Headquarters = 'HEADQUARTERS',
	Other = 'OTHER',
	Shipping = 'SHIPPING',
}

export type AddressValidationResult = {
	__typename?: 'AddressValidationResult';
	errors: Array<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
	warnings: Array<Scalars['String']['output']>;
};

export enum AdjustmentCalculationTypeV2 {
	Fixed = 'FIXED',
	Percentage = 'PERCENTAGE',
}

export enum AdjustmentCreatorTypeV2 {
	Admin = 'ADMIN',
	Vetter = 'VETTER',
}

export enum AdjustmentTypeV2 {
	Discount = 'DISCOUNT',
	Fee = 'FEE',
}

export type AdminActiveActivities = {
	__typename?: 'AdminActiveActivities';
	activities: Array<AdminActivity>;
};

export type AdminActivity =
	| AdminChatActivity
	| AdminOrderActivity
	| AdminQuoteActivity
	| AdminQuoteOfferActivity;

export enum AdminActivityType {
	OrderNewSampleRequestPending = 'ORDER_NEW_SAMPLE_REQUEST_PENDING',
	OrderProductProductionInProgress = 'ORDER_PRODUCT_PRODUCTION_IN_PROGRESS',
	OrderProductProductionPending = 'ORDER_PRODUCT_PRODUCTION_PENDING',
	OrderProductShipmentPending = 'ORDER_PRODUCT_SHIPMENT_PENDING',
	OrderSampleProductionInProgress = 'ORDER_SAMPLE_PRODUCTION_IN_PROGRESS',
	OrderSampleProductionPending = 'ORDER_SAMPLE_PRODUCTION_PENDING',
	OrderSampleSubmissionPending = 'ORDER_SAMPLE_SUBMISSION_PENDING',
	PendingQuote = 'PENDING_QUOTE',
	QuoteOfferAdminReview = 'QUOTE_OFFER_ADMIN_REVIEW',
	UnreadChatMessage = 'UNREAD_CHAT_MESSAGE',
}

export type AdminChatActivity = {
	__typename?: 'AdminChatActivity';
	context?: Maybe<ChatContext>;
	contextId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
	lastMessageAt: Scalars['DateTime']['output'];
	type: AdminActivityType;
	unreadCount: Scalars['Int']['output'];
};

export type AdminInvoiceDraftLineItemInputV2 = {
	/** Either 'product' or 'sample' — drives which ID field below is used. */
	kind: Scalars['String']['input'];
	/** Set when kind = 'product'. */
	orderItemId?: InputMaybe<Scalars['ID']['input']>;
	/** Set when kind = 'sample'. */
	sampleId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Admin-built invoice draft lifecycle.
 *   - draft: items selected, e-conomic draft minted, not yet sent.
 *   - booked: admin booked + sent — read-only thereafter.
 *   - cancelled: admin cancelled before booking; e-conomic draft deleted,
 *     items become invoiceable again automatically.
 */
export enum AdminInvoiceDraftStatus {
	Booked = 'booked',
	Cancelled = 'cancelled',
	Draft = 'draft',
}

export type AdminInvoiceDraftV2 = {
	__typename?: 'AdminInvoiceDraftV2';
	bookedAt?: Maybe<Scalars['DateTime']['output']>;
	cancelledAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	createdByUserId?: Maybe<Scalars['ID']['output']>;
	currency: Scalars['String']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	/** Set when cancel-on-booked issued a credit note that reversed economicBookedInvoiceNumber. */
	economicCreditNoteInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicDraftInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	lastError?: Maybe<Scalars['String']['output']>;
	/** Discriminated array — each item is either {kind:'product', orderItemId} or {kind:'sample', sampleId}. */
	lineItems: Scalars['JSON']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	organizationId: Scalars['ID']['output'];
	/** Purchase Order number from the buyer's AP — surfaced on the booked invoice as e-conomic references.other. */
	poNumber?: Maybe<Scalars['String']['output']>;
	recipientEmail?: Maybe<Scalars['String']['output']>;
	status: AdminInvoiceDraftStatus;
	title?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

/** Admin action required on an order — state transition blocked until admin acts. */
export type AdminOrderActivity = {
	__typename?: 'AdminOrderActivity';
	id: Scalars['ID']['output'];
	order?: Maybe<QuoteOrderV2>;
	orderId: Scalars['ID']['output'];
	type: AdminActivityType;
};

export type AdminQuoteActivity = {
	__typename?: 'AdminQuoteActivity';
	id: Scalars['ID']['output'];
	quote?: Maybe<QuoteV2>;
	quoteId: Scalars['ID']['output'];
	type: AdminActivityType;
};

export type AdminQuoteOfferActivity = {
	__typename?: 'AdminQuoteOfferActivity';
	id: Scalars['ID']['output'];
	quoteOffer?: Maybe<QuoteOfferV2>;
	quoteOfferId: Scalars['ID']['output'];
	type: AdminActivityType;
};

export type AdminSystemSetting = {
	__typename?: 'AdminSystemSetting';
	createdAt: Scalars['String']['output'];
	defaultApproval: Scalars['Boolean']['output'];
	defaultMargin: Scalars['Float']['output'];
	id: Scalars['ID']['output'];
	updatedAt: Scalars['String']['output'];
};

export type AdminUser = Base & {
	__typename?: 'AdminUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type AdminUserPage = {
	__typename?: 'AdminUserPage';
	data: Array<AdminUser>;
	pageInfo: PageInfo;
};

export type ApproveEarlyAccessResponse = {
	__typename?: 'ApproveEarlyAccessResponse';
	inviteToken: Scalars['String']['output'];
	message: Scalars['String']['output'];
};

export type ApproveNewSampleRoundV2Input = {
	adminNotes?: InputMaybe<Scalars['String']['input']>;
	approvalId: Scalars['ID']['input'];
	/**
	 * When true, this round's paid amount credits against the product
	 * invoice. Admin sets at greenlight; can change via setSampleDeductibilityV2.
	 */
	isDeductible?: InputMaybe<Scalars['Boolean']['input']>;
	nextSampleChoice?: InputMaybe<SampleChoiceV2>;
	overrideAdminCurrency?: InputMaybe<CurrencyEnum>;
	overrideAdminPrice?: InputMaybe<Scalars['Float']['input']>;
	waivePayment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApproveSampleV2Input = {
	approvalNotes?: InputMaybe<Scalars['String']['input']>;
	sampleId: Scalars['ID']['input'];
};

export type AssignPermissionsToRoleInput = {
	permissionIds: Array<Scalars['ID']['input']>;
	roleId: Scalars['ID']['input'];
};

export type AssignStudioFileToClientInput = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	studioFileId: Scalars['ID']['input'];
};

export enum AuthRoleEnum {
	Admin = 'ADMIN',
	Manufacturer = 'MANUFACTURER',
	Organization = 'ORGANIZATION',
	Vetter = 'VETTER',
}

export type AuthenticationToken = Base & {
	__typename?: 'AuthenticationToken';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	secret?: Maybe<Scalars['String']['output']>;
	token: Scalars['String']['output'];
	type: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<AuthenticationUser>;
	userId: Scalars['ID']['output'];
};

export enum AuthenticationTokenTypeEnum {
	Login = 'LOGIN',
	Refresh = 'REFRESH',
	Register = 'REGISTER',
	ResetPassword = 'RESET_PASSWORD',
	Validation = 'VALIDATION',
}

export type AuthenticationUser = Base & {
	__typename?: 'AuthenticationUser';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	language: Scalars['String']['output'];
	lastActive?: Maybe<Scalars['DateTime']['output']>;
	lockReason?: Maybe<Scalars['String']['output']>;
	lockedAt?: Maybe<Scalars['DateTime']['output']>;
	mfaEnabled: Scalars['Boolean']['output'];
	mfaMethod?: Maybe<MfaMethodEnum>;
	organizationUser?: Maybe<OrganizationUser>;
	role: AuthRoleEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterUser?: Maybe<VetterUser>;
};

export type AuthenticationUserInput = {
	email: Scalars['String']['input'];
};

export type AuthenticationUserMetadata = {
	__typename?: 'AuthenticationUserMetadata';
	organizationId?: Maybe<Scalars['ID']['output']>;
};

export type AuthenticationUserPage = {
	__typename?: 'AuthenticationUserPage';
	data: Array<AuthenticationUser>;
	pageInfo: PageInfo;
};

export type AuthenticationUserUpdateInput = {
	email?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	language?: InputMaybe<Scalars['String']['input']>;
	role?: InputMaybe<AuthRoleEnum>;
};

export type AuthorizationPermission = Base & {
	__typename?: 'AuthorizationPermission';
	action?: Maybe<AuthorizationPermissionAction>;
	authorizationRolePermissions?: Maybe<Array<AuthorizationRolePermission>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	resource?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AuthorizationPermissionAction {
	Create = 'CREATE',
	Delete = 'DELETE',
	Read = 'READ',
	Update = 'UPDATE',
}

export type AuthorizationRole = Base & {
	__typename?: 'AuthorizationRole';
	authorizationRolePermissions?: Maybe<Array<AuthorizationRolePermission>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	scope: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizationRoleCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AuthorizationRolePage = {
	__typename?: 'AuthorizationRolePage';
	data?: Maybe<Array<AuthorizationRole>>;
	pageInfo: PageInfo;
};

export type AuthorizationRolePermission = Base & {
	__typename?: 'AuthorizationRolePermission';
	authorizationPermission?: Maybe<AuthorizationPermission>;
	authorizationPermissionId: Scalars['ID']['output'];
	authorizationRoleId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizationRoleUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizationUserRole = Base & {
	__typename?: 'AuthorizationUserRole';
	authorizationRole?: Maybe<AuthorizationRole>;
	authorizationRoleId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	resourceId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type AuthorizationUserRolePage = {
	__typename?: 'AuthorizationUserRolePage';
	data?: Maybe<Array<AuthorizationUserRole>>;
	pageInfo: PageInfo;
};

export type BackupCodesResponse = {
	__typename?: 'BackupCodesResponse';
	backupCodes: Array<Scalars['String']['output']>;
	message: Scalars['String']['output'];
};

export type Base = {
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookAdminInvoiceDraftV2Response = {
	__typename?: 'BookAdminInvoiceDraftV2Response';
	draft?: Maybe<AdminInvoiceDraftV2>;
	error?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type Brand = Base & {
	__typename?: 'Brand';
	address?: Maybe<BrandAddress>;
	brandFiles?: Maybe<Array<BrandFile>>;
	brandPersonality?: Maybe<BrandPersonality>;
	brandguide?: Maybe<Scalars['String']['output']>;
	colorPalette?: Maybe<BrandColorPalette>;
	colors?: Maybe<Array<Scalars['String']['output']>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	fontFiles?: Maybe<Array<FontFile>>;
	id: Scalars['ID']['output'];
	logo?: Maybe<BrandLogo>;
	name: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	typography?: Maybe<BrandTypography>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	usageGuidelines?: Maybe<BrandUsageGuidelines>;
	website?: Maybe<Scalars['String']['output']>;
};

export type BrandAiContext = {
	__typename?: 'BrandAIContext';
	assetSummary?: Maybe<BrandAssetSummary>;
	brand: Brand;
	designGuidelines?: Maybe<Scalars['String']['output']>;
	recommendations?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandAddress = {
	__typename?: 'BrandAddress';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	formatted?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	street?: Maybe<Scalars['String']['output']>;
};

export type BrandAddressInput = {
	city?: InputMaybe<Scalars['String']['input']>;
	country?: InputMaybe<Scalars['String']['input']>;
	formatted?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<Scalars['String']['input']>;
	street?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAsset = BrandFile | FontFile;

export type BrandAssetSummary = {
	__typename?: 'BrandAssetSummary';
	availableFormats: Array<Scalars['String']['output']>;
	brandMood?: Maybe<Scalars['String']['output']>;
	colorCount: Scalars['Int']['output'];
	dominantColors: Array<Scalars['String']['output']>;
	fontCount: Scalars['Int']['output'];
	logoVariants: Scalars['Int']['output'];
	totalAssets: Scalars['Int']['output'];
};

export type BrandColor = {
	__typename?: 'BrandColor';
	aiDescription?: Maybe<Scalars['String']['output']>;
	hex: Scalars['String']['output'];
	mood?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	usage?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandColorInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	hex: Scalars['String']['input'];
	mood?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	usage?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrandColorPalette = {
	__typename?: 'BrandColorPalette';
	accent?: Maybe<Array<BrandColor>>;
	neutral?: Maybe<Array<BrandColor>>;
	primary?: Maybe<Array<BrandColor>>;
	secondary?: Maybe<Array<BrandColor>>;
};

export type BrandColorPaletteInput = {
	accent?: InputMaybe<Array<BrandColorInput>>;
	neutral?: InputMaybe<Array<BrandColorInput>>;
	primary?: InputMaybe<Array<BrandColorInput>>;
	secondary?: InputMaybe<Array<BrandColorInput>>;
};

export type BrandCreateInput = {
	address?: InputMaybe<BrandAddressInput>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandFile = {
	__typename?: 'BrandFile';
	aiDescription?: Maybe<Scalars['String']['output']>;
	backgroundType?: Maybe<Array<Scalars['String']['output']>>;
	designVariant?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<FileDimensions>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	resolution?: Maybe<Scalars['String']['output']>;
	size: Scalars['Int']['output'];
	tags?: Maybe<Array<Scalars['String']['output']>>;
	type: BrandFileType;
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
	usageContext?: Maybe<Array<Scalars['String']['output']>>;
};

export enum BrandFileType {
	Document = 'document',
	Font = 'font',
	Icon = 'icon',
	Image = 'image',
	Logo = 'logo',
}

export type BrandFileUploadInput = {
	brandFileType: BrandFileType;
	brandId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type BrandLogo = {
	__typename?: 'BrandLogo';
	aiDescription?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<FileDimensions>;
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
};

export type BrandLogoInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<FileDimensionsInput>;
	id: Scalars['ID']['input'];
	mimeType: Scalars['String']['input'];
	name: Scalars['String']['input'];
	size: Scalars['Int']['input'];
	uploadedAt: Scalars['DateTime']['input'];
	url: Scalars['String']['input'];
};

export type BrandPage = {
	__typename?: 'BrandPage';
	data: Array<Brand>;
	pageInfo: PageInfo;
};

export type BrandPersonality = {
	__typename?: 'BrandPersonality';
	aiGuidance?: Maybe<Scalars['String']['output']>;
	tone?: Maybe<Scalars['String']['output']>;
	traits?: Maybe<Array<Scalars['String']['output']>>;
	values?: Maybe<Array<Scalars['String']['output']>>;
};

export type BrandPersonalityInput = {
	aiGuidance?: InputMaybe<Scalars['String']['input']>;
	tone?: InputMaybe<Scalars['String']['input']>;
	traits?: InputMaybe<Array<Scalars['String']['input']>>;
	values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrandTypography = {
	__typename?: 'BrandTypography';
	guidelines?: Maybe<Scalars['String']['output']>;
	hierarchy?: Maybe<TypographyHierarchy>;
	primaryFont?: Maybe<Scalars['String']['output']>;
	secondaryFont?: Maybe<Scalars['String']['output']>;
};

export type BrandTypographyInput = {
	guidelines?: InputMaybe<Scalars['String']['input']>;
	hierarchy?: InputMaybe<TypographyHierarchyInput>;
	primaryFont?: InputMaybe<Scalars['String']['input']>;
	secondaryFont?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdateInput = {
	address?: InputMaybe<BrandAddressInput>;
	brandPersonality?: InputMaybe<BrandPersonalityInput>;
	brandguide?: InputMaybe<Scalars['String']['input']>;
	colorPalette?: InputMaybe<BrandColorPaletteInput>;
	colors?: InputMaybe<Array<Scalars['String']['input']>>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	logo?: InputMaybe<BrandLogoInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	typography?: InputMaybe<BrandTypographyInput>;
	usageGuidelines?: InputMaybe<BrandUsageGuidelinesInput>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUsageGuidelines = {
	__typename?: 'BrandUsageGuidelines';
	aiInstructions?: Maybe<Scalars['String']['output']>;
	colorUsage?: Maybe<Scalars['String']['output']>;
	logoPlacement?: Maybe<Scalars['String']['output']>;
	spacing?: Maybe<Scalars['String']['output']>;
	typographyRules?: Maybe<Scalars['String']['output']>;
};

export type BrandUsageGuidelinesInput = {
	aiInstructions?: InputMaybe<Scalars['String']['input']>;
	colorUsage?: InputMaybe<Scalars['String']['input']>;
	logoPlacement?: InputMaybe<Scalars['String']['input']>;
	spacing?: InputMaybe<Scalars['String']['input']>;
	typographyRules?: InputMaybe<Scalars['String']['input']>;
};

export type BulkImageFileInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
};

export type BulkImageUploadUrl = {
	__typename?: 'BulkImageUploadUrl';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	fileName: Scalars['String']['output'];
	imageId: Scalars['ID']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type BulkProductInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	imageUrls: Array<Scalars['String']['input']>;
	metadata?: InputMaybe<ProductMetadataInput>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BusinessRegistration = {
	__typename?: 'BusinessRegistration';
	number: Scalars['String']['output'];
	type: Scalars['String']['output'];
	verified?: Maybe<Scalars['Boolean']['output']>;
	verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessRegistrationInput = {
	number: Scalars['String']['input'];
	type: Scalars['String']['input'];
};

export type CvrAddress = {
	__typename?: 'CVRAddress';
	city: Scalars['String']['output'];
	country: Scalars['String']['output'];
	street: Scalars['String']['output'];
	zipcode: Scalars['String']['output'];
};

export type CvrCompanyInfo = {
	__typename?: 'CVRCompanyInfo';
	active: Scalars['Boolean']['output'];
	address: CvrAddress;
	email?: Maybe<Scalars['String']['output']>;
	employees?: Maybe<Scalars['String']['output']>;
	industryCode?: Maybe<Scalars['Int']['output']>;
	industryDescription?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	phone?: Maybe<Scalars['String']['output']>;
	startDate?: Maybe<Scalars['String']['output']>;
	vat: Scalars['String']['output'];
};

export type CvrValidationResult = {
	__typename?: 'CVRValidationResult';
	companyInfo?: Maybe<CvrCompanyInfo>;
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type CancelAdminInvoiceDraftV2Response = {
	__typename?: 'CancelAdminInvoiceDraftV2Response';
	/** Set when the cancel issued a credit note (booked draft path). Null for plain draft cancellations. */
	creditNoteInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	error?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CancelProductPaymentV2Input = {
	paymentTransactionId: Scalars['ID']['input'];
	reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelProductPaymentV2Response = {
	__typename?: 'CancelProductPaymentV2Response';
	alreadyCancelled?: Maybe<Scalars['Boolean']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CancelSampleInvoiceForOrderV2Input = {
	orderId: Scalars['ID']['input'];
	sampleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CancelSampleInvoiceForOrderV2Response = {
	__typename?: 'CancelSampleInvoiceForOrderV2Response';
	cancelledCount?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CategorizeBulkProductImagesInput = {
	imageUrls: Array<Scalars['String']['input']>;
};

export type CategorizeBulkProductImagesResponse = {
	__typename?: 'CategorizeBulkProductImagesResponse';
	categorizedImages: Scalars['Int']['output'];
	message: Scalars['String']['output'];
	products: Array<CategorizedProduct>;
	success: Scalars['Boolean']['output'];
	totalImages: Scalars['Int']['output'];
	unmappedImages: Array<UnmappedProjectProductImage>;
};

export type CategorizedProduct = {
	__typename?: 'CategorizedProduct';
	imageUrls: Array<Scalars['String']['output']>;
	productName: Scalars['String']['output'];
};

export enum ChatAttachmentType {
	Mask = 'mask',
	MaskPreview = 'maskPreview',
	Reference = 'reference',
}

export type ChatAttachmentUploadInput = {
	attachmentType: ChatAttachmentType;
	contentType: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	studioFileId: Scalars['ID']['input'];
};

export type ChatAttachmentUploadResponse = {
	__typename?: 'ChatAttachmentUploadResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type ChatContext = Base & {
	__typename?: 'ChatContext';
	contextType: ChatContextType;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
	messages: Array<ChatMessage>;
	organization?: Maybe<Organization>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	quote?: Maybe<QuoteV2>;
	quoteId: Scalars['ID']['output'];
	targetLanguages?: Maybe<Array<SupportedLanguage>>;
	translationEnabled: Scalars['Boolean']['output'];
	unreadCount: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterId?: Maybe<Scalars['ID']['output']>;
	vetterUser?: Maybe<VetterUser>;
};

export enum ChatContextType {
	AdminOrganization = 'ADMIN_ORGANIZATION',
	AdminVetter = 'ADMIN_VETTER',
}

export type ChatFileUploadInput = {
	contextId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type ChatMessage = Base & {
	__typename?: 'ChatMessage';
	content?: Maybe<Scalars['String']['output']>;
	contextId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	isRead: Scalars['Boolean']['output'];
	messageType: MessageType;
	metadata?: Maybe<Scalars['JSON']['output']>;
	readAt?: Maybe<Scalars['DateTime']['output']>;
	senderId: Scalars['ID']['output'];
	senderType: AuthRoleEnum;
	translations?: Maybe<MessageTranslations>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ChatRole {
	Assistant = 'assistant',
	System = 'system',
	User = 'user',
}

export enum CheckoutSessionStatus {
	Cancelled = 'cancelled',
	Completed = 'completed',
	Expired = 'expired',
	Pending = 'pending',
}

export type CompleteRecommendationInput = {
	dimensions?: InputMaybe<ProductDimensionsInput>;
	recommendationId: Scalars['ID']['input'];
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CompleteRecommendationResponse = {
	__typename?: 'CompleteRecommendationResponse';
	message?: Maybe<Scalars['String']['output']>;
	productId?: Maybe<Scalars['ID']['output']>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type ConfirmBrandFileUploadInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	backgroundType?: InputMaybe<Array<Scalars['String']['input']>>;
	blobUrl: Scalars['String']['input'];
	brandFileType: BrandFileType;
	brandId: Scalars['ID']['input'];
	designVariant?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<FileDimensionsInput>;
	fileId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	resolution?: InputMaybe<Scalars['String']['input']>;
	tags?: InputMaybe<Array<Scalars['String']['input']>>;
	usageContext?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConfirmBrandFontUploadInput = {
	aiDescription?: InputMaybe<Scalars['String']['input']>;
	blobUrl: Scalars['String']['input'];
	brandId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fontFamily: Scalars['String']['input'];
	fontId: Scalars['ID']['input'];
	fontStyle?: InputMaybe<Scalars['String']['input']>;
	fontWeight?: InputMaybe<Scalars['String']['input']>;
	language?: InputMaybe<Array<Scalars['String']['input']>>;
	mood?: InputMaybe<Array<Scalars['String']['input']>>;
	readability?: InputMaybe<Scalars['String']['input']>;
	usage?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConfirmChatFileUploadInput = {
	blobUrl: Scalars['String']['input'];
	contextId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type ConfirmProductImageUploadInput = {
	altText?: InputMaybe<Scalars['String']['input']>;
	blobUrl: Scalars['String']['input'];
	caption?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ImageDimensionsInput>;
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	imageId: Scalars['ID']['input'];
	isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
	metadata?: InputMaybe<Array<ImageMetadataInput>>;
	productId: Scalars['ID']['input'];
	sortOrder?: InputMaybe<Scalars['Int']['input']>;
	studioFileVersionId?: InputMaybe<Scalars['ID']['input']>;
	type?: InputMaybe<ProductImageType>;
};

export type ConfirmQuoteOfferFileUploadV2Input = {
	blobUrl: Scalars['String']['input'];
	fileId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	quoteV2Id: Scalars['ID']['input'];
};

export type ConfirmStudioReferenceImageUploadInput = {
	altText?: InputMaybe<Scalars['String']['input']>;
	blobUrl: Scalars['String']['input'];
	caption?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ImageDimensionsInput>;
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
	imageId: Scalars['ID']['input'];
};

export type ConvertCurrencyInput = {
	amount: Scalars['Float']['input'];
	fromCurrency: CurrencyEnum;
	toCurrency: CurrencyEnum;
};

export type ConvertQuoteOfferInput = {
	quoteOfferId: Scalars['ID']['input'];
	targetCurrency: CurrencyEnum;
};

export type CreateAdminInvoiceDraftV2Input = {
	/**
	 * When true, the server creates the draft AND immediately books + emails
	 * it in the same call (admin's 'Book & send' from a fresh modal). When
	 * false/omitted, the draft is created and left in DRAFT status for the
	 * resume-and-book flow. Booking requires recipientEmail.
	 */
	book?: InputMaybe<Scalars['Boolean']['input']>;
	currency: Scalars['String']['input'];
	lineItems: Array<AdminInvoiceDraftLineItemInputV2>;
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationId: Scalars['ID']['input'];
	/**
	 * Optional Purchase Order number from the buyer's AP department.
	 * Lands in e-conomic references.other so it renders as "Your
	 * reference" on the invoice PDF — matches the same field on the
	 * client-initiated invoice mutations.
	 */
	poNumber?: InputMaybe<Scalars['String']['input']>;
	recipientEmail?: InputMaybe<Scalars['String']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdminInvoiceDraftV2Response = {
	__typename?: 'CreateAdminInvoiceDraftV2Response';
	draft?: Maybe<AdminInvoiceDraftV2>;
	error?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateAdminUserInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type CreateBulkProductsInput = {
	products: Array<BulkProductInput>;
};

export type CreateBulkProjectProductsInput = {
	products: Array<ProjectProductInput>;
	sessionId: Scalars['ID']['input'];
};

export type CreateChatContextInput = {
	contextType: ChatContextType;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	quoteId: Scalars['ID']['input'];
	targetLanguages?: InputMaybe<Array<SupportedLanguage>>;
	translationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDesignSpecInput = {
	appliesTo?: InputMaybe<Scalars['String']['input']>;
	assetPurpose?: InputMaybe<Scalars['String']['input']>;
	assetType?: InputMaybe<Scalars['String']['input']>;
	assetUrl?: InputMaybe<Scalars['String']['input']>;
	colorHex?: InputMaybe<Scalars['String']['input']>;
	colorName?: InputMaybe<Scalars['String']['input']>;
	confidence?: InputMaybe<Scalars['Float']['input']>;
	derivationMethod?: InputMaybe<Scalars['String']['input']>;
	derivedFromSpecId?: InputMaybe<Scalars['ID']['input']>;
	fontFamily?: InputMaybe<Scalars['String']['input']>;
	fontSize?: InputMaybe<Scalars['Float']['input']>;
	metadata?: InputMaybe<Scalars['JSON']['input']>;
	placement?: InputMaybe<DesignSpecPlacementInput>;
	promptSnippet?: InputMaybe<Scalars['String']['input']>;
	specType: DesignSpecType;
	studioChatId?: InputMaybe<Scalars['ID']['input']>;
	studioFileVersionId: Scalars['ID']['input'];
	textContent?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyAuthorizationUserRoleInput = {
	authorizationRoleIds: Array<Scalars['ID']['input']>;
	userId: Scalars['ID']['input'];
};

export type CreateOfferVariationV2Input = {
	adjustments?: InputMaybe<Array<CreateVariationAdjustmentV2Input>>;
	attachments?: InputMaybe<Array<QuoteOfferAttachmentV2Input>>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	quantities: Array<CreateVariationQuantityV2Input>;
	sample?: InputMaybe<CreateVariationSampleV2Input>;
};

export type CreateOrganizationIndustryInput = {
	name: Scalars['String']['input'];
};

export type CreateProductFromStudioInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ProductDimensionsInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	studioFileId: Scalars['ID']['input'];
	versionIds: Array<Scalars['ID']['input']>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateProductFromStudioResponse = {
	__typename?: 'CreateProductFromStudioResponse';
	message?: Maybe<Scalars['String']['output']>;
	productId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateProductOfferV2Input = {
	quoteItemV2Id: Scalars['ID']['input'];
	variations: Array<CreateOfferVariationV2Input>;
};

export type CreateProductPaymentForOrderV2Input = {
	orderId: Scalars['ID']['input'];
	orderItemIds: Array<Scalars['ID']['input']>;
	paymentMethod?: InputMaybe<ProductPaymentMethodV2>;
	poNumber?: InputMaybe<Scalars['String']['input']>;
	returnUrl: Scalars['String']['input'];
};

export type CreateProductPaymentForOrderV2Response = {
	__typename?: 'CreateProductPaymentForOrderV2Response';
	clientSecret?: Maybe<Scalars['String']['output']>;
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	paymentMethod?: Maybe<Scalars['String']['output']>;
	paymentTransactionId?: Maybe<Scalars['ID']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateProductVariantFromStudioInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	studioFileVersionId: Scalars['ID']['input'];
};

export type CreateProductVariantFromStudioResponse = {
	__typename?: 'CreateProductVariantFromStudioResponse';
	message?: Maybe<Scalars['String']['output']>;
	productId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateProjectInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	endDate?: InputMaybe<Scalars['DateTime']['input']>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sessionId: Scalars['ID']['input'];
	startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateProjectProductInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	finalize?: InputMaybe<Scalars['Boolean']['input']>;
	imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	inspirationImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	productId?: InputMaybe<Scalars['ID']['input']>;
	projectId?: InputMaybe<Scalars['ID']['input']>;
	remixPrompt?: InputMaybe<Scalars['String']['input']>;
	sessionId?: InputMaybe<Scalars['ID']['input']>;
	type: ProjectProductType;
};

export type CreateProjectResponse = {
	__typename?: 'CreateProjectResponse';
	message: Scalars['String']['output'];
	project?: Maybe<Project>;
	success: Scalars['Boolean']['output'];
};

export type CreateQuoteItemV2Input = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	productId: Scalars['ID']['input'];
	quantities: Array<Scalars['Int']['input']>;
};

export type CreateQuoteOfferBatchV2Input = {
	acceptDeadline?: InputMaybe<Scalars['DateTime']['input']>;
	acceptDeadlineType?: InputMaybe<AcceptDeadlineTypeV2>;
	currency: CurrencyEnum;
	manufacturerId?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	productOffers: Array<CreateProductOfferV2Input>;
	quoteV2Id: Scalars['ID']['input'];
	submitToAdmin?: InputMaybe<Scalars['Boolean']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateQuoteOrderItemV2Input = {
	notes?: InputMaybe<Scalars['String']['input']>;
	quantity: Scalars['Int']['input'];
	quoteOfferItemVariationQuantityV2Id: Scalars['ID']['input'];
};

export type CreateQuoteOrderV2Input = {
	acceptDeadline?: InputMaybe<Scalars['DateTime']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	items: Array<CreateQuoteOrderItemV2Input>;
	name: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
	quoteV2Id: Scalars['ID']['input'];
};

export type CreateQuoteV2Input = {
	/** Contact persons (organizationUser.id) for client notifications. Defaults to empty array. */
	contactUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	deliveryAddress?: InputMaybe<DeliveryAddressV2Input>;
	description?: InputMaybe<Scalars['String']['input']>;
	items?: InputMaybe<Array<CreateQuoteItemV2Input>>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	purpose?: InputMaybe<QuotePurposeV2>;
	purposeOther?: InputMaybe<Scalars['String']['input']>;
	setAsCurrent?: InputMaybe<Scalars['Boolean']['input']>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateSampleInvoiceForOrderV2Input = {
	orderId: Scalars['ID']['input'];
	poNumber?: InputMaybe<Scalars['String']['input']>;
	sampleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateSampleInvoiceForOrderV2Response = {
	__typename?: 'CreateSampleInvoiceForOrderV2Response';
	belowInvoiceMinimum?: Maybe<Scalars['Boolean']['output']>;
	invoiceMinimum?: Maybe<Scalars['Float']['output']>;
	invoicedCount?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateSamplePaymentCheckoutInput = {
	currency: CurrencyEnum;
	orderId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
	returnUrl: Scalars['String']['input'];
	samples: Array<SamplePaymentItemInput>;
};

export type CreateSamplePaymentCheckoutResponse = {
	__typename?: 'CreateSamplePaymentCheckoutResponse';
	clientSecret?: Maybe<Scalars['String']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateSamplePaymentForOrderV2Input = {
	orderId: Scalars['ID']['input'];
	poNumber?: InputMaybe<Scalars['String']['input']>;
	returnUrl: Scalars['String']['input'];
	sampleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateSamplePaymentForOrderV2Response = {
	__typename?: 'CreateSamplePaymentForOrderV2Response';
	checkoutLimit?: Maybe<Scalars['Float']['output']>;
	checkoutLimitExceeded?: Maybe<Scalars['Boolean']['output']>;
	clientSecret?: Maybe<Scalars['String']['output']>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateStudioFileVersionInput = {
	changeNotes?: InputMaybe<Scalars['String']['input']>;
	createdBy: Scalars['ID']['input'];
	imageUrls: Array<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	slug: Scalars['String']['input'];
	specs?: InputMaybe<StudioFileSpecsInput>;
	studioFileId: Scalars['ID']['input'];
	versionNumber: Scalars['Int']['input'];
};

export type CreateStudioFileVersionSpecificationInput = {
	capacity?: InputMaybe<SpecificationCapacityInput>;
	colors?: InputMaybe<Array<Scalars['String']['input']>>;
	dimensions?: InputMaybe<SpecificationDimensionsInput>;
	elementName: Scalars['String']['input'];
	elementType?: InputMaybe<Scalars['String']['input']>;
	features?: InputMaybe<Array<Scalars['String']['input']>>;
	finish?: InputMaybe<Scalars['String']['input']>;
	material?: InputMaybe<Scalars['String']['input']>;
	secondaryMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
	studioFileVersionId: Scalars['ID']['input'];
	textureDescription?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<SpecificationWeightInput>;
};

export type CreateStudioFileVersionTechPackInput = {
	additionalNotes?: InputMaybe<Scalars['String']['input']>;
	colorways?: InputMaybe<Array<TechPackColorwayInput>>;
	construction?: InputMaybe<TechPackConstructionInput>;
	dimensions?: InputMaybe<TechPackDimensionsInput>;
	labeling?: InputMaybe<TechPackLabelingInput>;
	materials?: InputMaybe<TechPackMaterialsInput>;
	packaging?: InputMaybe<TechPackPackagingInput>;
	qualityControl?: InputMaybe<TechPackQualityControlInput>;
	studioFileVersionId: Scalars['ID']['input'];
};

/**
 * Embedded Stripe checkout session for creating a new subscription.
 * The frontend mounts `clientSecret` via @stripe/react-stripe-js.
 */
export type CreateSubscriptionCheckoutResponse = {
	__typename?: 'CreateSubscriptionCheckoutResponse';
	clientSecret?: Maybe<Scalars['String']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type CreateVariationAdjustmentV2Input = {
	calculationType: AdjustmentCalculationTypeV2;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	type: AdjustmentTypeV2;
	value: Scalars['Float']['input'];
};

export type CreateVariationDeliveryV2Input = {
	adminFee?: InputMaybe<Scalars['Float']['input']>;
	basePrice: Scalars['Float']['input'];
	basePriceCurrency?: InputMaybe<CurrencyEnum>;
	deliveryDaysMax: Scalars['Int']['input'];
	deliveryDaysMin: Scalars['Int']['input'];
	quantity: Scalars['Int']['input'];
	shippingMethod: ShippingMethodV2;
};

export type CreateVariationQuantityV2Input = {
	baseUnitPrice: Scalars['Float']['input'];
	baseUnitPriceCurrency?: InputMaybe<CurrencyEnum>;
	deliveries: Array<CreateVariationDeliveryV2Input>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	quantity: Scalars['Int']['input'];
	quoteItemQuantityV2Id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateVariationSampleV2Input = {
	baseSamplePrice: Scalars['Float']['input'];
	baseSamplePriceCurrency?: InputMaybe<CurrencyEnum>;
	baseShippingPrice?: InputMaybe<Scalars['Float']['input']>;
	baseShippingPriceCurrency?: InputMaybe<CurrencyEnum>;
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVetterEntityInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	name: Scalars['String']['input'];
};

export type CreateVetterUserInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	vetterEntityId: Scalars['ID']['input'];
};

export type CurrencyConversionResult = {
	__typename?: 'CurrencyConversionResult';
	convertedAmount: Scalars['Float']['output'];
	exchangeRate: Scalars['Float']['output'];
	fromCurrency: CurrencyEnum;
	originalAmount: Scalars['Float']['output'];
	rateDate?: Maybe<Scalars['DateTime']['output']>;
	toCurrency: CurrencyEnum;
};

export enum CurrencyEnum {
	Aed = 'AED',
	Ars = 'ARS',
	Aud = 'AUD',
	Bgn = 'BGN',
	Brl = 'BRL',
	Cad = 'CAD',
	Chf = 'CHF',
	Clp = 'CLP',
	Cny = 'CNY',
	Cop = 'COP',
	Czk = 'CZK',
	Dkk = 'DKK',
	Egp = 'EGP',
	Eur = 'EUR',
	Gbp = 'GBP',
	Hkd = 'HKD',
	Hrk = 'HRK',
	Huf = 'HUF',
	Idr = 'IDR',
	Ils = 'ILS',
	Inr = 'INR',
	Isk = 'ISK',
	Jpy = 'JPY',
	Krw = 'KRW',
	Mxn = 'MXN',
	Myr = 'MYR',
	Nok = 'NOK',
	Nzd = 'NZD',
	Pen = 'PEN',
	Php = 'PHP',
	Pln = 'PLN',
	Ron = 'RON',
	Sar = 'SAR',
	Sek = 'SEK',
	Sgd = 'SGD',
	Thb = 'THB',
	Try = 'TRY',
	Usd = 'USD',
	Vnd = 'VND',
	Zar = 'ZAR',
}

export type DateRange = {
	__typename?: 'DateRange';
	endDate: Scalars['DateTime']['output'];
	startDate: Scalars['DateTime']['output'];
};

export type DateRangeInput = {
	endDate?: InputMaybe<Scalars['String']['input']>;
	startDate: Scalars['String']['input'];
};

export type DeleteInput = {
	id: Scalars['ID']['input'];
};

export type DeleteManyAuthorizationUserRoleInput = {
	authorizationRoleIds: Array<Scalars['ID']['input']>;
	userId: Scalars['ID']['input'];
};

export type DeleteManyInput = {
	ids: Array<Scalars['ID']['input']>;
};

export type DeleteOrganizationIndustryInput = {
	/** Industry ID to assign to all orgs currently using the deleted industry. Null clears the FK on those orgs. */
	defaultReassignTo?: InputMaybe<Scalars['ID']['input']>;
	id: Scalars['ID']['input'];
	/** Per-org overrides. Each listed org gets the specific industryId (null to clear). Orgs not listed fall back to defaultReassignTo. */
	perOrganizationReassignments?: InputMaybe<Array<OrganizationIndustryReassignment>>;
};

export type DeleteQuoteItemV2Input = {
	id: Scalars['ID']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteQuoteV2Input = {
	id: Scalars['ID']['input'];
};

export type DeliveryAddressV2 = {
	__typename?: 'DeliveryAddressV2';
	addressLine1?: Maybe<Scalars['String']['output']>;
	addressLine2?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	googlePlaceId?: Maybe<Scalars['String']['output']>;
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	stateCode?: Maybe<Scalars['String']['output']>;
};

export type DeliveryAddressV2Input = {
	addressLine1?: InputMaybe<Scalars['String']['input']>;
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city?: InputMaybe<Scalars['String']['input']>;
	countryCode?: InputMaybe<Scalars['String']['input']>;
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type DenyNewSampleRoundV2Input = {
	adminNotes?: InputMaybe<Scalars['String']['input']>;
	approvalId: Scalars['ID']['input'];
};

export type DesignSpecPlacement = {
	__typename?: 'DesignSpecPlacement';
	height?: Maybe<Scalars['Float']['output']>;
	position?: Maybe<Scalars['String']['output']>;
	rotation?: Maybe<Scalars['Float']['output']>;
	scale?: Maybe<Scalars['Float']['output']>;
	width?: Maybe<Scalars['Float']['output']>;
	x?: Maybe<Scalars['Float']['output']>;
	y?: Maybe<Scalars['Float']['output']>;
};

export type DesignSpecPlacementInput = {
	height?: InputMaybe<Scalars['Float']['input']>;
	position?: InputMaybe<Scalars['String']['input']>;
	rotation?: InputMaybe<Scalars['Float']['input']>;
	scale?: InputMaybe<Scalars['Float']['input']>;
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export enum DesignSpecType {
	Asset = 'asset',
	Color = 'color',
	Placement = 'placement',
	Text = 'text',
}

export type DownloadUrlResponse = {
	__typename?: 'DownloadUrlResponse';
	downloadUrl: Scalars['String']['output'];
	errors?: Maybe<Array<ResponseError>>;
	expiresAt: Scalars['DateTime']['output'];
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type DuplicateBatchResponse = {
	__typename?: 'DuplicateBatchResponse';
	batchId?: Maybe<Scalars['ID']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export type EarlyAccessInvite = {
	__typename?: 'EarlyAccessInvite';
	email: Scalars['String']['output'];
	firstName: Scalars['String']['output'];
	lastName: Scalars['String']['output'];
};

export type EarlyAccessRequest = {
	__typename?: 'EarlyAccessRequest';
	approvedAt?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['String']['output'];
	email: Scalars['String']['output'];
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	status: EarlyAccessStatusEnum;
	updatedAt: Scalars['String']['output'];
	usedAt?: Maybe<Scalars['String']['output']>;
};

export enum EarlyAccessStatusEnum {
	Approved = 'Approved',
	Pending = 'Pending',
	Rejected = 'Rejected',
	Used = 'Used',
}

export type EmailExistsResponse = {
	__typename?: 'EmailExistsResponse';
	exists: Scalars['Boolean']['output'];
};

export type FileDimensions = {
	__typename?: 'FileDimensions';
	aspectRatio?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Int']['output']>;
	width?: Maybe<Scalars['Int']['output']>;
};

export type FileDimensionsInput = {
	aspectRatio?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Int']['input']>;
	width?: InputMaybe<Scalars['Int']['input']>;
};

export type FileInput = {
	fileType?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	url: Scalars['String']['input'];
};

export enum FileTypeEnum {
	Csv = 'CSV',
	Excel = 'EXCEL',
	Font = 'FONT',
	Image = 'IMAGE',
	Pdf = 'PDF',
	Video = 'VIDEO',
}

/** Generic response for generating pre-signed upload/download URLs (Azure Blob, S3, etc.) across the app. */
export type FileUploadResponse = {
	__typename?: 'FileUploadResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	errors: Array<ResponseError>;
	expiresAt: Scalars['DateTime']['output'];
	fileId?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type FinishMetadataAttachmentUploadInput = {
	attachment: MetadataAttachmentInput;
	metadataId: Scalars['ID']['input'];
};

export type FontFile = {
	__typename?: 'FontFile';
	aiDescription?: Maybe<Scalars['String']['output']>;
	family: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	language?: Maybe<Array<Scalars['String']['output']>>;
	mood?: Maybe<Array<Scalars['String']['output']>>;
	name: Scalars['String']['output'];
	readability?: Maybe<Scalars['String']['output']>;
	style?: Maybe<Scalars['String']['output']>;
	url?: Maybe<Scalars['String']['output']>;
	usage?: Maybe<Array<Scalars['String']['output']>>;
	weight?: Maybe<Scalars['String']['output']>;
};

export type FontFileUploadInput = {
	brandId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	fontFamily: Scalars['String']['input'];
	fontStyle?: InputMaybe<Scalars['String']['input']>;
	fontWeight?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateBulkProductImageUploadUrlsInput = {
	files: Array<BulkImageFileInput>;
};

export type GenerateBulkProductImageUploadUrlsResponse = {
	__typename?: 'GenerateBulkProductImageUploadUrlsResponse';
	urls: Array<BulkImageUploadUrl>;
};

export type GenerateProjectProductImageUploadUrlsInput = {
	files: Array<ImageFileInput>;
	imageType: ProjectProductImageType;
};

export type GenerateProjectProductImageUploadUrlsResponse = {
	__typename?: 'GenerateProjectProductImageUploadUrlsResponse';
	urls: Array<ImageUploadUrl>;
};

export type GenerateStudioReferenceImageUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
};

export type GenerateStudioReferenceImageUploadUrlResponse = {
	__typename?: 'GenerateStudioReferenceImageUploadUrlResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	imageId: Scalars['ID']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type GenerateUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	organizationUserId: Scalars['ID']['input'];
};

export type GetAllAdminAuthenticationUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAdminUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAuthorizationRoleInput = {
	excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	scope?: InputMaybe<Scalars['String']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAuthorizationUserRoleInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	userId: Scalars['ID']['input'];
};

export type GetAllBrandInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllLoggingAuditLogInput = {
	dateRange?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	referenceId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllLoggingLoginLogInput = {
	dateRange?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	referenceId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllManufacturerInput = {
	filter?: InputMaybe<ManufacturerFilterInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationInput = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	order?: InputMaybe<OrderInput>;
	/** Filter by an organizationIndustry row id. The legacy enum-based filter is gone. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationUserInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllProductInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetAllProductTagInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllProjectInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllQuoteOrdersV2Input = {
	filter?: InputMaybe<GetQuoteOrdersV2Filter>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllQuoteOrdersV2Response = {
	__typename?: 'GetAllQuoteOrdersV2Response';
	data?: Maybe<Array<QuoteOrderV2>>;
	pageInfo?: Maybe<PageInfo>;
};

export type GetAllQuotesV2Input = {
	createdAt?: InputMaybe<DateRangeInput>;
	deadline?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	projectId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	statuses?: InputMaybe<Array<QuoteStatusV2>>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetAllQuotesV2Response = {
	__typename?: 'GetAllQuotesV2Response';
	data?: Maybe<Array<QuoteV2>>;
	pageInfo?: Maybe<PageInfo>;
};

export type GetAllStudioFileInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	showArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllVetterEntityInput = {
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllVetterUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetChatContextsResponse = {
	__typename?: 'GetChatContextsResponse';
	data?: Maybe<Array<ChatContext>>;
	pageInfo?: Maybe<PageInfo>;
};

export type GetChatMessagesInput = {
	language?: InputMaybe<SupportedLanguage>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
};

export type GetChatMessagesResponse = {
	__typename?: 'GetChatMessagesResponse';
	data?: Maybe<Array<ChatMessage>>;
	pageInfo?: Maybe<PageInfo>;
};

export type GetDownloadUrlInput = {
	organizationUserId: Scalars['ID']['input'];
};

export type GetInvoiceableItemsForOrgV2Response = {
	__typename?: 'GetInvoiceableItemsForOrgV2Response';
	currency: Scalars['String']['output'];
	orders: Array<InvoiceableOrderV2>;
};

export type GetMyAuthorizationUserRoleInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetMyChatContextsInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetQuoteOrdersV2Filter = {
	dateRange?: InputMaybe<DateRangeInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	status?: InputMaybe<Array<QuoteOrderStatusV2>>;
};

export type GraphQlContext = {
	__typename?: 'GraphQLContext';
	exp?: Maybe<Scalars['String']['output']>;
	iat?: Maybe<Scalars['String']['output']>;
	sub?: Maybe<Scalars['String']['output']>;
};

export type ImageDimensions = {
	__typename?: 'ImageDimensions';
	aspectRatio?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Int']['output']>;
	width?: Maybe<Scalars['Int']['output']>;
};

export type ImageDimensionsInput = {
	height: Scalars['Int']['input'];
	width: Scalars['Int']['input'];
};

export type ImageFileInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: FileTypeEnum;
};

export type ImageMetadata = {
	__typename?: 'ImageMetadata';
	attachments?: Maybe<Array<MetadataAttachment>>;
	canvasHeight: Scalars['Float']['output'];
	canvasWidth: Scalars['Float']['output'];
	comment?: Maybe<Scalars['String']['output']>;
	height?: Maybe<Scalars['Float']['output']>;
	points?: Maybe<Array<PolygonPoint>>;
	type: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
	x?: Maybe<Scalars['Float']['output']>;
	y?: Maybe<Scalars['Float']['output']>;
};

export type ImageMetadataInput = {
	attachments?: InputMaybe<Array<MetadataAttachmentInput>>;
	canvasHeight: Scalars['Float']['input'];
	canvasWidth: Scalars['Float']['input'];
	comment?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	points?: InputMaybe<Array<PolygonPointInput>>;
	type: Scalars['String']['input'];
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageUploadResponse = {
	__typename?: 'ImageUploadResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	errors: Array<ResponseError>;
	expiresAt: Scalars['DateTime']['output'];
	imageId?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type ImageUploadUrl = {
	__typename?: 'ImageUploadUrl';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	fileName: Scalars['String']['output'];
	imageId: Scalars['ID']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type InvoiceRecipientInputV2 = {
	email?: InputMaybe<Scalars['String']['input']>;
	orgUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type InvoiceableItemV2 = {
	__typename?: 'InvoiceableItemV2';
	/** Sum of paid deductible-sample amounts that will fire as credit lines when this product is invoiced. */
	deductibleAmount?: Maybe<Scalars['Float']['output']>;
	deductibleSampleCount?: Maybe<Scalars['Int']['output']>;
	/** Per-delivery breakdown (Express, Sea, etc.). */
	deliveries: Array<ProductPaymentPreviewDeliveryV2>;
	/** Delivery subtotal — sum across all delivery rows for this item. */
	deliveryAmount?: Maybe<Scalars['Float']['output']>;
	/** Variation name + quantity, e.g. 'Blue T-shirt — 100 units'. */
	description: Scalars['String']['output'];
	/** Per-fee breakdown (Setup Fee, Surcharge, etc.) — mirrors getProductPaymentPreviewV2. */
	fees: Array<ProductPaymentPreviewFeeV2>;
	/** Fee subtotal — sum of all fee-type snapshot adjustments for this item. */
	feesAmount?: Maybe<Scalars['Float']['output']>;
	/**
	 * lineSubtotal − deductibleAmount, clamped to ≥0. What the customer
	 * actually owes for this product item end-to-end.
	 */
	lineNetAmount?: Maybe<Scalars['Float']['output']>;
	/**
	 * productsAmount + feesAmount + deliveryAmount, ex-VAT. What the
	 * product line + its fee/delivery sublines will total on the invoice
	 * (before deductible-sample credits).
	 */
	lineSubtotal?: Maybe<Scalars['Float']['output']>;
	/**
	 * Reference to the underlying QuoteOrderItemV2 — frontend can drill in
	 * for federated fields like imageUrl, productPaymentStatus, etc.
	 * without us hand-rolling them on this view-model.
	 */
	orderItem: QuoteOrderItemV2;
	orderItemId: Scalars['ID']['output'];
	/**
	 * Product subtotal only (no fees, no delivery). Same number as the
	 * existing client modal's productsAmount — kept for backwards
	 * compatibility. Use lineSubtotal for what'll actually be invoiced.
	 * Null when product mode isn't ADMIN_MANUAL.
	 */
	productAmount?: Maybe<Scalars['Float']['output']>;
	productDraftId?: Maybe<Scalars['ID']['output']>;
	productEconomicInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	/** Null when this order's productPaymentMode isn't ADMIN_MANUAL — picker hides the product row entirely. */
	productStatus?: Maybe<InvoiceableLineStatusV2>;
	quantity: Scalars['Int']['output'];
	/** Empty when samplePaymentMode isn't ADMIN_MANUAL. */
	samples: Array<InvoiceableSampleV2>;
};

export enum InvoiceableLineStatusV2 {
	Booked = 'BOOKED',
	OnDraft = 'ON_DRAFT',
	Paid = 'PAID',
	Unpaid = 'UNPAID',
}

export type InvoiceableOrderV2 = {
	__typename?: 'InvoiceableOrderV2';
	items: Array<InvoiceableItemV2>;
	orderId: Scalars['ID']['output'];
	orderName: Scalars['String']['output'];
	orderNumber: Scalars['String']['output'];
	productPaymentMode: PaymentModeEnum;
	samplePaymentMode: PaymentModeEnum;
};

export type InvoiceableSampleV2 = {
	__typename?: 'InvoiceableSampleV2';
	amount?: Maybe<Scalars['Float']['output']>;
	draftId?: Maybe<Scalars['ID']['output']>;
	economicInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	/** Negative-line credit will fire on the parent product invoice when this sample is paid. */
	isDeductible: Scalars['Boolean']['output'];
	sampleId: Scalars['ID']['output'];
	sampleRound: Scalars['Int']['output'];
	status: InvoiceableLineStatusV2;
};

/**
 * Single entry in the organization's kickback ledger. The sum of all entries
 * for an org equals their current balance.
 */
export type KickbackTransaction = {
	__typename?: 'KickbackTransaction';
	amount: Scalars['Float']['output'];
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	orderId?: Maybe<Scalars['ID']['output']>;
	organizationId: Scalars['ID']['output'];
	type: KickbackTransactionType;
};

export enum KickbackTransactionType {
	Accrual = 'accrual',
	Adjustment = 'adjustment',
	Redemption = 'redemption',
}

export type LocalizationAddressFormat = {
	__typename?: 'LocalizationAddressFormat';
	postalCodeLabel: Scalars['String']['output'];
	stateLabel?: Maybe<Scalars['String']['output']>;
	stateRequired: Scalars['Boolean']['output'];
};

export type LocalizationBusinessRegistrationType = {
	__typename?: 'LocalizationBusinessRegistrationType';
	code: Scalars['String']['output'];
	helpText?: Maybe<Scalars['String']['output']>;
	isRequired: Scalars['Boolean']['output'];
	label: Scalars['String']['output'];
	placeholder?: Maybe<Scalars['String']['output']>;
	vatDerivationPattern?: Maybe<Scalars['String']['output']>;
};

export type LocalizationCountry = {
	__typename?: 'LocalizationCountry';
	addressFormat: LocalizationAddressFormat;
	code: Scalars['String']['output'];
	currency?: Maybe<Scalars['String']['output']>;
	defaultMeasurementSystem?: Maybe<MeasurementSystemEnum>;
	defaultTimezone?: Maybe<Scalars['String']['output']>;
	hasStates: Scalars['Boolean']['output'];
	isEU: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	nativeName?: Maybe<Scalars['String']['output']>;
	phonePrefix?: Maybe<Scalars['String']['output']>;
	registrations: Array<LocalizationBusinessRegistrationType>;
	states: Array<LocalizationState>;
};

export type LocalizationDefaults = {
	__typename?: 'LocalizationDefaults';
	countryCode: Scalars['String']['output'];
	currency: CurrencyEnum;
	measurementSystem: MeasurementSystemEnum;
	timezone: Scalars['String']['output'];
};

export type LocalizationOrganizationSetting = Base & {
	__typename?: 'LocalizationOrganizationSetting';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	offset: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocalizationState = {
	__typename?: 'LocalizationState';
	code: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type LocalizationTimezone = {
	__typename?: 'LocalizationTimezone';
	name: Scalars['String']['output'];
	offset: Scalars['String']['output'];
};

export type LoggingAuditLog = Base & {
	__typename?: 'LoggingAuditLog';
	action?: Maybe<Scalars['String']['output']>;
	changes?: Maybe<Scalars['JSON']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['JSON']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	resource?: Maybe<Scalars['String']['output']>;
	resourceId?: Maybe<Scalars['ID']['output']>;
	serviceName?: Maybe<Scalars['String']['output']>;
	status?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type LoggingAuditLogPage = {
	__typename?: 'LoggingAuditLogPage';
	data: Array<LoggingAuditLog>;
	pageInfo: PageInfo;
};

export type LoggingLoginLog = Base & {
	__typename?: 'LoggingLoginLog';
	browser: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	failureReason?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	ipAddress: Scalars['String']['output'];
	method: Scalars['String']['output'];
	os: Scalars['String']['output'];
	referenceId: Scalars['ID']['output'];
	serviceId: Scalars['String']['output'];
	status: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<AuthenticationUser>;
	userAgent: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type LoggingLoginLogPage = {
	__typename?: 'LoggingLoginLogPage';
	data: Array<LoggingLoginLog>;
	pageInfo: PageInfo;
};

export type LoginInput = {
	authKey: Scalars['String']['input'];
	authSecret: Scalars['String']['input'];
};

export enum LoginLockReason {
	AccountPermanentlyLocked = 'AccountPermanentlyLocked',
	AccountTemporarilyLocked = 'AccountTemporarilyLocked',
	TooManyAttemptsFromThisIp = 'TooManyAttemptsFromThisIP',
}

export type LoginResponse = {
	__typename?: 'LoginResponse';
	backupCodes?: Maybe<Array<Scalars['String']['output']>>;
	mfaMethod?: Maybe<MfaMethodEnum>;
	mfaRequired: Scalars['Boolean']['output'];
	role: AuthRoleEnum;
	supportsBackupCodes: Scalars['Boolean']['output'];
	token: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type LoginValidateInput = {
	role?: InputMaybe<Array<AuthRoleEnum>>;
	token: Scalars['String']['input'];
};

export type LoginValidateResponse = {
	__typename?: 'LoginValidateResponse';
	token: Scalars['String']['output'];
	user: AuthenticationUser;
};

export type LoginWithBackupCodeInput = {
	backupCode: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type LogoutInput = {
	token: Scalars['String']['input'];
};

export type Manufacturer = Base & {
	__typename?: 'Manufacturer';
	country?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	logoUrl?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
	website?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerCreateInput = {
	country?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	logoUrl?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type ManufacturerFilterInput = {
	country?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	unassignedToVetterEntity?: InputMaybe<Scalars['Boolean']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type ManufacturerPage = {
	__typename?: 'ManufacturerPage';
	data: Array<Manufacturer>;
	pageInfo: PageInfo;
};

export type ManufacturerUpdateInput = {
	country?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	logoUrl?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	vetterEntityId?: InputMaybe<Scalars['ID']['input']>;
	website?: InputMaybe<Scalars['String']['input']>;
};

export type MarkContextMessagesAsReadInput = {
	contextId: Scalars['ID']['input'];
	messageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MarkProductInvoicePaidV2Input = {
	note?: InputMaybe<Scalars['String']['input']>;
	paymentTransactionId: Scalars['ID']['input'];
};

export type MarkProductInvoicePaidV2Response = {
	__typename?: 'MarkProductInvoicePaidV2Response';
	alreadyPaid?: Maybe<Scalars['Boolean']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export enum MeasurementSystemEnum {
	Imperial = 'IMPERIAL',
	Metric = 'METRIC',
}

export type MessageResponse = {
	__typename?: 'MessageResponse';
	errors?: Maybe<Array<ResponseError>>;
	message: Scalars['String']['output'];
	messageKey?: Maybe<Scalars['String']['output']>;
	referenceKey?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type MessageTranslations = {
	__typename?: 'MessageTranslations';
	da?: Maybe<Scalars['String']['output']>;
	en?: Maybe<Scalars['String']['output']>;
	zh?: Maybe<Scalars['String']['output']>;
};

export enum MessageType {
	File = 'file',
	System = 'system',
	Text = 'text',
}

export type MetadataAttachment = {
	__typename?: 'MetadataAttachment';
	contentType: Scalars['String']['output'];
	fileName: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	url: Scalars['String']['output'];
};

export type MetadataAttachmentInput = {
	contentType: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	size: Scalars['Int']['input'];
	url: Scalars['String']['input'];
};

export type MetadataAttachmentUploadInput = {
	contentType: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	studioFileVersionMetadataId: Scalars['ID']['input'];
};

export type MetadataAttachmentUploadResponse = {
	__typename?: 'MetadataAttachmentUploadResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	uploadUrl: Scalars['String']['output'];
};

export enum MetadataType {
	Polygon = 'polygon',
	Square = 'square',
}

export enum MfaMethodEnum {
	Authenticator = 'Authenticator',
	Email = 'Email',
}

export type MultipleDeleteResponse = {
	__typename?: 'MultipleDeleteResponse';
	deleted?: Maybe<Scalars['Int']['output']>;
	failed?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
	__typename?: 'Mutation';
	acceptOffersV2: AcceptOffersV2Response;
	acceptSampleAsIsV2: QuoteOrderItemSampleV2;
	acquireStudioLock: AcquireStudioLockResponse;
	addAdminAdjustmentToOfferV2: MessageResponse;
	addAdminAdjustmentToVariationV2: MessageResponse;
	addOfferToBatchV2: MessageResponse;
	addQuoteItemV2: MessageResponse;
	addStudioFileVersionMetadata: MessageResponse;
	approveEarlyAccessRequest: ApproveEarlyAccessResponse;
	approveNewSampleRoundV2: QuoteOrderItemSampleV2;
	approveProduct: MessageResponse;
	approveSampleV2: QuoteOrderItemSampleApprovalV2;
	assignPermissionsToRole: MessageResponse;
	assignProductToOrganization: MessageResponse;
	assignProductsToOrganization: MessageResponse;
	assignStudioFileToClient: MessageResponse;
	assignVetterEntitiesToQuoteV2: MessageResponse;
	/**
	 * Book the e-conomic draft + send the PDF via sendBy:'email'.
	 * Requires recipientEmail on the draft (synced to the e-conomic
	 * customer master first). Flips status to 'booked' — read-only
	 * thereafter; admin must issue a credit note to reverse.
	 */
	bookAdminInvoiceDraftV2: BookAdminInvoiceDraftV2Response;
	/**
	 * Cancel an admin-built invoice from any non-final state:
	 *   - draft  → deletes the e-conomic draft; items re-enter the
	 *              invoiceable pool automatically.
	 *   - booked → issues a credit note in e-conomic that fully reverses
	 *              the booked invoice, matches the two so both rows show
	 *              remainder = 0, and persists the credit-note number for
	 *              the audit trail. Same shape as cancelProductPayment so
	 *              admin-built and client-initiated cancellation flows
	 *              behave the same.
	 *
	 * Idempotent on already-cancelled drafts.
	 */
	cancelAdminInvoiceDraftV2: CancelAdminInvoiceDraftV2Response;
	/**
	 * Cancel an unpaid product payment. Refuses if any line is paid
	 * (needs a refund flow). Invoice path → credit note; Stripe path →
	 * expire session + delete orphan draft.
	 */
	cancelProductPaymentV2: CancelProductPaymentV2Response;
	cancelQuoteOrderV2: QuoteOrderV2;
	cancelSampleInvoiceForOrderV2: CancelSampleInvoiceForOrderV2Response;
	/** Undo a scheduled downgrade before it takes effect. */
	cancelScheduledPlanChange: SubscriptionMutationResponse;
	/** Cancel at the end of the current billing period. */
	cancelSubscription: SubscriptionMutationResponse;
	categorizeBulkProductImages: CategorizeBulkProductImagesResponse;
	/**
	 * Upgrade or downgrade the current subscription.
	 * - Upgrades take effect immediately and invoice the prorated diff now.
	 *   If SCA/3DS is required, response.requiresAction is true with a
	 *   clientSecret the frontend confirms with Stripe.js.
	 * - Downgrades are scheduled for the end of the current billing period
	 *   via a Stripe subscription schedule; pendingTier and
	 *   pendingTierEffectiveAt on the subscription reflect the scheduled change.
	 */
	changeSubscriptionPlan: SubscriptionMutationResponse;
	completeOrderItemProductionV2: QuoteOrderItemV2;
	completeQuoteOrderV2: QuoteOrderV2;
	completeRecommendation: CompleteRecommendationResponse;
	completeSampleProductionV2: QuoteOrderItemSampleV2;
	confirmBrandFileUpload: MessageResponse;
	confirmBrandFontUpload: MessageResponse;
	confirmChatFileUpload: MessageResponse;
	confirmProductImageUpload: MessageResponse;
	confirmQuoteOfferFileUploadV2: MessageResponse;
	confirmQuoteOrderV2: QuoteOrderV2;
	confirmStudioReferenceImageUpload: MessageResponse;
	/**
	 * Create a new admin-built invoice draft. Mints the row + an e-conomic
	 * draft from the selected line items in one go. Idempotency: each
	 * call creates a NEW draft — use updateAdminInvoiceDraftV2 to modify.
	 */
	createAdminInvoiceDraftV2: CreateAdminInvoiceDraftV2Response;
	/** Create a new admin user (Admin only) */
	createAdminUser: MessageResponse;
	createAuthorizationRole: MessageResponse;
	createBrand: MessageResponse;
	createBulkProducts: MessageResponse;
	createBulkProjectProducts: MessageResponse;
	createChatContext: MessageResponse;
	createDesignSpec: MessageResponse;
	createManufacturer: MessageResponse;
	createManyAuthorizationUserRole: MessageResponse;
	createOrganization: MessageResponse;
	createOrganizationAddress: OrganizationAddress;
	createOrganizationCompliance: OrganizationCompliance;
	createOrganizationComplianceConnection: OrganizationComplianceConnection;
	/**
	 * Create a new industry. Admins create published rows; org users
	 * create pending rows (visible only to their org until an admin
	 * publishes them).
	 */
	createOrganizationIndustry: OrganizationIndustry;
	createOrganizationOnboarding: OrganizationOnboardingResponse;
	createOrganizationProductInterest: OrganizationProductInterest;
	createOrganizationSignup: RegisterResponse;
	createOrganizationSourcingPreference: OrganizationSourcingPreference;
	createOrganizationSourcingPreferenceConnection: OrganizationSourcingPreferenceConnection;
	createOrganizationUser: MessageResponse;
	createProduct: MessageResponse;
	createProductFromStudioFile: CreateProductFromStudioResponse;
	/**
	 * Client-initiated product payment. Customer picks items to bundle;
	 * payment service builds the e-conomic draft and either returns a
	 * Stripe checkout clientSecret (below threshold) or books an invoice
	 * and emails the PDF (above threshold). Required before
	 * startOrderItemProductionV2.
	 */
	createProductPaymentForOrderV2: CreateProductPaymentForOrderV2Response;
	createProductTag: MessageResponse;
	createProductVariantFromStudioFile: CreateProductVariantFromStudioResponse;
	createProject: CreateProjectResponse;
	createProjectProduct: MessageResponse;
	createQuoteOfferBatchV2: MessageResponse;
	createQuoteOrderV2: QuoteOrderV2;
	createQuoteV2: MessageResponse;
	createSampleInvoiceForOrderV2: CreateSampleInvoiceForOrderV2Response;
	createSamplePaymentCheckout: CreateSamplePaymentCheckoutResponse;
	createSamplePaymentForOrderV2: CreateSamplePaymentForOrderV2Response;
	createStudioFile: MessageResponse;
	createStudioFileVersion: MessageResponse;
	createStudioFileVersionSpecification: MessageResponse;
	createStudioFileVersionTechPack: MessageResponse;
	/**
	 * Starts a Stripe embedded-checkout session for the chosen tier. If the org
	 * already has a subscription, use changeSubscriptionPlan instead.
	 */
	createSubscriptionCheckoutSession: CreateSubscriptionCheckoutResponse;
	createVetterEntity: MessageResponse;
	createVetterUser: MessageResponse;
	declineProduct: MessageResponse;
	/** Delete an admin user (Admin only) */
	deleteAdminUser: MessageResponse;
	deleteAuthorizationRole: MessageResponse;
	deleteBrand: MessageResponse;
	deleteBrandFile: MessageResponse;
	deleteBrandFont: MessageResponse;
	deleteChatFile: MessageResponse;
	deleteContextMessage: MessageResponse;
	deleteDesignSpec: MessageResponse;
	deleteManufacturer: MessageResponse;
	/** Delete multiple admin users (Admin only) */
	deleteManyAdminUser: MessageResponse;
	deleteManyAuthorizationRole: MessageResponse;
	deleteManyAuthorizationUserRole: MessageResponse;
	deleteManyBrand: MessageResponse;
	deleteManyManufacturer: MessageResponse;
	deleteManyOrganization?: Maybe<MessageResponse>;
	deleteManyOrganizationUser: MessageResponse;
	deleteManyProject: MessageResponse;
	deleteManyProjectProduct: MessageResponse;
	deleteManyVetterEntity: MessageResponse;
	deleteManyVetterUser: MessageResponse;
	deleteMyOrganization: MessageResponse;
	deleteOrganization?: Maybe<MessageResponse>;
	deleteOrganizationAddress: MessageResponse;
	deleteOrganizationCompliance: MessageResponse;
	deleteOrganizationComplianceConnection: MessageResponse;
	deleteOrganizationComplianceConnections: MessageResponse;
	deleteOrganizationCompliances: MessageResponse;
	/**
	 * Admin: delete an industry. Any orgs still pointing at this row
	 * will be re-pointed first: per-org overrides take precedence,
	 * then defaultReassignTo applies to the rest (null clears the FK).
	 */
	deleteOrganizationIndustry: MessageResponse;
	deleteOrganizationProductInterest: MessageResponse;
	deleteOrganizationProductInterests: MessageResponse;
	deleteOrganizationSourcingPreference: MessageResponse;
	deleteOrganizationSourcingPreferenceConnection: MessageResponse;
	deleteOrganizationSourcingPreferenceConnections: MessageResponse;
	deleteOrganizationSourcingPreferences: MessageResponse;
	deleteOrganizationUser: MessageResponse;
	deleteProduct: MessageResponse;
	deleteProductImage: MessageResponse;
	deleteProductTag: MessageResponse;
	deleteProductTags: MessageResponse;
	deleteProject: MessageResponse;
	deleteProjectProduct: MessageResponse;
	deleteQuoteItemV2: MessageResponse;
	deleteQuoteOfferBatchV2: MessageResponse;
	deleteQuoteOfferFileV2: MessageResponse;
	deleteQuoteV2: MessageResponse;
	deleteStudioFile: MessageResponse;
	deleteStudioFileVersion: MessageResponse;
	deleteStudioFileVersionMetadata: MessageResponse;
	deleteStudioFileVersionSpecification: MessageResponse;
	deleteStudioFileVersionTechPack: MessageResponse;
	deleteVetterEntity: MessageResponse;
	deleteVetterUser: MessageResponse;
	denyNewSampleRoundV2: QuoteOrderItemSampleApprovalV2;
	dismissProductRecommendation: MessageResponse;
	duplicateQuoteOfferBatchV2: DuplicateBatchResponse;
	finishMetadataAttachmentUpload: MessageResponse;
	generateBrandFileUploadUrl: FileUploadResponse;
	generateBrandFontUploadUrl: FileUploadResponse;
	generateBulkProductImageUploadUrls: GenerateBulkProductImageUploadUrlsResponse;
	generateChatAttachmentUploadUrl: ChatAttachmentUploadResponse;
	generateChatFileUploadUrl: FileUploadResponse;
	generateMetadataAttachmentUploadUrl: MetadataAttachmentUploadResponse;
	generateOrganizationUserAvatarUploadUrl: UploadUrlResponse;
	generateProductImageUploadUrl: ImageUploadResponse;
	generateProjectProductImageUploadUrls: GenerateProjectProductImageUploadUrlsResponse;
	generateQuoteOfferFileUploadUrlV2: FileUploadResponse;
	generateSampleVirtualDeliveryFileUploadUrlV2: FileUploadResponse;
	generateStudioReferenceImageUploadUrl: GenerateStudioReferenceImageUploadUrlResponse;
	getQuoteOfferFileDownloadUrlV2: FileUploadResponse;
	login: LoginResponse;
	loginValidate: LoginValidateResponse;
	loginWithBackupCode: MessageResponse;
	logout: MessageResponse;
	markContextMessagesAsRead: MessageResponse;
	markDeliveryDeliveredV2: QuoteOrderItemDeliveryV2;
	/**
	 * Admin-only override for product invoices the hourly poller missed
	 * (wrong-account transfer, poller outage, etc.). Flips invoice,
	 * transaction, and lines to paid, records audit, accrues kickback.
	 */
	markProductInvoicePaidV2: MarkProductInvoicePaidV2Response;
	markSampleDeliveredV2: QuoteOrderItemSampleV2;
	/** Admin override for booked sample invoices the hourly poller missed. Note surfaces in audit reports. */
	markSampleInvoicePaidV2: QuoteOrderItemSampleV2;
	passwordReset: MessageResponse;
	passwordResetRequest: Scalars['String']['output'];
	passwordResetValidate: MessageResponse;
	passwordUpdate: MessageResponse;
	/** Admin: flip a pending industry to published. */
	publishOrganizationIndustry: OrganizationIndustry;
	reRequestNewSampleRoundV2: QuoteOrderItemSampleApprovalV2;
	refreshExchangeRates: Scalars['Boolean']['output'];
	refreshToken: LoginValidateResponse;
	regenerateBackupCodes: BackupCodesResponse;
	register: RegisterResponse;
	rejectEarlyAccessRequest: MessageResponse;
	rejectOfferV2: MessageResponse;
	rejectSampleV2: QuoteOrderItemSampleApprovalV2;
	releaseStudioLock: MessageResponse;
	remixProductToStudio: RemixProductToStudioResponse;
	removeAdminAdjustmentFromOfferV2: MessageResponse;
	removeMetadataAttachment: MessageResponse;
	removePermissionsFromRole: MessageResponse;
	removeVetterEntitiesFromQuoteV2: MessageResponse;
	requestEarlyAccess: MessageResponse;
	requestNewSampleRoundV2: QuoteOrderItemSampleV2;
	resendEmailMfaCode: MessageResponse;
	resendPasswordResetRequest: Scalars['String']['output'];
	/** Undo a scheduled cancellation before the period ends. */
	resumeSubscription: SubscriptionMutationResponse;
	revertToStudioFileVersion: MessageResponse;
	root?: Maybe<Scalars['String']['output']>;
	sendChatMessage: SendChatMessageResponse;
	sendContextMessage: MessageResponse;
	sendQuoteOfferBatchToClientV2: MessageResponse;
	/**
	 * Marks the given quote as the calling user's current quote. This is
	 * per-user — admins acting across multiple organizations each have
	 * their own independent current pointer.
	 */
	setCurrentQuoteV2: MessageResponse;
	/** Admin override for sample deductibility (client originally sets it at approval time). */
	setSampleDeductibilityV2: QuoteOrderItemSampleV2;
	shipDeliveryV2: QuoteOrderItemDeliveryV2;
	shipSampleV2: QuoteOrderItemSampleV2;
	/**
	 * Move an item to production_started. Gated on the customer having
	 * paid the production invoice for this item.
	 */
	startOrderItemProductionV2: QuoteOrderItemV2;
	startSampleProductionV2: QuoteOrderItemSampleV2;
	submitQuoteOfferBatchV2: MessageResponse;
	submitQuoteOffersToClientV2: MessageResponse;
	submitQuoteV2: MessageResponse;
	submitVirtualSampleV2: QuoteOrderItemSampleV2;
	unlockAuthenticationUser: MessageResponse;
	updateAdminAdjustmentInOfferV2: MessageResponse;
	/**
	 * Replace contents of an existing draft. Deletes the old e-conomic
	 * draft and mints a new one (PATCH on draftInvoices is feature-
	 * incomplete in e-conomic). Only works when status = 'draft'.
	 */
	updateAdminInvoiceDraftV2: CreateAdminInvoiceDraftV2Response;
	/** Update an admin user (Admin only) */
	updateAdminUser: MessageResponse;
	updateAuthorizationRole: MessageResponse;
	updateBrand: MessageResponse;
	updateBrandColorPalette: MessageResponse;
	updateBrandPersonality: MessageResponse;
	updateBrandTypography: MessageResponse;
	updateBrandUsageGuidelines: MessageResponse;
	updateChatContextTranslation: MessageResponse;
	updateDeliveryStatusV2: QuoteOrderItemDeliveryV2;
	updateManufacturer: MessageResponse;
	updateOrderInvoiceMinimumV2: QuoteOrderV2;
	updateOrderInvoiceRecipientV2: QuoteOrderV2;
	updateOrderPaymentModeV2: QuoteOrderV2;
	updateOrderStripeCheckoutLimitV2: QuoteOrderV2;
	updateOrganization: MessageResponse;
	updateOrganizationAddress: OrganizationAddress;
	updateOrganizationApprovalAndMargin: MessageResponse;
	updateOrganizationCompliance: OrganizationCompliance;
	updateOrganizationComplianceConnection: OrganizationComplianceConnection;
	/** Admin: rename or republish an industry. */
	updateOrganizationIndustry: OrganizationIndustry;
	/** Set/clear per-org invoice minimum (DKK). null = default (25,000 DKK). */
	updateOrganizationInvoiceMinimum: MessageResponse;
	/** Set per-org default payment modes for products and samples (independent). */
	updateOrganizationPaymentMode: MessageResponse;
	updateOrganizationProductInterest: OrganizationProductInterest;
	updateOrganizationSetting: MessageResponse;
	updateOrganizationSourcingPreference: OrganizationSourcingPreference;
	updateOrganizationSourcingPreferenceConnection: OrganizationSourcingPreferenceConnection;
	/** Set/clear per-org Stripe checkout limit (EUR). null = default (€3,000). */
	updateOrganizationStripeCheckoutLimit: MessageResponse;
	updateOrganizationUser: MessageResponse;
	updateProduct: MessageResponse;
	updateProductImagePrimary: MessageResponse;
	updateProductTag: MessageResponse;
	/**
	 * Dedicated mutation to update the contact persons on a quote.
	 * Unlike updateQuoteV2 — which only fires during draft editing —
	 * this works regardless of quote status. The customer or admin
	 * can revise the notification list as the project evolves (someone
	 * leaves the company, a different finance contact takes over,
	 * etc.) without having to roll the quote back into draft.
	 *
	 * Pass an empty array to opt out of notifications entirely.
	 */
	updateQuoteContactsV2: QuoteV2;
	updateQuoteItemV2: MessageResponse;
	updateQuoteOfferBatchMarginsV2: MessageResponse;
	updateQuoteOfferBatchV2: MessageResponse;
	updateQuoteOrderStatusV2: QuoteOrderV2;
	updateQuoteV2: MessageResponse;
	updateSampleAdminPriceV2: QuoteOfferItemSampleV2;
	updateStudioFile: MessageResponse;
	updateStudioFileVersionMetadata: MessageResponse;
	updateStudioFileVersionSpecification: MessageResponse;
	updateStudioFileVersionTechPack: MessageResponse;
	updateStudioPromptTemplate: StudioPromptTemplate;
	/**
	 * Admin-only: update non-Stripe-sourced fields on a tier
	 * (kickback rate, AI token rate, isActive flag, stripePriceId pointer).
	 * Price + currency are read-only via this mutation — they come from
	 * Stripe via the price.created / price.updated webhook. To change a
	 * tier's price, edit it in the Stripe dashboard or create a new
	 * Stripe Price and point stripePriceId at it.
	 */
	updateSubscriptionTierConfig: SubscriptionTierConfig;
	updateSystemSettings: MessageResponse;
	updateUserLanguagePreference: MessageResponse;
	updateVetterEntity: MessageResponse;
	updateVetterUser: MessageResponse;
	validateAuthenticationToken: AuthenticationToken;
	verifyAuthenticatorMfa: LoginResponse;
	verifyAuthenticatorSetup: LoginResponse;
	verifyEmailMfa: LoginResponse;
	waiveSamplePaymentV2: QuoteOrderItemSampleV2;
};

export type MutationAcceptOffersV2Args = {
	input: AcceptOffersV2Input;
};

export type MutationAcceptSampleAsIsV2Args = {
	sampleId: Scalars['ID']['input'];
};

export type MutationAcquireStudioLockArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type MutationAddAdminAdjustmentToOfferV2Args = {
	input: AddAdminAdjustmentV2Input;
};

export type MutationAddAdminAdjustmentToVariationV2Args = {
	input: AddAdminAdjustmentToVariationV2Input;
};

export type MutationAddOfferToBatchV2Args = {
	input: AddOfferToBatchV2Input;
};

export type MutationAddQuoteItemV2Args = {
	input: AddQuoteItemV2Input;
};

export type MutationAddStudioFileVersionMetadataArgs = {
	input: AddStudioFileVersionMetadataInput;
	studioFileVersionId: Scalars['ID']['input'];
};

export type MutationApproveEarlyAccessRequestArgs = {
	requestId: Scalars['ID']['input'];
};

export type MutationApproveNewSampleRoundV2Args = {
	input: ApproveNewSampleRoundV2Input;
};

export type MutationApproveProductArgs = {
	productId: Scalars['ID']['input'];
};

export type MutationApproveSampleV2Args = {
	input: ApproveSampleV2Input;
};

export type MutationAssignPermissionsToRoleArgs = {
	input: AssignPermissionsToRoleInput;
};

export type MutationAssignProductToOrganizationArgs = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	productId: Scalars['ID']['input'];
};

export type MutationAssignProductsToOrganizationArgs = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	productIds: Array<Scalars['ID']['input']>;
};

export type MutationAssignStudioFileToClientArgs = {
	input: AssignStudioFileToClientInput;
};

export type MutationAssignVetterEntitiesToQuoteV2Args = {
	quoteV2Id: Scalars['ID']['input'];
	vetterEntityIds: Array<Scalars['ID']['input']>;
};

export type MutationBookAdminInvoiceDraftV2Args = {
	draftId: Scalars['ID']['input'];
};

export type MutationCancelAdminInvoiceDraftV2Args = {
	draftId: Scalars['ID']['input'];
};

export type MutationCancelProductPaymentV2Args = {
	input: CancelProductPaymentV2Input;
};

export type MutationCancelQuoteOrderV2Args = {
	id: Scalars['ID']['input'];
	reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCancelSampleInvoiceForOrderV2Args = {
	input: CancelSampleInvoiceForOrderV2Input;
};

export type MutationCategorizeBulkProductImagesArgs = {
	input: CategorizeBulkProductImagesInput;
};

export type MutationChangeSubscriptionPlanArgs = {
	tier: SubscriptionTier;
};

export type MutationCompleteOrderItemProductionV2Args = {
	orderItemId: Scalars['ID']['input'];
};

export type MutationCompleteQuoteOrderV2Args = {
	id: Scalars['ID']['input'];
};

export type MutationCompleteRecommendationArgs = {
	input: CompleteRecommendationInput;
};

export type MutationCompleteSampleProductionV2Args = {
	sampleId: Scalars['ID']['input'];
};

export type MutationConfirmBrandFileUploadArgs = {
	input: ConfirmBrandFileUploadInput;
};

export type MutationConfirmBrandFontUploadArgs = {
	input: ConfirmBrandFontUploadInput;
};

export type MutationConfirmChatFileUploadArgs = {
	input: ConfirmChatFileUploadInput;
};

export type MutationConfirmProductImageUploadArgs = {
	input: ConfirmProductImageUploadInput;
};

export type MutationConfirmQuoteOfferFileUploadV2Args = {
	input: ConfirmQuoteOfferFileUploadV2Input;
};

export type MutationConfirmQuoteOrderV2Args = {
	id: Scalars['ID']['input'];
};

export type MutationConfirmStudioReferenceImageUploadArgs = {
	input: ConfirmStudioReferenceImageUploadInput;
};

export type MutationCreateAdminInvoiceDraftV2Args = {
	input: CreateAdminInvoiceDraftV2Input;
};

export type MutationCreateAdminUserArgs = {
	input: CreateAdminUserInput;
};

export type MutationCreateAuthorizationRoleArgs = {
	input: AuthorizationRoleCreateInput;
};

export type MutationCreateBrandArgs = {
	input: BrandCreateInput;
};

export type MutationCreateBulkProductsArgs = {
	input: CreateBulkProductsInput;
};

export type MutationCreateBulkProjectProductsArgs = {
	input: CreateBulkProjectProductsInput;
};

export type MutationCreateChatContextArgs = {
	input: CreateChatContextInput;
};

export type MutationCreateDesignSpecArgs = {
	input: CreateDesignSpecInput;
};

export type MutationCreateManufacturerArgs = {
	input: ManufacturerCreateInput;
};

export type MutationCreateManyAuthorizationUserRoleArgs = {
	input: CreateManyAuthorizationUserRoleInput;
};

export type MutationCreateOrganizationArgs = {
	input: OrganizationCreateInput;
};

export type MutationCreateOrganizationAddressArgs = {
	input: OrganizationAddressInput;
	organizationId: Scalars['ID']['input'];
};

export type MutationCreateOrganizationComplianceArgs = {
	input: OrganizationComplianceCreateInput;
};

export type MutationCreateOrganizationComplianceConnectionArgs = {
	input: OrganizationComplianceConnectionCreateInput;
};

export type MutationCreateOrganizationIndustryArgs = {
	input: CreateOrganizationIndustryInput;
};

export type MutationCreateOrganizationOnboardingArgs = {
	input: OrganizationOnboardingInput;
};

export type MutationCreateOrganizationProductInterestArgs = {
	input: OrganizationProductInterestCreateInput;
};

export type MutationCreateOrganizationSignupArgs = {
	input: OrganizationSignupInput;
};

export type MutationCreateOrganizationSourcingPreferenceArgs = {
	input: OrganizationSourcingPreferenceCreateInput;
};

export type MutationCreateOrganizationSourcingPreferenceConnectionArgs = {
	input: OrganizationSourcingPreferenceConnectionCreateInput;
};

export type MutationCreateOrganizationUserArgs = {
	input: OrganizationUserCreateInput;
};

export type MutationCreateProductArgs = {
	input: ProductCreateInput;
};

export type MutationCreateProductFromStudioFileArgs = {
	input: CreateProductFromStudioInput;
};

export type MutationCreateProductPaymentForOrderV2Args = {
	input: CreateProductPaymentForOrderV2Input;
};

export type MutationCreateProductTagArgs = {
	input: ProductTagCreateInput;
};

export type MutationCreateProductVariantFromStudioFileArgs = {
	input: CreateProductVariantFromStudioInput;
};

export type MutationCreateProjectArgs = {
	input: CreateProjectInput;
};

export type MutationCreateProjectProductArgs = {
	input: CreateProjectProductInput;
};

export type MutationCreateQuoteOfferBatchV2Args = {
	input: CreateQuoteOfferBatchV2Input;
};

export type MutationCreateQuoteOrderV2Args = {
	input: CreateQuoteOrderV2Input;
};

export type MutationCreateQuoteV2Args = {
	input: CreateQuoteV2Input;
};

export type MutationCreateSampleInvoiceForOrderV2Args = {
	input: CreateSampleInvoiceForOrderV2Input;
};

export type MutationCreateSamplePaymentCheckoutArgs = {
	input: CreateSamplePaymentCheckoutInput;
};

export type MutationCreateSamplePaymentForOrderV2Args = {
	input: CreateSamplePaymentForOrderV2Input;
};

export type MutationCreateStudioFileArgs = {
	input: StudioFileCreateInput;
};

export type MutationCreateStudioFileVersionArgs = {
	input: CreateStudioFileVersionInput;
};

export type MutationCreateStudioFileVersionSpecificationArgs = {
	input: CreateStudioFileVersionSpecificationInput;
};

export type MutationCreateStudioFileVersionTechPackArgs = {
	input: CreateStudioFileVersionTechPackInput;
};

export type MutationCreateSubscriptionCheckoutSessionArgs = {
	tier: SubscriptionTier;
};

export type MutationCreateVetterEntityArgs = {
	input: CreateVetterEntityInput;
};

export type MutationCreateVetterUserArgs = {
	input: CreateVetterUserInput;
};

export type MutationDeclineProductArgs = {
	productId: Scalars['ID']['input'];
};

export type MutationDeleteAdminUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteAuthorizationRoleArgs = {
	input: DeleteInput;
};

export type MutationDeleteBrandArgs = {
	input: DeleteInput;
};

export type MutationDeleteBrandFileArgs = {
	brandId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
};

export type MutationDeleteBrandFontArgs = {
	brandId: Scalars['ID']['input'];
	fontId: Scalars['ID']['input'];
};

export type MutationDeleteChatFileArgs = {
	contextId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
};

export type MutationDeleteContextMessageArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteDesignSpecArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteManufacturerArgs = {
	input: DeleteInput;
};

export type MutationDeleteManyAdminUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAuthorizationRoleArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAuthorizationUserRoleArgs = {
	input: DeleteManyAuthorizationUserRoleInput;
};

export type MutationDeleteManyBrandArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyManufacturerArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyOrganizationArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyOrganizationUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyProjectArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyProjectProductArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyVetterEntityArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyVetterUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationArgs = {
	input: DeleteInput;
};

export type MutationDeleteOrganizationAddressArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationComplianceArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationComplianceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationComplianceConnectionsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationCompliancesArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationIndustryArgs = {
	input: DeleteOrganizationIndustryInput;
};

export type MutationDeleteOrganizationProductInterestArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationProductInterestsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationSourcingPreferenceArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationSourcingPreferenceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationSourcingPreferenceConnectionsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationSourcingPreferencesArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteOrganizationUserArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductImageArgs = {
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type MutationDeleteProductTagArgs = {
	input: DeleteInput;
};

export type MutationDeleteProductTagsArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteProjectArgs = {
	input: DeleteInput;
};

export type MutationDeleteProjectProductArgs = {
	input: DeleteInput;
};

export type MutationDeleteQuoteItemV2Args = {
	input: DeleteQuoteItemV2Input;
};

export type MutationDeleteQuoteOfferBatchV2Args = {
	batchId: Scalars['ID']['input'];
};

export type MutationDeleteQuoteOfferFileV2Args = {
	fileId: Scalars['ID']['input'];
	quoteV2Id: Scalars['ID']['input'];
};

export type MutationDeleteQuoteV2Args = {
	input: DeleteQuoteV2Input;
};

export type MutationDeleteStudioFileArgs = {
	input: DeleteInput;
};

export type MutationDeleteStudioFileVersionArgs = {
	versionId: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileVersionMetadataArgs = {
	metadataId: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileVersionSpecificationArgs = {
	specificationId: Scalars['ID']['input'];
};

export type MutationDeleteStudioFileVersionTechPackArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteVetterEntityArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteVetterUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDenyNewSampleRoundV2Args = {
	input: DenyNewSampleRoundV2Input;
};

export type MutationDismissProductRecommendationArgs = {
	recommendationId: Scalars['ID']['input'];
};

export type MutationDuplicateQuoteOfferBatchV2Args = {
	batchId: Scalars['ID']['input'];
};

export type MutationFinishMetadataAttachmentUploadArgs = {
	input: FinishMetadataAttachmentUploadInput;
};

export type MutationGenerateBrandFileUploadUrlArgs = {
	input: BrandFileUploadInput;
};

export type MutationGenerateBrandFontUploadUrlArgs = {
	input: FontFileUploadInput;
};

export type MutationGenerateBulkProductImageUploadUrlsArgs = {
	input: GenerateBulkProductImageUploadUrlsInput;
};

export type MutationGenerateChatAttachmentUploadUrlArgs = {
	input: ChatAttachmentUploadInput;
};

export type MutationGenerateChatFileUploadUrlArgs = {
	input: ChatFileUploadInput;
};

export type MutationGenerateMetadataAttachmentUploadUrlArgs = {
	input: MetadataAttachmentUploadInput;
};

export type MutationGenerateOrganizationUserAvatarUploadUrlArgs = {
	input: GenerateUploadUrlInput;
};

export type MutationGenerateProductImageUploadUrlArgs = {
	input: ProductImageUploadInput;
};

export type MutationGenerateProjectProductImageUploadUrlsArgs = {
	input: GenerateProjectProductImageUploadUrlsInput;
};

export type MutationGenerateQuoteOfferFileUploadUrlV2Args = {
	input: QuoteOfferFileUploadV2Input;
};

export type MutationGenerateSampleVirtualDeliveryFileUploadUrlV2Args = {
	input: SampleVirtualDeliveryFileUploadV2Input;
};

export type MutationGenerateStudioReferenceImageUploadUrlArgs = {
	input: GenerateStudioReferenceImageUploadUrlInput;
};

export type MutationGetQuoteOfferFileDownloadUrlV2Args = {
	fileId: Scalars['ID']['input'];
	quoteV2Id: Scalars['ID']['input'];
};

export type MutationLoginArgs = {
	input: LoginInput;
};

export type MutationLoginValidateArgs = {
	input: LoginValidateInput;
};

export type MutationLoginWithBackupCodeArgs = {
	input: LoginWithBackupCodeInput;
};

export type MutationLogoutArgs = {
	input: LogoutInput;
};

export type MutationMarkContextMessagesAsReadArgs = {
	input: MarkContextMessagesAsReadInput;
};

export type MutationMarkDeliveryDeliveredV2Args = {
	actualDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	id: Scalars['ID']['input'];
};

export type MutationMarkProductInvoicePaidV2Args = {
	input: MarkProductInvoicePaidV2Input;
};

export type MutationMarkSampleDeliveredV2Args = {
	sampleId: Scalars['ID']['input'];
};

export type MutationMarkSampleInvoicePaidV2Args = {
	note?: InputMaybe<Scalars['String']['input']>;
	sampleId: Scalars['ID']['input'];
};

export type MutationPasswordResetArgs = {
	input: PasswordResetInput;
};

export type MutationPasswordResetRequestArgs = {
	input: PasswordResetRequestInput;
};

export type MutationPasswordResetValidateArgs = {
	input: PasswordResetValidateInput;
};

export type MutationPasswordUpdateArgs = {
	input: PasswordUpdateInput;
};

export type MutationPublishOrganizationIndustryArgs = {
	id: Scalars['ID']['input'];
};

export type MutationReRequestNewSampleRoundV2Args = {
	input: ReRequestNewSampleRoundV2Input;
};

export type MutationRegenerateBackupCodesArgs = {
	input: RegenerateBackupCodesInput;
};

export type MutationRegisterArgs = {
	input: RegisterInput;
};

export type MutationRejectEarlyAccessRequestArgs = {
	requestId: Scalars['ID']['input'];
};

export type MutationRejectOfferV2Args = {
	offerId: Scalars['ID']['input'];
	reason: Scalars['String']['input'];
};

export type MutationRejectSampleV2Args = {
	input: RejectSampleV2Input;
};

export type MutationReleaseStudioLockArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type MutationRemixProductToStudioArgs = {
	input: RemixProductToStudioInput;
};

export type MutationRemoveAdminAdjustmentFromOfferV2Args = {
	adjustmentId: Scalars['ID']['input'];
	offerId: Scalars['ID']['input'];
};

export type MutationRemoveMetadataAttachmentArgs = {
	input: RemoveMetadataAttachmentInput;
};

export type MutationRemovePermissionsFromRoleArgs = {
	input: RemovePermissionsFromRoleInput;
};

export type MutationRemoveVetterEntitiesFromQuoteV2Args = {
	quoteV2Id: Scalars['ID']['input'];
	vetterEntityIds: Array<Scalars['ID']['input']>;
};

export type MutationRequestEarlyAccessArgs = {
	input: RequestEarlyAccessInput;
};

export type MutationRequestNewSampleRoundV2Args = {
	previousSampleId: Scalars['ID']['input'];
	reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationResendEmailMfaCodeArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationResendPasswordResetRequestArgs = {
	input: PasswordResetRequestInput;
};

export type MutationRevertToStudioFileVersionArgs = {
	versionId: Scalars['ID']['input'];
};

export type MutationSendChatMessageArgs = {
	input: SendChatMessageInput;
};

export type MutationSendContextMessageArgs = {
	input: SendContextMessageInput;
};

export type MutationSendQuoteOfferBatchToClientV2Args = {
	batchId: Scalars['ID']['input'];
};

export type MutationSetCurrentQuoteV2Args = {
	id: Scalars['ID']['input'];
};

export type MutationSetSampleDeductibilityV2Args = {
	isDeductible: Scalars['Boolean']['input'];
	sampleId: Scalars['ID']['input'];
};

export type MutationShipDeliveryV2Args = {
	carrier: Scalars['String']['input'];
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	id: Scalars['ID']['input'];
	trackingNumber: Scalars['String']['input'];
};

export type MutationShipSampleV2Args = {
	carrier?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
	sampleId: Scalars['ID']['input'];
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartOrderItemProductionV2Args = {
	orderItemId: Scalars['ID']['input'];
};

export type MutationStartSampleProductionV2Args = {
	sampleId: Scalars['ID']['input'];
};

export type MutationSubmitQuoteOfferBatchV2Args = {
	batchId: Scalars['ID']['input'];
};

export type MutationSubmitQuoteOffersToClientV2Args = {
	input: SubmitQuoteOffersToClientV2Input;
};

export type MutationSubmitQuoteV2Args = {
	input: SubmitQuoteV2Input;
};

export type MutationSubmitVirtualSampleV2Args = {
	input: SubmitVirtualSampleV2Input;
};

export type MutationUnlockAuthenticationUserArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationUpdateAdminAdjustmentInOfferV2Args = {
	input: UpdateAdminAdjustmentV2Input;
};

export type MutationUpdateAdminInvoiceDraftV2Args = {
	input: UpdateAdminInvoiceDraftV2Input;
};

export type MutationUpdateAdminUserArgs = {
	id: Scalars['ID']['input'];
	input: UpdateAdminUserInput;
};

export type MutationUpdateAuthorizationRoleArgs = {
	input: AuthorizationRoleUpdateInput;
};

export type MutationUpdateBrandArgs = {
	input: BrandUpdateInput;
};

export type MutationUpdateBrandColorPaletteArgs = {
	brandId: Scalars['ID']['input'];
	colorPalette: BrandColorPaletteInput;
};

export type MutationUpdateBrandPersonalityArgs = {
	brandId: Scalars['ID']['input'];
	personality: BrandPersonalityInput;
};

export type MutationUpdateBrandTypographyArgs = {
	brandId: Scalars['ID']['input'];
	typography: BrandTypographyInput;
};

export type MutationUpdateBrandUsageGuidelinesArgs = {
	brandId: Scalars['ID']['input'];
	guidelines: BrandUsageGuidelinesInput;
};

export type MutationUpdateChatContextTranslationArgs = {
	input: UpdateChatContextTranslationInput;
};

export type MutationUpdateDeliveryStatusV2Args = {
	id: Scalars['ID']['input'];
	status: QuoteOrderItemDeliveryStatusV2;
};

export type MutationUpdateManufacturerArgs = {
	input: ManufacturerUpdateInput;
};

export type MutationUpdateOrderInvoiceMinimumV2Args = {
	limit?: InputMaybe<Scalars['Float']['input']>;
	orderId: Scalars['ID']['input'];
};

export type MutationUpdateOrderInvoiceRecipientV2Args = {
	orderId: Scalars['ID']['input'];
	recipient: InvoiceRecipientInputV2;
};

export type MutationUpdateOrderPaymentModeV2Args = {
	orderId: Scalars['ID']['input'];
	productPaymentMode: PaymentModeEnum;
	samplePaymentMode: PaymentModeEnum;
};

export type MutationUpdateOrderStripeCheckoutLimitV2Args = {
	limit?: InputMaybe<Scalars['Float']['input']>;
	orderId: Scalars['ID']['input'];
};

export type MutationUpdateOrganizationArgs = {
	input: OrganizationUpdateInput;
};

export type MutationUpdateOrganizationAddressArgs = {
	id: Scalars['ID']['input'];
	input: OrganizationAddressInput;
};

export type MutationUpdateOrganizationApprovalAndMarginArgs = {
	input: UpdateOrganizationApprovalAndMarginInput;
};

export type MutationUpdateOrganizationComplianceArgs = {
	input: OrganizationComplianceUpdateInput;
};

export type MutationUpdateOrganizationComplianceConnectionArgs = {
	input: OrganizationComplianceConnectionUpdateInput;
};

export type MutationUpdateOrganizationIndustryArgs = {
	input: UpdateOrganizationIndustryInput;
};

export type MutationUpdateOrganizationInvoiceMinimumArgs = {
	input: UpdateOrganizationInvoiceMinimumInput;
};

export type MutationUpdateOrganizationPaymentModeArgs = {
	input: UpdateOrganizationPaymentModeInput;
};

export type MutationUpdateOrganizationProductInterestArgs = {
	input: OrganizationProductInterestUpdateInput;
};

export type MutationUpdateOrganizationSettingArgs = {
	input: OrganizationSettingUpdateInput;
};

export type MutationUpdateOrganizationSourcingPreferenceArgs = {
	input: OrganizationSourcingPreferenceUpdateInput;
};

export type MutationUpdateOrganizationSourcingPreferenceConnectionArgs = {
	input: OrganizationSourcingPreferenceConnectionUpdateInput;
};

export type MutationUpdateOrganizationStripeCheckoutLimitArgs = {
	input: UpdateOrganizationStripeCheckoutLimitInput;
};

export type MutationUpdateOrganizationUserArgs = {
	input: OrganizationUserUpdateInput;
};

export type MutationUpdateProductArgs = {
	input: ProductUpdateInput;
};

export type MutationUpdateProductImagePrimaryArgs = {
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type MutationUpdateProductTagArgs = {
	input: ProductTagUpdateInput;
};

export type MutationUpdateQuoteContactsV2Args = {
	contactUserIds: Array<Scalars['ID']['input']>;
	quoteId: Scalars['ID']['input'];
};

export type MutationUpdateQuoteItemV2Args = {
	input: UpdateQuoteItemV2Input;
};

export type MutationUpdateQuoteOfferBatchMarginsV2Args = {
	input: UpdateQuoteOfferBatchMarginsV2Input;
};

export type MutationUpdateQuoteOfferBatchV2Args = {
	batchId: Scalars['ID']['input'];
	input: UpdateQuoteOfferBatchV2Input;
};

export type MutationUpdateQuoteOrderStatusV2Args = {
	id: Scalars['ID']['input'];
	status: QuoteOrderStatusV2;
};

export type MutationUpdateQuoteV2Args = {
	input: UpdateQuoteV2Input;
};

export type MutationUpdateSampleAdminPriceV2Args = {
	input: UpdateSampleAdminPriceV2Input;
};

export type MutationUpdateStudioFileArgs = {
	input: StudioFileUpdateInput;
};

export type MutationUpdateStudioFileVersionMetadataArgs = {
	input: UpdateStudioFileVersionMetadataInput;
	metadataId: Scalars['ID']['input'];
};

export type MutationUpdateStudioFileVersionSpecificationArgs = {
	input: UpdateStudioFileVersionSpecificationInput;
	specificationId: Scalars['ID']['input'];
};

export type MutationUpdateStudioFileVersionTechPackArgs = {
	id: Scalars['ID']['input'];
	input: UpdateStudioFileVersionTechPackInput;
};

export type MutationUpdateStudioPromptTemplateArgs = {
	input: UpdateStudioPromptTemplateInput;
};

export type MutationUpdateSubscriptionTierConfigArgs = {
	aiTokenRatePerMillion?: InputMaybe<Scalars['Float']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	kickbackRate?: InputMaybe<Scalars['Float']['input']>;
	stripePriceId?: InputMaybe<Scalars['String']['input']>;
	tier: SubscriptionTier;
};

export type MutationUpdateSystemSettingsArgs = {
	input: UpdateSystemSettingInput;
};

export type MutationUpdateUserLanguagePreferenceArgs = {
	language?: InputMaybe<SupportedLanguage>;
};

export type MutationUpdateVetterEntityArgs = {
	id: Scalars['ID']['input'];
	input: UpdateVetterEntityInput;
};

export type MutationUpdateVetterUserArgs = {
	id: Scalars['ID']['input'];
	input: UpdateVetterUserInput;
};

export type MutationValidateAuthenticationTokenArgs = {
	token: Scalars['String']['input'];
};

export type MutationVerifyAuthenticatorMfaArgs = {
	input: VerifyAuthenticatorMfaInput;
};

export type MutationVerifyAuthenticatorSetupArgs = {
	input: VerifyAuthenticatorSetupInput;
};

export type MutationVerifyEmailMfaArgs = {
	input: VerifyEmailMfaInput;
};

export type MutationWaiveSamplePaymentV2Args = {
	sampleId: Scalars['ID']['input'];
};

export enum NewSampleRequestStatusV2 {
	Approved = 'approved',
	Denied = 'denied',
	Pending = 'pending',
}

/** Tracks the kind of transition an offer is going through — used by notifications, history entries, and audit logs across the quote flow. */
export enum OfferAction {
	AddMargin = 'ADD_MARGIN',
	AdminAcceptClient = 'ADMIN_ACCEPT_CLIENT',
	AdminAcceptVetter = 'ADMIN_ACCEPT_VETTER',
	AdminRejectClient = 'ADMIN_REJECT_CLIENT',
	AdminRejectVetter = 'ADMIN_REJECT_VETTER',
	ApproveForClient = 'APPROVE_FOR_CLIENT',
	AutoReject = 'AUTO_REJECT',
	Cancel = 'CANCEL',
	ClientAcceptAdmin = 'CLIENT_ACCEPT_ADMIN',
	ClientRejectAdmin = 'CLIENT_REJECT_ADMIN',
	CounterOffer = 'COUNTER_OFFER',
	CounterOfferBasePrice = 'COUNTER_OFFER_BASE_PRICE',
	Create = 'CREATE',
	Expire = 'EXPIRE',
	Submit = 'SUBMIT',
	VetterAcceptAdmin = 'VETTER_ACCEPT_ADMIN',
	VetterRejectAdmin = 'VETTER_REJECT_ADMIN',
}

export type OnboardingComplianceInput = {
	certificationNumber?: InputMaybe<Scalars['String']['input']>;
	certifyingBody?: InputMaybe<Scalars['String']['input']>;
	expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
	issueDate?: InputMaybe<Scalars['DateTime']['input']>;
	organizationComplianceId: Scalars['ID']['input'];
};

export type OnboardingProductInterestInput = {
	customTagName?: InputMaybe<Scalars['String']['input']>;
	productTagId?: InputMaybe<Scalars['ID']['input']>;
};

export type OnboardingSourcingPreferenceInput = {
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationSourcingPreferenceId: Scalars['ID']['input'];
	priority?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderCheckoutLimitV2 = {
	__typename?: 'OrderCheckoutLimitV2';
	/**
	 * Effective invoice minimum in DKK. Below this total, the invoice
	 * path is unavailable and the customer must pay via Stripe.
	 * Null = no minimum (invoice available at any total).
	 */
	invoiceMinimum?: Maybe<Scalars['Float']['output']>;
	/**
	 * Effective Stripe checkout limit in EUR. Above this total, the
	 * Stripe path is unavailable and the customer must pay by invoice.
	 * Null = no limit (Stripe always available).
	 */
	limit?: Maybe<Scalars['Float']['output']>;
	/** Where the limit comes from: order, org, or none. */
	source: Scalars['String']['output'];
};

export type OrderInput = {
	direction: OrderTypes;
	field: Scalars['String']['input'];
};

export type OrderStatsByStatusV2 = {
	__typename?: 'OrderStatsByStatusV2';
	currency?: Maybe<CurrencyEnum>;
	dateRange?: Maybe<DateRange>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	statusBreakdown: Array<OrderStatusBreakdownV2>;
	total: Scalars['Int']['output'];
	totalAmount: Scalars['Float']['output'];
};

export type OrderStatsV2 = {
	__typename?: 'OrderStatsV2';
	averageDeliveryAmount: Scalars['Float']['output'];
	averageMargin: Scalars['Float']['output'];
	averageOrderAmount: Scalars['Float']['output'];
	currency?: Maybe<CurrencyEnum>;
	dateRange?: Maybe<DateRange>;
	medianDeliveryAmount: Scalars['Float']['output'];
	medianMargin: Scalars['Float']['output'];
	medianOrderAmount: Scalars['Float']['output'];
	organizationId?: Maybe<Scalars['ID']['output']>;
	totalOrderAmount: Scalars['Float']['output'];
	totalOrders: Scalars['Int']['output'];
};

export type OrderStatusBreakdownV2 = {
	__typename?: 'OrderStatusBreakdownV2';
	count: Scalars['Int']['output'];
	percentage: Scalars['Float']['output'];
	status: QuoteOrderStatusV2;
	totalAmount: Scalars['Float']['output'];
};

export type OrderTransactionDescriptionV2 = {
	__typename?: 'OrderTransactionDescriptionV2';
	/** Only set for sample rows — sample round number. Always null for product rows. */
	sampleRound?: Maybe<Scalars['Int']['output']>;
	text: Scalars['String']['output'];
};

/** Discriminator on OrderTransactionRowV2 — sample-payment row vs product-payment row. */
export enum OrderTransactionKindV2 {
	Product = 'product',
	Sample = 'sample',
}

export type OrderTransactionRowV2 = {
	__typename?: 'OrderTransactionRowV2';
	currency: CurrencyEnum;
	/** ISO date used for ordering — invoice createdAt or transaction createdAt. */
	date: Scalars['DateTime']['output'];
	/** One entry per sample in a batch / per paymentProductLine in a product txn. */
	descriptions: Array<OrderTransactionDescriptionV2>;
	/** e-conomic booked invoice number when there is one. */
	invoiceNumber?: Maybe<Scalars['Int']['output']>;
	/** True for historical rows (cancelled / failed invoice attempts that have been superseded). */
	isHistory: Scalars['Boolean']['output'];
	/** Stable React key — invoice key for grouped sample rows, UUID for standalones / product rows. */
	key: Scalars['String']['output'];
	/** sample | product — drives UI affordances (e.g. cancel button is product-only today). */
	kind: OrderTransactionKindV2;
	/** 'Stripe' or 'Invoice'. */
	method?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	/** Parent paymentTransaction id for product rows. Null for sample rows. */
	paymentTransactionId?: Maybe<Scalars['ID']['output']>;
	/**
	 * Lifecycle: unpaid / invoiced / paid / waived / refunded / failed (sample);
	 * pending / processing / completed / failed (product).
	 */
	status: Scalars['String']['output'];
	totalPrice: Scalars['Float']['output'];
};

export enum OrderTypes {
	Asc = 'ASC',
	Desc = 'DESC',
}

export type Organization = Base & {
	__typename?: 'Organization';
	addresses?: Maybe<Array<OrganizationAddress>>;
	businessRegistrations?: Maybe<Array<BusinessRegistration>>;
	complianceConnections?: Maybe<Array<OrganizationComplianceConnection>>;
	compliances?: Maybe<Array<OrganizationCompliance>>;
	countryCode?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	kickbackBalance?: Maybe<Scalars['Float']['output']>;
	kickbackTransactions?: Maybe<Array<KickbackTransaction>>;
	logo?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	onboarded: Scalars['Boolean']['output'];
	/** Resolved industry record. Null when organizationIndustryId is null. */
	organizationIndustry?: Maybe<OrganizationIndustry>;
	/** FK to the organizationIndustry table. Null = no industry chosen. */
	organizationIndustryId?: Maybe<Scalars['ID']['output']>;
	organizationSetting?: Maybe<OrganizationSetting>;
	organizationUsers?: Maybe<Array<OrganizationUser>>;
	productInterests?: Maybe<Array<OrganizationProductInterest>>;
	projects?: Maybe<Array<Project>>;
	sourcingPreferenceConnections?: Maybe<Array<OrganizationSourcingPreferenceConnection>>;
	sourcingPreferences?: Maybe<Array<OrganizationSourcingPreference>>;
	subscription?: Maybe<OrganizationSubscription>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationKickbackTransactionsArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationActiveActivities = {
	__typename?: 'OrganizationActiveActivities';
	activities: Array<OrganizationActivity>;
};

export type OrganizationActivity =
	| OrganizationChatActivity
	| OrganizationOrderActivity
	| OrganizationQuoteActivity
	| OrganizationQuoteOfferActivity;

export enum OrganizationActivityType {
	DraftQuote = 'DRAFT_QUOTE',
	OrderSampleApprovalPending = 'ORDER_SAMPLE_APPROVAL_PENDING',
	OrderSamplePaymentPending = 'ORDER_SAMPLE_PAYMENT_PENDING',
	QuoteOfferClientReview = 'QUOTE_OFFER_CLIENT_REVIEW',
	UnreadChatMessage = 'UNREAD_CHAT_MESSAGE',
}

export type OrganizationAddress = Base & {
	__typename?: 'OrganizationAddress';
	addressLine1: Scalars['String']['output'];
	addressLine2?: Maybe<Scalars['String']['output']>;
	addressType: AddressType;
	city: Scalars['String']['output'];
	countryCode: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	googlePlaceId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isPrimary: Scalars['Boolean']['output'];
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	postalCode: Scalars['String']['output'];
	stateCode?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationAddressInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	addressType?: InputMaybe<AddressType>;
	city: Scalars['String']['input'];
	countryCode: Scalars['String']['input'];
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	postalCode: Scalars['String']['input'];
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationApprovalAndMargin = {
	__typename?: 'OrganizationApprovalAndMargin';
	defaultApproval: Scalars['Boolean']['output'];
	defaultMargin: Scalars['Float']['output'];
	organizationId: Scalars['ID']['output'];
};

export type OrganizationChatActivity = {
	__typename?: 'OrganizationChatActivity';
	context?: Maybe<ChatContext>;
	contextId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
	lastMessageAt: Scalars['DateTime']['output'];
	type: OrganizationActivityType;
	unreadCount: Scalars['Int']['output'];
};

export type OrganizationCompliance = Base & {
	__typename?: 'OrganizationCompliance';
	connections?: Maybe<Array<OrganizationComplianceConnection>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationComplianceConnection = Base & {
	__typename?: 'OrganizationComplianceConnection';
	certificationNumber?: Maybe<Scalars['String']['output']>;
	certifyingBody?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	expiryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	issueDate?: Maybe<Scalars['DateTime']['output']>;
	organization?: Maybe<Organization>;
	organizationCompliance?: Maybe<OrganizationCompliance>;
	organizationComplianceId: Scalars['ID']['output'];
	organizationId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationComplianceConnectionCreateInput = {
	certificationNumber?: InputMaybe<Scalars['String']['input']>;
	certifyingBody?: InputMaybe<Scalars['String']['input']>;
	expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
	issueDate?: InputMaybe<Scalars['DateTime']['input']>;
	organizationComplianceId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type OrganizationComplianceConnectionListInput = {
	order?: InputMaybe<OrderInput>;
	organizationComplianceId?: InputMaybe<Scalars['ID']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationComplianceConnectionListResponse = {
	__typename?: 'OrganizationComplianceConnectionListResponse';
	data: Array<OrganizationComplianceConnection>;
	pageInfo: PageInfo;
};

export type OrganizationComplianceConnectionUpdateInput = {
	certificationNumber?: InputMaybe<Scalars['String']['input']>;
	certifyingBody?: InputMaybe<Scalars['String']['input']>;
	expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
	id: Scalars['ID']['input'];
	issueDate?: InputMaybe<Scalars['DateTime']['input']>;
	organizationComplianceId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationComplianceCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
};

export type OrganizationComplianceListInput = {
	name?: InputMaybe<Scalars['String']['input']>;
	order?: InputMaybe<OrderInput>;
	pagination?: InputMaybe<PaginationInput>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationComplianceListResponse = {
	__typename?: 'OrganizationComplianceListResponse';
	data?: Maybe<Array<OrganizationCompliance>>;
	pageInfo: PageInfo;
};

export type OrganizationComplianceUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateInput = {
	address?: InputMaybe<OrganizationAddressInput>;
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode: Scalars['String']['input'];
	currency?: InputMaybe<CurrencyEnum>;
	email?: InputMaybe<Scalars['String']['input']>;
	measurementSystem?: InputMaybe<MeasurementSystemEnum>;
	name: Scalars['String']['input'];
	/** FK to an existing organizationIndustry row. Use createOrganizationIndustry first to get an id for a custom industry. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	timezone?: InputMaybe<Scalars['ID']['input']>;
	users?: InputMaybe<Array<UserInput>>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationIndustry = Base & {
	__typename?: 'OrganizationIndustry';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** Org that submitted this industry via the Other flow. Null when admin-created. */
	createdByOrganizationId?: Maybe<Scalars['ID']['output']>;
	id: Scalars['ID']['output'];
	isPublished: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationIndustryReassignment = {
	organizationId: Scalars['ID']['input'];
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
};

export enum OrganizationLocationEnum {
	Africa = 'AFRICA',
	Asia = 'ASIA',
	Australia = 'AUSTRALIA',
	Europe = 'EUROPE',
	Global = 'GLOBAL',
	NorthernEurope = 'NORTHERN_EUROPE',
	NorthAmerica = 'NORTH_AMERICA',
	SouthAmerica = 'SOUTH_AMERICA',
}

export type OrganizationOnboardingInput = {
	compliances?: InputMaybe<Array<OnboardingComplianceInput>>;
	organizationId: Scalars['ID']['input'];
	productInterests?: InputMaybe<Array<OnboardingProductInterestInput>>;
	sourcingPreferences?: InputMaybe<Array<OnboardingSourcingPreferenceInput>>;
};

export type OrganizationOnboardingResponse = {
	__typename?: 'OrganizationOnboardingResponse';
	complianceConnections: Array<OrganizationComplianceConnection>;
	message: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	productInterests: Array<OrganizationProductInterest>;
	sourcingPreferenceConnections: Array<OrganizationSourcingPreferenceConnection>;
	success: Scalars['Boolean']['output'];
};

/** Client action required on an order — state transition blocked until the client acts. */
export type OrganizationOrderActivity = {
	__typename?: 'OrganizationOrderActivity';
	id: Scalars['ID']['output'];
	order?: Maybe<QuoteOrderV2>;
	orderId: Scalars['ID']['output'];
	type: OrganizationActivityType;
};

export type OrganizationPage = {
	__typename?: 'OrganizationPage';
	data: Array<Organization>;
	pageInfo: PageInfo;
};

export type OrganizationProductInterest = Base & {
	__typename?: 'OrganizationProductInterest';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	productTagId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationProductInterestCreateInput = {
	organizationId: Scalars['ID']['input'];
	productTagId: Scalars['ID']['input'];
};

export type OrganizationProductInterestListInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination?: InputMaybe<PaginationInput>;
	productTagId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationProductInterestListResponse = {
	__typename?: 'OrganizationProductInterestListResponse';
	data?: Maybe<Array<OrganizationProductInterest>>;
	pageInfo: PageInfo;
};

export type OrganizationProductInterestUpdateInput = {
	id: Scalars['ID']['input'];
};

export type OrganizationQuoteActivity = {
	__typename?: 'OrganizationQuoteActivity';
	id: Scalars['ID']['output'];
	quote?: Maybe<QuoteV2>;
	quoteId: Scalars['ID']['output'];
	type: OrganizationActivityType;
};

export type OrganizationQuoteOfferActivity = {
	__typename?: 'OrganizationQuoteOfferActivity';
	id: Scalars['ID']['output'];
	quoteOffer?: Maybe<QuoteOfferV2>;
	quoteOfferId: Scalars['ID']['output'];
	type: OrganizationActivityType;
};

export type OrganizationResponse = {
	__typename?: 'OrganizationResponse';
	data?: Maybe<Organization>;
	message: Scalars['String']['output'];
	messageKey: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export type OrganizationSetting = Base & {
	__typename?: 'OrganizationSetting';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currency?: Maybe<CurrencyEnum>;
	id: Scalars['ID']['output'];
	/** Per-org invoice minimum (DKK). Below → Stripe only. Null = system default (25,000). */
	invoiceMinimumThreshold?: Maybe<Scalars['Float']['output']>;
	measurementSystem: MeasurementSystemEnum;
	organizationId: Scalars['ID']['output'];
	/** Default payment mode for product payments. Snapshotted to the order at acceptance. */
	productPaymentMode: PaymentModeEnum;
	/** Default payment mode for sample payments. Snapshotted to the order at acceptance. */
	samplePaymentMode: PaymentModeEnum;
	/** Per-org Stripe checkout limit (EUR). Null = system default (3,000). */
	stripeCheckoutLimit?: Maybe<Scalars['Float']['output']>;
	timezone: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSettingUpdateInput = {
	currency: CurrencyEnum;
	id: Scalars['ID']['input'];
	measurementSystem: MeasurementSystemEnum;
	timezone: Scalars['String']['input'];
};

export type OrganizationSettingsInput = {
	currency?: InputMaybe<CurrencyEnum>;
	measurementSystem?: InputMaybe<MeasurementSystemEnum>;
	timezone?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSignupInput = {
	address?: InputMaybe<SignupAddressInput>;
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode: Scalars['String']['input'];
	currency: CurrencyEnum;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	inviteToken: Scalars['String']['input'];
	jobPosition: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	measurementSystem: MeasurementSystemEnum;
	mfaMethod: MfaMethodEnum;
	/** Optional FK to an existing organizationIndustry row picked from the dropdown. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	/** Optional free-text industry name (the 'Other' path). The org service creates a pending OrganizationIndustry row tied to the new org. */
	organizationIndustryName?: InputMaybe<Scalars['String']['input']>;
	organizationName: Scalars['String']['input'];
	password: Scalars['Password']['input'];
	role: AuthRoleEnum;
	timezone: Scalars['ID']['input'];
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSourcingPreference = Base & {
	__typename?: 'OrganizationSourcingPreference';
	connections?: Maybe<Array<OrganizationSourcingPreferenceConnection>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSourcingPreferenceConnection = Base & {
	__typename?: 'OrganizationSourcingPreferenceConnection';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	organizationSourcingPreference?: Maybe<OrganizationSourcingPreference>;
	organizationSourcingPreferenceId: Scalars['ID']['output'];
	priority?: Maybe<Scalars['Int']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSourcingPreferenceConnectionCreateInput = {
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationId: Scalars['ID']['input'];
	organizationSourcingPreferenceId: Scalars['ID']['input'];
	priority?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationSourcingPreferenceConnectionListInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	organizationSourcingPreferenceId?: InputMaybe<Scalars['ID']['input']>;
	pagination?: InputMaybe<PaginationInput>;
};

export type OrganizationSourcingPreferenceConnectionListResponse = {
	__typename?: 'OrganizationSourcingPreferenceConnectionListResponse';
	data: Array<OrganizationSourcingPreferenceConnection>;
	pageInfo: PageInfo;
};

export type OrganizationSourcingPreferenceConnectionUpdateInput = {
	id: Scalars['ID']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	organizationSourcingPreferenceId?: InputMaybe<Scalars['ID']['input']>;
	priority?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationSourcingPreferenceCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
};

export type OrganizationSourcingPreferenceListInput = {
	name?: InputMaybe<Scalars['String']['input']>;
	order?: InputMaybe<OrderInput>;
	pagination?: InputMaybe<PaginationInput>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSourcingPreferenceListResponse = {
	__typename?: 'OrganizationSourcingPreferenceListResponse';
	data: Array<OrganizationSourcingPreference>;
	pageInfo: PageInfo;
};

export type OrganizationSourcingPreferenceUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

/** An organization's current subscription. */
export type OrganizationSubscription = {
	__typename?: 'OrganizationSubscription';
	cancelAtPeriodEnd: Scalars['Boolean']['output'];
	canceledAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
	currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	organizationId: Scalars['ID']['output'];
	/** Set when a downgrade is scheduled; the tier the sub will switch to at pendingTierEffectiveAt. */
	pendingTier?: Maybe<SubscriptionTier>;
	pendingTierEffectiveAt?: Maybe<Scalars['DateTime']['output']>;
	status: SubscriptionStatus;
	stripeCustomerId?: Maybe<Scalars['String']['output']>;
	stripePriceId?: Maybe<Scalars['String']['output']>;
	stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
	tier: SubscriptionTier;
	trialEnd?: Maybe<Scalars['DateTime']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationUpdateInput = {
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	/** FK to organizationIndustry. Pass null to clear. Pass undefined / omit to leave unchanged. */
	organizationIndustryId?: InputMaybe<Scalars['ID']['input']>;
	settings?: InputMaybe<OrganizationSettingsInput>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUser = Base & {
	__typename?: 'OrganizationUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	authorizationUserRoles?: Maybe<Array<Maybe<AuthorizationUserRole>>>;
	avatar?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	jobPosition?: Maybe<Scalars['String']['output']>;
	lastName: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	roles?: Maybe<Array<Scalars['ID']['output']>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type OrganizationUserCreateInput = {
	avatar?: InputMaybe<FileInput>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	invitationMethod: OrganizationUserInvitationMethodEnum;
	jobPosition?: InputMaybe<Scalars['String']['input']>;
	lastName: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	roles?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum OrganizationUserInvitationMethodEnum {
	Manual = 'MANUAL',
	System = 'SYSTEM',
}

export type OrganizationUserPage = {
	__typename?: 'OrganizationUserPage';
	data?: Maybe<Array<OrganizationUser>>;
	errors?: Maybe<Array<ResponseError>>;
	pageInfo?: Maybe<PageInfo>;
};

export type OrganizationUserUpdateInput = {
	avatar?: InputMaybe<FileInput>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	jobPosition?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
	__typename?: 'PageInfo';
	currentPage: Scalars['Int']['output'];
	hasNextPage: Scalars['Boolean']['output'];
	hasPreviousPage: Scalars['Boolean']['output'];
	totalCount: Scalars['Int']['output'];
	totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
	currentPage: Scalars['Int']['input'];
	limit: Scalars['Int']['input'];
};

export type PasswordResetInput = {
	password: Scalars['Password']['input'];
	token: Scalars['String']['input'];
};

export type PasswordResetRequestInput = {
	authKey: Scalars['String']['input'];
};

export type PasswordResetValidateInput = {
	code: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type PasswordUpdateInput = {
	newPassword: Scalars['Password']['input'];
	oldPassword: Scalars['Password']['input'];
	userId: Scalars['ID']['input'];
};

/**
 * How a given payment is collected. Configured per-org (default) and
 * per-order (override) for products and samples independently.
 *   - CLIENT_CHOICE: customer picks Stripe or invoice at checkout (default)
 *   - STRIPE_ONLY: lock to card payment
 *   - INVOICE_ONLY: lock to e-conomic invoice
 *   - ADMIN_MANUAL: pulled out of the auto-flow — production-gate is
 *     skipped, client-side pay buttons are hidden, admin invoices
 *     these items manually via the Billing tab.
 */
export enum PaymentModeEnum {
	AdminManual = 'ADMIN_MANUAL',
	ClientChoice = 'CLIENT_CHOICE',
	InvoiceOnly = 'INVOICE_ONLY',
	StripeOnly = 'STRIPE_ONLY',
}

export type PaymentProductInvoice = Base & {
	__typename?: 'PaymentProductInvoice';
	attempts: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicCustomerNumber?: Maybe<Scalars['Int']['output']>;
	economicDraftInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicPdfUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
	lastError?: Maybe<Scalars['String']['output']>;
	lastPolledAt?: Maybe<Scalars['DateTime']['output']>;
	markedPaidByUserId?: Maybe<Scalars['ID']['output']>;
	markedPaidNote?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paidVia?: Maybe<SamplePaymentInvoicePaidVia>;
	paymentTransactionId: Scalars['ID']['output'];
	status: PaymentProductInvoiceStatus;
	triggeredByUserId?: Maybe<Scalars['ID']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

/** paymentProductInvoice (bank-transfer) lifecycle. Mirrors SamplePaymentInvoiceStatus. */
export enum PaymentProductInvoiceStatus {
	Booked = 'booked',
	Cancelled = 'cancelled',
	Failed = 'failed',
	Paid = 'paid',
	Pending = 'pending',
}

export type PaymentProductLine = Base & {
	__typename?: 'PaymentProductLine';
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	/** Sum of deductible-paid-samples credited against this item. */
	deductibleAmount: Scalars['Float']['output'];
	/** Sample IDs whose paid amounts contributed to deductibleAmount. */
	deductibleSampleIds?: Maybe<Array<Scalars['ID']['output']>>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	/** productAmount - deductibleAmount. Sum of all lineNetAmount on a transaction equals the transaction's totalAmount. */
	lineNetAmount: Scalars['Float']['output'];
	orderId: Scalars['ID']['output'];
	orderItemId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paymentTransactionId: Scalars['ID']['output'];
	/** Sum of this item's products + fees + delivery, before deduction. */
	productAmount: Scalars['Float']['output'];
	status: PaymentProductLineStatus;
	updatedAt: Scalars['DateTime']['output'];
};

/** Per-line product status — pending until the parent transaction settles. */
export enum PaymentProductLineStatus {
	Failed = 'failed',
	Paid = 'paid',
	Pending = 'pending',
	Refunded = 'refunded',
}

export type PaymentTransaction = Base & {
	__typename?: 'PaymentTransaction';
	checkoutSessions: Array<StripeCheckoutSession>;
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	failureReason?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	organizationId: Scalars['ID']['output'];
	paymentMethod?: Maybe<Scalars['String']['output']>;
	/** Present on invoice-paid product transactions. */
	productInvoice?: Maybe<PaymentProductInvoice>;
	/** Present on product transactions, empty on sample. */
	productLines: Array<PaymentProductLine>;
	refundAmount?: Maybe<Scalars['Float']['output']>;
	refundedAt?: Maybe<Scalars['DateTime']['output']>;
	samplePayments: Array<SamplePayment>;
	status: PaymentTransactionStatus;
	stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
	totalAmount: Scalars['Float']['output'];
	/** Sample or product transaction. Defaults to 'sample' for legacy rows. */
	type: PaymentTransactionType;
	updatedAt: Scalars['DateTime']['output'];
};

/** paymentTransaction lifecycle. */
export enum PaymentTransactionStatus {
	Completed = 'completed',
	Failed = 'failed',
	PartiallyRefunded = 'partially_refunded',
	Pending = 'pending',
	Processing = 'processing',
	Refunded = 'refunded',
}

/** Sample vs product transaction — same root row, different children. */
export enum PaymentTransactionType {
	Product = 'product',
	Sample = 'sample',
}

export type PhoneInput = {
	code: Scalars['String']['input'];
	number: Scalars['String']['input'];
	schema: Scalars['String']['input'];
};

export type PlaceAutocompleteResult = {
	__typename?: 'PlaceAutocompleteResult';
	description: Scalars['String']['output'];
	mainText: Scalars['String']['output'];
	placeId: Scalars['String']['output'];
	secondaryText: Scalars['String']['output'];
};

export type PlaceDetails = {
	__typename?: 'PlaceDetails';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	formattedAddress: Scalars['String']['output'];
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	placeId: Scalars['String']['output'];
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	stateCode?: Maybe<Scalars['String']['output']>;
	streetName?: Maybe<Scalars['String']['output']>;
	streetNumber?: Maybe<Scalars['String']['output']>;
	timezone?: Maybe<Scalars['String']['output']>;
};

/**
 * Breakdown of a plan change — shows the user exactly why they're paying
 * what they're paying (or what they'll save on a downgrade).
 * All amounts are in the subscription's currency (typically USD).
 */
export type PlanChangeBreakdown = {
	__typename?: 'PlanChangeBreakdown';
	/** Currency code (e.g. USD, DKK). */
	currency: Scalars['String']['output'];
	/** Net price of the current plan (monthly, ex-VAT). */
	currentPriceNet: Scalars['Float']['output'];
	/** Net price of the new plan (monthly, ex-VAT). */
	newPriceNet: Scalars['Float']['output'];
	/** Prorated net difference charged now (upgrade) or credited (downgrade). */
	proratedAmountNet?: Maybe<Scalars['Float']['output']>;
	/** Total amount charged now (proratedAmountNet + vatAmount). Null for downgrades. */
	totalAmount?: Maybe<Scalars['Float']['output']>;
	/** VAT amount on the prorated charge. */
	vatAmount?: Maybe<Scalars['Float']['output']>;
	/** VAT percentage applied (e.g. 25 for Denmark, 0 for EU reverse-charge). */
	vatRate: Scalars['Float']['output'];
};

export type PolygonPoint = {
	__typename?: 'PolygonPoint';
	x: Scalars['Float']['output'];
	y: Scalars['Float']['output'];
};

export type PolygonPointInput = {
	x: Scalars['Float']['input'];
	y: Scalars['Float']['input'];
};

export type Product = Base & {
	__typename?: 'Product';
	brand?: Maybe<Brand>;
	brandId?: Maybe<Scalars['ID']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<ProductDimensions>;
	id: Scalars['ID']['output'];
	images?: Maybe<Array<ProductImage>>;
	metadata?: Maybe<ProductMetadata>;
	name: Scalars['String']['output'];
	recommendations: Array<ProductRecommendation>;
	sku: Scalars['String']['output'];
	status: ProductStatus;
	studioFile?: Maybe<StudioFile>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	tags?: Maybe<Array<ProductTag>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	weight?: Maybe<Scalars['Float']['output']>;
};

export type ProductCreateInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ProductDimensionsInput>;
	imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	metadata?: InputMaybe<ProductMetadataInput>;
	name: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductDimensions = {
	__typename?: 'ProductDimensions';
	height?: Maybe<Scalars['Float']['output']>;
	length?: Maybe<Scalars['Float']['output']>;
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

export type ProductDimensionsInput = {
	height: Scalars['Float']['input'];
	length: Scalars['Float']['input'];
	unit: Scalars['String']['input'];
	width: Scalars['Float']['input'];
};

export type ProductImage = {
	__typename?: 'ProductImage';
	altText?: Maybe<Scalars['String']['output']>;
	caption?: Maybe<Scalars['String']['output']>;
	dimensions?: Maybe<ImageDimensions>;
	id: Scalars['ID']['output'];
	isPrimary?: Maybe<Scalars['Boolean']['output']>;
	metadata?: Maybe<Array<ImageMetadata>>;
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	sortOrder?: Maybe<Scalars['Int']['output']>;
	studioFileVersionId?: Maybe<Scalars['ID']['output']>;
	type?: Maybe<ProductImageType>;
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
};

export enum ProductImageType {
	Dieline = 'dieline',
	Image = 'image',
	Preview = 'preview',
}

export type ProductImageUploadInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	productId: Scalars['ID']['input'];
};

export type ProductMetadata = {
	__typename?: 'ProductMetadata';
	createdFromProject?: Maybe<Scalars['Boolean']['output']>;
	createdFromSplitGrid?: Maybe<Scalars['Boolean']['output']>;
	createdFromStudio?: Maybe<Scalars['Boolean']['output']>;
	inspirationImageUrls?: Maybe<Array<Scalars['String']['output']>>;
	isAIGenerated?: Maybe<Scalars['Boolean']['output']>;
	projectProductId?: Maybe<Scalars['ID']['output']>;
	studioVersionId?: Maybe<Scalars['ID']['output']>;
	studioVersionNumbers?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ProductMetadataInput = {
	createdFromProject?: InputMaybe<Scalars['Boolean']['input']>;
	createdFromSplitGrid?: InputMaybe<Scalars['Boolean']['input']>;
	createdFromStudio?: InputMaybe<Scalars['Boolean']['input']>;
	inspirationImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	isAIGenerated?: InputMaybe<Scalars['Boolean']['input']>;
	projectProductId?: InputMaybe<Scalars['ID']['input']>;
	studioVersionId?: InputMaybe<Scalars['ID']['input']>;
	studioVersionNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProductPage = {
	__typename?: 'ProductPage';
	data: Array<Product>;
	pageInfo: PageInfo;
};

/**
 * Customer's explicit payment-method choice for a product payment.
 * When omitted, the backend auto-routes (invoice if total exceeds the
 * order's Stripe checkout limit, Stripe otherwise). When provided,
 * the backend honours the pick and validates eligibility (errors out
 * if the total is below the invoice minimum / above the Stripe limit
 * for the chosen method).
 */
export enum ProductPaymentMethodV2 {
	Invoice = 'invoice',
	Stripe = 'stripe',
}

export type ProductPaymentPreviewDeliveryV2 = {
	__typename?: 'ProductPaymentPreviewDeliveryV2';
	/** Amount in the requested currency, rounded to 2 decimals. */
	amount: Scalars['Float']['output'];
	/** Title-cased shipping method, e.g. 'Express', 'Sea'. */
	method: Scalars['String']['output'];
};

export type ProductPaymentPreviewFeeV2 = {
	__typename?: 'ProductPaymentPreviewFeeV2';
	/** Amount in the requested currency, rounded to 2 decimals. */
	amount: Scalars['Float']['output'];
	/** Adjustment name as configured on the offer (e.g. 'Setup Fee'). */
	name: Scalars['String']['output'];
};

export type ProductPaymentPreviewLineV2 = {
	__typename?: 'ProductPaymentPreviewLineV2';
	/** Sum of paid + deductible samples on this item — credited against the invoice. */
	deductibleAmount: Scalars['Float']['output'];
	/** How many deductible+paid samples contributed to deductibleAmount. */
	deductibleSampleCount: Scalars['Int']['output'];
	/** Per-delivery breakdown — one entry per quoteOrderItemDeliveryV2 row (split shipments produce >1). */
	deliveries: Array<ProductPaymentPreviewDeliveryV2>;
	deliveryAmount: Scalars['Float']['output'];
	/** Per-fee breakdown — one entry per FEE-type adjustment; same source the e-conomic draft sub-lines use. */
	fees: Array<ProductPaymentPreviewFeeV2>;
	feesAmount: Scalars['Float']['output'];
	/** Human-readable label, e.g. 'Blue T-shirt'. */
	label: Scalars['String']['output'];
	/** lineSubtotal − deductibleAmount, clamped to ≥0. What the customer is actually charged for this item. */
	lineNetAmount: Scalars['Float']['output'];
	/** productsAmount + feesAmount + deliveryAmount (ex-VAT, before deduction). */
	lineSubtotal: Scalars['Float']['output'];
	orderItemId: Scalars['ID']['output'];
	productsAmount: Scalars['Float']['output'];
};

export type ProductPaymentPreviewV2 = {
	__typename?: 'ProductPaymentPreviewV2';
	currency: Scalars['String']['output'];
	/** Sum of all items' lineSubtotal — what the customer will be charged before VAT and any sample credits. */
	grandTotal: Scalars['Float']['output'];
	items: Array<ProductPaymentPreviewLineV2>;
};

export type ProductRecommendation = Base & {
	__typename?: 'ProductRecommendation';
	actionLabel: Scalars['String']['output'];
	actionUrl?: Maybe<Scalars['String']['output']>;
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description: Scalars['String']['output'];
	dismissedAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	productId: Scalars['ID']['output'];
	status: ProductRecommendationStatus;
	title: Scalars['String']['output'];
	type: ProductRecommendationType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProductRecommendationStatus {
	Active = 'ACTIVE',
	Completed = 'COMPLETED',
	Dismissed = 'DISMISSED',
}

export enum ProductRecommendationType {
	EnhanceWithStudio = 'ENHANCE_WITH_STUDIO',
	MissingSpecifications = 'MISSING_SPECIFICATIONS',
}

export enum ProductStatus {
	Active = 'ACTIVE',
	Archived = 'ARCHIVED',
	PendingApproval = 'PENDING_APPROVAL',
}

export type ProductTag = {
	__typename?: 'ProductTag';
	color?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	parent?: Maybe<ProductTag>;
	parentId?: Maybe<Scalars['ID']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductTagCreateInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductTagPage = {
	__typename?: 'ProductTagPage';
	data: Array<ProductTag>;
	pageInfo: PageInfo;
};

export type ProductTagUpdateInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductUpdateInput = {
	brandId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	dimensions?: InputMaybe<ProductDimensionsInput>;
	id: Scalars['ID']['input'];
	metadata?: InputMaybe<ProductMetadataInput>;
	name?: InputMaybe<Scalars['String']['input']>;
	sku?: InputMaybe<Scalars['String']['input']>;
	tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Project = Base & {
	__typename?: 'Project';
	brand?: Maybe<Brand>;
	brandId?: Maybe<Scalars['ID']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	endDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	projectProducts?: Maybe<Array<ProjectProduct>>;
	startDate?: Maybe<Scalars['DateTime']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectPage = {
	__typename?: 'ProjectPage';
	data: Array<Project>;
	pageInfo: PageInfo;
};

export type ProjectProduct = Base & {
	__typename?: 'ProjectProduct';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	imageUrls?: Maybe<Array<Scalars['String']['output']>>;
	inspirationImageUrls?: Maybe<Array<Scalars['String']['output']>>;
	isProductCreated: Scalars['Boolean']['output'];
	isStudioFileCreated: Scalars['Boolean']['output'];
	name?: Maybe<Scalars['String']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	product?: Maybe<Product>;
	productId?: Maybe<Scalars['ID']['output']>;
	projectId?: Maybe<Scalars['ID']['output']>;
	remixPrompt?: Maybe<Scalars['String']['output']>;
	sessionId?: Maybe<Scalars['ID']['output']>;
	studioFile?: Maybe<StudioFile>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	type: ProjectProductType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ProjectProductImageType {
	InspirationImage = 'INSPIRATION_IMAGE',
	ProductImage = 'PRODUCT_IMAGE',
}

export type ProjectProductInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	inspirationImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	productId?: InputMaybe<Scalars['ID']['input']>;
	remixPrompt?: InputMaybe<Scalars['String']['input']>;
	type: ProjectProductType;
};

export enum ProjectProductType {
	Existing = 'EXISTING',
	Generated = 'GENERATED',
	Remix = 'REMIX',
	Uploaded = 'UPLOADED',
}

export type Query = {
	__typename?: 'Query';
	addressAutocomplete: Array<PlaceAutocompleteResult>;
	checkEmailExists: EmailExistsResponse;
	convertCurrency: CurrencyConversionResult;
	convertQuoteOffer: QuoteOfferConversionResult;
	formatVATNumber: Scalars['String']['output'];
	generateVATFromRegistration?: Maybe<Scalars['String']['output']>;
	/** Get admin active activities (Admin only) */
	getAdminActiveActivities: AdminActiveActivities;
	/** Fetch one draft (for resume in the builder modal). */
	getAdminInvoiceDraftV2?: Maybe<AdminInvoiceDraftV2>;
	/** Admin Billing tab — all drafts for this org, newest first. Filter by status client-side. */
	getAdminInvoiceDraftsForOrgV2: Array<AdminInvoiceDraftV2>;
	/** Get a single admin user by ID (Admin only) */
	getAdminUser?: Maybe<AdminUser>;
	getAllAdminAuthenticationUser: AuthenticationUserPage;
	/** Get all admin users with pagination (Admin only) */
	getAllAdminUser: AdminUserPage;
	getAllAuthorizationRole?: Maybe<AuthorizationRolePage>;
	getAllAuthorizationUserRole?: Maybe<AuthorizationUserRolePage>;
	getAllBrand: BrandPage;
	getAllLocalizationCountries: Array<LocalizationCountry>;
	getAllLocalizationTimezones?: Maybe<Array<LocalizationTimezone>>;
	getAllLoggingAuditLog?: Maybe<LoggingAuditLogPage>;
	getAllLoggingLoginLog?: Maybe<LoggingLoginLogPage>;
	getAllManufacturer: ManufacturerPage;
	getAllOrganization: OrganizationPage;
	/**
	 * Industries the calling user is allowed to see. For authenticated
	 * users that's all published rows plus their own pending rows.
	 * For unauthenticated callers (public signup) it's just the
	 * published list — non-sensitive metadata used to populate the
	 * industry dropdown before the user has an account.
	 */
	getAllOrganizationIndustries: Array<OrganizationIndustry>;
	/** Admin-only: every industry regardless of publish state. */
	getAllOrganizationIndustriesAdmin: Array<OrganizationIndustry>;
	getAllOrganizationUser?: Maybe<OrganizationUserPage>;
	getAllProduct: ProductPage;
	getAllProductTag: ProductTagPage;
	getAllProjects: ProjectPage;
	getAllQuoteItemsOffersStatsV2: Array<QuoteItemOffersStatsV2>;
	getAllQuoteOrdersV2: GetAllQuoteOrdersV2Response;
	getAllQuotesV2?: Maybe<GetAllQuotesV2Response>;
	getAllStudioFile: StudioFilePage;
	getAllVetterEntity: VetterEntityPage;
	getAllVetterUser: VetterUserPage;
	getAuthenticationUser: AuthenticationUser;
	getAuthorizationRole?: Maybe<AuthorizationRole>;
	getAuthorizationRoleByName?: Maybe<AuthorizationRole>;
	getBrand: Brand;
	getBrandAIContext: BrandAiContext;
	getBrandFileDownloadUrl: FileUploadResponse;
	getBrandFontDownloadUrl: FileUploadResponse;
	getChatContext?: Maybe<ChatContext>;
	getChatContextsByQuote: Array<ChatContext>;
	getChatFileDownloadUrl: FileUploadResponse;
	getChatMessages?: Maybe<GetChatMessagesResponse>;
	getCheckoutSession?: Maybe<StripeCheckoutSession>;
	/**
	 * Returns the calling user's current draft quote (per-user pointer),
	 * or null if they don't have one.
	 */
	getCurrentQuoteV2?: Maybe<QuoteV2>;
	getDesignSpecsByChat: Array<StudioDesignSpec>;
	getDesignSpecsByVersion: Array<StudioDesignSpec>;
	getEarlyAccessByToken?: Maybe<EarlyAccessInvite>;
	/**
	 * Powers the admin Billing tab — returns every item/sample for this
	 * org whose order is in ADMIN_MANUAL mode (per-side: product or sample),
	 * grouped by order, with each line's status (unpaid / on draft #X /
	 * booked / paid). Already-paid lines come back so the picker can show
	 * them greyed out instead of pretending they don't exist.
	 */
	getInvoiceableItemsForOrgV2: GetInvoiceableItemsForOrgV2Response;
	getLocalizationCountry: LocalizationCountry;
	getLocalizationDefaults: LocalizationDefaults;
	getLocalizationOrganizationSetting?: Maybe<LocalizationOrganizationSetting>;
	getLocalizationStates: Array<LocalizationState>;
	getManufacturer: Manufacturer;
	/** Get current admin user's profile (Admin only) */
	getMyAdminProfile?: Maybe<AdminUser>;
	getMyAuthorizationUserRole?: Maybe<AuthorizationUserRolePage>;
	getMyChatContexts?: Maybe<GetChatContextsResponse>;
	/** Kickback ledger for the caller's organization (most recent first). */
	getMyKickbackTransactions: Array<KickbackTransaction>;
	/** Current subscription for the caller's organization (null if no sub). */
	getMySubscription?: Maybe<OrganizationSubscription>;
	getMyVetterProfile?: Maybe<VetterUser>;
	getOrderCheckoutLimitV2: OrderCheckoutLimitV2;
	getOrderPayment?: Maybe<PaymentTransaction>;
	getOrderStatsByStatusV2: OrderStatsByStatusV2;
	getOrderStatsV2: OrderStatsV2;
	/** Unified transaction rows for the Transactions tab — sample + product payments combined, sorted newest-first. */
	getOrderTransactionsV2: Array<OrderTransactionRowV2>;
	getOrganization?: Maybe<Organization>;
	/** Get organization active activities (Organization users only) */
	getOrganizationActiveActivities: OrganizationActiveActivities;
	getOrganizationAddresses: Array<OrganizationAddress>;
	getOrganizationApprovalAndMargin?: Maybe<OrganizationApprovalAndMargin>;
	getOrganizationCompliance?: Maybe<OrganizationCompliance>;
	getOrganizationComplianceConnection?: Maybe<OrganizationComplianceConnection>;
	getOrganizationComplianceConnections: OrganizationComplianceConnectionListResponse;
	getOrganizationCompliances: OrganizationComplianceListResponse;
	getOrganizationProductInterest?: Maybe<OrganizationProductInterest>;
	getOrganizationProductInterests: OrganizationProductInterestListResponse;
	getOrganizationSetting?: Maybe<OrganizationSetting>;
	getOrganizationSourcingPreference?: Maybe<OrganizationSourcingPreference>;
	getOrganizationSourcingPreferenceConnection?: Maybe<OrganizationSourcingPreferenceConnection>;
	getOrganizationSourcingPreferenceConnections: OrganizationSourcingPreferenceConnectionListResponse;
	getOrganizationSourcingPreferences: OrganizationSourcingPreferenceListResponse;
	getOrganizationUser?: Maybe<OrganizationUser>;
	getOrganizationUserAvatarDownloadUrl: DownloadUrlResponse;
	getPaymentTransaction?: Maybe<PaymentTransaction>;
	getPlaceDetails?: Maybe<PlaceDetails>;
	getProduct: Product;
	getProductImageDownloadUrl: ImageUploadResponse;
	/**
	 * Per-item breakdown for the 'Pay for Production' modal — products +
	 * fees + delivery, ex-VAT. Uses the same math as the Stripe checkout
	 * and e-conomic draft so the frontend shows the real numbers.
	 */
	getProductPaymentPreviewV2: ProductPaymentPreviewV2;
	getProductTag: ProductTag;
	getProject?: Maybe<Project>;
	getProjectProductsBySession: Array<ProjectProduct>;
	getQuoteHistoryV2: Array<QuoteHistoryV2>;
	getQuoteItemOffersStatsV2: QuoteItemOffersStatsV2;
	getQuoteItemOffersV2: Array<QuoteOfferV2>;
	getQuoteOfferBatchV2?: Maybe<QuoteOfferBatchV2>;
	getQuoteOfferBatchesV2: Array<QuoteOfferBatchV2>;
	getQuoteOfferV2?: Maybe<QuoteOfferV2>;
	getQuoteOffersV2: Array<QuoteOfferV2>;
	getQuoteOrderByNumberV2?: Maybe<QuoteOrderV2>;
	getQuoteOrderTimelineV2: QuoteOrderTimelineV2;
	getQuoteOrderV2?: Maybe<QuoteOrderV2>;
	getQuoteOrdersV2: Array<QuoteOrderV2>;
	getQuoteStatsByStatusV2: QuoteStatsByStatusV2;
	getQuoteStatsV2: QuoteStatsV2;
	getQuoteV2?: Maybe<QuoteV2>;
	getRecentOrdersV2: Array<QuoteOrderV2>;
	getRecentQuotesV2: Array<QuoteV2>;
	getStudioAgentTools: Array<StudioAgentTool>;
	getStudioFile?: Maybe<StudioFile>;
	getStudioFileChats: Array<StudioChat>;
	getStudioFileLock?: Maybe<StudioLock>;
	getStudioFileVersionTechPack?: Maybe<StudioFileVersionTechPack>;
	getStudioFileVersionTechPackById?: Maybe<StudioFileVersionTechPack>;
	getStudioFileVersions: Array<StudioFileVersion>;
	getStudioPromptTemplate?: Maybe<StudioPromptTemplate>;
	getStudioPromptTemplates: Array<StudioPromptTemplate>;
	/** Config for all subscription tiers (admin-editable rates). */
	getSubscriptionTierConfigs: Array<SubscriptionTierConfig>;
	getSystemSettings?: Maybe<AdminSystemSetting>;
	getUnreadMessagesCount: Scalars['Int']['output'];
	getUserPreferences?: Maybe<UserPreferences>;
	getVATFormat?: Maybe<Scalars['String']['output']>;
	/** Get vetter active activities (Vetter only) */
	getVetterActiveActivities: VetterActiveActivities;
	getVetterEntity?: Maybe<VetterEntity>;
	getVetterUser?: Maybe<VetterUser>;
	isEUCountry: Scalars['Boolean']['output'];
	listEarlyAccessRequests: Array<EarlyAccessRequest>;
	quoteExchangeRate?: Maybe<QuoteExchangeRate>;
	quoteExchangeRates: Array<QuoteExchangeRate>;
	remainingBackupCodes: Scalars['Int']['output'];
	root?: Maybe<Scalars['String']['output']>;
	searchBrandAssets: Array<BrandAsset>;
	supportedCurrencies: Array<CurrencyEnum>;
	validateAddress: AddressValidationResult;
	validateBusinessRegistration: ValidationResult;
	validateCVR: CvrValidationResult;
	validateVAT: VatValidationResult;
};

export type QueryAddressAutocompleteArgs = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	input: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckEmailExistsArgs = {
	email: Scalars['String']['input'];
};

export type QueryConvertCurrencyArgs = {
	input: ConvertCurrencyInput;
};

export type QueryConvertQuoteOfferArgs = {
	input: ConvertQuoteOfferInput;
};

export type QueryFormatVatNumberArgs = {
	countryCode: Scalars['String']['input'];
	rawNumber: Scalars['String']['input'];
};

export type QueryGenerateVatFromRegistrationArgs = {
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
};

export type QueryGetAdminActiveActivitiesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetAdminInvoiceDraftV2Args = {
	id: Scalars['ID']['input'];
};

export type QueryGetAdminInvoiceDraftsForOrgV2Args = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetAdminUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAllAdminAuthenticationUserArgs = {
	input: GetAllAdminAuthenticationUserInput;
};

export type QueryGetAllAdminUserArgs = {
	input: GetAllAdminUserInput;
};

export type QueryGetAllAuthorizationRoleArgs = {
	input: GetAllAuthorizationRoleInput;
};

export type QueryGetAllAuthorizationUserRoleArgs = {
	input: GetAllAuthorizationUserRoleInput;
};

export type QueryGetAllBrandArgs = {
	input: GetAllBrandInput;
};

export type QueryGetAllLoggingAuditLogArgs = {
	input: GetAllLoggingAuditLogInput;
};

export type QueryGetAllLoggingLoginLogArgs = {
	input: GetAllLoggingLoginLogInput;
};

export type QueryGetAllManufacturerArgs = {
	input: GetAllManufacturerInput;
};

export type QueryGetAllOrganizationArgs = {
	input: GetAllOrganizationInput;
};

export type QueryGetAllOrganizationUserArgs = {
	input: GetAllOrganizationUserInput;
};

export type QueryGetAllProductArgs = {
	input: GetAllProductInput;
};

export type QueryGetAllProductTagArgs = {
	input: GetAllProductTagInput;
};

export type QueryGetAllProjectsArgs = {
	input: GetAllProjectInput;
};

export type QueryGetAllQuoteItemsOffersStatsV2Args = {
	quoteV2Id: Scalars['ID']['input'];
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetAllQuoteOrdersV2Args = {
	input: GetAllQuoteOrdersV2Input;
};

export type QueryGetAllQuotesV2Args = {
	input: GetAllQuotesV2Input;
};

export type QueryGetAllStudioFileArgs = {
	input: GetAllStudioFileInput;
};

export type QueryGetAllVetterEntityArgs = {
	input: GetAllVetterEntityInput;
};

export type QueryGetAllVetterUserArgs = {
	input: GetAllVetterUserInput;
};

export type QueryGetAuthenticationUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAuthorizationRoleArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAuthorizationRoleByNameArgs = {
	name: Scalars['String']['input'];
};

export type QueryGetBrandArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetBrandAiContextArgs = {
	brandId: Scalars['ID']['input'];
};

export type QueryGetBrandFileDownloadUrlArgs = {
	brandId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
};

export type QueryGetBrandFontDownloadUrlArgs = {
	brandId: Scalars['ID']['input'];
	fontId: Scalars['ID']['input'];
};

export type QueryGetChatContextArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetChatContextsByQuoteArgs = {
	quoteId: Scalars['ID']['input'];
};

export type QueryGetChatFileDownloadUrlArgs = {
	contextId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
};

export type QueryGetChatMessagesArgs = {
	contextId: Scalars['ID']['input'];
	input: GetChatMessagesInput;
};

export type QueryGetCheckoutSessionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetDesignSpecsByChatArgs = {
	studioChatId: Scalars['ID']['input'];
};

export type QueryGetDesignSpecsByVersionArgs = {
	studioFileVersionId: Scalars['ID']['input'];
};

export type QueryGetEarlyAccessByTokenArgs = {
	inviteToken: Scalars['String']['input'];
};

export type QueryGetInvoiceableItemsForOrgV2Args = {
	currency: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
};

export type QueryGetLocalizationCountryArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetLocalizationDefaultsArgs = {
	placeId: Scalars['String']['input'];
};

export type QueryGetLocalizationOrganizationSettingArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetLocalizationStatesArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetManufacturerArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetMyAuthorizationUserRoleArgs = {
	input: GetMyAuthorizationUserRoleInput;
};

export type QueryGetMyChatContextsArgs = {
	input: GetMyChatContextsInput;
};

export type QueryGetMyKickbackTransactionsArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetOrderCheckoutLimitV2Args = {
	orderId: Scalars['ID']['input'];
};

export type QueryGetOrderPaymentArgs = {
	orderId: Scalars['ID']['input'];
};

export type QueryGetOrderStatsByStatusV2Args = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetOrderStatsV2Args = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
};

export type QueryGetOrderTransactionsV2Args = {
	orderId: Scalars['ID']['input'];
};

export type QueryGetOrganizationArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationActiveActivitiesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetOrganizationAddressesArgs = {
	organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetOrganizationApprovalAndMarginArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationComplianceArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationComplianceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationComplianceConnectionsArgs = {
	input: OrganizationComplianceConnectionListInput;
};

export type QueryGetOrganizationCompliancesArgs = {
	input: OrganizationComplianceListInput;
};

export type QueryGetOrganizationProductInterestArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationProductInterestsArgs = {
	input: OrganizationProductInterestListInput;
};

export type QueryGetOrganizationSettingArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationSourcingPreferenceArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationSourcingPreferenceConnectionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationSourcingPreferenceConnectionsArgs = {
	input: OrganizationSourcingPreferenceConnectionListInput;
};

export type QueryGetOrganizationSourcingPreferencesArgs = {
	input: OrganizationSourcingPreferenceListInput;
};

export type QueryGetOrganizationUserArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryGetOrganizationUserAvatarDownloadUrlArgs = {
	input: GetDownloadUrlInput;
};

export type QueryGetPaymentTransactionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetPlaceDetailsArgs = {
	placeId: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetProductArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetProductImageDownloadUrlArgs = {
	imageId: Scalars['ID']['input'];
	productId: Scalars['ID']['input'];
};

export type QueryGetProductPaymentPreviewV2Args = {
	currency: Scalars['String']['input'];
	orderItemIds: Array<Scalars['ID']['input']>;
};

export type QueryGetProductTagArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetProjectArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetProjectProductsBySessionArgs = {
	projectId?: InputMaybe<Scalars['ID']['input']>;
	sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetQuoteHistoryV2Args = {
	quoteV2Id: Scalars['ID']['input'];
};

export type QueryGetQuoteItemOffersStatsV2Args = {
	quoteItemV2Id: Scalars['ID']['input'];
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetQuoteItemOffersV2Args = {
	quoteItemV2Id: Scalars['ID']['input'];
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
	statusFilter?: InputMaybe<Array<QuoteOfferStatusV2>>;
};

export type QueryGetQuoteOfferBatchV2Args = {
	id: Scalars['ID']['input'];
};

export type QueryGetQuoteOfferBatchesV2Args = {
	quoteV2Id: Scalars['ID']['input'];
	statusFilter?: InputMaybe<Array<QuoteOfferStatusV2>>;
};

export type QueryGetQuoteOfferV2Args = {
	id: Scalars['ID']['input'];
};

export type QueryGetQuoteOffersV2Args = {
	ids: Array<Scalars['ID']['input']>;
};

export type QueryGetQuoteOrderByNumberV2Args = {
	orderNumber: Scalars['String']['input'];
};

export type QueryGetQuoteOrderTimelineV2Args = {
	orderId: Scalars['ID']['input'];
};

export type QueryGetQuoteOrderV2Args = {
	id: Scalars['ID']['input'];
};

export type QueryGetQuoteOrdersV2Args = {
	quoteV2Id: Scalars['ID']['input'];
};

export type QueryGetQuoteStatsByStatusV2Args = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetQuoteStatsV2Args = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
};

export type QueryGetQuoteV2Args = {
	id: Scalars['ID']['input'];
};

export type QueryGetRecentOrdersV2Args = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetRecentQuotesV2Args = {
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetStudioAgentToolsArgs = {
	agentType: StudioAgentType;
};

export type QueryGetStudioFileArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetStudioFileChatsArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type QueryGetStudioFileLockArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type QueryGetStudioFileVersionTechPackArgs = {
	studioFileVersionId: Scalars['ID']['input'];
};

export type QueryGetStudioFileVersionTechPackByIdArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetStudioFileVersionsArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type QueryGetStudioPromptTemplateArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetStudioPromptTemplatesArgs = {
	agentType?: InputMaybe<StudioAgentType>;
};

export type QueryGetVatFormatArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetVetterActiveActivitiesArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetVetterEntityArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetVetterUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryIsEuCountryArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryListEarlyAccessRequestsArgs = {
	status?: InputMaybe<EarlyAccessStatusEnum>;
};

export type QueryQuoteExchangeRateArgs = {
	fromCurrency: CurrencyEnum;
	toCurrency: CurrencyEnum;
};

export type QueryQuoteExchangeRatesArgs = {
	fromCurrency?: InputMaybe<CurrencyEnum>;
	rateDate?: InputMaybe<Scalars['DateTime']['input']>;
	toCurrency?: InputMaybe<CurrencyEnum>;
};

export type QueryRemainingBackupCodesArgs = {
	userId: Scalars['ID']['input'];
};

export type QuerySearchBrandAssetsArgs = {
	brandId: Scalars['ID']['input'];
	context?: InputMaybe<Array<Scalars['String']['input']>>;
	query: Scalars['String']['input'];
};

export type QueryValidateAddressArgs = {
	placeId: Scalars['String']['input'];
};

export type QueryValidateBusinessRegistrationArgs = {
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
};

export type QueryValidateCvrArgs = {
	cvrNumber: Scalars['String']['input'];
};

export type QueryValidateVatArgs = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	vatNumber: Scalars['String']['input'];
};

export type QuoteExchangeRate = {
	__typename?: 'QuoteExchangeRate';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	fromCurrency: CurrencyEnum;
	id: Scalars['ID']['output'];
	rate: Scalars['Float']['output'];
	rateDate: Scalars['DateTime']['output'];
	source: Scalars['String']['output'];
	toCurrency: CurrencyEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum QuoteHistoryActionV2 {
	FeeAdded = 'FEE_ADDED',
	FeeRemoved = 'FEE_REMOVED',
	FeeUpdated = 'FEE_UPDATED',
	ItemAdded = 'ITEM_ADDED',
	ItemRemoved = 'ITEM_REMOVED',
	ItemUpdated = 'ITEM_UPDATED',
	MarginAdded = 'MARGIN_ADDED',
	MarginUpdated = 'MARGIN_UPDATED',
	OfferAccepted = 'OFFER_ACCEPTED',
	OfferBatchCreated = 'OFFER_BATCH_CREATED',
	OfferBatchSubmitted = 'OFFER_BATCH_SUBMITTED',
	OfferCreated = 'OFFER_CREATED',
	OfferRejected = 'OFFER_REJECTED',
	OfferSentToClient = 'OFFER_SENT_TO_CLIENT',
	OfferSubmitted = 'OFFER_SUBMITTED',
	OrderCreated = 'ORDER_CREATED',
	QuoteCancelled = 'QUOTE_CANCELLED',
	QuoteCreated = 'QUOTE_CREATED',
	QuoteSubmitted = 'QUOTE_SUBMITTED',
	QuoteUpdated = 'QUOTE_UPDATED',
	SamplePriceUpdated = 'SAMPLE_PRICE_UPDATED',
	VetterAssigned = 'VETTER_ASSIGNED',
	VetterRemoved = 'VETTER_REMOVED',
}

export type QuoteHistoryV2 = Base & {
	__typename?: 'QuoteHistoryV2';
	action: QuoteHistoryActionV2;
	actorId: Scalars['ID']['output'];
	actorType: ActorTypeV2;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['JSON']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	quote: QuoteV2;
	quoteV2Id: Scalars['ID']['output'];
	relatedBatchId?: Maybe<Scalars['ID']['output']>;
	relatedOfferId?: Maybe<Scalars['ID']['output']>;
	relatedOrderId?: Maybe<Scalars['ID']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuoteItemOffersStatsV2 = {
	__typename?: 'QuoteItemOffersStatsV2';
	acceptedOffers: Scalars['Int']['output'];
	cancelledOffers: Scalars['Int']['output'];
	draftOffers: Scalars['Int']['output'];
	pendingOffers: Scalars['Int']['output'];
	quoteItemV2Id: Scalars['ID']['output'];
	rejectedOffers: Scalars['Int']['output'];
	submittedOffers: Scalars['Int']['output'];
	totalOffers: Scalars['Int']['output'];
};

export type QuoteItemQuantityV2 = Base & {
	__typename?: 'QuoteItemQuantityV2';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	quoteItem: QuoteItemV2;
	quoteItemV2Id: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variationQuantities: Array<QuoteOfferItemVariationQuantityV2>;
};

export type QuoteItemV2 = Base & {
	__typename?: 'QuoteItemV2';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	offerItems: Array<QuoteOfferItemV2>;
	product?: Maybe<Product>;
	productId: Scalars['ID']['output'];
	quantities: Array<QuoteItemQuantityV2>;
	quote: QuoteV2;
	quoteV2Id: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuoteOfferAttachmentV2 = {
	__typename?: 'QuoteOfferAttachmentV2';
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	name: Scalars['String']['output'];
	size: Scalars['Int']['output'];
	uploadedAt: Scalars['DateTime']['output'];
	url?: Maybe<Scalars['String']['output']>;
};

export type QuoteOfferAttachmentV2Input = {
	id: Scalars['ID']['input'];
	mimeType: Scalars['String']['input'];
	name: Scalars['String']['input'];
	size: Scalars['Int']['input'];
	url: Scalars['String']['input'];
};

export type QuoteOfferBatchV2 = Base & {
	__typename?: 'QuoteOfferBatchV2';
	acceptDeadline?: Maybe<Scalars['DateTime']['output']>;
	acceptDeadlineType?: Maybe<AcceptDeadlineTypeV2>;
	baseTotalAmount?: Maybe<Scalars['Float']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	manufacturer?: Maybe<Manufacturer>;
	manufacturerId?: Maybe<Scalars['ID']['output']>;
	marginTotal?: Maybe<Scalars['Float']['output']>;
	name: Scalars['String']['output'];
	offers: Array<QuoteOfferV2>;
	quote: QuoteV2;
	quoteV2Id: Scalars['ID']['output'];
	releasedVariationsCount: Scalars['Int']['output'];
	sentToClientAt?: Maybe<Scalars['DateTime']['output']>;
	status: QuoteOfferStatusV2;
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
	totalAmount: Scalars['Float']['output'];
	totalVariationsCount: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetter?: Maybe<VetterUser>;
	vetterId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteOfferBatchV2BaseTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferBatchV2MarginTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferBatchV2TotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferConversionResult = {
	__typename?: 'QuoteOfferConversionResult';
	convertedAmount: Scalars['Float']['output'];
	convertedAt: Scalars['DateTime']['output'];
	convertedCurrency: CurrencyEnum;
	exchangeRate: Scalars['Float']['output'];
	originalAmount: Scalars['Float']['output'];
	originalCurrency: CurrencyEnum;
	quoteOfferId: Scalars['ID']['output'];
};

export type QuoteOfferFileUploadV2Input = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	quoteV2Id: Scalars['ID']['input'];
};

export type QuoteOfferItemDeliveryV2 = Base & {
	__typename?: 'QuoteOfferItemDeliveryV2';
	adminFee: Scalars['Float']['output'];
	basePrice: Scalars['Float']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax: Scalars['Int']['output'];
	deliveryDaysMin: Scalars['Int']['output'];
	deliveryGroupId?: Maybe<Scalars['ID']['output']>;
	deliveryGroupName?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	quantity: Scalars['Int']['output'];
	quoteOfferItemVariationQuantityV2Id: Scalars['ID']['output'];
	shippingMethod: ShippingMethodV2;
	totalPrice: Scalars['Float']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variationQuantity: QuoteOfferItemVariationQuantityV2;
};

export type QuoteOfferItemDeliveryV2AdminFeeArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemDeliveryV2BasePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemDeliveryV2TotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemSampleChoiceV2 = Base & {
	__typename?: 'QuoteOfferItemSampleChoiceV2';
	choice: SampleChoiceV2;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	quoteOfferItemSampleV2Id: Scalars['ID']['output'];
	quoteOfferItemVariationV2Id: Scalars['ID']['output'];
	sample: QuoteOfferItemSampleV2;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variation: QuoteOfferItemVariationV2;
};

export type QuoteOfferItemSampleV2 = Base & {
	__typename?: 'QuoteOfferItemSampleV2';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	adminPrice: Scalars['Float']['output'];
	approvedAt?: Maybe<Scalars['DateTime']['output']>;
	approvedBy?: Maybe<Scalars['ID']['output']>;
	baseSamplePrice: Scalars['Float']['output'];
	baseShippingPrice?: Maybe<Scalars['Float']['output']>;
	carrier?: Maybe<Scalars['String']['output']>;
	choices: Array<QuoteOfferItemSampleChoiceV2>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveryDaysMax?: Maybe<Scalars['Int']['output']>;
	deliveryDaysMin?: Maybe<Scalars['Int']['output']>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	productId: Scalars['ID']['output'];
	quote: QuoteV2;
	quoteV2Id: Scalars['ID']['output'];
	rejectedAt?: Maybe<Scalars['DateTime']['output']>;
	rejectionReason?: Maybe<Scalars['String']['output']>;
	requestedAt?: Maybe<Scalars['DateTime']['output']>;
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	status: Scalars['String']['output'];
	totalSamplePrice: Scalars['Float']['output'];
	totalShippingPrice?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntityId?: Maybe<Scalars['ID']['output']>;
	vetterId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteOfferItemSampleV2AdminPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemSampleV2BaseSamplePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemSampleV2BaseShippingPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemSampleV2TotalSamplePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemSampleV2TotalShippingPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemV2 = Base & {
	__typename?: 'QuoteOfferItemV2';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	quoteItem: QuoteItemV2;
	quoteItemV2Id: Scalars['ID']['output'];
	quoteOffer: QuoteOfferV2;
	quoteOfferV2Id: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variations: Array<QuoteOfferItemVariationV2>;
};

export type QuoteOfferItemV2VariationsArgs = {
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteOfferItemVariationAdjustmentV2 = Base & {
	__typename?: 'QuoteOfferItemVariationAdjustmentV2';
	calculationType: AdjustmentCalculationTypeV2;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	createdByType: AdjustmentCreatorTypeV2;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	quoteOfferItemVariationV2Id: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
	type: AdjustmentTypeV2;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	value: Scalars['Float']['output'];
	variation: QuoteOfferItemVariationV2;
};

export type QuoteOfferItemVariationAdjustmentV2ValueArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationQuantityV2 = Base & {
	__typename?: 'QuoteOfferItemVariationQuantityV2';
	adjustedTotalPrice?: Maybe<Scalars['Float']['output']>;
	baseTotalPrice: Scalars['Float']['output'];
	baseUnitPrice: Scalars['Float']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deliveries: Array<QuoteOfferItemDeliveryV2>;
	id: Scalars['ID']['output'];
	marginAmount?: Maybe<Scalars['Float']['output']>;
	marginPercentage?: Maybe<Scalars['Float']['output']>;
	maxProductionDays?: Maybe<Scalars['Int']['output']>;
	minProductionDays?: Maybe<Scalars['Int']['output']>;
	orderItems: Array<QuoteOrderItemV2>;
	quantity: Scalars['Int']['output'];
	quoteItemQuantityV2Id?: Maybe<Scalars['ID']['output']>;
	quoteOfferItemVariationV2Id: Scalars['ID']['output'];
	releasedToClient: Scalars['Boolean']['output'];
	requestedQuantity?: Maybe<QuoteItemQuantityV2>;
	sortOrder: Scalars['Int']['output'];
	totalPrice?: Maybe<Scalars['Float']['output']>;
	unitPrice?: Maybe<Scalars['Float']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variation: QuoteOfferItemVariationV2;
};

export type QuoteOfferItemVariationQuantityV2AdjustedTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationQuantityV2BaseTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationQuantityV2BaseUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationQuantityV2MarginAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationQuantityV2TotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationQuantityV2UnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferItemVariationV2 = Base & {
	__typename?: 'QuoteOfferItemVariationV2';
	adjustments: Array<QuoteOfferItemVariationAdjustmentV2>;
	attachments?: Maybe<Array<QuoteOfferAttachmentV2>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	offerItem: QuoteOfferItemV2;
	quantities: Array<QuoteOfferItemVariationQuantityV2>;
	quoteOfferItemV2Id: Scalars['ID']['output'];
	releasedToClient: Scalars['Boolean']['output'];
	sampleChoice?: Maybe<QuoteOfferItemSampleChoiceV2>;
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuoteOfferItemVariationV2QuantitiesArgs = {
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum QuoteOfferStatusV2 {
	Accepted = 'accepted',
	Cancelled = 'cancelled',
	Draft = 'draft',
	Expired = 'expired',
	Pending = 'pending',
	Rejected = 'rejected',
	Submitted = 'submitted',
}

export type QuoteOfferV2 = Base & {
	__typename?: 'QuoteOfferV2';
	acceptDeadline?: Maybe<Scalars['DateTime']['output']>;
	baseTotalAmount?: Maybe<Scalars['Float']['output']>;
	batch?: Maybe<QuoteOfferBatchV2>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	items: Array<QuoteOfferItemV2>;
	manufacturer?: Maybe<Manufacturer>;
	manufacturerId?: Maybe<Scalars['ID']['output']>;
	marginTotal?: Maybe<Scalars['Float']['output']>;
	name: Scalars['String']['output'];
	quote: QuoteV2;
	quoteOfferBatchV2Id?: Maybe<Scalars['ID']['output']>;
	quoteV2Id: Scalars['ID']['output'];
	respondedAt?: Maybe<Scalars['DateTime']['output']>;
	sentToClientAt?: Maybe<Scalars['DateTime']['output']>;
	status: QuoteOfferStatusV2;
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
	totalAmount: Scalars['Float']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetter?: Maybe<VetterUser>;
	vetterId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteOfferV2BaseTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferV2MarginTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOfferV2TotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum QuoteOrderItemDeliveryStatusV2 {
	Cancelled = 'cancelled',
	Delivered = 'delivered',
	InTransit = 'in_transit',
	Pending = 'pending',
	Processing = 'processing',
	ReadyToShip = 'ready_to_ship',
	Shipped = 'shipped',
}

export type QuoteOrderItemDeliveryV2 = {
	__typename?: 'QuoteOrderItemDeliveryV2';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	adminFee?: Maybe<Scalars['Float']['output']>;
	basePrice?: Maybe<Scalars['Float']['output']>;
	carrier?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	deliveryDaysMax: Scalars['Int']['output'];
	deliveryDaysMin: Scalars['Int']['output'];
	deliveryGroupId?: Maybe<Scalars['ID']['output']>;
	deliveryGroupName?: Maybe<Scalars['String']['output']>;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	offerDelivery: QuoteOfferItemDeliveryV2;
	orderItem: QuoteOrderItemV2;
	quantity: Scalars['Int']['output'];
	quoteOfferItemDeliveryV2Id: Scalars['ID']['output'];
	quoteOrderItemV2Id: Scalars['ID']['output'];
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	shippingMethod: ShippingMethodV2;
	status: QuoteOrderItemDeliveryStatusV2;
	totalPrice?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type QuoteOrderItemDeliveryV2AdminFeeArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemDeliveryV2BasePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemDeliveryV2TotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum QuoteOrderItemSampleApprovalDecisionV2 {
	Approved = 'approved',
	ApprovedWithNotes = 'approved_with_notes',
	Rejected = 'rejected',
}

export enum QuoteOrderItemSampleApprovalReviewHistoryActionV2 {
	Approved = 'approved',
	Denied = 'denied',
	ReRequested = 're_requested',
}

export enum QuoteOrderItemSampleApprovalReviewHistoryActorV2 {
	Admin = 'admin',
	Client = 'client',
}

export type QuoteOrderItemSampleApprovalReviewHistoryEntryV2 = {
	__typename?: 'QuoteOrderItemSampleApprovalReviewHistoryEntryV2';
	action: QuoteOrderItemSampleApprovalReviewHistoryActionV2;
	actor: QuoteOrderItemSampleApprovalReviewHistoryActorV2;
	at: Scalars['DateTime']['output'];
	notes?: Maybe<Scalars['String']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteOrderItemSampleApprovalV2 = Base & {
	__typename?: 'QuoteOrderItemSampleApprovalV2';
	approvalNotes?: Maybe<Scalars['String']['output']>;
	approvedAt: Scalars['DateTime']['output'];
	approvedByUserId: Scalars['ID']['output'];
	attachments?: Maybe<Scalars['JSON']['output']>;
	createdAt: Scalars['DateTime']['output'];
	decision: QuoteOrderItemSampleApprovalDecisionV2;
	id: Scalars['ID']['output'];
	newSampleRequestStatus?: Maybe<NewSampleRequestStatusV2>;
	nextSampleChoice?: Maybe<SampleChoiceV2>;
	rejectionAttachments: Array<SampleVirtualDeliveryAttachmentV2>;
	requestNewSample?: Maybe<Scalars['Boolean']['output']>;
	reviewHistory?: Maybe<Array<QuoteOrderItemSampleApprovalReviewHistoryEntryV2>>;
	reviewedAt?: Maybe<Scalars['DateTime']['output']>;
	reviewedByUserId?: Maybe<Scalars['ID']['output']>;
	revisionRequests?: Maybe<Scalars['JSON']['output']>;
	sample: QuoteOrderItemSampleV2;
	updatedAt: Scalars['DateTime']['output'];
};

export enum QuoteOrderItemSampleDeliveryMethodV2 {
	Physical = 'physical',
	Virtual = 'virtual',
}

export enum QuoteOrderItemSampleStatusV2 {
	Approved = 'approved',
	AwaitingApproval = 'awaiting_approval',
	Cancelled = 'cancelled',
	Delivered = 'delivered',
	Pending = 'pending',
	ProductionCompleted = 'production_completed',
	ProductionStarted = 'production_started',
	Rejected = 'rejected',
	Shipped = 'shipped',
	VirtualSubmitted = 'virtual_submitted',
}

export type QuoteOrderItemSampleV2 = Base & {
	__typename?: 'QuoteOrderItemSampleV2';
	actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	adminPrice?: Maybe<Scalars['Float']['output']>;
	/**
	 * Admin price in DKK (read from adminPrices.DKK). Used by the
	 * frontend to compare against the Stripe checkout limit.
	 */
	adminPriceDkk?: Maybe<Scalars['Float']['output']>;
	approvals: Array<QuoteOrderItemSampleApprovalV2>;
	carrier?: Maybe<Scalars['String']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currentApproval?: Maybe<QuoteOrderItemSampleApprovalV2>;
	deliveryMethod: QuoteOrderItemSampleDeliveryMethodV2;
	estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	/**
	 * When true, this sample's paid amount credits against the eventual
	 * product invoice. Set by the client at approval time; toggled by
	 * admin via setSampleDeductibilityV2.
	 */
	isDeductible: Scalars['Boolean']['output'];
	offerSample?: Maybe<QuoteOfferItemSampleV2>;
	order: QuoteOrderV2;
	orderItem: QuoteOrderItemV2;
	paymentStatus: SamplePaymentStatus;
	previousSample?: Maybe<QuoteOrderItemSampleV2>;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	sampleChoice: SampleChoiceV2;
	samplePayment?: Maybe<SamplePayment>;
	samplePrice?: Maybe<Scalars['Float']['output']>;
	sampleRound: Scalars['Int']['output'];
	shippedAt?: Maybe<Scalars['DateTime']['output']>;
	shippingPrice?: Maybe<Scalars['Float']['output']>;
	status: QuoteOrderItemSampleStatusV2;
	totalSampleCost?: Maybe<Scalars['Float']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
	virtualDelivery?: Maybe<SampleVirtualDeliveryV2>;
	virtualDeliveryAttachments?: Maybe<Scalars['JSON']['output']>;
	virtualDeliverySubmittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuoteOrderItemSampleV2AdminPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemSampleV2SamplePriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemSampleV2ShippingPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemSampleV2TotalSampleCostArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum QuoteOrderItemStatusV2 {
	Cancelled = 'cancelled',
	Confirmed = 'confirmed',
	Delivered = 'delivered',
	Pending = 'pending',
	ProductionCompleted = 'production_completed',
	ProductionStarted = 'production_started',
	Shipped = 'shipped',
}

export type QuoteOrderItemV2 = Base & {
	__typename?: 'QuoteOrderItemV2';
	adjustedTotalPrice?: Maybe<Scalars['Float']['output']>;
	baseTotalPrice?: Maybe<Scalars['Float']['output']>;
	baseUnitPrice: Scalars['Float']['output'];
	createdAt: Scalars['DateTime']['output'];
	customizations?: Maybe<Scalars['JSON']['output']>;
	deliveries: Array<QuoteOrderItemDeliveryV2>;
	id: Scalars['ID']['output'];
	isProductPaymentPaid: Scalars['Boolean']['output'];
	manufacturerId?: Maybe<Scalars['ID']['output']>;
	marginAmount?: Maybe<Scalars['Float']['output']>;
	marginPercentage?: Maybe<Scalars['Float']['output']>;
	notes?: Maybe<Scalars['String']['output']>;
	order: QuoteOrderV2;
	productionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
	productionStartedAt?: Maybe<Scalars['DateTime']['output']>;
	quantity: Scalars['Int']['output'];
	sampleChoice?: Maybe<SampleChoiceV2>;
	samples: Array<QuoteOrderItemSampleV2>;
	snapshotAdjustments?: Maybe<Scalars['JSON']['output']>;
	snapshotAttachments?: Maybe<Scalars['JSON']['output']>;
	sortOrder: Scalars['Int']['output'];
	status: QuoteOrderItemStatusV2;
	totalPrice: Scalars['Float']['output'];
	unitPrice: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
	variationQuantity: QuoteOfferItemVariationQuantityV2;
	vetterId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteOrderItemV2AdjustedTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemV2BaseTotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemV2BaseUnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemV2MarginAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemV2TotalPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderItemV2UnitPriceArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum QuoteOrderStatusV2 {
	Cancelled = 'cancelled',
	Completed = 'completed',
	Confirmed = 'confirmed',
	Pending = 'pending',
}

export enum QuoteOrderTimelineEventCategoryV2 {
	Delivery = 'DELIVERY',
	Order = 'ORDER',
	Production = 'PRODUCTION',
	Sample = 'SAMPLE',
}

export type QuoteOrderTimelineEventMetadataV2 = {
	__typename?: 'QuoteOrderTimelineEventMetadataV2';
	approvalDecision?: Maybe<Scalars['String']['output']>;
	approvalNotes?: Maybe<Scalars['String']['output']>;
	carrier?: Maybe<Scalars['String']['output']>;
	deliveryGroupName?: Maybe<Scalars['String']['output']>;
	deliveryMethod?: Maybe<Scalars['String']['output']>;
	sampleRound?: Maybe<Scalars['Int']['output']>;
	shippingMethod?: Maybe<Scalars['String']['output']>;
	trackingNumber?: Maybe<Scalars['String']['output']>;
};

export enum QuoteOrderTimelineEventTypeV2 {
	DeliveryDelivered = 'DELIVERY_DELIVERED',
	DeliveryShipped = 'DELIVERY_SHIPPED',
	ItemProductionCompleted = 'ITEM_PRODUCTION_COMPLETED',
	ItemProductionStarted = 'ITEM_PRODUCTION_STARTED',
	OrderCancelled = 'ORDER_CANCELLED',
	OrderCompleted = 'ORDER_COMPLETED',
	OrderConfirmed = 'ORDER_CONFIRMED',
	OrderCreated = 'ORDER_CREATED',
	SampleApproved = 'SAMPLE_APPROVED',
	SampleApprovedWithNotes = 'SAMPLE_APPROVED_WITH_NOTES',
	SampleDelivered = 'SAMPLE_DELIVERED',
	SampleProductionCompleted = 'SAMPLE_PRODUCTION_COMPLETED',
	SampleProductionStarted = 'SAMPLE_PRODUCTION_STARTED',
	SampleRejected = 'SAMPLE_REJECTED',
	SampleShipped = 'SAMPLE_SHIPPED',
	SampleVirtualSubmitted = 'SAMPLE_VIRTUAL_SUBMITTED',
}

export type QuoteOrderTimelineEventV2 = {
	__typename?: 'QuoteOrderTimelineEventV2';
	category: QuoteOrderTimelineEventCategoryV2;
	date: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<QuoteOrderTimelineEventMetadataV2>;
	title: Scalars['String']['output'];
	type: QuoteOrderTimelineEventTypeV2;
};

export type QuoteOrderTimelineItemGroupV2 = {
	__typename?: 'QuoteOrderTimelineItemGroupV2';
	events: Array<QuoteOrderTimelineEventV2>;
	itemName: Scalars['String']['output'];
	orderItemId: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
};

export type QuoteOrderTimelineV2 = {
	__typename?: 'QuoteOrderTimelineV2';
	itemGroups: Array<QuoteOrderTimelineItemGroupV2>;
	orderEvents: Array<QuoteOrderTimelineEventV2>;
};

export type QuoteOrderV2 = Base & {
	__typename?: 'QuoteOrderV2';
	acceptDeadline?: Maybe<Scalars['DateTime']['output']>;
	adjustedTotalAmount?: Maybe<Scalars['Float']['output']>;
	allSamples: Array<QuoteOrderItemSampleV2>;
	baseTotalAmount?: Maybe<Scalars['Float']['output']>;
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	confirmedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	description?: Maybe<Scalars['String']['output']>;
	economicInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	invoiceMinimum?: Maybe<Scalars['Float']['output']>;
	invoiceRecipientEmail?: Maybe<Scalars['String']['output']>;
	invoiceRecipientOrgUserId?: Maybe<Scalars['ID']['output']>;
	items: Array<QuoteOrderItemV2>;
	marginTotal?: Maybe<Scalars['Float']['output']>;
	name: Scalars['String']['output'];
	orderNumber: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	paymentTransaction?: Maybe<PaymentTransaction>;
	productPaymentMode: PaymentModeEnum;
	quote: QuoteV2;
	samplePaymentMode: PaymentModeEnum;
	status: QuoteOrderStatusV2;
	stripeCheckoutLimit?: Maybe<Scalars['Float']['output']>;
	totalAmount: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type QuoteOrderV2AdjustedTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderV2BaseTotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderV2MarginTotalArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export type QuoteOrderV2TotalAmountArgs = {
	inCurrency?: InputMaybe<CurrencyEnum>;
};

export enum QuotePurposeV2 {
	Event = 'EVENT',
	Other = 'OTHER',
	Packaging = 'PACKAGING',
	Resell = 'RESELL',
}

export type QuoteStatsByStatusV2 = {
	__typename?: 'QuoteStatsByStatusV2';
	dateRange?: Maybe<DateRange>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	statusBreakdown: Array<QuoteStatusBreakdownV2>;
	total: Scalars['Int']['output'];
	totalClients: Scalars['Int']['output'];
};

export type QuoteStatsV2 = {
	__typename?: 'QuoteStatsV2';
	dateRange?: Maybe<DateRange>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	totalQuotes: Scalars['Int']['output'];
};

export type QuoteStatusBreakdownV2 = {
	__typename?: 'QuoteStatusBreakdownV2';
	clientCount: Scalars['Int']['output'];
	count: Scalars['Int']['output'];
	percentage: Scalars['Float']['output'];
	status: QuoteStatusV2;
};

export enum QuoteStatusV2 {
	Accepted = 'accepted',
	Draft = 'draft',
	Expired = 'expired',
	Pending = 'pending',
	Rejected = 'rejected',
	Submitted = 'submitted',
}

export type QuoteV2 = Base & {
	__typename?: 'QuoteV2';
	/** List of organizationUser.id values picked at quote finalize as contact persons. Empty array means no client-side notifications go out. */
	contactUserIds: Array<Scalars['ID']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	deadline?: Maybe<Scalars['DateTime']['output']>;
	deliveryAddress?: Maybe<DeliveryAddressV2>;
	description?: Maybe<Scalars['String']['output']>;
	history: Array<QuoteHistoryV2>;
	id: Scalars['ID']['output'];
	/**
	 * Whether this quote is the current quote for the calling user.
	 * Each user (admin or org user) has their own independent current
	 * quote — see quoteCurrentUserV2.
	 */
	isCurrentForMe: Scalars['Boolean']['output'];
	items: Array<QuoteItemV2>;
	name: Scalars['String']['output'];
	offerBatches: Array<QuoteOfferBatchV2>;
	offers: Array<QuoteOfferV2>;
	orders: Array<QuoteOrderV2>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	projectId?: Maybe<Scalars['ID']['output']>;
	/** Why the client is requesting this quote. Optional, set at finalize. */
	purpose?: Maybe<QuotePurposeV2>;
	/** Free-text detail when purpose=OTHER. Ignored for other purpose values. */
	purposeOther?: Maybe<Scalars['String']['output']>;
	status: QuoteStatusV2;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterEntityIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ReRequestNewSampleRoundV2Input = {
	approvalId: Scalars['ID']['input'];
	clientNote?: InputMaybe<Scalars['String']['input']>;
};

export type RegenerateBackupCodesInput = {
	mfaToken: Scalars['String']['input'];
	password: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type RegisterInput = {
	mfaMethod: MfaMethodEnum;
	password: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type RegisterResponse = {
	__typename?: 'RegisterResponse';
	qrCodeDataURL?: Maybe<Scalars['String']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type RejectSampleV2Input = {
	approvalNotes?: InputMaybe<Scalars['String']['input']>;
	attachments?: InputMaybe<Array<SampleVirtualDeliveryAttachmentV2Input>>;
	nextSampleChoice?: InputMaybe<SampleChoiceV2>;
	requestNewSample: Scalars['Boolean']['input'];
	revisionRequests?: InputMaybe<Scalars['JSON']['input']>;
	sampleId: Scalars['ID']['input'];
};

export type RemixProductToStudioInput = {
	additionalReferenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	productId: Scalars['ID']['input'];
	userPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type RemixProductToStudioResponse = {
	__typename?: 'RemixProductToStudioResponse';
	message?: Maybe<Scalars['String']['output']>;
	studioFileId?: Maybe<Scalars['ID']['output']>;
	success: Scalars['Boolean']['output'];
};

export type RemoveMetadataAttachmentInput = {
	attachmentIndex: Scalars['Int']['input'];
	metadataId: Scalars['ID']['input'];
};

export type RemovePermissionsFromRoleInput = {
	permissionIds: Array<Scalars['ID']['input']>;
	roleId: Scalars['ID']['input'];
};

export type RequestEarlyAccessInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type ResponseError = {
	__typename?: 'ResponseError';
	code?: Maybe<Scalars['String']['output']>;
	details?: Maybe<Scalars['String']['output']>;
	field?: Maybe<Scalars['String']['output']>;
	index?: Maybe<Scalars['Int']['output']>;
	message: Scalars['String']['output'];
};

export enum SampleChoiceV2 {
	NoSample = 'NO_SAMPLE',
	SampleNoShipping = 'SAMPLE_NO_SHIPPING',
	SampleWithShipping = 'SAMPLE_WITH_SHIPPING',
}

export type SamplePayment = Base & {
	__typename?: 'SamplePayment';
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	description?: Maybe<Scalars['String']['output']>;
	economicMirror?: Maybe<SamplePaymentEconomicMirror>;
	id: Scalars['ID']['output'];
	invoice?: Maybe<SamplePaymentInvoice>;
	invoices: Array<SamplePaymentInvoice>;
	orderItemId: Scalars['ID']['output'];
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paymentStatus: SamplePaymentStatus;
	sampleId: Scalars['ID']['output'];
	samplePrice: Scalars['Float']['output'];
	shippingPrice: Scalars['Float']['output'];
	totalPrice: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type SamplePaymentEconomicMirror = Base & {
	__typename?: 'SamplePaymentEconomicMirror';
	attempts: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicPdfUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastError?: Maybe<Scalars['String']['output']>;
	status: SamplePaymentEconomicMirrorStatus;
	updatedAt: Scalars['DateTime']['output'];
};

export enum SamplePaymentEconomicMirrorStatus {
	Failed = 'failed',
	Pending = 'pending',
	Succeeded = 'succeeded',
}

export type SamplePaymentInvoice = Base & {
	__typename?: 'SamplePaymentInvoice';
	attempts: Scalars['Int']['output'];
	createdAt: Scalars['DateTime']['output'];
	economicBookedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
	economicPdfUrl?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastError?: Maybe<Scalars['String']['output']>;
	paidAt?: Maybe<Scalars['DateTime']['output']>;
	paidVia?: Maybe<SamplePaymentInvoicePaidVia>;
	status: SamplePaymentInvoiceStatus;
	updatedAt: Scalars['DateTime']['output'];
};

/** How a sample invoice ended up marked paid — poller vs admin override. */
export enum SamplePaymentInvoicePaidVia {
	AdminManual = 'admin_manual',
	Poller = 'poller',
}

/** samplePaymentInvoice (bank-transfer) lifecycle — separate from samplePayment. */
export enum SamplePaymentInvoiceStatus {
	Booked = 'booked',
	Cancelled = 'cancelled',
	Failed = 'failed',
	Paid = 'paid',
	Pending = 'pending',
}

export type SamplePaymentItemInput = {
	name: Scalars['String']['input'];
	orderItemId: Scalars['ID']['input'];
	price: Scalars['Float']['input'];
	sampleId: Scalars['ID']['input'];
};

/** samplePayment lifecycle. */
export enum SamplePaymentStatus {
	Failed = 'failed',
	Invoiced = 'invoiced',
	Paid = 'paid',
	Refunded = 'refunded',
	Unpaid = 'unpaid',
	Waived = 'waived',
}

export type SampleVirtualDeliveryAttachmentV2 = {
	__typename?: 'SampleVirtualDeliveryAttachmentV2';
	caption?: Maybe<Scalars['String']['output']>;
	downloadUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	fileId: Scalars['ID']['output'];
	fileName: Scalars['String']['output'];
	fileSize: Scalars['Int']['output'];
	fileType: Scalars['String']['output'];
	uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SampleVirtualDeliveryAttachmentV2Input = {
	blobUrl: Scalars['String']['input'];
	caption?: InputMaybe<Scalars['String']['input']>;
	fileId: Scalars['ID']['input'];
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
};

export type SampleVirtualDeliveryFileUploadV2Input = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	sampleId: Scalars['ID']['input'];
};

export type SampleVirtualDeliveryV2 = {
	__typename?: 'SampleVirtualDeliveryV2';
	attachments: Array<SampleVirtualDeliveryAttachmentV2>;
	notes?: Maybe<Scalars['String']['output']>;
	sampleId: Scalars['ID']['output'];
	submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendChatMessageInput = {
	content: Scalars['String']['input'];
	maskImage?: InputMaybe<Scalars['String']['input']>;
	maskImagePreview?: InputMaybe<Scalars['String']['input']>;
	referenceImages?: InputMaybe<Array<Scalars['String']['input']>>;
	studioFileId: Scalars['ID']['input'];
};

export type SendChatMessageResponse = {
	__typename?: 'SendChatMessageResponse';
	message: StudioChat;
	toolsUsed?: Maybe<Array<Scalars['String']['output']>>;
	versionCreated: Scalars['Boolean']['output'];
};

export type SendContextMessageInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	contextId: Scalars['ID']['input'];
	messageType?: InputMaybe<MessageType>;
	metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ShippingMethodV2 {
	Express = 'EXPRESS',
	Sea = 'SEA',
}

export type SignupAddressInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city: Scalars['String']['input'];
	countryCode: Scalars['String']['input'];
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	postalCode: Scalars['String']['input'];
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type SpecificationCapacity = {
	__typename?: 'SpecificationCapacity';
	unit: Scalars['String']['output'];
	value: Scalars['Float']['output'];
};

export type SpecificationCapacityInput = {
	unit: Scalars['String']['input'];
	value: Scalars['Float']['input'];
};

export type SpecificationDimensions = {
	__typename?: 'SpecificationDimensions';
	depth?: Maybe<Scalars['Float']['output']>;
	diameter?: Maybe<Scalars['Float']['output']>;
	height?: Maybe<Scalars['Float']['output']>;
	unit: Scalars['String']['output'];
	width?: Maybe<Scalars['Float']['output']>;
};

export type SpecificationDimensionsInput = {
	depth?: InputMaybe<Scalars['Float']['input']>;
	diameter?: InputMaybe<Scalars['Float']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	unit: Scalars['String']['input'];
	width?: InputMaybe<Scalars['Float']['input']>;
};

export type SpecificationWeight = {
	__typename?: 'SpecificationWeight';
	unit: Scalars['String']['output'];
	value: Scalars['Float']['output'];
};

export type SpecificationWeightInput = {
	unit: Scalars['String']['input'];
	value: Scalars['Float']['input'];
};

export enum StatusEnum {
	Canceled = 'CANCELED',
	Completed = 'COMPLETED',
	Pending = 'PENDING',
}

export type StripeCheckoutSession = Base & {
	__typename?: 'StripeCheckoutSession';
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt: Scalars['DateTime']['output'];
	currency: CurrencyEnum;
	expiresAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	orderId: Scalars['ID']['output'];
	samplePayments: Array<SamplePayment>;
	status: CheckoutSessionStatus;
	stripeSessionId: Scalars['String']['output'];
	totalAmount: Scalars['Float']['output'];
	updatedAt: Scalars['DateTime']['output'];
};

export type Studio = Base & {
	__typename?: 'Studio';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudioAgentTool = {
	__typename?: 'StudioAgentTool';
	description: Scalars['String']['output'];
	name: Scalars['String']['output'];
	parameters: Scalars['String']['output'];
	supportedProviders: Array<Scalars['String']['output']>;
};

export enum StudioAgentType {
	Packaging = 'Packaging',
	Product = 'Product',
}

export type StudioChat = Base & {
	__typename?: 'StudioChat';
	chatType: StudioChatType;
	content: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	maskImage?: Maybe<Scalars['String']['output']>;
	maskImagePreview?: Maybe<Scalars['String']['output']>;
	referenceImages?: Maybe<Array<Scalars['String']['output']>>;
	role: ChatRole;
	status: StudioChatStatus;
	studioFile: StudioFile;
	studioFileId: Scalars['ID']['output'];
	toolCalls?: Maybe<Array<ToolCall>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum StudioChatStatus {
	Completed = 'completed',
	Failed = 'failed',
	Pending = 'pending',
	Processing = 'processing',
}

export enum StudioChatType {
	Reasoning = 'reasoning',
	Text = 'text',
}

export type StudioDesignSpec = {
	__typename?: 'StudioDesignSpec';
	appliesTo?: Maybe<Scalars['String']['output']>;
	assetPurpose?: Maybe<Scalars['String']['output']>;
	assetType?: Maybe<Scalars['String']['output']>;
	assetUrl?: Maybe<Scalars['String']['output']>;
	colorHex?: Maybe<Scalars['String']['output']>;
	colorName?: Maybe<Scalars['String']['output']>;
	confidence?: Maybe<Scalars['Float']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	derivationMethod?: Maybe<Scalars['String']['output']>;
	derivedFromSpec?: Maybe<StudioDesignSpec>;
	derivedFromSpecId?: Maybe<Scalars['ID']['output']>;
	fontFamily?: Maybe<Scalars['String']['output']>;
	fontSize?: Maybe<Scalars['Float']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['JSON']['output']>;
	placement?: Maybe<DesignSpecPlacement>;
	promptSnippet?: Maybe<Scalars['String']['output']>;
	specType: DesignSpecType;
	studioChatId?: Maybe<Scalars['ID']['output']>;
	studioFileVersionId: Scalars['ID']['output'];
	textContent?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudioFile = Base & {
	__typename?: 'StudioFile';
	canvasBackgroundColor: Scalars['String']['output'];
	canvasHeight: Scalars['Int']['output'];
	canvasWidth: Scalars['Int']['output'];
	chats?: Maybe<Array<StudioChat>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currentVersion?: Maybe<StudioFileVersion>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isAutoGenerated: Scalars['Boolean']['output'];
	isGenerating: Scalars['Boolean']['output'];
	name?: Maybe<Scalars['String']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	ownerRole: AuthRoleEnum;
	productId?: Maybe<Scalars['ID']['output']>;
	sourceProductId?: Maybe<Scalars['ID']['output']>;
	status: StudioFileStatus;
	type: StudioFileType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	versions?: Maybe<Array<StudioFileVersion>>;
};

export type StudioFileCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	referenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
	status: StudioFileStatus;
	type: StudioFileType;
	userPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type StudioFilePage = {
	__typename?: 'StudioFilePage';
	data: Array<StudioFile>;
	pageInfo: PageInfo;
};

export type StudioFileSpecs = {
	__typename?: 'StudioFileSpecs';
	materialType?: Maybe<Scalars['String']['output']>;
	weight?: Maybe<Scalars['Float']['output']>;
};

export type StudioFileSpecsInput = {
	materialType?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum StudioFileStatus {
	Active = 'ACTIVE',
	Archived = 'ARCHIVED',
	Inactive = 'INACTIVE',
}

export enum StudioFileType {
	LabelDesign = 'LABEL_DESIGN',
	Other = 'OTHER',
	PackagingDesign = 'PACKAGING_DESIGN',
	ProductDesign = 'PRODUCT_DESIGN',
}

export type StudioFileUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<StudioFileStatus>;
	type?: InputMaybe<StudioFileType>;
};

export type StudioFileVersion = Base & {
	__typename?: 'StudioFileVersion';
	changeNotes?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	createdBy: Scalars['ID']['output'];
	designSpecs?: Maybe<Array<StudioDesignSpec>>;
	id: Scalars['ID']['output'];
	imageDescription?: Maybe<Scalars['String']['output']>;
	imageUrls: Array<Scalars['String']['output']>;
	metadata?: Maybe<Array<StudioFileVersionMetadata>>;
	name: Scalars['String']['output'];
	slug: Scalars['String']['output'];
	specifications?: Maybe<Array<StudioFileVersionSpecification>>;
	specs?: Maybe<StudioFileSpecs>;
	studioFile: StudioFile;
	studioFileId: Scalars['ID']['output'];
	techPack?: Maybe<StudioFileVersionTechPack>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	versionNumber: Scalars['Int']['output'];
};

export type StudioFileVersionMetadata = {
	__typename?: 'StudioFileVersionMetadata';
	attachments?: Maybe<Array<MetadataAttachment>>;
	canvasHeight: Scalars['Float']['output'];
	canvasWidth: Scalars['Float']['output'];
	comment?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	height?: Maybe<Scalars['Float']['output']>;
	id: Scalars['ID']['output'];
	points?: Maybe<Array<PolygonPoint>>;
	studioFileVersionId: Scalars['ID']['output'];
	type: MetadataType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	width?: Maybe<Scalars['Float']['output']>;
	x?: Maybe<Scalars['Float']['output']>;
	y?: Maybe<Scalars['Float']['output']>;
};

export type StudioFileVersionSpecification = {
	__typename?: 'StudioFileVersionSpecification';
	capacity?: Maybe<SpecificationCapacity>;
	colors?: Maybe<Array<Scalars['String']['output']>>;
	confidence?: Maybe<Scalars['Float']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	dimensions?: Maybe<SpecificationDimensions>;
	elementName: Scalars['String']['output'];
	elementType?: Maybe<Scalars['String']['output']>;
	features?: Maybe<Array<Scalars['String']['output']>>;
	finish?: Maybe<Scalars['String']['output']>;
	generatedAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	material?: Maybe<Scalars['String']['output']>;
	secondaryMaterials?: Maybe<Array<Scalars['String']['output']>>;
	studioFileVersionId: Scalars['ID']['output'];
	textureDescription?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	weight?: Maybe<SpecificationWeight>;
};

export type StudioFileVersionTechPack = Base & {
	__typename?: 'StudioFileVersionTechPack';
	additionalNotes?: Maybe<Scalars['String']['output']>;
	colorways?: Maybe<Array<TechPackColorway>>;
	construction?: Maybe<TechPackConstruction>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	createdBy: Scalars['ID']['output'];
	dimensions?: Maybe<TechPackDimensions>;
	id: Scalars['ID']['output'];
	labeling?: Maybe<TechPackLabeling>;
	materials?: Maybe<TechPackMaterials>;
	packaging?: Maybe<TechPackPackaging>;
	qualityControl?: Maybe<TechPackQualityControl>;
	studioFileVersion: StudioFileVersion;
	studioFileVersionId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type StudioLock = {
	__typename?: 'StudioLock';
	expiresAt: Scalars['DateTime']['output'];
	lockedAt: Scalars['DateTime']['output'];
	studioFileId: Scalars['ID']['output'];
	userId: Scalars['ID']['output'];
};

export type StudioPromptTemplate = Base & {
	__typename?: 'StudioPromptTemplate';
	agentType: StudioAgentType;
	category: StudioPromptTemplateCategory;
	content: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	key: Scalars['String']['output'];
	provider?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	variables?: Maybe<Array<Scalars['String']['output']>>;
};

export enum StudioPromptTemplateCategory {
	System = 'System',
	Tool = 'Tool',
}

export type SubmitOfferSelectionV2 = {
	offerId: Scalars['ID']['input'];
	variationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	variations?: InputMaybe<Array<SubmitVariationSelectionV2>>;
};

export type SubmitQuoteOffersToClientV2Input = {
	offers: Array<SubmitOfferSelectionV2>;
};

export type SubmitQuoteV2Input = {
	id: Scalars['ID']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmitVariationSelectionV2 = {
	quantityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	variationId: Scalars['ID']['input'];
};

export type SubmitVirtualSampleV2Input = {
	attachments: Array<SampleVirtualDeliveryAttachmentV2Input>;
	notes?: InputMaybe<Scalars['String']['input']>;
	sampleId: Scalars['ID']['input'];
};

export type Subscription = {
	__typename?: 'Subscription';
	messageAdded?: Maybe<ChatMessage>;
	messageDeleted?: Maybe<Scalars['ID']['output']>;
	messageUpdated?: Maybe<ChatMessage>;
	studioChatUpdated?: Maybe<StudioChat>;
	studioFileVersionAdded?: Maybe<StudioFileVersion>;
	studioLockChanged?: Maybe<StudioLock>;
	unreadCountChanged?: Maybe<UnreadCountUpdate>;
};

export type SubscriptionMessageAddedArgs = {
	contextId: Scalars['ID']['input'];
};

export type SubscriptionMessageDeletedArgs = {
	contextId: Scalars['ID']['input'];
};

export type SubscriptionMessageUpdatedArgs = {
	contextId: Scalars['ID']['input'];
};

export type SubscriptionStudioChatUpdatedArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type SubscriptionStudioFileVersionAddedArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type SubscriptionStudioLockChangedArgs = {
	studioFileId: Scalars['ID']['input'];
};

export type SubscriptionUnreadCountChangedArgs = {
	userId: Scalars['ID']['input'];
};

/**
 * Generic subscription-mutation result.
 *
 * For changeSubscriptionPlan on upgrades: if Stripe needs SCA/3DS to
 * charge the prorated diff, requiresAction is true and the frontend
 * confirms the payment using clientSecret.
 */
export type SubscriptionMutationResponse = {
	__typename?: 'SubscriptionMutationResponse';
	/** Breakdown of the plan change (prices, proration, VAT). Present on successful changeSubscriptionPlan. */
	breakdown?: Maybe<PlanChangeBreakdown>;
	clientSecret?: Maybe<Scalars['String']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	requiresAction?: Maybe<Scalars['Boolean']['output']>;
	subscription?: Maybe<OrganizationSubscription>;
	success: Scalars['Boolean']['output'];
};

export enum SubscriptionStatus {
	Active = 'active',
	Canceled = 'canceled',
	Incomplete = 'incomplete',
	IncompleteExpired = 'incomplete_expired',
	PastDue = 'past_due',
	Trialing = 'trialing',
	Unpaid = 'unpaid',
}

export enum SubscriptionTier {
	Creator = 'creator',
	Enterprise = 'enterprise',
	Pro = 'pro',
}

/**
 * Admin-editable config for each subscription tier.
 * Lets the operator adjust monthly price, kickback rate, token rate, and fee %
 * without a deploy.
 */
export type SubscriptionTierConfig = {
	__typename?: 'SubscriptionTierConfig';
	aiTokenRatePerMillion?: Maybe<Scalars['Float']['output']>;
	/** ISO 4217 currency code, lower-case to match Stripe (e.g. eur, usd, dkk). Null if no Stripe Price is attached. */
	currency?: Maybe<Scalars['String']['output']>;
	isActive: Scalars['Boolean']['output'];
	kickbackRate: Scalars['Float']['output'];
	/** Monthly price for this tier. Synced from Stripe via webhook. See currency field for the unit. */
	monthlyPrice?: Maybe<Scalars['Float']['output']>;
	stripePriceId?: Maybe<Scalars['String']['output']>;
	tier: SubscriptionTier;
	updatedAt: Scalars['DateTime']['output'];
};

export enum SupportedLanguage {
	Da = 'da',
	En = 'en',
	Zh = 'zh',
}

export type TechPackCareLabel = {
	__typename?: 'TechPackCareLabel';
	content?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	symbols?: Maybe<Array<Scalars['String']['output']>>;
};

export type TechPackCareLabelInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	symbols?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TechPackColorway = {
	__typename?: 'TechPackColorway';
	code?: Maybe<Scalars['String']['output']>;
	fabricColors?: Maybe<Scalars['JSON']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	pantoneReferences?: Maybe<Array<Scalars['String']['output']>>;
	trimColors?: Maybe<Scalars['JSON']['output']>;
};

export type TechPackColorwayInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	fabricColors?: InputMaybe<Scalars['JSON']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	pantoneReferences?: InputMaybe<Array<Scalars['String']['input']>>;
	trimColors?: InputMaybe<Scalars['JSON']['input']>;
};

export type TechPackConstruction = {
	__typename?: 'TechPackConstruction';
	seamAllowances?: Maybe<Array<TechPackSeamAllowance>>;
	specialInstructions?: Maybe<Array<Scalars['String']['output']>>;
	stitchTypes?: Maybe<Array<TechPackStitch>>;
};

export type TechPackConstructionInput = {
	seamAllowances?: InputMaybe<Array<TechPackSeamAllowanceInput>>;
	specialInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
	stitchTypes?: InputMaybe<Array<TechPackStitchInput>>;
};

export type TechPackDimensions = {
	__typename?: 'TechPackDimensions';
	measurements?: Maybe<Array<TechPackMeasurement>>;
	sizeChart?: Maybe<Array<TechPackSize>>;
};

export type TechPackDimensionsInput = {
	measurements?: InputMaybe<Array<TechPackMeasurementInput>>;
	sizeChart?: InputMaybe<Array<TechPackSizeInput>>;
};

export type TechPackFabric = {
	__typename?: 'TechPackFabric';
	code?: Maybe<Scalars['String']['output']>;
	composition?: Maybe<Scalars['String']['output']>;
	supplier?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
	weight?: Maybe<Scalars['String']['output']>;
	width?: Maybe<Scalars['String']['output']>;
};

export type TechPackFabricInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	composition?: InputMaybe<Scalars['String']['input']>;
	supplier?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<Scalars['String']['input']>;
	width?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackHardware = {
	__typename?: 'TechPackHardware';
	code?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	quantity?: Maybe<Scalars['Int']['output']>;
	supplier?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackHardwareInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	quantity?: InputMaybe<Scalars['Int']['input']>;
	supplier?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackLabel = {
	__typename?: 'TechPackLabel';
	content?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackLabelInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackLabeling = {
	__typename?: 'TechPackLabeling';
	additionalLabels?: Maybe<Array<TechPackLabel>>;
	careLabel?: Maybe<TechPackCareLabel>;
	mainLabel?: Maybe<TechPackLabel>;
};

export type TechPackLabelingInput = {
	additionalLabels?: InputMaybe<Array<TechPackLabelInput>>;
	careLabel?: InputMaybe<TechPackCareLabelInput>;
	mainLabel?: InputMaybe<TechPackLabelInput>;
};

export type TechPackMaterials = {
	__typename?: 'TechPackMaterials';
	fabric?: Maybe<TechPackFabric>;
	hardware?: Maybe<Array<TechPackHardware>>;
	trims?: Maybe<Array<TechPackTrim>>;
};

export type TechPackMaterialsInput = {
	fabric?: InputMaybe<TechPackFabricInput>;
	hardware?: InputMaybe<Array<TechPackHardwareInput>>;
	trims?: InputMaybe<Array<TechPackTrimInput>>;
};

export type TechPackMeasurement = {
	__typename?: 'TechPackMeasurement';
	name?: Maybe<Scalars['String']['output']>;
	tolerance?: Maybe<Scalars['String']['output']>;
	value?: Maybe<Scalars['String']['output']>;
};

export type TechPackMeasurementInput = {
	name?: InputMaybe<Scalars['String']['input']>;
	tolerance?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackPackaging = {
	__typename?: 'TechPackPackaging';
	instructions?: Maybe<Array<Scalars['String']['output']>>;
	labeling?: Maybe<Array<Scalars['String']['output']>>;
	materials?: Maybe<Array<Scalars['String']['output']>>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackPackagingInput = {
	instructions?: InputMaybe<Array<Scalars['String']['input']>>;
	labeling?: InputMaybe<Array<Scalars['String']['input']>>;
	materials?: InputMaybe<Array<Scalars['String']['input']>>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackQualityControl = {
	__typename?: 'TechPackQualityControl';
	acceptableDefects?: Maybe<Array<Scalars['String']['output']>>;
	inspectionPoints?: Maybe<Array<Scalars['String']['output']>>;
	testingRequirements?: Maybe<Array<Scalars['String']['output']>>;
};

export type TechPackQualityControlInput = {
	acceptableDefects?: InputMaybe<Array<Scalars['String']['input']>>;
	inspectionPoints?: InputMaybe<Array<Scalars['String']['input']>>;
	testingRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TechPackSeamAllowance = {
	__typename?: 'TechPackSeamAllowance';
	allowance?: Maybe<Scalars['String']['output']>;
	location?: Maybe<Scalars['String']['output']>;
};

export type TechPackSeamAllowanceInput = {
	allowance?: InputMaybe<Scalars['String']['input']>;
	location?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackSize = {
	__typename?: 'TechPackSize';
	measurements?: Maybe<Scalars['JSON']['output']>;
	size?: Maybe<Scalars['String']['output']>;
};

export type TechPackSizeInput = {
	measurements?: InputMaybe<Scalars['JSON']['input']>;
	size?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackStitch = {
	__typename?: 'TechPackStitch';
	location?: Maybe<Scalars['String']['output']>;
	stitchesPerInch?: Maybe<Scalars['Int']['output']>;
	threadColor?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackStitchInput = {
	location?: InputMaybe<Scalars['String']['input']>;
	stitchesPerInch?: InputMaybe<Scalars['Int']['input']>;
	threadColor?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type TechPackTrim = {
	__typename?: 'TechPackTrim';
	code?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	placement?: Maybe<Scalars['String']['output']>;
	supplier?: Maybe<Scalars['String']['output']>;
	type?: Maybe<Scalars['String']['output']>;
};

export type TechPackTrimInput = {
	code?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	placement?: InputMaybe<Scalars['String']['input']>;
	supplier?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<Scalars['String']['input']>;
};

export type ToolCall = {
	__typename?: 'ToolCall';
	arguments?: Maybe<Scalars['JSON']['output']>;
	result?: Maybe<Scalars['JSON']['output']>;
	timestamp: Scalars['DateTime']['output'];
	tool: Scalars['String']['output'];
};

export type TypographyHierarchy = {
	__typename?: 'TypographyHierarchy';
	body?: Maybe<TypographyStyle>;
	caption?: Maybe<TypographyStyle>;
	h1?: Maybe<TypographyStyle>;
	h2?: Maybe<TypographyStyle>;
	h3?: Maybe<TypographyStyle>;
};

export type TypographyHierarchyInput = {
	body?: InputMaybe<TypographyStyleInput>;
	caption?: InputMaybe<TypographyStyleInput>;
	h1?: InputMaybe<TypographyStyleInput>;
	h2?: InputMaybe<TypographyStyleInput>;
	h3?: InputMaybe<TypographyStyleInput>;
};

export type TypographyStyle = {
	__typename?: 'TypographyStyle';
	fontFamily?: Maybe<Scalars['String']['output']>;
	fontSize?: Maybe<Scalars['String']['output']>;
	fontWeight?: Maybe<Scalars['String']['output']>;
	lineHeight?: Maybe<Scalars['String']['output']>;
	usage?: Maybe<Scalars['String']['output']>;
};

export type TypographyStyleInput = {
	fontFamily?: InputMaybe<Scalars['String']['input']>;
	fontSize?: InputMaybe<Scalars['String']['input']>;
	fontWeight?: InputMaybe<Scalars['String']['input']>;
	lineHeight?: InputMaybe<Scalars['String']['input']>;
	usage?: InputMaybe<Scalars['String']['input']>;
};

export type UnmappedProjectProductImage = {
	__typename?: 'UnmappedProjectProductImage';
	fileName: Scalars['String']['output'];
	imageUrl: Scalars['String']['output'];
};

export type UnreadCountUpdate = {
	__typename?: 'UnreadCountUpdate';
	contextId: Scalars['ID']['output'];
	unreadCount: Scalars['Int']['output'];
	userId: Scalars['ID']['output'];
};

export type UpdateAdminAdjustmentV2Input = {
	adjustmentId: Scalars['ID']['input'];
	calculationType: AdjustmentCalculationTypeV2;
	currency: CurrencyEnum;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	offerId: Scalars['ID']['input'];
	type: AdjustmentTypeV2;
	value: Scalars['Float']['input'];
};

export type UpdateAdminInvoiceDraftV2Input = {
	draftId: Scalars['ID']['input'];
	lineItems: Array<AdminInvoiceDraftLineItemInputV2>;
	notes?: InputMaybe<Scalars['String']['input']>;
	poNumber?: InputMaybe<Scalars['String']['input']>;
	recipientEmail?: InputMaybe<Scalars['String']['input']>;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdminUserInput = {
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChatContextTranslationInput = {
	contextId: Scalars['ID']['input'];
	targetLanguages?: InputMaybe<Array<SupportedLanguage>>;
	translationEnabled: Scalars['Boolean']['input'];
};

export type UpdateOfferVariationV2Input = {
	adjustments?: InputMaybe<Array<UpdateVariationAdjustmentV2Input>>;
	attachments?: InputMaybe<Array<QuoteOfferAttachmentV2Input>>;
	description?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name: Scalars['String']['input'];
	quantities: Array<UpdateVariationQuantityV2Input>;
	sample?: InputMaybe<UpdateVariationSampleV2Input>;
};

export type UpdateOrganizationApprovalAndMarginInput = {
	defaultApproval: Scalars['Boolean']['input'];
	defaultMargin: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationIndustryInput = {
	id: Scalars['ID']['input'];
	/** Optional explicit publish flip (admin only). */
	isPublished?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInvoiceMinimumInput = {
	organizationId: Scalars['ID']['input'];
	/** Null clears the override — falls back to default (25,000 DKK). */
	threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrganizationPaymentModeInput = {
	organizationId: Scalars['ID']['input'];
	productPaymentMode: PaymentModeEnum;
	samplePaymentMode: PaymentModeEnum;
};

export type UpdateOrganizationStripeCheckoutLimitInput = {
	organizationId: Scalars['ID']['input'];
	/** Null clears the override — falls back to default (€3,000). */
	threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductOfferV2Input = {
	quoteItemV2Id: Scalars['ID']['input'];
	variations: Array<UpdateOfferVariationV2Input>;
};

export type UpdateQuantityMarginV2Input = {
	marginAmount?: InputMaybe<Scalars['Float']['input']>;
	marginAmountCurrency?: InputMaybe<CurrencyEnum>;
	marginPercentage?: InputMaybe<Scalars['Float']['input']>;
	quantityId: Scalars['ID']['input'];
};

export type UpdateQuoteItemV2Input = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	id: Scalars['ID']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	quantities?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateQuoteItemV2InputItem = {
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	id: Scalars['ID']['input'];
	productId?: InputMaybe<Scalars['ID']['input']>;
	quantities?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateQuoteOfferBatchMarginsV2Input = {
	batchId: Scalars['ID']['input'];
	quantities: Array<UpdateQuantityMarginV2Input>;
};

export type UpdateQuoteOfferBatchV2Input = {
	acceptDeadline?: InputMaybe<Scalars['DateTime']['input']>;
	acceptDeadlineType?: InputMaybe<AcceptDeadlineTypeV2>;
	currency: CurrencyEnum;
	manufacturerId?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	productOffers: Array<UpdateProductOfferV2Input>;
	submitToAdmin?: InputMaybe<Scalars['Boolean']['input']>;
	vetterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateQuoteV2Input = {
	/** Contact persons (organizationUser.id). Pass null to leave unchanged, [] to clear. */
	contactUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	deadline?: InputMaybe<Scalars['DateTime']['input']>;
	deliveryAddress?: InputMaybe<DeliveryAddressV2Input>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	items?: InputMaybe<Array<UpdateQuoteItemV2InputItem>>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	/** Why this quote is being requested. null leaves it unchanged. */
	purpose?: InputMaybe<QuotePurposeV2>;
	/** Free-text detail when purpose=OTHER. null leaves it unchanged. */
	purposeOther?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<QuoteStatusV2>;
};

export type UpdateSampleAdminPriceV2Input = {
	adminCurrency?: InputMaybe<CurrencyEnum>;
	adminPrice: Scalars['Float']['input'];
	sampleId: Scalars['ID']['input'];
};

export type UpdateStudioFileVersionMetadataInput = {
	canvasHeight?: InputMaybe<Scalars['Float']['input']>;
	canvasWidth?: InputMaybe<Scalars['Float']['input']>;
	comment?: InputMaybe<Scalars['String']['input']>;
	height?: InputMaybe<Scalars['Float']['input']>;
	points?: InputMaybe<Array<PolygonPointInput>>;
	type?: InputMaybe<MetadataType>;
	width?: InputMaybe<Scalars['Float']['input']>;
	x?: InputMaybe<Scalars['Float']['input']>;
	y?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudioFileVersionSpecificationInput = {
	capacity?: InputMaybe<SpecificationCapacityInput>;
	colors?: InputMaybe<Array<Scalars['String']['input']>>;
	dimensions?: InputMaybe<SpecificationDimensionsInput>;
	elementName?: InputMaybe<Scalars['String']['input']>;
	elementType?: InputMaybe<Scalars['String']['input']>;
	features?: InputMaybe<Array<Scalars['String']['input']>>;
	finish?: InputMaybe<Scalars['String']['input']>;
	material?: InputMaybe<Scalars['String']['input']>;
	secondaryMaterials?: InputMaybe<Array<Scalars['String']['input']>>;
	textureDescription?: InputMaybe<Scalars['String']['input']>;
	weight?: InputMaybe<SpecificationWeightInput>;
};

export type UpdateStudioFileVersionTechPackInput = {
	additionalNotes?: InputMaybe<Scalars['String']['input']>;
	colorways?: InputMaybe<Array<TechPackColorwayInput>>;
	construction?: InputMaybe<TechPackConstructionInput>;
	dimensions?: InputMaybe<TechPackDimensionsInput>;
	labeling?: InputMaybe<TechPackLabelingInput>;
	materials?: InputMaybe<TechPackMaterialsInput>;
	packaging?: InputMaybe<TechPackPackagingInput>;
	qualityControl?: InputMaybe<TechPackQualityControlInput>;
};

export type UpdateStudioPromptTemplateInput = {
	content?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSystemSettingInput = {
	defaultApproval?: InputMaybe<Scalars['Boolean']['input']>;
	defaultMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVariationAdjustmentV2Input = {
	calculationType: AdjustmentCalculationTypeV2;
	description?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name: Scalars['String']['input'];
	type: AdjustmentTypeV2;
	value: Scalars['Float']['input'];
};

export type UpdateVariationDeliveryV2Input = {
	adminFee?: InputMaybe<Scalars['Float']['input']>;
	basePrice: Scalars['Float']['input'];
	basePriceCurrency?: InputMaybe<CurrencyEnum>;
	deliveryDaysMax: Scalars['Int']['input'];
	deliveryDaysMin: Scalars['Int']['input'];
	id?: InputMaybe<Scalars['ID']['input']>;
	quantity: Scalars['Int']['input'];
	shippingMethod: ShippingMethodV2;
};

export type UpdateVariationQuantityV2Input = {
	baseUnitPrice: Scalars['Float']['input'];
	baseUnitPriceCurrency?: InputMaybe<CurrencyEnum>;
	deliveries: Array<UpdateVariationDeliveryV2Input>;
	id?: InputMaybe<Scalars['ID']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	quantity: Scalars['Int']['input'];
	quoteItemQuantityV2Id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateVariationSampleV2Input = {
	baseSamplePrice: Scalars['Float']['input'];
	baseSamplePriceCurrency?: InputMaybe<CurrencyEnum>;
	baseShippingPrice?: InputMaybe<Scalars['Float']['input']>;
	baseShippingPriceCurrency?: InputMaybe<CurrencyEnum>;
	deliveryDaysMax?: InputMaybe<Scalars['Int']['input']>;
	deliveryDaysMin?: InputMaybe<Scalars['Int']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	maxProductionDays?: InputMaybe<Scalars['Int']['input']>;
	minProductionDays?: InputMaybe<Scalars['Int']['input']>;
	notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVetterEntityInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVetterUserInput = {
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UploadUrlResponse = {
	__typename?: 'UploadUrlResponse';
	errors?: Maybe<Array<ResponseError>>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success?: Maybe<Scalars['Boolean']['output']>;
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
	birthday?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<FileInput>;
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
};

export type UserPreferences = {
	__typename?: 'UserPreferences';
	preferredLanguage?: Maybe<SupportedLanguage>;
	userId: Scalars['ID']['output'];
};

export enum UserType {
	Admin = 'admin',
	Organization = 'organization',
	Vetter = 'vetter',
}

export type VatAddress = {
	__typename?: 'VATAddress';
	city?: Maybe<Scalars['String']['output']>;
	country: Scalars['String']['output'];
	street?: Maybe<Scalars['String']['output']>;
	zipcode?: Maybe<Scalars['String']['output']>;
};

export type VatCompanyInfo = {
	__typename?: 'VATCompanyInfo';
	active?: Maybe<Scalars['Boolean']['output']>;
	address?: Maybe<VatAddress>;
	name?: Maybe<Scalars['String']['output']>;
	vat: Scalars['String']['output'];
};

export type VatValidationResult = {
	__typename?: 'VATValidationResult';
	companyInfo?: Maybe<VatCompanyInfo>;
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type ValidationResult = {
	__typename?: 'ValidationResult';
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type VerifyAuthenticatorMfaInput = {
	isBackupCode?: InputMaybe<Scalars['Boolean']['input']>;
	/** See VerifyEmailMfaInput.rememberMe. */
	rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
	token: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyAuthenticatorSetupInput = {
	/** See VerifyEmailMfaInput.rememberMe. */
	rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
	token: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyEmailMfaInput = {
	code: Scalars['String']['input'];
	/**
	 * If true, "remember this device for 30 days" was checked. The refresh
	 * token created downstream by loginValidate gets a 30-day trust window
	 * anchored at this MFA verification; subsequent refreshes inherit the
	 * same expiry rather than extending it. Default false → 1-day window.
	 */
	rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
	userId: Scalars['ID']['input'];
};

export type VetterActiveActivities = {
	__typename?: 'VetterActiveActivities';
	activities: Array<VetterActivity>;
};

export type VetterActivity = VetterChatActivity | VetterQuoteActivity | VetterQuoteOfferActivity;

export enum VetterActivityType {
	AssignedQuote = 'ASSIGNED_QUOTE',
	AssignedQuoteOffer = 'ASSIGNED_QUOTE_OFFER',
	UnreadChatMessage = 'UNREAD_CHAT_MESSAGE',
}

export type VetterChatActivity = {
	__typename?: 'VetterChatActivity';
	context?: Maybe<ChatContext>;
	contextId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
	lastMessageAt: Scalars['DateTime']['output'];
	type: VetterActivityType;
	unreadCount: Scalars['Int']['output'];
};

export type VetterEntity = Base & {
	__typename?: 'VetterEntity';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	manufacturers: Array<Manufacturer>;
	name: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	vetterUsers?: Maybe<Array<VetterUser>>;
};

export type VetterEntityPage = {
	__typename?: 'VetterEntityPage';
	data: Array<VetterEntity>;
	pageInfo: PageInfo;
};

export type VetterQuoteActivity = {
	__typename?: 'VetterQuoteActivity';
	id: Scalars['ID']['output'];
	quote?: Maybe<QuoteV2>;
	quoteId: Scalars['ID']['output'];
	type: VetterActivityType;
};

export type VetterQuoteOfferActivity = {
	__typename?: 'VetterQuoteOfferActivity';
	id: Scalars['ID']['output'];
	quoteOffer?: Maybe<QuoteOfferV2>;
	quoteOfferId: Scalars['ID']['output'];
	type: VetterActivityType;
};

export type VetterUser = Base & {
	__typename?: 'VetterUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
	vetterEntity?: Maybe<VetterEntity>;
	vetterEntityId: Scalars['ID']['output'];
};

export type VetterUserPage = {
	__typename?: 'VetterUserPage';
	data: Array<VetterUser>;
	pageInfo: PageInfo;
};

export type AuthorizationPermissionFragmentFragment = {
	__typename?: 'AuthorizationPermission';
	id: string;
	resource?: string | null;
	action?: AuthorizationPermissionAction | null;
	description?: string | null;
	createdAt?: string | null;
	updatedAt?: string | null;
};

export type AuthorizationRoleFragmentFragment = {
	__typename?: 'AuthorizationRole';
	id: string;
	name: string;
	description?: string | null;
	scope: string;
	createdAt?: string | null;
	updatedAt?: string | null;
	authorizationRolePermissions?: Array<{
		__typename?: 'AuthorizationRolePermission';
		id: string;
		authorizationPermission?: {
			__typename?: 'AuthorizationPermission';
			id: string;
			resource?: string | null;
			action?: AuthorizationPermissionAction | null;
			description?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		} | null;
	}> | null;
};

export type AuthorizationUserRoleFragmentFragment = {
	__typename?: 'AuthorizationUserRole';
	id: string;
	userId: string;
	authorizationRoleId: string;
	createdAt?: string | null;
	updatedAt?: string | null;
	authorizationRole?: {
		__typename?: 'AuthorizationRole';
		id: string;
		name: string;
		description?: string | null;
		scope: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		authorizationRolePermissions?: Array<{
			__typename?: 'AuthorizationRolePermission';
			id: string;
			authorizationPermission?: {
				__typename?: 'AuthorizationPermission';
				id: string;
				resource?: string | null;
				action?: AuthorizationPermissionAction | null;
				description?: string | null;
				createdAt?: string | null;
				updatedAt?: string | null;
			} | null;
		}> | null;
	} | null;
};

export type PageInfoFragmentFragment = {
	__typename?: 'PageInfo';
	totalPages: number;
	currentPage: number;
	totalCount: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
};

export type ResponseErrorFragmentFragment = {
	__typename?: 'ResponseError';
	message: string;
	code?: string | null;
	field?: string | null;
	details?: string | null;
};

export type MessageResponseFragmentFragment = {
	__typename?: 'MessageResponse';
	success: boolean;
	message: string;
	referenceKey?: string | null;
	errors?: Array<{
		__typename?: 'ResponseError';
		message: string;
		code?: string | null;
		field?: string | null;
		details?: string | null;
	}> | null;
};

export type DeliveryAddressV2FragmentFragment = {
	__typename?: 'DeliveryAddressV2';
	addressLine1?: string | null;
	addressLine2?: string | null;
	city?: string | null;
	stateCode?: string | null;
	postalCode?: string | null;
	countryCode?: string | null;
};

export type ProductBasicFragmentFragment = {
	__typename?: 'Product';
	id: string;
	name: string;
	sku: string;
	weight?: number | null;
	dimensions?: {
		__typename?: 'ProductDimensions';
		length?: number | null;
		width?: number | null;
		height?: number | null;
		unit: string;
	} | null;
	images?: Array<{
		__typename?: 'ProductImage';
		id: string;
		url?: string | null;
		name: string;
		mimeType: string;
	}> | null;
};

export type ProductQuoteFragmentFragment = {
	__typename?: 'Product';
	description?: string | null;
	id: string;
	name: string;
	sku: string;
	weight?: number | null;
	brand?: { __typename?: 'Brand'; id: string; name: string } | null;
	dimensions?: {
		__typename?: 'ProductDimensions';
		length?: number | null;
		width?: number | null;
		height?: number | null;
		unit: string;
	} | null;
	images?: Array<{
		__typename?: 'ProductImage';
		id: string;
		url?: string | null;
		name: string;
		mimeType: string;
	}> | null;
};

export type CreateAdminInvoiceDraftV2MutationVariables = Exact<{
	input: CreateAdminInvoiceDraftV2Input;
}>;

export type CreateAdminInvoiceDraftV2Mutation = {
	__typename?: 'Mutation';
	createAdminInvoiceDraftV2: {
		__typename?: 'CreateAdminInvoiceDraftV2Response';
		success: boolean;
		error?: string | null;
		draft?: {
			__typename?: 'AdminInvoiceDraftV2';
			id: string;
			status: AdminInvoiceDraftStatus;
			economicDraftInvoiceNumber?: number | null;
			economicBookedInvoiceNumber?: number | null;
			bookedAt?: string | null;
			lineItems: any;
		} | null;
	};
};

export type UpdateAdminInvoiceDraftV2MutationVariables = Exact<{
	input: UpdateAdminInvoiceDraftV2Input;
}>;

export type UpdateAdminInvoiceDraftV2Mutation = {
	__typename?: 'Mutation';
	updateAdminInvoiceDraftV2: {
		__typename?: 'CreateAdminInvoiceDraftV2Response';
		success: boolean;
		error?: string | null;
		draft?: {
			__typename?: 'AdminInvoiceDraftV2';
			id: string;
			status: AdminInvoiceDraftStatus;
			economicDraftInvoiceNumber?: number | null;
			lineItems: any;
		} | null;
	};
};

export type BookAdminInvoiceDraftV2MutationVariables = Exact<{
	draftId: Scalars['ID']['input'];
}>;

export type BookAdminInvoiceDraftV2Mutation = {
	__typename?: 'Mutation';
	bookAdminInvoiceDraftV2: {
		__typename?: 'BookAdminInvoiceDraftV2Response';
		success: boolean;
		error?: string | null;
		draft?: {
			__typename?: 'AdminInvoiceDraftV2';
			id: string;
			status: AdminInvoiceDraftStatus;
			economicBookedInvoiceNumber?: number | null;
			bookedAt?: string | null;
		} | null;
	};
};

export type CancelAdminInvoiceDraftV2MutationVariables = Exact<{
	draftId: Scalars['ID']['input'];
}>;

export type CancelAdminInvoiceDraftV2Mutation = {
	__typename?: 'Mutation';
	cancelAdminInvoiceDraftV2: {
		__typename?: 'CancelAdminInvoiceDraftV2Response';
		success: boolean;
		error?: string | null;
		creditNoteInvoiceNumber?: number | null;
	};
};

export type CreateAdminUserMutationVariables = Exact<{
	input: CreateAdminUserInput;
}>;

export type CreateAdminUserMutation = {
	__typename?: 'Mutation';
	createAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateAdminUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateAdminUserInput;
}>;

export type UpdateAdminUserMutation = {
	__typename?: 'Mutation';
	updateAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteAdminUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteAdminUserMutation = {
	__typename?: 'Mutation';
	deleteAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyAdminUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyAdminUserMutation = {
	__typename?: 'Mutation';
	deleteManyAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type LoginMutationVariables = Exact<{
	input: LoginInput;
}>;

export type LoginMutation = {
	__typename?: 'Mutation';
	login: {
		__typename?: 'LoginResponse';
		token: string;
		userId: string;
		mfaRequired: boolean;
		mfaMethod?: MfaMethodEnum | null;
		role: AuthRoleEnum;
		supportsBackupCodes: boolean;
	};
};

export type LoginValidateMutationVariables = Exact<{
	input: LoginValidateInput;
}>;

export type LoginValidateMutation = {
	__typename?: 'Mutation';
	loginValidate: {
		__typename?: 'LoginValidateResponse';
		token: string;
		user: {
			__typename?: 'AuthenticationUser';
			id: string;
			role: AuthRoleEnum;
			language: string;
			email?: string | null;
			vetterUser?: {
				__typename?: 'VetterUser';
				vetterEntityId: string;
				firstName: string;
				lastName: string;
			} | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				organizationId: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					onboarded: boolean;
					organizationSetting?: {
						__typename?: 'OrganizationSetting';
						timezone: string;
						currency?: CurrencyEnum | null;
						measurementSystem: MeasurementSystemEnum;
					} | null;
				} | null;
			} | null;
		};
	};
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = {
	__typename?: 'Mutation';
	refreshToken: {
		__typename?: 'LoginValidateResponse';
		token: string;
		user: {
			__typename?: 'AuthenticationUser';
			id: string;
			role: AuthRoleEnum;
			language: string;
			email?: string | null;
			vetterUser?: {
				__typename?: 'VetterUser';
				vetterEntityId: string;
				firstName: string;
				lastName: string;
			} | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				organizationId: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					onboarded: boolean;
					organizationSetting?: {
						__typename?: 'OrganizationSetting';
						timezone: string;
						currency?: CurrencyEnum | null;
						measurementSystem: MeasurementSystemEnum;
					} | null;
				} | null;
			} | null;
		};
	};
};

export type ValidateAuthenticationTokenMutationVariables = Exact<{
	token: Scalars['String']['input'];
}>;

export type ValidateAuthenticationTokenMutation = {
	__typename?: 'Mutation';
	validateAuthenticationToken: {
		__typename?: 'AuthenticationToken';
		token: string;
		user?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
	};
};

export type RegisterMutationVariables = Exact<{
	input: RegisterInput;
}>;

export type RegisterMutation = {
	__typename?: 'Mutation';
	register: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type UnlockAuthenticationUserMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type UnlockAuthenticationUserMutation = {
	__typename?: 'Mutation';
	unlockAuthenticationUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type PasswordResetRequestMutationVariables = Exact<{
	input: PasswordResetRequestInput;
}>;

export type PasswordResetRequestMutation = {
	__typename?: 'Mutation';
	passwordResetRequest: string;
};

export type PasswordResetValidateMutationVariables = Exact<{
	input: PasswordResetValidateInput;
}>;

export type PasswordResetValidateMutation = {
	__typename?: 'Mutation';
	passwordResetValidate: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type PasswordResetMutationVariables = Exact<{
	input: PasswordResetInput;
}>;

export type PasswordResetMutation = {
	__typename?: 'Mutation';
	passwordReset: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type ResendPasswordResetRequestMutationVariables = Exact<{
	input: PasswordResetRequestInput;
}>;

export type ResendPasswordResetRequestMutation = {
	__typename?: 'Mutation';
	resendPasswordResetRequest: string;
};

export type VerifyAuthenticatorSetupMutationVariables = Exact<{
	input: VerifyAuthenticatorSetupInput;
}>;

export type VerifyAuthenticatorSetupMutation = {
	__typename?: 'Mutation';
	verifyAuthenticatorSetup: {
		__typename?: 'LoginResponse';
		token: string;
		userId: string;
		role: AuthRoleEnum;
		backupCodes?: Array<string> | null;
	};
};

export type VerifyEmailMfaMutationVariables = Exact<{
	input: VerifyEmailMfaInput;
}>;

export type VerifyEmailMfaMutation = {
	__typename?: 'Mutation';
	verifyEmailMfa: { __typename?: 'LoginResponse'; token: string; role: AuthRoleEnum };
};

export type ResendEmailMfaCodeMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type ResendEmailMfaCodeMutation = {
	__typename?: 'Mutation';
	resendEmailMfaCode: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type VerifyAuthenticatorMfaMutationVariables = Exact<{
	input: VerifyAuthenticatorMfaInput;
}>;

export type VerifyAuthenticatorMfaMutation = {
	__typename?: 'Mutation';
	verifyAuthenticatorMfa: { __typename?: 'LoginResponse'; token: string; role: AuthRoleEnum };
};

export type LogoutMutationVariables = Exact<{
	input: LogoutInput;
}>;

export type LogoutMutation = {
	__typename?: 'Mutation';
	logout: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateOrganizationSignupMutationVariables = Exact<{
	input: OrganizationSignupInput;
}>;

export type CreateOrganizationSignupMutation = {
	__typename?: 'Mutation';
	createOrganizationSignup: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type CreateAuthorizationRoleMutationVariables = Exact<{
	input: AuthorizationRoleCreateInput;
}>;

export type CreateAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	createAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateAuthorizationRoleMutationVariables = Exact<{
	input: AuthorizationRoleUpdateInput;
}>;

export type UpdateAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	updateAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteAuthorizationRoleMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	deleteAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyAuthorizationRoleMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	deleteManyAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateManyAuthorizationUserRoleMutationVariables = Exact<{
	input: CreateManyAuthorizationUserRoleInput;
}>;

export type CreateManyAuthorizationUserRoleMutation = {
	__typename?: 'Mutation';
	createManyAuthorizationUserRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyAuthorizationUserRoleMutationVariables = Exact<{
	input: DeleteManyAuthorizationUserRoleInput;
}>;

export type DeleteManyAuthorizationUserRoleMutation = {
	__typename?: 'Mutation';
	deleteManyAuthorizationUserRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AssignPermissionsToRoleMutationVariables = Exact<{
	input: AssignPermissionsToRoleInput;
}>;

export type AssignPermissionsToRoleMutation = {
	__typename?: 'Mutation';
	assignPermissionsToRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemovePermissionsFromRoleMutationVariables = Exact<{
	input: RemovePermissionsFromRoleInput;
}>;

export type RemovePermissionsFromRoleMutation = {
	__typename?: 'Mutation';
	removePermissionsFromRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateBrandMutationVariables = Exact<{
	input: BrandCreateInput;
}>;

export type CreateBrandMutation = {
	__typename?: 'Mutation';
	createBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateBrandMutationVariables = Exact<{
	input: BrandUpdateInput;
}>;

export type UpdateBrandMutation = {
	__typename?: 'Mutation';
	updateBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteBrandMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteBrandMutation = {
	__typename?: 'Mutation';
	deleteBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyBrandsMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyBrandsMutation = {
	__typename?: 'Mutation';
	deleteManyBrand: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateBrandFontUploadUrlMutationVariables = Exact<{
	input: FontFileUploadInput;
}>;

export type GenerateBrandFontUploadUrlMutation = {
	__typename?: 'Mutation';
	generateBrandFontUploadUrl: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		blobUrl?: string | null;
		fileId?: string | null;
		expiresAt: string;
		errors: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}>;
	};
};

export type GenerateBrandFileUploadUrlMutationVariables = Exact<{
	input: BrandFileUploadInput;
}>;

export type GenerateBrandFileUploadUrlMutation = {
	__typename?: 'Mutation';
	generateBrandFileUploadUrl: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		blobUrl?: string | null;
		fileId?: string | null;
		expiresAt: string;
		errors: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}>;
	};
};

export type ConfirmBrandFileUploadMutationVariables = Exact<{
	input: ConfirmBrandFileUploadInput;
}>;

export type ConfirmBrandFileUploadMutation = {
	__typename?: 'Mutation';
	confirmBrandFileUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type ConfirmBrandFontUploadMutationVariables = Exact<{
	input: ConfirmBrandFontUploadInput;
}>;

export type ConfirmBrandFontUploadMutation = {
	__typename?: 'Mutation';
	confirmBrandFontUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteBrandFileMutationVariables = Exact<{
	brandId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
}>;

export type DeleteBrandFileMutation = {
	__typename?: 'Mutation';
	deleteBrandFile: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteBrandFontMutationVariables = Exact<{
	brandId: Scalars['ID']['input'];
	fontId: Scalars['ID']['input'];
}>;

export type DeleteBrandFontMutation = {
	__typename?: 'Mutation';
	deleteBrandFont: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CategorizeBulkProductImagesMutationVariables = Exact<{
	input: CategorizeBulkProductImagesInput;
}>;

export type CategorizeBulkProductImagesMutation = {
	__typename?: 'Mutation';
	categorizeBulkProductImages: {
		__typename?: 'CategorizeBulkProductImagesResponse';
		success: boolean;
		message: string;
		totalImages: number;
		categorizedImages: number;
		products: Array<{
			__typename?: 'CategorizedProduct';
			productName: string;
			imageUrls: Array<string>;
		}>;
		unmappedImages: Array<{
			__typename?: 'UnmappedProjectProductImage';
			imageUrl: string;
			fileName: string;
		}>;
	};
};

export type CreateChatContextMutationVariables = Exact<{
	input: CreateChatContextInput;
}>;

export type CreateChatContextMutation = {
	__typename?: 'Mutation';
	createChatContext: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type SendContextMessageMutationVariables = Exact<{
	input: SendContextMessageInput;
}>;

export type SendContextMessageMutation = {
	__typename?: 'Mutation';
	sendContextMessage: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type MarkMessagesAsReadMutationVariables = Exact<{
	input: MarkContextMessagesAsReadInput;
}>;

export type MarkMessagesAsReadMutation = {
	__typename?: 'Mutation';
	markContextMessagesAsRead: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type GenerateChatFileUploadUrlMutationVariables = Exact<{
	input: ChatFileUploadInput;
}>;

export type GenerateChatFileUploadUrlMutation = {
	__typename?: 'Mutation';
	generateChatFileUploadUrl: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		uploadUrl: string;
		fileId?: string | null;
		blobUrl?: string | null;
		expiresAt: string;
	};
};

export type ConfirmChatFileUploadMutationVariables = Exact<{
	input: ConfirmChatFileUploadInput;
}>;

export type ConfirmChatFileUploadMutation = {
	__typename?: 'Mutation';
	confirmChatFileUpload: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteChatFileMutationVariables = Exact<{
	contextId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
}>;

export type DeleteChatFileMutation = {
	__typename?: 'Mutation';
	deleteChatFile: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type UpdateChatContextTranslationMutationVariables = Exact<{
	input: UpdateChatContextTranslationInput;
}>;

export type UpdateChatContextTranslationMutation = {
	__typename?: 'Mutation';
	updateChatContextTranslation: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrganizationProductInterestMutationVariables = Exact<{
	input: OrganizationProductInterestCreateInput;
}>;

export type CreateOrganizationProductInterestMutation = {
	__typename?: 'Mutation';
	createOrganizationProductInterest: {
		__typename?: 'OrganizationProductInterest';
		id: string;
		organizationId: string;
		productTagId: string;
	};
};

export type DeleteOrganizationProductInterestMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationProductInterestMutation = {
	__typename?: 'Mutation';
	deleteOrganizationProductInterest: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrganizationSourcingPreferenceConnectionMutationVariables = Exact<{
	input: OrganizationSourcingPreferenceConnectionCreateInput;
}>;

export type CreateOrganizationSourcingPreferenceConnectionMutation = {
	__typename?: 'Mutation';
	createOrganizationSourcingPreferenceConnection: {
		__typename?: 'OrganizationSourcingPreferenceConnection';
		id: string;
		organizationId: string;
		organizationSourcingPreferenceId: string;
		priority?: number | null;
		notes?: string | null;
		organizationSourcingPreference?: {
			__typename?: 'OrganizationSourcingPreference';
			id: string;
			name: string;
			description?: string | null;
		} | null;
	};
};

export type UpdateOrganizationSourcingPreferenceConnectionMutationVariables = Exact<{
	input: OrganizationSourcingPreferenceConnectionUpdateInput;
}>;

export type UpdateOrganizationSourcingPreferenceConnectionMutation = {
	__typename?: 'Mutation';
	updateOrganizationSourcingPreferenceConnection: {
		__typename?: 'OrganizationSourcingPreferenceConnection';
		id: string;
		organizationId: string;
		organizationSourcingPreferenceId: string;
		priority?: number | null;
		notes?: string | null;
		organizationSourcingPreference?: {
			__typename?: 'OrganizationSourcingPreference';
			id: string;
			name: string;
			description?: string | null;
		} | null;
	};
};

export type DeleteOrganizationSourcingPreferenceConnectionMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationSourcingPreferenceConnectionMutation = {
	__typename?: 'Mutation';
	deleteOrganizationSourcingPreferenceConnection: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrganizationComplianceConnectionMutationVariables = Exact<{
	input: OrganizationComplianceConnectionCreateInput;
}>;

export type CreateOrganizationComplianceConnectionMutation = {
	__typename?: 'Mutation';
	createOrganizationComplianceConnection: {
		__typename?: 'OrganizationComplianceConnection';
		id: string;
		organizationId: string;
		organizationComplianceId: string;
		certificationNumber?: string | null;
		certifyingBody?: string | null;
		issueDate?: string | null;
		expiryDate?: string | null;
		organizationCompliance?: {
			__typename?: 'OrganizationCompliance';
			id: string;
			name: string;
			description?: string | null;
		} | null;
	};
};

export type UpdateOrganizationComplianceConnectionMutationVariables = Exact<{
	input: OrganizationComplianceConnectionUpdateInput;
}>;

export type UpdateOrganizationComplianceConnectionMutation = {
	__typename?: 'Mutation';
	updateOrganizationComplianceConnection: {
		__typename?: 'OrganizationComplianceConnection';
		id: string;
		organizationId: string;
		organizationComplianceId: string;
		certificationNumber?: string | null;
		certifyingBody?: string | null;
		issueDate?: string | null;
		expiryDate?: string | null;
		organizationCompliance?: {
			__typename?: 'OrganizationCompliance';
			id: string;
			name: string;
			description?: string | null;
		} | null;
	};
};

export type DeleteOrganizationComplianceConnectionMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationComplianceConnectionMutation = {
	__typename?: 'Mutation';
	deleteOrganizationComplianceConnection: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateProductVariantFromStudioFileMutationVariables = Exact<{
	input: CreateProductVariantFromStudioInput;
}>;

export type CreateProductVariantFromStudioFileMutation = {
	__typename?: 'Mutation';
	createProductVariantFromStudioFile: {
		__typename?: 'CreateProductVariantFromStudioResponse';
		success: boolean;
		message?: string | null;
		productId?: string | null;
	};
};

export type CreateProjectMutationVariables = Exact<{
	input: CreateProjectInput;
}>;

export type CreateProjectMutation = {
	__typename?: 'Mutation';
	createProject: {
		__typename?: 'CreateProjectResponse';
		success: boolean;
		message: string;
		project?: {
			__typename?: 'Project';
			id: string;
			name: string;
			description?: string | null;
			startDate?: string | null;
			endDate?: string | null;
		} | null;
	};
};

export type CreateProjectProductMutationVariables = Exact<{
	input: CreateProjectProductInput;
}>;

export type CreateProjectProductMutation = {
	__typename?: 'Mutation';
	createProjectProduct: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		errors?: Array<{
			__typename?: 'ResponseError';
			field?: string | null;
			message: string;
		}> | null;
	};
};

export type CreateBulkProjectProductsMutationVariables = Exact<{
	input: CreateBulkProjectProductsInput;
}>;

export type CreateBulkProjectProductsMutation = {
	__typename?: 'Mutation';
	createBulkProjectProducts: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		errors?: Array<{
			__typename?: 'ResponseError';
			field?: string | null;
			message: string;
		}> | null;
	};
};

export type DeleteManyProjectsMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyProjectsMutation = {
	__typename?: 'Mutation';
	deleteManyProject: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteProjectMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProjectMutation = {
	__typename?: 'Mutation';
	deleteProject: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteProjectProductMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProjectProductMutation = {
	__typename?: 'Mutation';
	deleteProjectProduct: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type RequestEarlyAccessMutationVariables = Exact<{
	input: RequestEarlyAccessInput;
}>;

export type RequestEarlyAccessMutation = {
	__typename?: 'Mutation';
	requestEarlyAccess: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type ApproveEarlyAccessRequestMutationVariables = Exact<{
	requestId: Scalars['ID']['input'];
}>;

export type ApproveEarlyAccessRequestMutation = {
	__typename?: 'Mutation';
	approveEarlyAccessRequest: {
		__typename?: 'ApproveEarlyAccessResponse';
		inviteToken: string;
		message: string;
	};
};

export type RejectEarlyAccessRequestMutationVariables = Exact<{
	requestId: Scalars['ID']['input'];
}>;

export type RejectEarlyAccessRequestMutation = {
	__typename?: 'Mutation';
	rejectEarlyAccessRequest: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GenerateProjectProductImageUploadUrlsMutationVariables = Exact<{
	input: GenerateProjectProductImageUploadUrlsInput;
}>;

export type GenerateProjectProductImageUploadUrlsMutation = {
	__typename?: 'Mutation';
	generateProjectProductImageUploadUrls: {
		__typename?: 'GenerateProjectProductImageUploadUrlsResponse';
		urls: Array<{
			__typename?: 'ImageUploadUrl';
			imageId: string;
			fileName: string;
			uploadUrl: string;
			blobUrl: string;
			expiresAt: string;
		}>;
	};
};

export type CreateManufacturerMutationVariables = Exact<{
	input: ManufacturerCreateInput;
}>;

export type CreateManufacturerMutation = {
	__typename?: 'Mutation';
	createManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateManufacturerMutationVariables = Exact<{
	input: ManufacturerUpdateInput;
}>;

export type UpdateManufacturerMutation = {
	__typename?: 'Mutation';
	updateManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManufacturerMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteManufacturerMutation = {
	__typename?: 'Mutation';
	deleteManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyManufacturersMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyManufacturersMutation = {
	__typename?: 'Mutation';
	deleteManyManufacturer: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateOrganizationMutationVariables = Exact<{
	input: OrganizationCreateInput;
}>;

export type CreateOrganizationMutation = {
	__typename?: 'Mutation';
	createOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrganizationUserMutationVariables = Exact<{
	input: OrganizationUserCreateInput;
}>;

export type CreateOrganizationUserMutation = {
	__typename?: 'Mutation';
	createOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationUserMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteOrganizationUserMutation = {
	__typename?: 'Mutation';
	deleteOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyOrganizationUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyOrganizationUserMutation = {
	__typename?: 'Mutation';
	deleteManyOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationSettingMutationVariables = Exact<{
	input: OrganizationSettingUpdateInput;
}>;

export type UpdateOrganizationSettingMutation = {
	__typename?: 'Mutation';
	updateOrganizationSetting: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationMutationVariables = Exact<{
	input: OrganizationUpdateInput;
}>;

export type UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteMyOrganizationMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMyOrganizationMutation = {
	__typename?: 'Mutation';
	deleteMyOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteOrganizationMutation = {
	__typename?: 'Mutation';
	deleteOrganization?: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type DeleteManyOrganizationMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyOrganizationMutation = {
	__typename?: 'Mutation';
	deleteManyOrganization?: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type UpdateOrganizationStripeCheckoutLimitMutationVariables = Exact<{
	input: UpdateOrganizationStripeCheckoutLimitInput;
}>;

export type UpdateOrganizationStripeCheckoutLimitMutation = {
	__typename?: 'Mutation';
	updateOrganizationStripeCheckoutLimit: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationInvoiceMinimumMutationVariables = Exact<{
	input: UpdateOrganizationInvoiceMinimumInput;
}>;

export type UpdateOrganizationInvoiceMinimumMutation = {
	__typename?: 'Mutation';
	updateOrganizationInvoiceMinimum: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationPaymentModeMutationVariables = Exact<{
	input: UpdateOrganizationPaymentModeInput;
}>;

export type UpdateOrganizationPaymentModeMutation = {
	__typename?: 'Mutation';
	updateOrganizationPaymentMode: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationApprovalAndMarginMutationVariables = Exact<{
	input: UpdateOrganizationApprovalAndMarginInput;
}>;

export type UpdateOrganizationApprovalAndMarginMutation = {
	__typename?: 'Mutation';
	updateOrganizationApprovalAndMargin: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrganizationAddressMutationVariables = Exact<{
	organizationId: Scalars['ID']['input'];
	input: OrganizationAddressInput;
}>;

export type CreateOrganizationAddressMutation = {
	__typename?: 'Mutation';
	createOrganizationAddress: {
		__typename?: 'OrganizationAddress';
		id: string;
		addressLine1: string;
		addressLine2?: string | null;
		addressType: AddressType;
		city: string;
		countryCode: string;
		postalCode: string;
		stateCode?: string | null;
		isPrimary: boolean;
		name?: string | null;
		googlePlaceId?: string | null;
		latitude?: number | null;
		longitude?: number | null;
	};
};

export type UpdateOrganizationAddressMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: OrganizationAddressInput;
}>;

export type UpdateOrganizationAddressMutation = {
	__typename?: 'Mutation';
	updateOrganizationAddress: {
		__typename?: 'OrganizationAddress';
		id: string;
		addressLine1: string;
		addressLine2?: string | null;
		addressType: AddressType;
		city: string;
		countryCode: string;
		postalCode: string;
		stateCode?: string | null;
		isPrimary: boolean;
		name?: string | null;
		googlePlaceId?: string | null;
		latitude?: number | null;
		longitude?: number | null;
	};
};

export type DeleteOrganizationAddressMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationAddressMutation = {
	__typename?: 'Mutation';
	deleteOrganizationAddress: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrganizationIndustryMutationVariables = Exact<{
	input: CreateOrganizationIndustryInput;
}>;

export type CreateOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	createOrganizationIndustry: {
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
		createdByOrganizationId?: string | null;
	};
};

export type PublishOrganizationIndustryMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type PublishOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	publishOrganizationIndustry: {
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
	};
};

export type UpdateOrganizationIndustryMutationVariables = Exact<{
	input: UpdateOrganizationIndustryInput;
}>;

export type UpdateOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	updateOrganizationIndustry: {
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
	};
};

export type DeleteOrganizationIndustryMutationVariables = Exact<{
	input: DeleteOrganizationIndustryInput;
}>;

export type DeleteOrganizationIndustryMutation = {
	__typename?: 'Mutation';
	deleteOrganizationIndustry: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrganizationOnboardingMutationVariables = Exact<{
	input: OrganizationOnboardingInput;
}>;

export type CreateOrganizationOnboardingMutation = {
	__typename?: 'Mutation';
	createOrganizationOnboarding: {
		__typename?: 'OrganizationOnboardingResponse';
		success: boolean;
		message: string;
		organizationId: string;
		productInterests: Array<{
			__typename?: 'OrganizationProductInterest';
			id: string;
			productTagId: string;
		}>;
		sourcingPreferenceConnections: Array<{
			__typename?: 'OrganizationSourcingPreferenceConnection';
			id: string;
			organizationSourcingPreferenceId: string;
			organizationSourcingPreference?: {
				__typename?: 'OrganizationSourcingPreference';
				id: string;
				name: string;
			} | null;
		}>;
		complianceConnections: Array<{
			__typename?: 'OrganizationComplianceConnection';
			id: string;
			organizationComplianceId: string;
			organizationCompliance?: {
				__typename?: 'OrganizationCompliance';
				id: string;
				name: string;
			} | null;
		}>;
	};
};

export type GenerateOrganizationUserAvatarUploadUrlMutationVariables = Exact<{
	input: GenerateUploadUrlInput;
}>;

export type GenerateOrganizationUserAvatarUploadUrlMutation = {
	__typename?: 'Mutation';
	generateOrganizationUserAvatarUploadUrl: {
		__typename?: 'UploadUrlResponse';
		success?: boolean | null;
		message?: string | null;
		uploadUrl?: string | null;
		expiresAt?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationUserAvatarMutationVariables = Exact<{
	input: OrganizationUserUpdateInput;
}>;

export type UpdateOrganizationUserAvatarMutation = {
	__typename?: 'Mutation';
	updateOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type CreateProductMutationVariables = Exact<{
	input: ProductCreateInput;
}>;

export type CreateProductMutation = {
	__typename?: 'Mutation';
	createProduct: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type UpdateProductMutationVariables = Exact<{
	input: ProductUpdateInput;
}>;

export type UpdateProductMutation = {
	__typename?: 'Mutation';
	updateProduct: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GenerateProductImageUploadUrlMutationVariables = Exact<{
	input: ProductImageUploadInput;
}>;

export type GenerateProductImageUploadUrlMutation = {
	__typename?: 'Mutation';
	generateProductImageUploadUrl: {
		__typename?: 'ImageUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		imageId?: string | null;
		blobUrl?: string | null;
		expiresAt: string;
	};
};

export type ConfirmProductImageUploadMutationVariables = Exact<{
	input: ConfirmProductImageUploadInput;
}>;

export type ConfirmProductImageUploadMutation = {
	__typename?: 'Mutation';
	confirmProductImageUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type DeleteProductImageMutationVariables = Exact<{
	productId: Scalars['ID']['input'];
	imageId: Scalars['ID']['input'];
}>;

export type DeleteProductImageMutation = {
	__typename?: 'Mutation';
	deleteProductImage: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateProductImagePrimaryMutationVariables = Exact<{
	productId: Scalars['ID']['input'];
	imageId: Scalars['ID']['input'];
}>;

export type UpdateProductImagePrimaryMutation = {
	__typename?: 'Mutation';
	updateProductImagePrimary: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type DeleteProductMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProductMutation = {
	__typename?: 'Mutation';
	deleteProduct: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type AssignProductToOrganizationMutationVariables = Exact<{
	productId: Scalars['ID']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AssignProductToOrganizationMutation = {
	__typename?: 'Mutation';
	assignProductToOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CompleteRecommendationMutationVariables = Exact<{
	input: CompleteRecommendationInput;
}>;

export type CompleteRecommendationMutation = {
	__typename?: 'Mutation';
	completeRecommendation: {
		__typename?: 'CompleteRecommendationResponse';
		success: boolean;
		message?: string | null;
		productId?: string | null;
		studioFileId?: string | null;
	};
};

export type GenerateBulkProductImageUploadUrlsMutationVariables = Exact<{
	input: GenerateBulkProductImageUploadUrlsInput;
}>;

export type GenerateBulkProductImageUploadUrlsMutation = {
	__typename?: 'Mutation';
	generateBulkProductImageUploadUrls: {
		__typename?: 'GenerateBulkProductImageUploadUrlsResponse';
		urls: Array<{
			__typename?: 'BulkImageUploadUrl';
			imageId: string;
			fileName: string;
			uploadUrl: string;
			blobUrl: string;
			expiresAt: string;
		}>;
	};
};

export type CreateBulkProductsMutationVariables = Exact<{
	input: CreateBulkProductsInput;
}>;

export type CreateBulkProductsMutation = {
	__typename?: 'Mutation';
	createBulkProducts: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateQuoteOfferBatchV2MutationVariables = Exact<{
	input: CreateQuoteOfferBatchV2Input;
}>;

export type CreateQuoteOfferBatchV2Mutation = {
	__typename?: 'Mutation';
	createQuoteOfferBatchV2: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateQuoteOfferBatchV2MutationVariables = Exact<{
	batchId: Scalars['ID']['input'];
	input: UpdateQuoteOfferBatchV2Input;
}>;

export type UpdateQuoteOfferBatchV2Mutation = {
	__typename?: 'Mutation';
	updateQuoteOfferBatchV2: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DuplicateQuoteOfferBatchV2MutationVariables = Exact<{
	batchId: Scalars['ID']['input'];
}>;

export type DuplicateQuoteOfferBatchV2Mutation = {
	__typename?: 'Mutation';
	duplicateQuoteOfferBatchV2: {
		__typename?: 'DuplicateBatchResponse';
		success: boolean;
		message: string;
		batchId?: string | null;
	};
};

export type DeleteQuoteOfferBatchV2MutationVariables = Exact<{
	batchId: Scalars['ID']['input'];
}>;

export type DeleteQuoteOfferBatchV2Mutation = {
	__typename?: 'Mutation';
	deleteQuoteOfferBatchV2: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type SubmitQuoteOfferBatchV2MutationVariables = Exact<{
	batchId: Scalars['ID']['input'];
}>;

export type SubmitQuoteOfferBatchV2Mutation = {
	__typename?: 'Mutation';
	submitQuoteOfferBatchV2: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type AddAdminAdjustmentToOfferV2MutationVariables = Exact<{
	input: AddAdminAdjustmentV2Input;
}>;

export type AddAdminAdjustmentToOfferV2Mutation = {
	__typename?: 'Mutation';
	addAdminAdjustmentToOfferV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type RemoveAdminAdjustmentFromOfferV2MutationVariables = Exact<{
	offerId: Scalars['ID']['input'];
	adjustmentId: Scalars['ID']['input'];
}>;

export type RemoveAdminAdjustmentFromOfferV2Mutation = {
	__typename?: 'Mutation';
	removeAdminAdjustmentFromOfferV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type AddAdminAdjustmentToVariationV2MutationVariables = Exact<{
	input: AddAdminAdjustmentToVariationV2Input;
}>;

export type AddAdminAdjustmentToVariationV2Mutation = {
	__typename?: 'Mutation';
	addAdminAdjustmentToVariationV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type AddOfferToBatchV2MutationVariables = Exact<{
	input: AddOfferToBatchV2Input;
}>;

export type AddOfferToBatchV2Mutation = {
	__typename?: 'Mutation';
	addOfferToBatchV2: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GenerateQuoteOfferFileUploadUrlV2MutationVariables = Exact<{
	input: QuoteOfferFileUploadV2Input;
}>;

export type GenerateQuoteOfferFileUploadUrlV2Mutation = {
	__typename?: 'Mutation';
	generateQuoteOfferFileUploadUrlV2: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		message: string;
		fileId?: string | null;
		uploadUrl: string;
		expiresAt: string;
	};
};

export type ConfirmQuoteOfferFileUploadV2MutationVariables = Exact<{
	input: ConfirmQuoteOfferFileUploadV2Input;
}>;

export type ConfirmQuoteOfferFileUploadV2Mutation = {
	__typename?: 'Mutation';
	confirmQuoteOfferFileUploadV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type DeleteQuoteOfferFileV2MutationVariables = Exact<{
	fileId: Scalars['ID']['input'];
	quoteV2Id: Scalars['ID']['input'];
}>;

export type DeleteQuoteOfferFileV2Mutation = {
	__typename?: 'Mutation';
	deleteQuoteOfferFileV2: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type AcceptOffersV2MutationVariables = Exact<{
	input: AcceptOffersV2Input;
}>;

export type AcceptOffersV2Mutation = {
	__typename?: 'Mutation';
	acceptOffersV2: {
		__typename?: 'AcceptOffersV2Response';
		success: boolean;
		message: string;
		order?: { __typename?: 'QuoteOrderV2'; id: string; orderNumber: string } | null;
		errors: Array<{ __typename?: 'ResponseError'; field?: string | null; message: string }>;
	};
};

export type SubmitQuoteOffersToClientV2MutationVariables = Exact<{
	input: SubmitQuoteOffersToClientV2Input;
}>;

export type SubmitQuoteOffersToClientV2Mutation = {
	__typename?: 'Mutation';
	submitQuoteOffersToClientV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type UpdateQuoteOfferBatchMarginsV2MutationVariables = Exact<{
	input: UpdateQuoteOfferBatchMarginsV2Input;
}>;

export type UpdateQuoteOfferBatchMarginsV2Mutation = {
	__typename?: 'Mutation';
	updateQuoteOfferBatchMarginsV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type ConfirmQuoteOrderV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type ConfirmQuoteOrderV2Mutation = {
	__typename?: 'Mutation';
	confirmQuoteOrderV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		status: QuoteOrderStatusV2;
		confirmedAt?: string | null;
	};
};

export type CancelQuoteOrderV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
	reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type CancelQuoteOrderV2Mutation = {
	__typename?: 'Mutation';
	cancelQuoteOrderV2: { __typename?: 'QuoteOrderV2'; id: string; status: QuoteOrderStatusV2 };
};

export type CompleteQuoteOrderV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type CompleteQuoteOrderV2Mutation = {
	__typename?: 'Mutation';
	completeQuoteOrderV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		status: QuoteOrderStatusV2;
		completedAt?: string | null;
	};
};

export type UpdateQuoteOrderStatusV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
	status: QuoteOrderStatusV2;
}>;

export type UpdateQuoteOrderStatusV2Mutation = {
	__typename?: 'Mutation';
	updateQuoteOrderStatusV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		status: QuoteOrderStatusV2;
	};
};

export type StartOrderItemProductionV2MutationVariables = Exact<{
	orderItemId: Scalars['ID']['input'];
}>;

export type StartOrderItemProductionV2Mutation = {
	__typename?: 'Mutation';
	startOrderItemProductionV2: {
		__typename?: 'QuoteOrderItemV2';
		id: string;
		status: QuoteOrderItemStatusV2;
		productionStartedAt?: string | null;
	};
};

export type CompleteOrderItemProductionV2MutationVariables = Exact<{
	orderItemId: Scalars['ID']['input'];
}>;

export type CompleteOrderItemProductionV2Mutation = {
	__typename?: 'Mutation';
	completeOrderItemProductionV2: {
		__typename?: 'QuoteOrderItemV2';
		id: string;
		status: QuoteOrderItemStatusV2;
		productionCompletedAt?: string | null;
	};
};

export type ShipDeliveryV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
	trackingNumber: Scalars['String']['input'];
	carrier: Scalars['String']['input'];
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type ShipDeliveryV2Mutation = {
	__typename?: 'Mutation';
	shipDeliveryV2: {
		__typename?: 'QuoteOrderItemDeliveryV2';
		id: string;
		status: QuoteOrderItemDeliveryStatusV2;
		trackingNumber?: string | null;
		carrier?: string | null;
		estimatedDeliveryDate?: string | null;
		shippedAt?: string | null;
	};
};

export type MarkDeliveryDeliveredV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
	actualDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type MarkDeliveryDeliveredV2Mutation = {
	__typename?: 'Mutation';
	markDeliveryDeliveredV2: {
		__typename?: 'QuoteOrderItemDeliveryV2';
		id: string;
		status: QuoteOrderItemDeliveryStatusV2;
		actualDeliveryDate?: string | null;
	};
};

export type CreateSamplePaymentForOrderV2MutationVariables = Exact<{
	input: CreateSamplePaymentForOrderV2Input;
}>;

export type CreateSamplePaymentForOrderV2Mutation = {
	__typename?: 'Mutation';
	createSamplePaymentForOrderV2: {
		__typename?: 'CreateSamplePaymentForOrderV2Response';
		success: boolean;
		message?: string | null;
		clientSecret?: string | null;
		sessionId?: string | null;
		expiresAt?: string | null;
		checkoutLimitExceeded?: boolean | null;
		checkoutLimit?: number | null;
	};
};

export type CreateProductPaymentForOrderV2MutationVariables = Exact<{
	input: CreateProductPaymentForOrderV2Input;
}>;

export type CreateProductPaymentForOrderV2Mutation = {
	__typename?: 'Mutation';
	createProductPaymentForOrderV2: {
		__typename?: 'CreateProductPaymentForOrderV2Response';
		success: boolean;
		message?: string | null;
		paymentTransactionId?: string | null;
		paymentMethod?: string | null;
		clientSecret?: string | null;
		sessionId?: string | null;
		economicBookedInvoiceNumber?: number | null;
	};
};

export type CreateSampleInvoiceForOrderV2MutationVariables = Exact<{
	input: CreateSampleInvoiceForOrderV2Input;
}>;

export type CreateSampleInvoiceForOrderV2Mutation = {
	__typename?: 'Mutation';
	createSampleInvoiceForOrderV2: {
		__typename?: 'CreateSampleInvoiceForOrderV2Response';
		success: boolean;
		message?: string | null;
		invoicedCount?: number | null;
		belowInvoiceMinimum?: boolean | null;
		invoiceMinimum?: number | null;
	};
};

export type CancelSampleInvoiceForOrderV2MutationVariables = Exact<{
	input: CancelSampleInvoiceForOrderV2Input;
}>;

export type CancelSampleInvoiceForOrderV2Mutation = {
	__typename?: 'Mutation';
	cancelSampleInvoiceForOrderV2: {
		__typename?: 'CancelSampleInvoiceForOrderV2Response';
		success: boolean;
		message?: string | null;
		cancelledCount?: number | null;
	};
};

export type CancelProductPaymentV2MutationVariables = Exact<{
	input: CancelProductPaymentV2Input;
}>;

export type CancelProductPaymentV2Mutation = {
	__typename?: 'Mutation';
	cancelProductPaymentV2: {
		__typename?: 'CancelProductPaymentV2Response';
		success: boolean;
		message?: string | null;
		alreadyCancelled?: boolean | null;
	};
};

export type MarkProductInvoicePaidV2MutationVariables = Exact<{
	input: MarkProductInvoicePaidV2Input;
}>;

export type MarkProductInvoicePaidV2Mutation = {
	__typename?: 'Mutation';
	markProductInvoicePaidV2: {
		__typename?: 'MarkProductInvoicePaidV2Response';
		success: boolean;
		message?: string | null;
		alreadyPaid?: boolean | null;
	};
};

export type UpdateOrderStripeCheckoutLimitV2MutationVariables = Exact<{
	orderId: Scalars['ID']['input'];
	limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type UpdateOrderStripeCheckoutLimitV2Mutation = {
	__typename?: 'Mutation';
	updateOrderStripeCheckoutLimitV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		stripeCheckoutLimit?: number | null;
	};
};

export type UpdateOrderInvoiceMinimumV2MutationVariables = Exact<{
	orderId: Scalars['ID']['input'];
	limit?: InputMaybe<Scalars['Float']['input']>;
}>;

export type UpdateOrderInvoiceMinimumV2Mutation = {
	__typename?: 'Mutation';
	updateOrderInvoiceMinimumV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		invoiceMinimum?: number | null;
	};
};

export type UpdateOrderInvoiceRecipientV2MutationVariables = Exact<{
	orderId: Scalars['ID']['input'];
	recipient: InvoiceRecipientInputV2;
}>;

export type UpdateOrderInvoiceRecipientV2Mutation = {
	__typename?: 'Mutation';
	updateOrderInvoiceRecipientV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		invoiceRecipientOrgUserId?: string | null;
		invoiceRecipientEmail?: string | null;
	};
};

export type UpdateOrderPaymentModeV2MutationVariables = Exact<{
	orderId: Scalars['ID']['input'];
	productPaymentMode: PaymentModeEnum;
	samplePaymentMode: PaymentModeEnum;
}>;

export type UpdateOrderPaymentModeV2Mutation = {
	__typename?: 'Mutation';
	updateOrderPaymentModeV2: {
		__typename?: 'QuoteOrderV2';
		id: string;
		productPaymentMode: PaymentModeEnum;
		samplePaymentMode: PaymentModeEnum;
	};
};

export type CreateQuoteV2MutationVariables = Exact<{
	input: CreateQuoteV2Input;
}>;

export type CreateQuoteV2Mutation = {
	__typename?: 'Mutation';
	createQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddQuoteItemV2MutationVariables = Exact<{
	input: AddQuoteItemV2Input;
}>;

export type AddQuoteItemV2Mutation = {
	__typename?: 'Mutation';
	addQuoteItemV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateQuoteItemV2MutationVariables = Exact<{
	input: UpdateQuoteItemV2Input;
}>;

export type UpdateQuoteItemV2Mutation = {
	__typename?: 'Mutation';
	updateQuoteItemV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteQuoteItemV2MutationVariables = Exact<{
	input: DeleteQuoteItemV2Input;
}>;

export type DeleteQuoteItemV2Mutation = {
	__typename?: 'Mutation';
	deleteQuoteItemV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteQuoteV2MutationVariables = Exact<{
	input: DeleteQuoteV2Input;
}>;

export type DeleteQuoteV2Mutation = {
	__typename?: 'Mutation';
	deleteQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SetCurrentQuoteV2MutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type SetCurrentQuoteV2Mutation = {
	__typename?: 'Mutation';
	setCurrentQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateQuoteV2MutationVariables = Exact<{
	input: UpdateQuoteV2Input;
}>;

export type UpdateQuoteV2Mutation = {
	__typename?: 'Mutation';
	updateQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateQuoteContactsV2MutationVariables = Exact<{
	quoteId: Scalars['ID']['input'];
	contactUserIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type UpdateQuoteContactsV2Mutation = {
	__typename?: 'Mutation';
	updateQuoteContactsV2: { __typename?: 'QuoteV2'; id: string; contactUserIds: Array<string> };
};

export type AssignVetterEntitiesToQuoteV2MutationVariables = Exact<{
	quoteV2Id: Scalars['ID']['input'];
	vetterEntityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AssignVetterEntitiesToQuoteV2Mutation = {
	__typename?: 'Mutation';
	assignVetterEntitiesToQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveVetterEntitiesFromQuoteV2MutationVariables = Exact<{
	quoteV2Id: Scalars['ID']['input'];
	vetterEntityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveVetterEntitiesFromQuoteV2Mutation = {
	__typename?: 'Mutation';
	removeVetterEntitiesFromQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type SubmitQuoteV2MutationVariables = Exact<{
	input: SubmitQuoteV2Input;
}>;

export type SubmitQuoteV2Mutation = {
	__typename?: 'Mutation';
	submitQuoteV2: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemixProductToStudioMutationVariables = Exact<{
	input: RemixProductToStudioInput;
}>;

export type RemixProductToStudioMutation = {
	__typename?: 'Mutation';
	remixProductToStudio: {
		__typename?: 'RemixProductToStudioResponse';
		success: boolean;
		message?: string | null;
		studioFileId?: string | null;
	};
};

export type StartSampleProductionV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
}>;

export type StartSampleProductionV2Mutation = {
	__typename?: 'Mutation';
	startSampleProductionV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		sampleChoice: SampleChoiceV2;
		sampleRound: number;
		status: QuoteOrderItemSampleStatusV2;
		productionStartedAt?: string | null;
	};
};

export type CompleteSampleProductionV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
}>;

export type CompleteSampleProductionV2Mutation = {
	__typename?: 'Mutation';
	completeSampleProductionV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		sampleChoice: SampleChoiceV2;
		sampleRound: number;
		status: QuoteOrderItemSampleStatusV2;
		productionStartedAt?: string | null;
		productionCompletedAt?: string | null;
	};
};

export type SubmitVirtualSampleV2MutationVariables = Exact<{
	input: SubmitVirtualSampleV2Input;
}>;

export type SubmitVirtualSampleV2Mutation = {
	__typename?: 'Mutation';
	submitVirtualSampleV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		sampleChoice: SampleChoiceV2;
		sampleRound: number;
		status: QuoteOrderItemSampleStatusV2;
		deliveryMethod: QuoteOrderItemSampleDeliveryMethodV2;
		virtualDeliveryAttachments?: any | null;
		virtualDeliverySubmittedAt?: string | null;
	};
};

export type GenerateSampleVirtualDeliveryFileUploadUrlV2MutationVariables = Exact<{
	input: SampleVirtualDeliveryFileUploadV2Input;
}>;

export type GenerateSampleVirtualDeliveryFileUploadUrlV2Mutation = {
	__typename?: 'Mutation';
	generateSampleVirtualDeliveryFileUploadUrlV2: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		message: string;
		uploadUrl: string;
		blobUrl?: string | null;
		fileId?: string | null;
		expiresAt: string;
	};
};

export type ShipSampleV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
	carrier?: InputMaybe<Scalars['String']['input']>;
	trackingNumber?: InputMaybe<Scalars['String']['input']>;
	estimatedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type ShipSampleV2Mutation = {
	__typename?: 'Mutation';
	shipSampleV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		sampleChoice: SampleChoiceV2;
		sampleRound: number;
		status: QuoteOrderItemSampleStatusV2;
		carrier?: string | null;
		trackingNumber?: string | null;
		estimatedDeliveryDate?: string | null;
		shippedAt?: string | null;
	};
};

export type MarkSampleDeliveredV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
}>;

export type MarkSampleDeliveredV2Mutation = {
	__typename?: 'Mutation';
	markSampleDeliveredV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		sampleChoice: SampleChoiceV2;
		sampleRound: number;
		status: QuoteOrderItemSampleStatusV2;
		carrier?: string | null;
		trackingNumber?: string | null;
		estimatedDeliveryDate?: string | null;
		shippedAt?: string | null;
		actualDeliveryDate?: string | null;
	};
};

export type UpdateSampleAdminPriceV2MutationVariables = Exact<{
	input: UpdateSampleAdminPriceV2Input;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type UpdateSampleAdminPriceV2Mutation = {
	__typename?: 'Mutation';
	updateSampleAdminPriceV2: {
		__typename?: 'QuoteOfferItemSampleV2';
		id: string;
		adminPrice: number;
		baseSamplePrice: number;
		baseShippingPrice?: number | null;
		totalSamplePrice: number;
	};
};

export type ApproveSampleV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
	approvalNotes?: InputMaybe<Scalars['String']['input']>;
}>;

export type ApproveSampleV2Mutation = {
	__typename?: 'Mutation';
	approveSampleV2: {
		__typename?: 'QuoteOrderItemSampleApprovalV2';
		id: string;
		approvalNotes?: string | null;
		approvedAt: string;
		approvedByUserId: string;
		decision: QuoteOrderItemSampleApprovalDecisionV2;
	};
};

export type RejectSampleV2MutationVariables = Exact<{
	input: RejectSampleV2Input;
}>;

export type RejectSampleV2Mutation = {
	__typename?: 'Mutation';
	rejectSampleV2: {
		__typename?: 'QuoteOrderItemSampleApprovalV2';
		id: string;
		approvalNotes?: string | null;
		decision: QuoteOrderItemSampleApprovalDecisionV2;
		requestNewSample?: boolean | null;
		newSampleRequestStatus?: NewSampleRequestStatusV2 | null;
		nextSampleChoice?: SampleChoiceV2 | null;
		sample: {
			__typename?: 'QuoteOrderItemSampleV2';
			id: string;
			status: QuoteOrderItemSampleStatusV2;
		};
	};
};

export type ApproveNewSampleRoundV2MutationVariables = Exact<{
	input: ApproveNewSampleRoundV2Input;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type ApproveNewSampleRoundV2Mutation = {
	__typename?: 'Mutation';
	approveNewSampleRoundV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		sampleRound: number;
		sampleChoice: SampleChoiceV2;
		deliveryMethod: QuoteOrderItemSampleDeliveryMethodV2;
		status: QuoteOrderItemSampleStatusV2;
		paymentStatus: SamplePaymentStatus;
		adminPrice?: number | null;
		isDeductible: boolean;
	};
};

export type SetSampleDeductibilityV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
	isDeductible: Scalars['Boolean']['input'];
}>;

export type SetSampleDeductibilityV2Mutation = {
	__typename?: 'Mutation';
	setSampleDeductibilityV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		isDeductible: boolean;
	};
};

export type WaiveSamplePaymentV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
}>;

export type WaiveSamplePaymentV2Mutation = {
	__typename?: 'Mutation';
	waiveSamplePaymentV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		paymentStatus: SamplePaymentStatus;
	};
};

export type MarkSampleInvoicePaidV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
	note?: InputMaybe<Scalars['String']['input']>;
}>;

export type MarkSampleInvoicePaidV2Mutation = {
	__typename?: 'Mutation';
	markSampleInvoicePaidV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		paymentStatus: SamplePaymentStatus;
	};
};

export type AcceptSampleAsIsV2MutationVariables = Exact<{
	sampleId: Scalars['ID']['input'];
}>;

export type AcceptSampleAsIsV2Mutation = {
	__typename?: 'Mutation';
	acceptSampleAsIsV2: {
		__typename?: 'QuoteOrderItemSampleV2';
		id: string;
		status: QuoteOrderItemSampleStatusV2;
	};
};

export type ReRequestNewSampleRoundV2MutationVariables = Exact<{
	input: ReRequestNewSampleRoundV2Input;
}>;

export type ReRequestNewSampleRoundV2Mutation = {
	__typename?: 'Mutation';
	reRequestNewSampleRoundV2: {
		__typename?: 'QuoteOrderItemSampleApprovalV2';
		id: string;
		newSampleRequestStatus?: NewSampleRequestStatusV2 | null;
		reviewHistory?: Array<{
			__typename?: 'QuoteOrderItemSampleApprovalReviewHistoryEntryV2';
			at: string;
			actor: QuoteOrderItemSampleApprovalReviewHistoryActorV2;
			action: QuoteOrderItemSampleApprovalReviewHistoryActionV2;
			notes?: string | null;
			userId?: string | null;
		}> | null;
	};
};

export type DenyNewSampleRoundV2MutationVariables = Exact<{
	input: DenyNewSampleRoundV2Input;
}>;

export type DenyNewSampleRoundV2Mutation = {
	__typename?: 'Mutation';
	denyNewSampleRoundV2: {
		__typename?: 'QuoteOrderItemSampleApprovalV2';
		id: string;
		newSampleRequestStatus?: NewSampleRequestStatusV2 | null;
		reviewedAt?: string | null;
		reviewedByUserId?: string | null;
		reviewHistory?: Array<{
			__typename?: 'QuoteOrderItemSampleApprovalReviewHistoryEntryV2';
			at: string;
			actor: QuoteOrderItemSampleApprovalReviewHistoryActorV2;
			action: QuoteOrderItemSampleApprovalReviewHistoryActionV2;
			notes?: string | null;
			userId?: string | null;
		}> | null;
	};
};

export type CreateSourcingPreferenceMutationVariables = Exact<{
	input: OrganizationSourcingPreferenceCreateInput;
}>;

export type CreateSourcingPreferenceMutation = {
	__typename?: 'Mutation';
	createOrganizationSourcingPreference: {
		__typename?: 'OrganizationSourcingPreference';
		id: string;
		name: string;
		description?: string | null;
	};
};

export type UpdateSourcingPreferenceMutationVariables = Exact<{
	input: OrganizationSourcingPreferenceUpdateInput;
}>;

export type UpdateSourcingPreferenceMutation = {
	__typename?: 'Mutation';
	updateOrganizationSourcingPreference: {
		__typename?: 'OrganizationSourcingPreference';
		id: string;
		name: string;
		description?: string | null;
	};
};

export type DeleteSourcingPreferenceMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteSourcingPreferenceMutation = {
	__typename?: 'Mutation';
	deleteOrganizationSourcingPreference: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type DeleteSourcingPreferencesMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteSourcingPreferencesMutation = {
	__typename?: 'Mutation';
	deleteOrganizationSourcingPreferences: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type CreateSourcingPreferenceConnectionMutationVariables = Exact<{
	input: OrganizationSourcingPreferenceConnectionCreateInput;
}>;

export type CreateSourcingPreferenceConnectionMutation = {
	__typename?: 'Mutation';
	createOrganizationSourcingPreferenceConnection: {
		__typename?: 'OrganizationSourcingPreferenceConnection';
		id: string;
		organizationId: string;
		organizationSourcingPreferenceId: string;
		priority?: number | null;
		notes?: string | null;
	};
};

export type UpdateSourcingPreferenceConnectionMutationVariables = Exact<{
	input: OrganizationSourcingPreferenceConnectionUpdateInput;
}>;

export type UpdateSourcingPreferenceConnectionMutation = {
	__typename?: 'Mutation';
	updateOrganizationSourcingPreferenceConnection: {
		__typename?: 'OrganizationSourcingPreferenceConnection';
		id: string;
		priority?: number | null;
		notes?: string | null;
	};
};

export type DeleteSourcingPreferenceConnectionMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteSourcingPreferenceConnectionMutation = {
	__typename?: 'Mutation';
	deleteOrganizationSourcingPreferenceConnection: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type CreateProductInterestMutationVariables = Exact<{
	input: OrganizationProductInterestCreateInput;
}>;

export type CreateProductInterestMutation = {
	__typename?: 'Mutation';
	createOrganizationProductInterest: {
		__typename?: 'OrganizationProductInterest';
		id: string;
		organizationId: string;
		productTagId: string;
	};
};

export type UpdateProductInterestMutationVariables = Exact<{
	input: OrganizationProductInterestUpdateInput;
}>;

export type UpdateProductInterestMutation = {
	__typename?: 'Mutation';
	updateOrganizationProductInterest: { __typename?: 'OrganizationProductInterest'; id: string };
};

export type DeleteProductInterestMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteProductInterestMutation = {
	__typename?: 'Mutation';
	deleteOrganizationProductInterest: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type DeleteProductInterestsMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteProductInterestsMutation = {
	__typename?: 'Mutation';
	deleteOrganizationProductInterests: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type CreateComplianceOptionMutationVariables = Exact<{
	input: OrganizationComplianceCreateInput;
}>;

export type CreateComplianceOptionMutation = {
	__typename?: 'Mutation';
	createOrganizationCompliance: {
		__typename?: 'OrganizationCompliance';
		id: string;
		name: string;
		description?: string | null;
	};
};

export type UpdateComplianceOptionMutationVariables = Exact<{
	input: OrganizationComplianceUpdateInput;
}>;

export type UpdateComplianceOptionMutation = {
	__typename?: 'Mutation';
	updateOrganizationCompliance: {
		__typename?: 'OrganizationCompliance';
		id: string;
		name: string;
		description?: string | null;
	};
};

export type DeleteComplianceOptionMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteComplianceOptionMutation = {
	__typename?: 'Mutation';
	deleteOrganizationCompliance: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type DeleteComplianceOptionsMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteComplianceOptionsMutation = {
	__typename?: 'Mutation';
	deleteOrganizationCompliances: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type CreateComplianceConnectionMutationVariables = Exact<{
	input: OrganizationComplianceConnectionCreateInput;
}>;

export type CreateComplianceConnectionMutation = {
	__typename?: 'Mutation';
	createOrganizationComplianceConnection: {
		__typename?: 'OrganizationComplianceConnection';
		id: string;
		organizationId: string;
		organizationComplianceId: string;
		certificationNumber?: string | null;
		issueDate?: string | null;
		expiryDate?: string | null;
		certifyingBody?: string | null;
	};
};

export type UpdateComplianceConnectionMutationVariables = Exact<{
	input: OrganizationComplianceConnectionUpdateInput;
}>;

export type UpdateComplianceConnectionMutation = {
	__typename?: 'Mutation';
	updateOrganizationComplianceConnection: {
		__typename?: 'OrganizationComplianceConnection';
		id: string;
		certificationNumber?: string | null;
		issueDate?: string | null;
		expiryDate?: string | null;
		certifyingBody?: string | null;
	};
};

export type DeleteComplianceConnectionMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteComplianceConnectionMutation = {
	__typename?: 'Mutation';
	deleteOrganizationComplianceConnection: {
		__typename?: 'MessageResponse';
		message: string;
		success: boolean;
	};
};

export type CreateProductTagMutationVariables = Exact<{
	input: ProductTagCreateInput;
}>;

export type CreateProductTagMutation = {
	__typename?: 'Mutation';
	createProductTag: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type UpdateProductTagMutationVariables = Exact<{
	input: ProductTagUpdateInput;
}>;

export type UpdateProductTagMutation = {
	__typename?: 'Mutation';
	updateProductTag: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type DeleteProductTagMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteProductTagMutation = {
	__typename?: 'Mutation';
	deleteProductTag: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type DeleteProductTagsMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteProductTagsMutation = {
	__typename?: 'Mutation';
	deleteProductTags: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type SendChatMessageMutationVariables = Exact<{
	input: SendChatMessageInput;
}>;

export type SendChatMessageMutation = {
	__typename?: 'Mutation';
	sendChatMessage: {
		__typename?: 'SendChatMessageResponse';
		versionCreated: boolean;
		toolsUsed?: Array<string> | null;
		message: {
			__typename?: 'StudioChat';
			id: string;
			content: string;
			role: ChatRole;
			createdAt?: string | null;
			referenceImages?: Array<string> | null;
			maskImage?: string | null;
			maskImagePreview?: string | null;
			updatedAt?: string | null;
			studioFileId: string;
		};
	};
};

export type GenerateChatAttachmentUploadUrlMutationVariables = Exact<{
	input: ChatAttachmentUploadInput;
}>;

export type GenerateChatAttachmentUploadUrlMutation = {
	__typename?: 'Mutation';
	generateChatAttachmentUploadUrl: {
		__typename?: 'ChatAttachmentUploadResponse';
		uploadUrl: string;
		blobUrl: string;
		expiresAt: string;
	};
};

export type CreateStudioFileMutationVariables = Exact<{
	input: StudioFileCreateInput;
}>;

export type CreateStudioFileMutation = {
	__typename?: 'Mutation';
	createStudioFile: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateStudioFileVersionMutationVariables = Exact<{
	input: CreateStudioFileVersionInput;
}>;

export type CreateStudioFileVersionMutation = {
	__typename?: 'Mutation';
	createStudioFileVersion: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteStudioFileMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteStudioFileMutation = {
	__typename?: 'Mutation';
	deleteStudioFile: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateStudioFileMutationVariables = Exact<{
	input: StudioFileUpdateInput;
}>;

export type UpdateStudioFileMutation = {
	__typename?: 'Mutation';
	updateStudioFile: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AddStudioFileVersionMetadataMutationVariables = Exact<{
	studioFileVersionId: Scalars['ID']['input'];
	input: AddStudioFileVersionMetadataInput;
}>;

export type AddStudioFileVersionMetadataMutation = {
	__typename?: 'Mutation';
	addStudioFileVersionMetadata: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteStudioFileVersionMetadataMutationVariables = Exact<{
	metadataId: Scalars['ID']['input'];
}>;

export type DeleteStudioFileVersionMetadataMutation = {
	__typename?: 'Mutation';
	deleteStudioFileVersionMetadata: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateStudioFileVersionMetadataMutationVariables = Exact<{
	metadataId: Scalars['ID']['input'];
	input: UpdateStudioFileVersionMetadataInput;
}>;

export type UpdateStudioFileVersionMetadataMutation = {
	__typename?: 'Mutation';
	updateStudioFileVersionMetadata: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateProductFromStudioFileMutationVariables = Exact<{
	input: CreateProductFromStudioInput;
}>;

export type CreateProductFromStudioFileMutation = {
	__typename?: 'Mutation';
	createProductFromStudioFile: {
		__typename?: 'CreateProductFromStudioResponse';
		success: boolean;
		message?: string | null;
		productId?: string | null;
	};
};

export type RevertToStudioFileVersionMutationVariables = Exact<{
	versionId: Scalars['ID']['input'];
}>;

export type RevertToStudioFileVersionMutation = {
	__typename?: 'Mutation';
	revertToStudioFileVersion: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateMetadataAttachmentUploadUrlMutationVariables = Exact<{
	input: MetadataAttachmentUploadInput;
}>;

export type GenerateMetadataAttachmentUploadUrlMutation = {
	__typename?: 'Mutation';
	generateMetadataAttachmentUploadUrl: {
		__typename?: 'MetadataAttachmentUploadResponse';
		uploadUrl: string;
		blobUrl: string;
		expiresAt: string;
	};
};

export type FinishMetadataAttachmentUploadMutationVariables = Exact<{
	input: FinishMetadataAttachmentUploadInput;
}>;

export type FinishMetadataAttachmentUploadMutation = {
	__typename?: 'Mutation';
	finishMetadataAttachmentUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemoveMetadataAttachmentMutationVariables = Exact<{
	input: RemoveMetadataAttachmentInput;
}>;

export type RemoveMetadataAttachmentMutation = {
	__typename?: 'Mutation';
	removeMetadataAttachment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteStudioFileVersionMutationVariables = Exact<{
	versionId: Scalars['ID']['input'];
}>;

export type DeleteStudioFileVersionMutation = {
	__typename?: 'Mutation';
	deleteStudioFileVersion: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateStudioFileVersionSpecificationMutationVariables = Exact<{
	specificationId: Scalars['ID']['input'];
	input: UpdateStudioFileVersionSpecificationInput;
}>;

export type UpdateStudioFileVersionSpecificationMutation = {
	__typename?: 'Mutation';
	updateStudioFileVersionSpecification: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteStudioFileVersionSpecificationMutationVariables = Exact<{
	specificationId: Scalars['ID']['input'];
}>;

export type DeleteStudioFileVersionSpecificationMutation = {
	__typename?: 'Mutation';
	deleteStudioFileVersionSpecification: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AssignStudioFileToClientMutationVariables = Exact<{
	input: AssignStudioFileToClientInput;
}>;

export type AssignStudioFileToClientMutation = {
	__typename?: 'Mutation';
	assignStudioFileToClient: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AcquireStudioLockMutationVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type AcquireStudioLockMutation = {
	__typename?: 'Mutation';
	acquireStudioLock: {
		__typename?: 'AcquireStudioLockResponse';
		success: boolean;
		message: string;
		lock?: {
			__typename?: 'StudioLock';
			studioFileId: string;
			userId: string;
			lockedAt: string;
			expiresAt: string;
		} | null;
	};
};

export type ReleaseStudioLockMutationVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type ReleaseStudioLockMutation = {
	__typename?: 'Mutation';
	releaseStudioLock: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateStudioPromptTemplateMutationVariables = Exact<{
	input: UpdateStudioPromptTemplateInput;
}>;

export type UpdateStudioPromptTemplateMutation = {
	__typename?: 'Mutation';
	updateStudioPromptTemplate: {
		__typename?: 'StudioPromptTemplate';
		id: string;
		key: string;
		content: string;
		description?: string | null;
		agentType: StudioAgentType;
		isActive: boolean;
		provider?: string | null;
		variables?: Array<string> | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	};
};

export type GenerateStudioReferenceImageUploadUrlMutationVariables = Exact<{
	input: GenerateStudioReferenceImageUploadUrlInput;
}>;

export type GenerateStudioReferenceImageUploadUrlMutation = {
	__typename?: 'Mutation';
	generateStudioReferenceImageUploadUrl: {
		__typename?: 'GenerateStudioReferenceImageUploadUrlResponse';
		imageId: string;
		uploadUrl: string;
		blobUrl: string;
		expiresAt: string;
	};
};

export type ConfirmStudioReferenceImageUploadMutationVariables = Exact<{
	input: ConfirmStudioReferenceImageUploadInput;
}>;

export type ConfirmStudioReferenceImageUploadMutation = {
	__typename?: 'Mutation';
	confirmStudioReferenceImageUpload: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
	};
};

export type CreateSubscriptionCheckoutSessionMutationVariables = Exact<{
	tier: SubscriptionTier;
}>;

export type CreateSubscriptionCheckoutSessionMutation = {
	__typename?: 'Mutation';
	createSubscriptionCheckoutSession: {
		__typename?: 'CreateSubscriptionCheckoutResponse';
		success: boolean;
		clientSecret?: string | null;
		sessionId?: string | null;
		message?: string | null;
	};
};

export type ChangeSubscriptionPlanMutationVariables = Exact<{
	tier: SubscriptionTier;
}>;

export type ChangeSubscriptionPlanMutation = {
	__typename?: 'Mutation';
	changeSubscriptionPlan: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		requiresAction?: boolean | null;
		clientSecret?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			tier: SubscriptionTier;
			status: SubscriptionStatus;
			stripePriceId?: string | null;
			currentPeriodEnd?: string | null;
			cancelAtPeriodEnd: boolean;
			pendingTier?: SubscriptionTier | null;
			pendingTierEffectiveAt?: string | null;
		} | null;
	};
};

export type CancelScheduledPlanChangeMutationVariables = Exact<{ [key: string]: never }>;

export type CancelScheduledPlanChangeMutation = {
	__typename?: 'Mutation';
	cancelScheduledPlanChange: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			tier: SubscriptionTier;
			pendingTier?: SubscriptionTier | null;
			pendingTierEffectiveAt?: string | null;
		} | null;
	};
};

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type CancelSubscriptionMutation = {
	__typename?: 'Mutation';
	cancelSubscription: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			status: SubscriptionStatus;
			cancelAtPeriodEnd: boolean;
			canceledAt?: string | null;
		} | null;
	};
};

export type ResumeSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type ResumeSubscriptionMutation = {
	__typename?: 'Mutation';
	resumeSubscription: {
		__typename?: 'SubscriptionMutationResponse';
		success: boolean;
		message?: string | null;
		subscription?: {
			__typename?: 'OrganizationSubscription';
			id: string;
			status: SubscriptionStatus;
			cancelAtPeriodEnd: boolean;
		} | null;
	};
};

export type UpdateSubscriptionTierConfigMutationVariables = Exact<{
	tier: SubscriptionTier;
	kickbackRate?: InputMaybe<Scalars['Float']['input']>;
	aiTokenRatePerMillion?: InputMaybe<Scalars['Float']['input']>;
	stripePriceId?: InputMaybe<Scalars['String']['input']>;
	isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateSubscriptionTierConfigMutation = {
	__typename?: 'Mutation';
	updateSubscriptionTierConfig: {
		__typename?: 'SubscriptionTierConfig';
		tier: SubscriptionTier;
		monthlyPrice?: number | null;
		currency?: string | null;
		kickbackRate: number;
		aiTokenRatePerMillion?: number | null;
		stripePriceId?: string | null;
		isActive: boolean;
		updatedAt: string;
	};
};

export type UpdateSystemSettingsMutationVariables = Exact<{
	input: UpdateSystemSettingInput;
}>;

export type UpdateSystemSettingsMutation = {
	__typename?: 'Mutation';
	updateSystemSettings: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type UpdateUserLanguagePreferenceMutationVariables = Exact<{
	language?: InputMaybe<SupportedLanguage>;
}>;

export type UpdateUserLanguagePreferenceMutation = {
	__typename?: 'Mutation';
	updateUserLanguagePreference: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateVetterEntityMutationVariables = Exact<{
	input: CreateVetterEntityInput;
}>;

export type CreateVetterEntityMutation = {
	__typename?: 'Mutation';
	createVetterEntity: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateVetterEntityMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateVetterEntityInput;
}>;

export type UpdateVetterEntityMutation = {
	__typename?: 'Mutation';
	updateVetterEntity: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteVetterEntityMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteVetterEntityMutation = {
	__typename?: 'Mutation';
	deleteVetterEntity: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateVetterUserMutationVariables = Exact<{
	input: CreateVetterUserInput;
}>;

export type CreateVetterUserMutation = {
	__typename?: 'Mutation';
	createVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateVetterUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateVetterUserInput;
}>;

export type UpdateVetterUserMutation = {
	__typename?: 'Mutation';
	updateVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteVetterUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteVetterUserMutation = {
	__typename?: 'Mutation';
	deleteVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyVetterUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyVetterUserMutation = {
	__typename?: 'Mutation';
	deleteManyVetterUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type GetAdminActiveActivitiesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAdminActiveActivitiesQuery = {
	__typename?: 'Query';
	getAdminActiveActivities: {
		__typename?: 'AdminActiveActivities';
		activities: Array<
			| {
					__typename: 'AdminChatActivity';
					id: string;
					type: AdminActivityType;
					contextId: string;
					unreadCount: number;
					lastMessageAt: string;
					context?: {
						__typename?: 'ChatContext';
						id: string;
						contextType: ChatContextType;
						quoteId: string;
						quote?: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						} | null;
					} | null;
			  }
			| {
					__typename: 'AdminOrderActivity';
					id: string;
					type: AdminActivityType;
					orderId: string;
					order?: {
						__typename?: 'QuoteOrderV2';
						id: string;
						orderNumber: string;
						name: string;
						quote: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						};
					} | null;
			  }
			| {
					__typename: 'AdminQuoteActivity';
					id: string;
					type: AdminActivityType;
					quoteId: string;
					quote?: {
						__typename?: 'QuoteV2';
						id: string;
						name: string;
						createdAt?: string | null;
						items: Array<{
							__typename?: 'QuoteItemV2';
							product?: {
								__typename?: 'Product';
								images?: Array<{
									__typename?: 'ProductImage';
									url?: string | null;
									name: string;
									isPrimary?: boolean | null;
								}> | null;
							} | null;
						}>;
					} | null;
			  }
			| {
					__typename: 'AdminQuoteOfferActivity';
					id: string;
					type: AdminActivityType;
					quoteOfferId: string;
					quoteOffer?: {
						__typename?: 'QuoteOfferV2';
						id: string;
						createdAt?: string | null;
						quote: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						};
					} | null;
			  }
		>;
	};
};

export type GetVetterActiveActivitiesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetVetterActiveActivitiesQuery = {
	__typename?: 'Query';
	getVetterActiveActivities: {
		__typename?: 'VetterActiveActivities';
		activities: Array<
			| {
					__typename: 'VetterChatActivity';
					id: string;
					type: VetterActivityType;
					contextId: string;
					unreadCount: number;
					lastMessageAt: string;
					context?: {
						__typename?: 'ChatContext';
						id: string;
						contextType: ChatContextType;
						quoteId: string;
						quote?: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						} | null;
					} | null;
			  }
			| {
					__typename: 'VetterQuoteActivity';
					id: string;
					type: VetterActivityType;
					quoteId: string;
					quote?: {
						__typename?: 'QuoteV2';
						id: string;
						name: string;
						createdAt?: string | null;
						organization?: {
							__typename?: 'Organization';
							id: string;
							name: string;
						} | null;
						offers: Array<{
							__typename?: 'QuoteOfferV2';
							id: string;
							status: QuoteOfferStatusV2;
							createdAt?: string | null;
						}>;
						items: Array<{
							__typename?: 'QuoteItemV2';
							product?: {
								__typename?: 'Product';
								images?: Array<{
									__typename?: 'ProductImage';
									url?: string | null;
									name: string;
									isPrimary?: boolean | null;
								}> | null;
							} | null;
						}>;
					} | null;
			  }
			| {
					__typename: 'VetterQuoteOfferActivity';
					id: string;
					type: VetterActivityType;
					quoteOfferId: string;
					quoteOffer?: {
						__typename?: 'QuoteOfferV2';
						id: string;
						createdAt?: string | null;
						quote: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							organization?: {
								__typename?: 'Organization';
								id: string;
								name: string;
							} | null;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						};
					} | null;
			  }
		>;
	};
};

export type GetOrganizationActiveActivitiesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetOrganizationActiveActivitiesQuery = {
	__typename?: 'Query';
	getOrganizationActiveActivities: {
		__typename?: 'OrganizationActiveActivities';
		activities: Array<
			| {
					__typename: 'OrganizationChatActivity';
					id: string;
					type: OrganizationActivityType;
					contextId: string;
					unreadCount: number;
					lastMessageAt: string;
					context?: {
						__typename?: 'ChatContext';
						id: string;
						contextType: ChatContextType;
						quoteId: string;
						quote?: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						} | null;
					} | null;
			  }
			| {
					__typename: 'OrganizationOrderActivity';
					id: string;
					type: OrganizationActivityType;
					orderId: string;
					order?: {
						__typename?: 'QuoteOrderV2';
						id: string;
						orderNumber: string;
						name: string;
						quote: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						};
					} | null;
			  }
			| {
					__typename: 'OrganizationQuoteActivity';
					id: string;
					type: OrganizationActivityType;
					quoteId: string;
					quote?: {
						__typename?: 'QuoteV2';
						id: string;
						name: string;
						items: Array<{
							__typename?: 'QuoteItemV2';
							product?: {
								__typename?: 'Product';
								images?: Array<{
									__typename?: 'ProductImage';
									url?: string | null;
									name: string;
									isPrimary?: boolean | null;
								}> | null;
							} | null;
						}>;
					} | null;
			  }
			| {
					__typename: 'OrganizationQuoteOfferActivity';
					id: string;
					type: OrganizationActivityType;
					quoteOfferId: string;
					quoteOffer?: {
						__typename?: 'QuoteOfferV2';
						id: string;
						status: QuoteOfferStatusV2;
						createdAt?: string | null;
						quote: {
							__typename?: 'QuoteV2';
							id: string;
							name: string;
							items: Array<{
								__typename?: 'QuoteItemV2';
								product?: {
									__typename?: 'Product';
									name: string;
									images?: Array<{
										__typename?: 'ProductImage';
										url?: string | null;
										name: string;
										isPrimary?: boolean | null;
									}> | null;
								} | null;
							}>;
						};
					} | null;
			  }
		>;
	};
};

export type GetAdminInvoiceDraftsForOrgV2QueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetAdminInvoiceDraftsForOrgV2Query = {
	__typename?: 'Query';
	getAdminInvoiceDraftsForOrgV2: Array<{
		__typename?: 'AdminInvoiceDraftV2';
		id: string;
		organizationId: string;
		currency: string;
		lineItems: any;
		recipientEmail?: string | null;
		title?: string | null;
		notes?: string | null;
		poNumber?: string | null;
		economicDraftInvoiceNumber?: number | null;
		economicBookedInvoiceNumber?: number | null;
		economicCreditNoteInvoiceNumber?: number | null;
		status: AdminInvoiceDraftStatus;
		createdByUserId?: string | null;
		bookedAt?: string | null;
		cancelledAt?: string | null;
		lastError?: string | null;
		createdAt: string;
		updatedAt: string;
	}>;
};

export type GetAdminInvoiceDraftV2QueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetAdminInvoiceDraftV2Query = {
	__typename?: 'Query';
	getAdminInvoiceDraftV2?: {
		__typename?: 'AdminInvoiceDraftV2';
		id: string;
		organizationId: string;
		currency: string;
		lineItems: any;
		recipientEmail?: string | null;
		title?: string | null;
		notes?: string | null;
		poNumber?: string | null;
		economicDraftInvoiceNumber?: number | null;
		economicBookedInvoiceNumber?: number | null;
		economicCreditNoteInvoiceNumber?: number | null;
		status: AdminInvoiceDraftStatus;
		createdByUserId?: string | null;
		bookedAt?: string | null;
		cancelledAt?: string | null;
		lastError?: string | null;
		createdAt: string;
		updatedAt: string;
	} | null;
};

export type GetAllAdminUserQueryVariables = Exact<{
	input: GetAllAdminUserInput;
}>;

export type GetAllAdminUserQuery = {
	__typename?: 'Query';
	getAllAdminUser: {
		__typename?: 'AdminUserPage';
		data: Array<{
			__typename?: 'AdminUser';
			id: string;
			userId: string;
			firstName: string;
			lastName: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				mfaEnabled: boolean;
				language: string;
				lastActive?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAuthenticationUserQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetAuthenticationUserQuery = {
	__typename?: 'Query';
	getAuthenticationUser: {
		__typename?: 'AuthenticationUser';
		id: string;
		email?: string | null;
		mfaEnabled: boolean;
		mfaMethod?: MfaMethodEnum | null;
		role: AuthRoleEnum;
	};
};

export type CheckEmailExistsQueryVariables = Exact<{
	email: Scalars['String']['input'];
}>;

export type CheckEmailExistsQuery = {
	__typename?: 'Query';
	checkEmailExists: { __typename?: 'EmailExistsResponse'; exists: boolean };
};

export type GetAllAuthorizationRoleQueryVariables = Exact<{
	input: GetAllAuthorizationRoleInput;
}>;

export type GetAllAuthorizationRoleQuery = {
	__typename?: 'Query';
	getAllAuthorizationRole?: {
		__typename?: 'AuthorizationRolePage';
		data?: Array<{
			__typename?: 'AuthorizationRole';
			id: string;
			name: string;
			description?: string | null;
			scope: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authorizationRolePermissions?: Array<{
				__typename?: 'AuthorizationRolePermission';
				id: string;
				authorizationPermission?: {
					__typename?: 'AuthorizationPermission';
					id: string;
					resource?: string | null;
					action?: AuthorizationPermissionAction | null;
					description?: string | null;
					createdAt?: string | null;
					updatedAt?: string | null;
				} | null;
			}> | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetAuthorizationRoleQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetAuthorizationRoleQuery = {
	__typename?: 'Query';
	getAuthorizationRole?: {
		__typename?: 'AuthorizationRole';
		id: string;
		name: string;
		description?: string | null;
		scope: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		authorizationRolePermissions?: Array<{
			__typename?: 'AuthorizationRolePermission';
			id: string;
			authorizationPermission?: {
				__typename?: 'AuthorizationPermission';
				id: string;
				resource?: string | null;
				action?: AuthorizationPermissionAction | null;
				description?: string | null;
				createdAt?: string | null;
				updatedAt?: string | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAuthorizationRoleByNameQueryVariables = Exact<{
	name: Scalars['String']['input'];
}>;

export type GetAuthorizationRoleByNameQuery = {
	__typename?: 'Query';
	getAuthorizationRoleByName?: {
		__typename?: 'AuthorizationRole';
		id: string;
		name: string;
		description?: string | null;
		scope: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		authorizationRolePermissions?: Array<{
			__typename?: 'AuthorizationRolePermission';
			id: string;
			authorizationPermission?: {
				__typename?: 'AuthorizationPermission';
				id: string;
				resource?: string | null;
				action?: AuthorizationPermissionAction | null;
				description?: string | null;
				createdAt?: string | null;
				updatedAt?: string | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAllAuthorizationUserRoleQueryVariables = Exact<{
	input: GetAllAuthorizationUserRoleInput;
}>;

export type GetAllAuthorizationUserRoleQuery = {
	__typename?: 'Query';
	getAllAuthorizationUserRole?: {
		__typename?: 'AuthorizationUserRolePage';
		data?: Array<{
			__typename?: 'AuthorizationUserRole';
			id: string;
			userId: string;
			authorizationRoleId: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authorizationRole?: {
				__typename?: 'AuthorizationRole';
				id: string;
				name: string;
				description?: string | null;
				scope: string;
				createdAt?: string | null;
				updatedAt?: string | null;
				authorizationRolePermissions?: Array<{
					__typename?: 'AuthorizationRolePermission';
					id: string;
					authorizationPermission?: {
						__typename?: 'AuthorizationPermission';
						id: string;
						resource?: string | null;
						action?: AuthorizationPermissionAction | null;
						description?: string | null;
						createdAt?: string | null;
						updatedAt?: string | null;
					} | null;
				}> | null;
			} | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetMyAuthorizationUserRoleQueryVariables = Exact<{
	input: GetMyAuthorizationUserRoleInput;
}>;

export type GetMyAuthorizationUserRoleQuery = {
	__typename?: 'Query';
	getMyAuthorizationUserRole?: {
		__typename?: 'AuthorizationUserRolePage';
		data?: Array<{
			__typename?: 'AuthorizationUserRole';
			id: string;
			userId: string;
			authorizationRoleId: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authorizationRole?: {
				__typename?: 'AuthorizationRole';
				id: string;
				name: string;
				description?: string | null;
				scope: string;
				createdAt?: string | null;
				updatedAt?: string | null;
				authorizationRolePermissions?: Array<{
					__typename?: 'AuthorizationRolePermission';
					id: string;
					authorizationPermission?: {
						__typename?: 'AuthorizationPermission';
						id: string;
						resource?: string | null;
						action?: AuthorizationPermissionAction | null;
						description?: string | null;
						createdAt?: string | null;
						updatedAt?: string | null;
					} | null;
				}> | null;
			} | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetAllBrandsQueryVariables = Exact<{
	input: GetAllBrandInput;
}>;

export type GetAllBrandsQuery = {
	__typename?: 'Query';
	getAllBrand: {
		__typename?: 'BrandPage';
		data: Array<{
			__typename?: 'Brand';
			id: string;
			name: string;
			organizationId: string;
			description?: string | null;
			brandguide?: string | null;
			colors?: Array<string> | null;
			website?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			logo?: {
				__typename?: 'BrandLogo';
				id: string;
				name: string;
				url?: string | null;
				mimeType: string;
			} | null;
			address?: {
				__typename?: 'BrandAddress';
				formatted?: string | null;
				city?: string | null;
				state?: string | null;
				country?: string | null;
				postalCode?: string | null;
			} | null;
			brandFiles?: Array<{
				__typename?: 'BrandFile';
				id: string;
				name: string;
				url?: string | null;
				type: BrandFileType;
				mimeType: string;
				size: number;
				uploadedAt: string;
			}> | null;
			fontFiles?: Array<{
				__typename?: 'FontFile';
				id: string;
				family: string;
				name: string;
				style?: string | null;
				url?: string | null;
				weight?: string | null;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetBrandQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetBrandQuery = {
	__typename?: 'Query';
	getBrand: {
		__typename?: 'Brand';
		id: string;
		name: string;
		description?: string | null;
		brandguide?: string | null;
		colors?: Array<string> | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		colorPalette?: {
			__typename?: 'BrandColorPalette';
			primary?: Array<{
				__typename?: 'BrandColor';
				name: string;
				hex: string;
				usage?: Array<string> | null;
			}> | null;
			secondary?: Array<{
				__typename?: 'BrandColor';
				name: string;
				hex: string;
				usage?: Array<string> | null;
			}> | null;
			accent?: Array<{
				__typename?: 'BrandColor';
				name: string;
				hex: string;
				usage?: Array<string> | null;
			}> | null;
			neutral?: Array<{
				__typename?: 'BrandColor';
				name: string;
				hex: string;
				usage?: Array<string> | null;
			}> | null;
		} | null;
		brandFiles?: Array<{
			__typename?: 'BrandFile';
			id: string;
			name: string;
			url?: string | null;
			type: BrandFileType;
			mimeType: string;
			size: number;
			uploadedAt: string;
		}> | null;
		fontFiles?: Array<{
			__typename?: 'FontFile';
			id: string;
			family: string;
			name: string;
			style?: string | null;
			url?: string | null;
			weight?: string | null;
		}> | null;
	};
};

export type SearchBrandAssetsQueryVariables = Exact<{
	brandId: Scalars['ID']['input'];
	query: Scalars['String']['input'];
	context?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type SearchBrandAssetsQuery = {
	__typename?: 'Query';
	searchBrandAssets: Array<
		| {
				__typename?: 'BrandFile';
				id: string;
				name: string;
				mimeType: string;
				size: number;
				url?: string | null;
				type: BrandFileType;
				designVariant?: string | null;
				backgroundType?: Array<string> | null;
				aiDescription?: string | null;
				tags?: Array<string> | null;
				dimensions?: {
					__typename?: 'FileDimensions';
					width?: number | null;
					height?: number | null;
				} | null;
		  }
		| {
				__typename?: 'FontFile';
				id: string;
				name: string;
				family: string;
				style?: string | null;
				url?: string | null;
				weight?: string | null;
				language?: Array<string> | null;
				mood?: Array<string> | null;
				usage?: Array<string> | null;
				readability?: string | null;
				aiDescription?: string | null;
		  }
	>;
};

export type GetChatContextsByQuoteQueryVariables = Exact<{
	quoteId: Scalars['ID']['input'];
}>;

export type GetChatContextsByQuoteQuery = {
	__typename?: 'Query';
	getChatContextsByQuote: Array<{
		__typename?: 'ChatContext';
		id: string;
		contextType: ChatContextType;
		organizationId?: string | null;
		vetterId?: string | null;
		quoteId: string;
		unreadCount: number;
		lastMessageAt?: string | null;
		translationEnabled: boolean;
		targetLanguages?: Array<SupportedLanguage> | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		vetterUser?: {
			__typename?: 'VetterUser';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
	}>;
};

export type GetChatMessagesQueryVariables = Exact<{
	contextId: Scalars['ID']['input'];
	input: GetChatMessagesInput;
}>;

export type GetChatMessagesQuery = {
	__typename?: 'Query';
	getChatMessages?: {
		__typename?: 'GetChatMessagesResponse';
		data?: Array<{
			__typename?: 'ChatMessage';
			id: string;
			content?: string | null;
			contextId: string;
			senderId: string;
			senderType: AuthRoleEnum;
			messageType: MessageType;
			metadata?: any | null;
			isRead: boolean;
			readAt?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			translations?: {
				__typename?: 'MessageTranslations';
				da?: string | null;
				en?: string | null;
				zh?: string | null;
			} | null;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
	} | null;
};

export type GetAllChatContextsQueryVariables = Exact<{
	input: GetMyChatContextsInput;
}>;

export type GetAllChatContextsQuery = {
	__typename?: 'Query';
	getMyChatContexts?: {
		__typename?: 'GetChatContextsResponse';
		data?: Array<{
			__typename?: 'ChatContext';
			id: string;
			contextType: ChatContextType;
			organizationId?: string | null;
			vetterId?: string | null;
			quoteId: string;
			unreadCount: number;
			lastMessageAt?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			vetterUser?: {
				__typename?: 'VetterUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
	} | null;
};

export type GetChatFileDownloadUrlQueryVariables = Exact<{
	contextId: Scalars['ID']['input'];
	fileId: Scalars['ID']['input'];
}>;

export type GetChatFileDownloadUrlQuery = {
	__typename?: 'Query';
	getChatFileDownloadUrl: {
		__typename?: 'FileUploadResponse';
		success: boolean;
		uploadUrl: string;
		expiresAt: string;
	};
};

export type ListEarlyAccessRequestsQueryVariables = Exact<{
	status?: InputMaybe<EarlyAccessStatusEnum>;
}>;

export type ListEarlyAccessRequestsQuery = {
	__typename?: 'Query';
	listEarlyAccessRequests: Array<{
		__typename?: 'EarlyAccessRequest';
		id: string;
		firstName: string;
		lastName: string;
		email: string;
		status: EarlyAccessStatusEnum;
		createdAt: string;
		approvedAt?: string | null;
		usedAt?: string | null;
	}>;
};

export type GetEarlyAccessByTokenQueryVariables = Exact<{
	inviteToken: Scalars['String']['input'];
}>;

export type GetEarlyAccessByTokenQuery = {
	__typename?: 'Query';
	getEarlyAccessByToken?: {
		__typename?: 'EarlyAccessInvite';
		firstName: string;
		lastName: string;
		email: string;
	} | null;
};

export type GetAllProjectsQueryVariables = Exact<{
	input: GetAllProjectInput;
}>;

export type GetAllProjectsQuery = {
	__typename?: 'Query';
	getAllProjects: {
		__typename?: 'ProjectPage';
		data: Array<{
			__typename?: 'Project';
			id: string;
			name: string;
			description?: string | null;
			startDate?: string | null;
			endDate?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			brand?: { __typename?: 'Brand'; id: string; name: string } | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
		};
	};
};

export type GetProjectProductsBySessionQueryVariables = Exact<{
	sessionId: Scalars['ID']['input'];
}>;

export type GetProjectProductsBySessionQuery = {
	__typename?: 'Query';
	getProjectProductsBySession: Array<{
		__typename?: 'ProjectProduct';
		id: string;
		type: ProjectProductType;
		name?: string | null;
		description?: string | null;
		imageUrls?: Array<string> | null;
		inspirationImageUrls?: Array<string> | null;
		productId?: string | null;
		isProductCreated: boolean;
		sessionId?: string | null;
		projectId?: string | null;
		organizationId?: string | null;
		remixPrompt?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		product?: {
			__typename?: 'Product';
			id: string;
			name: string;
			sku: string;
			description?: string | null;
			images?: Array<{
				__typename?: 'ProductImage';
				id: string;
				url?: string | null;
				isPrimary?: boolean | null;
				name: string;
			}> | null;
		} | null;
	}>;
};

export type GetAllLocalizationTimezonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllLocalizationTimezonesQuery = {
	__typename?: 'Query';
	getAllLocalizationTimezones?: Array<{
		__typename?: 'LocalizationTimezone';
		name: string;
		offset: string;
	}> | null;
};

export type GetAllLocalizationCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllLocalizationCountriesQuery = {
	__typename?: 'Query';
	getAllLocalizationCountries: Array<{
		__typename?: 'LocalizationCountry';
		code: string;
		name: string;
		currency?: string | null;
		defaultTimezone?: string | null;
		defaultMeasurementSystem?: MeasurementSystemEnum | null;
		hasStates: boolean;
		isEU: boolean;
		phonePrefix?: string | null;
		nativeName?: string | null;
		registrations: Array<{
			__typename?: 'LocalizationBusinessRegistrationType';
			code: string;
			label: string;
			placeholder?: string | null;
			helpText?: string | null;
			isRequired: boolean;
			vatDerivationPattern?: string | null;
		}>;
		addressFormat: {
			__typename?: 'LocalizationAddressFormat';
			postalCodeLabel: string;
			stateLabel?: string | null;
			stateRequired: boolean;
		};
	}>;
};

export type GetLocalizationCountryQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
}>;

export type GetLocalizationCountryQuery = {
	__typename?: 'Query';
	getLocalizationCountry: {
		__typename?: 'LocalizationCountry';
		code: string;
		name: string;
		currency?: string | null;
		defaultTimezone?: string | null;
		defaultMeasurementSystem?: MeasurementSystemEnum | null;
		hasStates: boolean;
		isEU: boolean;
		phonePrefix?: string | null;
		nativeName?: string | null;
		registrations: Array<{
			__typename?: 'LocalizationBusinessRegistrationType';
			code: string;
			label: string;
			placeholder?: string | null;
			helpText?: string | null;
			isRequired: boolean;
			vatDerivationPattern?: string | null;
		}>;
		addressFormat: {
			__typename?: 'LocalizationAddressFormat';
			postalCodeLabel: string;
			stateLabel?: string | null;
			stateRequired: boolean;
		};
		states: Array<{ __typename?: 'LocalizationState'; code: string; name: string }>;
	};
};

export type GetLocalizationStatesQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
}>;

export type GetLocalizationStatesQuery = {
	__typename?: 'Query';
	getLocalizationStates: Array<{ __typename?: 'LocalizationState'; code: string; name: string }>;
};

export type ValidateCvrQueryVariables = Exact<{
	cvrNumber: Scalars['String']['input'];
}>;

export type ValidateCvrQuery = {
	__typename?: 'Query';
	validateCVR: {
		__typename?: 'CVRValidationResult';
		valid: boolean;
		error?: string | null;
		companyInfo?: {
			__typename?: 'CVRCompanyInfo';
			name: string;
			vat: string;
			active: boolean;
			startDate?: string | null;
			industryCode?: number | null;
			industryDescription?: string | null;
			employees?: string | null;
			phone?: string | null;
			email?: string | null;
			address: {
				__typename?: 'CVRAddress';
				street: string;
				zipcode: string;
				city: string;
				country: string;
			};
		} | null;
	};
};

export type ValidateBusinessRegistrationQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
}>;

export type ValidateBusinessRegistrationQuery = {
	__typename?: 'Query';
	validateBusinessRegistration: {
		__typename?: 'ValidationResult';
		valid: boolean;
		error?: string | null;
	};
};

export type AddressAutocompleteQueryVariables = Exact<{
	input: Scalars['String']['input'];
	countryCode?: InputMaybe<Scalars['String']['input']>;
	sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressAutocompleteQuery = {
	__typename?: 'Query';
	addressAutocomplete: Array<{
		__typename?: 'PlaceAutocompleteResult';
		placeId: string;
		description: string;
		mainText: string;
		secondaryText: string;
	}>;
};

export type GetPlaceDetailsQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlaceDetailsQuery = {
	__typename?: 'Query';
	getPlaceDetails?: {
		__typename?: 'PlaceDetails';
		placeId: string;
		formattedAddress: string;
		streetNumber?: string | null;
		streetName?: string | null;
		city?: string | null;
		state?: string | null;
		stateCode?: string | null;
		postalCode?: string | null;
		country?: string | null;
		countryCode?: string | null;
		latitude?: number | null;
		longitude?: number | null;
		timezone?: string | null;
	} | null;
};

export type ValidateAddressQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
}>;

export type ValidateAddressQuery = {
	__typename?: 'Query';
	validateAddress: {
		__typename?: 'AddressValidationResult';
		valid: boolean;
		errors: Array<string>;
		warnings: Array<string>;
	};
};

export type GetLocalizationDefaultsQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
}>;

export type GetLocalizationDefaultsQuery = {
	__typename?: 'Query';
	getLocalizationDefaults: {
		__typename?: 'LocalizationDefaults';
		countryCode: string;
		currency: CurrencyEnum;
		measurementSystem: MeasurementSystemEnum;
		timezone: string;
	};
};

export type GenerateVatFromRegistrationQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
}>;

export type GenerateVatFromRegistrationQuery = {
	__typename?: 'Query';
	generateVATFromRegistration?: string | null;
};

export type GetAllLoggingAuditLogQueryVariables = Exact<{
	input: GetAllLoggingAuditLogInput;
}>;

export type GetAllLoggingAuditLogQuery = {
	__typename?: 'Query';
	getAllLoggingAuditLog?: {
		__typename?: 'LoggingAuditLogPage';
		data: Array<{
			__typename?: 'LoggingAuditLog';
			id: string;
			action?: string | null;
			changes?: any | null;
			createdAt?: string | null;
			description?: string | null;
			organizationId?: string | null;
			resource?: string | null;
			resourceId?: string | null;
			serviceName?: string | null;
			status?: string | null;
			updatedAt?: string | null;
			userId?: string | null;
			metadata?: any | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
			totalCount: number;
			totalPages: number;
		};
	} | null;
};

export type GetAllLoggingLoginLogQueryVariables = Exact<{
	input: GetAllLoggingLoginLogInput;
}>;

export type GetAllLoggingLoginLogQuery = {
	__typename?: 'Query';
	getAllLoggingLoginLog?: {
		__typename?: 'LoggingLoginLogPage';
		data: Array<{
			__typename?: 'LoggingLoginLog';
			id: string;
			browser: string;
			createdAt?: string | null;
			failureReason?: string | null;
			ipAddress: string;
			method: string;
			os: string;
			referenceId: string;
			serviceId: string;
			status: string;
			updatedAt?: string | null;
			userAgent: string;
			userId: string;
			user?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				organizationUser?: {
					__typename?: 'OrganizationUser';
					id: string;
					firstName: string;
					lastName: string;
				} | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
			totalCount: number;
			totalPages: number;
		};
	} | null;
};

export type GetAllManufacturersQueryVariables = Exact<{
	input: GetAllManufacturerInput;
}>;

export type GetAllManufacturersQuery = {
	__typename?: 'Query';
	getAllManufacturer: {
		__typename?: 'ManufacturerPage';
		data: Array<{
			__typename?: 'Manufacturer';
			id: string;
			name: string;
			country?: string | null;
			description?: string | null;
			website?: string | null;
			logoUrl?: string | null;
			isActive: boolean;
			createdAt?: string | null;
			updatedAt?: string | null;
			vetterEntity?: { __typename?: 'VetterEntity'; id: string; name: string } | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetManufacturerQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetManufacturerQuery = {
	__typename?: 'Query';
	getManufacturer: {
		__typename?: 'Manufacturer';
		id: string;
		name: string;
		country?: string | null;
		description?: string | null;
		website?: string | null;
		logoUrl?: string | null;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		vetterEntity?: {
			__typename?: 'VetterEntity';
			id: string;
			name: string;
			description?: string | null;
			isActive: boolean;
		} | null;
	};
};

export type GetOrderStatsV2QueryVariables = Exact<{
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
}>;

export type GetOrderStatsV2Query = {
	__typename?: 'Query';
	getOrderStatsV2: {
		__typename?: 'OrderStatsV2';
		totalOrders: number;
		totalOrderAmount: number;
		averageOrderAmount: number;
		medianOrderAmount: number;
		averageDeliveryAmount: number;
		medianDeliveryAmount: number;
		averageMargin: number;
		medianMargin: number;
		organizationId?: string | null;
	};
};

export type GetOrderStatsByStatusV2QueryVariables = Exact<{
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetOrderStatsByStatusV2Query = {
	__typename?: 'Query';
	getOrderStatsByStatusV2: {
		__typename?: 'OrderStatsByStatusV2';
		total: number;
		totalAmount: number;
		organizationId?: string | null;
		statusBreakdown: Array<{
			__typename?: 'OrderStatusBreakdownV2';
			status: QuoteOrderStatusV2;
			count: number;
			percentage: number;
			totalAmount: number;
		}>;
	};
};

export type GetOrganizationSettingQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationSettingQuery = {
	__typename?: 'Query';
	getOrganizationSetting?: {
		__typename?: 'OrganizationSetting';
		id: string;
		measurementSystem: MeasurementSystemEnum;
		currency?: CurrencyEnum | null;
		timezone: string;
		stripeCheckoutLimit?: number | null;
		invoiceMinimumThreshold?: number | null;
		productPaymentMode: PaymentModeEnum;
		samplePaymentMode: PaymentModeEnum;
	} | null;
};

export type GetOrganizationApprovalAndMarginQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationApprovalAndMarginQuery = {
	__typename?: 'Query';
	getOrganizationApprovalAndMargin?: {
		__typename?: 'OrganizationApprovalAndMargin';
		organizationId: string;
		defaultApproval: boolean;
		defaultMargin: number;
	} | null;
};

export type GetAllOrganizationUserQueryVariables = Exact<{
	input: GetAllOrganizationUserInput;
}>;

export type GetAllOrganizationUserQuery = {
	__typename?: 'Query';
	getAllOrganizationUser?: {
		__typename?: 'OrganizationUserPage';
		data?: Array<{
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			avatar?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				lastActive?: string | null;
			} | null;
			authorizationUserRoles?: Array<{
				__typename?: 'AuthorizationUserRole';
				id: string;
				userId: string;
				authorizationRoleId: string;
				authorizationRole?: {
					__typename?: 'AuthorizationRole';
					id: string;
					name: string;
					description?: string | null;
				} | null;
			} | null> | null;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type GetOrganizationUserQueryVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type GetOrganizationUserQuery = {
	__typename?: 'Query';
	getOrganizationUser?: {
		__typename?: 'OrganizationUser';
		id: string;
		firstName: string;
		lastName: string;
		jobPosition?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		authenticationUser?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			role: AuthRoleEnum;
		} | null;
	} | null;
};

export type GetOrganizationQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOrganizationQuery = {
	__typename?: 'Query';
	getOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		logo?: string | null;
		websiteUrl?: string | null;
		organizationIndustryId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organizationIndustry?: {
			__typename?: 'OrganizationIndustry';
			id: string;
			name: string;
			isPublished: boolean;
		} | null;
		addresses?: Array<{
			__typename?: 'OrganizationAddress';
			id: string;
			addressLine1: string;
			addressLine2?: string | null;
			addressType: AddressType;
			city: string;
			countryCode: string;
			postalCode: string;
			stateCode?: string | null;
			isPrimary: boolean;
			name?: string | null;
			googlePlaceId?: string | null;
			latitude?: number | null;
			longitude?: number | null;
		}> | null;
	} | null;
};

export type GetAllOrganizationQueryVariables = Exact<{
	input: GetAllOrganizationInput;
}>;

export type GetAllOrganizationQuery = {
	__typename?: 'Query';
	getAllOrganization: {
		__typename?: 'OrganizationPage';
		data: Array<{
			__typename?: 'Organization';
			id: string;
			name: string;
			logo?: string | null;
			websiteUrl?: string | null;
			organizationIndustryId?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organizationIndustry?: {
				__typename?: 'OrganizationIndustry';
				id: string;
				name: string;
				isPublished: boolean;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationWithSettingsQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationWithSettingsQuery = {
	__typename?: 'Query';
	getOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		logo?: string | null;
		websiteUrl?: string | null;
		organizationIndustryId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organizationIndustry?: {
			__typename?: 'OrganizationIndustry';
			id: string;
			name: string;
			isPublished: boolean;
		} | null;
		organizationSetting?: {
			__typename?: 'OrganizationSetting';
			id: string;
			measurementSystem: MeasurementSystemEnum;
			currency?: CurrencyEnum | null;
			timezone: string;
		} | null;
		addresses?: Array<{
			__typename?: 'OrganizationAddress';
			id: string;
			addressLine1: string;
			addressLine2?: string | null;
			addressType: AddressType;
			city: string;
			countryCode: string;
			postalCode: string;
			stateCode?: string | null;
			isPrimary: boolean;
			name?: string | null;
			googlePlaceId?: string | null;
			latitude?: number | null;
			longitude?: number | null;
		}> | null;
	} | null;
};

export type GetOrganizationAddressesQueryVariables = Exact<{
	organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetOrganizationAddressesQuery = {
	__typename?: 'Query';
	getOrganizationAddresses: Array<{
		__typename?: 'OrganizationAddress';
		id: string;
		name?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		stateCode?: string | null;
		postalCode: string;
		countryCode: string;
		addressType: AddressType;
		isPrimary: boolean;
	}>;
};

export type GetOrganizationCompliancesQueryVariables = Exact<{
	input: OrganizationComplianceListInput;
}>;

export type GetOrganizationCompliancesQuery = {
	__typename?: 'Query';
	getOrganizationCompliances: {
		__typename?: 'OrganizationComplianceListResponse';
		data?: Array<{
			__typename?: 'OrganizationCompliance';
			id: string;
			name: string;
			description?: string | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationSourcingPreferencesQueryVariables = Exact<{
	input: OrganizationSourcingPreferenceListInput;
}>;

export type GetOrganizationSourcingPreferencesQuery = {
	__typename?: 'Query';
	getOrganizationSourcingPreferences: {
		__typename?: 'OrganizationSourcingPreferenceListResponse';
		data: Array<{
			__typename?: 'OrganizationSourcingPreference';
			id: string;
			name: string;
			description?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAllOrganizationIndustriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllOrganizationIndustriesQuery = {
	__typename?: 'Query';
	getAllOrganizationIndustries: Array<{
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
		createdByOrganizationId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	}>;
};

export type GetAllOrganizationIndustriesAdminQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllOrganizationIndustriesAdminQuery = {
	__typename?: 'Query';
	getAllOrganizationIndustriesAdmin: Array<{
		__typename?: 'OrganizationIndustry';
		id: string;
		name: string;
		isPublished: boolean;
		createdByOrganizationId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	}>;
};

export type GetOrganizationPreferencesQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationPreferencesQuery = {
	__typename?: 'Query';
	getOrganizationProductInterests: {
		__typename?: 'OrganizationProductInterestListResponse';
		data?: Array<{
			__typename?: 'OrganizationProductInterest';
			id: string;
			organizationId: string;
			productTagId: string;
		}> | null;
	};
	getOrganizationSourcingPreferenceConnections: {
		__typename?: 'OrganizationSourcingPreferenceConnectionListResponse';
		data: Array<{
			__typename?: 'OrganizationSourcingPreferenceConnection';
			id: string;
			organizationId: string;
			organizationSourcingPreferenceId: string;
			priority?: number | null;
			notes?: string | null;
			organizationSourcingPreference?: {
				__typename?: 'OrganizationSourcingPreference';
				id: string;
				name: string;
				description?: string | null;
			} | null;
		}>;
	};
	getOrganizationComplianceConnections: {
		__typename?: 'OrganizationComplianceConnectionListResponse';
		data: Array<{
			__typename?: 'OrganizationComplianceConnection';
			id: string;
			organizationId: string;
			organizationComplianceId: string;
			certificationNumber?: string | null;
			issueDate?: string | null;
			expiryDate?: string | null;
			certifyingBody?: string | null;
			organizationCompliance?: {
				__typename?: 'OrganizationCompliance';
				id: string;
				name: string;
				description?: string | null;
			} | null;
		}>;
	};
};

export type GetOrganizationProductInterestsQueryVariables = Exact<{
	input: OrganizationProductInterestListInput;
}>;

export type GetOrganizationProductInterestsQuery = {
	__typename?: 'Query';
	getOrganizationProductInterests: {
		__typename?: 'OrganizationProductInterestListResponse';
		data?: Array<{
			__typename?: 'OrganizationProductInterest';
			id: string;
			organizationId: string;
			productTagId: string;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationUserAvatarDownloadUrlQueryVariables = Exact<{
	input: GetDownloadUrlInput;
}>;

export type GetOrganizationUserAvatarDownloadUrlQuery = {
	__typename?: 'Query';
	getOrganizationUserAvatarDownloadUrl: {
		__typename?: 'DownloadUrlResponse';
		success: boolean;
		message?: string | null;
		downloadUrl: string;
		expiresAt: string;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type GetAllProductsQueryVariables = Exact<{
	input: GetAllProductInput;
}>;

export type GetAllProductsQuery = {
	__typename?: 'Query';
	getAllProduct: {
		__typename?: 'ProductPage';
		data: Array<{
			__typename?: 'Product';
			id: string;
			name: string;
			description?: string | null;
			sku: string;
			weight?: number | null;
			status: ProductStatus;
			createdAt?: string | null;
			updatedAt?: string | null;
			dimensions?: {
				__typename?: 'ProductDimensions';
				length?: number | null;
				width?: number | null;
				height?: number | null;
				unit: string;
			} | null;
			images?: Array<{
				__typename?: 'ProductImage';
				id: string;
				url?: string | null;
				name: string;
				isPrimary?: boolean | null;
				altText?: string | null;
				sortOrder?: number | null;
				mimeType: string;
				size: number;
				uploadedAt: string;
			}> | null;
			tags?: Array<{
				__typename?: 'ProductTag';
				id: string;
				name: string;
				color?: string | null;
			}> | null;
			recommendations: Array<{
				__typename?: 'ProductRecommendation';
				id: string;
				productId: string;
				type: ProductRecommendationType;
				title: string;
				description: string;
				actionLabel: string;
				actionUrl?: string | null;
				status: ProductRecommendationStatus;
			}>;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetProductQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetProductQuery = {
	__typename?: 'Query';
	getProduct: {
		__typename?: 'Product';
		id: string;
		name: string;
		description?: string | null;
		sku: string;
		brandId?: string | null;
		weight?: number | null;
		studioFileId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		metadata?: {
			__typename?: 'ProductMetadata';
			isAIGenerated?: boolean | null;
			createdFromProject?: boolean | null;
		} | null;
		dimensions?: {
			__typename?: 'ProductDimensions';
			length?: number | null;
			width?: number | null;
			height?: number | null;
			unit: string;
		} | null;
		images?: Array<{
			__typename?: 'ProductImage';
			id: string;
			url?: string | null;
			name: string;
			type?: ProductImageType | null;
			isPrimary?: boolean | null;
			altText?: string | null;
			mimeType: string;
			sortOrder?: number | null;
			metadata?: Array<{
				__typename?: 'ImageMetadata';
				type: string;
				x?: number | null;
				y?: number | null;
				width?: number | null;
				height?: number | null;
				comment?: string | null;
				canvasWidth: number;
				canvasHeight: number;
				points?: Array<{ __typename?: 'PolygonPoint'; x: number; y: number }> | null;
				attachments?: Array<{
					__typename?: 'MetadataAttachment';
					fileName: string;
					contentType: string;
					size: number;
					url: string;
				}> | null;
			}> | null;
		}> | null;
		brand?: {
			__typename?: 'Brand';
			id: string;
			name: string;
			brandFiles?: Array<{
				__typename?: 'BrandFile';
				id: string;
				name: string;
				url?: string | null;
				type: BrandFileType;
				mimeType: string;
				size: number;
				uploadedAt: string;
			}> | null;
		} | null;
		recommendations: Array<{
			__typename?: 'ProductRecommendation';
			id: string;
			productId: string;
			type: ProductRecommendationType;
			title: string;
			description: string;
			actionLabel: string;
			actionUrl?: string | null;
			status: ProductRecommendationStatus;
		}>;
		studioFile?: {
			__typename?: 'StudioFile';
			id: string;
			name?: string | null;
			currentVersion?: {
				__typename?: 'StudioFileVersion';
				id: string;
				imageUrls: Array<string>;
				versionNumber: number;
			} | null;
		} | null;
	};
};

export type GetAllProductTagsQueryVariables = Exact<{
	input: GetAllProductTagInput;
}>;

export type GetAllProductTagsQuery = {
	__typename?: 'Query';
	getAllProductTag: {
		__typename?: 'ProductTagPage';
		data: Array<{
			__typename?: 'ProductTag';
			id: string;
			name: string;
			parentId?: string | null;
			color?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetProjectQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetProjectQuery = {
	__typename?: 'Query';
	getProject?: {
		__typename?: 'Project';
		id: string;
		name: string;
		description?: string | null;
		startDate?: string | null;
		endDate?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		brand?: { __typename?: 'Brand'; id: string; name: string } | null;
		projectProducts?: Array<{
			__typename?: 'ProjectProduct';
			id: string;
			name?: string | null;
			type: ProjectProductType;
			imageUrls?: Array<string> | null;
			inspirationImageUrls?: Array<string> | null;
			remixPrompt?: string | null;
			productId?: string | null;
			studioFileId?: string | null;
			isProductCreated: boolean;
			isStudioFileCreated: boolean;
			studioFile?: {
				__typename?: 'StudioFile';
				id: string;
				name?: string | null;
				currentVersion?: {
					__typename?: 'StudioFileVersion';
					id: string;
					imageUrls: Array<string>;
					versionNumber: number;
				} | null;
			} | null;
			product?: {
				__typename?: 'Product';
				id: string;
				name: string;
				images?: Array<{
					__typename?: 'ProductImage';
					url?: string | null;
					isPrimary?: boolean | null;
				}> | null;
			} | null;
		}> | null;
	} | null;
};

export type GetQuoteItemOffersStatsV2QueryVariables = Exact<{
	quoteItemV2Id: Scalars['ID']['input'];
}>;

export type GetQuoteItemOffersStatsV2Query = {
	__typename?: 'Query';
	getQuoteItemOffersStatsV2: {
		__typename?: 'QuoteItemOffersStatsV2';
		quoteItemV2Id: string;
		totalOffers: number;
		draftOffers: number;
		submittedOffers: number;
		pendingOffers: number;
		acceptedOffers: number;
		rejectedOffers: number;
		cancelledOffers: number;
	};
};

export type GetAllQuoteItemsOffersStatsV2QueryVariables = Exact<{
	quoteV2Id: Scalars['ID']['input'];
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAllQuoteItemsOffersStatsV2Query = {
	__typename?: 'Query';
	getAllQuoteItemsOffersStatsV2: Array<{
		__typename?: 'QuoteItemOffersStatsV2';
		quoteItemV2Id: string;
		totalOffers: number;
		draftOffers: number;
		submittedOffers: number;
		pendingOffers: number;
		acceptedOffers: number;
		rejectedOffers: number;
		cancelledOffers: number;
	}>;
};

export type GetQuoteItemOffersV2QueryVariables = Exact<{
	quoteItemV2Id: Scalars['ID']['input'];
	statusFilter?: InputMaybe<Array<QuoteOfferStatusV2> | QuoteOfferStatusV2>;
	inCurrency?: InputMaybe<CurrencyEnum>;
	releasedToClient?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetQuoteItemOffersV2Query = {
	__typename?: 'Query';
	getQuoteItemOffersV2: Array<{
		__typename?: 'QuoteOfferV2';
		id: string;
		name: string;
		status: QuoteOfferStatusV2;
		submittedAt?: string | null;
		acceptDeadline?: string | null;
		manufacturerId?: string | null;
		vetterId?: string | null;
		quoteOfferBatchV2Id?: string | null;
		batch?: {
			__typename?: 'QuoteOfferBatchV2';
			id: string;
			name: string;
			status: QuoteOfferStatusV2;
			acceptDeadlineType?: AcceptDeadlineTypeV2 | null;
			vetterId?: string | null;
			manufacturerId?: string | null;
			manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null;
			vetter?: {
				__typename?: 'VetterUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
		items: Array<{
			__typename?: 'QuoteOfferItemV2';
			id: string;
			quoteItemV2Id: string;
			variations: Array<{
				__typename?: 'QuoteOfferItemVariationV2';
				id: string;
				name: string;
				description?: string | null;
				releasedToClient: boolean;
				attachments?: Array<{
					__typename?: 'QuoteOfferAttachmentV2';
					id: string;
					name: string;
					url?: string | null;
					size: number;
					mimeType: string;
				}> | null;
				adjustments: Array<{
					__typename?: 'QuoteOfferItemVariationAdjustmentV2';
					id: string;
					name: string;
					description?: string | null;
					type: AdjustmentTypeV2;
					calculationType: AdjustmentCalculationTypeV2;
					value: number;
					createdByType: AdjustmentCreatorTypeV2;
				}>;
				sampleChoice?: {
					__typename?: 'QuoteOfferItemSampleChoiceV2';
					id: string;
					choice: SampleChoiceV2;
					sample: {
						__typename?: 'QuoteOfferItemSampleV2';
						id: string;
						adminPrice: number;
						baseSamplePrice: number;
						baseShippingPrice?: number | null;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
						minProductionDays?: number | null;
						maxProductionDays?: number | null;
					};
				} | null;
				quantities: Array<{
					__typename?: 'QuoteOfferItemVariationQuantityV2';
					id: string;
					quoteItemQuantityV2Id?: string | null;
					quantity: number;
					releasedToClient: boolean;
					baseUnitPrice: number;
					unitPrice?: number | null;
					marginAmount?: number | null;
					marginPercentage?: number | null;
					minProductionDays?: number | null;
					maxProductionDays?: number | null;
					deliveries: Array<{
						__typename?: 'QuoteOfferItemDeliveryV2';
						id: string;
						quantity: number;
						basePrice: number;
						totalPrice: number;
						deliveryDaysMin: number;
						deliveryDaysMax: number;
						shippingMethod: ShippingMethodV2;
					}>;
				}>;
			}>;
		}>;
	}>;
};

export type GetQuoteOffersForCheckoutV2QueryVariables = Exact<{
	ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetQuoteOffersForCheckoutV2Query = {
	__typename?: 'Query';
	getQuoteOffersV2: Array<{
		__typename?: 'QuoteOfferV2';
		id: string;
		name: string;
		items: Array<{
			__typename?: 'QuoteOfferItemV2';
			id: string;
			variations: Array<{
				__typename?: 'QuoteOfferItemVariationV2';
				id: string;
				name: string;
				adjustments: Array<{
					__typename?: 'QuoteOfferItemVariationAdjustmentV2';
					id: string;
					name: string;
					type: AdjustmentTypeV2;
					calculationType: AdjustmentCalculationTypeV2;
					value: number;
				}>;
				sampleChoice?: {
					__typename?: 'QuoteOfferItemSampleChoiceV2';
					id: string;
					choice: SampleChoiceV2;
					sample: {
						__typename?: 'QuoteOfferItemSampleV2';
						id: string;
						adminPrice: number;
					};
				} | null;
				quantities: Array<{
					__typename?: 'QuoteOfferItemVariationQuantityV2';
					id: string;
					quantity: number;
					baseUnitPrice: number;
					unitPrice?: number | null;
					totalPrice?: number | null;
					adjustedTotalPrice?: number | null;
					deliveries: Array<{
						__typename?: 'QuoteOfferItemDeliveryV2';
						id: string;
						totalPrice: number;
						shippingMethod: ShippingMethodV2;
					}>;
				}>;
			}>;
		}>;
	}>;
};

export type GetAllQuoteOrdersV2QueryVariables = Exact<{
	input: GetAllQuoteOrdersV2Input;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetAllQuoteOrdersV2Query = {
	__typename?: 'Query';
	getAllQuoteOrdersV2: {
		__typename?: 'GetAllQuoteOrdersV2Response';
		data?: Array<{
			__typename?: 'QuoteOrderV2';
			id: string;
			orderNumber: string;
			name: string;
			description?: string | null;
			totalAmount: number;
			baseTotalAmount?: number | null;
			adjustedTotalAmount?: number | null;
			marginTotal?: number | null;
			status: QuoteOrderStatusV2;
			createdAt: string;
			completedAt?: string | null;
			confirmedAt?: string | null;
			acceptDeadline?: string | null;
			organizationId: string;
			quote: {
				__typename?: 'QuoteV2';
				id: string;
				name: string;
				organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			};
			items: Array<{ __typename?: 'QuoteOrderItemV2'; id: string; quantity: number }>;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
	};
};

export type GetQuoteOrderV2QueryVariables = Exact<{
	id: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetQuoteOrderV2Query = {
	__typename?: 'Query';
	getQuoteOrderV2?: {
		__typename?: 'QuoteOrderV2';
		id: string;
		orderNumber: string;
		name: string;
		description?: string | null;
		totalAmount: number;
		baseTotalAmount?: number | null;
		adjustedTotalAmount?: number | null;
		marginTotal?: number | null;
		status: QuoteOrderStatusV2;
		createdAt: string;
		updatedAt: string;
		completedAt?: string | null;
		confirmedAt?: string | null;
		acceptDeadline?: string | null;
		organizationId: string;
		stripeCheckoutLimit?: number | null;
		invoiceMinimum?: number | null;
		productPaymentMode: PaymentModeEnum;
		samplePaymentMode: PaymentModeEnum;
		invoiceRecipientOrgUserId?: string | null;
		invoiceRecipientEmail?: string | null;
		quote: {
			__typename?: 'QuoteV2';
			id: string;
			name: string;
			description?: string | null;
			deadline?: string | null;
			deliveryAddress?: {
				__typename?: 'DeliveryAddressV2';
				addressLine1?: string | null;
				addressLine2?: string | null;
				city?: string | null;
				stateCode?: string | null;
				postalCode?: string | null;
				countryCode?: string | null;
			} | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		};
		items: Array<{
			__typename?: 'QuoteOrderItemV2';
			id: string;
			quantity: number;
			baseUnitPrice: number;
			unitPrice: number;
			baseTotalPrice?: number | null;
			totalPrice: number;
			adjustedTotalPrice?: number | null;
			marginAmount?: number | null;
			marginPercentage?: number | null;
			notes?: string | null;
			sortOrder: number;
			status: QuoteOrderItemStatusV2;
			sampleChoice?: SampleChoiceV2 | null;
			productionStartedAt?: string | null;
			productionCompletedAt?: string | null;
			snapshotAdjustments?: any | null;
			snapshotAttachments?: any | null;
			manufacturerId?: string | null;
			vetterId?: string | null;
			isProductPaymentPaid: boolean;
			deliveries: Array<{
				__typename?: 'QuoteOrderItemDeliveryV2';
				id: string;
				quantity: number;
				shippingMethod: ShippingMethodV2;
				deliveryDaysMin: number;
				deliveryDaysMax: number;
				basePrice?: number | null;
				adminFee?: number | null;
				totalPrice?: number | null;
				status: QuoteOrderItemDeliveryStatusV2;
				carrier?: string | null;
				trackingNumber?: string | null;
				estimatedDeliveryDate?: string | null;
				shippedAt?: string | null;
				actualDeliveryDate?: string | null;
				deliveryGroupId?: string | null;
				deliveryGroupName?: string | null;
				offerDelivery: {
					__typename?: 'QuoteOfferItemDeliveryV2';
					id: string;
					variationQuantity: {
						__typename?: 'QuoteOfferItemVariationQuantityV2';
						id: string;
						minProductionDays?: number | null;
						maxProductionDays?: number | null;
					};
				};
			}>;
			samples: Array<{
				__typename?: 'QuoteOrderItemSampleV2';
				id: string;
				sampleChoice: SampleChoiceV2;
				sampleRound: number;
				status: QuoteOrderItemSampleStatusV2;
				isDeductible: boolean;
				deliveryMethod: QuoteOrderItemSampleDeliveryMethodV2;
				carrier?: string | null;
				trackingNumber?: string | null;
				estimatedDeliveryDate?: string | null;
				shippedAt?: string | null;
				actualDeliveryDate?: string | null;
				virtualDeliverySubmittedAt?: string | null;
				productionStartedAt?: string | null;
				productionCompletedAt?: string | null;
				samplePrice?: number | null;
				shippingPrice?: number | null;
				totalSampleCost?: number | null;
				adminPrice?: number | null;
				adminPriceDkk?: number | null;
				paymentStatus: SamplePaymentStatus;
				virtualDelivery?: {
					__typename?: 'SampleVirtualDeliveryV2';
					sampleId: string;
					submittedAt?: string | null;
					notes?: string | null;
					attachments: Array<{
						__typename?: 'SampleVirtualDeliveryAttachmentV2';
						fileId: string;
						fileName: string;
						fileType: string;
						fileSize: number;
						caption?: string | null;
						uploadedAt?: string | null;
						downloadUrl: string;
						expiresAt: string;
					}>;
				} | null;
				samplePayment?: {
					__typename?: 'SamplePayment';
					id: string;
					createdAt: string;
					description?: string | null;
					samplePrice: number;
					shippingPrice: number;
					totalPrice: number;
					currency: CurrencyEnum;
					paidAt?: string | null;
					paymentStatus: SamplePaymentStatus;
					invoice?: {
						__typename?: 'SamplePaymentInvoice';
						id: string;
						status: SamplePaymentInvoiceStatus;
						economicBookedInvoiceNumber?: number | null;
					} | null;
				} | null;
				currentApproval?: {
					__typename?: 'QuoteOrderItemSampleApprovalV2';
					id: string;
					decision: QuoteOrderItemSampleApprovalDecisionV2;
					approvedAt: string;
					approvalNotes?: string | null;
					requestNewSample?: boolean | null;
					newSampleRequestStatus?: NewSampleRequestStatusV2 | null;
					nextSampleChoice?: SampleChoiceV2 | null;
					reviewedAt?: string | null;
					reviewedByUserId?: string | null;
					reviewHistory?: Array<{
						__typename?: 'QuoteOrderItemSampleApprovalReviewHistoryEntryV2';
						at: string;
						actor: QuoteOrderItemSampleApprovalReviewHistoryActorV2;
						action: QuoteOrderItemSampleApprovalReviewHistoryActionV2;
						notes?: string | null;
						userId?: string | null;
					}> | null;
					rejectionAttachments: Array<{
						__typename?: 'SampleVirtualDeliveryAttachmentV2';
						fileId: string;
						fileName: string;
						fileType: string;
						fileSize: number;
						caption?: string | null;
						uploadedAt?: string | null;
						downloadUrl: string;
						expiresAt: string;
					}>;
				} | null;
				approvals: Array<{
					__typename?: 'QuoteOrderItemSampleApprovalV2';
					id: string;
					createdAt: string;
					decision: QuoteOrderItemSampleApprovalDecisionV2;
					approvedAt: string;
					approvalNotes?: string | null;
					requestNewSample?: boolean | null;
					newSampleRequestStatus?: NewSampleRequestStatusV2 | null;
					nextSampleChoice?: SampleChoiceV2 | null;
					reviewedAt?: string | null;
					reviewedByUserId?: string | null;
					approvedByUserId: string;
					reviewHistory?: Array<{
						__typename?: 'QuoteOrderItemSampleApprovalReviewHistoryEntryV2';
						at: string;
						actor: QuoteOrderItemSampleApprovalReviewHistoryActorV2;
						action: QuoteOrderItemSampleApprovalReviewHistoryActionV2;
						notes?: string | null;
						userId?: string | null;
					}> | null;
					rejectionAttachments: Array<{
						__typename?: 'SampleVirtualDeliveryAttachmentV2';
						fileId: string;
						fileName: string;
						fileType: string;
						fileSize: number;
						caption?: string | null;
						uploadedAt?: string | null;
						downloadUrl: string;
						expiresAt: string;
					}>;
				}>;
			}>;
			variationQuantity: {
				__typename?: 'QuoteOfferItemVariationQuantityV2';
				id: string;
				quantity: number;
				minProductionDays?: number | null;
				maxProductionDays?: number | null;
				variation: {
					__typename?: 'QuoteOfferItemVariationV2';
					id: string;
					name: string;
					description?: string | null;
					offerItem: {
						__typename?: 'QuoteOfferItemV2';
						id: string;
						quoteOffer: {
							__typename?: 'QuoteOfferV2';
							id: string;
							name: string;
							manufacturer?: {
								__typename?: 'Manufacturer';
								id: string;
								name: string;
								logoUrl?: string | null;
							} | null;
							vetter?: {
								__typename?: 'VetterUser';
								id: string;
								firstName: string;
								lastName: string;
							} | null;
						};
						quoteItem: {
							__typename?: 'QuoteItemV2';
							id: string;
							deadline?: string | null;
							product?: {
								__typename?: 'Product';
								id: string;
								name: string;
								sku: string;
								description?: string | null;
								images?: Array<{
									__typename?: 'ProductImage';
									id: string;
									url?: string | null;
									name: string;
									mimeType: string;
									sortOrder?: number | null;
								}> | null;
								brand?: {
									__typename?: 'Brand';
									id: string;
									name: string;
									logo?: { __typename?: 'BrandLogo'; url?: string | null } | null;
								} | null;
							} | null;
						};
					};
				};
			};
		}>;
	} | null;
};

export type GetOrderCheckoutLimitV2QueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
}>;

export type GetOrderCheckoutLimitV2Query = {
	__typename?: 'Query';
	getOrderCheckoutLimitV2: {
		__typename?: 'OrderCheckoutLimitV2';
		limit?: number | null;
		invoiceMinimum?: number | null;
		source: string;
	};
};

export type GetProductPaymentPreviewV2QueryVariables = Exact<{
	orderItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
	currency: Scalars['String']['input'];
}>;

export type GetProductPaymentPreviewV2Query = {
	__typename?: 'Query';
	getProductPaymentPreviewV2: {
		__typename?: 'ProductPaymentPreviewV2';
		currency: string;
		grandTotal: number;
		items: Array<{
			__typename?: 'ProductPaymentPreviewLineV2';
			orderItemId: string;
			label: string;
			productsAmount: number;
			feesAmount: number;
			deliveryAmount: number;
			deductibleAmount: number;
			deductibleSampleCount: number;
			lineSubtotal: number;
			lineNetAmount: number;
			fees: Array<{
				__typename?: 'ProductPaymentPreviewFeeV2';
				name: string;
				amount: number;
			}>;
			deliveries: Array<{
				__typename?: 'ProductPaymentPreviewDeliveryV2';
				method: string;
				amount: number;
			}>;
		}>;
	};
};

export type GetOrderTransactionsV2QueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
}>;

export type GetOrderTransactionsV2Query = {
	__typename?: 'Query';
	getOrderTransactionsV2: Array<{
		__typename?: 'OrderTransactionRowV2';
		key: string;
		kind: OrderTransactionKindV2;
		date: string;
		totalPrice: number;
		currency: CurrencyEnum;
		status: string;
		paidAt?: string | null;
		method?: string | null;
		invoiceNumber?: number | null;
		isHistory: boolean;
		paymentTransactionId?: string | null;
		descriptions: Array<{
			__typename?: 'OrderTransactionDescriptionV2';
			text: string;
			sampleRound?: number | null;
		}>;
	}>;
};

export type GetQuoteOrderTimelineV2QueryVariables = Exact<{
	orderId: Scalars['ID']['input'];
}>;

export type GetQuoteOrderTimelineV2Query = {
	__typename?: 'Query';
	getQuoteOrderTimelineV2: {
		__typename?: 'QuoteOrderTimelineV2';
		orderEvents: Array<{
			__typename?: 'QuoteOrderTimelineEventV2';
			id: string;
			type: QuoteOrderTimelineEventTypeV2;
			category: QuoteOrderTimelineEventCategoryV2;
			title: string;
			description?: string | null;
			date: string;
			metadata?: {
				__typename?: 'QuoteOrderTimelineEventMetadataV2';
				trackingNumber?: string | null;
				carrier?: string | null;
				shippingMethod?: string | null;
				sampleRound?: number | null;
				deliveryMethod?: string | null;
				approvalDecision?: string | null;
				approvalNotes?: string | null;
				deliveryGroupName?: string | null;
			} | null;
		}>;
		itemGroups: Array<{
			__typename?: 'QuoteOrderTimelineItemGroupV2';
			orderItemId: string;
			itemName: string;
			sortOrder: number;
			events: Array<{
				__typename?: 'QuoteOrderTimelineEventV2';
				id: string;
				type: QuoteOrderTimelineEventTypeV2;
				category: QuoteOrderTimelineEventCategoryV2;
				title: string;
				description?: string | null;
				date: string;
				metadata?: {
					__typename?: 'QuoteOrderTimelineEventMetadataV2';
					trackingNumber?: string | null;
					carrier?: string | null;
					shippingMethod?: string | null;
					sampleRound?: number | null;
					deliveryMethod?: string | null;
					approvalDecision?: string | null;
					approvalNotes?: string | null;
					deliveryGroupName?: string | null;
				} | null;
			}>;
		}>;
	};
};

export type GetInvoiceableItemsForOrgV2QueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
	currency: Scalars['String']['input'];
}>;

export type GetInvoiceableItemsForOrgV2Query = {
	__typename?: 'Query';
	getInvoiceableItemsForOrgV2: {
		__typename?: 'GetInvoiceableItemsForOrgV2Response';
		currency: string;
		orders: Array<{
			__typename?: 'InvoiceableOrderV2';
			orderId: string;
			orderNumber: string;
			orderName: string;
			productPaymentMode: PaymentModeEnum;
			samplePaymentMode: PaymentModeEnum;
			items: Array<{
				__typename?: 'InvoiceableItemV2';
				orderItemId: string;
				description: string;
				quantity: number;
				productAmount?: number | null;
				feesAmount?: number | null;
				deliveryAmount?: number | null;
				deductibleAmount?: number | null;
				deductibleSampleCount?: number | null;
				lineSubtotal?: number | null;
				lineNetAmount?: number | null;
				productStatus?: InvoiceableLineStatusV2 | null;
				productDraftId?: string | null;
				productEconomicInvoiceNumber?: number | null;
				orderItem: {
					__typename?: 'QuoteOrderItemV2';
					id: string;
					variationQuantity: {
						__typename?: 'QuoteOfferItemVariationQuantityV2';
						variation: {
							__typename?: 'QuoteOfferItemVariationV2';
							offerItem: {
								__typename?: 'QuoteOfferItemV2';
								quoteItem: {
									__typename?: 'QuoteItemV2';
									product?: {
										__typename?: 'Product';
										images?: Array<{
											__typename?: 'ProductImage';
											url?: string | null;
											sortOrder?: number | null;
										}> | null;
									} | null;
								};
							};
						};
					};
				};
				fees: Array<{
					__typename?: 'ProductPaymentPreviewFeeV2';
					name: string;
					amount: number;
				}>;
				deliveries: Array<{
					__typename?: 'ProductPaymentPreviewDeliveryV2';
					method: string;
					amount: number;
				}>;
				samples: Array<{
					__typename?: 'InvoiceableSampleV2';
					sampleId: string;
					sampleRound: number;
					amount?: number | null;
					isDeductible: boolean;
					status: InvoiceableLineStatusV2;
					draftId?: string | null;
					economicInvoiceNumber?: number | null;
				}>;
			}>;
		}>;
	};
};

export type GetQuoteOrganizationV2QueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetQuoteOrganizationV2Query = {
	__typename?: 'Query';
	getQuoteV2?: {
		__typename?: 'QuoteV2';
		id: string;
		name: string;
		description?: string | null;
		deadline?: string | null;
		purpose?: QuotePurposeV2 | null;
		purposeOther?: string | null;
		status: QuoteStatusV2;
		organizationId: string;
		contactUserIds: Array<string>;
		createdAt?: string | null;
		updatedAt?: string | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		deliveryAddress?: {
			__typename?: 'DeliveryAddressV2';
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			stateCode?: string | null;
			postalCode?: string | null;
			countryCode?: string | null;
		} | null;
		items: Array<{
			__typename?: 'QuoteItemV2';
			id: string;
			productId: string;
			sortOrder: number;
			deadline?: string | null;
			product?: {
				__typename?: 'Product';
				description?: string | null;
				id: string;
				name: string;
				sku: string;
				weight?: number | null;
				brand?: { __typename?: 'Brand'; id: string; name: string } | null;
				dimensions?: {
					__typename?: 'ProductDimensions';
					length?: number | null;
					width?: number | null;
					height?: number | null;
					unit: string;
				} | null;
				images?: Array<{
					__typename?: 'ProductImage';
					id: string;
					url?: string | null;
					name: string;
					mimeType: string;
				}> | null;
			} | null;
			quantities: Array<{
				__typename?: 'QuoteItemQuantityV2';
				id: string;
				quantity: number;
				sortOrder: number;
			}>;
		}>;
	} | null;
};

export type GetQuoteOfferBatchesOrganizationV2QueryVariables = Exact<{
	quoteV2Id: Scalars['ID']['input'];
	statusFilter?: InputMaybe<Array<QuoteOfferStatusV2> | QuoteOfferStatusV2>;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetQuoteOfferBatchesOrganizationV2Query = {
	__typename?: 'Query';
	getQuoteOfferBatchesV2: Array<{
		__typename?: 'QuoteOfferBatchV2';
		id: string;
		name: string;
		status: QuoteOfferStatusV2;
		acceptDeadline?: string | null;
		acceptDeadlineType?: AcceptDeadlineTypeV2 | null;
		submittedAt?: string | null;
		sentToClientAt?: string | null;
		manufacturerId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null;
		offers: Array<{
			__typename?: 'QuoteOfferV2';
			id: string;
			items: Array<{
				__typename?: 'QuoteOfferItemV2';
				id: string;
				quoteItemV2Id: string;
				variations: Array<{
					__typename?: 'QuoteOfferItemVariationV2';
					id: string;
					name: string;
					description?: string | null;
					attachments?: Array<{
						__typename?: 'QuoteOfferAttachmentV2';
						id: string;
						name: string;
						url?: string | null;
						size: number;
						mimeType: string;
					}> | null;
					adjustments: Array<{
						__typename?: 'QuoteOfferItemVariationAdjustmentV2';
						id: string;
						name: string;
						description?: string | null;
						type: AdjustmentTypeV2;
						calculationType: AdjustmentCalculationTypeV2;
						value: number;
						createdByType: AdjustmentCreatorTypeV2;
					}>;
					sampleChoice?: {
						__typename?: 'QuoteOfferItemSampleChoiceV2';
						id: string;
						choice: SampleChoiceV2;
						sample: {
							__typename?: 'QuoteOfferItemSampleV2';
							id: string;
							adminPrice: number;
							totalSamplePrice: number;
							deliveryDaysMin?: number | null;
							deliveryDaysMax?: number | null;
							minProductionDays?: number | null;
							maxProductionDays?: number | null;
						};
					} | null;
					quantities: Array<{
						__typename?: 'QuoteOfferItemVariationQuantityV2';
						id: string;
						quoteItemQuantityV2Id?: string | null;
						quantity: number;
						unitPrice?: number | null;
						totalPrice?: number | null;
						minProductionDays?: number | null;
						maxProductionDays?: number | null;
						deliveries: Array<{
							__typename?: 'QuoteOfferItemDeliveryV2';
							id: string;
							quantity: number;
							totalPrice: number;
							deliveryDaysMin: number;
							deliveryDaysMax: number;
							shippingMethod: ShippingMethodV2;
						}>;
					}>;
				}>;
			}>;
		}>;
	}>;
};

export type GetQuoteItemOffersOrganizationV2QueryVariables = Exact<{
	quoteItemV2Id: Scalars['ID']['input'];
	statusFilter?: InputMaybe<Array<QuoteOfferStatusV2> | QuoteOfferStatusV2>;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetQuoteItemOffersOrganizationV2Query = {
	__typename?: 'Query';
	getQuoteItemOffersV2: Array<{
		__typename?: 'QuoteOfferV2';
		id: string;
		name: string;
		status: QuoteOfferStatusV2;
		acceptDeadline?: string | null;
		submittedAt?: string | null;
		sentToClientAt?: string | null;
		quoteOfferBatchV2Id?: string | null;
		manufacturerId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		batch?: {
			__typename?: 'QuoteOfferBatchV2';
			id: string;
			name: string;
			acceptDeadlineType?: AcceptDeadlineTypeV2 | null;
		} | null;
		manufacturer?: {
			__typename?: 'Manufacturer';
			id: string;
			name: string;
			logoUrl?: string | null;
		} | null;
		items: Array<{
			__typename?: 'QuoteOfferItemV2';
			id: string;
			quoteItemV2Id: string;
			variations: Array<{
				__typename?: 'QuoteOfferItemVariationV2';
				id: string;
				name: string;
				description?: string | null;
				attachments?: Array<{
					__typename?: 'QuoteOfferAttachmentV2';
					id: string;
					name: string;
					url?: string | null;
					size: number;
					mimeType: string;
				}> | null;
				adjustments: Array<{
					__typename?: 'QuoteOfferItemVariationAdjustmentV2';
					id: string;
					name: string;
					description?: string | null;
					type: AdjustmentTypeV2;
					calculationType: AdjustmentCalculationTypeV2;
					value: number;
					createdByType: AdjustmentCreatorTypeV2;
				}>;
				sampleChoice?: {
					__typename?: 'QuoteOfferItemSampleChoiceV2';
					id: string;
					choice: SampleChoiceV2;
					sample: {
						__typename?: 'QuoteOfferItemSampleV2';
						id: string;
						adminPrice: number;
						totalSamplePrice: number;
						deliveryDaysMin?: number | null;
						deliveryDaysMax?: number | null;
						minProductionDays?: number | null;
						maxProductionDays?: number | null;
					};
				} | null;
				quantities: Array<{
					__typename?: 'QuoteOfferItemVariationQuantityV2';
					id: string;
					quoteItemQuantityV2Id?: string | null;
					quantity: number;
					unitPrice?: number | null;
					totalPrice?: number | null;
					minProductionDays?: number | null;
					maxProductionDays?: number | null;
					deliveries: Array<{
						__typename?: 'QuoteOfferItemDeliveryV2';
						id: string;
						quantity: number;
						totalPrice: number;
						deliveryDaysMin: number;
						deliveryDaysMax: number;
						shippingMethod: ShippingMethodV2;
					}>;
				}>;
			}>;
		}>;
	}>;
};

export type GetQuoteV2QueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetQuoteV2Query = {
	__typename?: 'Query';
	getQuoteV2?: {
		__typename?: 'QuoteV2';
		id: string;
		name: string;
		description?: string | null;
		deadline?: string | null;
		purpose?: QuotePurposeV2 | null;
		purposeOther?: string | null;
		status: QuoteStatusV2;
		organizationId: string;
		contactUserIds: Array<string>;
		isCurrentForMe: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		vetterEntityIds?: Array<string> | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		deliveryAddress?: {
			__typename?: 'DeliveryAddressV2';
			addressLine1?: string | null;
			addressLine2?: string | null;
			city?: string | null;
			stateCode?: string | null;
			postalCode?: string | null;
			countryCode?: string | null;
		} | null;
		items: Array<{
			__typename?: 'QuoteItemV2';
			id: string;
			productId: string;
			sortOrder: number;
			deadline?: string | null;
			product?: {
				__typename?: 'Product';
				description?: string | null;
				id: string;
				name: string;
				sku: string;
				weight?: number | null;
				brand?: { __typename?: 'Brand'; id: string; name: string } | null;
				dimensions?: {
					__typename?: 'ProductDimensions';
					length?: number | null;
					width?: number | null;
					height?: number | null;
					unit: string;
				} | null;
				images?: Array<{
					__typename?: 'ProductImage';
					id: string;
					url?: string | null;
					name: string;
					mimeType: string;
				}> | null;
			} | null;
			quantities: Array<{
				__typename?: 'QuoteItemQuantityV2';
				id: string;
				quantity: number;
				sortOrder: number;
			}>;
		}>;
	} | null;
};

export type GetCurrentQuoteV2QueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentQuoteV2Query = {
	__typename?: 'Query';
	getCurrentQuoteV2?: {
		__typename?: 'QuoteV2';
		id: string;
		name: string;
		description?: string | null;
		deadline?: string | null;
		status: QuoteStatusV2;
		organizationId: string;
		isCurrentForMe: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		items: Array<{
			__typename?: 'QuoteItemV2';
			id: string;
			productId: string;
			sortOrder: number;
			deadline?: string | null;
			product?: {
				__typename?: 'Product';
				id: string;
				name: string;
				sku: string;
				weight?: number | null;
				dimensions?: {
					__typename?: 'ProductDimensions';
					length?: number | null;
					width?: number | null;
					height?: number | null;
					unit: string;
				} | null;
				images?: Array<{
					__typename?: 'ProductImage';
					id: string;
					url?: string | null;
					name: string;
					mimeType: string;
				}> | null;
			} | null;
			quantities: Array<{
				__typename?: 'QuoteItemQuantityV2';
				id: string;
				quantity: number;
				sortOrder: number;
			}>;
		}>;
	} | null;
};

export type GetCurrentQuoteV2CountQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentQuoteV2CountQuery = {
	__typename?: 'Query';
	getCurrentQuoteV2?: {
		__typename?: 'QuoteV2';
		id: string;
		organizationId: string;
		items: Array<{
			__typename?: 'QuoteItemV2';
			id: string;
			productId: string;
			product?: {
				__typename?: 'Product';
				id: string;
				name: string;
				sku: string;
				weight?: number | null;
				dimensions?: {
					__typename?: 'ProductDimensions';
					length?: number | null;
					width?: number | null;
					height?: number | null;
					unit: string;
				} | null;
				images?: Array<{
					__typename?: 'ProductImage';
					id: string;
					url?: string | null;
					name: string;
					mimeType: string;
				}> | null;
			} | null;
		}>;
	} | null;
};

export type GetAllQuotesV2QueryVariables = Exact<{
	input: GetAllQuotesV2Input;
}>;

export type GetAllQuotesV2Query = {
	__typename?: 'Query';
	getAllQuotesV2?: {
		__typename?: 'GetAllQuotesV2Response';
		data?: Array<{
			__typename?: 'QuoteV2';
			id: string;
			name: string;
			description?: string | null;
			deadline?: string | null;
			status: QuoteStatusV2;
			organizationId: string;
			isCurrentForMe: boolean;
			createdAt?: string | null;
			updatedAt?: string | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			items: Array<{ __typename?: 'QuoteItemV2'; id: string; deadline?: string | null }>;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
		} | null;
	} | null;
};

export type GetQuoteOfferBatchesV2QueryVariables = Exact<{
	quoteV2Id: Scalars['ID']['input'];
	statusFilter?: InputMaybe<Array<QuoteOfferStatusV2> | QuoteOfferStatusV2>;
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetQuoteOfferBatchesV2Query = {
	__typename?: 'Query';
	getQuoteOfferBatchesV2: Array<{
		__typename?: 'QuoteOfferBatchV2';
		id: string;
		name: string;
		status: QuoteOfferStatusV2;
		acceptDeadline?: string | null;
		acceptDeadlineType?: AcceptDeadlineTypeV2 | null;
		submittedAt?: string | null;
		sentToClientAt?: string | null;
		totalVariationsCount: number;
		releasedVariationsCount: number;
		manufacturerId?: string | null;
		vetterId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null;
		vetter?: {
			__typename?: 'VetterUser';
			id: string;
			firstName: string;
			lastName: string;
		} | null;
		offers: Array<{
			__typename?: 'QuoteOfferV2';
			id: string;
			items: Array<{
				__typename?: 'QuoteOfferItemV2';
				id: string;
				quoteItemV2Id: string;
				variations: Array<{
					__typename?: 'QuoteOfferItemVariationV2';
					id: string;
					name: string;
					description?: string | null;
					attachments?: Array<{
						__typename?: 'QuoteOfferAttachmentV2';
						id: string;
						name: string;
						url?: string | null;
						size: number;
						mimeType: string;
					}> | null;
					adjustments: Array<{
						__typename?: 'QuoteOfferItemVariationAdjustmentV2';
						id: string;
						name: string;
						description?: string | null;
						type: AdjustmentTypeV2;
						calculationType: AdjustmentCalculationTypeV2;
						value: number;
						createdByType: AdjustmentCreatorTypeV2;
					}>;
					sampleChoice?: {
						__typename?: 'QuoteOfferItemSampleChoiceV2';
						id: string;
						choice: SampleChoiceV2;
						sample: {
							__typename?: 'QuoteOfferItemSampleV2';
							id: string;
							baseSamplePrice: number;
							baseShippingPrice?: number | null;
							deliveryDaysMin?: number | null;
							deliveryDaysMax?: number | null;
							minProductionDays?: number | null;
							maxProductionDays?: number | null;
						};
					} | null;
					quantities: Array<{
						__typename?: 'QuoteOfferItemVariationQuantityV2';
						id: string;
						quoteItemQuantityV2Id?: string | null;
						quantity: number;
						baseUnitPrice: number;
						unitPrice?: number | null;
						totalPrice?: number | null;
						marginAmount?: number | null;
						marginPercentage?: number | null;
						minProductionDays?: number | null;
						maxProductionDays?: number | null;
						deliveries: Array<{
							__typename?: 'QuoteOfferItemDeliveryV2';
							id: string;
							quantity: number;
							basePrice: number;
							deliveryDaysMin: number;
							deliveryDaysMax: number;
							shippingMethod: ShippingMethodV2;
						}>;
					}>;
				}>;
			}>;
		}>;
	}>;
};

export type GetQuoteOfferBatchV2QueryVariables = Exact<{
	id: Scalars['ID']['input'];
	inCurrency?: InputMaybe<CurrencyEnum>;
}>;

export type GetQuoteOfferBatchV2Query = {
	__typename?: 'Query';
	getQuoteOfferBatchV2?: {
		__typename?: 'QuoteOfferBatchV2';
		id: string;
		name: string;
		status: QuoteOfferStatusV2;
		acceptDeadline?: string | null;
		acceptDeadlineType?: AcceptDeadlineTypeV2 | null;
		manufacturerId?: string | null;
		vetterId?: string | null;
		quoteV2Id: string;
		offers: Array<{
			__typename?: 'QuoteOfferV2';
			id: string;
			items: Array<{
				__typename?: 'QuoteOfferItemV2';
				id: string;
				quoteItemV2Id: string;
				variations: Array<{
					__typename?: 'QuoteOfferItemVariationV2';
					id: string;
					name: string;
					description?: string | null;
					releasedToClient: boolean;
					attachments?: Array<{
						__typename?: 'QuoteOfferAttachmentV2';
						id: string;
						name: string;
						url?: string | null;
						size: number;
						mimeType: string;
					}> | null;
					adjustments: Array<{
						__typename?: 'QuoteOfferItemVariationAdjustmentV2';
						id: string;
						name: string;
						description?: string | null;
						type: AdjustmentTypeV2;
						calculationType: AdjustmentCalculationTypeV2;
						value: number;
						createdByType: AdjustmentCreatorTypeV2;
					}>;
					sampleChoice?: {
						__typename?: 'QuoteOfferItemSampleChoiceV2';
						id: string;
						choice: SampleChoiceV2;
						sample: {
							__typename?: 'QuoteOfferItemSampleV2';
							id: string;
							baseSamplePrice: number;
							baseShippingPrice?: number | null;
							deliveryDaysMin?: number | null;
							deliveryDaysMax?: number | null;
							minProductionDays?: number | null;
							maxProductionDays?: number | null;
						};
					} | null;
					quantities: Array<{
						__typename?: 'QuoteOfferItemVariationQuantityV2';
						id: string;
						quoteItemQuantityV2Id?: string | null;
						quantity: number;
						releasedToClient: boolean;
						baseUnitPrice: number;
						minProductionDays?: number | null;
						maxProductionDays?: number | null;
						deliveries: Array<{
							__typename?: 'QuoteOfferItemDeliveryV2';
							id: string;
							quantity: number;
							basePrice: number;
							deliveryDaysMin: number;
							deliveryDaysMax: number;
							shippingMethod: ShippingMethodV2;
						}>;
					}>;
				}>;
			}>;
		}>;
	} | null;
};

export type GetRecentQuotesSharedV2QueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetRecentQuotesSharedV2Query = {
	__typename?: 'Query';
	getRecentQuotesV2: Array<{
		__typename?: 'QuoteV2';
		id: string;
		name: string;
		status: QuoteStatusV2;
		createdAt?: string | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		items: Array<{
			__typename?: 'QuoteItemV2';
			product?: {
				__typename?: 'Product';
				name: string;
				images?: Array<{
					__typename?: 'ProductImage';
					url?: string | null;
					name: string;
					isPrimary?: boolean | null;
				}> | null;
			} | null;
		}>;
	}>;
};

export type GetRecentOrdersSharedV2QueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetRecentOrdersSharedV2Query = {
	__typename?: 'Query';
	getRecentOrdersV2: Array<{
		__typename?: 'QuoteOrderV2';
		id: string;
		name: string;
		status: QuoteOrderStatusV2;
		createdAt: string;
		totalAmount: number;
		quote: {
			__typename?: 'QuoteV2';
			id: string;
			name: string;
			items: Array<{
				__typename?: 'QuoteItemV2';
				product?: {
					__typename?: 'Product';
					name: string;
					images?: Array<{
						__typename?: 'ProductImage';
						url?: string | null;
						name: string;
						isPrimary?: boolean | null;
					}> | null;
				} | null;
			}>;
		};
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
	}>;
};

export type GetQuoteStatsByStatusV2QueryVariables = Exact<{
	currency?: InputMaybe<CurrencyEnum>;
	dateRange?: InputMaybe<DateRangeInput>;
	vetterEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetQuoteStatsByStatusV2Query = {
	__typename?: 'Query';
	getQuoteStatsByStatusV2: {
		__typename?: 'QuoteStatsByStatusV2';
		total: number;
		totalClients: number;
		organizationId?: string | null;
		statusBreakdown: Array<{
			__typename?: 'QuoteStatusBreakdownV2';
			status: QuoteStatusV2;
			count: number;
			percentage: number;
			clientCount: number;
		}>;
	};
};

export type GetSourcingPreferencesQueryVariables = Exact<{
	input: OrganizationSourcingPreferenceListInput;
}>;

export type GetSourcingPreferencesQuery = {
	__typename?: 'Query';
	getOrganizationSourcingPreferences: {
		__typename?: 'OrganizationSourcingPreferenceListResponse';
		data: Array<{
			__typename?: 'OrganizationSourcingPreference';
			id: string;
			name: string;
			description?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetSourcingPreferenceConnectionsQueryVariables = Exact<{
	input: OrganizationSourcingPreferenceConnectionListInput;
}>;

export type GetSourcingPreferenceConnectionsQuery = {
	__typename?: 'Query';
	getOrganizationSourcingPreferenceConnections: {
		__typename?: 'OrganizationSourcingPreferenceConnectionListResponse';
		data: Array<{
			__typename?: 'OrganizationSourcingPreferenceConnection';
			id: string;
			organizationId: string;
			organizationSourcingPreferenceId: string;
			priority?: number | null;
			notes?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organizationSourcingPreference?: {
				__typename?: 'OrganizationSourcingPreference';
				id: string;
				name: string;
				description?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetProductInterestsQueryVariables = Exact<{
	input: OrganizationProductInterestListInput;
}>;

export type GetProductInterestsQuery = {
	__typename?: 'Query';
	getOrganizationProductInterests: {
		__typename?: 'OrganizationProductInterestListResponse';
		data?: Array<{
			__typename?: 'OrganizationProductInterest';
			id: string;
			organizationId: string;
			productTagId: string;
			createdAt?: string | null;
			updatedAt?: string | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetComplianceOptionsQueryVariables = Exact<{
	input: OrganizationComplianceListInput;
}>;

export type GetComplianceOptionsQuery = {
	__typename?: 'Query';
	getOrganizationCompliances: {
		__typename?: 'OrganizationComplianceListResponse';
		data?: Array<{
			__typename?: 'OrganizationCompliance';
			id: string;
			name: string;
			description?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetComplianceConnectionsQueryVariables = Exact<{
	input: OrganizationComplianceConnectionListInput;
}>;

export type GetComplianceConnectionsQuery = {
	__typename?: 'Query';
	getOrganizationComplianceConnections: {
		__typename?: 'OrganizationComplianceConnectionListResponse';
		data: Array<{
			__typename?: 'OrganizationComplianceConnection';
			id: string;
			organizationId: string;
			organizationComplianceId: string;
			certificationNumber?: string | null;
			issueDate?: string | null;
			expiryDate?: string | null;
			certifyingBody?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			organizationCompliance?: {
				__typename?: 'OrganizationCompliance';
				id: string;
				name: string;
				description?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			currentPage: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetStudioFileChatsQueryVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type GetStudioFileChatsQuery = {
	__typename?: 'Query';
	getStudioFileChats: Array<{
		__typename?: 'StudioChat';
		id: string;
		content: string;
		role: ChatRole;
		chatType: StudioChatType;
		status: StudioChatStatus;
		createdAt?: string | null;
		referenceImages?: Array<string> | null;
		maskImage?: string | null;
		maskImagePreview?: string | null;
		updatedAt?: string | null;
		studioFileId: string;
		toolCalls?: Array<{
			__typename?: 'ToolCall';
			tool: string;
			arguments?: any | null;
			result?: any | null;
			timestamp: string;
		}> | null;
	}>;
};

export type GetStudioFileQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetStudioFileQuery = {
	__typename?: 'Query';
	getStudioFile?: {
		__typename?: 'StudioFile';
		id: string;
		status: StudioFileStatus;
		isGenerating: boolean;
		organizationId?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		name?: string | null;
		productId?: string | null;
		versions?: Array<{
			__typename?: 'StudioFileVersion';
			id: string;
			name: string;
			slug: string;
			imageUrls: Array<string>;
			versionNumber: number;
			changeNotes?: string | null;
			createdAt?: string | null;
			createdBy: string;
			metadata?: Array<{
				__typename?: 'StudioFileVersionMetadata';
				id: string;
				x?: number | null;
				y?: number | null;
				width?: number | null;
				height?: number | null;
				comment?: string | null;
				canvasWidth: number;
				canvasHeight: number;
				type: MetadataType;
				createdAt?: string | null;
				points?: Array<{ __typename?: 'PolygonPoint'; x: number; y: number }> | null;
				attachments?: Array<{
					__typename?: 'MetadataAttachment';
					fileName: string;
					contentType: string;
					size: number;
					url: string;
				}> | null;
			}> | null;
			specifications?: Array<{
				__typename?: 'StudioFileVersionSpecification';
				id: string;
				elementName: string;
				elementType?: string | null;
				colors?: Array<string> | null;
				material?: string | null;
				secondaryMaterials?: Array<string> | null;
				finish?: string | null;
				textureDescription?: string | null;
				features?: Array<string> | null;
				confidence?: number | null;
				generatedAt: string;
				dimensions?: {
					__typename?: 'SpecificationDimensions';
					width?: number | null;
					height?: number | null;
					depth?: number | null;
					diameter?: number | null;
					unit: string;
				} | null;
				weight?: { __typename?: 'SpecificationWeight'; value: number; unit: string } | null;
				capacity?: {
					__typename?: 'SpecificationCapacity';
					value: number;
					unit: string;
				} | null;
			}> | null;
			techPack?: {
				__typename?: 'StudioFileVersionTechPack';
				id: string;
				additionalNotes?: string | null;
				colorways?: Array<{
					__typename?: 'TechPackColorway';
					name?: string | null;
					code?: string | null;
					pantoneReferences?: Array<string> | null;
					fabricColors?: any | null;
					trimColors?: any | null;
				}> | null;
				construction?: {
					__typename?: 'TechPackConstruction';
					specialInstructions?: Array<string> | null;
					stitchTypes?: Array<{
						__typename?: 'TechPackStitch';
						type?: string | null;
						location?: string | null;
						stitchesPerInch?: number | null;
						threadColor?: string | null;
					}> | null;
					seamAllowances?: Array<{
						__typename?: 'TechPackSeamAllowance';
						location?: string | null;
						allowance?: string | null;
					}> | null;
				} | null;
				dimensions?: {
					__typename?: 'TechPackDimensions';
					sizeChart?: Array<{
						__typename?: 'TechPackSize';
						size?: string | null;
						measurements?: any | null;
					}> | null;
					measurements?: Array<{
						__typename?: 'TechPackMeasurement';
						name?: string | null;
						value?: string | null;
						tolerance?: string | null;
					}> | null;
				} | null;
				labeling?: {
					__typename?: 'TechPackLabeling';
					mainLabel?: {
						__typename?: 'TechPackLabel';
						type?: string | null;
						placement?: string | null;
						content?: string | null;
					} | null;
					careLabel?: {
						__typename?: 'TechPackCareLabel';
						placement?: string | null;
						content?: string | null;
						symbols?: Array<string> | null;
					} | null;
					additionalLabels?: Array<{
						__typename?: 'TechPackLabel';
						type?: string | null;
						placement?: string | null;
						content?: string | null;
					}> | null;
				} | null;
				materials?: {
					__typename?: 'TechPackMaterials';
					fabric?: {
						__typename?: 'TechPackFabric';
						type?: string | null;
						composition?: string | null;
						weight?: string | null;
						width?: string | null;
						code?: string | null;
						supplier?: string | null;
					} | null;
					trims?: Array<{
						__typename?: 'TechPackTrim';
						type?: string | null;
						description?: string | null;
						placement?: string | null;
						code?: string | null;
						supplier?: string | null;
					}> | null;
					hardware?: Array<{
						__typename?: 'TechPackHardware';
						type?: string | null;
						description?: string | null;
						quantity?: number | null;
						code?: string | null;
						supplier?: string | null;
					}> | null;
				} | null;
				packaging?: {
					__typename?: 'TechPackPackaging';
					type?: string | null;
					materials?: Array<string> | null;
					instructions?: Array<string> | null;
					labeling?: Array<string> | null;
				} | null;
				qualityControl?: {
					__typename?: 'TechPackQualityControl';
					inspectionPoints?: Array<string> | null;
					testingRequirements?: Array<string> | null;
					acceptableDefects?: Array<string> | null;
				} | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAllStudioFilesQueryVariables = Exact<{
	input: GetAllStudioFileInput;
}>;

export type GetAllStudioFilesQuery = {
	__typename?: 'Query';
	getAllStudioFile: {
		__typename?: 'StudioFilePage';
		data: Array<{
			__typename?: 'StudioFile';
			id: string;
			organizationId?: string | null;
			status: StudioFileStatus;
			isGenerating: boolean;
			createdAt?: string | null;
			updatedAt?: string | null;
			name?: string | null;
			type: StudioFileType;
			productId?: string | null;
			currentVersion?: {
				__typename?: 'StudioFileVersion';
				id: string;
				name: string;
				slug: string;
				imageUrls: Array<string>;
				versionNumber: number;
			} | null;
			versions?: Array<{
				__typename?: 'StudioFileVersion';
				id: string;
				name: string;
				imageUrls: Array<string>;
				versionNumber: number;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetStudioFileLockQueryVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type GetStudioFileLockQuery = {
	__typename?: 'Query';
	getStudioFileLock?: {
		__typename?: 'StudioLock';
		studioFileId: string;
		userId: string;
		lockedAt: string;
		expiresAt: string;
	} | null;
};

export type GetStudioFileVersionsQueryVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type GetStudioFileVersionsQuery = {
	__typename?: 'Query';
	getStudioFileVersions: Array<{
		__typename?: 'StudioFileVersion';
		id: string;
		name: string;
		slug: string;
		imageUrls: Array<string>;
		studioFileId: string;
		versionNumber: number;
		changeNotes?: string | null;
		createdAt?: string | null;
		createdBy: string;
		metadata?: Array<{
			__typename?: 'StudioFileVersionMetadata';
			id: string;
			x?: number | null;
			y?: number | null;
			width?: number | null;
			height?: number | null;
			comment?: string | null;
			canvasWidth: number;
			canvasHeight: number;
			type: MetadataType;
			createdAt?: string | null;
			points?: Array<{ __typename?: 'PolygonPoint'; x: number; y: number }> | null;
			attachments?: Array<{
				__typename?: 'MetadataAttachment';
				fileName: string;
				contentType: string;
				size: number;
				url: string;
			}> | null;
		}> | null;
		techPack?: {
			__typename?: 'StudioFileVersionTechPack';
			id: string;
			additionalNotes?: string | null;
			colorways?: Array<{
				__typename?: 'TechPackColorway';
				name?: string | null;
				code?: string | null;
				pantoneReferences?: Array<string> | null;
				fabricColors?: any | null;
				trimColors?: any | null;
			}> | null;
			construction?: {
				__typename?: 'TechPackConstruction';
				specialInstructions?: Array<string> | null;
				stitchTypes?: Array<{
					__typename?: 'TechPackStitch';
					type?: string | null;
					location?: string | null;
					stitchesPerInch?: number | null;
					threadColor?: string | null;
				}> | null;
				seamAllowances?: Array<{
					__typename?: 'TechPackSeamAllowance';
					location?: string | null;
					allowance?: string | null;
				}> | null;
			} | null;
			dimensions?: {
				__typename?: 'TechPackDimensions';
				sizeChart?: Array<{
					__typename?: 'TechPackSize';
					size?: string | null;
					measurements?: any | null;
				}> | null;
				measurements?: Array<{
					__typename?: 'TechPackMeasurement';
					name?: string | null;
					value?: string | null;
					tolerance?: string | null;
				}> | null;
			} | null;
			labeling?: {
				__typename?: 'TechPackLabeling';
				mainLabel?: {
					__typename?: 'TechPackLabel';
					type?: string | null;
					placement?: string | null;
					content?: string | null;
				} | null;
				careLabel?: {
					__typename?: 'TechPackCareLabel';
					placement?: string | null;
					content?: string | null;
					symbols?: Array<string> | null;
				} | null;
				additionalLabels?: Array<{
					__typename?: 'TechPackLabel';
					type?: string | null;
					placement?: string | null;
					content?: string | null;
				}> | null;
			} | null;
			materials?: {
				__typename?: 'TechPackMaterials';
				fabric?: {
					__typename?: 'TechPackFabric';
					type?: string | null;
					composition?: string | null;
					weight?: string | null;
					width?: string | null;
					code?: string | null;
					supplier?: string | null;
				} | null;
				trims?: Array<{
					__typename?: 'TechPackTrim';
					type?: string | null;
					description?: string | null;
					placement?: string | null;
					code?: string | null;
					supplier?: string | null;
				}> | null;
				hardware?: Array<{
					__typename?: 'TechPackHardware';
					type?: string | null;
					description?: string | null;
					quantity?: number | null;
					code?: string | null;
					supplier?: string | null;
				}> | null;
			} | null;
			packaging?: {
				__typename?: 'TechPackPackaging';
				type?: string | null;
				materials?: Array<string> | null;
				instructions?: Array<string> | null;
				labeling?: Array<string> | null;
			} | null;
			qualityControl?: {
				__typename?: 'TechPackQualityControl';
				inspectionPoints?: Array<string> | null;
				testingRequirements?: Array<string> | null;
				acceptableDefects?: Array<string> | null;
			} | null;
		} | null;
	}>;
};

export type GetStudioPromptTemplatesQueryVariables = Exact<{
	agentType?: InputMaybe<StudioAgentType>;
}>;

export type GetStudioPromptTemplatesQuery = {
	__typename?: 'Query';
	getStudioPromptTemplates: Array<{
		__typename?: 'StudioPromptTemplate';
		id: string;
		key: string;
		content: string;
		description?: string | null;
		agentType: StudioAgentType;
		category: StudioPromptTemplateCategory;
		isActive: boolean;
		provider?: string | null;
		variables?: Array<string> | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	}>;
};

export type GetStudioPromptTemplateQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetStudioPromptTemplateQuery = {
	__typename?: 'Query';
	getStudioPromptTemplate?: {
		__typename?: 'StudioPromptTemplate';
		id: string;
		key: string;
		content: string;
		description?: string | null;
		agentType: StudioAgentType;
		category: StudioPromptTemplateCategory;
		isActive: boolean;
		provider?: string | null;
		variables?: Array<string> | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	} | null;
};

export type GetStudioAgentToolsQueryVariables = Exact<{
	agentType: StudioAgentType;
}>;

export type GetStudioAgentToolsQuery = {
	__typename?: 'Query';
	getStudioAgentTools: Array<{
		__typename?: 'StudioAgentTool';
		name: string;
		description: string;
		parameters: string;
		supportedProviders: Array<string>;
	}>;
};

export type GetSubscriptionTierConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubscriptionTierConfigsQuery = {
	__typename?: 'Query';
	getSubscriptionTierConfigs: Array<{
		__typename?: 'SubscriptionTierConfig';
		tier: SubscriptionTier;
		monthlyPrice?: number | null;
		currency?: string | null;
		kickbackRate: number;
		aiTokenRatePerMillion?: number | null;
		stripePriceId?: string | null;
		isActive: boolean;
		updatedAt: string;
	}>;
};

export type GetMySubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type GetMySubscriptionQuery = {
	__typename?: 'Query';
	getMySubscription?: {
		__typename?: 'OrganizationSubscription';
		id: string;
		organizationId: string;
		tier: SubscriptionTier;
		status: SubscriptionStatus;
		stripeCustomerId?: string | null;
		stripeSubscriptionId?: string | null;
		stripePriceId?: string | null;
		currentPeriodStart?: string | null;
		currentPeriodEnd?: string | null;
		cancelAtPeriodEnd: boolean;
		canceledAt?: string | null;
		trialEnd?: string | null;
		pendingTier?: SubscriptionTier | null;
		pendingTierEffectiveAt?: string | null;
		createdAt: string;
		updatedAt: string;
	} | null;
};

export type GetMyKickbackTransactionsQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetMyKickbackTransactionsQuery = {
	__typename?: 'Query';
	getMyKickbackTransactions: Array<{
		__typename?: 'KickbackTransaction';
		id: string;
		organizationId: string;
		orderId?: string | null;
		type: KickbackTransactionType;
		amount: number;
		description?: string | null;
		createdAt: string;
	}>;
};

export type GetSystemSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSystemSettingsQuery = {
	__typename?: 'Query';
	getSystemSettings?: {
		__typename?: 'AdminSystemSetting';
		id: string;
		defaultApproval: boolean;
		defaultMargin: number;
		createdAt: string;
		updatedAt: string;
	} | null;
};

export type GetOrganizationUserDetailsQueryVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type GetOrganizationUserDetailsQuery = {
	__typename?: 'Query';
	getOrganizationUser?: {
		__typename?: 'OrganizationUser';
		id: string;
		firstName: string;
		lastName: string;
		jobPosition?: string | null;
		avatar?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organizationId: string;
		userId: string;
		roles?: Array<string> | null;
		authenticationUser?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			language: string;
			role: AuthRoleEnum;
			mfaEnabled: boolean;
			mfaMethod?: MfaMethodEnum | null;
			lockReason?: string | null;
			lockedAt?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			organizationIndustryId?: string | null;
			websiteUrl?: string | null;
			logo?: string | null;
			organizationIndustry?: {
				__typename?: 'OrganizationIndustry';
				id: string;
				name: string;
			} | null;
		} | null;
		authorizationUserRoles?: Array<{
			__typename?: 'AuthorizationUserRole';
			id: string;
			authorizationRoleId: string;
			createdAt?: string | null;
			authorizationRole?: {
				__typename?: 'AuthorizationRole';
				id: string;
				name: string;
				description?: string | null;
				scope: string;
			} | null;
		} | null> | null;
	} | null;
};

export type UpdateOrganizationUserMutationVariables = Exact<{
	input: OrganizationUserUpdateInput;
}>;

export type UpdateOrganizationUserMutation = {
	__typename?: 'Mutation';
	updateOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
	};
};

export type GetUserAuditLogsQueryVariables = Exact<{
	input: GetAllLoggingAuditLogInput;
}>;

export type GetUserAuditLogsQuery = {
	__typename?: 'Query';
	getAllLoggingAuditLog?: {
		__typename?: 'LoggingAuditLogPage';
		data: Array<{
			__typename?: 'LoggingAuditLog';
			id: string;
			action?: string | null;
			resource?: string | null;
			resourceId?: string | null;
			description?: string | null;
			status?: string | null;
			serviceName?: string | null;
			changes?: any | null;
			metadata?: any | null;
			createdAt?: string | null;
			userId?: string | null;
			organizationId?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetUserLoginLogsQueryVariables = Exact<{
	input: GetAllLoggingLoginLogInput;
}>;

export type GetUserLoginLogsQuery = {
	__typename?: 'Query';
	getAllLoggingLoginLog?: {
		__typename?: 'LoggingLoginLogPage';
		data: Array<{
			__typename?: 'LoggingLoginLog';
			id: string;
			method: string;
			status: string;
			failureReason?: string | null;
			ipAddress: string;
			userAgent: string;
			browser: string;
			os: string;
			createdAt?: string | null;
			userId: string;
			referenceId: string;
			serviceId: string;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetUserPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserPreferencesQuery = {
	__typename?: 'Query';
	getUserPreferences?: {
		__typename?: 'UserPreferences';
		userId: string;
		preferredLanguage?: SupportedLanguage | null;
	} | null;
};

export type GetAllVetterEntitiesQueryVariables = Exact<{
	input: GetAllVetterEntityInput;
}>;

export type GetAllVetterEntitiesQuery = {
	__typename?: 'Query';
	getAllVetterEntity: {
		__typename?: 'VetterEntityPage';
		data: Array<{
			__typename?: 'VetterEntity';
			id: string;
			name: string;
			description?: string | null;
			isActive: boolean;
			vetterUsers?: Array<{
				__typename?: 'VetterUser';
				id: string;
				userId: string;
				firstName: string;
				lastName: string;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetVetterEntityQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetVetterEntityQuery = {
	__typename?: 'Query';
	getVetterEntity?: {
		__typename?: 'VetterEntity';
		id: string;
		name: string;
		description?: string | null;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		vetterUsers?: Array<{
			__typename?: 'VetterUser';
			id: string;
			firstName: string;
			lastName: string;
			userId: string;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
			} | null;
		}> | null;
		manufacturers: Array<{
			__typename?: 'Manufacturer';
			id: string;
			name: string;
			country?: string | null;
			description?: string | null;
			website?: string | null;
			logoUrl?: string | null;
			isActive: boolean;
			createdAt?: string | null;
			updatedAt?: string | null;
		}>;
	} | null;
};

export type GetAllVetterUserQueryVariables = Exact<{
	input: GetAllVetterUserInput;
}>;

export type GetAllVetterUserQuery = {
	__typename?: 'Query';
	getAllVetterUser: {
		__typename?: 'VetterUserPage';
		data: Array<{
			__typename?: 'VetterUser';
			id: string;
			userId: string;
			firstName: string;
			lastName: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				mfaEnabled: boolean;
				language: string;
				lastActive?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type OnMessageAddedSubscriptionVariables = Exact<{
	contextId: Scalars['ID']['input'];
}>;

export type OnMessageAddedSubscription = {
	__typename?: 'Subscription';
	messageAdded?: {
		__typename?: 'ChatMessage';
		id: string;
		content?: string | null;
		contextId: string;
		senderId: string;
		senderType: AuthRoleEnum;
		messageType: MessageType;
		metadata?: any | null;
		isRead: boolean;
		readAt?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		translations?: {
			__typename?: 'MessageTranslations';
			da?: string | null;
			en?: string | null;
			zh?: string | null;
		} | null;
	} | null;
};

export type OnMessageDeletedSubscriptionVariables = Exact<{
	contextId: Scalars['ID']['input'];
}>;

export type OnMessageDeletedSubscription = {
	__typename?: 'Subscription';
	messageDeleted?: string | null;
};

export type OnMessageUpdatedSubscriptionVariables = Exact<{
	contextId: Scalars['ID']['input'];
}>;

export type OnMessageUpdatedSubscription = {
	__typename?: 'Subscription';
	messageUpdated?: {
		__typename?: 'ChatMessage';
		id: string;
		content?: string | null;
		contextId: string;
		senderId: string;
		senderType: AuthRoleEnum;
		messageType: MessageType;
		metadata?: any | null;
		isRead: boolean;
		readAt?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
	} | null;
};

export type OnUnreadCountChangedSubscriptionVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type OnUnreadCountChangedSubscription = {
	__typename?: 'Subscription';
	unreadCountChanged?: {
		__typename?: 'UnreadCountUpdate';
		contextId: string;
		unreadCount: number;
		userId: string;
	} | null;
};

export type OnStudioChatUpdatedSubscriptionVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type OnStudioChatUpdatedSubscription = {
	__typename?: 'Subscription';
	studioChatUpdated?: {
		__typename?: 'StudioChat';
		id: string;
		content: string;
		role: ChatRole;
		chatType: StudioChatType;
		status: StudioChatStatus;
		createdAt?: string | null;
		referenceImages?: Array<string> | null;
		maskImage?: string | null;
		maskImagePreview?: string | null;
		updatedAt?: string | null;
		studioFileId: string;
		toolCalls?: Array<{
			__typename?: 'ToolCall';
			tool: string;
			arguments?: any | null;
			result?: any | null;
			timestamp: string;
		}> | null;
	} | null;
};

export type OnStudioLockChangedSubscriptionVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type OnStudioLockChangedSubscription = {
	__typename?: 'Subscription';
	studioLockChanged?: {
		__typename?: 'StudioLock';
		studioFileId: string;
		userId: string;
		lockedAt: string;
		expiresAt: string;
	} | null;
};

export type OnStudioFileVersionAddedSubscriptionVariables = Exact<{
	studioFileId: Scalars['ID']['input'];
}>;

export type OnStudioFileVersionAddedSubscription = {
	__typename?: 'Subscription';
	studioFileVersionAdded?: {
		__typename?: 'StudioFileVersion';
		id: string;
		name: string;
		versionNumber: number;
		imageUrls: Array<string>;
		imageDescription?: string | null;
		changeNotes?: string | null;
		createdAt?: string | null;
		createdBy: string;
		metadata?: Array<{
			__typename?: 'StudioFileVersionMetadata';
			id: string;
			x?: number | null;
			y?: number | null;
			width?: number | null;
			height?: number | null;
			type: MetadataType;
			comment?: string | null;
			canvasWidth: number;
			canvasHeight: number;
			createdAt?: string | null;
			points?: Array<{ __typename?: 'PolygonPoint'; x: number; y: number }> | null;
		}> | null;
		specifications?: Array<{
			__typename?: 'StudioFileVersionSpecification';
			id: string;
			elementName: string;
			elementType?: string | null;
			colors?: Array<string> | null;
			material?: string | null;
			secondaryMaterials?: Array<string> | null;
			finish?: string | null;
			textureDescription?: string | null;
			features?: Array<string> | null;
			dimensions?: {
				__typename?: 'SpecificationDimensions';
				width?: number | null;
				height?: number | null;
				depth?: number | null;
				diameter?: number | null;
				unit: string;
			} | null;
			weight?: { __typename?: 'SpecificationWeight'; value: number; unit: string } | null;
			capacity?: { __typename?: 'SpecificationCapacity'; value: number; unit: string } | null;
		}> | null;
	} | null;
};

export const AuthorizationPermissionFragmentFragmentDoc = gql`
	fragment AuthorizationPermissionFragment on AuthorizationPermission {
		id
		resource
		action
		description
		createdAt
		updatedAt
	}
`;
export const AuthorizationRoleFragmentFragmentDoc = gql`
	fragment AuthorizationRoleFragment on AuthorizationRole {
		id
		name
		description
		scope
		createdAt
		updatedAt
		authorizationRolePermissions {
			id
			authorizationPermission {
				...AuthorizationPermissionFragment
			}
		}
	}
	${AuthorizationPermissionFragmentFragmentDoc}
`;
export const AuthorizationUserRoleFragmentFragmentDoc = gql`
	fragment AuthorizationUserRoleFragment on AuthorizationUserRole {
		id
		userId
		authorizationRoleId
		createdAt
		updatedAt
		authorizationRole {
			...AuthorizationRoleFragment
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
`;
export const PageInfoFragmentFragmentDoc = gql`
	fragment PageInfoFragment on PageInfo {
		totalPages
		currentPage
		totalCount
		hasNextPage
		hasPreviousPage
	}
`;
export const ResponseErrorFragmentFragmentDoc = gql`
	fragment ResponseErrorFragment on ResponseError {
		message
		code
		field
		details
	}
`;
export const MessageResponseFragmentFragmentDoc = gql`
	fragment MessageResponseFragment on MessageResponse {
		success
		message
		referenceKey
		errors {
			...ResponseErrorFragment
		}
	}
	${ResponseErrorFragmentFragmentDoc}
`;
export const DeliveryAddressV2FragmentFragmentDoc = gql`
	fragment DeliveryAddressV2Fragment on DeliveryAddressV2 {
		addressLine1
		addressLine2
		city
		stateCode
		postalCode
		countryCode
	}
`;
export const ProductBasicFragmentFragmentDoc = gql`
	fragment ProductBasicFragment on Product {
		id
		name
		sku
		weight
		dimensions {
			length
			width
			height
			unit
		}
		images {
			id
			url
			name
			mimeType
		}
	}
`;
export const ProductQuoteFragmentFragmentDoc = gql`
	fragment ProductQuoteFragment on Product {
		...ProductBasicFragment
		description
		brand {
			id
			name
		}
	}
	${ProductBasicFragmentFragmentDoc}
`;
export const CreateAdminInvoiceDraftV2Document = gql`
	mutation CreateAdminInvoiceDraftV2($input: CreateAdminInvoiceDraftV2Input!) {
		createAdminInvoiceDraftV2(input: $input) {
			success
			error
			draft {
				id
				status
				economicDraftInvoiceNumber
				economicBookedInvoiceNumber
				bookedAt
				lineItems
			}
		}
	}
`;
export type CreateAdminInvoiceDraftV2MutationFn = Apollo.MutationFunction<
	CreateAdminInvoiceDraftV2Mutation,
	CreateAdminInvoiceDraftV2MutationVariables
>;

/**
 * __useCreateAdminInvoiceDraftV2Mutation__
 *
 * To run a mutation, you first call `useCreateAdminInvoiceDraftV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminInvoiceDraftV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminInvoiceDraftV2Mutation, { data, loading, error }] = useCreateAdminInvoiceDraftV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminInvoiceDraftV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateAdminInvoiceDraftV2Mutation,
		CreateAdminInvoiceDraftV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateAdminInvoiceDraftV2Mutation,
		CreateAdminInvoiceDraftV2MutationVariables
	>(CreateAdminInvoiceDraftV2Document, options);
}
export type CreateAdminInvoiceDraftV2MutationHookResult = ReturnType<
	typeof useCreateAdminInvoiceDraftV2Mutation
>;
export type CreateAdminInvoiceDraftV2MutationResult =
	Apollo.MutationResult<CreateAdminInvoiceDraftV2Mutation>;
export type CreateAdminInvoiceDraftV2MutationOptions = Apollo.BaseMutationOptions<
	CreateAdminInvoiceDraftV2Mutation,
	CreateAdminInvoiceDraftV2MutationVariables
>;
export const UpdateAdminInvoiceDraftV2Document = gql`
	mutation UpdateAdminInvoiceDraftV2($input: UpdateAdminInvoiceDraftV2Input!) {
		updateAdminInvoiceDraftV2(input: $input) {
			success
			error
			draft {
				id
				status
				economicDraftInvoiceNumber
				lineItems
			}
		}
	}
`;
export type UpdateAdminInvoiceDraftV2MutationFn = Apollo.MutationFunction<
	UpdateAdminInvoiceDraftV2Mutation,
	UpdateAdminInvoiceDraftV2MutationVariables
>;

/**
 * __useUpdateAdminInvoiceDraftV2Mutation__
 *
 * To run a mutation, you first call `useUpdateAdminInvoiceDraftV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminInvoiceDraftV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminInvoiceDraftV2Mutation, { data, loading, error }] = useUpdateAdminInvoiceDraftV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminInvoiceDraftV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateAdminInvoiceDraftV2Mutation,
		UpdateAdminInvoiceDraftV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateAdminInvoiceDraftV2Mutation,
		UpdateAdminInvoiceDraftV2MutationVariables
	>(UpdateAdminInvoiceDraftV2Document, options);
}
export type UpdateAdminInvoiceDraftV2MutationHookResult = ReturnType<
	typeof useUpdateAdminInvoiceDraftV2Mutation
>;
export type UpdateAdminInvoiceDraftV2MutationResult =
	Apollo.MutationResult<UpdateAdminInvoiceDraftV2Mutation>;
export type UpdateAdminInvoiceDraftV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateAdminInvoiceDraftV2Mutation,
	UpdateAdminInvoiceDraftV2MutationVariables
>;
export const BookAdminInvoiceDraftV2Document = gql`
	mutation BookAdminInvoiceDraftV2($draftId: ID!) {
		bookAdminInvoiceDraftV2(draftId: $draftId) {
			success
			error
			draft {
				id
				status
				economicBookedInvoiceNumber
				bookedAt
			}
		}
	}
`;
export type BookAdminInvoiceDraftV2MutationFn = Apollo.MutationFunction<
	BookAdminInvoiceDraftV2Mutation,
	BookAdminInvoiceDraftV2MutationVariables
>;

/**
 * __useBookAdminInvoiceDraftV2Mutation__
 *
 * To run a mutation, you first call `useBookAdminInvoiceDraftV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAdminInvoiceDraftV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAdminInvoiceDraftV2Mutation, { data, loading, error }] = useBookAdminInvoiceDraftV2Mutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useBookAdminInvoiceDraftV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		BookAdminInvoiceDraftV2Mutation,
		BookAdminInvoiceDraftV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		BookAdminInvoiceDraftV2Mutation,
		BookAdminInvoiceDraftV2MutationVariables
	>(BookAdminInvoiceDraftV2Document, options);
}
export type BookAdminInvoiceDraftV2MutationHookResult = ReturnType<
	typeof useBookAdminInvoiceDraftV2Mutation
>;
export type BookAdminInvoiceDraftV2MutationResult =
	Apollo.MutationResult<BookAdminInvoiceDraftV2Mutation>;
export type BookAdminInvoiceDraftV2MutationOptions = Apollo.BaseMutationOptions<
	BookAdminInvoiceDraftV2Mutation,
	BookAdminInvoiceDraftV2MutationVariables
>;
export const CancelAdminInvoiceDraftV2Document = gql`
	mutation CancelAdminInvoiceDraftV2($draftId: ID!) {
		cancelAdminInvoiceDraftV2(draftId: $draftId) {
			success
			error
			creditNoteInvoiceNumber
		}
	}
`;
export type CancelAdminInvoiceDraftV2MutationFn = Apollo.MutationFunction<
	CancelAdminInvoiceDraftV2Mutation,
	CancelAdminInvoiceDraftV2MutationVariables
>;

/**
 * __useCancelAdminInvoiceDraftV2Mutation__
 *
 * To run a mutation, you first call `useCancelAdminInvoiceDraftV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAdminInvoiceDraftV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAdminInvoiceDraftV2Mutation, { data, loading, error }] = useCancelAdminInvoiceDraftV2Mutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useCancelAdminInvoiceDraftV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelAdminInvoiceDraftV2Mutation,
		CancelAdminInvoiceDraftV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CancelAdminInvoiceDraftV2Mutation,
		CancelAdminInvoiceDraftV2MutationVariables
	>(CancelAdminInvoiceDraftV2Document, options);
}
export type CancelAdminInvoiceDraftV2MutationHookResult = ReturnType<
	typeof useCancelAdminInvoiceDraftV2Mutation
>;
export type CancelAdminInvoiceDraftV2MutationResult =
	Apollo.MutationResult<CancelAdminInvoiceDraftV2Mutation>;
export type CancelAdminInvoiceDraftV2MutationOptions = Apollo.BaseMutationOptions<
	CancelAdminInvoiceDraftV2Mutation,
	CancelAdminInvoiceDraftV2MutationVariables
>;
export const CreateAdminUserDocument = gql`
	mutation CreateAdminUser($input: CreateAdminUserInput!) {
		createAdminUser(input: $input) {
			success
			message
		}
	}
`;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<
	CreateAdminUserMutation,
	CreateAdminUserMutationVariables
>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateAdminUserMutation,
		CreateAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(
		CreateAdminUserDocument,
		options
	);
}
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<
	CreateAdminUserMutation,
	CreateAdminUserMutationVariables
>;
export const UpdateAdminUserDocument = gql`
	mutation UpdateAdminUser($id: ID!, $input: UpdateAdminUserInput!) {
		updateAdminUser(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateAdminUserMutationFn = Apollo.MutationFunction<
	UpdateAdminUserMutation,
	UpdateAdminUserMutationVariables
>;

/**
 * __useUpdateAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserMutation, { data, loading, error }] = useUpdateAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateAdminUserMutation,
		UpdateAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(
		UpdateAdminUserDocument,
		options
	);
}
export type UpdateAdminUserMutationHookResult = ReturnType<typeof useUpdateAdminUserMutation>;
export type UpdateAdminUserMutationResult = Apollo.MutationResult<UpdateAdminUserMutation>;
export type UpdateAdminUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateAdminUserMutation,
	UpdateAdminUserMutationVariables
>;
export const DeleteAdminUserDocument = gql`
	mutation DeleteAdminUser($id: ID!) {
		deleteAdminUser(id: $id) {
			success
			message
		}
	}
`;
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<
	DeleteAdminUserMutation,
	DeleteAdminUserMutationVariables
>;

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteAdminUserMutation,
		DeleteAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(
		DeleteAdminUserDocument,
		options
	);
}
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>;
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>;
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteAdminUserMutation,
	DeleteAdminUserMutationVariables
>;
export const DeleteManyAdminUserDocument = gql`
	mutation DeleteManyAdminUser($input: DeleteManyInput!) {
		deleteManyAdminUser(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyAdminUserMutationFn = Apollo.MutationFunction<
	DeleteManyAdminUserMutation,
	DeleteManyAdminUserMutationVariables
>;

/**
 * __useDeleteManyAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAdminUserMutation, { data, loading, error }] = useDeleteManyAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAdminUserMutation,
		DeleteManyAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyAdminUserMutation, DeleteManyAdminUserMutationVariables>(
		DeleteManyAdminUserDocument,
		options
	);
}
export type DeleteManyAdminUserMutationHookResult = ReturnType<
	typeof useDeleteManyAdminUserMutation
>;
export type DeleteManyAdminUserMutationResult = Apollo.MutationResult<DeleteManyAdminUserMutation>;
export type DeleteManyAdminUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAdminUserMutation,
	DeleteManyAdminUserMutationVariables
>;
export const LoginDocument = gql`
	mutation Login($input: LoginInput!) {
		login(input: $input) {
			token
			userId
			mfaRequired
			mfaMethod
			role
			supportsBackupCodes
		}
	}
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
	baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
	LoginMutation,
	LoginMutationVariables
>;
export const LoginValidateDocument = gql`
	mutation LoginValidate($input: LoginValidateInput!) {
		loginValidate(input: $input) {
			token
			user {
				id
				role
				language
				email
				vetterUser {
					vetterEntityId
					firstName
					lastName
				}
				organizationUser {
					id
					organizationId
					firstName
					lastName
					organization {
						id
						name
						onboarded
						organizationSetting {
							timezone
							currency
							measurementSystem
						}
					}
				}
			}
		}
	}
`;
export type LoginValidateMutationFn = Apollo.MutationFunction<
	LoginValidateMutation,
	LoginValidateMutationVariables
>;

/**
 * __useLoginValidateMutation__
 *
 * To run a mutation, you first call `useLoginValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginValidateMutation, { data, loading, error }] = useLoginValidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginValidateMutation(
	baseOptions?: Apollo.MutationHookOptions<LoginValidateMutation, LoginValidateMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LoginValidateMutation, LoginValidateMutationVariables>(
		LoginValidateDocument,
		options
	);
}
export type LoginValidateMutationHookResult = ReturnType<typeof useLoginValidateMutation>;
export type LoginValidateMutationResult = Apollo.MutationResult<LoginValidateMutation>;
export type LoginValidateMutationOptions = Apollo.BaseMutationOptions<
	LoginValidateMutation,
	LoginValidateMutationVariables
>;
export const RefreshTokenDocument = gql`
	mutation RefreshToken {
		refreshToken {
			token
			user {
				id
				role
				language
				email
				vetterUser {
					vetterEntityId
					firstName
					lastName
				}
				organizationUser {
					id
					organizationId
					firstName
					lastName
					organization {
						id
						name
						onboarded
						organizationSetting {
							timezone
							currency
							measurementSystem
						}
					}
				}
			}
		}
	}
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
		RefreshTokenDocument,
		options
	);
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;
export const ValidateAuthenticationTokenDocument = gql`
	mutation ValidateAuthenticationToken($token: String!) {
		validateAuthenticationToken(token: $token) {
			token
			user {
				id
				email
				organizationUser {
					id
					firstName
					lastName
				}
			}
		}
	}
`;
export type ValidateAuthenticationTokenMutationFn = Apollo.MutationFunction<
	ValidateAuthenticationTokenMutation,
	ValidateAuthenticationTokenMutationVariables
>;

/**
 * __useValidateAuthenticationTokenMutation__
 *
 * To run a mutation, you first call `useValidateAuthenticationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAuthenticationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAuthenticationTokenMutation, { data, loading, error }] = useValidateAuthenticationTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateAuthenticationTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ValidateAuthenticationTokenMutation,
		ValidateAuthenticationTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ValidateAuthenticationTokenMutation,
		ValidateAuthenticationTokenMutationVariables
	>(ValidateAuthenticationTokenDocument, options);
}
export type ValidateAuthenticationTokenMutationHookResult = ReturnType<
	typeof useValidateAuthenticationTokenMutation
>;
export type ValidateAuthenticationTokenMutationResult =
	Apollo.MutationResult<ValidateAuthenticationTokenMutation>;
export type ValidateAuthenticationTokenMutationOptions = Apollo.BaseMutationOptions<
	ValidateAuthenticationTokenMutation,
	ValidateAuthenticationTokenMutationVariables
>;
export const RegisterDocument = gql`
	mutation Register($input: RegisterInput!) {
		register(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type RegisterMutationFn = Apollo.MutationFunction<
	RegisterMutation,
	RegisterMutationVariables
>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
	baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(
		RegisterDocument,
		options
	);
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<
	RegisterMutation,
	RegisterMutationVariables
>;
export const UnlockAuthenticationUserDocument = gql`
	mutation UnlockAuthenticationUser($userId: ID!) {
		unlockAuthenticationUser(userId: $userId) {
			success
			message
		}
	}
`;
export type UnlockAuthenticationUserMutationFn = Apollo.MutationFunction<
	UnlockAuthenticationUserMutation,
	UnlockAuthenticationUserMutationVariables
>;

/**
 * __useUnlockAuthenticationUserMutation__
 *
 * To run a mutation, you first call `useUnlockAuthenticationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockAuthenticationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockAuthenticationUserMutation, { data, loading, error }] = useUnlockAuthenticationUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnlockAuthenticationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UnlockAuthenticationUserMutation,
		UnlockAuthenticationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UnlockAuthenticationUserMutation,
		UnlockAuthenticationUserMutationVariables
	>(UnlockAuthenticationUserDocument, options);
}
export type UnlockAuthenticationUserMutationHookResult = ReturnType<
	typeof useUnlockAuthenticationUserMutation
>;
export type UnlockAuthenticationUserMutationResult =
	Apollo.MutationResult<UnlockAuthenticationUserMutation>;
export type UnlockAuthenticationUserMutationOptions = Apollo.BaseMutationOptions<
	UnlockAuthenticationUserMutation,
	UnlockAuthenticationUserMutationVariables
>;
export const PasswordResetRequestDocument = gql`
	mutation PasswordResetRequest($input: PasswordResetRequestInput!) {
		passwordResetRequest(input: $input)
	}
`;
export type PasswordResetRequestMutationFn = Apollo.MutationFunction<
	PasswordResetRequestMutation,
	PasswordResetRequestMutationVariables
>;

/**
 * __usePasswordResetRequestMutation__
 *
 * To run a mutation, you first call `usePasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetRequestMutation, { data, loading, error }] = usePasswordResetRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PasswordResetRequestMutation,
		PasswordResetRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PasswordResetRequestMutation, PasswordResetRequestMutationVariables>(
		PasswordResetRequestDocument,
		options
	);
}
export type PasswordResetRequestMutationHookResult = ReturnType<
	typeof usePasswordResetRequestMutation
>;
export type PasswordResetRequestMutationResult =
	Apollo.MutationResult<PasswordResetRequestMutation>;
export type PasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetRequestMutation,
	PasswordResetRequestMutationVariables
>;
export const PasswordResetValidateDocument = gql`
	mutation PasswordResetValidate($input: PasswordResetValidateInput!) {
		passwordResetValidate(input: $input) {
			success
			message
		}
	}
`;
export type PasswordResetValidateMutationFn = Apollo.MutationFunction<
	PasswordResetValidateMutation,
	PasswordResetValidateMutationVariables
>;

/**
 * __usePasswordResetValidateMutation__
 *
 * To run a mutation, you first call `usePasswordResetValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetValidateMutation, { data, loading, error }] = usePasswordResetValidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetValidateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PasswordResetValidateMutation,
		PasswordResetValidateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PasswordResetValidateMutation,
		PasswordResetValidateMutationVariables
	>(PasswordResetValidateDocument, options);
}
export type PasswordResetValidateMutationHookResult = ReturnType<
	typeof usePasswordResetValidateMutation
>;
export type PasswordResetValidateMutationResult =
	Apollo.MutationResult<PasswordResetValidateMutation>;
export type PasswordResetValidateMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetValidateMutation,
	PasswordResetValidateMutationVariables
>;
export const PasswordResetDocument = gql`
	mutation PasswordReset($input: PasswordResetInput!) {
		passwordReset(input: $input) {
			success
			message
		}
	}
`;
export type PasswordResetMutationFn = Apollo.MutationFunction<
	PasswordResetMutation,
	PasswordResetMutationVariables
>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetMutation(
	baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(
		PasswordResetDocument,
		options
	);
}
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetMutation,
	PasswordResetMutationVariables
>;
export const ResendPasswordResetRequestDocument = gql`
	mutation ResendPasswordResetRequest($input: PasswordResetRequestInput!) {
		resendPasswordResetRequest(input: $input)
	}
`;
export type ResendPasswordResetRequestMutationFn = Apollo.MutationFunction<
	ResendPasswordResetRequestMutation,
	ResendPasswordResetRequestMutationVariables
>;

/**
 * __useResendPasswordResetRequestMutation__
 *
 * To run a mutation, you first call `useResendPasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPasswordResetRequestMutation, { data, loading, error }] = useResendPasswordResetRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendPasswordResetRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResendPasswordResetRequestMutation,
		ResendPasswordResetRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ResendPasswordResetRequestMutation,
		ResendPasswordResetRequestMutationVariables
	>(ResendPasswordResetRequestDocument, options);
}
export type ResendPasswordResetRequestMutationHookResult = ReturnType<
	typeof useResendPasswordResetRequestMutation
>;
export type ResendPasswordResetRequestMutationResult =
	Apollo.MutationResult<ResendPasswordResetRequestMutation>;
export type ResendPasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
	ResendPasswordResetRequestMutation,
	ResendPasswordResetRequestMutationVariables
>;
export const VerifyAuthenticatorSetupDocument = gql`
	mutation VerifyAuthenticatorSetup($input: VerifyAuthenticatorSetupInput!) {
		verifyAuthenticatorSetup(input: $input) {
			token
			userId
			role
			backupCodes
		}
	}
`;
export type VerifyAuthenticatorSetupMutationFn = Apollo.MutationFunction<
	VerifyAuthenticatorSetupMutation,
	VerifyAuthenticatorSetupMutationVariables
>;

/**
 * __useVerifyAuthenticatorSetupMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticatorSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticatorSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticatorSetupMutation, { data, loading, error }] = useVerifyAuthenticatorSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthenticatorSetupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyAuthenticatorSetupMutation,
		VerifyAuthenticatorSetupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VerifyAuthenticatorSetupMutation,
		VerifyAuthenticatorSetupMutationVariables
	>(VerifyAuthenticatorSetupDocument, options);
}
export type VerifyAuthenticatorSetupMutationHookResult = ReturnType<
	typeof useVerifyAuthenticatorSetupMutation
>;
export type VerifyAuthenticatorSetupMutationResult =
	Apollo.MutationResult<VerifyAuthenticatorSetupMutation>;
export type VerifyAuthenticatorSetupMutationOptions = Apollo.BaseMutationOptions<
	VerifyAuthenticatorSetupMutation,
	VerifyAuthenticatorSetupMutationVariables
>;
export const VerifyEmailMfaDocument = gql`
	mutation VerifyEmailMfa($input: VerifyEmailMfaInput!) {
		verifyEmailMfa(input: $input) {
			token
			role
		}
	}
`;
export type VerifyEmailMfaMutationFn = Apollo.MutationFunction<
	VerifyEmailMfaMutation,
	VerifyEmailMfaMutationVariables
>;

/**
 * __useVerifyEmailMfaMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMfaMutation, { data, loading, error }] = useVerifyEmailMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMfaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyEmailMfaMutation,
		VerifyEmailMfaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VerifyEmailMfaMutation, VerifyEmailMfaMutationVariables>(
		VerifyEmailMfaDocument,
		options
	);
}
export type VerifyEmailMfaMutationHookResult = ReturnType<typeof useVerifyEmailMfaMutation>;
export type VerifyEmailMfaMutationResult = Apollo.MutationResult<VerifyEmailMfaMutation>;
export type VerifyEmailMfaMutationOptions = Apollo.BaseMutationOptions<
	VerifyEmailMfaMutation,
	VerifyEmailMfaMutationVariables
>;
export const ResendEmailMfaCodeDocument = gql`
	mutation ResendEmailMfaCode($userId: ID!) {
		resendEmailMfaCode(userId: $userId) {
			message
			success
		}
	}
`;
export type ResendEmailMfaCodeMutationFn = Apollo.MutationFunction<
	ResendEmailMfaCodeMutation,
	ResendEmailMfaCodeMutationVariables
>;

/**
 * __useResendEmailMfaCodeMutation__
 *
 * To run a mutation, you first call `useResendEmailMfaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailMfaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailMfaCodeMutation, { data, loading, error }] = useResendEmailMfaCodeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendEmailMfaCodeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResendEmailMfaCodeMutation,
		ResendEmailMfaCodeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ResendEmailMfaCodeMutation, ResendEmailMfaCodeMutationVariables>(
		ResendEmailMfaCodeDocument,
		options
	);
}
export type ResendEmailMfaCodeMutationHookResult = ReturnType<typeof useResendEmailMfaCodeMutation>;
export type ResendEmailMfaCodeMutationResult = Apollo.MutationResult<ResendEmailMfaCodeMutation>;
export type ResendEmailMfaCodeMutationOptions = Apollo.BaseMutationOptions<
	ResendEmailMfaCodeMutation,
	ResendEmailMfaCodeMutationVariables
>;
export const VerifyAuthenticatorMfaDocument = gql`
	mutation VerifyAuthenticatorMfa($input: VerifyAuthenticatorMfaInput!) {
		verifyAuthenticatorMfa(input: $input) {
			token
			role
		}
	}
`;
export type VerifyAuthenticatorMfaMutationFn = Apollo.MutationFunction<
	VerifyAuthenticatorMfaMutation,
	VerifyAuthenticatorMfaMutationVariables
>;

/**
 * __useVerifyAuthenticatorMfaMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticatorMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticatorMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticatorMfaMutation, { data, loading, error }] = useVerifyAuthenticatorMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthenticatorMfaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyAuthenticatorMfaMutation,
		VerifyAuthenticatorMfaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VerifyAuthenticatorMfaMutation,
		VerifyAuthenticatorMfaMutationVariables
	>(VerifyAuthenticatorMfaDocument, options);
}
export type VerifyAuthenticatorMfaMutationHookResult = ReturnType<
	typeof useVerifyAuthenticatorMfaMutation
>;
export type VerifyAuthenticatorMfaMutationResult =
	Apollo.MutationResult<VerifyAuthenticatorMfaMutation>;
export type VerifyAuthenticatorMfaMutationOptions = Apollo.BaseMutationOptions<
	VerifyAuthenticatorMfaMutation,
	VerifyAuthenticatorMfaMutationVariables
>;
export const LogoutDocument = gql`
	mutation Logout($input: LogoutInput!) {
		logout(input: $input) {
			success
			message
		}
	}
`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(
	baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
	LogoutMutation,
	LogoutMutationVariables
>;
export const CreateOrganizationSignupDocument = gql`
	mutation CreateOrganizationSignup($input: OrganizationSignupInput!) {
		createOrganizationSignup(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type CreateOrganizationSignupMutationFn = Apollo.MutationFunction<
	CreateOrganizationSignupMutation,
	CreateOrganizationSignupMutationVariables
>;

/**
 * __useCreateOrganizationSignupMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationSignupMutation, { data, loading, error }] = useCreateOrganizationSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationSignupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationSignupMutation,
		CreateOrganizationSignupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationSignupMutation,
		CreateOrganizationSignupMutationVariables
	>(CreateOrganizationSignupDocument, options);
}
export type CreateOrganizationSignupMutationHookResult = ReturnType<
	typeof useCreateOrganizationSignupMutation
>;
export type CreateOrganizationSignupMutationResult =
	Apollo.MutationResult<CreateOrganizationSignupMutation>;
export type CreateOrganizationSignupMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationSignupMutation,
	CreateOrganizationSignupMutationVariables
>;
export const CreateAuthorizationRoleDocument = gql`
	mutation CreateAuthorizationRole($input: AuthorizationRoleCreateInput!) {
		createAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateAuthorizationRoleMutationFn = Apollo.MutationFunction<
	CreateAuthorizationRoleMutation,
	CreateAuthorizationRoleMutationVariables
>;

/**
 * __useCreateAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizationRoleMutation, { data, loading, error }] = useCreateAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateAuthorizationRoleMutation,
		CreateAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateAuthorizationRoleMutation,
		CreateAuthorizationRoleMutationVariables
	>(CreateAuthorizationRoleDocument, options);
}
export type CreateAuthorizationRoleMutationHookResult = ReturnType<
	typeof useCreateAuthorizationRoleMutation
>;
export type CreateAuthorizationRoleMutationResult =
	Apollo.MutationResult<CreateAuthorizationRoleMutation>;
export type CreateAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	CreateAuthorizationRoleMutation,
	CreateAuthorizationRoleMutationVariables
>;
export const UpdateAuthorizationRoleDocument = gql`
	mutation UpdateAuthorizationRole($input: AuthorizationRoleUpdateInput!) {
		updateAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateAuthorizationRoleMutationFn = Apollo.MutationFunction<
	UpdateAuthorizationRoleMutation,
	UpdateAuthorizationRoleMutationVariables
>;

/**
 * __useUpdateAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizationRoleMutation, { data, loading, error }] = useUpdateAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateAuthorizationRoleMutation,
		UpdateAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateAuthorizationRoleMutation,
		UpdateAuthorizationRoleMutationVariables
	>(UpdateAuthorizationRoleDocument, options);
}
export type UpdateAuthorizationRoleMutationHookResult = ReturnType<
	typeof useUpdateAuthorizationRoleMutation
>;
export type UpdateAuthorizationRoleMutationResult =
	Apollo.MutationResult<UpdateAuthorizationRoleMutation>;
export type UpdateAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	UpdateAuthorizationRoleMutation,
	UpdateAuthorizationRoleMutationVariables
>;
export const DeleteAuthorizationRoleDocument = gql`
	mutation DeleteAuthorizationRole($input: DeleteInput!) {
		deleteAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteAuthorizationRoleMutationFn = Apollo.MutationFunction<
	DeleteAuthorizationRoleMutation,
	DeleteAuthorizationRoleMutationVariables
>;

/**
 * __useDeleteAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorizationRoleMutation, { data, loading, error }] = useDeleteAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteAuthorizationRoleMutation,
		DeleteAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteAuthorizationRoleMutation,
		DeleteAuthorizationRoleMutationVariables
	>(DeleteAuthorizationRoleDocument, options);
}
export type DeleteAuthorizationRoleMutationHookResult = ReturnType<
	typeof useDeleteAuthorizationRoleMutation
>;
export type DeleteAuthorizationRoleMutationResult =
	Apollo.MutationResult<DeleteAuthorizationRoleMutation>;
export type DeleteAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteAuthorizationRoleMutation,
	DeleteAuthorizationRoleMutationVariables
>;
export const DeleteManyAuthorizationRoleDocument = gql`
	mutation DeleteManyAuthorizationRole($input: DeleteManyInput!) {
		deleteManyAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyAuthorizationRoleMutationFn = Apollo.MutationFunction<
	DeleteManyAuthorizationRoleMutation,
	DeleteManyAuthorizationRoleMutationVariables
>;

/**
 * __useDeleteManyAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useDeleteManyAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAuthorizationRoleMutation, { data, loading, error }] = useDeleteManyAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAuthorizationRoleMutation,
		DeleteManyAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyAuthorizationRoleMutation,
		DeleteManyAuthorizationRoleMutationVariables
	>(DeleteManyAuthorizationRoleDocument, options);
}
export type DeleteManyAuthorizationRoleMutationHookResult = ReturnType<
	typeof useDeleteManyAuthorizationRoleMutation
>;
export type DeleteManyAuthorizationRoleMutationResult =
	Apollo.MutationResult<DeleteManyAuthorizationRoleMutation>;
export type DeleteManyAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAuthorizationRoleMutation,
	DeleteManyAuthorizationRoleMutationVariables
>;
export const CreateManyAuthorizationUserRoleDocument = gql`
	mutation CreateManyAuthorizationUserRole($input: CreateManyAuthorizationUserRoleInput!) {
		createManyAuthorizationUserRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateManyAuthorizationUserRoleMutationFn = Apollo.MutationFunction<
	CreateManyAuthorizationUserRoleMutation,
	CreateManyAuthorizationUserRoleMutationVariables
>;

/**
 * __useCreateManyAuthorizationUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateManyAuthorizationUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyAuthorizationUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyAuthorizationUserRoleMutation, { data, loading, error }] = useCreateManyAuthorizationUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManyAuthorizationUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateManyAuthorizationUserRoleMutation,
		CreateManyAuthorizationUserRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateManyAuthorizationUserRoleMutation,
		CreateManyAuthorizationUserRoleMutationVariables
	>(CreateManyAuthorizationUserRoleDocument, options);
}
export type CreateManyAuthorizationUserRoleMutationHookResult = ReturnType<
	typeof useCreateManyAuthorizationUserRoleMutation
>;
export type CreateManyAuthorizationUserRoleMutationResult =
	Apollo.MutationResult<CreateManyAuthorizationUserRoleMutation>;
export type CreateManyAuthorizationUserRoleMutationOptions = Apollo.BaseMutationOptions<
	CreateManyAuthorizationUserRoleMutation,
	CreateManyAuthorizationUserRoleMutationVariables
>;
export const DeleteManyAuthorizationUserRoleDocument = gql`
	mutation DeleteManyAuthorizationUserRole($input: DeleteManyAuthorizationUserRoleInput!) {
		deleteManyAuthorizationUserRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyAuthorizationUserRoleMutationFn = Apollo.MutationFunction<
	DeleteManyAuthorizationUserRoleMutation,
	DeleteManyAuthorizationUserRoleMutationVariables
>;

/**
 * __useDeleteManyAuthorizationUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteManyAuthorizationUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAuthorizationUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAuthorizationUserRoleMutation, { data, loading, error }] = useDeleteManyAuthorizationUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAuthorizationUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAuthorizationUserRoleMutation,
		DeleteManyAuthorizationUserRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyAuthorizationUserRoleMutation,
		DeleteManyAuthorizationUserRoleMutationVariables
	>(DeleteManyAuthorizationUserRoleDocument, options);
}
export type DeleteManyAuthorizationUserRoleMutationHookResult = ReturnType<
	typeof useDeleteManyAuthorizationUserRoleMutation
>;
export type DeleteManyAuthorizationUserRoleMutationResult =
	Apollo.MutationResult<DeleteManyAuthorizationUserRoleMutation>;
export type DeleteManyAuthorizationUserRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAuthorizationUserRoleMutation,
	DeleteManyAuthorizationUserRoleMutationVariables
>;
export const AssignPermissionsToRoleDocument = gql`
	mutation AssignPermissionsToRole($input: AssignPermissionsToRoleInput!) {
		assignPermissionsToRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AssignPermissionsToRoleMutationFn = Apollo.MutationFunction<
	AssignPermissionsToRoleMutation,
	AssignPermissionsToRoleMutationVariables
>;

/**
 * __useAssignPermissionsToRoleMutation__
 *
 * To run a mutation, you first call `useAssignPermissionsToRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPermissionsToRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPermissionsToRoleMutation, { data, loading, error }] = useAssignPermissionsToRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPermissionsToRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignPermissionsToRoleMutation,
		AssignPermissionsToRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignPermissionsToRoleMutation,
		AssignPermissionsToRoleMutationVariables
	>(AssignPermissionsToRoleDocument, options);
}
export type AssignPermissionsToRoleMutationHookResult = ReturnType<
	typeof useAssignPermissionsToRoleMutation
>;
export type AssignPermissionsToRoleMutationResult =
	Apollo.MutationResult<AssignPermissionsToRoleMutation>;
export type AssignPermissionsToRoleMutationOptions = Apollo.BaseMutationOptions<
	AssignPermissionsToRoleMutation,
	AssignPermissionsToRoleMutationVariables
>;
export const RemovePermissionsFromRoleDocument = gql`
	mutation RemovePermissionsFromRole($input: RemovePermissionsFromRoleInput!) {
		removePermissionsFromRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemovePermissionsFromRoleMutationFn = Apollo.MutationFunction<
	RemovePermissionsFromRoleMutation,
	RemovePermissionsFromRoleMutationVariables
>;

/**
 * __useRemovePermissionsFromRoleMutation__
 *
 * To run a mutation, you first call `useRemovePermissionsFromRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionsFromRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionsFromRoleMutation, { data, loading, error }] = useRemovePermissionsFromRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePermissionsFromRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemovePermissionsFromRoleMutation,
		RemovePermissionsFromRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemovePermissionsFromRoleMutation,
		RemovePermissionsFromRoleMutationVariables
	>(RemovePermissionsFromRoleDocument, options);
}
export type RemovePermissionsFromRoleMutationHookResult = ReturnType<
	typeof useRemovePermissionsFromRoleMutation
>;
export type RemovePermissionsFromRoleMutationResult =
	Apollo.MutationResult<RemovePermissionsFromRoleMutation>;
export type RemovePermissionsFromRoleMutationOptions = Apollo.BaseMutationOptions<
	RemovePermissionsFromRoleMutation,
	RemovePermissionsFromRoleMutationVariables
>;
export const CreateBrandDocument = gql`
	mutation CreateBrand($input: BrandCreateInput!) {
		createBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateBrandMutationFn = Apollo.MutationFunction<
	CreateBrandMutation,
	CreateBrandMutationVariables
>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateBrandMutation, CreateBrandMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(
		CreateBrandDocument,
		options
	);
}
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<CreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<
	CreateBrandMutation,
	CreateBrandMutationVariables
>;
export const UpdateBrandDocument = gql`
	mutation UpdateBrand($input: BrandUpdateInput!) {
		updateBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateBrandMutationFn = Apollo.MutationFunction<
	UpdateBrandMutation,
	UpdateBrandMutationVariables
>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(
		UpdateBrandDocument,
		options
	);
}
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<
	UpdateBrandMutation,
	UpdateBrandMutationVariables
>;
export const DeleteBrandDocument = gql`
	mutation DeleteBrand($input: DeleteInput!) {
		deleteBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteBrandMutationFn = Apollo.MutationFunction<
	DeleteBrandMutation,
	DeleteBrandMutationVariables
>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBrandMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteBrandMutation, DeleteBrandMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(
		DeleteBrandDocument,
		options
	);
}
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<DeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<
	DeleteBrandMutation,
	DeleteBrandMutationVariables
>;
export const DeleteManyBrandsDocument = gql`
	mutation DeleteManyBrands($input: DeleteManyInput!) {
		deleteManyBrand(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyBrandsMutationFn = Apollo.MutationFunction<
	DeleteManyBrandsMutation,
	DeleteManyBrandsMutationVariables
>;

/**
 * __useDeleteManyBrandsMutation__
 *
 * To run a mutation, you first call `useDeleteManyBrandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyBrandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyBrandsMutation, { data, loading, error }] = useDeleteManyBrandsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyBrandsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyBrandsMutation,
		DeleteManyBrandsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyBrandsMutation, DeleteManyBrandsMutationVariables>(
		DeleteManyBrandsDocument,
		options
	);
}
export type DeleteManyBrandsMutationHookResult = ReturnType<typeof useDeleteManyBrandsMutation>;
export type DeleteManyBrandsMutationResult = Apollo.MutationResult<DeleteManyBrandsMutation>;
export type DeleteManyBrandsMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyBrandsMutation,
	DeleteManyBrandsMutationVariables
>;
export const GenerateBrandFontUploadUrlDocument = gql`
	mutation GenerateBrandFontUploadUrl($input: FontFileUploadInput!) {
		generateBrandFontUploadUrl(input: $input) {
			success
			message
			uploadUrl
			blobUrl
			fileId
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;
export type GenerateBrandFontUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateBrandFontUploadUrlMutation,
	GenerateBrandFontUploadUrlMutationVariables
>;

/**
 * __useGenerateBrandFontUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateBrandFontUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBrandFontUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBrandFontUploadUrlMutation, { data, loading, error }] = useGenerateBrandFontUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBrandFontUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateBrandFontUploadUrlMutation,
		GenerateBrandFontUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateBrandFontUploadUrlMutation,
		GenerateBrandFontUploadUrlMutationVariables
	>(GenerateBrandFontUploadUrlDocument, options);
}
export type GenerateBrandFontUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateBrandFontUploadUrlMutation
>;
export type GenerateBrandFontUploadUrlMutationResult =
	Apollo.MutationResult<GenerateBrandFontUploadUrlMutation>;
export type GenerateBrandFontUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateBrandFontUploadUrlMutation,
	GenerateBrandFontUploadUrlMutationVariables
>;
export const GenerateBrandFileUploadUrlDocument = gql`
	mutation GenerateBrandFileUploadUrl($input: BrandFileUploadInput!) {
		generateBrandFileUploadUrl(input: $input) {
			success
			message
			uploadUrl
			blobUrl
			fileId
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;
export type GenerateBrandFileUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateBrandFileUploadUrlMutation,
	GenerateBrandFileUploadUrlMutationVariables
>;

/**
 * __useGenerateBrandFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateBrandFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBrandFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBrandFileUploadUrlMutation, { data, loading, error }] = useGenerateBrandFileUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBrandFileUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateBrandFileUploadUrlMutation,
		GenerateBrandFileUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateBrandFileUploadUrlMutation,
		GenerateBrandFileUploadUrlMutationVariables
	>(GenerateBrandFileUploadUrlDocument, options);
}
export type GenerateBrandFileUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateBrandFileUploadUrlMutation
>;
export type GenerateBrandFileUploadUrlMutationResult =
	Apollo.MutationResult<GenerateBrandFileUploadUrlMutation>;
export type GenerateBrandFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateBrandFileUploadUrlMutation,
	GenerateBrandFileUploadUrlMutationVariables
>;
export const ConfirmBrandFileUploadDocument = gql`
	mutation ConfirmBrandFileUpload($input: ConfirmBrandFileUploadInput!) {
		confirmBrandFileUpload(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmBrandFileUploadMutationFn = Apollo.MutationFunction<
	ConfirmBrandFileUploadMutation,
	ConfirmBrandFileUploadMutationVariables
>;

/**
 * __useConfirmBrandFileUploadMutation__
 *
 * To run a mutation, you first call `useConfirmBrandFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBrandFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBrandFileUploadMutation, { data, loading, error }] = useConfirmBrandFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmBrandFileUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmBrandFileUploadMutation,
		ConfirmBrandFileUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmBrandFileUploadMutation,
		ConfirmBrandFileUploadMutationVariables
	>(ConfirmBrandFileUploadDocument, options);
}
export type ConfirmBrandFileUploadMutationHookResult = ReturnType<
	typeof useConfirmBrandFileUploadMutation
>;
export type ConfirmBrandFileUploadMutationResult =
	Apollo.MutationResult<ConfirmBrandFileUploadMutation>;
export type ConfirmBrandFileUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmBrandFileUploadMutation,
	ConfirmBrandFileUploadMutationVariables
>;
export const ConfirmBrandFontUploadDocument = gql`
	mutation ConfirmBrandFontUpload($input: ConfirmBrandFontUploadInput!) {
		confirmBrandFontUpload(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ConfirmBrandFontUploadMutationFn = Apollo.MutationFunction<
	ConfirmBrandFontUploadMutation,
	ConfirmBrandFontUploadMutationVariables
>;

/**
 * __useConfirmBrandFontUploadMutation__
 *
 * To run a mutation, you first call `useConfirmBrandFontUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBrandFontUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBrandFontUploadMutation, { data, loading, error }] = useConfirmBrandFontUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmBrandFontUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmBrandFontUploadMutation,
		ConfirmBrandFontUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmBrandFontUploadMutation,
		ConfirmBrandFontUploadMutationVariables
	>(ConfirmBrandFontUploadDocument, options);
}
export type ConfirmBrandFontUploadMutationHookResult = ReturnType<
	typeof useConfirmBrandFontUploadMutation
>;
export type ConfirmBrandFontUploadMutationResult =
	Apollo.MutationResult<ConfirmBrandFontUploadMutation>;
export type ConfirmBrandFontUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmBrandFontUploadMutation,
	ConfirmBrandFontUploadMutationVariables
>;
export const DeleteBrandFileDocument = gql`
	mutation DeleteBrandFile($brandId: ID!, $fileId: ID!) {
		deleteBrandFile(brandId: $brandId, fileId: $fileId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteBrandFileMutationFn = Apollo.MutationFunction<
	DeleteBrandFileMutation,
	DeleteBrandFileMutationVariables
>;

/**
 * __useDeleteBrandFileMutation__
 *
 * To run a mutation, you first call `useDeleteBrandFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandFileMutation, { data, loading, error }] = useDeleteBrandFileMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteBrandFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteBrandFileMutation,
		DeleteBrandFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteBrandFileMutation, DeleteBrandFileMutationVariables>(
		DeleteBrandFileDocument,
		options
	);
}
export type DeleteBrandFileMutationHookResult = ReturnType<typeof useDeleteBrandFileMutation>;
export type DeleteBrandFileMutationResult = Apollo.MutationResult<DeleteBrandFileMutation>;
export type DeleteBrandFileMutationOptions = Apollo.BaseMutationOptions<
	DeleteBrandFileMutation,
	DeleteBrandFileMutationVariables
>;
export const DeleteBrandFontDocument = gql`
	mutation DeleteBrandFont($brandId: ID!, $fontId: ID!) {
		deleteBrandFont(brandId: $brandId, fontId: $fontId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteBrandFontMutationFn = Apollo.MutationFunction<
	DeleteBrandFontMutation,
	DeleteBrandFontMutationVariables
>;

/**
 * __useDeleteBrandFontMutation__
 *
 * To run a mutation, you first call `useDeleteBrandFontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandFontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandFontMutation, { data, loading, error }] = useDeleteBrandFontMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      fontId: // value for 'fontId'
 *   },
 * });
 */
export function useDeleteBrandFontMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteBrandFontMutation,
		DeleteBrandFontMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteBrandFontMutation, DeleteBrandFontMutationVariables>(
		DeleteBrandFontDocument,
		options
	);
}
export type DeleteBrandFontMutationHookResult = ReturnType<typeof useDeleteBrandFontMutation>;
export type DeleteBrandFontMutationResult = Apollo.MutationResult<DeleteBrandFontMutation>;
export type DeleteBrandFontMutationOptions = Apollo.BaseMutationOptions<
	DeleteBrandFontMutation,
	DeleteBrandFontMutationVariables
>;
export const CategorizeBulkProductImagesDocument = gql`
	mutation CategorizeBulkProductImages($input: CategorizeBulkProductImagesInput!) {
		categorizeBulkProductImages(input: $input) {
			success
			message
			totalImages
			categorizedImages
			products {
				productName
				imageUrls
			}
			unmappedImages {
				imageUrl
				fileName
			}
		}
	}
`;
export type CategorizeBulkProductImagesMutationFn = Apollo.MutationFunction<
	CategorizeBulkProductImagesMutation,
	CategorizeBulkProductImagesMutationVariables
>;

/**
 * __useCategorizeBulkProductImagesMutation__
 *
 * To run a mutation, you first call `useCategorizeBulkProductImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategorizeBulkProductImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categorizeBulkProductImagesMutation, { data, loading, error }] = useCategorizeBulkProductImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCategorizeBulkProductImagesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CategorizeBulkProductImagesMutation,
		CategorizeBulkProductImagesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CategorizeBulkProductImagesMutation,
		CategorizeBulkProductImagesMutationVariables
	>(CategorizeBulkProductImagesDocument, options);
}
export type CategorizeBulkProductImagesMutationHookResult = ReturnType<
	typeof useCategorizeBulkProductImagesMutation
>;
export type CategorizeBulkProductImagesMutationResult =
	Apollo.MutationResult<CategorizeBulkProductImagesMutation>;
export type CategorizeBulkProductImagesMutationOptions = Apollo.BaseMutationOptions<
	CategorizeBulkProductImagesMutation,
	CategorizeBulkProductImagesMutationVariables
>;
export const CreateChatContextDocument = gql`
	mutation CreateChatContext($input: CreateChatContextInput!) {
		createChatContext(input: $input) {
			message
			success
		}
	}
`;
export type CreateChatContextMutationFn = Apollo.MutationFunction<
	CreateChatContextMutation,
	CreateChatContextMutationVariables
>;

/**
 * __useCreateChatContextMutation__
 *
 * To run a mutation, you first call `useCreateChatContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatContextMutation, { data, loading, error }] = useCreateChatContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatContextMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateChatContextMutation,
		CreateChatContextMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateChatContextMutation, CreateChatContextMutationVariables>(
		CreateChatContextDocument,
		options
	);
}
export type CreateChatContextMutationHookResult = ReturnType<typeof useCreateChatContextMutation>;
export type CreateChatContextMutationResult = Apollo.MutationResult<CreateChatContextMutation>;
export type CreateChatContextMutationOptions = Apollo.BaseMutationOptions<
	CreateChatContextMutation,
	CreateChatContextMutationVariables
>;
export const SendContextMessageDocument = gql`
	mutation SendContextMessage($input: SendContextMessageInput!) {
		sendContextMessage(input: $input) {
			message
			success
		}
	}
`;
export type SendContextMessageMutationFn = Apollo.MutationFunction<
	SendContextMessageMutation,
	SendContextMessageMutationVariables
>;

/**
 * __useSendContextMessageMutation__
 *
 * To run a mutation, you first call `useSendContextMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContextMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContextMessageMutation, { data, loading, error }] = useSendContextMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContextMessageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendContextMessageMutation,
		SendContextMessageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendContextMessageMutation, SendContextMessageMutationVariables>(
		SendContextMessageDocument,
		options
	);
}
export type SendContextMessageMutationHookResult = ReturnType<typeof useSendContextMessageMutation>;
export type SendContextMessageMutationResult = Apollo.MutationResult<SendContextMessageMutation>;
export type SendContextMessageMutationOptions = Apollo.BaseMutationOptions<
	SendContextMessageMutation,
	SendContextMessageMutationVariables
>;
export const MarkMessagesAsReadDocument = gql`
	mutation MarkMessagesAsRead($input: MarkContextMessagesAsReadInput!) {
		markContextMessagesAsRead(input: $input) {
			success
			message
		}
	}
`;
export type MarkMessagesAsReadMutationFn = Apollo.MutationFunction<
	MarkMessagesAsReadMutation,
	MarkMessagesAsReadMutationVariables
>;

/**
 * __useMarkMessagesAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessagesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessagesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessagesAsReadMutation, { data, loading, error }] = useMarkMessagesAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkMessagesAsReadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkMessagesAsReadMutation,
		MarkMessagesAsReadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkMessagesAsReadMutation, MarkMessagesAsReadMutationVariables>(
		MarkMessagesAsReadDocument,
		options
	);
}
export type MarkMessagesAsReadMutationHookResult = ReturnType<typeof useMarkMessagesAsReadMutation>;
export type MarkMessagesAsReadMutationResult = Apollo.MutationResult<MarkMessagesAsReadMutation>;
export type MarkMessagesAsReadMutationOptions = Apollo.BaseMutationOptions<
	MarkMessagesAsReadMutation,
	MarkMessagesAsReadMutationVariables
>;
export const GenerateChatFileUploadUrlDocument = gql`
	mutation GenerateChatFileUploadUrl($input: ChatFileUploadInput!) {
		generateChatFileUploadUrl(input: $input) {
			success
			uploadUrl
			fileId
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateChatFileUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateChatFileUploadUrlMutation,
	GenerateChatFileUploadUrlMutationVariables
>;

/**
 * __useGenerateChatFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateChatFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateChatFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateChatFileUploadUrlMutation, { data, loading, error }] = useGenerateChatFileUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateChatFileUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateChatFileUploadUrlMutation,
		GenerateChatFileUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateChatFileUploadUrlMutation,
		GenerateChatFileUploadUrlMutationVariables
	>(GenerateChatFileUploadUrlDocument, options);
}
export type GenerateChatFileUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateChatFileUploadUrlMutation
>;
export type GenerateChatFileUploadUrlMutationResult =
	Apollo.MutationResult<GenerateChatFileUploadUrlMutation>;
export type GenerateChatFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateChatFileUploadUrlMutation,
	GenerateChatFileUploadUrlMutationVariables
>;
export const ConfirmChatFileUploadDocument = gql`
	mutation ConfirmChatFileUpload($input: ConfirmChatFileUploadInput!) {
		confirmChatFileUpload(input: $input) {
			success
			message
		}
	}
`;
export type ConfirmChatFileUploadMutationFn = Apollo.MutationFunction<
	ConfirmChatFileUploadMutation,
	ConfirmChatFileUploadMutationVariables
>;

/**
 * __useConfirmChatFileUploadMutation__
 *
 * To run a mutation, you first call `useConfirmChatFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmChatFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmChatFileUploadMutation, { data, loading, error }] = useConfirmChatFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmChatFileUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmChatFileUploadMutation,
		ConfirmChatFileUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmChatFileUploadMutation,
		ConfirmChatFileUploadMutationVariables
	>(ConfirmChatFileUploadDocument, options);
}
export type ConfirmChatFileUploadMutationHookResult = ReturnType<
	typeof useConfirmChatFileUploadMutation
>;
export type ConfirmChatFileUploadMutationResult =
	Apollo.MutationResult<ConfirmChatFileUploadMutation>;
export type ConfirmChatFileUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmChatFileUploadMutation,
	ConfirmChatFileUploadMutationVariables
>;
export const DeleteChatFileDocument = gql`
	mutation DeleteChatFile($contextId: ID!, $fileId: ID!) {
		deleteChatFile(contextId: $contextId, fileId: $fileId) {
			success
			message
			referenceKey
		}
	}
`;
export type DeleteChatFileMutationFn = Apollo.MutationFunction<
	DeleteChatFileMutation,
	DeleteChatFileMutationVariables
>;

/**
 * __useDeleteChatFileMutation__
 *
 * To run a mutation, you first call `useDeleteChatFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatFileMutation, { data, loading, error }] = useDeleteChatFileMutation({
 *   variables: {
 *      contextId: // value for 'contextId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteChatFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteChatFileMutation,
		DeleteChatFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteChatFileMutation, DeleteChatFileMutationVariables>(
		DeleteChatFileDocument,
		options
	);
}
export type DeleteChatFileMutationHookResult = ReturnType<typeof useDeleteChatFileMutation>;
export type DeleteChatFileMutationResult = Apollo.MutationResult<DeleteChatFileMutation>;
export type DeleteChatFileMutationOptions = Apollo.BaseMutationOptions<
	DeleteChatFileMutation,
	DeleteChatFileMutationVariables
>;
export const UpdateChatContextTranslationDocument = gql`
	mutation UpdateChatContextTranslation($input: UpdateChatContextTranslationInput!) {
		updateChatContextTranslation(input: $input) {
			success
			message
		}
	}
`;
export type UpdateChatContextTranslationMutationFn = Apollo.MutationFunction<
	UpdateChatContextTranslationMutation,
	UpdateChatContextTranslationMutationVariables
>;

/**
 * __useUpdateChatContextTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateChatContextTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatContextTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatContextTranslationMutation, { data, loading, error }] = useUpdateChatContextTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatContextTranslationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateChatContextTranslationMutation,
		UpdateChatContextTranslationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateChatContextTranslationMutation,
		UpdateChatContextTranslationMutationVariables
	>(UpdateChatContextTranslationDocument, options);
}
export type UpdateChatContextTranslationMutationHookResult = ReturnType<
	typeof useUpdateChatContextTranslationMutation
>;
export type UpdateChatContextTranslationMutationResult =
	Apollo.MutationResult<UpdateChatContextTranslationMutation>;
export type UpdateChatContextTranslationMutationOptions = Apollo.BaseMutationOptions<
	UpdateChatContextTranslationMutation,
	UpdateChatContextTranslationMutationVariables
>;
export const CreateOrganizationProductInterestDocument = gql`
	mutation CreateOrganizationProductInterest($input: OrganizationProductInterestCreateInput!) {
		createOrganizationProductInterest(input: $input) {
			id
			organizationId
			productTagId
		}
	}
`;
export type CreateOrganizationProductInterestMutationFn = Apollo.MutationFunction<
	CreateOrganizationProductInterestMutation,
	CreateOrganizationProductInterestMutationVariables
>;

/**
 * __useCreateOrganizationProductInterestMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationProductInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationProductInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationProductInterestMutation, { data, loading, error }] = useCreateOrganizationProductInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationProductInterestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationProductInterestMutation,
		CreateOrganizationProductInterestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationProductInterestMutation,
		CreateOrganizationProductInterestMutationVariables
	>(CreateOrganizationProductInterestDocument, options);
}
export type CreateOrganizationProductInterestMutationHookResult = ReturnType<
	typeof useCreateOrganizationProductInterestMutation
>;
export type CreateOrganizationProductInterestMutationResult =
	Apollo.MutationResult<CreateOrganizationProductInterestMutation>;
export type CreateOrganizationProductInterestMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationProductInterestMutation,
	CreateOrganizationProductInterestMutationVariables
>;
export const DeleteOrganizationProductInterestDocument = gql`
	mutation DeleteOrganizationProductInterest($id: ID!) {
		deleteOrganizationProductInterest(id: $id) {
			success
			message
		}
	}
`;
export type DeleteOrganizationProductInterestMutationFn = Apollo.MutationFunction<
	DeleteOrganizationProductInterestMutation,
	DeleteOrganizationProductInterestMutationVariables
>;

/**
 * __useDeleteOrganizationProductInterestMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationProductInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationProductInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationProductInterestMutation, { data, loading, error }] = useDeleteOrganizationProductInterestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationProductInterestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationProductInterestMutation,
		DeleteOrganizationProductInterestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationProductInterestMutation,
		DeleteOrganizationProductInterestMutationVariables
	>(DeleteOrganizationProductInterestDocument, options);
}
export type DeleteOrganizationProductInterestMutationHookResult = ReturnType<
	typeof useDeleteOrganizationProductInterestMutation
>;
export type DeleteOrganizationProductInterestMutationResult =
	Apollo.MutationResult<DeleteOrganizationProductInterestMutation>;
export type DeleteOrganizationProductInterestMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationProductInterestMutation,
	DeleteOrganizationProductInterestMutationVariables
>;
export const CreateOrganizationSourcingPreferenceConnectionDocument = gql`
	mutation CreateOrganizationSourcingPreferenceConnection(
		$input: OrganizationSourcingPreferenceConnectionCreateInput!
	) {
		createOrganizationSourcingPreferenceConnection(input: $input) {
			id
			organizationId
			organizationSourcingPreferenceId
			priority
			notes
			organizationSourcingPreference {
				id
				name
				description
			}
		}
	}
`;
export type CreateOrganizationSourcingPreferenceConnectionMutationFn = Apollo.MutationFunction<
	CreateOrganizationSourcingPreferenceConnectionMutation,
	CreateOrganizationSourcingPreferenceConnectionMutationVariables
>;

/**
 * __useCreateOrganizationSourcingPreferenceConnectionMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationSourcingPreferenceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationSourcingPreferenceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationSourcingPreferenceConnectionMutation, { data, loading, error }] = useCreateOrganizationSourcingPreferenceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationSourcingPreferenceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationSourcingPreferenceConnectionMutation,
		CreateOrganizationSourcingPreferenceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationSourcingPreferenceConnectionMutation,
		CreateOrganizationSourcingPreferenceConnectionMutationVariables
	>(CreateOrganizationSourcingPreferenceConnectionDocument, options);
}
export type CreateOrganizationSourcingPreferenceConnectionMutationHookResult = ReturnType<
	typeof useCreateOrganizationSourcingPreferenceConnectionMutation
>;
export type CreateOrganizationSourcingPreferenceConnectionMutationResult =
	Apollo.MutationResult<CreateOrganizationSourcingPreferenceConnectionMutation>;
export type CreateOrganizationSourcingPreferenceConnectionMutationOptions =
	Apollo.BaseMutationOptions<
		CreateOrganizationSourcingPreferenceConnectionMutation,
		CreateOrganizationSourcingPreferenceConnectionMutationVariables
	>;
export const UpdateOrganizationSourcingPreferenceConnectionDocument = gql`
	mutation UpdateOrganizationSourcingPreferenceConnection(
		$input: OrganizationSourcingPreferenceConnectionUpdateInput!
	) {
		updateOrganizationSourcingPreferenceConnection(input: $input) {
			id
			organizationId
			organizationSourcingPreferenceId
			priority
			notes
			organizationSourcingPreference {
				id
				name
				description
			}
		}
	}
`;
export type UpdateOrganizationSourcingPreferenceConnectionMutationFn = Apollo.MutationFunction<
	UpdateOrganizationSourcingPreferenceConnectionMutation,
	UpdateOrganizationSourcingPreferenceConnectionMutationVariables
>;

/**
 * __useUpdateOrganizationSourcingPreferenceConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSourcingPreferenceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSourcingPreferenceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSourcingPreferenceConnectionMutation, { data, loading, error }] = useUpdateOrganizationSourcingPreferenceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSourcingPreferenceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationSourcingPreferenceConnectionMutation,
		UpdateOrganizationSourcingPreferenceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationSourcingPreferenceConnectionMutation,
		UpdateOrganizationSourcingPreferenceConnectionMutationVariables
	>(UpdateOrganizationSourcingPreferenceConnectionDocument, options);
}
export type UpdateOrganizationSourcingPreferenceConnectionMutationHookResult = ReturnType<
	typeof useUpdateOrganizationSourcingPreferenceConnectionMutation
>;
export type UpdateOrganizationSourcingPreferenceConnectionMutationResult =
	Apollo.MutationResult<UpdateOrganizationSourcingPreferenceConnectionMutation>;
export type UpdateOrganizationSourcingPreferenceConnectionMutationOptions =
	Apollo.BaseMutationOptions<
		UpdateOrganizationSourcingPreferenceConnectionMutation,
		UpdateOrganizationSourcingPreferenceConnectionMutationVariables
	>;
export const DeleteOrganizationSourcingPreferenceConnectionDocument = gql`
	mutation DeleteOrganizationSourcingPreferenceConnection($id: ID!) {
		deleteOrganizationSourcingPreferenceConnection(id: $id) {
			success
			message
		}
	}
`;
export type DeleteOrganizationSourcingPreferenceConnectionMutationFn = Apollo.MutationFunction<
	DeleteOrganizationSourcingPreferenceConnectionMutation,
	DeleteOrganizationSourcingPreferenceConnectionMutationVariables
>;

/**
 * __useDeleteOrganizationSourcingPreferenceConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationSourcingPreferenceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationSourcingPreferenceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationSourcingPreferenceConnectionMutation, { data, loading, error }] = useDeleteOrganizationSourcingPreferenceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationSourcingPreferenceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationSourcingPreferenceConnectionMutation,
		DeleteOrganizationSourcingPreferenceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationSourcingPreferenceConnectionMutation,
		DeleteOrganizationSourcingPreferenceConnectionMutationVariables
	>(DeleteOrganizationSourcingPreferenceConnectionDocument, options);
}
export type DeleteOrganizationSourcingPreferenceConnectionMutationHookResult = ReturnType<
	typeof useDeleteOrganizationSourcingPreferenceConnectionMutation
>;
export type DeleteOrganizationSourcingPreferenceConnectionMutationResult =
	Apollo.MutationResult<DeleteOrganizationSourcingPreferenceConnectionMutation>;
export type DeleteOrganizationSourcingPreferenceConnectionMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteOrganizationSourcingPreferenceConnectionMutation,
		DeleteOrganizationSourcingPreferenceConnectionMutationVariables
	>;
export const CreateOrganizationComplianceConnectionDocument = gql`
	mutation CreateOrganizationComplianceConnection(
		$input: OrganizationComplianceConnectionCreateInput!
	) {
		createOrganizationComplianceConnection(input: $input) {
			id
			organizationId
			organizationComplianceId
			certificationNumber
			certifyingBody
			issueDate
			expiryDate
			organizationCompliance {
				id
				name
				description
			}
		}
	}
`;
export type CreateOrganizationComplianceConnectionMutationFn = Apollo.MutationFunction<
	CreateOrganizationComplianceConnectionMutation,
	CreateOrganizationComplianceConnectionMutationVariables
>;

/**
 * __useCreateOrganizationComplianceConnectionMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationComplianceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationComplianceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationComplianceConnectionMutation, { data, loading, error }] = useCreateOrganizationComplianceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationComplianceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationComplianceConnectionMutation,
		CreateOrganizationComplianceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationComplianceConnectionMutation,
		CreateOrganizationComplianceConnectionMutationVariables
	>(CreateOrganizationComplianceConnectionDocument, options);
}
export type CreateOrganizationComplianceConnectionMutationHookResult = ReturnType<
	typeof useCreateOrganizationComplianceConnectionMutation
>;
export type CreateOrganizationComplianceConnectionMutationResult =
	Apollo.MutationResult<CreateOrganizationComplianceConnectionMutation>;
export type CreateOrganizationComplianceConnectionMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationComplianceConnectionMutation,
	CreateOrganizationComplianceConnectionMutationVariables
>;
export const UpdateOrganizationComplianceConnectionDocument = gql`
	mutation UpdateOrganizationComplianceConnection(
		$input: OrganizationComplianceConnectionUpdateInput!
	) {
		updateOrganizationComplianceConnection(input: $input) {
			id
			organizationId
			organizationComplianceId
			certificationNumber
			certifyingBody
			issueDate
			expiryDate
			organizationCompliance {
				id
				name
				description
			}
		}
	}
`;
export type UpdateOrganizationComplianceConnectionMutationFn = Apollo.MutationFunction<
	UpdateOrganizationComplianceConnectionMutation,
	UpdateOrganizationComplianceConnectionMutationVariables
>;

/**
 * __useUpdateOrganizationComplianceConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationComplianceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationComplianceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationComplianceConnectionMutation, { data, loading, error }] = useUpdateOrganizationComplianceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationComplianceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationComplianceConnectionMutation,
		UpdateOrganizationComplianceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationComplianceConnectionMutation,
		UpdateOrganizationComplianceConnectionMutationVariables
	>(UpdateOrganizationComplianceConnectionDocument, options);
}
export type UpdateOrganizationComplianceConnectionMutationHookResult = ReturnType<
	typeof useUpdateOrganizationComplianceConnectionMutation
>;
export type UpdateOrganizationComplianceConnectionMutationResult =
	Apollo.MutationResult<UpdateOrganizationComplianceConnectionMutation>;
export type UpdateOrganizationComplianceConnectionMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationComplianceConnectionMutation,
	UpdateOrganizationComplianceConnectionMutationVariables
>;
export const DeleteOrganizationComplianceConnectionDocument = gql`
	mutation DeleteOrganizationComplianceConnection($id: ID!) {
		deleteOrganizationComplianceConnection(id: $id) {
			success
			message
		}
	}
`;
export type DeleteOrganizationComplianceConnectionMutationFn = Apollo.MutationFunction<
	DeleteOrganizationComplianceConnectionMutation,
	DeleteOrganizationComplianceConnectionMutationVariables
>;

/**
 * __useDeleteOrganizationComplianceConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationComplianceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationComplianceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationComplianceConnectionMutation, { data, loading, error }] = useDeleteOrganizationComplianceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationComplianceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationComplianceConnectionMutation,
		DeleteOrganizationComplianceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationComplianceConnectionMutation,
		DeleteOrganizationComplianceConnectionMutationVariables
	>(DeleteOrganizationComplianceConnectionDocument, options);
}
export type DeleteOrganizationComplianceConnectionMutationHookResult = ReturnType<
	typeof useDeleteOrganizationComplianceConnectionMutation
>;
export type DeleteOrganizationComplianceConnectionMutationResult =
	Apollo.MutationResult<DeleteOrganizationComplianceConnectionMutation>;
export type DeleteOrganizationComplianceConnectionMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationComplianceConnectionMutation,
	DeleteOrganizationComplianceConnectionMutationVariables
>;
export const CreateProductVariantFromStudioFileDocument = gql`
	mutation CreateProductVariantFromStudioFile($input: CreateProductVariantFromStudioInput!) {
		createProductVariantFromStudioFile(input: $input) {
			success
			message
			productId
		}
	}
`;
export type CreateProductVariantFromStudioFileMutationFn = Apollo.MutationFunction<
	CreateProductVariantFromStudioFileMutation,
	CreateProductVariantFromStudioFileMutationVariables
>;

/**
 * __useCreateProductVariantFromStudioFileMutation__
 *
 * To run a mutation, you first call `useCreateProductVariantFromStudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductVariantFromStudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductVariantFromStudioFileMutation, { data, loading, error }] = useCreateProductVariantFromStudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductVariantFromStudioFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProductVariantFromStudioFileMutation,
		CreateProductVariantFromStudioFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateProductVariantFromStudioFileMutation,
		CreateProductVariantFromStudioFileMutationVariables
	>(CreateProductVariantFromStudioFileDocument, options);
}
export type CreateProductVariantFromStudioFileMutationHookResult = ReturnType<
	typeof useCreateProductVariantFromStudioFileMutation
>;
export type CreateProductVariantFromStudioFileMutationResult =
	Apollo.MutationResult<CreateProductVariantFromStudioFileMutation>;
export type CreateProductVariantFromStudioFileMutationOptions = Apollo.BaseMutationOptions<
	CreateProductVariantFromStudioFileMutation,
	CreateProductVariantFromStudioFileMutationVariables
>;
export const CreateProjectDocument = gql`
	mutation CreateProject($input: CreateProjectInput!) {
		createProject(input: $input) {
			success
			message
			project {
				id
				name
				description
				startDate
				endDate
			}
		}
	}
`;
export type CreateProjectMutationFn = Apollo.MutationFunction<
	CreateProjectMutation,
	CreateProjectMutationVariables
>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(
		CreateProjectDocument,
		options
	);
}
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
	CreateProjectMutation,
	CreateProjectMutationVariables
>;
export const CreateProjectProductDocument = gql`
	mutation CreateProjectProduct($input: CreateProjectProductInput!) {
		createProjectProduct(input: $input) {
			success
			message
			errors {
				field
				message
			}
		}
	}
`;
export type CreateProjectProductMutationFn = Apollo.MutationFunction<
	CreateProjectProductMutation,
	CreateProjectProductMutationVariables
>;

/**
 * __useCreateProjectProductMutation__
 *
 * To run a mutation, you first call `useCreateProjectProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectProductMutation, { data, loading, error }] = useCreateProjectProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectProductMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProjectProductMutation,
		CreateProjectProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateProjectProductMutation, CreateProjectProductMutationVariables>(
		CreateProjectProductDocument,
		options
	);
}
export type CreateProjectProductMutationHookResult = ReturnType<
	typeof useCreateProjectProductMutation
>;
export type CreateProjectProductMutationResult =
	Apollo.MutationResult<CreateProjectProductMutation>;
export type CreateProjectProductMutationOptions = Apollo.BaseMutationOptions<
	CreateProjectProductMutation,
	CreateProjectProductMutationVariables
>;
export const CreateBulkProjectProductsDocument = gql`
	mutation CreateBulkProjectProducts($input: CreateBulkProjectProductsInput!) {
		createBulkProjectProducts(input: $input) {
			success
			message
			errors {
				field
				message
			}
		}
	}
`;
export type CreateBulkProjectProductsMutationFn = Apollo.MutationFunction<
	CreateBulkProjectProductsMutation,
	CreateBulkProjectProductsMutationVariables
>;

/**
 * __useCreateBulkProjectProductsMutation__
 *
 * To run a mutation, you first call `useCreateBulkProjectProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkProjectProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkProjectProductsMutation, { data, loading, error }] = useCreateBulkProjectProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkProjectProductsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateBulkProjectProductsMutation,
		CreateBulkProjectProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateBulkProjectProductsMutation,
		CreateBulkProjectProductsMutationVariables
	>(CreateBulkProjectProductsDocument, options);
}
export type CreateBulkProjectProductsMutationHookResult = ReturnType<
	typeof useCreateBulkProjectProductsMutation
>;
export type CreateBulkProjectProductsMutationResult =
	Apollo.MutationResult<CreateBulkProjectProductsMutation>;
export type CreateBulkProjectProductsMutationOptions = Apollo.BaseMutationOptions<
	CreateBulkProjectProductsMutation,
	CreateBulkProjectProductsMutationVariables
>;
export const DeleteManyProjectsDocument = gql`
	mutation DeleteManyProjects($input: DeleteManyInput!) {
		deleteManyProject(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyProjectsMutationFn = Apollo.MutationFunction<
	DeleteManyProjectsMutation,
	DeleteManyProjectsMutationVariables
>;

/**
 * __useDeleteManyProjectsMutation__
 *
 * To run a mutation, you first call `useDeleteManyProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyProjectsMutation, { data, loading, error }] = useDeleteManyProjectsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyProjectsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyProjectsMutation,
		DeleteManyProjectsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyProjectsMutation, DeleteManyProjectsMutationVariables>(
		DeleteManyProjectsDocument,
		options
	);
}
export type DeleteManyProjectsMutationHookResult = ReturnType<typeof useDeleteManyProjectsMutation>;
export type DeleteManyProjectsMutationResult = Apollo.MutationResult<DeleteManyProjectsMutation>;
export type DeleteManyProjectsMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyProjectsMutation,
	DeleteManyProjectsMutationVariables
>;
export const DeleteProjectDocument = gql`
	mutation DeleteProject($input: DeleteInput!) {
		deleteProject(input: $input) {
			success
			message
		}
	}
`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<
	DeleteProjectMutation,
	DeleteProjectMutationVariables
>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(
		DeleteProjectDocument,
		options
	);
}
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
	DeleteProjectMutation,
	DeleteProjectMutationVariables
>;
export const DeleteProjectProductDocument = gql`
	mutation DeleteProjectProduct($input: DeleteInput!) {
		deleteProjectProduct(input: $input) {
			success
			message
		}
	}
`;
export type DeleteProjectProductMutationFn = Apollo.MutationFunction<
	DeleteProjectProductMutation,
	DeleteProjectProductMutationVariables
>;

/**
 * __useDeleteProjectProductMutation__
 *
 * To run a mutation, you first call `useDeleteProjectProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectProductMutation, { data, loading, error }] = useDeleteProjectProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectProductMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProjectProductMutation,
		DeleteProjectProductMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProjectProductMutation, DeleteProjectProductMutationVariables>(
		DeleteProjectProductDocument,
		options
	);
}
export type DeleteProjectProductMutationHookResult = ReturnType<
	typeof useDeleteProjectProductMutation
>;
export type DeleteProjectProductMutationResult =
	Apollo.MutationResult<DeleteProjectProductMutation>;
export type DeleteProjectProductMutationOptions = Apollo.BaseMutationOptions<
	DeleteProjectProductMutation,
	DeleteProjectProductMutationVariables
>;
export const RequestEarlyAccessDocument = gql`
	mutation RequestEarlyAccess($input: RequestEarlyAccessInput!) {
		requestEarlyAccess(input: $input) {
			success
			message
		}
	}
`;
export type RequestEarlyAccessMutationFn = Apollo.MutationFunction<
	RequestEarlyAccessMutation,
	RequestEarlyAccessMutationVariables
>;

/**
 * __useRequestEarlyAccessMutation__
 *
 * To run a mutation, you first call `useRequestEarlyAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEarlyAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEarlyAccessMutation, { data, loading, error }] = useRequestEarlyAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEarlyAccessMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestEarlyAccessMutation,
		RequestEarlyAccessMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RequestEarlyAccessMutation, RequestEarlyAccessMutationVariables>(
		RequestEarlyAccessDocument,
		options
	);
}
export type RequestEarlyAccessMutationHookResult = ReturnType<typeof useRequestEarlyAccessMutation>;
export type RequestEarlyAccessMutationResult = Apollo.MutationResult<RequestEarlyAccessMutation>;
export type RequestEarlyAccessMutationOptions = Apollo.BaseMutationOptions<
	RequestEarlyAccessMutation,
	RequestEarlyAccessMutationVariables
>;
export const ApproveEarlyAccessRequestDocument = gql`
	mutation ApproveEarlyAccessRequest($requestId: ID!) {
		approveEarlyAccessRequest(requestId: $requestId) {
			inviteToken
			message
		}
	}
`;
export type ApproveEarlyAccessRequestMutationFn = Apollo.MutationFunction<
	ApproveEarlyAccessRequestMutation,
	ApproveEarlyAccessRequestMutationVariables
>;

/**
 * __useApproveEarlyAccessRequestMutation__
 *
 * To run a mutation, you first call `useApproveEarlyAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveEarlyAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveEarlyAccessRequestMutation, { data, loading, error }] = useApproveEarlyAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useApproveEarlyAccessRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveEarlyAccessRequestMutation,
		ApproveEarlyAccessRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveEarlyAccessRequestMutation,
		ApproveEarlyAccessRequestMutationVariables
	>(ApproveEarlyAccessRequestDocument, options);
}
export type ApproveEarlyAccessRequestMutationHookResult = ReturnType<
	typeof useApproveEarlyAccessRequestMutation
>;
export type ApproveEarlyAccessRequestMutationResult =
	Apollo.MutationResult<ApproveEarlyAccessRequestMutation>;
export type ApproveEarlyAccessRequestMutationOptions = Apollo.BaseMutationOptions<
	ApproveEarlyAccessRequestMutation,
	ApproveEarlyAccessRequestMutationVariables
>;
export const RejectEarlyAccessRequestDocument = gql`
	mutation RejectEarlyAccessRequest($requestId: ID!) {
		rejectEarlyAccessRequest(requestId: $requestId) {
			success
			message
		}
	}
`;
export type RejectEarlyAccessRequestMutationFn = Apollo.MutationFunction<
	RejectEarlyAccessRequestMutation,
	RejectEarlyAccessRequestMutationVariables
>;

/**
 * __useRejectEarlyAccessRequestMutation__
 *
 * To run a mutation, you first call `useRejectEarlyAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectEarlyAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectEarlyAccessRequestMutation, { data, loading, error }] = useRejectEarlyAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRejectEarlyAccessRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectEarlyAccessRequestMutation,
		RejectEarlyAccessRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectEarlyAccessRequestMutation,
		RejectEarlyAccessRequestMutationVariables
	>(RejectEarlyAccessRequestDocument, options);
}
export type RejectEarlyAccessRequestMutationHookResult = ReturnType<
	typeof useRejectEarlyAccessRequestMutation
>;
export type RejectEarlyAccessRequestMutationResult =
	Apollo.MutationResult<RejectEarlyAccessRequestMutation>;
export type RejectEarlyAccessRequestMutationOptions = Apollo.BaseMutationOptions<
	RejectEarlyAccessRequestMutation,
	RejectEarlyAccessRequestMutationVariables
>;
export const GenerateProjectProductImageUploadUrlsDocument = gql`
	mutation GenerateProjectProductImageUploadUrls(
		$input: GenerateProjectProductImageUploadUrlsInput!
	) {
		generateProjectProductImageUploadUrls(input: $input) {
			urls {
				imageId
				fileName
				uploadUrl
				blobUrl
				expiresAt
			}
		}
	}
`;
export type GenerateProjectProductImageUploadUrlsMutationFn = Apollo.MutationFunction<
	GenerateProjectProductImageUploadUrlsMutation,
	GenerateProjectProductImageUploadUrlsMutationVariables
>;

/**
 * __useGenerateProjectProductImageUploadUrlsMutation__
 *
 * To run a mutation, you first call `useGenerateProjectProductImageUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectProductImageUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectProductImageUploadUrlsMutation, { data, loading, error }] = useGenerateProjectProductImageUploadUrlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProjectProductImageUploadUrlsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateProjectProductImageUploadUrlsMutation,
		GenerateProjectProductImageUploadUrlsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateProjectProductImageUploadUrlsMutation,
		GenerateProjectProductImageUploadUrlsMutationVariables
	>(GenerateProjectProductImageUploadUrlsDocument, options);
}
export type GenerateProjectProductImageUploadUrlsMutationHookResult = ReturnType<
	typeof useGenerateProjectProductImageUploadUrlsMutation
>;
export type GenerateProjectProductImageUploadUrlsMutationResult =
	Apollo.MutationResult<GenerateProjectProductImageUploadUrlsMutation>;
export type GenerateProjectProductImageUploadUrlsMutationOptions = Apollo.BaseMutationOptions<
	GenerateProjectProductImageUploadUrlsMutation,
	GenerateProjectProductImageUploadUrlsMutationVariables
>;
export const CreateManufacturerDocument = gql`
	mutation CreateManufacturer($input: ManufacturerCreateInput!) {
		createManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type CreateManufacturerMutationFn = Apollo.MutationFunction<
	CreateManufacturerMutation,
	CreateManufacturerMutationVariables
>;

/**
 * __useCreateManufacturerMutation__
 *
 * To run a mutation, you first call `useCreateManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManufacturerMutation, { data, loading, error }] = useCreateManufacturerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManufacturerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateManufacturerMutation,
		CreateManufacturerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateManufacturerMutation, CreateManufacturerMutationVariables>(
		CreateManufacturerDocument,
		options
	);
}
export type CreateManufacturerMutationHookResult = ReturnType<typeof useCreateManufacturerMutation>;
export type CreateManufacturerMutationResult = Apollo.MutationResult<CreateManufacturerMutation>;
export type CreateManufacturerMutationOptions = Apollo.BaseMutationOptions<
	CreateManufacturerMutation,
	CreateManufacturerMutationVariables
>;
export const UpdateManufacturerDocument = gql`
	mutation UpdateManufacturer($input: ManufacturerUpdateInput!) {
		updateManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type UpdateManufacturerMutationFn = Apollo.MutationFunction<
	UpdateManufacturerMutation,
	UpdateManufacturerMutationVariables
>;

/**
 * __useUpdateManufacturerMutation__
 *
 * To run a mutation, you first call `useUpdateManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManufacturerMutation, { data, loading, error }] = useUpdateManufacturerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManufacturerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateManufacturerMutation,
		UpdateManufacturerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateManufacturerMutation, UpdateManufacturerMutationVariables>(
		UpdateManufacturerDocument,
		options
	);
}
export type UpdateManufacturerMutationHookResult = ReturnType<typeof useUpdateManufacturerMutation>;
export type UpdateManufacturerMutationResult = Apollo.MutationResult<UpdateManufacturerMutation>;
export type UpdateManufacturerMutationOptions = Apollo.BaseMutationOptions<
	UpdateManufacturerMutation,
	UpdateManufacturerMutationVariables
>;
export const DeleteManufacturerDocument = gql`
	mutation DeleteManufacturer($input: DeleteInput!) {
		deleteManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManufacturerMutationFn = Apollo.MutationFunction<
	DeleteManufacturerMutation,
	DeleteManufacturerMutationVariables
>;

/**
 * __useDeleteManufacturerMutation__
 *
 * To run a mutation, you first call `useDeleteManufacturerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManufacturerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManufacturerMutation, { data, loading, error }] = useDeleteManufacturerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManufacturerMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManufacturerMutation,
		DeleteManufacturerMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManufacturerMutation, DeleteManufacturerMutationVariables>(
		DeleteManufacturerDocument,
		options
	);
}
export type DeleteManufacturerMutationHookResult = ReturnType<typeof useDeleteManufacturerMutation>;
export type DeleteManufacturerMutationResult = Apollo.MutationResult<DeleteManufacturerMutation>;
export type DeleteManufacturerMutationOptions = Apollo.BaseMutationOptions<
	DeleteManufacturerMutation,
	DeleteManufacturerMutationVariables
>;
export const DeleteManyManufacturersDocument = gql`
	mutation DeleteManyManufacturers($input: DeleteManyInput!) {
		deleteManyManufacturer(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyManufacturersMutationFn = Apollo.MutationFunction<
	DeleteManyManufacturersMutation,
	DeleteManyManufacturersMutationVariables
>;

/**
 * __useDeleteManyManufacturersMutation__
 *
 * To run a mutation, you first call `useDeleteManyManufacturersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyManufacturersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyManufacturersMutation, { data, loading, error }] = useDeleteManyManufacturersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyManufacturersMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyManufacturersMutation,
		DeleteManyManufacturersMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyManufacturersMutation,
		DeleteManyManufacturersMutationVariables
	>(DeleteManyManufacturersDocument, options);
}
export type DeleteManyManufacturersMutationHookResult = ReturnType<
	typeof useDeleteManyManufacturersMutation
>;
export type DeleteManyManufacturersMutationResult =
	Apollo.MutationResult<DeleteManyManufacturersMutation>;
export type DeleteManyManufacturersMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyManufacturersMutation,
	DeleteManyManufacturersMutationVariables
>;
export const CreateOrganizationDocument = gql`
	mutation CreateOrganization($input: OrganizationCreateInput!) {
		createOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
	CreateOrganizationMutation,
	CreateOrganizationMutationVariables
>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationMutation,
		CreateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(
		CreateOrganizationDocument,
		options
	);
}
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationMutation,
	CreateOrganizationMutationVariables
>;
export const CreateOrganizationUserDocument = gql`
	mutation CreateOrganizationUser($input: OrganizationUserCreateInput!) {
		createOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrganizationUserMutationFn = Apollo.MutationFunction<
	CreateOrganizationUserMutation,
	CreateOrganizationUserMutationVariables
>;

/**
 * __useCreateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationUserMutation, { data, loading, error }] = useCreateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationUserMutation,
		CreateOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationUserMutation,
		CreateOrganizationUserMutationVariables
	>(CreateOrganizationUserDocument, options);
}
export type CreateOrganizationUserMutationHookResult = ReturnType<
	typeof useCreateOrganizationUserMutation
>;
export type CreateOrganizationUserMutationResult =
	Apollo.MutationResult<CreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationUserMutation,
	CreateOrganizationUserMutationVariables
>;
export const DeleteOrganizationUserDocument = gql`
	mutation DeleteOrganizationUser($input: DeleteInput!) {
		deleteOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<
	DeleteOrganizationUserMutation,
	DeleteOrganizationUserMutationVariables
>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationUserMutation,
		DeleteOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationUserMutation,
		DeleteOrganizationUserMutationVariables
	>(DeleteOrganizationUserDocument, options);
}
export type DeleteOrganizationUserMutationHookResult = ReturnType<
	typeof useDeleteOrganizationUserMutation
>;
export type DeleteOrganizationUserMutationResult =
	Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationUserMutation,
	DeleteOrganizationUserMutationVariables
>;
export const DeleteManyOrganizationUserDocument = gql`
	mutation DeleteManyOrganizationUser($input: DeleteManyInput!) {
		deleteManyOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyOrganizationUserMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationUserMutation,
	DeleteManyOrganizationUserMutationVariables
>;

/**
 * __useDeleteManyOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationUserMutation, { data, loading, error }] = useDeleteManyOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationUserMutation,
		DeleteManyOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationUserMutation,
		DeleteManyOrganizationUserMutationVariables
	>(DeleteManyOrganizationUserDocument, options);
}
export type DeleteManyOrganizationUserMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationUserMutation
>;
export type DeleteManyOrganizationUserMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationUserMutation>;
export type DeleteManyOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationUserMutation,
	DeleteManyOrganizationUserMutationVariables
>;
export const UpdateOrganizationSettingDocument = gql`
	mutation UpdateOrganizationSetting($input: OrganizationSettingUpdateInput!) {
		updateOrganizationSetting(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationSettingMutationFn = Apollo.MutationFunction<
	UpdateOrganizationSettingMutation,
	UpdateOrganizationSettingMutationVariables
>;

/**
 * __useUpdateOrganizationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingMutation, { data, loading, error }] = useUpdateOrganizationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSettingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationSettingMutation,
		UpdateOrganizationSettingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationSettingMutation,
		UpdateOrganizationSettingMutationVariables
	>(UpdateOrganizationSettingDocument, options);
}
export type UpdateOrganizationSettingMutationHookResult = ReturnType<
	typeof useUpdateOrganizationSettingMutation
>;
export type UpdateOrganizationSettingMutationResult =
	Apollo.MutationResult<UpdateOrganizationSettingMutation>;
export type UpdateOrganizationSettingMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationSettingMutation,
	UpdateOrganizationSettingMutationVariables
>;
export const UpdateOrganizationDocument = gql`
	mutation UpdateOrganization($input: OrganizationUpdateInput!) {
		updateOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<
	UpdateOrganizationMutation,
	UpdateOrganizationMutationVariables
>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationMutation,
		UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(
		UpdateOrganizationDocument,
		options
	);
}
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationMutation,
	UpdateOrganizationMutationVariables
>;
export const DeleteMyOrganizationDocument = gql`
	mutation DeleteMyOrganization {
		deleteMyOrganization {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteMyOrganizationMutationFn = Apollo.MutationFunction<
	DeleteMyOrganizationMutation,
	DeleteMyOrganizationMutationVariables
>;

/**
 * __useDeleteMyOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteMyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyOrganizationMutation, { data, loading, error }] = useDeleteMyOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteMyOrganizationMutation,
		DeleteMyOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteMyOrganizationMutation, DeleteMyOrganizationMutationVariables>(
		DeleteMyOrganizationDocument,
		options
	);
}
export type DeleteMyOrganizationMutationHookResult = ReturnType<
	typeof useDeleteMyOrganizationMutation
>;
export type DeleteMyOrganizationMutationResult =
	Apollo.MutationResult<DeleteMyOrganizationMutation>;
export type DeleteMyOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteMyOrganizationMutation,
	DeleteMyOrganizationMutationVariables
>;
export const DeleteOrganizationDocument = gql`
	mutation DeleteOrganization($input: DeleteInput!) {
		deleteOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<
	DeleteOrganizationMutation,
	DeleteOrganizationMutationVariables
>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationMutation,
		DeleteOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(
		DeleteOrganizationDocument,
		options
	);
}
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationMutation,
	DeleteOrganizationMutationVariables
>;
export const DeleteManyOrganizationDocument = gql`
	mutation DeleteManyOrganization($input: DeleteManyInput!) {
		deleteManyOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyOrganizationMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationMutation,
	DeleteManyOrganizationMutationVariables
>;

/**
 * __useDeleteManyOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationMutation, { data, loading, error }] = useDeleteManyOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationMutation,
		DeleteManyOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationMutation,
		DeleteManyOrganizationMutationVariables
	>(DeleteManyOrganizationDocument, options);
}
export type DeleteManyOrganizationMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationMutation
>;
export type DeleteManyOrganizationMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationMutation>;
export type DeleteManyOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationMutation,
	DeleteManyOrganizationMutationVariables
>;
export const UpdateOrganizationStripeCheckoutLimitDocument = gql`
	mutation UpdateOrganizationStripeCheckoutLimit(
		$input: UpdateOrganizationStripeCheckoutLimitInput!
	) {
		updateOrganizationStripeCheckoutLimit(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationStripeCheckoutLimitMutationFn = Apollo.MutationFunction<
	UpdateOrganizationStripeCheckoutLimitMutation,
	UpdateOrganizationStripeCheckoutLimitMutationVariables
>;

/**
 * __useUpdateOrganizationStripeCheckoutLimitMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationStripeCheckoutLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationStripeCheckoutLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationStripeCheckoutLimitMutation, { data, loading, error }] = useUpdateOrganizationStripeCheckoutLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationStripeCheckoutLimitMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationStripeCheckoutLimitMutation,
		UpdateOrganizationStripeCheckoutLimitMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationStripeCheckoutLimitMutation,
		UpdateOrganizationStripeCheckoutLimitMutationVariables
	>(UpdateOrganizationStripeCheckoutLimitDocument, options);
}
export type UpdateOrganizationStripeCheckoutLimitMutationHookResult = ReturnType<
	typeof useUpdateOrganizationStripeCheckoutLimitMutation
>;
export type UpdateOrganizationStripeCheckoutLimitMutationResult =
	Apollo.MutationResult<UpdateOrganizationStripeCheckoutLimitMutation>;
export type UpdateOrganizationStripeCheckoutLimitMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationStripeCheckoutLimitMutation,
	UpdateOrganizationStripeCheckoutLimitMutationVariables
>;
export const UpdateOrganizationInvoiceMinimumDocument = gql`
	mutation UpdateOrganizationInvoiceMinimum($input: UpdateOrganizationInvoiceMinimumInput!) {
		updateOrganizationInvoiceMinimum(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationInvoiceMinimumMutationFn = Apollo.MutationFunction<
	UpdateOrganizationInvoiceMinimumMutation,
	UpdateOrganizationInvoiceMinimumMutationVariables
>;

/**
 * __useUpdateOrganizationInvoiceMinimumMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInvoiceMinimumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInvoiceMinimumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInvoiceMinimumMutation, { data, loading, error }] = useUpdateOrganizationInvoiceMinimumMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationInvoiceMinimumMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationInvoiceMinimumMutation,
		UpdateOrganizationInvoiceMinimumMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationInvoiceMinimumMutation,
		UpdateOrganizationInvoiceMinimumMutationVariables
	>(UpdateOrganizationInvoiceMinimumDocument, options);
}
export type UpdateOrganizationInvoiceMinimumMutationHookResult = ReturnType<
	typeof useUpdateOrganizationInvoiceMinimumMutation
>;
export type UpdateOrganizationInvoiceMinimumMutationResult =
	Apollo.MutationResult<UpdateOrganizationInvoiceMinimumMutation>;
export type UpdateOrganizationInvoiceMinimumMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationInvoiceMinimumMutation,
	UpdateOrganizationInvoiceMinimumMutationVariables
>;
export const UpdateOrganizationPaymentModeDocument = gql`
	mutation UpdateOrganizationPaymentMode($input: UpdateOrganizationPaymentModeInput!) {
		updateOrganizationPaymentMode(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationPaymentModeMutationFn = Apollo.MutationFunction<
	UpdateOrganizationPaymentModeMutation,
	UpdateOrganizationPaymentModeMutationVariables
>;

/**
 * __useUpdateOrganizationPaymentModeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPaymentModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPaymentModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPaymentModeMutation, { data, loading, error }] = useUpdateOrganizationPaymentModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationPaymentModeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationPaymentModeMutation,
		UpdateOrganizationPaymentModeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationPaymentModeMutation,
		UpdateOrganizationPaymentModeMutationVariables
	>(UpdateOrganizationPaymentModeDocument, options);
}
export type UpdateOrganizationPaymentModeMutationHookResult = ReturnType<
	typeof useUpdateOrganizationPaymentModeMutation
>;
export type UpdateOrganizationPaymentModeMutationResult =
	Apollo.MutationResult<UpdateOrganizationPaymentModeMutation>;
export type UpdateOrganizationPaymentModeMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationPaymentModeMutation,
	UpdateOrganizationPaymentModeMutationVariables
>;
export const UpdateOrganizationApprovalAndMarginDocument = gql`
	mutation UpdateOrganizationApprovalAndMargin(
		$input: UpdateOrganizationApprovalAndMarginInput!
	) {
		updateOrganizationApprovalAndMargin(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationApprovalAndMarginMutationFn = Apollo.MutationFunction<
	UpdateOrganizationApprovalAndMarginMutation,
	UpdateOrganizationApprovalAndMarginMutationVariables
>;

/**
 * __useUpdateOrganizationApprovalAndMarginMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationApprovalAndMarginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationApprovalAndMarginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationApprovalAndMarginMutation, { data, loading, error }] = useUpdateOrganizationApprovalAndMarginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationApprovalAndMarginMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationApprovalAndMarginMutation,
		UpdateOrganizationApprovalAndMarginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationApprovalAndMarginMutation,
		UpdateOrganizationApprovalAndMarginMutationVariables
	>(UpdateOrganizationApprovalAndMarginDocument, options);
}
export type UpdateOrganizationApprovalAndMarginMutationHookResult = ReturnType<
	typeof useUpdateOrganizationApprovalAndMarginMutation
>;
export type UpdateOrganizationApprovalAndMarginMutationResult =
	Apollo.MutationResult<UpdateOrganizationApprovalAndMarginMutation>;
export type UpdateOrganizationApprovalAndMarginMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationApprovalAndMarginMutation,
	UpdateOrganizationApprovalAndMarginMutationVariables
>;
export const CreateOrganizationAddressDocument = gql`
	mutation CreateOrganizationAddress($organizationId: ID!, $input: OrganizationAddressInput!) {
		createOrganizationAddress(organizationId: $organizationId, input: $input) {
			id
			addressLine1
			addressLine2
			addressType
			city
			countryCode
			postalCode
			stateCode
			isPrimary
			name
			googlePlaceId
			latitude
			longitude
		}
	}
`;
export type CreateOrganizationAddressMutationFn = Apollo.MutationFunction<
	CreateOrganizationAddressMutation,
	CreateOrganizationAddressMutationVariables
>;

/**
 * __useCreateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAddressMutation, { data, loading, error }] = useCreateOrganizationAddressMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationAddressMutation,
		CreateOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationAddressMutation,
		CreateOrganizationAddressMutationVariables
	>(CreateOrganizationAddressDocument, options);
}
export type CreateOrganizationAddressMutationHookResult = ReturnType<
	typeof useCreateOrganizationAddressMutation
>;
export type CreateOrganizationAddressMutationResult =
	Apollo.MutationResult<CreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationAddressMutation,
	CreateOrganizationAddressMutationVariables
>;
export const UpdateOrganizationAddressDocument = gql`
	mutation UpdateOrganizationAddress($id: ID!, $input: OrganizationAddressInput!) {
		updateOrganizationAddress(id: $id, input: $input) {
			id
			addressLine1
			addressLine2
			addressType
			city
			countryCode
			postalCode
			stateCode
			isPrimary
			name
			googlePlaceId
			latitude
			longitude
		}
	}
`;
export type UpdateOrganizationAddressMutationFn = Apollo.MutationFunction<
	UpdateOrganizationAddressMutation,
	UpdateOrganizationAddressMutationVariables
>;

/**
 * __useUpdateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressMutation, { data, loading, error }] = useUpdateOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationAddressMutation,
		UpdateOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationAddressMutation,
		UpdateOrganizationAddressMutationVariables
	>(UpdateOrganizationAddressDocument, options);
}
export type UpdateOrganizationAddressMutationHookResult = ReturnType<
	typeof useUpdateOrganizationAddressMutation
>;
export type UpdateOrganizationAddressMutationResult =
	Apollo.MutationResult<UpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationAddressMutation,
	UpdateOrganizationAddressMutationVariables
>;
export const DeleteOrganizationAddressDocument = gql`
	mutation DeleteOrganizationAddress($id: ID!) {
		deleteOrganizationAddress(id: $id) {
			success
			message
		}
	}
`;
export type DeleteOrganizationAddressMutationFn = Apollo.MutationFunction<
	DeleteOrganizationAddressMutation,
	DeleteOrganizationAddressMutationVariables
>;

/**
 * __useDeleteOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAddressMutation, { data, loading, error }] = useDeleteOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationAddressMutation,
		DeleteOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationAddressMutation,
		DeleteOrganizationAddressMutationVariables
	>(DeleteOrganizationAddressDocument, options);
}
export type DeleteOrganizationAddressMutationHookResult = ReturnType<
	typeof useDeleteOrganizationAddressMutation
>;
export type DeleteOrganizationAddressMutationResult =
	Apollo.MutationResult<DeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationAddressMutation,
	DeleteOrganizationAddressMutationVariables
>;
export const CreateOrganizationIndustryDocument = gql`
	mutation CreateOrganizationIndustry($input: CreateOrganizationIndustryInput!) {
		createOrganizationIndustry(input: $input) {
			id
			name
			isPublished
			createdByOrganizationId
		}
	}
`;
export type CreateOrganizationIndustryMutationFn = Apollo.MutationFunction<
	CreateOrganizationIndustryMutation,
	CreateOrganizationIndustryMutationVariables
>;

/**
 * __useCreateOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationIndustryMutation, { data, loading, error }] = useCreateOrganizationIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationIndustryMutation,
		CreateOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationIndustryMutation,
		CreateOrganizationIndustryMutationVariables
	>(CreateOrganizationIndustryDocument, options);
}
export type CreateOrganizationIndustryMutationHookResult = ReturnType<
	typeof useCreateOrganizationIndustryMutation
>;
export type CreateOrganizationIndustryMutationResult =
	Apollo.MutationResult<CreateOrganizationIndustryMutation>;
export type CreateOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationIndustryMutation,
	CreateOrganizationIndustryMutationVariables
>;
export const PublishOrganizationIndustryDocument = gql`
	mutation PublishOrganizationIndustry($id: ID!) {
		publishOrganizationIndustry(id: $id) {
			id
			name
			isPublished
		}
	}
`;
export type PublishOrganizationIndustryMutationFn = Apollo.MutationFunction<
	PublishOrganizationIndustryMutation,
	PublishOrganizationIndustryMutationVariables
>;

/**
 * __usePublishOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `usePublishOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOrganizationIndustryMutation, { data, loading, error }] = usePublishOrganizationIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PublishOrganizationIndustryMutation,
		PublishOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PublishOrganizationIndustryMutation,
		PublishOrganizationIndustryMutationVariables
	>(PublishOrganizationIndustryDocument, options);
}
export type PublishOrganizationIndustryMutationHookResult = ReturnType<
	typeof usePublishOrganizationIndustryMutation
>;
export type PublishOrganizationIndustryMutationResult =
	Apollo.MutationResult<PublishOrganizationIndustryMutation>;
export type PublishOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	PublishOrganizationIndustryMutation,
	PublishOrganizationIndustryMutationVariables
>;
export const UpdateOrganizationIndustryDocument = gql`
	mutation UpdateOrganizationIndustry($input: UpdateOrganizationIndustryInput!) {
		updateOrganizationIndustry(input: $input) {
			id
			name
			isPublished
		}
	}
`;
export type UpdateOrganizationIndustryMutationFn = Apollo.MutationFunction<
	UpdateOrganizationIndustryMutation,
	UpdateOrganizationIndustryMutationVariables
>;

/**
 * __useUpdateOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationIndustryMutation, { data, loading, error }] = useUpdateOrganizationIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationIndustryMutation,
		UpdateOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationIndustryMutation,
		UpdateOrganizationIndustryMutationVariables
	>(UpdateOrganizationIndustryDocument, options);
}
export type UpdateOrganizationIndustryMutationHookResult = ReturnType<
	typeof useUpdateOrganizationIndustryMutation
>;
export type UpdateOrganizationIndustryMutationResult =
	Apollo.MutationResult<UpdateOrganizationIndustryMutation>;
export type UpdateOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationIndustryMutation,
	UpdateOrganizationIndustryMutationVariables
>;
export const DeleteOrganizationIndustryDocument = gql`
	mutation DeleteOrganizationIndustry($input: DeleteOrganizationIndustryInput!) {
		deleteOrganizationIndustry(input: $input) {
			success
			message
		}
	}
`;
export type DeleteOrganizationIndustryMutationFn = Apollo.MutationFunction<
	DeleteOrganizationIndustryMutation,
	DeleteOrganizationIndustryMutationVariables
>;

/**
 * __useDeleteOrganizationIndustryMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationIndustryMutation, { data, loading, error }] = useDeleteOrganizationIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationIndustryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationIndustryMutation,
		DeleteOrganizationIndustryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationIndustryMutation,
		DeleteOrganizationIndustryMutationVariables
	>(DeleteOrganizationIndustryDocument, options);
}
export type DeleteOrganizationIndustryMutationHookResult = ReturnType<
	typeof useDeleteOrganizationIndustryMutation
>;
export type DeleteOrganizationIndustryMutationResult =
	Apollo.MutationResult<DeleteOrganizationIndustryMutation>;
export type DeleteOrganizationIndustryMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationIndustryMutation,
	DeleteOrganizationIndustryMutationVariables
>;
export const CreateOrganizationOnboardingDocument = gql`
	mutation CreateOrganizationOnboarding($input: OrganizationOnboardingInput!) {
		createOrganizationOnboarding(input: $input) {
			success
			message
			organizationId
			productInterests {
				id
				productTagId
			}
			sourcingPreferenceConnections {
				id
				organizationSourcingPreferenceId
				organizationSourcingPreference {
					id
					name
				}
			}
			complianceConnections {
				id
				organizationComplianceId
				organizationCompliance {
					id
					name
				}
			}
		}
	}
`;
export type CreateOrganizationOnboardingMutationFn = Apollo.MutationFunction<
	CreateOrganizationOnboardingMutation,
	CreateOrganizationOnboardingMutationVariables
>;

/**
 * __useCreateOrganizationOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationOnboardingMutation, { data, loading, error }] = useCreateOrganizationOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationOnboardingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationOnboardingMutation,
		CreateOrganizationOnboardingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationOnboardingMutation,
		CreateOrganizationOnboardingMutationVariables
	>(CreateOrganizationOnboardingDocument, options);
}
export type CreateOrganizationOnboardingMutationHookResult = ReturnType<
	typeof useCreateOrganizationOnboardingMutation
>;
export type CreateOrganizationOnboardingMutationResult =
	Apollo.MutationResult<CreateOrganizationOnboardingMutation>;
export type CreateOrganizationOnboardingMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationOnboardingMutation,
	CreateOrganizationOnboardingMutationVariables
>;
export const GenerateOrganizationUserAvatarUploadUrlDocument = gql`
	mutation GenerateOrganizationUserAvatarUploadUrl($input: GenerateUploadUrlInput!) {
		generateOrganizationUserAvatarUploadUrl(input: $input) {
			success
			message
			uploadUrl
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;
export type GenerateOrganizationUserAvatarUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateOrganizationUserAvatarUploadUrlMutation,
	GenerateOrganizationUserAvatarUploadUrlMutationVariables
>;

/**
 * __useGenerateOrganizationUserAvatarUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationUserAvatarUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationUserAvatarUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationUserAvatarUploadUrlMutation, { data, loading, error }] = useGenerateOrganizationUserAvatarUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOrganizationUserAvatarUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateOrganizationUserAvatarUploadUrlMutation,
		GenerateOrganizationUserAvatarUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateOrganizationUserAvatarUploadUrlMutation,
		GenerateOrganizationUserAvatarUploadUrlMutationVariables
	>(GenerateOrganizationUserAvatarUploadUrlDocument, options);
}
export type GenerateOrganizationUserAvatarUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateOrganizationUserAvatarUploadUrlMutation
>;
export type GenerateOrganizationUserAvatarUploadUrlMutationResult =
	Apollo.MutationResult<GenerateOrganizationUserAvatarUploadUrlMutation>;
export type GenerateOrganizationUserAvatarUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateOrganizationUserAvatarUploadUrlMutation,
	GenerateOrganizationUserAvatarUploadUrlMutationVariables
>;
export const UpdateOrganizationUserAvatarDocument = gql`
	mutation UpdateOrganizationUserAvatar($input: OrganizationUserUpdateInput!) {
		updateOrganizationUser(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type UpdateOrganizationUserAvatarMutationFn = Apollo.MutationFunction<
	UpdateOrganizationUserAvatarMutation,
	UpdateOrganizationUserAvatarMutationVariables
>;

/**
 * __useUpdateOrganizationUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserAvatarMutation, { data, loading, error }] = useUpdateOrganizationUserAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserAvatarMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationUserAvatarMutation,
		UpdateOrganizationUserAvatarMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationUserAvatarMutation,
		UpdateOrganizationUserAvatarMutationVariables
	>(UpdateOrganizationUserAvatarDocument, options);
}
export type UpdateOrganizationUserAvatarMutationHookResult = ReturnType<
	typeof useUpdateOrganizationUserAvatarMutation
>;
export type UpdateOrganizationUserAvatarMutationResult =
	Apollo.MutationResult<UpdateOrganizationUserAvatarMutation>;
export type UpdateOrganizationUserAvatarMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationUserAvatarMutation,
	UpdateOrganizationUserAvatarMutationVariables
>;
export const CreateProductDocument = gql`
	mutation CreateProduct($input: ProductCreateInput!) {
		createProduct(input: $input) {
			success
			message
			referenceKey
		}
	}
`;
export type CreateProductMutationFn = Apollo.MutationFunction<
	CreateProductMutation,
	CreateProductMutationVariables
>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(
		CreateProductDocument,
		options
	);
}
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<
	CreateProductMutation,
	CreateProductMutationVariables
>;
export const UpdateProductDocument = gql`
	mutation UpdateProduct($input: ProductUpdateInput!) {
		updateProduct(input: $input) {
			success
			message
		}
	}
`;
export type UpdateProductMutationFn = Apollo.MutationFunction<
	UpdateProductMutation,
	UpdateProductMutationVariables
>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(
		UpdateProductDocument,
		options
	);
}
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductMutation,
	UpdateProductMutationVariables
>;
export const GenerateProductImageUploadUrlDocument = gql`
	mutation GenerateProductImageUploadUrl($input: ProductImageUploadInput!) {
		generateProductImageUploadUrl(input: $input) {
			success
			message
			uploadUrl
			imageId
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateProductImageUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateProductImageUploadUrlMutation,
	GenerateProductImageUploadUrlMutationVariables
>;

/**
 * __useGenerateProductImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateProductImageUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProductImageUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProductImageUploadUrlMutation, { data, loading, error }] = useGenerateProductImageUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProductImageUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateProductImageUploadUrlMutation,
		GenerateProductImageUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateProductImageUploadUrlMutation,
		GenerateProductImageUploadUrlMutationVariables
	>(GenerateProductImageUploadUrlDocument, options);
}
export type GenerateProductImageUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateProductImageUploadUrlMutation
>;
export type GenerateProductImageUploadUrlMutationResult =
	Apollo.MutationResult<GenerateProductImageUploadUrlMutation>;
export type GenerateProductImageUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateProductImageUploadUrlMutation,
	GenerateProductImageUploadUrlMutationVariables
>;
export const ConfirmProductImageUploadDocument = gql`
	mutation ConfirmProductImageUpload($input: ConfirmProductImageUploadInput!) {
		confirmProductImageUpload(input: $input) {
			success
			message
		}
	}
`;
export type ConfirmProductImageUploadMutationFn = Apollo.MutationFunction<
	ConfirmProductImageUploadMutation,
	ConfirmProductImageUploadMutationVariables
>;

/**
 * __useConfirmProductImageUploadMutation__
 *
 * To run a mutation, you first call `useConfirmProductImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProductImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProductImageUploadMutation, { data, loading, error }] = useConfirmProductImageUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmProductImageUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmProductImageUploadMutation,
		ConfirmProductImageUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmProductImageUploadMutation,
		ConfirmProductImageUploadMutationVariables
	>(ConfirmProductImageUploadDocument, options);
}
export type ConfirmProductImageUploadMutationHookResult = ReturnType<
	typeof useConfirmProductImageUploadMutation
>;
export type ConfirmProductImageUploadMutationResult =
	Apollo.MutationResult<ConfirmProductImageUploadMutation>;
export type ConfirmProductImageUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmProductImageUploadMutation,
	ConfirmProductImageUploadMutationVariables
>;
export const DeleteProductImageDocument = gql`
	mutation DeleteProductImage($productId: ID!, $imageId: ID!) {
		deleteProductImage(productId: $productId, imageId: $imageId) {
			success
			message
		}
	}
`;
export type DeleteProductImageMutationFn = Apollo.MutationFunction<
	DeleteProductImageMutation,
	DeleteProductImageMutationVariables
>;

/**
 * __useDeleteProductImageMutation__
 *
 * To run a mutation, you first call `useDeleteProductImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductImageMutation, { data, loading, error }] = useDeleteProductImageMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useDeleteProductImageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductImageMutation,
		DeleteProductImageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductImageMutation, DeleteProductImageMutationVariables>(
		DeleteProductImageDocument,
		options
	);
}
export type DeleteProductImageMutationHookResult = ReturnType<typeof useDeleteProductImageMutation>;
export type DeleteProductImageMutationResult = Apollo.MutationResult<DeleteProductImageMutation>;
export type DeleteProductImageMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductImageMutation,
	DeleteProductImageMutationVariables
>;
export const UpdateProductImagePrimaryDocument = gql`
	mutation UpdateProductImagePrimary($productId: ID!, $imageId: ID!) {
		updateProductImagePrimary(productId: $productId, imageId: $imageId) {
			success
			message
		}
	}
`;
export type UpdateProductImagePrimaryMutationFn = Apollo.MutationFunction<
	UpdateProductImagePrimaryMutation,
	UpdateProductImagePrimaryMutationVariables
>;

/**
 * __useUpdateProductImagePrimaryMutation__
 *
 * To run a mutation, you first call `useUpdateProductImagePrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductImagePrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductImagePrimaryMutation, { data, loading, error }] = useUpdateProductImagePrimaryMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useUpdateProductImagePrimaryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateProductImagePrimaryMutation,
		UpdateProductImagePrimaryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateProductImagePrimaryMutation,
		UpdateProductImagePrimaryMutationVariables
	>(UpdateProductImagePrimaryDocument, options);
}
export type UpdateProductImagePrimaryMutationHookResult = ReturnType<
	typeof useUpdateProductImagePrimaryMutation
>;
export type UpdateProductImagePrimaryMutationResult =
	Apollo.MutationResult<UpdateProductImagePrimaryMutation>;
export type UpdateProductImagePrimaryMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductImagePrimaryMutation,
	UpdateProductImagePrimaryMutationVariables
>;
export const DeleteProductDocument = gql`
	mutation DeleteProduct($input: DeleteInput!) {
		deleteProduct(input: $input) {
			success
			message
		}
	}
`;
export type DeleteProductMutationFn = Apollo.MutationFunction<
	DeleteProductMutation,
	DeleteProductMutationVariables
>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(
		DeleteProductDocument,
		options
	);
}
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductMutation,
	DeleteProductMutationVariables
>;
export const AssignProductToOrganizationDocument = gql`
	mutation AssignProductToOrganization($productId: ID!, $organizationId: ID) {
		assignProductToOrganization(productId: $productId, organizationId: $organizationId) {
			success
			message
		}
	}
`;
export type AssignProductToOrganizationMutationFn = Apollo.MutationFunction<
	AssignProductToOrganizationMutation,
	AssignProductToOrganizationMutationVariables
>;

/**
 * __useAssignProductToOrganizationMutation__
 *
 * To run a mutation, you first call `useAssignProductToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProductToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProductToOrganizationMutation, { data, loading, error }] = useAssignProductToOrganizationMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAssignProductToOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignProductToOrganizationMutation,
		AssignProductToOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignProductToOrganizationMutation,
		AssignProductToOrganizationMutationVariables
	>(AssignProductToOrganizationDocument, options);
}
export type AssignProductToOrganizationMutationHookResult = ReturnType<
	typeof useAssignProductToOrganizationMutation
>;
export type AssignProductToOrganizationMutationResult =
	Apollo.MutationResult<AssignProductToOrganizationMutation>;
export type AssignProductToOrganizationMutationOptions = Apollo.BaseMutationOptions<
	AssignProductToOrganizationMutation,
	AssignProductToOrganizationMutationVariables
>;
export const CompleteRecommendationDocument = gql`
	mutation CompleteRecommendation($input: CompleteRecommendationInput!) {
		completeRecommendation(input: $input) {
			success
			message
			productId
			studioFileId
		}
	}
`;
export type CompleteRecommendationMutationFn = Apollo.MutationFunction<
	CompleteRecommendationMutation,
	CompleteRecommendationMutationVariables
>;

/**
 * __useCompleteRecommendationMutation__
 *
 * To run a mutation, you first call `useCompleteRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRecommendationMutation, { data, loading, error }] = useCompleteRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRecommendationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompleteRecommendationMutation,
		CompleteRecommendationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompleteRecommendationMutation,
		CompleteRecommendationMutationVariables
	>(CompleteRecommendationDocument, options);
}
export type CompleteRecommendationMutationHookResult = ReturnType<
	typeof useCompleteRecommendationMutation
>;
export type CompleteRecommendationMutationResult =
	Apollo.MutationResult<CompleteRecommendationMutation>;
export type CompleteRecommendationMutationOptions = Apollo.BaseMutationOptions<
	CompleteRecommendationMutation,
	CompleteRecommendationMutationVariables
>;
export const GenerateBulkProductImageUploadUrlsDocument = gql`
	mutation GenerateBulkProductImageUploadUrls($input: GenerateBulkProductImageUploadUrlsInput!) {
		generateBulkProductImageUploadUrls(input: $input) {
			urls {
				imageId
				fileName
				uploadUrl
				blobUrl
				expiresAt
			}
		}
	}
`;
export type GenerateBulkProductImageUploadUrlsMutationFn = Apollo.MutationFunction<
	GenerateBulkProductImageUploadUrlsMutation,
	GenerateBulkProductImageUploadUrlsMutationVariables
>;

/**
 * __useGenerateBulkProductImageUploadUrlsMutation__
 *
 * To run a mutation, you first call `useGenerateBulkProductImageUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBulkProductImageUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBulkProductImageUploadUrlsMutation, { data, loading, error }] = useGenerateBulkProductImageUploadUrlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateBulkProductImageUploadUrlsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateBulkProductImageUploadUrlsMutation,
		GenerateBulkProductImageUploadUrlsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateBulkProductImageUploadUrlsMutation,
		GenerateBulkProductImageUploadUrlsMutationVariables
	>(GenerateBulkProductImageUploadUrlsDocument, options);
}
export type GenerateBulkProductImageUploadUrlsMutationHookResult = ReturnType<
	typeof useGenerateBulkProductImageUploadUrlsMutation
>;
export type GenerateBulkProductImageUploadUrlsMutationResult =
	Apollo.MutationResult<GenerateBulkProductImageUploadUrlsMutation>;
export type GenerateBulkProductImageUploadUrlsMutationOptions = Apollo.BaseMutationOptions<
	GenerateBulkProductImageUploadUrlsMutation,
	GenerateBulkProductImageUploadUrlsMutationVariables
>;
export const CreateBulkProductsDocument = gql`
	mutation CreateBulkProducts($input: CreateBulkProductsInput!) {
		createBulkProducts(input: $input) {
			success
			message
		}
	}
`;
export type CreateBulkProductsMutationFn = Apollo.MutationFunction<
	CreateBulkProductsMutation,
	CreateBulkProductsMutationVariables
>;

/**
 * __useCreateBulkProductsMutation__
 *
 * To run a mutation, you first call `useCreateBulkProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkProductsMutation, { data, loading, error }] = useCreateBulkProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkProductsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateBulkProductsMutation,
		CreateBulkProductsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateBulkProductsMutation, CreateBulkProductsMutationVariables>(
		CreateBulkProductsDocument,
		options
	);
}
export type CreateBulkProductsMutationHookResult = ReturnType<typeof useCreateBulkProductsMutation>;
export type CreateBulkProductsMutationResult = Apollo.MutationResult<CreateBulkProductsMutation>;
export type CreateBulkProductsMutationOptions = Apollo.BaseMutationOptions<
	CreateBulkProductsMutation,
	CreateBulkProductsMutationVariables
>;
export const CreateQuoteOfferBatchV2Document = gql`
	mutation CreateQuoteOfferBatchV2($input: CreateQuoteOfferBatchV2Input!) {
		createQuoteOfferBatchV2(input: $input) {
			success
			message
		}
	}
`;
export type CreateQuoteOfferBatchV2MutationFn = Apollo.MutationFunction<
	CreateQuoteOfferBatchV2Mutation,
	CreateQuoteOfferBatchV2MutationVariables
>;

/**
 * __useCreateQuoteOfferBatchV2Mutation__
 *
 * To run a mutation, you first call `useCreateQuoteOfferBatchV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteOfferBatchV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteOfferBatchV2Mutation, { data, loading, error }] = useCreateQuoteOfferBatchV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteOfferBatchV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateQuoteOfferBatchV2Mutation,
		CreateQuoteOfferBatchV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateQuoteOfferBatchV2Mutation,
		CreateQuoteOfferBatchV2MutationVariables
	>(CreateQuoteOfferBatchV2Document, options);
}
export type CreateQuoteOfferBatchV2MutationHookResult = ReturnType<
	typeof useCreateQuoteOfferBatchV2Mutation
>;
export type CreateQuoteOfferBatchV2MutationResult =
	Apollo.MutationResult<CreateQuoteOfferBatchV2Mutation>;
export type CreateQuoteOfferBatchV2MutationOptions = Apollo.BaseMutationOptions<
	CreateQuoteOfferBatchV2Mutation,
	CreateQuoteOfferBatchV2MutationVariables
>;
export const UpdateQuoteOfferBatchV2Document = gql`
	mutation UpdateQuoteOfferBatchV2($batchId: ID!, $input: UpdateQuoteOfferBatchV2Input!) {
		updateQuoteOfferBatchV2(batchId: $batchId, input: $input) {
			success
			message
		}
	}
`;
export type UpdateQuoteOfferBatchV2MutationFn = Apollo.MutationFunction<
	UpdateQuoteOfferBatchV2Mutation,
	UpdateQuoteOfferBatchV2MutationVariables
>;

/**
 * __useUpdateQuoteOfferBatchV2Mutation__
 *
 * To run a mutation, you first call `useUpdateQuoteOfferBatchV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteOfferBatchV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteOfferBatchV2Mutation, { data, loading, error }] = useUpdateQuoteOfferBatchV2Mutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteOfferBatchV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateQuoteOfferBatchV2Mutation,
		UpdateQuoteOfferBatchV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateQuoteOfferBatchV2Mutation,
		UpdateQuoteOfferBatchV2MutationVariables
	>(UpdateQuoteOfferBatchV2Document, options);
}
export type UpdateQuoteOfferBatchV2MutationHookResult = ReturnType<
	typeof useUpdateQuoteOfferBatchV2Mutation
>;
export type UpdateQuoteOfferBatchV2MutationResult =
	Apollo.MutationResult<UpdateQuoteOfferBatchV2Mutation>;
export type UpdateQuoteOfferBatchV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateQuoteOfferBatchV2Mutation,
	UpdateQuoteOfferBatchV2MutationVariables
>;
export const DuplicateQuoteOfferBatchV2Document = gql`
	mutation DuplicateQuoteOfferBatchV2($batchId: ID!) {
		duplicateQuoteOfferBatchV2(batchId: $batchId) {
			success
			message
			batchId
		}
	}
`;
export type DuplicateQuoteOfferBatchV2MutationFn = Apollo.MutationFunction<
	DuplicateQuoteOfferBatchV2Mutation,
	DuplicateQuoteOfferBatchV2MutationVariables
>;

/**
 * __useDuplicateQuoteOfferBatchV2Mutation__
 *
 * To run a mutation, you first call `useDuplicateQuoteOfferBatchV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateQuoteOfferBatchV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateQuoteOfferBatchV2Mutation, { data, loading, error }] = useDuplicateQuoteOfferBatchV2Mutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useDuplicateQuoteOfferBatchV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		DuplicateQuoteOfferBatchV2Mutation,
		DuplicateQuoteOfferBatchV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DuplicateQuoteOfferBatchV2Mutation,
		DuplicateQuoteOfferBatchV2MutationVariables
	>(DuplicateQuoteOfferBatchV2Document, options);
}
export type DuplicateQuoteOfferBatchV2MutationHookResult = ReturnType<
	typeof useDuplicateQuoteOfferBatchV2Mutation
>;
export type DuplicateQuoteOfferBatchV2MutationResult =
	Apollo.MutationResult<DuplicateQuoteOfferBatchV2Mutation>;
export type DuplicateQuoteOfferBatchV2MutationOptions = Apollo.BaseMutationOptions<
	DuplicateQuoteOfferBatchV2Mutation,
	DuplicateQuoteOfferBatchV2MutationVariables
>;
export const DeleteQuoteOfferBatchV2Document = gql`
	mutation DeleteQuoteOfferBatchV2($batchId: ID!) {
		deleteQuoteOfferBatchV2(batchId: $batchId) {
			success
			message
		}
	}
`;
export type DeleteQuoteOfferBatchV2MutationFn = Apollo.MutationFunction<
	DeleteQuoteOfferBatchV2Mutation,
	DeleteQuoteOfferBatchV2MutationVariables
>;

/**
 * __useDeleteQuoteOfferBatchV2Mutation__
 *
 * To run a mutation, you first call `useDeleteQuoteOfferBatchV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteOfferBatchV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteOfferBatchV2Mutation, { data, loading, error }] = useDeleteQuoteOfferBatchV2Mutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useDeleteQuoteOfferBatchV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteQuoteOfferBatchV2Mutation,
		DeleteQuoteOfferBatchV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteQuoteOfferBatchV2Mutation,
		DeleteQuoteOfferBatchV2MutationVariables
	>(DeleteQuoteOfferBatchV2Document, options);
}
export type DeleteQuoteOfferBatchV2MutationHookResult = ReturnType<
	typeof useDeleteQuoteOfferBatchV2Mutation
>;
export type DeleteQuoteOfferBatchV2MutationResult =
	Apollo.MutationResult<DeleteQuoteOfferBatchV2Mutation>;
export type DeleteQuoteOfferBatchV2MutationOptions = Apollo.BaseMutationOptions<
	DeleteQuoteOfferBatchV2Mutation,
	DeleteQuoteOfferBatchV2MutationVariables
>;
export const SubmitQuoteOfferBatchV2Document = gql`
	mutation SubmitQuoteOfferBatchV2($batchId: ID!) {
		submitQuoteOfferBatchV2(batchId: $batchId) {
			success
			message
		}
	}
`;
export type SubmitQuoteOfferBatchV2MutationFn = Apollo.MutationFunction<
	SubmitQuoteOfferBatchV2Mutation,
	SubmitQuoteOfferBatchV2MutationVariables
>;

/**
 * __useSubmitQuoteOfferBatchV2Mutation__
 *
 * To run a mutation, you first call `useSubmitQuoteOfferBatchV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuoteOfferBatchV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuoteOfferBatchV2Mutation, { data, loading, error }] = useSubmitQuoteOfferBatchV2Mutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useSubmitQuoteOfferBatchV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubmitQuoteOfferBatchV2Mutation,
		SubmitQuoteOfferBatchV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubmitQuoteOfferBatchV2Mutation,
		SubmitQuoteOfferBatchV2MutationVariables
	>(SubmitQuoteOfferBatchV2Document, options);
}
export type SubmitQuoteOfferBatchV2MutationHookResult = ReturnType<
	typeof useSubmitQuoteOfferBatchV2Mutation
>;
export type SubmitQuoteOfferBatchV2MutationResult =
	Apollo.MutationResult<SubmitQuoteOfferBatchV2Mutation>;
export type SubmitQuoteOfferBatchV2MutationOptions = Apollo.BaseMutationOptions<
	SubmitQuoteOfferBatchV2Mutation,
	SubmitQuoteOfferBatchV2MutationVariables
>;
export const AddAdminAdjustmentToOfferV2Document = gql`
	mutation AddAdminAdjustmentToOfferV2($input: AddAdminAdjustmentV2Input!) {
		addAdminAdjustmentToOfferV2(input: $input) {
			success
			message
		}
	}
`;
export type AddAdminAdjustmentToOfferV2MutationFn = Apollo.MutationFunction<
	AddAdminAdjustmentToOfferV2Mutation,
	AddAdminAdjustmentToOfferV2MutationVariables
>;

/**
 * __useAddAdminAdjustmentToOfferV2Mutation__
 *
 * To run a mutation, you first call `useAddAdminAdjustmentToOfferV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminAdjustmentToOfferV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminAdjustmentToOfferV2Mutation, { data, loading, error }] = useAddAdminAdjustmentToOfferV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdminAdjustmentToOfferV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddAdminAdjustmentToOfferV2Mutation,
		AddAdminAdjustmentToOfferV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddAdminAdjustmentToOfferV2Mutation,
		AddAdminAdjustmentToOfferV2MutationVariables
	>(AddAdminAdjustmentToOfferV2Document, options);
}
export type AddAdminAdjustmentToOfferV2MutationHookResult = ReturnType<
	typeof useAddAdminAdjustmentToOfferV2Mutation
>;
export type AddAdminAdjustmentToOfferV2MutationResult =
	Apollo.MutationResult<AddAdminAdjustmentToOfferV2Mutation>;
export type AddAdminAdjustmentToOfferV2MutationOptions = Apollo.BaseMutationOptions<
	AddAdminAdjustmentToOfferV2Mutation,
	AddAdminAdjustmentToOfferV2MutationVariables
>;
export const RemoveAdminAdjustmentFromOfferV2Document = gql`
	mutation RemoveAdminAdjustmentFromOfferV2($offerId: ID!, $adjustmentId: ID!) {
		removeAdminAdjustmentFromOfferV2(offerId: $offerId, adjustmentId: $adjustmentId) {
			success
			message
		}
	}
`;
export type RemoveAdminAdjustmentFromOfferV2MutationFn = Apollo.MutationFunction<
	RemoveAdminAdjustmentFromOfferV2Mutation,
	RemoveAdminAdjustmentFromOfferV2MutationVariables
>;

/**
 * __useRemoveAdminAdjustmentFromOfferV2Mutation__
 *
 * To run a mutation, you first call `useRemoveAdminAdjustmentFromOfferV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminAdjustmentFromOfferV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminAdjustmentFromOfferV2Mutation, { data, loading, error }] = useRemoveAdminAdjustmentFromOfferV2Mutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      adjustmentId: // value for 'adjustmentId'
 *   },
 * });
 */
export function useRemoveAdminAdjustmentFromOfferV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveAdminAdjustmentFromOfferV2Mutation,
		RemoveAdminAdjustmentFromOfferV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveAdminAdjustmentFromOfferV2Mutation,
		RemoveAdminAdjustmentFromOfferV2MutationVariables
	>(RemoveAdminAdjustmentFromOfferV2Document, options);
}
export type RemoveAdminAdjustmentFromOfferV2MutationHookResult = ReturnType<
	typeof useRemoveAdminAdjustmentFromOfferV2Mutation
>;
export type RemoveAdminAdjustmentFromOfferV2MutationResult =
	Apollo.MutationResult<RemoveAdminAdjustmentFromOfferV2Mutation>;
export type RemoveAdminAdjustmentFromOfferV2MutationOptions = Apollo.BaseMutationOptions<
	RemoveAdminAdjustmentFromOfferV2Mutation,
	RemoveAdminAdjustmentFromOfferV2MutationVariables
>;
export const AddAdminAdjustmentToVariationV2Document = gql`
	mutation AddAdminAdjustmentToVariationV2($input: AddAdminAdjustmentToVariationV2Input!) {
		addAdminAdjustmentToVariationV2(input: $input) {
			success
			message
		}
	}
`;
export type AddAdminAdjustmentToVariationV2MutationFn = Apollo.MutationFunction<
	AddAdminAdjustmentToVariationV2Mutation,
	AddAdminAdjustmentToVariationV2MutationVariables
>;

/**
 * __useAddAdminAdjustmentToVariationV2Mutation__
 *
 * To run a mutation, you first call `useAddAdminAdjustmentToVariationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminAdjustmentToVariationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminAdjustmentToVariationV2Mutation, { data, loading, error }] = useAddAdminAdjustmentToVariationV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdminAdjustmentToVariationV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddAdminAdjustmentToVariationV2Mutation,
		AddAdminAdjustmentToVariationV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddAdminAdjustmentToVariationV2Mutation,
		AddAdminAdjustmentToVariationV2MutationVariables
	>(AddAdminAdjustmentToVariationV2Document, options);
}
export type AddAdminAdjustmentToVariationV2MutationHookResult = ReturnType<
	typeof useAddAdminAdjustmentToVariationV2Mutation
>;
export type AddAdminAdjustmentToVariationV2MutationResult =
	Apollo.MutationResult<AddAdminAdjustmentToVariationV2Mutation>;
export type AddAdminAdjustmentToVariationV2MutationOptions = Apollo.BaseMutationOptions<
	AddAdminAdjustmentToVariationV2Mutation,
	AddAdminAdjustmentToVariationV2MutationVariables
>;
export const AddOfferToBatchV2Document = gql`
	mutation AddOfferToBatchV2($input: AddOfferToBatchV2Input!) {
		addOfferToBatchV2(input: $input) {
			success
			message
		}
	}
`;
export type AddOfferToBatchV2MutationFn = Apollo.MutationFunction<
	AddOfferToBatchV2Mutation,
	AddOfferToBatchV2MutationVariables
>;

/**
 * __useAddOfferToBatchV2Mutation__
 *
 * To run a mutation, you first call `useAddOfferToBatchV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfferToBatchV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfferToBatchV2Mutation, { data, loading, error }] = useAddOfferToBatchV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOfferToBatchV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddOfferToBatchV2Mutation,
		AddOfferToBatchV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddOfferToBatchV2Mutation, AddOfferToBatchV2MutationVariables>(
		AddOfferToBatchV2Document,
		options
	);
}
export type AddOfferToBatchV2MutationHookResult = ReturnType<typeof useAddOfferToBatchV2Mutation>;
export type AddOfferToBatchV2MutationResult = Apollo.MutationResult<AddOfferToBatchV2Mutation>;
export type AddOfferToBatchV2MutationOptions = Apollo.BaseMutationOptions<
	AddOfferToBatchV2Mutation,
	AddOfferToBatchV2MutationVariables
>;
export const GenerateQuoteOfferFileUploadUrlV2Document = gql`
	mutation GenerateQuoteOfferFileUploadUrlV2($input: QuoteOfferFileUploadV2Input!) {
		generateQuoteOfferFileUploadUrlV2(input: $input) {
			success
			message
			fileId
			uploadUrl
			expiresAt
		}
	}
`;
export type GenerateQuoteOfferFileUploadUrlV2MutationFn = Apollo.MutationFunction<
	GenerateQuoteOfferFileUploadUrlV2Mutation,
	GenerateQuoteOfferFileUploadUrlV2MutationVariables
>;

/**
 * __useGenerateQuoteOfferFileUploadUrlV2Mutation__
 *
 * To run a mutation, you first call `useGenerateQuoteOfferFileUploadUrlV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuoteOfferFileUploadUrlV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuoteOfferFileUploadUrlV2Mutation, { data, loading, error }] = useGenerateQuoteOfferFileUploadUrlV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateQuoteOfferFileUploadUrlV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateQuoteOfferFileUploadUrlV2Mutation,
		GenerateQuoteOfferFileUploadUrlV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateQuoteOfferFileUploadUrlV2Mutation,
		GenerateQuoteOfferFileUploadUrlV2MutationVariables
	>(GenerateQuoteOfferFileUploadUrlV2Document, options);
}
export type GenerateQuoteOfferFileUploadUrlV2MutationHookResult = ReturnType<
	typeof useGenerateQuoteOfferFileUploadUrlV2Mutation
>;
export type GenerateQuoteOfferFileUploadUrlV2MutationResult =
	Apollo.MutationResult<GenerateQuoteOfferFileUploadUrlV2Mutation>;
export type GenerateQuoteOfferFileUploadUrlV2MutationOptions = Apollo.BaseMutationOptions<
	GenerateQuoteOfferFileUploadUrlV2Mutation,
	GenerateQuoteOfferFileUploadUrlV2MutationVariables
>;
export const ConfirmQuoteOfferFileUploadV2Document = gql`
	mutation ConfirmQuoteOfferFileUploadV2($input: ConfirmQuoteOfferFileUploadV2Input!) {
		confirmQuoteOfferFileUploadV2(input: $input) {
			success
			message
		}
	}
`;
export type ConfirmQuoteOfferFileUploadV2MutationFn = Apollo.MutationFunction<
	ConfirmQuoteOfferFileUploadV2Mutation,
	ConfirmQuoteOfferFileUploadV2MutationVariables
>;

/**
 * __useConfirmQuoteOfferFileUploadV2Mutation__
 *
 * To run a mutation, you first call `useConfirmQuoteOfferFileUploadV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmQuoteOfferFileUploadV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmQuoteOfferFileUploadV2Mutation, { data, loading, error }] = useConfirmQuoteOfferFileUploadV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmQuoteOfferFileUploadV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmQuoteOfferFileUploadV2Mutation,
		ConfirmQuoteOfferFileUploadV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmQuoteOfferFileUploadV2Mutation,
		ConfirmQuoteOfferFileUploadV2MutationVariables
	>(ConfirmQuoteOfferFileUploadV2Document, options);
}
export type ConfirmQuoteOfferFileUploadV2MutationHookResult = ReturnType<
	typeof useConfirmQuoteOfferFileUploadV2Mutation
>;
export type ConfirmQuoteOfferFileUploadV2MutationResult =
	Apollo.MutationResult<ConfirmQuoteOfferFileUploadV2Mutation>;
export type ConfirmQuoteOfferFileUploadV2MutationOptions = Apollo.BaseMutationOptions<
	ConfirmQuoteOfferFileUploadV2Mutation,
	ConfirmQuoteOfferFileUploadV2MutationVariables
>;
export const DeleteQuoteOfferFileV2Document = gql`
	mutation DeleteQuoteOfferFileV2($fileId: ID!, $quoteV2Id: ID!) {
		deleteQuoteOfferFileV2(fileId: $fileId, quoteV2Id: $quoteV2Id) {
			success
			message
		}
	}
`;
export type DeleteQuoteOfferFileV2MutationFn = Apollo.MutationFunction<
	DeleteQuoteOfferFileV2Mutation,
	DeleteQuoteOfferFileV2MutationVariables
>;

/**
 * __useDeleteQuoteOfferFileV2Mutation__
 *
 * To run a mutation, you first call `useDeleteQuoteOfferFileV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteOfferFileV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteOfferFileV2Mutation, { data, loading, error }] = useDeleteQuoteOfferFileV2Mutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      quoteV2Id: // value for 'quoteV2Id'
 *   },
 * });
 */
export function useDeleteQuoteOfferFileV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteQuoteOfferFileV2Mutation,
		DeleteQuoteOfferFileV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteQuoteOfferFileV2Mutation,
		DeleteQuoteOfferFileV2MutationVariables
	>(DeleteQuoteOfferFileV2Document, options);
}
export type DeleteQuoteOfferFileV2MutationHookResult = ReturnType<
	typeof useDeleteQuoteOfferFileV2Mutation
>;
export type DeleteQuoteOfferFileV2MutationResult =
	Apollo.MutationResult<DeleteQuoteOfferFileV2Mutation>;
export type DeleteQuoteOfferFileV2MutationOptions = Apollo.BaseMutationOptions<
	DeleteQuoteOfferFileV2Mutation,
	DeleteQuoteOfferFileV2MutationVariables
>;
export const AcceptOffersV2Document = gql`
	mutation AcceptOffersV2($input: AcceptOffersV2Input!) {
		acceptOffersV2(input: $input) {
			success
			message
			order {
				id
				orderNumber
			}
			errors {
				field
				message
			}
		}
	}
`;
export type AcceptOffersV2MutationFn = Apollo.MutationFunction<
	AcceptOffersV2Mutation,
	AcceptOffersV2MutationVariables
>;

/**
 * __useAcceptOffersV2Mutation__
 *
 * To run a mutation, you first call `useAcceptOffersV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOffersV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOffersV2Mutation, { data, loading, error }] = useAcceptOffersV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptOffersV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AcceptOffersV2Mutation,
		AcceptOffersV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcceptOffersV2Mutation, AcceptOffersV2MutationVariables>(
		AcceptOffersV2Document,
		options
	);
}
export type AcceptOffersV2MutationHookResult = ReturnType<typeof useAcceptOffersV2Mutation>;
export type AcceptOffersV2MutationResult = Apollo.MutationResult<AcceptOffersV2Mutation>;
export type AcceptOffersV2MutationOptions = Apollo.BaseMutationOptions<
	AcceptOffersV2Mutation,
	AcceptOffersV2MutationVariables
>;
export const SubmitQuoteOffersToClientV2Document = gql`
	mutation SubmitQuoteOffersToClientV2($input: SubmitQuoteOffersToClientV2Input!) {
		submitQuoteOffersToClientV2(input: $input) {
			success
			message
		}
	}
`;
export type SubmitQuoteOffersToClientV2MutationFn = Apollo.MutationFunction<
	SubmitQuoteOffersToClientV2Mutation,
	SubmitQuoteOffersToClientV2MutationVariables
>;

/**
 * __useSubmitQuoteOffersToClientV2Mutation__
 *
 * To run a mutation, you first call `useSubmitQuoteOffersToClientV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuoteOffersToClientV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuoteOffersToClientV2Mutation, { data, loading, error }] = useSubmitQuoteOffersToClientV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitQuoteOffersToClientV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubmitQuoteOffersToClientV2Mutation,
		SubmitQuoteOffersToClientV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubmitQuoteOffersToClientV2Mutation,
		SubmitQuoteOffersToClientV2MutationVariables
	>(SubmitQuoteOffersToClientV2Document, options);
}
export type SubmitQuoteOffersToClientV2MutationHookResult = ReturnType<
	typeof useSubmitQuoteOffersToClientV2Mutation
>;
export type SubmitQuoteOffersToClientV2MutationResult =
	Apollo.MutationResult<SubmitQuoteOffersToClientV2Mutation>;
export type SubmitQuoteOffersToClientV2MutationOptions = Apollo.BaseMutationOptions<
	SubmitQuoteOffersToClientV2Mutation,
	SubmitQuoteOffersToClientV2MutationVariables
>;
export const UpdateQuoteOfferBatchMarginsV2Document = gql`
	mutation UpdateQuoteOfferBatchMarginsV2($input: UpdateQuoteOfferBatchMarginsV2Input!) {
		updateQuoteOfferBatchMarginsV2(input: $input) {
			success
			message
		}
	}
`;
export type UpdateQuoteOfferBatchMarginsV2MutationFn = Apollo.MutationFunction<
	UpdateQuoteOfferBatchMarginsV2Mutation,
	UpdateQuoteOfferBatchMarginsV2MutationVariables
>;

/**
 * __useUpdateQuoteOfferBatchMarginsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateQuoteOfferBatchMarginsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteOfferBatchMarginsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteOfferBatchMarginsV2Mutation, { data, loading, error }] = useUpdateQuoteOfferBatchMarginsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteOfferBatchMarginsV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateQuoteOfferBatchMarginsV2Mutation,
		UpdateQuoteOfferBatchMarginsV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateQuoteOfferBatchMarginsV2Mutation,
		UpdateQuoteOfferBatchMarginsV2MutationVariables
	>(UpdateQuoteOfferBatchMarginsV2Document, options);
}
export type UpdateQuoteOfferBatchMarginsV2MutationHookResult = ReturnType<
	typeof useUpdateQuoteOfferBatchMarginsV2Mutation
>;
export type UpdateQuoteOfferBatchMarginsV2MutationResult =
	Apollo.MutationResult<UpdateQuoteOfferBatchMarginsV2Mutation>;
export type UpdateQuoteOfferBatchMarginsV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateQuoteOfferBatchMarginsV2Mutation,
	UpdateQuoteOfferBatchMarginsV2MutationVariables
>;
export const ConfirmQuoteOrderV2Document = gql`
	mutation ConfirmQuoteOrderV2($id: ID!) {
		confirmQuoteOrderV2(id: $id) {
			id
			status
			confirmedAt
		}
	}
`;
export type ConfirmQuoteOrderV2MutationFn = Apollo.MutationFunction<
	ConfirmQuoteOrderV2Mutation,
	ConfirmQuoteOrderV2MutationVariables
>;

/**
 * __useConfirmQuoteOrderV2Mutation__
 *
 * To run a mutation, you first call `useConfirmQuoteOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmQuoteOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmQuoteOrderV2Mutation, { data, loading, error }] = useConfirmQuoteOrderV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmQuoteOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmQuoteOrderV2Mutation,
		ConfirmQuoteOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ConfirmQuoteOrderV2Mutation, ConfirmQuoteOrderV2MutationVariables>(
		ConfirmQuoteOrderV2Document,
		options
	);
}
export type ConfirmQuoteOrderV2MutationHookResult = ReturnType<
	typeof useConfirmQuoteOrderV2Mutation
>;
export type ConfirmQuoteOrderV2MutationResult = Apollo.MutationResult<ConfirmQuoteOrderV2Mutation>;
export type ConfirmQuoteOrderV2MutationOptions = Apollo.BaseMutationOptions<
	ConfirmQuoteOrderV2Mutation,
	ConfirmQuoteOrderV2MutationVariables
>;
export const CancelQuoteOrderV2Document = gql`
	mutation CancelQuoteOrderV2($id: ID!, $reason: String) {
		cancelQuoteOrderV2(id: $id, reason: $reason) {
			id
			status
		}
	}
`;
export type CancelQuoteOrderV2MutationFn = Apollo.MutationFunction<
	CancelQuoteOrderV2Mutation,
	CancelQuoteOrderV2MutationVariables
>;

/**
 * __useCancelQuoteOrderV2Mutation__
 *
 * To run a mutation, you first call `useCancelQuoteOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelQuoteOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelQuoteOrderV2Mutation, { data, loading, error }] = useCancelQuoteOrderV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelQuoteOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelQuoteOrderV2Mutation,
		CancelQuoteOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CancelQuoteOrderV2Mutation, CancelQuoteOrderV2MutationVariables>(
		CancelQuoteOrderV2Document,
		options
	);
}
export type CancelQuoteOrderV2MutationHookResult = ReturnType<typeof useCancelQuoteOrderV2Mutation>;
export type CancelQuoteOrderV2MutationResult = Apollo.MutationResult<CancelQuoteOrderV2Mutation>;
export type CancelQuoteOrderV2MutationOptions = Apollo.BaseMutationOptions<
	CancelQuoteOrderV2Mutation,
	CancelQuoteOrderV2MutationVariables
>;
export const CompleteQuoteOrderV2Document = gql`
	mutation CompleteQuoteOrderV2($id: ID!) {
		completeQuoteOrderV2(id: $id) {
			id
			status
			completedAt
		}
	}
`;
export type CompleteQuoteOrderV2MutationFn = Apollo.MutationFunction<
	CompleteQuoteOrderV2Mutation,
	CompleteQuoteOrderV2MutationVariables
>;

/**
 * __useCompleteQuoteOrderV2Mutation__
 *
 * To run a mutation, you first call `useCompleteQuoteOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteQuoteOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeQuoteOrderV2Mutation, { data, loading, error }] = useCompleteQuoteOrderV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteQuoteOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompleteQuoteOrderV2Mutation,
		CompleteQuoteOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CompleteQuoteOrderV2Mutation, CompleteQuoteOrderV2MutationVariables>(
		CompleteQuoteOrderV2Document,
		options
	);
}
export type CompleteQuoteOrderV2MutationHookResult = ReturnType<
	typeof useCompleteQuoteOrderV2Mutation
>;
export type CompleteQuoteOrderV2MutationResult =
	Apollo.MutationResult<CompleteQuoteOrderV2Mutation>;
export type CompleteQuoteOrderV2MutationOptions = Apollo.BaseMutationOptions<
	CompleteQuoteOrderV2Mutation,
	CompleteQuoteOrderV2MutationVariables
>;
export const UpdateQuoteOrderStatusV2Document = gql`
	mutation UpdateQuoteOrderStatusV2($id: ID!, $status: QuoteOrderStatusV2!) {
		updateQuoteOrderStatusV2(id: $id, status: $status) {
			id
			status
		}
	}
`;
export type UpdateQuoteOrderStatusV2MutationFn = Apollo.MutationFunction<
	UpdateQuoteOrderStatusV2Mutation,
	UpdateQuoteOrderStatusV2MutationVariables
>;

/**
 * __useUpdateQuoteOrderStatusV2Mutation__
 *
 * To run a mutation, you first call `useUpdateQuoteOrderStatusV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteOrderStatusV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteOrderStatusV2Mutation, { data, loading, error }] = useUpdateQuoteOrderStatusV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateQuoteOrderStatusV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateQuoteOrderStatusV2Mutation,
		UpdateQuoteOrderStatusV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateQuoteOrderStatusV2Mutation,
		UpdateQuoteOrderStatusV2MutationVariables
	>(UpdateQuoteOrderStatusV2Document, options);
}
export type UpdateQuoteOrderStatusV2MutationHookResult = ReturnType<
	typeof useUpdateQuoteOrderStatusV2Mutation
>;
export type UpdateQuoteOrderStatusV2MutationResult =
	Apollo.MutationResult<UpdateQuoteOrderStatusV2Mutation>;
export type UpdateQuoteOrderStatusV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateQuoteOrderStatusV2Mutation,
	UpdateQuoteOrderStatusV2MutationVariables
>;
export const StartOrderItemProductionV2Document = gql`
	mutation StartOrderItemProductionV2($orderItemId: ID!) {
		startOrderItemProductionV2(orderItemId: $orderItemId) {
			id
			status
			productionStartedAt
		}
	}
`;
export type StartOrderItemProductionV2MutationFn = Apollo.MutationFunction<
	StartOrderItemProductionV2Mutation,
	StartOrderItemProductionV2MutationVariables
>;

/**
 * __useStartOrderItemProductionV2Mutation__
 *
 * To run a mutation, you first call `useStartOrderItemProductionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOrderItemProductionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOrderItemProductionV2Mutation, { data, loading, error }] = useStartOrderItemProductionV2Mutation({
 *   variables: {
 *      orderItemId: // value for 'orderItemId'
 *   },
 * });
 */
export function useStartOrderItemProductionV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		StartOrderItemProductionV2Mutation,
		StartOrderItemProductionV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StartOrderItemProductionV2Mutation,
		StartOrderItemProductionV2MutationVariables
	>(StartOrderItemProductionV2Document, options);
}
export type StartOrderItemProductionV2MutationHookResult = ReturnType<
	typeof useStartOrderItemProductionV2Mutation
>;
export type StartOrderItemProductionV2MutationResult =
	Apollo.MutationResult<StartOrderItemProductionV2Mutation>;
export type StartOrderItemProductionV2MutationOptions = Apollo.BaseMutationOptions<
	StartOrderItemProductionV2Mutation,
	StartOrderItemProductionV2MutationVariables
>;
export const CompleteOrderItemProductionV2Document = gql`
	mutation CompleteOrderItemProductionV2($orderItemId: ID!) {
		completeOrderItemProductionV2(orderItemId: $orderItemId) {
			id
			status
			productionCompletedAt
		}
	}
`;
export type CompleteOrderItemProductionV2MutationFn = Apollo.MutationFunction<
	CompleteOrderItemProductionV2Mutation,
	CompleteOrderItemProductionV2MutationVariables
>;

/**
 * __useCompleteOrderItemProductionV2Mutation__
 *
 * To run a mutation, you first call `useCompleteOrderItemProductionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrderItemProductionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOrderItemProductionV2Mutation, { data, loading, error }] = useCompleteOrderItemProductionV2Mutation({
 *   variables: {
 *      orderItemId: // value for 'orderItemId'
 *   },
 * });
 */
export function useCompleteOrderItemProductionV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompleteOrderItemProductionV2Mutation,
		CompleteOrderItemProductionV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompleteOrderItemProductionV2Mutation,
		CompleteOrderItemProductionV2MutationVariables
	>(CompleteOrderItemProductionV2Document, options);
}
export type CompleteOrderItemProductionV2MutationHookResult = ReturnType<
	typeof useCompleteOrderItemProductionV2Mutation
>;
export type CompleteOrderItemProductionV2MutationResult =
	Apollo.MutationResult<CompleteOrderItemProductionV2Mutation>;
export type CompleteOrderItemProductionV2MutationOptions = Apollo.BaseMutationOptions<
	CompleteOrderItemProductionV2Mutation,
	CompleteOrderItemProductionV2MutationVariables
>;
export const ShipDeliveryV2Document = gql`
	mutation ShipDeliveryV2(
		$id: ID!
		$trackingNumber: String!
		$carrier: String!
		$estimatedDeliveryDate: DateTime
	) {
		shipDeliveryV2(
			id: $id
			trackingNumber: $trackingNumber
			carrier: $carrier
			estimatedDeliveryDate: $estimatedDeliveryDate
		) {
			id
			status
			trackingNumber
			carrier
			estimatedDeliveryDate
			shippedAt
		}
	}
`;
export type ShipDeliveryV2MutationFn = Apollo.MutationFunction<
	ShipDeliveryV2Mutation,
	ShipDeliveryV2MutationVariables
>;

/**
 * __useShipDeliveryV2Mutation__
 *
 * To run a mutation, you first call `useShipDeliveryV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipDeliveryV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipDeliveryV2Mutation, { data, loading, error }] = useShipDeliveryV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackingNumber: // value for 'trackingNumber'
 *      carrier: // value for 'carrier'
 *      estimatedDeliveryDate: // value for 'estimatedDeliveryDate'
 *   },
 * });
 */
export function useShipDeliveryV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		ShipDeliveryV2Mutation,
		ShipDeliveryV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ShipDeliveryV2Mutation, ShipDeliveryV2MutationVariables>(
		ShipDeliveryV2Document,
		options
	);
}
export type ShipDeliveryV2MutationHookResult = ReturnType<typeof useShipDeliveryV2Mutation>;
export type ShipDeliveryV2MutationResult = Apollo.MutationResult<ShipDeliveryV2Mutation>;
export type ShipDeliveryV2MutationOptions = Apollo.BaseMutationOptions<
	ShipDeliveryV2Mutation,
	ShipDeliveryV2MutationVariables
>;
export const MarkDeliveryDeliveredV2Document = gql`
	mutation MarkDeliveryDeliveredV2($id: ID!, $actualDeliveryDate: DateTime) {
		markDeliveryDeliveredV2(id: $id, actualDeliveryDate: $actualDeliveryDate) {
			id
			status
			actualDeliveryDate
		}
	}
`;
export type MarkDeliveryDeliveredV2MutationFn = Apollo.MutationFunction<
	MarkDeliveryDeliveredV2Mutation,
	MarkDeliveryDeliveredV2MutationVariables
>;

/**
 * __useMarkDeliveryDeliveredV2Mutation__
 *
 * To run a mutation, you first call `useMarkDeliveryDeliveredV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDeliveryDeliveredV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDeliveryDeliveredV2Mutation, { data, loading, error }] = useMarkDeliveryDeliveredV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      actualDeliveryDate: // value for 'actualDeliveryDate'
 *   },
 * });
 */
export function useMarkDeliveryDeliveredV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkDeliveryDeliveredV2Mutation,
		MarkDeliveryDeliveredV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkDeliveryDeliveredV2Mutation,
		MarkDeliveryDeliveredV2MutationVariables
	>(MarkDeliveryDeliveredV2Document, options);
}
export type MarkDeliveryDeliveredV2MutationHookResult = ReturnType<
	typeof useMarkDeliveryDeliveredV2Mutation
>;
export type MarkDeliveryDeliveredV2MutationResult =
	Apollo.MutationResult<MarkDeliveryDeliveredV2Mutation>;
export type MarkDeliveryDeliveredV2MutationOptions = Apollo.BaseMutationOptions<
	MarkDeliveryDeliveredV2Mutation,
	MarkDeliveryDeliveredV2MutationVariables
>;
export const CreateSamplePaymentForOrderV2Document = gql`
	mutation CreateSamplePaymentForOrderV2($input: CreateSamplePaymentForOrderV2Input!) {
		createSamplePaymentForOrderV2(input: $input) {
			success
			message
			clientSecret
			sessionId
			expiresAt
			checkoutLimitExceeded
			checkoutLimit
		}
	}
`;
export type CreateSamplePaymentForOrderV2MutationFn = Apollo.MutationFunction<
	CreateSamplePaymentForOrderV2Mutation,
	CreateSamplePaymentForOrderV2MutationVariables
>;

/**
 * __useCreateSamplePaymentForOrderV2Mutation__
 *
 * To run a mutation, you first call `useCreateSamplePaymentForOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamplePaymentForOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamplePaymentForOrderV2Mutation, { data, loading, error }] = useCreateSamplePaymentForOrderV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSamplePaymentForOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSamplePaymentForOrderV2Mutation,
		CreateSamplePaymentForOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateSamplePaymentForOrderV2Mutation,
		CreateSamplePaymentForOrderV2MutationVariables
	>(CreateSamplePaymentForOrderV2Document, options);
}
export type CreateSamplePaymentForOrderV2MutationHookResult = ReturnType<
	typeof useCreateSamplePaymentForOrderV2Mutation
>;
export type CreateSamplePaymentForOrderV2MutationResult =
	Apollo.MutationResult<CreateSamplePaymentForOrderV2Mutation>;
export type CreateSamplePaymentForOrderV2MutationOptions = Apollo.BaseMutationOptions<
	CreateSamplePaymentForOrderV2Mutation,
	CreateSamplePaymentForOrderV2MutationVariables
>;
export const CreateProductPaymentForOrderV2Document = gql`
	mutation CreateProductPaymentForOrderV2($input: CreateProductPaymentForOrderV2Input!) {
		createProductPaymentForOrderV2(input: $input) {
			success
			message
			paymentTransactionId
			paymentMethod
			clientSecret
			sessionId
			economicBookedInvoiceNumber
		}
	}
`;
export type CreateProductPaymentForOrderV2MutationFn = Apollo.MutationFunction<
	CreateProductPaymentForOrderV2Mutation,
	CreateProductPaymentForOrderV2MutationVariables
>;

/**
 * __useCreateProductPaymentForOrderV2Mutation__
 *
 * To run a mutation, you first call `useCreateProductPaymentForOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductPaymentForOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductPaymentForOrderV2Mutation, { data, loading, error }] = useCreateProductPaymentForOrderV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductPaymentForOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProductPaymentForOrderV2Mutation,
		CreateProductPaymentForOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateProductPaymentForOrderV2Mutation,
		CreateProductPaymentForOrderV2MutationVariables
	>(CreateProductPaymentForOrderV2Document, options);
}
export type CreateProductPaymentForOrderV2MutationHookResult = ReturnType<
	typeof useCreateProductPaymentForOrderV2Mutation
>;
export type CreateProductPaymentForOrderV2MutationResult =
	Apollo.MutationResult<CreateProductPaymentForOrderV2Mutation>;
export type CreateProductPaymentForOrderV2MutationOptions = Apollo.BaseMutationOptions<
	CreateProductPaymentForOrderV2Mutation,
	CreateProductPaymentForOrderV2MutationVariables
>;
export const CreateSampleInvoiceForOrderV2Document = gql`
	mutation CreateSampleInvoiceForOrderV2($input: CreateSampleInvoiceForOrderV2Input!) {
		createSampleInvoiceForOrderV2(input: $input) {
			success
			message
			invoicedCount
			belowInvoiceMinimum
			invoiceMinimum
		}
	}
`;
export type CreateSampleInvoiceForOrderV2MutationFn = Apollo.MutationFunction<
	CreateSampleInvoiceForOrderV2Mutation,
	CreateSampleInvoiceForOrderV2MutationVariables
>;

/**
 * __useCreateSampleInvoiceForOrderV2Mutation__
 *
 * To run a mutation, you first call `useCreateSampleInvoiceForOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSampleInvoiceForOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSampleInvoiceForOrderV2Mutation, { data, loading, error }] = useCreateSampleInvoiceForOrderV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSampleInvoiceForOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSampleInvoiceForOrderV2Mutation,
		CreateSampleInvoiceForOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateSampleInvoiceForOrderV2Mutation,
		CreateSampleInvoiceForOrderV2MutationVariables
	>(CreateSampleInvoiceForOrderV2Document, options);
}
export type CreateSampleInvoiceForOrderV2MutationHookResult = ReturnType<
	typeof useCreateSampleInvoiceForOrderV2Mutation
>;
export type CreateSampleInvoiceForOrderV2MutationResult =
	Apollo.MutationResult<CreateSampleInvoiceForOrderV2Mutation>;
export type CreateSampleInvoiceForOrderV2MutationOptions = Apollo.BaseMutationOptions<
	CreateSampleInvoiceForOrderV2Mutation,
	CreateSampleInvoiceForOrderV2MutationVariables
>;
export const CancelSampleInvoiceForOrderV2Document = gql`
	mutation CancelSampleInvoiceForOrderV2($input: CancelSampleInvoiceForOrderV2Input!) {
		cancelSampleInvoiceForOrderV2(input: $input) {
			success
			message
			cancelledCount
		}
	}
`;
export type CancelSampleInvoiceForOrderV2MutationFn = Apollo.MutationFunction<
	CancelSampleInvoiceForOrderV2Mutation,
	CancelSampleInvoiceForOrderV2MutationVariables
>;

/**
 * __useCancelSampleInvoiceForOrderV2Mutation__
 *
 * To run a mutation, you first call `useCancelSampleInvoiceForOrderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSampleInvoiceForOrderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSampleInvoiceForOrderV2Mutation, { data, loading, error }] = useCancelSampleInvoiceForOrderV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSampleInvoiceForOrderV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelSampleInvoiceForOrderV2Mutation,
		CancelSampleInvoiceForOrderV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CancelSampleInvoiceForOrderV2Mutation,
		CancelSampleInvoiceForOrderV2MutationVariables
	>(CancelSampleInvoiceForOrderV2Document, options);
}
export type CancelSampleInvoiceForOrderV2MutationHookResult = ReturnType<
	typeof useCancelSampleInvoiceForOrderV2Mutation
>;
export type CancelSampleInvoiceForOrderV2MutationResult =
	Apollo.MutationResult<CancelSampleInvoiceForOrderV2Mutation>;
export type CancelSampleInvoiceForOrderV2MutationOptions = Apollo.BaseMutationOptions<
	CancelSampleInvoiceForOrderV2Mutation,
	CancelSampleInvoiceForOrderV2MutationVariables
>;
export const CancelProductPaymentV2Document = gql`
	mutation CancelProductPaymentV2($input: CancelProductPaymentV2Input!) {
		cancelProductPaymentV2(input: $input) {
			success
			message
			alreadyCancelled
		}
	}
`;
export type CancelProductPaymentV2MutationFn = Apollo.MutationFunction<
	CancelProductPaymentV2Mutation,
	CancelProductPaymentV2MutationVariables
>;

/**
 * __useCancelProductPaymentV2Mutation__
 *
 * To run a mutation, you first call `useCancelProductPaymentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProductPaymentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProductPaymentV2Mutation, { data, loading, error }] = useCancelProductPaymentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelProductPaymentV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelProductPaymentV2Mutation,
		CancelProductPaymentV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CancelProductPaymentV2Mutation,
		CancelProductPaymentV2MutationVariables
	>(CancelProductPaymentV2Document, options);
}
export type CancelProductPaymentV2MutationHookResult = ReturnType<
	typeof useCancelProductPaymentV2Mutation
>;
export type CancelProductPaymentV2MutationResult =
	Apollo.MutationResult<CancelProductPaymentV2Mutation>;
export type CancelProductPaymentV2MutationOptions = Apollo.BaseMutationOptions<
	CancelProductPaymentV2Mutation,
	CancelProductPaymentV2MutationVariables
>;
export const MarkProductInvoicePaidV2Document = gql`
	mutation MarkProductInvoicePaidV2($input: MarkProductInvoicePaidV2Input!) {
		markProductInvoicePaidV2(input: $input) {
			success
			message
			alreadyPaid
		}
	}
`;
export type MarkProductInvoicePaidV2MutationFn = Apollo.MutationFunction<
	MarkProductInvoicePaidV2Mutation,
	MarkProductInvoicePaidV2MutationVariables
>;

/**
 * __useMarkProductInvoicePaidV2Mutation__
 *
 * To run a mutation, you first call `useMarkProductInvoicePaidV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProductInvoicePaidV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProductInvoicePaidV2Mutation, { data, loading, error }] = useMarkProductInvoicePaidV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkProductInvoicePaidV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkProductInvoicePaidV2Mutation,
		MarkProductInvoicePaidV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkProductInvoicePaidV2Mutation,
		MarkProductInvoicePaidV2MutationVariables
	>(MarkProductInvoicePaidV2Document, options);
}
export type MarkProductInvoicePaidV2MutationHookResult = ReturnType<
	typeof useMarkProductInvoicePaidV2Mutation
>;
export type MarkProductInvoicePaidV2MutationResult =
	Apollo.MutationResult<MarkProductInvoicePaidV2Mutation>;
export type MarkProductInvoicePaidV2MutationOptions = Apollo.BaseMutationOptions<
	MarkProductInvoicePaidV2Mutation,
	MarkProductInvoicePaidV2MutationVariables
>;
export const UpdateOrderStripeCheckoutLimitV2Document = gql`
	mutation UpdateOrderStripeCheckoutLimitV2($orderId: ID!, $limit: Float) {
		updateOrderStripeCheckoutLimitV2(orderId: $orderId, limit: $limit) {
			id
			stripeCheckoutLimit
		}
	}
`;
export type UpdateOrderStripeCheckoutLimitV2MutationFn = Apollo.MutationFunction<
	UpdateOrderStripeCheckoutLimitV2Mutation,
	UpdateOrderStripeCheckoutLimitV2MutationVariables
>;

/**
 * __useUpdateOrderStripeCheckoutLimitV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrderStripeCheckoutLimitV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStripeCheckoutLimitV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStripeCheckoutLimitV2Mutation, { data, loading, error }] = useUpdateOrderStripeCheckoutLimitV2Mutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUpdateOrderStripeCheckoutLimitV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderStripeCheckoutLimitV2Mutation,
		UpdateOrderStripeCheckoutLimitV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderStripeCheckoutLimitV2Mutation,
		UpdateOrderStripeCheckoutLimitV2MutationVariables
	>(UpdateOrderStripeCheckoutLimitV2Document, options);
}
export type UpdateOrderStripeCheckoutLimitV2MutationHookResult = ReturnType<
	typeof useUpdateOrderStripeCheckoutLimitV2Mutation
>;
export type UpdateOrderStripeCheckoutLimitV2MutationResult =
	Apollo.MutationResult<UpdateOrderStripeCheckoutLimitV2Mutation>;
export type UpdateOrderStripeCheckoutLimitV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderStripeCheckoutLimitV2Mutation,
	UpdateOrderStripeCheckoutLimitV2MutationVariables
>;
export const UpdateOrderInvoiceMinimumV2Document = gql`
	mutation UpdateOrderInvoiceMinimumV2($orderId: ID!, $limit: Float) {
		updateOrderInvoiceMinimumV2(orderId: $orderId, limit: $limit) {
			id
			invoiceMinimum
		}
	}
`;
export type UpdateOrderInvoiceMinimumV2MutationFn = Apollo.MutationFunction<
	UpdateOrderInvoiceMinimumV2Mutation,
	UpdateOrderInvoiceMinimumV2MutationVariables
>;

/**
 * __useUpdateOrderInvoiceMinimumV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrderInvoiceMinimumV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderInvoiceMinimumV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderInvoiceMinimumV2Mutation, { data, loading, error }] = useUpdateOrderInvoiceMinimumV2Mutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUpdateOrderInvoiceMinimumV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderInvoiceMinimumV2Mutation,
		UpdateOrderInvoiceMinimumV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderInvoiceMinimumV2Mutation,
		UpdateOrderInvoiceMinimumV2MutationVariables
	>(UpdateOrderInvoiceMinimumV2Document, options);
}
export type UpdateOrderInvoiceMinimumV2MutationHookResult = ReturnType<
	typeof useUpdateOrderInvoiceMinimumV2Mutation
>;
export type UpdateOrderInvoiceMinimumV2MutationResult =
	Apollo.MutationResult<UpdateOrderInvoiceMinimumV2Mutation>;
export type UpdateOrderInvoiceMinimumV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderInvoiceMinimumV2Mutation,
	UpdateOrderInvoiceMinimumV2MutationVariables
>;
export const UpdateOrderInvoiceRecipientV2Document = gql`
	mutation UpdateOrderInvoiceRecipientV2($orderId: ID!, $recipient: InvoiceRecipientInputV2!) {
		updateOrderInvoiceRecipientV2(orderId: $orderId, recipient: $recipient) {
			id
			invoiceRecipientOrgUserId
			invoiceRecipientEmail
		}
	}
`;
export type UpdateOrderInvoiceRecipientV2MutationFn = Apollo.MutationFunction<
	UpdateOrderInvoiceRecipientV2Mutation,
	UpdateOrderInvoiceRecipientV2MutationVariables
>;

/**
 * __useUpdateOrderInvoiceRecipientV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrderInvoiceRecipientV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderInvoiceRecipientV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderInvoiceRecipientV2Mutation, { data, loading, error }] = useUpdateOrderInvoiceRecipientV2Mutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      recipient: // value for 'recipient'
 *   },
 * });
 */
export function useUpdateOrderInvoiceRecipientV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderInvoiceRecipientV2Mutation,
		UpdateOrderInvoiceRecipientV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderInvoiceRecipientV2Mutation,
		UpdateOrderInvoiceRecipientV2MutationVariables
	>(UpdateOrderInvoiceRecipientV2Document, options);
}
export type UpdateOrderInvoiceRecipientV2MutationHookResult = ReturnType<
	typeof useUpdateOrderInvoiceRecipientV2Mutation
>;
export type UpdateOrderInvoiceRecipientV2MutationResult =
	Apollo.MutationResult<UpdateOrderInvoiceRecipientV2Mutation>;
export type UpdateOrderInvoiceRecipientV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderInvoiceRecipientV2Mutation,
	UpdateOrderInvoiceRecipientV2MutationVariables
>;
export const UpdateOrderPaymentModeV2Document = gql`
	mutation UpdateOrderPaymentModeV2(
		$orderId: ID!
		$productPaymentMode: PaymentModeEnum!
		$samplePaymentMode: PaymentModeEnum!
	) {
		updateOrderPaymentModeV2(
			orderId: $orderId
			productPaymentMode: $productPaymentMode
			samplePaymentMode: $samplePaymentMode
		) {
			id
			productPaymentMode
			samplePaymentMode
		}
	}
`;
export type UpdateOrderPaymentModeV2MutationFn = Apollo.MutationFunction<
	UpdateOrderPaymentModeV2Mutation,
	UpdateOrderPaymentModeV2MutationVariables
>;

/**
 * __useUpdateOrderPaymentModeV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrderPaymentModeV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderPaymentModeV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderPaymentModeV2Mutation, { data, loading, error }] = useUpdateOrderPaymentModeV2Mutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productPaymentMode: // value for 'productPaymentMode'
 *      samplePaymentMode: // value for 'samplePaymentMode'
 *   },
 * });
 */
export function useUpdateOrderPaymentModeV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrderPaymentModeV2Mutation,
		UpdateOrderPaymentModeV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrderPaymentModeV2Mutation,
		UpdateOrderPaymentModeV2MutationVariables
	>(UpdateOrderPaymentModeV2Document, options);
}
export type UpdateOrderPaymentModeV2MutationHookResult = ReturnType<
	typeof useUpdateOrderPaymentModeV2Mutation
>;
export type UpdateOrderPaymentModeV2MutationResult =
	Apollo.MutationResult<UpdateOrderPaymentModeV2Mutation>;
export type UpdateOrderPaymentModeV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateOrderPaymentModeV2Mutation,
	UpdateOrderPaymentModeV2MutationVariables
>;
export const CreateQuoteV2Document = gql`
	mutation CreateQuoteV2($input: CreateQuoteV2Input!) {
		createQuoteV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateQuoteV2MutationFn = Apollo.MutationFunction<
	CreateQuoteV2Mutation,
	CreateQuoteV2MutationVariables
>;

/**
 * __useCreateQuoteV2Mutation__
 *
 * To run a mutation, you first call `useCreateQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteV2Mutation, { data, loading, error }] = useCreateQuoteV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<CreateQuoteV2Mutation, CreateQuoteV2MutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateQuoteV2Mutation, CreateQuoteV2MutationVariables>(
		CreateQuoteV2Document,
		options
	);
}
export type CreateQuoteV2MutationHookResult = ReturnType<typeof useCreateQuoteV2Mutation>;
export type CreateQuoteV2MutationResult = Apollo.MutationResult<CreateQuoteV2Mutation>;
export type CreateQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	CreateQuoteV2Mutation,
	CreateQuoteV2MutationVariables
>;
export const AddQuoteItemV2Document = gql`
	mutation AddQuoteItemV2($input: AddQuoteItemV2Input!) {
		addQuoteItemV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddQuoteItemV2MutationFn = Apollo.MutationFunction<
	AddQuoteItemV2Mutation,
	AddQuoteItemV2MutationVariables
>;

/**
 * __useAddQuoteItemV2Mutation__
 *
 * To run a mutation, you first call `useAddQuoteItemV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuoteItemV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuoteItemV2Mutation, { data, loading, error }] = useAddQuoteItemV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuoteItemV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddQuoteItemV2Mutation,
		AddQuoteItemV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddQuoteItemV2Mutation, AddQuoteItemV2MutationVariables>(
		AddQuoteItemV2Document,
		options
	);
}
export type AddQuoteItemV2MutationHookResult = ReturnType<typeof useAddQuoteItemV2Mutation>;
export type AddQuoteItemV2MutationResult = Apollo.MutationResult<AddQuoteItemV2Mutation>;
export type AddQuoteItemV2MutationOptions = Apollo.BaseMutationOptions<
	AddQuoteItemV2Mutation,
	AddQuoteItemV2MutationVariables
>;
export const UpdateQuoteItemV2Document = gql`
	mutation UpdateQuoteItemV2($input: UpdateQuoteItemV2Input!) {
		updateQuoteItemV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateQuoteItemV2MutationFn = Apollo.MutationFunction<
	UpdateQuoteItemV2Mutation,
	UpdateQuoteItemV2MutationVariables
>;

/**
 * __useUpdateQuoteItemV2Mutation__
 *
 * To run a mutation, you first call `useUpdateQuoteItemV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteItemV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteItemV2Mutation, { data, loading, error }] = useUpdateQuoteItemV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteItemV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateQuoteItemV2Mutation,
		UpdateQuoteItemV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateQuoteItemV2Mutation, UpdateQuoteItemV2MutationVariables>(
		UpdateQuoteItemV2Document,
		options
	);
}
export type UpdateQuoteItemV2MutationHookResult = ReturnType<typeof useUpdateQuoteItemV2Mutation>;
export type UpdateQuoteItemV2MutationResult = Apollo.MutationResult<UpdateQuoteItemV2Mutation>;
export type UpdateQuoteItemV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateQuoteItemV2Mutation,
	UpdateQuoteItemV2MutationVariables
>;
export const DeleteQuoteItemV2Document = gql`
	mutation DeleteQuoteItemV2($input: DeleteQuoteItemV2Input!) {
		deleteQuoteItemV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteQuoteItemV2MutationFn = Apollo.MutationFunction<
	DeleteQuoteItemV2Mutation,
	DeleteQuoteItemV2MutationVariables
>;

/**
 * __useDeleteQuoteItemV2Mutation__
 *
 * To run a mutation, you first call `useDeleteQuoteItemV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteItemV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteItemV2Mutation, { data, loading, error }] = useDeleteQuoteItemV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuoteItemV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteQuoteItemV2Mutation,
		DeleteQuoteItemV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteQuoteItemV2Mutation, DeleteQuoteItemV2MutationVariables>(
		DeleteQuoteItemV2Document,
		options
	);
}
export type DeleteQuoteItemV2MutationHookResult = ReturnType<typeof useDeleteQuoteItemV2Mutation>;
export type DeleteQuoteItemV2MutationResult = Apollo.MutationResult<DeleteQuoteItemV2Mutation>;
export type DeleteQuoteItemV2MutationOptions = Apollo.BaseMutationOptions<
	DeleteQuoteItemV2Mutation,
	DeleteQuoteItemV2MutationVariables
>;
export const DeleteQuoteV2Document = gql`
	mutation DeleteQuoteV2($input: DeleteQuoteV2Input!) {
		deleteQuoteV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteQuoteV2MutationFn = Apollo.MutationFunction<
	DeleteQuoteV2Mutation,
	DeleteQuoteV2MutationVariables
>;

/**
 * __useDeleteQuoteV2Mutation__
 *
 * To run a mutation, you first call `useDeleteQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteV2Mutation, { data, loading, error }] = useDeleteQuoteV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteQuoteV2Mutation, DeleteQuoteV2MutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteQuoteV2Mutation, DeleteQuoteV2MutationVariables>(
		DeleteQuoteV2Document,
		options
	);
}
export type DeleteQuoteV2MutationHookResult = ReturnType<typeof useDeleteQuoteV2Mutation>;
export type DeleteQuoteV2MutationResult = Apollo.MutationResult<DeleteQuoteV2Mutation>;
export type DeleteQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	DeleteQuoteV2Mutation,
	DeleteQuoteV2MutationVariables
>;
export const SetCurrentQuoteV2Document = gql`
	mutation SetCurrentQuoteV2($id: ID!) {
		setCurrentQuoteV2(id: $id) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SetCurrentQuoteV2MutationFn = Apollo.MutationFunction<
	SetCurrentQuoteV2Mutation,
	SetCurrentQuoteV2MutationVariables
>;

/**
 * __useSetCurrentQuoteV2Mutation__
 *
 * To run a mutation, you first call `useSetCurrentQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCurrentQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCurrentQuoteV2Mutation, { data, loading, error }] = useSetCurrentQuoteV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetCurrentQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetCurrentQuoteV2Mutation,
		SetCurrentQuoteV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SetCurrentQuoteV2Mutation, SetCurrentQuoteV2MutationVariables>(
		SetCurrentQuoteV2Document,
		options
	);
}
export type SetCurrentQuoteV2MutationHookResult = ReturnType<typeof useSetCurrentQuoteV2Mutation>;
export type SetCurrentQuoteV2MutationResult = Apollo.MutationResult<SetCurrentQuoteV2Mutation>;
export type SetCurrentQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	SetCurrentQuoteV2Mutation,
	SetCurrentQuoteV2MutationVariables
>;
export const UpdateQuoteV2Document = gql`
	mutation UpdateQuoteV2($input: UpdateQuoteV2Input!) {
		updateQuoteV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateQuoteV2MutationFn = Apollo.MutationFunction<
	UpdateQuoteV2Mutation,
	UpdateQuoteV2MutationVariables
>;

/**
 * __useUpdateQuoteV2Mutation__
 *
 * To run a mutation, you first call `useUpdateQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteV2Mutation, { data, loading, error }] = useUpdateQuoteV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateQuoteV2Mutation, UpdateQuoteV2MutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateQuoteV2Mutation, UpdateQuoteV2MutationVariables>(
		UpdateQuoteV2Document,
		options
	);
}
export type UpdateQuoteV2MutationHookResult = ReturnType<typeof useUpdateQuoteV2Mutation>;
export type UpdateQuoteV2MutationResult = Apollo.MutationResult<UpdateQuoteV2Mutation>;
export type UpdateQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateQuoteV2Mutation,
	UpdateQuoteV2MutationVariables
>;
export const UpdateQuoteContactsV2Document = gql`
	mutation UpdateQuoteContactsV2($quoteId: ID!, $contactUserIds: [ID!]!) {
		updateQuoteContactsV2(quoteId: $quoteId, contactUserIds: $contactUserIds) {
			id
			contactUserIds
		}
	}
`;
export type UpdateQuoteContactsV2MutationFn = Apollo.MutationFunction<
	UpdateQuoteContactsV2Mutation,
	UpdateQuoteContactsV2MutationVariables
>;

/**
 * __useUpdateQuoteContactsV2Mutation__
 *
 * To run a mutation, you first call `useUpdateQuoteContactsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteContactsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteContactsV2Mutation, { data, loading, error }] = useUpdateQuoteContactsV2Mutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      contactUserIds: // value for 'contactUserIds'
 *   },
 * });
 */
export function useUpdateQuoteContactsV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateQuoteContactsV2Mutation,
		UpdateQuoteContactsV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateQuoteContactsV2Mutation,
		UpdateQuoteContactsV2MutationVariables
	>(UpdateQuoteContactsV2Document, options);
}
export type UpdateQuoteContactsV2MutationHookResult = ReturnType<
	typeof useUpdateQuoteContactsV2Mutation
>;
export type UpdateQuoteContactsV2MutationResult =
	Apollo.MutationResult<UpdateQuoteContactsV2Mutation>;
export type UpdateQuoteContactsV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateQuoteContactsV2Mutation,
	UpdateQuoteContactsV2MutationVariables
>;
export const AssignVetterEntitiesToQuoteV2Document = gql`
	mutation AssignVetterEntitiesToQuoteV2($quoteV2Id: ID!, $vetterEntityIds: [ID!]!) {
		assignVetterEntitiesToQuoteV2(quoteV2Id: $quoteV2Id, vetterEntityIds: $vetterEntityIds) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AssignVetterEntitiesToQuoteV2MutationFn = Apollo.MutationFunction<
	AssignVetterEntitiesToQuoteV2Mutation,
	AssignVetterEntitiesToQuoteV2MutationVariables
>;

/**
 * __useAssignVetterEntitiesToQuoteV2Mutation__
 *
 * To run a mutation, you first call `useAssignVetterEntitiesToQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignVetterEntitiesToQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignVetterEntitiesToQuoteV2Mutation, { data, loading, error }] = useAssignVetterEntitiesToQuoteV2Mutation({
 *   variables: {
 *      quoteV2Id: // value for 'quoteV2Id'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useAssignVetterEntitiesToQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignVetterEntitiesToQuoteV2Mutation,
		AssignVetterEntitiesToQuoteV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignVetterEntitiesToQuoteV2Mutation,
		AssignVetterEntitiesToQuoteV2MutationVariables
	>(AssignVetterEntitiesToQuoteV2Document, options);
}
export type AssignVetterEntitiesToQuoteV2MutationHookResult = ReturnType<
	typeof useAssignVetterEntitiesToQuoteV2Mutation
>;
export type AssignVetterEntitiesToQuoteV2MutationResult =
	Apollo.MutationResult<AssignVetterEntitiesToQuoteV2Mutation>;
export type AssignVetterEntitiesToQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	AssignVetterEntitiesToQuoteV2Mutation,
	AssignVetterEntitiesToQuoteV2MutationVariables
>;
export const RemoveVetterEntitiesFromQuoteV2Document = gql`
	mutation RemoveVetterEntitiesFromQuoteV2($quoteV2Id: ID!, $vetterEntityIds: [ID!]!) {
		removeVetterEntitiesFromQuoteV2(quoteV2Id: $quoteV2Id, vetterEntityIds: $vetterEntityIds) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveVetterEntitiesFromQuoteV2MutationFn = Apollo.MutationFunction<
	RemoveVetterEntitiesFromQuoteV2Mutation,
	RemoveVetterEntitiesFromQuoteV2MutationVariables
>;

/**
 * __useRemoveVetterEntitiesFromQuoteV2Mutation__
 *
 * To run a mutation, you first call `useRemoveVetterEntitiesFromQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVetterEntitiesFromQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVetterEntitiesFromQuoteV2Mutation, { data, loading, error }] = useRemoveVetterEntitiesFromQuoteV2Mutation({
 *   variables: {
 *      quoteV2Id: // value for 'quoteV2Id'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useRemoveVetterEntitiesFromQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveVetterEntitiesFromQuoteV2Mutation,
		RemoveVetterEntitiesFromQuoteV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveVetterEntitiesFromQuoteV2Mutation,
		RemoveVetterEntitiesFromQuoteV2MutationVariables
	>(RemoveVetterEntitiesFromQuoteV2Document, options);
}
export type RemoveVetterEntitiesFromQuoteV2MutationHookResult = ReturnType<
	typeof useRemoveVetterEntitiesFromQuoteV2Mutation
>;
export type RemoveVetterEntitiesFromQuoteV2MutationResult =
	Apollo.MutationResult<RemoveVetterEntitiesFromQuoteV2Mutation>;
export type RemoveVetterEntitiesFromQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	RemoveVetterEntitiesFromQuoteV2Mutation,
	RemoveVetterEntitiesFromQuoteV2MutationVariables
>;
export const SubmitQuoteV2Document = gql`
	mutation SubmitQuoteV2($input: SubmitQuoteV2Input!) {
		submitQuoteV2(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type SubmitQuoteV2MutationFn = Apollo.MutationFunction<
	SubmitQuoteV2Mutation,
	SubmitQuoteV2MutationVariables
>;

/**
 * __useSubmitQuoteV2Mutation__
 *
 * To run a mutation, you first call `useSubmitQuoteV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuoteV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuoteV2Mutation, { data, loading, error }] = useSubmitQuoteV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitQuoteV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<SubmitQuoteV2Mutation, SubmitQuoteV2MutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SubmitQuoteV2Mutation, SubmitQuoteV2MutationVariables>(
		SubmitQuoteV2Document,
		options
	);
}
export type SubmitQuoteV2MutationHookResult = ReturnType<typeof useSubmitQuoteV2Mutation>;
export type SubmitQuoteV2MutationResult = Apollo.MutationResult<SubmitQuoteV2Mutation>;
export type SubmitQuoteV2MutationOptions = Apollo.BaseMutationOptions<
	SubmitQuoteV2Mutation,
	SubmitQuoteV2MutationVariables
>;
export const RemixProductToStudioDocument = gql`
	mutation RemixProductToStudio($input: RemixProductToStudioInput!) {
		remixProductToStudio(input: $input) {
			success
			message
			studioFileId
		}
	}
`;
export type RemixProductToStudioMutationFn = Apollo.MutationFunction<
	RemixProductToStudioMutation,
	RemixProductToStudioMutationVariables
>;

/**
 * __useRemixProductToStudioMutation__
 *
 * To run a mutation, you first call `useRemixProductToStudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemixProductToStudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remixProductToStudioMutation, { data, loading, error }] = useRemixProductToStudioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemixProductToStudioMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemixProductToStudioMutation,
		RemixProductToStudioMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RemixProductToStudioMutation, RemixProductToStudioMutationVariables>(
		RemixProductToStudioDocument,
		options
	);
}
export type RemixProductToStudioMutationHookResult = ReturnType<
	typeof useRemixProductToStudioMutation
>;
export type RemixProductToStudioMutationResult =
	Apollo.MutationResult<RemixProductToStudioMutation>;
export type RemixProductToStudioMutationOptions = Apollo.BaseMutationOptions<
	RemixProductToStudioMutation,
	RemixProductToStudioMutationVariables
>;
export const StartSampleProductionV2Document = gql`
	mutation StartSampleProductionV2($sampleId: ID!) {
		startSampleProductionV2(sampleId: $sampleId) {
			id
			sampleChoice
			sampleRound
			status
			productionStartedAt
		}
	}
`;
export type StartSampleProductionV2MutationFn = Apollo.MutationFunction<
	StartSampleProductionV2Mutation,
	StartSampleProductionV2MutationVariables
>;

/**
 * __useStartSampleProductionV2Mutation__
 *
 * To run a mutation, you first call `useStartSampleProductionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSampleProductionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSampleProductionV2Mutation, { data, loading, error }] = useStartSampleProductionV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useStartSampleProductionV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		StartSampleProductionV2Mutation,
		StartSampleProductionV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StartSampleProductionV2Mutation,
		StartSampleProductionV2MutationVariables
	>(StartSampleProductionV2Document, options);
}
export type StartSampleProductionV2MutationHookResult = ReturnType<
	typeof useStartSampleProductionV2Mutation
>;
export type StartSampleProductionV2MutationResult =
	Apollo.MutationResult<StartSampleProductionV2Mutation>;
export type StartSampleProductionV2MutationOptions = Apollo.BaseMutationOptions<
	StartSampleProductionV2Mutation,
	StartSampleProductionV2MutationVariables
>;
export const CompleteSampleProductionV2Document = gql`
	mutation CompleteSampleProductionV2($sampleId: ID!) {
		completeSampleProductionV2(sampleId: $sampleId) {
			id
			sampleChoice
			sampleRound
			status
			productionStartedAt
			productionCompletedAt
		}
	}
`;
export type CompleteSampleProductionV2MutationFn = Apollo.MutationFunction<
	CompleteSampleProductionV2Mutation,
	CompleteSampleProductionV2MutationVariables
>;

/**
 * __useCompleteSampleProductionV2Mutation__
 *
 * To run a mutation, you first call `useCompleteSampleProductionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSampleProductionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSampleProductionV2Mutation, { data, loading, error }] = useCompleteSampleProductionV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useCompleteSampleProductionV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		CompleteSampleProductionV2Mutation,
		CompleteSampleProductionV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CompleteSampleProductionV2Mutation,
		CompleteSampleProductionV2MutationVariables
	>(CompleteSampleProductionV2Document, options);
}
export type CompleteSampleProductionV2MutationHookResult = ReturnType<
	typeof useCompleteSampleProductionV2Mutation
>;
export type CompleteSampleProductionV2MutationResult =
	Apollo.MutationResult<CompleteSampleProductionV2Mutation>;
export type CompleteSampleProductionV2MutationOptions = Apollo.BaseMutationOptions<
	CompleteSampleProductionV2Mutation,
	CompleteSampleProductionV2MutationVariables
>;
export const SubmitVirtualSampleV2Document = gql`
	mutation SubmitVirtualSampleV2($input: SubmitVirtualSampleV2Input!) {
		submitVirtualSampleV2(input: $input) {
			id
			sampleChoice
			sampleRound
			status
			deliveryMethod
			virtualDeliveryAttachments
			virtualDeliverySubmittedAt
		}
	}
`;
export type SubmitVirtualSampleV2MutationFn = Apollo.MutationFunction<
	SubmitVirtualSampleV2Mutation,
	SubmitVirtualSampleV2MutationVariables
>;

/**
 * __useSubmitVirtualSampleV2Mutation__
 *
 * To run a mutation, you first call `useSubmitVirtualSampleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVirtualSampleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVirtualSampleV2Mutation, { data, loading, error }] = useSubmitVirtualSampleV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitVirtualSampleV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubmitVirtualSampleV2Mutation,
		SubmitVirtualSampleV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SubmitVirtualSampleV2Mutation,
		SubmitVirtualSampleV2MutationVariables
	>(SubmitVirtualSampleV2Document, options);
}
export type SubmitVirtualSampleV2MutationHookResult = ReturnType<
	typeof useSubmitVirtualSampleV2Mutation
>;
export type SubmitVirtualSampleV2MutationResult =
	Apollo.MutationResult<SubmitVirtualSampleV2Mutation>;
export type SubmitVirtualSampleV2MutationOptions = Apollo.BaseMutationOptions<
	SubmitVirtualSampleV2Mutation,
	SubmitVirtualSampleV2MutationVariables
>;
export const GenerateSampleVirtualDeliveryFileUploadUrlV2Document = gql`
	mutation GenerateSampleVirtualDeliveryFileUploadUrlV2(
		$input: SampleVirtualDeliveryFileUploadV2Input!
	) {
		generateSampleVirtualDeliveryFileUploadUrlV2(input: $input) {
			success
			message
			uploadUrl
			blobUrl
			fileId
			expiresAt
		}
	}
`;
export type GenerateSampleVirtualDeliveryFileUploadUrlV2MutationFn = Apollo.MutationFunction<
	GenerateSampleVirtualDeliveryFileUploadUrlV2Mutation,
	GenerateSampleVirtualDeliveryFileUploadUrlV2MutationVariables
>;

/**
 * __useGenerateSampleVirtualDeliveryFileUploadUrlV2Mutation__
 *
 * To run a mutation, you first call `useGenerateSampleVirtualDeliveryFileUploadUrlV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSampleVirtualDeliveryFileUploadUrlV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSampleVirtualDeliveryFileUploadUrlV2Mutation, { data, loading, error }] = useGenerateSampleVirtualDeliveryFileUploadUrlV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSampleVirtualDeliveryFileUploadUrlV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateSampleVirtualDeliveryFileUploadUrlV2Mutation,
		GenerateSampleVirtualDeliveryFileUploadUrlV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateSampleVirtualDeliveryFileUploadUrlV2Mutation,
		GenerateSampleVirtualDeliveryFileUploadUrlV2MutationVariables
	>(GenerateSampleVirtualDeliveryFileUploadUrlV2Document, options);
}
export type GenerateSampleVirtualDeliveryFileUploadUrlV2MutationHookResult = ReturnType<
	typeof useGenerateSampleVirtualDeliveryFileUploadUrlV2Mutation
>;
export type GenerateSampleVirtualDeliveryFileUploadUrlV2MutationResult =
	Apollo.MutationResult<GenerateSampleVirtualDeliveryFileUploadUrlV2Mutation>;
export type GenerateSampleVirtualDeliveryFileUploadUrlV2MutationOptions =
	Apollo.BaseMutationOptions<
		GenerateSampleVirtualDeliveryFileUploadUrlV2Mutation,
		GenerateSampleVirtualDeliveryFileUploadUrlV2MutationVariables
	>;
export const ShipSampleV2Document = gql`
	mutation ShipSampleV2(
		$sampleId: ID!
		$carrier: String
		$trackingNumber: String
		$estimatedDeliveryDate: DateTime
	) {
		shipSampleV2(
			sampleId: $sampleId
			carrier: $carrier
			trackingNumber: $trackingNumber
			estimatedDeliveryDate: $estimatedDeliveryDate
		) {
			id
			sampleChoice
			sampleRound
			status
			carrier
			trackingNumber
			estimatedDeliveryDate
			shippedAt
		}
	}
`;
export type ShipSampleV2MutationFn = Apollo.MutationFunction<
	ShipSampleV2Mutation,
	ShipSampleV2MutationVariables
>;

/**
 * __useShipSampleV2Mutation__
 *
 * To run a mutation, you first call `useShipSampleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipSampleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipSampleV2Mutation, { data, loading, error }] = useShipSampleV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *      carrier: // value for 'carrier'
 *      trackingNumber: // value for 'trackingNumber'
 *      estimatedDeliveryDate: // value for 'estimatedDeliveryDate'
 *   },
 * });
 */
export function useShipSampleV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<ShipSampleV2Mutation, ShipSampleV2MutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ShipSampleV2Mutation, ShipSampleV2MutationVariables>(
		ShipSampleV2Document,
		options
	);
}
export type ShipSampleV2MutationHookResult = ReturnType<typeof useShipSampleV2Mutation>;
export type ShipSampleV2MutationResult = Apollo.MutationResult<ShipSampleV2Mutation>;
export type ShipSampleV2MutationOptions = Apollo.BaseMutationOptions<
	ShipSampleV2Mutation,
	ShipSampleV2MutationVariables
>;
export const MarkSampleDeliveredV2Document = gql`
	mutation MarkSampleDeliveredV2($sampleId: ID!) {
		markSampleDeliveredV2(sampleId: $sampleId) {
			id
			sampleChoice
			sampleRound
			status
			carrier
			trackingNumber
			estimatedDeliveryDate
			shippedAt
			actualDeliveryDate
		}
	}
`;
export type MarkSampleDeliveredV2MutationFn = Apollo.MutationFunction<
	MarkSampleDeliveredV2Mutation,
	MarkSampleDeliveredV2MutationVariables
>;

/**
 * __useMarkSampleDeliveredV2Mutation__
 *
 * To run a mutation, you first call `useMarkSampleDeliveredV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSampleDeliveredV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSampleDeliveredV2Mutation, { data, loading, error }] = useMarkSampleDeliveredV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useMarkSampleDeliveredV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkSampleDeliveredV2Mutation,
		MarkSampleDeliveredV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkSampleDeliveredV2Mutation,
		MarkSampleDeliveredV2MutationVariables
	>(MarkSampleDeliveredV2Document, options);
}
export type MarkSampleDeliveredV2MutationHookResult = ReturnType<
	typeof useMarkSampleDeliveredV2Mutation
>;
export type MarkSampleDeliveredV2MutationResult =
	Apollo.MutationResult<MarkSampleDeliveredV2Mutation>;
export type MarkSampleDeliveredV2MutationOptions = Apollo.BaseMutationOptions<
	MarkSampleDeliveredV2Mutation,
	MarkSampleDeliveredV2MutationVariables
>;
export const UpdateSampleAdminPriceV2Document = gql`
	mutation UpdateSampleAdminPriceV2(
		$input: UpdateSampleAdminPriceV2Input!
		$inCurrency: CurrencyEnum
	) {
		updateSampleAdminPriceV2(input: $input) {
			id
			adminPrice(inCurrency: $inCurrency)
			baseSamplePrice(inCurrency: $inCurrency)
			baseShippingPrice(inCurrency: $inCurrency)
			totalSamplePrice(inCurrency: $inCurrency)
		}
	}
`;
export type UpdateSampleAdminPriceV2MutationFn = Apollo.MutationFunction<
	UpdateSampleAdminPriceV2Mutation,
	UpdateSampleAdminPriceV2MutationVariables
>;

/**
 * __useUpdateSampleAdminPriceV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSampleAdminPriceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleAdminPriceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleAdminPriceV2Mutation, { data, loading, error }] = useUpdateSampleAdminPriceV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useUpdateSampleAdminPriceV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSampleAdminPriceV2Mutation,
		UpdateSampleAdminPriceV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateSampleAdminPriceV2Mutation,
		UpdateSampleAdminPriceV2MutationVariables
	>(UpdateSampleAdminPriceV2Document, options);
}
export type UpdateSampleAdminPriceV2MutationHookResult = ReturnType<
	typeof useUpdateSampleAdminPriceV2Mutation
>;
export type UpdateSampleAdminPriceV2MutationResult =
	Apollo.MutationResult<UpdateSampleAdminPriceV2Mutation>;
export type UpdateSampleAdminPriceV2MutationOptions = Apollo.BaseMutationOptions<
	UpdateSampleAdminPriceV2Mutation,
	UpdateSampleAdminPriceV2MutationVariables
>;
export const ApproveSampleV2Document = gql`
	mutation ApproveSampleV2($sampleId: ID!, $approvalNotes: String) {
		approveSampleV2(input: { sampleId: $sampleId, approvalNotes: $approvalNotes }) {
			id
			approvalNotes
			approvedAt
			approvedByUserId
			decision
		}
	}
`;
export type ApproveSampleV2MutationFn = Apollo.MutationFunction<
	ApproveSampleV2Mutation,
	ApproveSampleV2MutationVariables
>;

/**
 * __useApproveSampleV2Mutation__
 *
 * To run a mutation, you first call `useApproveSampleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSampleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSampleV2Mutation, { data, loading, error }] = useApproveSampleV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *      approvalNotes: // value for 'approvalNotes'
 *   },
 * });
 */
export function useApproveSampleV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveSampleV2Mutation,
		ApproveSampleV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ApproveSampleV2Mutation, ApproveSampleV2MutationVariables>(
		ApproveSampleV2Document,
		options
	);
}
export type ApproveSampleV2MutationHookResult = ReturnType<typeof useApproveSampleV2Mutation>;
export type ApproveSampleV2MutationResult = Apollo.MutationResult<ApproveSampleV2Mutation>;
export type ApproveSampleV2MutationOptions = Apollo.BaseMutationOptions<
	ApproveSampleV2Mutation,
	ApproveSampleV2MutationVariables
>;
export const RejectSampleV2Document = gql`
	mutation RejectSampleV2($input: RejectSampleV2Input!) {
		rejectSampleV2(input: $input) {
			id
			approvalNotes
			decision
			requestNewSample
			newSampleRequestStatus
			nextSampleChoice
			sample {
				id
				status
			}
		}
	}
`;
export type RejectSampleV2MutationFn = Apollo.MutationFunction<
	RejectSampleV2Mutation,
	RejectSampleV2MutationVariables
>;

/**
 * __useRejectSampleV2Mutation__
 *
 * To run a mutation, you first call `useRejectSampleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSampleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSampleV2Mutation, { data, loading, error }] = useRejectSampleV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectSampleV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectSampleV2Mutation,
		RejectSampleV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RejectSampleV2Mutation, RejectSampleV2MutationVariables>(
		RejectSampleV2Document,
		options
	);
}
export type RejectSampleV2MutationHookResult = ReturnType<typeof useRejectSampleV2Mutation>;
export type RejectSampleV2MutationResult = Apollo.MutationResult<RejectSampleV2Mutation>;
export type RejectSampleV2MutationOptions = Apollo.BaseMutationOptions<
	RejectSampleV2Mutation,
	RejectSampleV2MutationVariables
>;
export const ApproveNewSampleRoundV2Document = gql`
	mutation ApproveNewSampleRoundV2(
		$input: ApproveNewSampleRoundV2Input!
		$inCurrency: CurrencyEnum
	) {
		approveNewSampleRoundV2(input: $input) {
			id
			sampleRound
			sampleChoice
			deliveryMethod
			status
			paymentStatus
			adminPrice(inCurrency: $inCurrency)
			isDeductible
		}
	}
`;
export type ApproveNewSampleRoundV2MutationFn = Apollo.MutationFunction<
	ApproveNewSampleRoundV2Mutation,
	ApproveNewSampleRoundV2MutationVariables
>;

/**
 * __useApproveNewSampleRoundV2Mutation__
 *
 * To run a mutation, you first call `useApproveNewSampleRoundV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveNewSampleRoundV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveNewSampleRoundV2Mutation, { data, loading, error }] = useApproveNewSampleRoundV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useApproveNewSampleRoundV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveNewSampleRoundV2Mutation,
		ApproveNewSampleRoundV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveNewSampleRoundV2Mutation,
		ApproveNewSampleRoundV2MutationVariables
	>(ApproveNewSampleRoundV2Document, options);
}
export type ApproveNewSampleRoundV2MutationHookResult = ReturnType<
	typeof useApproveNewSampleRoundV2Mutation
>;
export type ApproveNewSampleRoundV2MutationResult =
	Apollo.MutationResult<ApproveNewSampleRoundV2Mutation>;
export type ApproveNewSampleRoundV2MutationOptions = Apollo.BaseMutationOptions<
	ApproveNewSampleRoundV2Mutation,
	ApproveNewSampleRoundV2MutationVariables
>;
export const SetSampleDeductibilityV2Document = gql`
	mutation SetSampleDeductibilityV2($sampleId: ID!, $isDeductible: Boolean!) {
		setSampleDeductibilityV2(sampleId: $sampleId, isDeductible: $isDeductible) {
			id
			isDeductible
		}
	}
`;
export type SetSampleDeductibilityV2MutationFn = Apollo.MutationFunction<
	SetSampleDeductibilityV2Mutation,
	SetSampleDeductibilityV2MutationVariables
>;

/**
 * __useSetSampleDeductibilityV2Mutation__
 *
 * To run a mutation, you first call `useSetSampleDeductibilityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSampleDeductibilityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSampleDeductibilityV2Mutation, { data, loading, error }] = useSetSampleDeductibilityV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *      isDeductible: // value for 'isDeductible'
 *   },
 * });
 */
export function useSetSampleDeductibilityV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetSampleDeductibilityV2Mutation,
		SetSampleDeductibilityV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SetSampleDeductibilityV2Mutation,
		SetSampleDeductibilityV2MutationVariables
	>(SetSampleDeductibilityV2Document, options);
}
export type SetSampleDeductibilityV2MutationHookResult = ReturnType<
	typeof useSetSampleDeductibilityV2Mutation
>;
export type SetSampleDeductibilityV2MutationResult =
	Apollo.MutationResult<SetSampleDeductibilityV2Mutation>;
export type SetSampleDeductibilityV2MutationOptions = Apollo.BaseMutationOptions<
	SetSampleDeductibilityV2Mutation,
	SetSampleDeductibilityV2MutationVariables
>;
export const WaiveSamplePaymentV2Document = gql`
	mutation WaiveSamplePaymentV2($sampleId: ID!) {
		waiveSamplePaymentV2(sampleId: $sampleId) {
			id
			paymentStatus
		}
	}
`;
export type WaiveSamplePaymentV2MutationFn = Apollo.MutationFunction<
	WaiveSamplePaymentV2Mutation,
	WaiveSamplePaymentV2MutationVariables
>;

/**
 * __useWaiveSamplePaymentV2Mutation__
 *
 * To run a mutation, you first call `useWaiveSamplePaymentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaiveSamplePaymentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waiveSamplePaymentV2Mutation, { data, loading, error }] = useWaiveSamplePaymentV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useWaiveSamplePaymentV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		WaiveSamplePaymentV2Mutation,
		WaiveSamplePaymentV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<WaiveSamplePaymentV2Mutation, WaiveSamplePaymentV2MutationVariables>(
		WaiveSamplePaymentV2Document,
		options
	);
}
export type WaiveSamplePaymentV2MutationHookResult = ReturnType<
	typeof useWaiveSamplePaymentV2Mutation
>;
export type WaiveSamplePaymentV2MutationResult =
	Apollo.MutationResult<WaiveSamplePaymentV2Mutation>;
export type WaiveSamplePaymentV2MutationOptions = Apollo.BaseMutationOptions<
	WaiveSamplePaymentV2Mutation,
	WaiveSamplePaymentV2MutationVariables
>;
export const MarkSampleInvoicePaidV2Document = gql`
	mutation MarkSampleInvoicePaidV2($sampleId: ID!, $note: String) {
		markSampleInvoicePaidV2(sampleId: $sampleId, note: $note) {
			id
			paymentStatus
		}
	}
`;
export type MarkSampleInvoicePaidV2MutationFn = Apollo.MutationFunction<
	MarkSampleInvoicePaidV2Mutation,
	MarkSampleInvoicePaidV2MutationVariables
>;

/**
 * __useMarkSampleInvoicePaidV2Mutation__
 *
 * To run a mutation, you first call `useMarkSampleInvoicePaidV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSampleInvoicePaidV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSampleInvoicePaidV2Mutation, { data, loading, error }] = useMarkSampleInvoicePaidV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useMarkSampleInvoicePaidV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		MarkSampleInvoicePaidV2Mutation,
		MarkSampleInvoicePaidV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		MarkSampleInvoicePaidV2Mutation,
		MarkSampleInvoicePaidV2MutationVariables
	>(MarkSampleInvoicePaidV2Document, options);
}
export type MarkSampleInvoicePaidV2MutationHookResult = ReturnType<
	typeof useMarkSampleInvoicePaidV2Mutation
>;
export type MarkSampleInvoicePaidV2MutationResult =
	Apollo.MutationResult<MarkSampleInvoicePaidV2Mutation>;
export type MarkSampleInvoicePaidV2MutationOptions = Apollo.BaseMutationOptions<
	MarkSampleInvoicePaidV2Mutation,
	MarkSampleInvoicePaidV2MutationVariables
>;
export const AcceptSampleAsIsV2Document = gql`
	mutation AcceptSampleAsIsV2($sampleId: ID!) {
		acceptSampleAsIsV2(sampleId: $sampleId) {
			id
			status
		}
	}
`;
export type AcceptSampleAsIsV2MutationFn = Apollo.MutationFunction<
	AcceptSampleAsIsV2Mutation,
	AcceptSampleAsIsV2MutationVariables
>;

/**
 * __useAcceptSampleAsIsV2Mutation__
 *
 * To run a mutation, you first call `useAcceptSampleAsIsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptSampleAsIsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptSampleAsIsV2Mutation, { data, loading, error }] = useAcceptSampleAsIsV2Mutation({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useAcceptSampleAsIsV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		AcceptSampleAsIsV2Mutation,
		AcceptSampleAsIsV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcceptSampleAsIsV2Mutation, AcceptSampleAsIsV2MutationVariables>(
		AcceptSampleAsIsV2Document,
		options
	);
}
export type AcceptSampleAsIsV2MutationHookResult = ReturnType<typeof useAcceptSampleAsIsV2Mutation>;
export type AcceptSampleAsIsV2MutationResult = Apollo.MutationResult<AcceptSampleAsIsV2Mutation>;
export type AcceptSampleAsIsV2MutationOptions = Apollo.BaseMutationOptions<
	AcceptSampleAsIsV2Mutation,
	AcceptSampleAsIsV2MutationVariables
>;
export const ReRequestNewSampleRoundV2Document = gql`
	mutation ReRequestNewSampleRoundV2($input: ReRequestNewSampleRoundV2Input!) {
		reRequestNewSampleRoundV2(input: $input) {
			id
			newSampleRequestStatus
			reviewHistory {
				at
				actor
				action
				notes
				userId
			}
		}
	}
`;
export type ReRequestNewSampleRoundV2MutationFn = Apollo.MutationFunction<
	ReRequestNewSampleRoundV2Mutation,
	ReRequestNewSampleRoundV2MutationVariables
>;

/**
 * __useReRequestNewSampleRoundV2Mutation__
 *
 * To run a mutation, you first call `useReRequestNewSampleRoundV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReRequestNewSampleRoundV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reRequestNewSampleRoundV2Mutation, { data, loading, error }] = useReRequestNewSampleRoundV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReRequestNewSampleRoundV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReRequestNewSampleRoundV2Mutation,
		ReRequestNewSampleRoundV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReRequestNewSampleRoundV2Mutation,
		ReRequestNewSampleRoundV2MutationVariables
	>(ReRequestNewSampleRoundV2Document, options);
}
export type ReRequestNewSampleRoundV2MutationHookResult = ReturnType<
	typeof useReRequestNewSampleRoundV2Mutation
>;
export type ReRequestNewSampleRoundV2MutationResult =
	Apollo.MutationResult<ReRequestNewSampleRoundV2Mutation>;
export type ReRequestNewSampleRoundV2MutationOptions = Apollo.BaseMutationOptions<
	ReRequestNewSampleRoundV2Mutation,
	ReRequestNewSampleRoundV2MutationVariables
>;
export const DenyNewSampleRoundV2Document = gql`
	mutation DenyNewSampleRoundV2($input: DenyNewSampleRoundV2Input!) {
		denyNewSampleRoundV2(input: $input) {
			id
			newSampleRequestStatus
			reviewedAt
			reviewedByUserId
			reviewHistory {
				at
				actor
				action
				notes
				userId
			}
		}
	}
`;
export type DenyNewSampleRoundV2MutationFn = Apollo.MutationFunction<
	DenyNewSampleRoundV2Mutation,
	DenyNewSampleRoundV2MutationVariables
>;

/**
 * __useDenyNewSampleRoundV2Mutation__
 *
 * To run a mutation, you first call `useDenyNewSampleRoundV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyNewSampleRoundV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyNewSampleRoundV2Mutation, { data, loading, error }] = useDenyNewSampleRoundV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDenyNewSampleRoundV2Mutation(
	baseOptions?: Apollo.MutationHookOptions<
		DenyNewSampleRoundV2Mutation,
		DenyNewSampleRoundV2MutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DenyNewSampleRoundV2Mutation, DenyNewSampleRoundV2MutationVariables>(
		DenyNewSampleRoundV2Document,
		options
	);
}
export type DenyNewSampleRoundV2MutationHookResult = ReturnType<
	typeof useDenyNewSampleRoundV2Mutation
>;
export type DenyNewSampleRoundV2MutationResult =
	Apollo.MutationResult<DenyNewSampleRoundV2Mutation>;
export type DenyNewSampleRoundV2MutationOptions = Apollo.BaseMutationOptions<
	DenyNewSampleRoundV2Mutation,
	DenyNewSampleRoundV2MutationVariables
>;
export const CreateSourcingPreferenceDocument = gql`
	mutation CreateSourcingPreference($input: OrganizationSourcingPreferenceCreateInput!) {
		createOrganizationSourcingPreference(input: $input) {
			id
			name
			description
		}
	}
`;
export type CreateSourcingPreferenceMutationFn = Apollo.MutationFunction<
	CreateSourcingPreferenceMutation,
	CreateSourcingPreferenceMutationVariables
>;

/**
 * __useCreateSourcingPreferenceMutation__
 *
 * To run a mutation, you first call `useCreateSourcingPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourcingPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourcingPreferenceMutation, { data, loading, error }] = useCreateSourcingPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourcingPreferenceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSourcingPreferenceMutation,
		CreateSourcingPreferenceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateSourcingPreferenceMutation,
		CreateSourcingPreferenceMutationVariables
	>(CreateSourcingPreferenceDocument, options);
}
export type CreateSourcingPreferenceMutationHookResult = ReturnType<
	typeof useCreateSourcingPreferenceMutation
>;
export type CreateSourcingPreferenceMutationResult =
	Apollo.MutationResult<CreateSourcingPreferenceMutation>;
export type CreateSourcingPreferenceMutationOptions = Apollo.BaseMutationOptions<
	CreateSourcingPreferenceMutation,
	CreateSourcingPreferenceMutationVariables
>;
export const UpdateSourcingPreferenceDocument = gql`
	mutation UpdateSourcingPreference($input: OrganizationSourcingPreferenceUpdateInput!) {
		updateOrganizationSourcingPreference(input: $input) {
			id
			name
			description
		}
	}
`;
export type UpdateSourcingPreferenceMutationFn = Apollo.MutationFunction<
	UpdateSourcingPreferenceMutation,
	UpdateSourcingPreferenceMutationVariables
>;

/**
 * __useUpdateSourcingPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingPreferenceMutation, { data, loading, error }] = useUpdateSourcingPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourcingPreferenceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSourcingPreferenceMutation,
		UpdateSourcingPreferenceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateSourcingPreferenceMutation,
		UpdateSourcingPreferenceMutationVariables
	>(UpdateSourcingPreferenceDocument, options);
}
export type UpdateSourcingPreferenceMutationHookResult = ReturnType<
	typeof useUpdateSourcingPreferenceMutation
>;
export type UpdateSourcingPreferenceMutationResult =
	Apollo.MutationResult<UpdateSourcingPreferenceMutation>;
export type UpdateSourcingPreferenceMutationOptions = Apollo.BaseMutationOptions<
	UpdateSourcingPreferenceMutation,
	UpdateSourcingPreferenceMutationVariables
>;
export const DeleteSourcingPreferenceDocument = gql`
	mutation DeleteSourcingPreference($id: ID!) {
		deleteOrganizationSourcingPreference(id: $id) {
			message
			success
		}
	}
`;
export type DeleteSourcingPreferenceMutationFn = Apollo.MutationFunction<
	DeleteSourcingPreferenceMutation,
	DeleteSourcingPreferenceMutationVariables
>;

/**
 * __useDeleteSourcingPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteSourcingPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourcingPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourcingPreferenceMutation, { data, loading, error }] = useDeleteSourcingPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSourcingPreferenceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteSourcingPreferenceMutation,
		DeleteSourcingPreferenceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteSourcingPreferenceMutation,
		DeleteSourcingPreferenceMutationVariables
	>(DeleteSourcingPreferenceDocument, options);
}
export type DeleteSourcingPreferenceMutationHookResult = ReturnType<
	typeof useDeleteSourcingPreferenceMutation
>;
export type DeleteSourcingPreferenceMutationResult =
	Apollo.MutationResult<DeleteSourcingPreferenceMutation>;
export type DeleteSourcingPreferenceMutationOptions = Apollo.BaseMutationOptions<
	DeleteSourcingPreferenceMutation,
	DeleteSourcingPreferenceMutationVariables
>;
export const DeleteSourcingPreferencesDocument = gql`
	mutation DeleteSourcingPreferences($input: DeleteManyInput!) {
		deleteOrganizationSourcingPreferences(input: $input) {
			message
			success
		}
	}
`;
export type DeleteSourcingPreferencesMutationFn = Apollo.MutationFunction<
	DeleteSourcingPreferencesMutation,
	DeleteSourcingPreferencesMutationVariables
>;

/**
 * __useDeleteSourcingPreferencesMutation__
 *
 * To run a mutation, you first call `useDeleteSourcingPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourcingPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourcingPreferencesMutation, { data, loading, error }] = useDeleteSourcingPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSourcingPreferencesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteSourcingPreferencesMutation,
		DeleteSourcingPreferencesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteSourcingPreferencesMutation,
		DeleteSourcingPreferencesMutationVariables
	>(DeleteSourcingPreferencesDocument, options);
}
export type DeleteSourcingPreferencesMutationHookResult = ReturnType<
	typeof useDeleteSourcingPreferencesMutation
>;
export type DeleteSourcingPreferencesMutationResult =
	Apollo.MutationResult<DeleteSourcingPreferencesMutation>;
export type DeleteSourcingPreferencesMutationOptions = Apollo.BaseMutationOptions<
	DeleteSourcingPreferencesMutation,
	DeleteSourcingPreferencesMutationVariables
>;
export const CreateSourcingPreferenceConnectionDocument = gql`
	mutation CreateSourcingPreferenceConnection(
		$input: OrganizationSourcingPreferenceConnectionCreateInput!
	) {
		createOrganizationSourcingPreferenceConnection(input: $input) {
			id
			organizationId
			organizationSourcingPreferenceId
			priority
			notes
		}
	}
`;
export type CreateSourcingPreferenceConnectionMutationFn = Apollo.MutationFunction<
	CreateSourcingPreferenceConnectionMutation,
	CreateSourcingPreferenceConnectionMutationVariables
>;

/**
 * __useCreateSourcingPreferenceConnectionMutation__
 *
 * To run a mutation, you first call `useCreateSourcingPreferenceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourcingPreferenceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourcingPreferenceConnectionMutation, { data, loading, error }] = useCreateSourcingPreferenceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourcingPreferenceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSourcingPreferenceConnectionMutation,
		CreateSourcingPreferenceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateSourcingPreferenceConnectionMutation,
		CreateSourcingPreferenceConnectionMutationVariables
	>(CreateSourcingPreferenceConnectionDocument, options);
}
export type CreateSourcingPreferenceConnectionMutationHookResult = ReturnType<
	typeof useCreateSourcingPreferenceConnectionMutation
>;
export type CreateSourcingPreferenceConnectionMutationResult =
	Apollo.MutationResult<CreateSourcingPreferenceConnectionMutation>;
export type CreateSourcingPreferenceConnectionMutationOptions = Apollo.BaseMutationOptions<
	CreateSourcingPreferenceConnectionMutation,
	CreateSourcingPreferenceConnectionMutationVariables
>;
export const UpdateSourcingPreferenceConnectionDocument = gql`
	mutation UpdateSourcingPreferenceConnection(
		$input: OrganizationSourcingPreferenceConnectionUpdateInput!
	) {
		updateOrganizationSourcingPreferenceConnection(input: $input) {
			id
			priority
			notes
		}
	}
`;
export type UpdateSourcingPreferenceConnectionMutationFn = Apollo.MutationFunction<
	UpdateSourcingPreferenceConnectionMutation,
	UpdateSourcingPreferenceConnectionMutationVariables
>;

/**
 * __useUpdateSourcingPreferenceConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingPreferenceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingPreferenceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingPreferenceConnectionMutation, { data, loading, error }] = useUpdateSourcingPreferenceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourcingPreferenceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSourcingPreferenceConnectionMutation,
		UpdateSourcingPreferenceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateSourcingPreferenceConnectionMutation,
		UpdateSourcingPreferenceConnectionMutationVariables
	>(UpdateSourcingPreferenceConnectionDocument, options);
}
export type UpdateSourcingPreferenceConnectionMutationHookResult = ReturnType<
	typeof useUpdateSourcingPreferenceConnectionMutation
>;
export type UpdateSourcingPreferenceConnectionMutationResult =
	Apollo.MutationResult<UpdateSourcingPreferenceConnectionMutation>;
export type UpdateSourcingPreferenceConnectionMutationOptions = Apollo.BaseMutationOptions<
	UpdateSourcingPreferenceConnectionMutation,
	UpdateSourcingPreferenceConnectionMutationVariables
>;
export const DeleteSourcingPreferenceConnectionDocument = gql`
	mutation DeleteSourcingPreferenceConnection($id: ID!) {
		deleteOrganizationSourcingPreferenceConnection(id: $id) {
			message
			success
		}
	}
`;
export type DeleteSourcingPreferenceConnectionMutationFn = Apollo.MutationFunction<
	DeleteSourcingPreferenceConnectionMutation,
	DeleteSourcingPreferenceConnectionMutationVariables
>;

/**
 * __useDeleteSourcingPreferenceConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteSourcingPreferenceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourcingPreferenceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourcingPreferenceConnectionMutation, { data, loading, error }] = useDeleteSourcingPreferenceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSourcingPreferenceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteSourcingPreferenceConnectionMutation,
		DeleteSourcingPreferenceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteSourcingPreferenceConnectionMutation,
		DeleteSourcingPreferenceConnectionMutationVariables
	>(DeleteSourcingPreferenceConnectionDocument, options);
}
export type DeleteSourcingPreferenceConnectionMutationHookResult = ReturnType<
	typeof useDeleteSourcingPreferenceConnectionMutation
>;
export type DeleteSourcingPreferenceConnectionMutationResult =
	Apollo.MutationResult<DeleteSourcingPreferenceConnectionMutation>;
export type DeleteSourcingPreferenceConnectionMutationOptions = Apollo.BaseMutationOptions<
	DeleteSourcingPreferenceConnectionMutation,
	DeleteSourcingPreferenceConnectionMutationVariables
>;
export const CreateProductInterestDocument = gql`
	mutation CreateProductInterest($input: OrganizationProductInterestCreateInput!) {
		createOrganizationProductInterest(input: $input) {
			id
			organizationId
			productTagId
		}
	}
`;
export type CreateProductInterestMutationFn = Apollo.MutationFunction<
	CreateProductInterestMutation,
	CreateProductInterestMutationVariables
>;

/**
 * __useCreateProductInterestMutation__
 *
 * To run a mutation, you first call `useCreateProductInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductInterestMutation, { data, loading, error }] = useCreateProductInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductInterestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProductInterestMutation,
		CreateProductInterestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateProductInterestMutation,
		CreateProductInterestMutationVariables
	>(CreateProductInterestDocument, options);
}
export type CreateProductInterestMutationHookResult = ReturnType<
	typeof useCreateProductInterestMutation
>;
export type CreateProductInterestMutationResult =
	Apollo.MutationResult<CreateProductInterestMutation>;
export type CreateProductInterestMutationOptions = Apollo.BaseMutationOptions<
	CreateProductInterestMutation,
	CreateProductInterestMutationVariables
>;
export const UpdateProductInterestDocument = gql`
	mutation UpdateProductInterest($input: OrganizationProductInterestUpdateInput!) {
		updateOrganizationProductInterest(input: $input) {
			id
		}
	}
`;
export type UpdateProductInterestMutationFn = Apollo.MutationFunction<
	UpdateProductInterestMutation,
	UpdateProductInterestMutationVariables
>;

/**
 * __useUpdateProductInterestMutation__
 *
 * To run a mutation, you first call `useUpdateProductInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductInterestMutation, { data, loading, error }] = useUpdateProductInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductInterestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateProductInterestMutation,
		UpdateProductInterestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateProductInterestMutation,
		UpdateProductInterestMutationVariables
	>(UpdateProductInterestDocument, options);
}
export type UpdateProductInterestMutationHookResult = ReturnType<
	typeof useUpdateProductInterestMutation
>;
export type UpdateProductInterestMutationResult =
	Apollo.MutationResult<UpdateProductInterestMutation>;
export type UpdateProductInterestMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductInterestMutation,
	UpdateProductInterestMutationVariables
>;
export const DeleteProductInterestDocument = gql`
	mutation DeleteProductInterest($id: ID!) {
		deleteOrganizationProductInterest(id: $id) {
			message
			success
		}
	}
`;
export type DeleteProductInterestMutationFn = Apollo.MutationFunction<
	DeleteProductInterestMutation,
	DeleteProductInterestMutationVariables
>;

/**
 * __useDeleteProductInterestMutation__
 *
 * To run a mutation, you first call `useDeleteProductInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductInterestMutation, { data, loading, error }] = useDeleteProductInterestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductInterestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductInterestMutation,
		DeleteProductInterestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteProductInterestMutation,
		DeleteProductInterestMutationVariables
	>(DeleteProductInterestDocument, options);
}
export type DeleteProductInterestMutationHookResult = ReturnType<
	typeof useDeleteProductInterestMutation
>;
export type DeleteProductInterestMutationResult =
	Apollo.MutationResult<DeleteProductInterestMutation>;
export type DeleteProductInterestMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductInterestMutation,
	DeleteProductInterestMutationVariables
>;
export const DeleteProductInterestsDocument = gql`
	mutation DeleteProductInterests($input: DeleteManyInput!) {
		deleteOrganizationProductInterests(input: $input) {
			message
			success
		}
	}
`;
export type DeleteProductInterestsMutationFn = Apollo.MutationFunction<
	DeleteProductInterestsMutation,
	DeleteProductInterestsMutationVariables
>;

/**
 * __useDeleteProductInterestsMutation__
 *
 * To run a mutation, you first call `useDeleteProductInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductInterestsMutation, { data, loading, error }] = useDeleteProductInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductInterestsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductInterestsMutation,
		DeleteProductInterestsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteProductInterestsMutation,
		DeleteProductInterestsMutationVariables
	>(DeleteProductInterestsDocument, options);
}
export type DeleteProductInterestsMutationHookResult = ReturnType<
	typeof useDeleteProductInterestsMutation
>;
export type DeleteProductInterestsMutationResult =
	Apollo.MutationResult<DeleteProductInterestsMutation>;
export type DeleteProductInterestsMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductInterestsMutation,
	DeleteProductInterestsMutationVariables
>;
export const CreateComplianceOptionDocument = gql`
	mutation CreateComplianceOption($input: OrganizationComplianceCreateInput!) {
		createOrganizationCompliance(input: $input) {
			id
			name
			description
		}
	}
`;
export type CreateComplianceOptionMutationFn = Apollo.MutationFunction<
	CreateComplianceOptionMutation,
	CreateComplianceOptionMutationVariables
>;

/**
 * __useCreateComplianceOptionMutation__
 *
 * To run a mutation, you first call `useCreateComplianceOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceOptionMutation, { data, loading, error }] = useCreateComplianceOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplianceOptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateComplianceOptionMutation,
		CreateComplianceOptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateComplianceOptionMutation,
		CreateComplianceOptionMutationVariables
	>(CreateComplianceOptionDocument, options);
}
export type CreateComplianceOptionMutationHookResult = ReturnType<
	typeof useCreateComplianceOptionMutation
>;
export type CreateComplianceOptionMutationResult =
	Apollo.MutationResult<CreateComplianceOptionMutation>;
export type CreateComplianceOptionMutationOptions = Apollo.BaseMutationOptions<
	CreateComplianceOptionMutation,
	CreateComplianceOptionMutationVariables
>;
export const UpdateComplianceOptionDocument = gql`
	mutation UpdateComplianceOption($input: OrganizationComplianceUpdateInput!) {
		updateOrganizationCompliance(input: $input) {
			id
			name
			description
		}
	}
`;
export type UpdateComplianceOptionMutationFn = Apollo.MutationFunction<
	UpdateComplianceOptionMutation,
	UpdateComplianceOptionMutationVariables
>;

/**
 * __useUpdateComplianceOptionMutation__
 *
 * To run a mutation, you first call `useUpdateComplianceOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComplianceOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComplianceOptionMutation, { data, loading, error }] = useUpdateComplianceOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateComplianceOptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateComplianceOptionMutation,
		UpdateComplianceOptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateComplianceOptionMutation,
		UpdateComplianceOptionMutationVariables
	>(UpdateComplianceOptionDocument, options);
}
export type UpdateComplianceOptionMutationHookResult = ReturnType<
	typeof useUpdateComplianceOptionMutation
>;
export type UpdateComplianceOptionMutationResult =
	Apollo.MutationResult<UpdateComplianceOptionMutation>;
export type UpdateComplianceOptionMutationOptions = Apollo.BaseMutationOptions<
	UpdateComplianceOptionMutation,
	UpdateComplianceOptionMutationVariables
>;
export const DeleteComplianceOptionDocument = gql`
	mutation DeleteComplianceOption($id: ID!) {
		deleteOrganizationCompliance(id: $id) {
			message
			success
		}
	}
`;
export type DeleteComplianceOptionMutationFn = Apollo.MutationFunction<
	DeleteComplianceOptionMutation,
	DeleteComplianceOptionMutationVariables
>;

/**
 * __useDeleteComplianceOptionMutation__
 *
 * To run a mutation, you first call `useDeleteComplianceOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComplianceOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComplianceOptionMutation, { data, loading, error }] = useDeleteComplianceOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteComplianceOptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteComplianceOptionMutation,
		DeleteComplianceOptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteComplianceOptionMutation,
		DeleteComplianceOptionMutationVariables
	>(DeleteComplianceOptionDocument, options);
}
export type DeleteComplianceOptionMutationHookResult = ReturnType<
	typeof useDeleteComplianceOptionMutation
>;
export type DeleteComplianceOptionMutationResult =
	Apollo.MutationResult<DeleteComplianceOptionMutation>;
export type DeleteComplianceOptionMutationOptions = Apollo.BaseMutationOptions<
	DeleteComplianceOptionMutation,
	DeleteComplianceOptionMutationVariables
>;
export const DeleteComplianceOptionsDocument = gql`
	mutation DeleteComplianceOptions($input: DeleteManyInput!) {
		deleteOrganizationCompliances(input: $input) {
			message
			success
		}
	}
`;
export type DeleteComplianceOptionsMutationFn = Apollo.MutationFunction<
	DeleteComplianceOptionsMutation,
	DeleteComplianceOptionsMutationVariables
>;

/**
 * __useDeleteComplianceOptionsMutation__
 *
 * To run a mutation, you first call `useDeleteComplianceOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComplianceOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComplianceOptionsMutation, { data, loading, error }] = useDeleteComplianceOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteComplianceOptionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteComplianceOptionsMutation,
		DeleteComplianceOptionsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteComplianceOptionsMutation,
		DeleteComplianceOptionsMutationVariables
	>(DeleteComplianceOptionsDocument, options);
}
export type DeleteComplianceOptionsMutationHookResult = ReturnType<
	typeof useDeleteComplianceOptionsMutation
>;
export type DeleteComplianceOptionsMutationResult =
	Apollo.MutationResult<DeleteComplianceOptionsMutation>;
export type DeleteComplianceOptionsMutationOptions = Apollo.BaseMutationOptions<
	DeleteComplianceOptionsMutation,
	DeleteComplianceOptionsMutationVariables
>;
export const CreateComplianceConnectionDocument = gql`
	mutation CreateComplianceConnection($input: OrganizationComplianceConnectionCreateInput!) {
		createOrganizationComplianceConnection(input: $input) {
			id
			organizationId
			organizationComplianceId
			certificationNumber
			issueDate
			expiryDate
			certifyingBody
		}
	}
`;
export type CreateComplianceConnectionMutationFn = Apollo.MutationFunction<
	CreateComplianceConnectionMutation,
	CreateComplianceConnectionMutationVariables
>;

/**
 * __useCreateComplianceConnectionMutation__
 *
 * To run a mutation, you first call `useCreateComplianceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceConnectionMutation, { data, loading, error }] = useCreateComplianceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplianceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateComplianceConnectionMutation,
		CreateComplianceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateComplianceConnectionMutation,
		CreateComplianceConnectionMutationVariables
	>(CreateComplianceConnectionDocument, options);
}
export type CreateComplianceConnectionMutationHookResult = ReturnType<
	typeof useCreateComplianceConnectionMutation
>;
export type CreateComplianceConnectionMutationResult =
	Apollo.MutationResult<CreateComplianceConnectionMutation>;
export type CreateComplianceConnectionMutationOptions = Apollo.BaseMutationOptions<
	CreateComplianceConnectionMutation,
	CreateComplianceConnectionMutationVariables
>;
export const UpdateComplianceConnectionDocument = gql`
	mutation UpdateComplianceConnection($input: OrganizationComplianceConnectionUpdateInput!) {
		updateOrganizationComplianceConnection(input: $input) {
			id
			certificationNumber
			issueDate
			expiryDate
			certifyingBody
		}
	}
`;
export type UpdateComplianceConnectionMutationFn = Apollo.MutationFunction<
	UpdateComplianceConnectionMutation,
	UpdateComplianceConnectionMutationVariables
>;

/**
 * __useUpdateComplianceConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateComplianceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComplianceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComplianceConnectionMutation, { data, loading, error }] = useUpdateComplianceConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateComplianceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateComplianceConnectionMutation,
		UpdateComplianceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateComplianceConnectionMutation,
		UpdateComplianceConnectionMutationVariables
	>(UpdateComplianceConnectionDocument, options);
}
export type UpdateComplianceConnectionMutationHookResult = ReturnType<
	typeof useUpdateComplianceConnectionMutation
>;
export type UpdateComplianceConnectionMutationResult =
	Apollo.MutationResult<UpdateComplianceConnectionMutation>;
export type UpdateComplianceConnectionMutationOptions = Apollo.BaseMutationOptions<
	UpdateComplianceConnectionMutation,
	UpdateComplianceConnectionMutationVariables
>;
export const DeleteComplianceConnectionDocument = gql`
	mutation DeleteComplianceConnection($id: ID!) {
		deleteOrganizationComplianceConnection(id: $id) {
			message
			success
		}
	}
`;
export type DeleteComplianceConnectionMutationFn = Apollo.MutationFunction<
	DeleteComplianceConnectionMutation,
	DeleteComplianceConnectionMutationVariables
>;

/**
 * __useDeleteComplianceConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteComplianceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComplianceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComplianceConnectionMutation, { data, loading, error }] = useDeleteComplianceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteComplianceConnectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteComplianceConnectionMutation,
		DeleteComplianceConnectionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteComplianceConnectionMutation,
		DeleteComplianceConnectionMutationVariables
	>(DeleteComplianceConnectionDocument, options);
}
export type DeleteComplianceConnectionMutationHookResult = ReturnType<
	typeof useDeleteComplianceConnectionMutation
>;
export type DeleteComplianceConnectionMutationResult =
	Apollo.MutationResult<DeleteComplianceConnectionMutation>;
export type DeleteComplianceConnectionMutationOptions = Apollo.BaseMutationOptions<
	DeleteComplianceConnectionMutation,
	DeleteComplianceConnectionMutationVariables
>;
export const CreateProductTagDocument = gql`
	mutation CreateProductTag($input: ProductTagCreateInput!) {
		createProductTag(input: $input) {
			message
			success
		}
	}
`;
export type CreateProductTagMutationFn = Apollo.MutationFunction<
	CreateProductTagMutation,
	CreateProductTagMutationVariables
>;

/**
 * __useCreateProductTagMutation__
 *
 * To run a mutation, you first call `useCreateProductTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductTagMutation, { data, loading, error }] = useCreateProductTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductTagMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProductTagMutation,
		CreateProductTagMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateProductTagMutation, CreateProductTagMutationVariables>(
		CreateProductTagDocument,
		options
	);
}
export type CreateProductTagMutationHookResult = ReturnType<typeof useCreateProductTagMutation>;
export type CreateProductTagMutationResult = Apollo.MutationResult<CreateProductTagMutation>;
export type CreateProductTagMutationOptions = Apollo.BaseMutationOptions<
	CreateProductTagMutation,
	CreateProductTagMutationVariables
>;
export const UpdateProductTagDocument = gql`
	mutation UpdateProductTag($input: ProductTagUpdateInput!) {
		updateProductTag(input: $input) {
			message
			success
		}
	}
`;
export type UpdateProductTagMutationFn = Apollo.MutationFunction<
	UpdateProductTagMutation,
	UpdateProductTagMutationVariables
>;

/**
 * __useUpdateProductTagMutation__
 *
 * To run a mutation, you first call `useUpdateProductTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductTagMutation, { data, loading, error }] = useUpdateProductTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductTagMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateProductTagMutation,
		UpdateProductTagMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateProductTagMutation, UpdateProductTagMutationVariables>(
		UpdateProductTagDocument,
		options
	);
}
export type UpdateProductTagMutationHookResult = ReturnType<typeof useUpdateProductTagMutation>;
export type UpdateProductTagMutationResult = Apollo.MutationResult<UpdateProductTagMutation>;
export type UpdateProductTagMutationOptions = Apollo.BaseMutationOptions<
	UpdateProductTagMutation,
	UpdateProductTagMutationVariables
>;
export const DeleteProductTagDocument = gql`
	mutation DeleteProductTag($input: DeleteInput!) {
		deleteProductTag(input: $input) {
			message
			success
		}
	}
`;
export type DeleteProductTagMutationFn = Apollo.MutationFunction<
	DeleteProductTagMutation,
	DeleteProductTagMutationVariables
>;

/**
 * __useDeleteProductTagMutation__
 *
 * To run a mutation, you first call `useDeleteProductTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTagMutation, { data, loading, error }] = useDeleteProductTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductTagMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductTagMutation,
		DeleteProductTagMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductTagMutation, DeleteProductTagMutationVariables>(
		DeleteProductTagDocument,
		options
	);
}
export type DeleteProductTagMutationHookResult = ReturnType<typeof useDeleteProductTagMutation>;
export type DeleteProductTagMutationResult = Apollo.MutationResult<DeleteProductTagMutation>;
export type DeleteProductTagMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductTagMutation,
	DeleteProductTagMutationVariables
>;
export const DeleteProductTagsDocument = gql`
	mutation DeleteProductTags($input: DeleteManyInput!) {
		deleteProductTags(input: $input) {
			message
			success
		}
	}
`;
export type DeleteProductTagsMutationFn = Apollo.MutationFunction<
	DeleteProductTagsMutation,
	DeleteProductTagsMutationVariables
>;

/**
 * __useDeleteProductTagsMutation__
 *
 * To run a mutation, you first call `useDeleteProductTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTagsMutation, { data, loading, error }] = useDeleteProductTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductTagsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteProductTagsMutation,
		DeleteProductTagsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteProductTagsMutation, DeleteProductTagsMutationVariables>(
		DeleteProductTagsDocument,
		options
	);
}
export type DeleteProductTagsMutationHookResult = ReturnType<typeof useDeleteProductTagsMutation>;
export type DeleteProductTagsMutationResult = Apollo.MutationResult<DeleteProductTagsMutation>;
export type DeleteProductTagsMutationOptions = Apollo.BaseMutationOptions<
	DeleteProductTagsMutation,
	DeleteProductTagsMutationVariables
>;
export const SendChatMessageDocument = gql`
	mutation SendChatMessage($input: SendChatMessageInput!) {
		sendChatMessage(input: $input) {
			message {
				id
				content
				role
				createdAt
				referenceImages
				maskImage
				maskImagePreview
				updatedAt
				studioFileId
			}
			versionCreated
			toolsUsed
		}
	}
`;
export type SendChatMessageMutationFn = Apollo.MutationFunction<
	SendChatMessageMutation,
	SendChatMessageMutationVariables
>;

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMessageMutation, { data, loading, error }] = useSendChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendChatMessageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendChatMessageMutation,
		SendChatMessageMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendChatMessageMutation, SendChatMessageMutationVariables>(
		SendChatMessageDocument,
		options
	);
}
export type SendChatMessageMutationHookResult = ReturnType<typeof useSendChatMessageMutation>;
export type SendChatMessageMutationResult = Apollo.MutationResult<SendChatMessageMutation>;
export type SendChatMessageMutationOptions = Apollo.BaseMutationOptions<
	SendChatMessageMutation,
	SendChatMessageMutationVariables
>;
export const GenerateChatAttachmentUploadUrlDocument = gql`
	mutation GenerateChatAttachmentUploadUrl($input: ChatAttachmentUploadInput!) {
		generateChatAttachmentUploadUrl(input: $input) {
			uploadUrl
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateChatAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateChatAttachmentUploadUrlMutation,
	GenerateChatAttachmentUploadUrlMutationVariables
>;

/**
 * __useGenerateChatAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateChatAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateChatAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateChatAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateChatAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateChatAttachmentUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateChatAttachmentUploadUrlMutation,
		GenerateChatAttachmentUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateChatAttachmentUploadUrlMutation,
		GenerateChatAttachmentUploadUrlMutationVariables
	>(GenerateChatAttachmentUploadUrlDocument, options);
}
export type GenerateChatAttachmentUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateChatAttachmentUploadUrlMutation
>;
export type GenerateChatAttachmentUploadUrlMutationResult =
	Apollo.MutationResult<GenerateChatAttachmentUploadUrlMutation>;
export type GenerateChatAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateChatAttachmentUploadUrlMutation,
	GenerateChatAttachmentUploadUrlMutationVariables
>;
export const CreateStudioFileDocument = gql`
	mutation CreateStudioFile($input: StudioFileCreateInput!) {
		createStudioFile(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateStudioFileMutationFn = Apollo.MutationFunction<
	CreateStudioFileMutation,
	CreateStudioFileMutationVariables
>;

/**
 * __useCreateStudioFileMutation__
 *
 * To run a mutation, you first call `useCreateStudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudioFileMutation, { data, loading, error }] = useCreateStudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudioFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateStudioFileMutation,
		CreateStudioFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateStudioFileMutation, CreateStudioFileMutationVariables>(
		CreateStudioFileDocument,
		options
	);
}
export type CreateStudioFileMutationHookResult = ReturnType<typeof useCreateStudioFileMutation>;
export type CreateStudioFileMutationResult = Apollo.MutationResult<CreateStudioFileMutation>;
export type CreateStudioFileMutationOptions = Apollo.BaseMutationOptions<
	CreateStudioFileMutation,
	CreateStudioFileMutationVariables
>;
export const CreateStudioFileVersionDocument = gql`
	mutation CreateStudioFileVersion($input: CreateStudioFileVersionInput!) {
		createStudioFileVersion(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateStudioFileVersionMutationFn = Apollo.MutationFunction<
	CreateStudioFileVersionMutation,
	CreateStudioFileVersionMutationVariables
>;

/**
 * __useCreateStudioFileVersionMutation__
 *
 * To run a mutation, you first call `useCreateStudioFileVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudioFileVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudioFileVersionMutation, { data, loading, error }] = useCreateStudioFileVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudioFileVersionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateStudioFileVersionMutation,
		CreateStudioFileVersionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateStudioFileVersionMutation,
		CreateStudioFileVersionMutationVariables
	>(CreateStudioFileVersionDocument, options);
}
export type CreateStudioFileVersionMutationHookResult = ReturnType<
	typeof useCreateStudioFileVersionMutation
>;
export type CreateStudioFileVersionMutationResult =
	Apollo.MutationResult<CreateStudioFileVersionMutation>;
export type CreateStudioFileVersionMutationOptions = Apollo.BaseMutationOptions<
	CreateStudioFileVersionMutation,
	CreateStudioFileVersionMutationVariables
>;
export const DeleteStudioFileDocument = gql`
	mutation DeleteStudioFile($input: DeleteInput!) {
		deleteStudioFile(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteStudioFileMutationFn = Apollo.MutationFunction<
	DeleteStudioFileMutation,
	DeleteStudioFileMutationVariables
>;

/**
 * __useDeleteStudioFileMutation__
 *
 * To run a mutation, you first call `useDeleteStudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudioFileMutation, { data, loading, error }] = useDeleteStudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStudioFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteStudioFileMutation,
		DeleteStudioFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteStudioFileMutation, DeleteStudioFileMutationVariables>(
		DeleteStudioFileDocument,
		options
	);
}
export type DeleteStudioFileMutationHookResult = ReturnType<typeof useDeleteStudioFileMutation>;
export type DeleteStudioFileMutationResult = Apollo.MutationResult<DeleteStudioFileMutation>;
export type DeleteStudioFileMutationOptions = Apollo.BaseMutationOptions<
	DeleteStudioFileMutation,
	DeleteStudioFileMutationVariables
>;
export const UpdateStudioFileDocument = gql`
	mutation UpdateStudioFile($input: StudioFileUpdateInput!) {
		updateStudioFile(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateStudioFileMutationFn = Apollo.MutationFunction<
	UpdateStudioFileMutation,
	UpdateStudioFileMutationVariables
>;

/**
 * __useUpdateStudioFileMutation__
 *
 * To run a mutation, you first call `useUpdateStudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudioFileMutation, { data, loading, error }] = useUpdateStudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudioFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateStudioFileMutation,
		UpdateStudioFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateStudioFileMutation, UpdateStudioFileMutationVariables>(
		UpdateStudioFileDocument,
		options
	);
}
export type UpdateStudioFileMutationHookResult = ReturnType<typeof useUpdateStudioFileMutation>;
export type UpdateStudioFileMutationResult = Apollo.MutationResult<UpdateStudioFileMutation>;
export type UpdateStudioFileMutationOptions = Apollo.BaseMutationOptions<
	UpdateStudioFileMutation,
	UpdateStudioFileMutationVariables
>;
export const AddStudioFileVersionMetadataDocument = gql`
	mutation AddStudioFileVersionMetadata(
		$studioFileVersionId: ID!
		$input: AddStudioFileVersionMetadataInput!
	) {
		addStudioFileVersionMetadata(studioFileVersionId: $studioFileVersionId, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AddStudioFileVersionMetadataMutationFn = Apollo.MutationFunction<
	AddStudioFileVersionMetadataMutation,
	AddStudioFileVersionMetadataMutationVariables
>;

/**
 * __useAddStudioFileVersionMetadataMutation__
 *
 * To run a mutation, you first call `useAddStudioFileVersionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudioFileVersionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudioFileVersionMetadataMutation, { data, loading, error }] = useAddStudioFileVersionMetadataMutation({
 *   variables: {
 *      studioFileVersionId: // value for 'studioFileVersionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStudioFileVersionMetadataMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddStudioFileVersionMetadataMutation,
		AddStudioFileVersionMetadataMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AddStudioFileVersionMetadataMutation,
		AddStudioFileVersionMetadataMutationVariables
	>(AddStudioFileVersionMetadataDocument, options);
}
export type AddStudioFileVersionMetadataMutationHookResult = ReturnType<
	typeof useAddStudioFileVersionMetadataMutation
>;
export type AddStudioFileVersionMetadataMutationResult =
	Apollo.MutationResult<AddStudioFileVersionMetadataMutation>;
export type AddStudioFileVersionMetadataMutationOptions = Apollo.BaseMutationOptions<
	AddStudioFileVersionMetadataMutation,
	AddStudioFileVersionMetadataMutationVariables
>;
export const DeleteStudioFileVersionMetadataDocument = gql`
	mutation DeleteStudioFileVersionMetadata($metadataId: ID!) {
		deleteStudioFileVersionMetadata(metadataId: $metadataId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteStudioFileVersionMetadataMutationFn = Apollo.MutationFunction<
	DeleteStudioFileVersionMetadataMutation,
	DeleteStudioFileVersionMetadataMutationVariables
>;

/**
 * __useDeleteStudioFileVersionMetadataMutation__
 *
 * To run a mutation, you first call `useDeleteStudioFileVersionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudioFileVersionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudioFileVersionMetadataMutation, { data, loading, error }] = useDeleteStudioFileVersionMetadataMutation({
 *   variables: {
 *      metadataId: // value for 'metadataId'
 *   },
 * });
 */
export function useDeleteStudioFileVersionMetadataMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteStudioFileVersionMetadataMutation,
		DeleteStudioFileVersionMetadataMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteStudioFileVersionMetadataMutation,
		DeleteStudioFileVersionMetadataMutationVariables
	>(DeleteStudioFileVersionMetadataDocument, options);
}
export type DeleteStudioFileVersionMetadataMutationHookResult = ReturnType<
	typeof useDeleteStudioFileVersionMetadataMutation
>;
export type DeleteStudioFileVersionMetadataMutationResult =
	Apollo.MutationResult<DeleteStudioFileVersionMetadataMutation>;
export type DeleteStudioFileVersionMetadataMutationOptions = Apollo.BaseMutationOptions<
	DeleteStudioFileVersionMetadataMutation,
	DeleteStudioFileVersionMetadataMutationVariables
>;
export const UpdateStudioFileVersionMetadataDocument = gql`
	mutation UpdateStudioFileVersionMetadata(
		$metadataId: ID!
		$input: UpdateStudioFileVersionMetadataInput!
	) {
		updateStudioFileVersionMetadata(metadataId: $metadataId, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateStudioFileVersionMetadataMutationFn = Apollo.MutationFunction<
	UpdateStudioFileVersionMetadataMutation,
	UpdateStudioFileVersionMetadataMutationVariables
>;

/**
 * __useUpdateStudioFileVersionMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateStudioFileVersionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudioFileVersionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudioFileVersionMetadataMutation, { data, loading, error }] = useUpdateStudioFileVersionMetadataMutation({
 *   variables: {
 *      metadataId: // value for 'metadataId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudioFileVersionMetadataMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateStudioFileVersionMetadataMutation,
		UpdateStudioFileVersionMetadataMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateStudioFileVersionMetadataMutation,
		UpdateStudioFileVersionMetadataMutationVariables
	>(UpdateStudioFileVersionMetadataDocument, options);
}
export type UpdateStudioFileVersionMetadataMutationHookResult = ReturnType<
	typeof useUpdateStudioFileVersionMetadataMutation
>;
export type UpdateStudioFileVersionMetadataMutationResult =
	Apollo.MutationResult<UpdateStudioFileVersionMetadataMutation>;
export type UpdateStudioFileVersionMetadataMutationOptions = Apollo.BaseMutationOptions<
	UpdateStudioFileVersionMetadataMutation,
	UpdateStudioFileVersionMetadataMutationVariables
>;
export const CreateProductFromStudioFileDocument = gql`
	mutation CreateProductFromStudioFile($input: CreateProductFromStudioInput!) {
		createProductFromStudioFile(input: $input) {
			success
			message
			productId
		}
	}
`;
export type CreateProductFromStudioFileMutationFn = Apollo.MutationFunction<
	CreateProductFromStudioFileMutation,
	CreateProductFromStudioFileMutationVariables
>;

/**
 * __useCreateProductFromStudioFileMutation__
 *
 * To run a mutation, you first call `useCreateProductFromStudioFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductFromStudioFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductFromStudioFileMutation, { data, loading, error }] = useCreateProductFromStudioFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductFromStudioFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateProductFromStudioFileMutation,
		CreateProductFromStudioFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateProductFromStudioFileMutation,
		CreateProductFromStudioFileMutationVariables
	>(CreateProductFromStudioFileDocument, options);
}
export type CreateProductFromStudioFileMutationHookResult = ReturnType<
	typeof useCreateProductFromStudioFileMutation
>;
export type CreateProductFromStudioFileMutationResult =
	Apollo.MutationResult<CreateProductFromStudioFileMutation>;
export type CreateProductFromStudioFileMutationOptions = Apollo.BaseMutationOptions<
	CreateProductFromStudioFileMutation,
	CreateProductFromStudioFileMutationVariables
>;
export const RevertToStudioFileVersionDocument = gql`
	mutation RevertToStudioFileVersion($versionId: ID!) {
		revertToStudioFileVersion(versionId: $versionId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RevertToStudioFileVersionMutationFn = Apollo.MutationFunction<
	RevertToStudioFileVersionMutation,
	RevertToStudioFileVersionMutationVariables
>;

/**
 * __useRevertToStudioFileVersionMutation__
 *
 * To run a mutation, you first call `useRevertToStudioFileVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertToStudioFileVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertToStudioFileVersionMutation, { data, loading, error }] = useRevertToStudioFileVersionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useRevertToStudioFileVersionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RevertToStudioFileVersionMutation,
		RevertToStudioFileVersionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RevertToStudioFileVersionMutation,
		RevertToStudioFileVersionMutationVariables
	>(RevertToStudioFileVersionDocument, options);
}
export type RevertToStudioFileVersionMutationHookResult = ReturnType<
	typeof useRevertToStudioFileVersionMutation
>;
export type RevertToStudioFileVersionMutationResult =
	Apollo.MutationResult<RevertToStudioFileVersionMutation>;
export type RevertToStudioFileVersionMutationOptions = Apollo.BaseMutationOptions<
	RevertToStudioFileVersionMutation,
	RevertToStudioFileVersionMutationVariables
>;
export const GenerateMetadataAttachmentUploadUrlDocument = gql`
	mutation GenerateMetadataAttachmentUploadUrl($input: MetadataAttachmentUploadInput!) {
		generateMetadataAttachmentUploadUrl(input: $input) {
			uploadUrl
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateMetadataAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateMetadataAttachmentUploadUrlMutation,
	GenerateMetadataAttachmentUploadUrlMutationVariables
>;

/**
 * __useGenerateMetadataAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateMetadataAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMetadataAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMetadataAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateMetadataAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMetadataAttachmentUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateMetadataAttachmentUploadUrlMutation,
		GenerateMetadataAttachmentUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateMetadataAttachmentUploadUrlMutation,
		GenerateMetadataAttachmentUploadUrlMutationVariables
	>(GenerateMetadataAttachmentUploadUrlDocument, options);
}
export type GenerateMetadataAttachmentUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateMetadataAttachmentUploadUrlMutation
>;
export type GenerateMetadataAttachmentUploadUrlMutationResult =
	Apollo.MutationResult<GenerateMetadataAttachmentUploadUrlMutation>;
export type GenerateMetadataAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateMetadataAttachmentUploadUrlMutation,
	GenerateMetadataAttachmentUploadUrlMutationVariables
>;
export const FinishMetadataAttachmentUploadDocument = gql`
	mutation FinishMetadataAttachmentUpload($input: FinishMetadataAttachmentUploadInput!) {
		finishMetadataAttachmentUpload(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type FinishMetadataAttachmentUploadMutationFn = Apollo.MutationFunction<
	FinishMetadataAttachmentUploadMutation,
	FinishMetadataAttachmentUploadMutationVariables
>;

/**
 * __useFinishMetadataAttachmentUploadMutation__
 *
 * To run a mutation, you first call `useFinishMetadataAttachmentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMetadataAttachmentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMetadataAttachmentUploadMutation, { data, loading, error }] = useFinishMetadataAttachmentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishMetadataAttachmentUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		FinishMetadataAttachmentUploadMutation,
		FinishMetadataAttachmentUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		FinishMetadataAttachmentUploadMutation,
		FinishMetadataAttachmentUploadMutationVariables
	>(FinishMetadataAttachmentUploadDocument, options);
}
export type FinishMetadataAttachmentUploadMutationHookResult = ReturnType<
	typeof useFinishMetadataAttachmentUploadMutation
>;
export type FinishMetadataAttachmentUploadMutationResult =
	Apollo.MutationResult<FinishMetadataAttachmentUploadMutation>;
export type FinishMetadataAttachmentUploadMutationOptions = Apollo.BaseMutationOptions<
	FinishMetadataAttachmentUploadMutation,
	FinishMetadataAttachmentUploadMutationVariables
>;
export const RemoveMetadataAttachmentDocument = gql`
	mutation RemoveMetadataAttachment($input: RemoveMetadataAttachmentInput!) {
		removeMetadataAttachment(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemoveMetadataAttachmentMutationFn = Apollo.MutationFunction<
	RemoveMetadataAttachmentMutation,
	RemoveMetadataAttachmentMutationVariables
>;

/**
 * __useRemoveMetadataAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveMetadataAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMetadataAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMetadataAttachmentMutation, { data, loading, error }] = useRemoveMetadataAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMetadataAttachmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveMetadataAttachmentMutation,
		RemoveMetadataAttachmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveMetadataAttachmentMutation,
		RemoveMetadataAttachmentMutationVariables
	>(RemoveMetadataAttachmentDocument, options);
}
export type RemoveMetadataAttachmentMutationHookResult = ReturnType<
	typeof useRemoveMetadataAttachmentMutation
>;
export type RemoveMetadataAttachmentMutationResult =
	Apollo.MutationResult<RemoveMetadataAttachmentMutation>;
export type RemoveMetadataAttachmentMutationOptions = Apollo.BaseMutationOptions<
	RemoveMetadataAttachmentMutation,
	RemoveMetadataAttachmentMutationVariables
>;
export const DeleteStudioFileVersionDocument = gql`
	mutation DeleteStudioFileVersion($versionId: ID!) {
		deleteStudioFileVersion(versionId: $versionId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteStudioFileVersionMutationFn = Apollo.MutationFunction<
	DeleteStudioFileVersionMutation,
	DeleteStudioFileVersionMutationVariables
>;

/**
 * __useDeleteStudioFileVersionMutation__
 *
 * To run a mutation, you first call `useDeleteStudioFileVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudioFileVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudioFileVersionMutation, { data, loading, error }] = useDeleteStudioFileVersionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDeleteStudioFileVersionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteStudioFileVersionMutation,
		DeleteStudioFileVersionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteStudioFileVersionMutation,
		DeleteStudioFileVersionMutationVariables
	>(DeleteStudioFileVersionDocument, options);
}
export type DeleteStudioFileVersionMutationHookResult = ReturnType<
	typeof useDeleteStudioFileVersionMutation
>;
export type DeleteStudioFileVersionMutationResult =
	Apollo.MutationResult<DeleteStudioFileVersionMutation>;
export type DeleteStudioFileVersionMutationOptions = Apollo.BaseMutationOptions<
	DeleteStudioFileVersionMutation,
	DeleteStudioFileVersionMutationVariables
>;
export const UpdateStudioFileVersionSpecificationDocument = gql`
	mutation UpdateStudioFileVersionSpecification(
		$specificationId: ID!
		$input: UpdateStudioFileVersionSpecificationInput!
	) {
		updateStudioFileVersionSpecification(specificationId: $specificationId, input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateStudioFileVersionSpecificationMutationFn = Apollo.MutationFunction<
	UpdateStudioFileVersionSpecificationMutation,
	UpdateStudioFileVersionSpecificationMutationVariables
>;

/**
 * __useUpdateStudioFileVersionSpecificationMutation__
 *
 * To run a mutation, you first call `useUpdateStudioFileVersionSpecificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudioFileVersionSpecificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudioFileVersionSpecificationMutation, { data, loading, error }] = useUpdateStudioFileVersionSpecificationMutation({
 *   variables: {
 *      specificationId: // value for 'specificationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudioFileVersionSpecificationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateStudioFileVersionSpecificationMutation,
		UpdateStudioFileVersionSpecificationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateStudioFileVersionSpecificationMutation,
		UpdateStudioFileVersionSpecificationMutationVariables
	>(UpdateStudioFileVersionSpecificationDocument, options);
}
export type UpdateStudioFileVersionSpecificationMutationHookResult = ReturnType<
	typeof useUpdateStudioFileVersionSpecificationMutation
>;
export type UpdateStudioFileVersionSpecificationMutationResult =
	Apollo.MutationResult<UpdateStudioFileVersionSpecificationMutation>;
export type UpdateStudioFileVersionSpecificationMutationOptions = Apollo.BaseMutationOptions<
	UpdateStudioFileVersionSpecificationMutation,
	UpdateStudioFileVersionSpecificationMutationVariables
>;
export const DeleteStudioFileVersionSpecificationDocument = gql`
	mutation DeleteStudioFileVersionSpecification($specificationId: ID!) {
		deleteStudioFileVersionSpecification(specificationId: $specificationId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteStudioFileVersionSpecificationMutationFn = Apollo.MutationFunction<
	DeleteStudioFileVersionSpecificationMutation,
	DeleteStudioFileVersionSpecificationMutationVariables
>;

/**
 * __useDeleteStudioFileVersionSpecificationMutation__
 *
 * To run a mutation, you first call `useDeleteStudioFileVersionSpecificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudioFileVersionSpecificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudioFileVersionSpecificationMutation, { data, loading, error }] = useDeleteStudioFileVersionSpecificationMutation({
 *   variables: {
 *      specificationId: // value for 'specificationId'
 *   },
 * });
 */
export function useDeleteStudioFileVersionSpecificationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteStudioFileVersionSpecificationMutation,
		DeleteStudioFileVersionSpecificationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteStudioFileVersionSpecificationMutation,
		DeleteStudioFileVersionSpecificationMutationVariables
	>(DeleteStudioFileVersionSpecificationDocument, options);
}
export type DeleteStudioFileVersionSpecificationMutationHookResult = ReturnType<
	typeof useDeleteStudioFileVersionSpecificationMutation
>;
export type DeleteStudioFileVersionSpecificationMutationResult =
	Apollo.MutationResult<DeleteStudioFileVersionSpecificationMutation>;
export type DeleteStudioFileVersionSpecificationMutationOptions = Apollo.BaseMutationOptions<
	DeleteStudioFileVersionSpecificationMutation,
	DeleteStudioFileVersionSpecificationMutationVariables
>;
export const AssignStudioFileToClientDocument = gql`
	mutation AssignStudioFileToClient($input: AssignStudioFileToClientInput!) {
		assignStudioFileToClient(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AssignStudioFileToClientMutationFn = Apollo.MutationFunction<
	AssignStudioFileToClientMutation,
	AssignStudioFileToClientMutationVariables
>;

/**
 * __useAssignStudioFileToClientMutation__
 *
 * To run a mutation, you first call `useAssignStudioFileToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignStudioFileToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignStudioFileToClientMutation, { data, loading, error }] = useAssignStudioFileToClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignStudioFileToClientMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignStudioFileToClientMutation,
		AssignStudioFileToClientMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignStudioFileToClientMutation,
		AssignStudioFileToClientMutationVariables
	>(AssignStudioFileToClientDocument, options);
}
export type AssignStudioFileToClientMutationHookResult = ReturnType<
	typeof useAssignStudioFileToClientMutation
>;
export type AssignStudioFileToClientMutationResult =
	Apollo.MutationResult<AssignStudioFileToClientMutation>;
export type AssignStudioFileToClientMutationOptions = Apollo.BaseMutationOptions<
	AssignStudioFileToClientMutation,
	AssignStudioFileToClientMutationVariables
>;
export const AcquireStudioLockDocument = gql`
	mutation AcquireStudioLock($studioFileId: ID!) {
		acquireStudioLock(studioFileId: $studioFileId) {
			success
			message
			lock {
				studioFileId
				userId
				lockedAt
				expiresAt
			}
		}
	}
`;
export type AcquireStudioLockMutationFn = Apollo.MutationFunction<
	AcquireStudioLockMutation,
	AcquireStudioLockMutationVariables
>;

/**
 * __useAcquireStudioLockMutation__
 *
 * To run a mutation, you first call `useAcquireStudioLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcquireStudioLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acquireStudioLockMutation, { data, loading, error }] = useAcquireStudioLockMutation({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useAcquireStudioLockMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AcquireStudioLockMutation,
		AcquireStudioLockMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcquireStudioLockMutation, AcquireStudioLockMutationVariables>(
		AcquireStudioLockDocument,
		options
	);
}
export type AcquireStudioLockMutationHookResult = ReturnType<typeof useAcquireStudioLockMutation>;
export type AcquireStudioLockMutationResult = Apollo.MutationResult<AcquireStudioLockMutation>;
export type AcquireStudioLockMutationOptions = Apollo.BaseMutationOptions<
	AcquireStudioLockMutation,
	AcquireStudioLockMutationVariables
>;
export const ReleaseStudioLockDocument = gql`
	mutation ReleaseStudioLock($studioFileId: ID!) {
		releaseStudioLock(studioFileId: $studioFileId) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type ReleaseStudioLockMutationFn = Apollo.MutationFunction<
	ReleaseStudioLockMutation,
	ReleaseStudioLockMutationVariables
>;

/**
 * __useReleaseStudioLockMutation__
 *
 * To run a mutation, you first call `useReleaseStudioLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseStudioLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseStudioLockMutation, { data, loading, error }] = useReleaseStudioLockMutation({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useReleaseStudioLockMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReleaseStudioLockMutation,
		ReleaseStudioLockMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReleaseStudioLockMutation, ReleaseStudioLockMutationVariables>(
		ReleaseStudioLockDocument,
		options
	);
}
export type ReleaseStudioLockMutationHookResult = ReturnType<typeof useReleaseStudioLockMutation>;
export type ReleaseStudioLockMutationResult = Apollo.MutationResult<ReleaseStudioLockMutation>;
export type ReleaseStudioLockMutationOptions = Apollo.BaseMutationOptions<
	ReleaseStudioLockMutation,
	ReleaseStudioLockMutationVariables
>;
export const UpdateStudioPromptTemplateDocument = gql`
	mutation UpdateStudioPromptTemplate($input: UpdateStudioPromptTemplateInput!) {
		updateStudioPromptTemplate(input: $input) {
			id
			key
			content
			description
			agentType
			isActive
			provider
			variables
			createdAt
			updatedAt
		}
	}
`;
export type UpdateStudioPromptTemplateMutationFn = Apollo.MutationFunction<
	UpdateStudioPromptTemplateMutation,
	UpdateStudioPromptTemplateMutationVariables
>;

/**
 * __useUpdateStudioPromptTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateStudioPromptTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudioPromptTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudioPromptTemplateMutation, { data, loading, error }] = useUpdateStudioPromptTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudioPromptTemplateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateStudioPromptTemplateMutation,
		UpdateStudioPromptTemplateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateStudioPromptTemplateMutation,
		UpdateStudioPromptTemplateMutationVariables
	>(UpdateStudioPromptTemplateDocument, options);
}
export type UpdateStudioPromptTemplateMutationHookResult = ReturnType<
	typeof useUpdateStudioPromptTemplateMutation
>;
export type UpdateStudioPromptTemplateMutationResult =
	Apollo.MutationResult<UpdateStudioPromptTemplateMutation>;
export type UpdateStudioPromptTemplateMutationOptions = Apollo.BaseMutationOptions<
	UpdateStudioPromptTemplateMutation,
	UpdateStudioPromptTemplateMutationVariables
>;
export const GenerateStudioReferenceImageUploadUrlDocument = gql`
	mutation GenerateStudioReferenceImageUploadUrl(
		$input: GenerateStudioReferenceImageUploadUrlInput!
	) {
		generateStudioReferenceImageUploadUrl(input: $input) {
			imageId
			uploadUrl
			blobUrl
			expiresAt
		}
	}
`;
export type GenerateStudioReferenceImageUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateStudioReferenceImageUploadUrlMutation,
	GenerateStudioReferenceImageUploadUrlMutationVariables
>;

/**
 * __useGenerateStudioReferenceImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateStudioReferenceImageUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStudioReferenceImageUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateStudioReferenceImageUploadUrlMutation, { data, loading, error }] = useGenerateStudioReferenceImageUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateStudioReferenceImageUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateStudioReferenceImageUploadUrlMutation,
		GenerateStudioReferenceImageUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateStudioReferenceImageUploadUrlMutation,
		GenerateStudioReferenceImageUploadUrlMutationVariables
	>(GenerateStudioReferenceImageUploadUrlDocument, options);
}
export type GenerateStudioReferenceImageUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateStudioReferenceImageUploadUrlMutation
>;
export type GenerateStudioReferenceImageUploadUrlMutationResult =
	Apollo.MutationResult<GenerateStudioReferenceImageUploadUrlMutation>;
export type GenerateStudioReferenceImageUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateStudioReferenceImageUploadUrlMutation,
	GenerateStudioReferenceImageUploadUrlMutationVariables
>;
export const ConfirmStudioReferenceImageUploadDocument = gql`
	mutation ConfirmStudioReferenceImageUpload($input: ConfirmStudioReferenceImageUploadInput!) {
		confirmStudioReferenceImageUpload(input: $input) {
			success
			message
			referenceKey
		}
	}
`;
export type ConfirmStudioReferenceImageUploadMutationFn = Apollo.MutationFunction<
	ConfirmStudioReferenceImageUploadMutation,
	ConfirmStudioReferenceImageUploadMutationVariables
>;

/**
 * __useConfirmStudioReferenceImageUploadMutation__
 *
 * To run a mutation, you first call `useConfirmStudioReferenceImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmStudioReferenceImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmStudioReferenceImageUploadMutation, { data, loading, error }] = useConfirmStudioReferenceImageUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmStudioReferenceImageUploadMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ConfirmStudioReferenceImageUploadMutation,
		ConfirmStudioReferenceImageUploadMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ConfirmStudioReferenceImageUploadMutation,
		ConfirmStudioReferenceImageUploadMutationVariables
	>(ConfirmStudioReferenceImageUploadDocument, options);
}
export type ConfirmStudioReferenceImageUploadMutationHookResult = ReturnType<
	typeof useConfirmStudioReferenceImageUploadMutation
>;
export type ConfirmStudioReferenceImageUploadMutationResult =
	Apollo.MutationResult<ConfirmStudioReferenceImageUploadMutation>;
export type ConfirmStudioReferenceImageUploadMutationOptions = Apollo.BaseMutationOptions<
	ConfirmStudioReferenceImageUploadMutation,
	ConfirmStudioReferenceImageUploadMutationVariables
>;
export const CreateSubscriptionCheckoutSessionDocument = gql`
	mutation CreateSubscriptionCheckoutSession($tier: SubscriptionTier!) {
		createSubscriptionCheckoutSession(tier: $tier) {
			success
			clientSecret
			sessionId
			message
		}
	}
`;
export type CreateSubscriptionCheckoutSessionMutationFn = Apollo.MutationFunction<
	CreateSubscriptionCheckoutSessionMutation,
	CreateSubscriptionCheckoutSessionMutationVariables
>;

/**
 * __useCreateSubscriptionCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCheckoutSessionMutation, { data, loading, error }] = useCreateSubscriptionCheckoutSessionMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useCreateSubscriptionCheckoutSessionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateSubscriptionCheckoutSessionMutation,
		CreateSubscriptionCheckoutSessionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateSubscriptionCheckoutSessionMutation,
		CreateSubscriptionCheckoutSessionMutationVariables
	>(CreateSubscriptionCheckoutSessionDocument, options);
}
export type CreateSubscriptionCheckoutSessionMutationHookResult = ReturnType<
	typeof useCreateSubscriptionCheckoutSessionMutation
>;
export type CreateSubscriptionCheckoutSessionMutationResult =
	Apollo.MutationResult<CreateSubscriptionCheckoutSessionMutation>;
export type CreateSubscriptionCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<
	CreateSubscriptionCheckoutSessionMutation,
	CreateSubscriptionCheckoutSessionMutationVariables
>;
export const ChangeSubscriptionPlanDocument = gql`
	mutation ChangeSubscriptionPlan($tier: SubscriptionTier!) {
		changeSubscriptionPlan(tier: $tier) {
			success
			message
			requiresAction
			clientSecret
			subscription {
				id
				tier
				status
				stripePriceId
				currentPeriodEnd
				cancelAtPeriodEnd
				pendingTier
				pendingTierEffectiveAt
			}
		}
	}
`;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<
	ChangeSubscriptionPlanMutation,
	ChangeSubscriptionPlanMutationVariables
>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ChangeSubscriptionPlanMutation,
		ChangeSubscriptionPlanMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ChangeSubscriptionPlanMutation,
		ChangeSubscriptionPlanMutationVariables
	>(ChangeSubscriptionPlanDocument, options);
}
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<
	typeof useChangeSubscriptionPlanMutation
>;
export type ChangeSubscriptionPlanMutationResult =
	Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<
	ChangeSubscriptionPlanMutation,
	ChangeSubscriptionPlanMutationVariables
>;
export const CancelScheduledPlanChangeDocument = gql`
	mutation CancelScheduledPlanChange {
		cancelScheduledPlanChange {
			success
			message
			subscription {
				id
				tier
				pendingTier
				pendingTierEffectiveAt
			}
		}
	}
`;
export type CancelScheduledPlanChangeMutationFn = Apollo.MutationFunction<
	CancelScheduledPlanChangeMutation,
	CancelScheduledPlanChangeMutationVariables
>;

/**
 * __useCancelScheduledPlanChangeMutation__
 *
 * To run a mutation, you first call `useCancelScheduledPlanChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledPlanChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledPlanChangeMutation, { data, loading, error }] = useCancelScheduledPlanChangeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelScheduledPlanChangeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelScheduledPlanChangeMutation,
		CancelScheduledPlanChangeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CancelScheduledPlanChangeMutation,
		CancelScheduledPlanChangeMutationVariables
	>(CancelScheduledPlanChangeDocument, options);
}
export type CancelScheduledPlanChangeMutationHookResult = ReturnType<
	typeof useCancelScheduledPlanChangeMutation
>;
export type CancelScheduledPlanChangeMutationResult =
	Apollo.MutationResult<CancelScheduledPlanChangeMutation>;
export type CancelScheduledPlanChangeMutationOptions = Apollo.BaseMutationOptions<
	CancelScheduledPlanChangeMutation,
	CancelScheduledPlanChangeMutationVariables
>;
export const CancelSubscriptionDocument = gql`
	mutation CancelSubscription {
		cancelSubscription {
			success
			message
			subscription {
				id
				status
				cancelAtPeriodEnd
				canceledAt
			}
		}
	}
`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<
	CancelSubscriptionMutation,
	CancelSubscriptionMutationVariables
>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CancelSubscriptionMutation,
		CancelSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(
		CancelSubscriptionDocument,
		options
	);
}
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<
	CancelSubscriptionMutation,
	CancelSubscriptionMutationVariables
>;
export const ResumeSubscriptionDocument = gql`
	mutation ResumeSubscription {
		resumeSubscription {
			success
			message
			subscription {
				id
				status
				cancelAtPeriodEnd
			}
		}
	}
`;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<
	ResumeSubscriptionMutation,
	ResumeSubscriptionMutationVariables
>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeSubscriptionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResumeSubscriptionMutation,
		ResumeSubscriptionMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(
		ResumeSubscriptionDocument,
		options
	);
}
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<
	ResumeSubscriptionMutation,
	ResumeSubscriptionMutationVariables
>;
export const UpdateSubscriptionTierConfigDocument = gql`
	mutation UpdateSubscriptionTierConfig(
		$tier: SubscriptionTier!
		$kickbackRate: Float
		$aiTokenRatePerMillion: Float
		$stripePriceId: String
		$isActive: Boolean
	) {
		updateSubscriptionTierConfig(
			tier: $tier
			kickbackRate: $kickbackRate
			aiTokenRatePerMillion: $aiTokenRatePerMillion
			stripePriceId: $stripePriceId
			isActive: $isActive
		) {
			tier
			monthlyPrice
			currency
			kickbackRate
			aiTokenRatePerMillion
			stripePriceId
			isActive
			updatedAt
		}
	}
`;
export type UpdateSubscriptionTierConfigMutationFn = Apollo.MutationFunction<
	UpdateSubscriptionTierConfigMutation,
	UpdateSubscriptionTierConfigMutationVariables
>;

/**
 * __useUpdateSubscriptionTierConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionTierConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionTierConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionTierConfigMutation, { data, loading, error }] = useUpdateSubscriptionTierConfigMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *      kickbackRate: // value for 'kickbackRate'
 *      aiTokenRatePerMillion: // value for 'aiTokenRatePerMillion'
 *      stripePriceId: // value for 'stripePriceId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateSubscriptionTierConfigMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSubscriptionTierConfigMutation,
		UpdateSubscriptionTierConfigMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateSubscriptionTierConfigMutation,
		UpdateSubscriptionTierConfigMutationVariables
	>(UpdateSubscriptionTierConfigDocument, options);
}
export type UpdateSubscriptionTierConfigMutationHookResult = ReturnType<
	typeof useUpdateSubscriptionTierConfigMutation
>;
export type UpdateSubscriptionTierConfigMutationResult =
	Apollo.MutationResult<UpdateSubscriptionTierConfigMutation>;
export type UpdateSubscriptionTierConfigMutationOptions = Apollo.BaseMutationOptions<
	UpdateSubscriptionTierConfigMutation,
	UpdateSubscriptionTierConfigMutationVariables
>;
export const UpdateSystemSettingsDocument = gql`
	mutation UpdateSystemSettings($input: UpdateSystemSettingInput!) {
		updateSystemSettings(input: $input) {
			message
			success
		}
	}
`;
export type UpdateSystemSettingsMutationFn = Apollo.MutationFunction<
	UpdateSystemSettingsMutation,
	UpdateSystemSettingsMutationVariables
>;

/**
 * __useUpdateSystemSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSystemSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemSettingsMutation, { data, loading, error }] = useUpdateSystemSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemSettingsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSystemSettingsMutation,
		UpdateSystemSettingsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>(
		UpdateSystemSettingsDocument,
		options
	);
}
export type UpdateSystemSettingsMutationHookResult = ReturnType<
	typeof useUpdateSystemSettingsMutation
>;
export type UpdateSystemSettingsMutationResult =
	Apollo.MutationResult<UpdateSystemSettingsMutation>;
export type UpdateSystemSettingsMutationOptions = Apollo.BaseMutationOptions<
	UpdateSystemSettingsMutation,
	UpdateSystemSettingsMutationVariables
>;
export const UpdateUserLanguagePreferenceDocument = gql`
	mutation UpdateUserLanguagePreference($language: SupportedLanguage) {
		updateUserLanguagePreference(language: $language) {
			success
			message
		}
	}
`;
export type UpdateUserLanguagePreferenceMutationFn = Apollo.MutationFunction<
	UpdateUserLanguagePreferenceMutation,
	UpdateUserLanguagePreferenceMutationVariables
>;

/**
 * __useUpdateUserLanguagePreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserLanguagePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLanguagePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLanguagePreferenceMutation, { data, loading, error }] = useUpdateUserLanguagePreferenceMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateUserLanguagePreferenceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateUserLanguagePreferenceMutation,
		UpdateUserLanguagePreferenceMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateUserLanguagePreferenceMutation,
		UpdateUserLanguagePreferenceMutationVariables
	>(UpdateUserLanguagePreferenceDocument, options);
}
export type UpdateUserLanguagePreferenceMutationHookResult = ReturnType<
	typeof useUpdateUserLanguagePreferenceMutation
>;
export type UpdateUserLanguagePreferenceMutationResult =
	Apollo.MutationResult<UpdateUserLanguagePreferenceMutation>;
export type UpdateUserLanguagePreferenceMutationOptions = Apollo.BaseMutationOptions<
	UpdateUserLanguagePreferenceMutation,
	UpdateUserLanguagePreferenceMutationVariables
>;
export const CreateVetterEntityDocument = gql`
	mutation CreateVetterEntity($input: CreateVetterEntityInput!) {
		createVetterEntity(input: $input) {
			success
			message
		}
	}
`;
export type CreateVetterEntityMutationFn = Apollo.MutationFunction<
	CreateVetterEntityMutation,
	CreateVetterEntityMutationVariables
>;

/**
 * __useCreateVetterEntityMutation__
 *
 * To run a mutation, you first call `useCreateVetterEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVetterEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVetterEntityMutation, { data, loading, error }] = useCreateVetterEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVetterEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateVetterEntityMutation,
		CreateVetterEntityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateVetterEntityMutation, CreateVetterEntityMutationVariables>(
		CreateVetterEntityDocument,
		options
	);
}
export type CreateVetterEntityMutationHookResult = ReturnType<typeof useCreateVetterEntityMutation>;
export type CreateVetterEntityMutationResult = Apollo.MutationResult<CreateVetterEntityMutation>;
export type CreateVetterEntityMutationOptions = Apollo.BaseMutationOptions<
	CreateVetterEntityMutation,
	CreateVetterEntityMutationVariables
>;
export const UpdateVetterEntityDocument = gql`
	mutation UpdateVetterEntity($id: ID!, $input: UpdateVetterEntityInput!) {
		updateVetterEntity(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateVetterEntityMutationFn = Apollo.MutationFunction<
	UpdateVetterEntityMutation,
	UpdateVetterEntityMutationVariables
>;

/**
 * __useUpdateVetterEntityMutation__
 *
 * To run a mutation, you first call `useUpdateVetterEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVetterEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVetterEntityMutation, { data, loading, error }] = useUpdateVetterEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVetterEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateVetterEntityMutation,
		UpdateVetterEntityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateVetterEntityMutation, UpdateVetterEntityMutationVariables>(
		UpdateVetterEntityDocument,
		options
	);
}
export type UpdateVetterEntityMutationHookResult = ReturnType<typeof useUpdateVetterEntityMutation>;
export type UpdateVetterEntityMutationResult = Apollo.MutationResult<UpdateVetterEntityMutation>;
export type UpdateVetterEntityMutationOptions = Apollo.BaseMutationOptions<
	UpdateVetterEntityMutation,
	UpdateVetterEntityMutationVariables
>;
export const DeleteVetterEntityDocument = gql`
	mutation DeleteVetterEntity($id: ID!) {
		deleteVetterEntity(id: $id) {
			success
			message
		}
	}
`;
export type DeleteVetterEntityMutationFn = Apollo.MutationFunction<
	DeleteVetterEntityMutation,
	DeleteVetterEntityMutationVariables
>;

/**
 * __useDeleteVetterEntityMutation__
 *
 * To run a mutation, you first call `useDeleteVetterEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVetterEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVetterEntityMutation, { data, loading, error }] = useDeleteVetterEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVetterEntityMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteVetterEntityMutation,
		DeleteVetterEntityMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteVetterEntityMutation, DeleteVetterEntityMutationVariables>(
		DeleteVetterEntityDocument,
		options
	);
}
export type DeleteVetterEntityMutationHookResult = ReturnType<typeof useDeleteVetterEntityMutation>;
export type DeleteVetterEntityMutationResult = Apollo.MutationResult<DeleteVetterEntityMutation>;
export type DeleteVetterEntityMutationOptions = Apollo.BaseMutationOptions<
	DeleteVetterEntityMutation,
	DeleteVetterEntityMutationVariables
>;
export const CreateVetterUserDocument = gql`
	mutation CreateVetterUser($input: CreateVetterUserInput!) {
		createVetterUser(input: $input) {
			success
			message
		}
	}
`;
export type CreateVetterUserMutationFn = Apollo.MutationFunction<
	CreateVetterUserMutation,
	CreateVetterUserMutationVariables
>;

/**
 * __useCreateVetterUserMutation__
 *
 * To run a mutation, you first call `useCreateVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVetterUserMutation, { data, loading, error }] = useCreateVetterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateVetterUserMutation,
		CreateVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateVetterUserMutation, CreateVetterUserMutationVariables>(
		CreateVetterUserDocument,
		options
	);
}
export type CreateVetterUserMutationHookResult = ReturnType<typeof useCreateVetterUserMutation>;
export type CreateVetterUserMutationResult = Apollo.MutationResult<CreateVetterUserMutation>;
export type CreateVetterUserMutationOptions = Apollo.BaseMutationOptions<
	CreateVetterUserMutation,
	CreateVetterUserMutationVariables
>;
export const UpdateVetterUserDocument = gql`
	mutation UpdateVetterUser($id: ID!, $input: UpdateVetterUserInput!) {
		updateVetterUser(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateVetterUserMutationFn = Apollo.MutationFunction<
	UpdateVetterUserMutation,
	UpdateVetterUserMutationVariables
>;

/**
 * __useUpdateVetterUserMutation__
 *
 * To run a mutation, you first call `useUpdateVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVetterUserMutation, { data, loading, error }] = useUpdateVetterUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateVetterUserMutation,
		UpdateVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateVetterUserMutation, UpdateVetterUserMutationVariables>(
		UpdateVetterUserDocument,
		options
	);
}
export type UpdateVetterUserMutationHookResult = ReturnType<typeof useUpdateVetterUserMutation>;
export type UpdateVetterUserMutationResult = Apollo.MutationResult<UpdateVetterUserMutation>;
export type UpdateVetterUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateVetterUserMutation,
	UpdateVetterUserMutationVariables
>;
export const DeleteVetterUserDocument = gql`
	mutation DeleteVetterUser($id: ID!) {
		deleteVetterUser(id: $id) {
			success
			message
		}
	}
`;
export type DeleteVetterUserMutationFn = Apollo.MutationFunction<
	DeleteVetterUserMutation,
	DeleteVetterUserMutationVariables
>;

/**
 * __useDeleteVetterUserMutation__
 *
 * To run a mutation, you first call `useDeleteVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVetterUserMutation, { data, loading, error }] = useDeleteVetterUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteVetterUserMutation,
		DeleteVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteVetterUserMutation, DeleteVetterUserMutationVariables>(
		DeleteVetterUserDocument,
		options
	);
}
export type DeleteVetterUserMutationHookResult = ReturnType<typeof useDeleteVetterUserMutation>;
export type DeleteVetterUserMutationResult = Apollo.MutationResult<DeleteVetterUserMutation>;
export type DeleteVetterUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteVetterUserMutation,
	DeleteVetterUserMutationVariables
>;
export const DeleteManyVetterUserDocument = gql`
	mutation DeleteManyVetterUser($input: DeleteManyInput!) {
		deleteManyVetterUser(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyVetterUserMutationFn = Apollo.MutationFunction<
	DeleteManyVetterUserMutation,
	DeleteManyVetterUserMutationVariables
>;

/**
 * __useDeleteManyVetterUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyVetterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyVetterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyVetterUserMutation, { data, loading, error }] = useDeleteManyVetterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyVetterUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyVetterUserMutation,
		DeleteManyVetterUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyVetterUserMutation, DeleteManyVetterUserMutationVariables>(
		DeleteManyVetterUserDocument,
		options
	);
}
export type DeleteManyVetterUserMutationHookResult = ReturnType<
	typeof useDeleteManyVetterUserMutation
>;
export type DeleteManyVetterUserMutationResult =
	Apollo.MutationResult<DeleteManyVetterUserMutation>;
export type DeleteManyVetterUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyVetterUserMutation,
	DeleteManyVetterUserMutationVariables
>;
export const GetAdminActiveActivitiesDocument = gql`
	query GetAdminActiveActivities($limit: Int) {
		getAdminActiveActivities(limit: $limit) {
			activities {
				... on AdminChatActivity {
					__typename
					id
					type
					contextId
					unreadCount
					lastMessageAt
					context {
						id
						contextType
						quoteId
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
					}
				}
				... on AdminQuoteActivity {
					__typename
					id
					type
					quoteId
					quote {
						id
						name
						createdAt
						items {
							product {
								images {
									url
									name
									isPrimary
								}
							}
						}
					}
				}
				... on AdminQuoteOfferActivity {
					__typename
					id
					type
					quoteOfferId
					quoteOffer {
						id
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
						createdAt
					}
				}
				... on AdminOrderActivity {
					__typename
					id
					type
					orderId
					order {
						id
						orderNumber
						name
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetAdminActiveActivitiesQuery__
 *
 * To run a query within a React component, call `useGetAdminActiveActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminActiveActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminActiveActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAdminActiveActivitiesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAdminActiveActivitiesQuery, GetAdminActiveActivitiesQueryVariables>(
		GetAdminActiveActivitiesDocument,
		options
	);
}
export function useGetAdminActiveActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>(GetAdminActiveActivitiesDocument, options);
}
export function useGetAdminActiveActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAdminActiveActivitiesQuery,
				GetAdminActiveActivitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAdminActiveActivitiesQuery,
		GetAdminActiveActivitiesQueryVariables
	>(GetAdminActiveActivitiesDocument, options);
}
export type GetAdminActiveActivitiesQueryHookResult = ReturnType<
	typeof useGetAdminActiveActivitiesQuery
>;
export type GetAdminActiveActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetAdminActiveActivitiesLazyQuery
>;
export type GetAdminActiveActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetAdminActiveActivitiesSuspenseQuery
>;
export type GetAdminActiveActivitiesQueryResult = Apollo.QueryResult<
	GetAdminActiveActivitiesQuery,
	GetAdminActiveActivitiesQueryVariables
>;
export const GetVetterActiveActivitiesDocument = gql`
	query GetVetterActiveActivities($limit: Int) {
		getVetterActiveActivities(limit: $limit) {
			activities {
				... on VetterChatActivity {
					__typename
					id
					type
					contextId
					unreadCount
					lastMessageAt
					context {
						id
						contextType
						quoteId
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
					}
				}
				... on VetterQuoteActivity {
					__typename
					id
					type
					quoteId
					quote {
						id
						name
						organization {
							id
							name
						}
						offers {
							id
							status
							createdAt
						}
						createdAt
						items {
							product {
								images {
									url
									name
									isPrimary
								}
							}
						}
					}
				}
				... on VetterQuoteOfferActivity {
					__typename
					id
					type
					quoteOfferId
					quoteOffer {
						id
						quote {
							id
							name
							organization {
								id
								name
							}
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
						createdAt
					}
				}
			}
		}
	}
`;

/**
 * __useGetVetterActiveActivitiesQuery__
 *
 * To run a query within a React component, call `useGetVetterActiveActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetterActiveActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetterActiveActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVetterActiveActivitiesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetVetterActiveActivitiesQuery,
		GetVetterActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetVetterActiveActivitiesQuery, GetVetterActiveActivitiesQueryVariables>(
		GetVetterActiveActivitiesDocument,
		options
	);
}
export function useGetVetterActiveActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetVetterActiveActivitiesQuery,
		GetVetterActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetVetterActiveActivitiesQuery,
		GetVetterActiveActivitiesQueryVariables
	>(GetVetterActiveActivitiesDocument, options);
}
export function useGetVetterActiveActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetVetterActiveActivitiesQuery,
				GetVetterActiveActivitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetVetterActiveActivitiesQuery,
		GetVetterActiveActivitiesQueryVariables
	>(GetVetterActiveActivitiesDocument, options);
}
export type GetVetterActiveActivitiesQueryHookResult = ReturnType<
	typeof useGetVetterActiveActivitiesQuery
>;
export type GetVetterActiveActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetVetterActiveActivitiesLazyQuery
>;
export type GetVetterActiveActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetVetterActiveActivitiesSuspenseQuery
>;
export type GetVetterActiveActivitiesQueryResult = Apollo.QueryResult<
	GetVetterActiveActivitiesQuery,
	GetVetterActiveActivitiesQueryVariables
>;
export const GetOrganizationActiveActivitiesDocument = gql`
	query GetOrganizationActiveActivities($limit: Int) {
		getOrganizationActiveActivities(limit: $limit) {
			activities {
				... on OrganizationChatActivity {
					__typename
					id
					type
					contextId
					unreadCount
					lastMessageAt
					context {
						id
						contextType
						quoteId
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
					}
				}
				... on OrganizationQuoteActivity {
					__typename
					id
					type
					quoteId
					quote {
						id
						name
						items {
							product {
								images {
									url
									name
									isPrimary
								}
							}
						}
					}
				}
				... on OrganizationQuoteOfferActivity {
					__typename
					id
					type
					quoteOfferId
					quoteOffer {
						id
						status
						createdAt
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
					}
				}
				... on OrganizationOrderActivity {
					__typename
					id
					type
					orderId
					order {
						id
						orderNumber
						name
						quote {
							id
							name
							items {
								product {
									name
									images {
										url
										name
										isPrimary
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationActiveActivitiesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationActiveActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationActiveActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationActiveActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOrganizationActiveActivitiesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>(GetOrganizationActiveActivitiesDocument, options);
}
export function useGetOrganizationActiveActivitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>(GetOrganizationActiveActivitiesDocument, options);
}
export function useGetOrganizationActiveActivitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationActiveActivitiesQuery,
				GetOrganizationActiveActivitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationActiveActivitiesQuery,
		GetOrganizationActiveActivitiesQueryVariables
	>(GetOrganizationActiveActivitiesDocument, options);
}
export type GetOrganizationActiveActivitiesQueryHookResult = ReturnType<
	typeof useGetOrganizationActiveActivitiesQuery
>;
export type GetOrganizationActiveActivitiesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationActiveActivitiesLazyQuery
>;
export type GetOrganizationActiveActivitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationActiveActivitiesSuspenseQuery
>;
export type GetOrganizationActiveActivitiesQueryResult = Apollo.QueryResult<
	GetOrganizationActiveActivitiesQuery,
	GetOrganizationActiveActivitiesQueryVariables
>;
export const GetAdminInvoiceDraftsForOrgV2Document = gql`
	query GetAdminInvoiceDraftsForOrgV2($organizationId: ID!) {
		getAdminInvoiceDraftsForOrgV2(organizationId: $organizationId) {
			id
			organizationId
			currency
			lineItems
			recipientEmail
			title
			notes
			poNumber
			economicDraftInvoiceNumber
			economicBookedInvoiceNumber
			economicCreditNoteInvoiceNumber
			status
			createdByUserId
			bookedAt
			cancelledAt
			lastError
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetAdminInvoiceDraftsForOrgV2Query__
 *
 * To run a query within a React component, call `useGetAdminInvoiceDraftsForOrgV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminInvoiceDraftsForOrgV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminInvoiceDraftsForOrgV2Query({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAdminInvoiceDraftsForOrgV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetAdminInvoiceDraftsForOrgV2Query,
		GetAdminInvoiceDraftsForOrgV2QueryVariables
	> &
		(
			| { variables: GetAdminInvoiceDraftsForOrgV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAdminInvoiceDraftsForOrgV2Query,
		GetAdminInvoiceDraftsForOrgV2QueryVariables
	>(GetAdminInvoiceDraftsForOrgV2Document, options);
}
export function useGetAdminInvoiceDraftsForOrgV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAdminInvoiceDraftsForOrgV2Query,
		GetAdminInvoiceDraftsForOrgV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAdminInvoiceDraftsForOrgV2Query,
		GetAdminInvoiceDraftsForOrgV2QueryVariables
	>(GetAdminInvoiceDraftsForOrgV2Document, options);
}
export function useGetAdminInvoiceDraftsForOrgV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAdminInvoiceDraftsForOrgV2Query,
				GetAdminInvoiceDraftsForOrgV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAdminInvoiceDraftsForOrgV2Query,
		GetAdminInvoiceDraftsForOrgV2QueryVariables
	>(GetAdminInvoiceDraftsForOrgV2Document, options);
}
export type GetAdminInvoiceDraftsForOrgV2QueryHookResult = ReturnType<
	typeof useGetAdminInvoiceDraftsForOrgV2Query
>;
export type GetAdminInvoiceDraftsForOrgV2LazyQueryHookResult = ReturnType<
	typeof useGetAdminInvoiceDraftsForOrgV2LazyQuery
>;
export type GetAdminInvoiceDraftsForOrgV2SuspenseQueryHookResult = ReturnType<
	typeof useGetAdminInvoiceDraftsForOrgV2SuspenseQuery
>;
export type GetAdminInvoiceDraftsForOrgV2QueryResult = Apollo.QueryResult<
	GetAdminInvoiceDraftsForOrgV2Query,
	GetAdminInvoiceDraftsForOrgV2QueryVariables
>;
export const GetAdminInvoiceDraftV2Document = gql`
	query GetAdminInvoiceDraftV2($id: ID!) {
		getAdminInvoiceDraftV2(id: $id) {
			id
			organizationId
			currency
			lineItems
			recipientEmail
			title
			notes
			poNumber
			economicDraftInvoiceNumber
			economicBookedInvoiceNumber
			economicCreditNoteInvoiceNumber
			status
			createdByUserId
			bookedAt
			cancelledAt
			lastError
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetAdminInvoiceDraftV2Query__
 *
 * To run a query within a React component, call `useGetAdminInvoiceDraftV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminInvoiceDraftV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminInvoiceDraftV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminInvoiceDraftV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetAdminInvoiceDraftV2Query,
		GetAdminInvoiceDraftV2QueryVariables
	> &
		({ variables: GetAdminInvoiceDraftV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAdminInvoiceDraftV2Query, GetAdminInvoiceDraftV2QueryVariables>(
		GetAdminInvoiceDraftV2Document,
		options
	);
}
export function useGetAdminInvoiceDraftV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAdminInvoiceDraftV2Query,
		GetAdminInvoiceDraftV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAdminInvoiceDraftV2Query, GetAdminInvoiceDraftV2QueryVariables>(
		GetAdminInvoiceDraftV2Document,
		options
	);
}
export function useGetAdminInvoiceDraftV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAdminInvoiceDraftV2Query,
				GetAdminInvoiceDraftV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAdminInvoiceDraftV2Query,
		GetAdminInvoiceDraftV2QueryVariables
	>(GetAdminInvoiceDraftV2Document, options);
}
export type GetAdminInvoiceDraftV2QueryHookResult = ReturnType<
	typeof useGetAdminInvoiceDraftV2Query
>;
export type GetAdminInvoiceDraftV2LazyQueryHookResult = ReturnType<
	typeof useGetAdminInvoiceDraftV2LazyQuery
>;
export type GetAdminInvoiceDraftV2SuspenseQueryHookResult = ReturnType<
	typeof useGetAdminInvoiceDraftV2SuspenseQuery
>;
export type GetAdminInvoiceDraftV2QueryResult = Apollo.QueryResult<
	GetAdminInvoiceDraftV2Query,
	GetAdminInvoiceDraftV2QueryVariables
>;
export const GetAllAdminUserDocument = gql`
	query GetAllAdminUser($input: GetAllAdminUserInput!) {
		getAllAdminUser(input: $input) {
			data {
				id
				userId
				firstName
				lastName
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					mfaEnabled
					language
					lastActive
				}
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAllAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAdminUserQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables> &
		({ variables: GetAllAdminUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export function useGetAllAdminUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export function useGetAllAdminUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export type GetAllAdminUserQueryHookResult = ReturnType<typeof useGetAllAdminUserQuery>;
export type GetAllAdminUserLazyQueryHookResult = ReturnType<typeof useGetAllAdminUserLazyQuery>;
export type GetAllAdminUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAdminUserSuspenseQuery
>;
export type GetAllAdminUserQueryResult = Apollo.QueryResult<
	GetAllAdminUserQuery,
	GetAllAdminUserQueryVariables
>;
export const GetAuthenticationUserDocument = gql`
	query GetAuthenticationUser($id: ID!) {
		getAuthenticationUser(id: $id) {
			id
			email
			mfaEnabled
			mfaMethod
			role
		}
	}
`;

/**
 * __useGetAuthenticationUserQuery__
 *
 * To run a query within a React component, call `useGetAuthenticationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticationUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuthenticationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthenticationUserQuery,
		GetAuthenticationUserQueryVariables
	> &
		({ variables: GetAuthenticationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>(
		GetAuthenticationUserDocument,
		options
	);
}
export function useGetAuthenticationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthenticationUserQuery,
		GetAuthenticationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>(
		GetAuthenticationUserDocument,
		options
	);
}
export function useGetAuthenticationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthenticationUserQuery,
				GetAuthenticationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>(
		GetAuthenticationUserDocument,
		options
	);
}
export type GetAuthenticationUserQueryHookResult = ReturnType<typeof useGetAuthenticationUserQuery>;
export type GetAuthenticationUserLazyQueryHookResult = ReturnType<
	typeof useGetAuthenticationUserLazyQuery
>;
export type GetAuthenticationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAuthenticationUserSuspenseQuery
>;
export type GetAuthenticationUserQueryResult = Apollo.QueryResult<
	GetAuthenticationUserQuery,
	GetAuthenticationUserQueryVariables
>;
export const CheckEmailExistsDocument = gql`
	query CheckEmailExists($email: String!) {
		checkEmailExists(email: $email) {
			exists
		}
	}
`;

/**
 * __useCheckEmailExistsQuery__
 *
 * To run a query within a React component, call `useCheckEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckEmailExistsQuery(
	baseOptions: Apollo.QueryHookOptions<CheckEmailExistsQuery, CheckEmailExistsQueryVariables> &
		({ variables: CheckEmailExistsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(
		CheckEmailExistsDocument,
		options
	);
}
export function useCheckEmailExistsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(
		CheckEmailExistsDocument,
		options
	);
}
export function useCheckEmailExistsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(
		CheckEmailExistsDocument,
		options
	);
}
export type CheckEmailExistsQueryHookResult = ReturnType<typeof useCheckEmailExistsQuery>;
export type CheckEmailExistsLazyQueryHookResult = ReturnType<typeof useCheckEmailExistsLazyQuery>;
export type CheckEmailExistsSuspenseQueryHookResult = ReturnType<
	typeof useCheckEmailExistsSuspenseQuery
>;
export type CheckEmailExistsQueryResult = Apollo.QueryResult<
	CheckEmailExistsQuery,
	CheckEmailExistsQueryVariables
>;
export const GetAllAuthorizationRoleDocument = gql`
	query GetAllAuthorizationRole($input: GetAllAuthorizationRoleInput!) {
		getAllAuthorizationRole(input: $input) {
			data {
				...AuthorizationRoleFragment
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllAuthorizationRoleQuery__
 *
 * To run a query within a React component, call `useGetAllAuthorizationRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAuthorizationRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAuthorizationRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAuthorizationRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	> &
		({ variables: GetAllAuthorizationRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllAuthorizationRoleQuery, GetAllAuthorizationRoleQueryVariables>(
		GetAllAuthorizationRoleDocument,
		options
	);
}
export function useGetAllAuthorizationRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllAuthorizationRoleQuery, GetAllAuthorizationRoleQueryVariables>(
		GetAllAuthorizationRoleDocument,
		options
	);
}
export function useGetAllAuthorizationRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAuthorizationRoleQuery,
				GetAllAuthorizationRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	>(GetAllAuthorizationRoleDocument, options);
}
export type GetAllAuthorizationRoleQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationRoleQuery
>;
export type GetAllAuthorizationRoleLazyQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationRoleLazyQuery
>;
export type GetAllAuthorizationRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationRoleSuspenseQuery
>;
export type GetAllAuthorizationRoleQueryResult = Apollo.QueryResult<
	GetAllAuthorizationRoleQuery,
	GetAllAuthorizationRoleQueryVariables
>;
export const GetAuthorizationRoleDocument = gql`
	query GetAuthorizationRole($id: ID!) {
		getAuthorizationRole(id: $id) {
			...AuthorizationRoleFragment
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
`;

/**
 * __useGetAuthorizationRoleQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuthorizationRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthorizationRoleQuery,
		GetAuthorizationRoleQueryVariables
	> &
		({ variables: GetAuthorizationRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>(
		GetAuthorizationRoleDocument,
		options
	);
}
export function useGetAuthorizationRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthorizationRoleQuery,
		GetAuthorizationRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>(
		GetAuthorizationRoleDocument,
		options
	);
}
export function useGetAuthorizationRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthorizationRoleQuery,
				GetAuthorizationRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>(
		GetAuthorizationRoleDocument,
		options
	);
}
export type GetAuthorizationRoleQueryHookResult = ReturnType<typeof useGetAuthorizationRoleQuery>;
export type GetAuthorizationRoleLazyQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleLazyQuery
>;
export type GetAuthorizationRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleSuspenseQuery
>;
export type GetAuthorizationRoleQueryResult = Apollo.QueryResult<
	GetAuthorizationRoleQuery,
	GetAuthorizationRoleQueryVariables
>;
export const GetAuthorizationRoleByNameDocument = gql`
	query GetAuthorizationRoleByName($name: String!) {
		getAuthorizationRoleByName(name: $name) {
			...AuthorizationRoleFragment
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
`;

/**
 * __useGetAuthorizationRoleByNameQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationRoleByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationRoleByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationRoleByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAuthorizationRoleByNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	> &
		(
			| { variables: GetAuthorizationRoleByNameQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>(GetAuthorizationRoleByNameDocument, options);
}
export function useGetAuthorizationRoleByNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>(GetAuthorizationRoleByNameDocument, options);
}
export function useGetAuthorizationRoleByNameSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthorizationRoleByNameQuery,
				GetAuthorizationRoleByNameQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>(GetAuthorizationRoleByNameDocument, options);
}
export type GetAuthorizationRoleByNameQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleByNameQuery
>;
export type GetAuthorizationRoleByNameLazyQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleByNameLazyQuery
>;
export type GetAuthorizationRoleByNameSuspenseQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleByNameSuspenseQuery
>;
export type GetAuthorizationRoleByNameQueryResult = Apollo.QueryResult<
	GetAuthorizationRoleByNameQuery,
	GetAuthorizationRoleByNameQueryVariables
>;
export const GetAllAuthorizationUserRoleDocument = gql`
	query GetAllAuthorizationUserRole($input: GetAllAuthorizationUserRoleInput!) {
		getAllAuthorizationUserRole(input: $input) {
			data {
				...AuthorizationUserRoleFragment
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${AuthorizationUserRoleFragmentFragmentDoc}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllAuthorizationUserRoleQuery__
 *
 * To run a query within a React component, call `useGetAllAuthorizationUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAuthorizationUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAuthorizationUserRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAuthorizationUserRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	> &
		(
			| { variables: GetAllAuthorizationUserRoleQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>(GetAllAuthorizationUserRoleDocument, options);
}
export function useGetAllAuthorizationUserRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>(GetAllAuthorizationUserRoleDocument, options);
}
export function useGetAllAuthorizationUserRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAuthorizationUserRoleQuery,
				GetAllAuthorizationUserRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>(GetAllAuthorizationUserRoleDocument, options);
}
export type GetAllAuthorizationUserRoleQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationUserRoleQuery
>;
export type GetAllAuthorizationUserRoleLazyQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationUserRoleLazyQuery
>;
export type GetAllAuthorizationUserRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationUserRoleSuspenseQuery
>;
export type GetAllAuthorizationUserRoleQueryResult = Apollo.QueryResult<
	GetAllAuthorizationUserRoleQuery,
	GetAllAuthorizationUserRoleQueryVariables
>;
export const GetMyAuthorizationUserRoleDocument = gql`
	query GetMyAuthorizationUserRole($input: GetMyAuthorizationUserRoleInput!) {
		getMyAuthorizationUserRole(input: $input) {
			data {
				...AuthorizationUserRoleFragment
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${AuthorizationUserRoleFragmentFragmentDoc}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetMyAuthorizationUserRoleQuery__
 *
 * To run a query within a React component, call `useGetMyAuthorizationUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAuthorizationUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAuthorizationUserRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyAuthorizationUserRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	> &
		(
			| { variables: GetMyAuthorizationUserRoleQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>(GetMyAuthorizationUserRoleDocument, options);
}
export function useGetMyAuthorizationUserRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>(GetMyAuthorizationUserRoleDocument, options);
}
export function useGetMyAuthorizationUserRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMyAuthorizationUserRoleQuery,
				GetMyAuthorizationUserRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>(GetMyAuthorizationUserRoleDocument, options);
}
export type GetMyAuthorizationUserRoleQueryHookResult = ReturnType<
	typeof useGetMyAuthorizationUserRoleQuery
>;
export type GetMyAuthorizationUserRoleLazyQueryHookResult = ReturnType<
	typeof useGetMyAuthorizationUserRoleLazyQuery
>;
export type GetMyAuthorizationUserRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetMyAuthorizationUserRoleSuspenseQuery
>;
export type GetMyAuthorizationUserRoleQueryResult = Apollo.QueryResult<
	GetMyAuthorizationUserRoleQuery,
	GetMyAuthorizationUserRoleQueryVariables
>;
export const GetAllBrandsDocument = gql`
	query GetAllBrands($input: GetAllBrandInput!) {
		getAllBrand(input: $input) {
			data {
				id
				name
				organizationId
				description
				brandguide
				colors
				website
				logo {
					id
					name
					url
					mimeType
				}
				address {
					formatted
					city
					state
					country
					postalCode
				}
				brandFiles {
					id
					name
					url
					type
					mimeType
					size
					uploadedAt
				}
				fontFiles {
					id
					family
					name
					style
					url
					weight
				}
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllBrandsQuery__
 *
 * To run a query within a React component, call `useGetAllBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBrandsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllBrandsQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables> &
		({ variables: GetAllBrandsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(
		GetAllBrandsDocument,
		options
	);
}
export function useGetAllBrandsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(
		GetAllBrandsDocument,
		options
	);
}
export function useGetAllBrandsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(
		GetAllBrandsDocument,
		options
	);
}
export type GetAllBrandsQueryHookResult = ReturnType<typeof useGetAllBrandsQuery>;
export type GetAllBrandsLazyQueryHookResult = ReturnType<typeof useGetAllBrandsLazyQuery>;
export type GetAllBrandsSuspenseQueryHookResult = ReturnType<typeof useGetAllBrandsSuspenseQuery>;
export type GetAllBrandsQueryResult = Apollo.QueryResult<
	GetAllBrandsQuery,
	GetAllBrandsQueryVariables
>;
export const GetBrandDocument = gql`
	query GetBrand($id: ID!) {
		getBrand(id: $id) {
			id
			name
			description
			brandguide
			colors
			colorPalette {
				primary {
					name
					hex
					usage
				}
				secondary {
					name
					hex
					usage
				}
				accent {
					name
					hex
					usage
				}
				neutral {
					name
					hex
					usage
				}
			}
			brandFiles {
				id
				name
				url
				type
				mimeType
				size
				uploadedAt
			}
			fontFiles {
				id
				family
				name
				style
				url
				weight
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetBrandQuery__
 *
 * To run a query within a React component, call `useGetBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandQuery(
	baseOptions: Apollo.QueryHookOptions<GetBrandQuery, GetBrandQueryVariables> &
		({ variables: GetBrandQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, options);
}
export function useGetBrandLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetBrandQuery, GetBrandQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, options);
}
export function useGetBrandSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetBrandQuery, GetBrandQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetBrandQuery, GetBrandQueryVariables>(
		GetBrandDocument,
		options
	);
}
export type GetBrandQueryHookResult = ReturnType<typeof useGetBrandQuery>;
export type GetBrandLazyQueryHookResult = ReturnType<typeof useGetBrandLazyQuery>;
export type GetBrandSuspenseQueryHookResult = ReturnType<typeof useGetBrandSuspenseQuery>;
export type GetBrandQueryResult = Apollo.QueryResult<GetBrandQuery, GetBrandQueryVariables>;
export const SearchBrandAssetsDocument = gql`
	query SearchBrandAssets($brandId: ID!, $query: String!, $context: [String!]) {
		searchBrandAssets(brandId: $brandId, query: $query, context: $context) {
			... on BrandFile {
				id
				name
				mimeType
				size
				url
				dimensions {
					width
					height
				}
				type
				designVariant
				backgroundType
				aiDescription
				tags
			}
			... on FontFile {
				id
				name
				family
				style
				url
				weight
				language
				mood
				usage
				readability
				aiDescription
			}
		}
	}
`;

/**
 * __useSearchBrandAssetsQuery__
 *
 * To run a query within a React component, call `useSearchBrandAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBrandAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBrandAssetsQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      query: // value for 'query'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useSearchBrandAssetsQuery(
	baseOptions: Apollo.QueryHookOptions<SearchBrandAssetsQuery, SearchBrandAssetsQueryVariables> &
		({ variables: SearchBrandAssetsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SearchBrandAssetsQuery, SearchBrandAssetsQueryVariables>(
		SearchBrandAssetsDocument,
		options
	);
}
export function useSearchBrandAssetsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SearchBrandAssetsQuery,
		SearchBrandAssetsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SearchBrandAssetsQuery, SearchBrandAssetsQueryVariables>(
		SearchBrandAssetsDocument,
		options
	);
}
export function useSearchBrandAssetsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<SearchBrandAssetsQuery, SearchBrandAssetsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SearchBrandAssetsQuery, SearchBrandAssetsQueryVariables>(
		SearchBrandAssetsDocument,
		options
	);
}
export type SearchBrandAssetsQueryHookResult = ReturnType<typeof useSearchBrandAssetsQuery>;
export type SearchBrandAssetsLazyQueryHookResult = ReturnType<typeof useSearchBrandAssetsLazyQuery>;
export type SearchBrandAssetsSuspenseQueryHookResult = ReturnType<
	typeof useSearchBrandAssetsSuspenseQuery
>;
export type SearchBrandAssetsQueryResult = Apollo.QueryResult<
	SearchBrandAssetsQuery,
	SearchBrandAssetsQueryVariables
>;
export const GetChatContextsByQuoteDocument = gql`
	query GetChatContextsByQuote($quoteId: ID!) {
		getChatContextsByQuote(quoteId: $quoteId) {
			id
			contextType
			organizationId
			vetterId
			quoteId
			unreadCount
			lastMessageAt
			translationEnabled
			targetLanguages
			organization {
				id
				name
			}
			vetterUser {
				id
				firstName
				lastName
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetChatContextsByQuoteQuery__
 *
 * To run a query within a React component, call `useGetChatContextsByQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatContextsByQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatContextsByQuoteQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetChatContextsByQuoteQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetChatContextsByQuoteQuery,
		GetChatContextsByQuoteQueryVariables
	> &
		({ variables: GetChatContextsByQuoteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetChatContextsByQuoteQuery, GetChatContextsByQuoteQueryVariables>(
		GetChatContextsByQuoteDocument,
		options
	);
}
export function useGetChatContextsByQuoteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetChatContextsByQuoteQuery,
		GetChatContextsByQuoteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetChatContextsByQuoteQuery, GetChatContextsByQuoteQueryVariables>(
		GetChatContextsByQuoteDocument,
		options
	);
}
export function useGetChatContextsByQuoteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetChatContextsByQuoteQuery,
				GetChatContextsByQuoteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetChatContextsByQuoteQuery,
		GetChatContextsByQuoteQueryVariables
	>(GetChatContextsByQuoteDocument, options);
}
export type GetChatContextsByQuoteQueryHookResult = ReturnType<
	typeof useGetChatContextsByQuoteQuery
>;
export type GetChatContextsByQuoteLazyQueryHookResult = ReturnType<
	typeof useGetChatContextsByQuoteLazyQuery
>;
export type GetChatContextsByQuoteSuspenseQueryHookResult = ReturnType<
	typeof useGetChatContextsByQuoteSuspenseQuery
>;
export type GetChatContextsByQuoteQueryResult = Apollo.QueryResult<
	GetChatContextsByQuoteQuery,
	GetChatContextsByQuoteQueryVariables
>;
export const GetChatMessagesDocument = gql`
	query GetChatMessages($contextId: ID!, $input: GetChatMessagesInput!) {
		getChatMessages(contextId: $contextId, input: $input) {
			data {
				id
				content
				contextId
				senderId
				senderType
				messageType
				metadata
				isRead
				readAt
				translations {
					da
					en
					zh
				}
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      contextId: // value for 'contextId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatMessagesQuery(
	baseOptions: Apollo.QueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables> &
		({ variables: GetChatMessagesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(
		GetChatMessagesDocument,
		options
	);
}
export function useGetChatMessagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(
		GetChatMessagesDocument,
		options
	);
}
export function useGetChatMessagesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(
		GetChatMessagesDocument,
		options
	);
}
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesSuspenseQueryHookResult = ReturnType<
	typeof useGetChatMessagesSuspenseQuery
>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<
	GetChatMessagesQuery,
	GetChatMessagesQueryVariables
>;
export const GetAllChatContextsDocument = gql`
	query GetAllChatContexts($input: GetMyChatContextsInput!) {
		getMyChatContexts(input: $input) {
			data {
				id
				contextType
				organizationId
				vetterId
				quoteId
				unreadCount
				lastMessageAt
				organization {
					id
					name
				}
				vetterUser {
					id
					firstName
					lastName
				}
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllChatContextsQuery__
 *
 * To run a query within a React component, call `useGetAllChatContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChatContextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChatContextsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllChatContextsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllChatContextsQuery,
		GetAllChatContextsQueryVariables
	> &
		({ variables: GetAllChatContextsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllChatContextsQuery, GetAllChatContextsQueryVariables>(
		GetAllChatContextsDocument,
		options
	);
}
export function useGetAllChatContextsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllChatContextsQuery,
		GetAllChatContextsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllChatContextsQuery, GetAllChatContextsQueryVariables>(
		GetAllChatContextsDocument,
		options
	);
}
export function useGetAllChatContextsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllChatContextsQuery, GetAllChatContextsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllChatContextsQuery, GetAllChatContextsQueryVariables>(
		GetAllChatContextsDocument,
		options
	);
}
export type GetAllChatContextsQueryHookResult = ReturnType<typeof useGetAllChatContextsQuery>;
export type GetAllChatContextsLazyQueryHookResult = ReturnType<
	typeof useGetAllChatContextsLazyQuery
>;
export type GetAllChatContextsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllChatContextsSuspenseQuery
>;
export type GetAllChatContextsQueryResult = Apollo.QueryResult<
	GetAllChatContextsQuery,
	GetAllChatContextsQueryVariables
>;
export const GetChatFileDownloadUrlDocument = gql`
	query GetChatFileDownloadUrl($contextId: ID!, $fileId: ID!) {
		getChatFileDownloadUrl(contextId: $contextId, fileId: $fileId) {
			success
			uploadUrl
			expiresAt
		}
	}
`;

/**
 * __useGetChatFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetChatFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatFileDownloadUrlQuery({
 *   variables: {
 *      contextId: // value for 'contextId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetChatFileDownloadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetChatFileDownloadUrlQuery,
		GetChatFileDownloadUrlQueryVariables
	> &
		({ variables: GetChatFileDownloadUrlQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetChatFileDownloadUrlQuery, GetChatFileDownloadUrlQueryVariables>(
		GetChatFileDownloadUrlDocument,
		options
	);
}
export function useGetChatFileDownloadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetChatFileDownloadUrlQuery,
		GetChatFileDownloadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetChatFileDownloadUrlQuery, GetChatFileDownloadUrlQueryVariables>(
		GetChatFileDownloadUrlDocument,
		options
	);
}
export function useGetChatFileDownloadUrlSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetChatFileDownloadUrlQuery,
				GetChatFileDownloadUrlQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetChatFileDownloadUrlQuery,
		GetChatFileDownloadUrlQueryVariables
	>(GetChatFileDownloadUrlDocument, options);
}
export type GetChatFileDownloadUrlQueryHookResult = ReturnType<
	typeof useGetChatFileDownloadUrlQuery
>;
export type GetChatFileDownloadUrlLazyQueryHookResult = ReturnType<
	typeof useGetChatFileDownloadUrlLazyQuery
>;
export type GetChatFileDownloadUrlSuspenseQueryHookResult = ReturnType<
	typeof useGetChatFileDownloadUrlSuspenseQuery
>;
export type GetChatFileDownloadUrlQueryResult = Apollo.QueryResult<
	GetChatFileDownloadUrlQuery,
	GetChatFileDownloadUrlQueryVariables
>;
export const ListEarlyAccessRequestsDocument = gql`
	query ListEarlyAccessRequests($status: EarlyAccessStatusEnum) {
		listEarlyAccessRequests(status: $status) {
			id
			firstName
			lastName
			email
			status
			createdAt
			approvedAt
			usedAt
		}
	}
`;

/**
 * __useListEarlyAccessRequestsQuery__
 *
 * To run a query within a React component, call `useListEarlyAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEarlyAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEarlyAccessRequestsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListEarlyAccessRequestsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ListEarlyAccessRequestsQuery,
		ListEarlyAccessRequestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ListEarlyAccessRequestsQuery, ListEarlyAccessRequestsQueryVariables>(
		ListEarlyAccessRequestsDocument,
		options
	);
}
export function useListEarlyAccessRequestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ListEarlyAccessRequestsQuery,
		ListEarlyAccessRequestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ListEarlyAccessRequestsQuery, ListEarlyAccessRequestsQueryVariables>(
		ListEarlyAccessRequestsDocument,
		options
	);
}
export function useListEarlyAccessRequestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ListEarlyAccessRequestsQuery,
				ListEarlyAccessRequestsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ListEarlyAccessRequestsQuery,
		ListEarlyAccessRequestsQueryVariables
	>(ListEarlyAccessRequestsDocument, options);
}
export type ListEarlyAccessRequestsQueryHookResult = ReturnType<
	typeof useListEarlyAccessRequestsQuery
>;
export type ListEarlyAccessRequestsLazyQueryHookResult = ReturnType<
	typeof useListEarlyAccessRequestsLazyQuery
>;
export type ListEarlyAccessRequestsSuspenseQueryHookResult = ReturnType<
	typeof useListEarlyAccessRequestsSuspenseQuery
>;
export type ListEarlyAccessRequestsQueryResult = Apollo.QueryResult<
	ListEarlyAccessRequestsQuery,
	ListEarlyAccessRequestsQueryVariables
>;
export const GetEarlyAccessByTokenDocument = gql`
	query GetEarlyAccessByToken($inviteToken: String!) {
		getEarlyAccessByToken(inviteToken: $inviteToken) {
			firstName
			lastName
			email
		}
	}
`;

/**
 * __useGetEarlyAccessByTokenQuery__
 *
 * To run a query within a React component, call `useGetEarlyAccessByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarlyAccessByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarlyAccessByTokenQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useGetEarlyAccessByTokenQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetEarlyAccessByTokenQuery,
		GetEarlyAccessByTokenQueryVariables
	> &
		({ variables: GetEarlyAccessByTokenQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetEarlyAccessByTokenQuery, GetEarlyAccessByTokenQueryVariables>(
		GetEarlyAccessByTokenDocument,
		options
	);
}
export function useGetEarlyAccessByTokenLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetEarlyAccessByTokenQuery,
		GetEarlyAccessByTokenQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetEarlyAccessByTokenQuery, GetEarlyAccessByTokenQueryVariables>(
		GetEarlyAccessByTokenDocument,
		options
	);
}
export function useGetEarlyAccessByTokenSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetEarlyAccessByTokenQuery,
				GetEarlyAccessByTokenQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetEarlyAccessByTokenQuery, GetEarlyAccessByTokenQueryVariables>(
		GetEarlyAccessByTokenDocument,
		options
	);
}
export type GetEarlyAccessByTokenQueryHookResult = ReturnType<typeof useGetEarlyAccessByTokenQuery>;
export type GetEarlyAccessByTokenLazyQueryHookResult = ReturnType<
	typeof useGetEarlyAccessByTokenLazyQuery
>;
export type GetEarlyAccessByTokenSuspenseQueryHookResult = ReturnType<
	typeof useGetEarlyAccessByTokenSuspenseQuery
>;
export type GetEarlyAccessByTokenQueryResult = Apollo.QueryResult<
	GetEarlyAccessByTokenQuery,
	GetEarlyAccessByTokenQueryVariables
>;
export const GetAllProjectsDocument = gql`
	query GetAllProjects($input: GetAllProjectInput!) {
		getAllProjects(input: $input) {
			data {
				id
				name
				description
				startDate
				endDate
				createdAt
				updatedAt
				organization {
					id
					name
				}
				brand {
					id
					name
				}
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
			}
		}
	}
`;

/**
 * __useGetAllProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllProjectsQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables> &
		({ variables: GetAllProjectsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(
		GetAllProjectsDocument,
		options
	);
}
export function useGetAllProjectsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(
		GetAllProjectsDocument,
		options
	);
}
export function useGetAllProjectsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(
		GetAllProjectsDocument,
		options
	);
}
export type GetAllProjectsQueryHookResult = ReturnType<typeof useGetAllProjectsQuery>;
export type GetAllProjectsLazyQueryHookResult = ReturnType<typeof useGetAllProjectsLazyQuery>;
export type GetAllProjectsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllProjectsSuspenseQuery
>;
export type GetAllProjectsQueryResult = Apollo.QueryResult<
	GetAllProjectsQuery,
	GetAllProjectsQueryVariables
>;
export const GetProjectProductsBySessionDocument = gql`
	query GetProjectProductsBySession($sessionId: ID!) {
		getProjectProductsBySession(sessionId: $sessionId) {
			id
			type
			name
			description
			imageUrls
			inspirationImageUrls
			productId
			isProductCreated
			sessionId
			projectId
			organizationId
			remixPrompt
			createdAt
			updatedAt
			product {
				id
				name
				sku
				description
				images {
					id
					url
					isPrimary
					name
				}
			}
		}
	}
`;

/**
 * __useGetProjectProductsBySessionQuery__
 *
 * To run a query within a React component, call `useGetProjectProductsBySessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectProductsBySessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectProductsBySessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetProjectProductsBySessionQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetProjectProductsBySessionQuery,
		GetProjectProductsBySessionQueryVariables
	> &
		(
			| { variables: GetProjectProductsBySessionQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetProjectProductsBySessionQuery,
		GetProjectProductsBySessionQueryVariables
	>(GetProjectProductsBySessionDocument, options);
}
export function useGetProjectProductsBySessionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetProjectProductsBySessionQuery,
		GetProjectProductsBySessionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetProjectProductsBySessionQuery,
		GetProjectProductsBySessionQueryVariables
	>(GetProjectProductsBySessionDocument, options);
}
export function useGetProjectProductsBySessionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetProjectProductsBySessionQuery,
				GetProjectProductsBySessionQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetProjectProductsBySessionQuery,
		GetProjectProductsBySessionQueryVariables
	>(GetProjectProductsBySessionDocument, options);
}
export type GetProjectProductsBySessionQueryHookResult = ReturnType<
	typeof useGetProjectProductsBySessionQuery
>;
export type GetProjectProductsBySessionLazyQueryHookResult = ReturnType<
	typeof useGetProjectProductsBySessionLazyQuery
>;
export type GetProjectProductsBySessionSuspenseQueryHookResult = ReturnType<
	typeof useGetProjectProductsBySessionSuspenseQuery
>;
export type GetProjectProductsBySessionQueryResult = Apollo.QueryResult<
	GetProjectProductsBySessionQuery,
	GetProjectProductsBySessionQueryVariables
>;
export const GetAllLocalizationTimezonesDocument = gql`
	query GetAllLocalizationTimezones {
		getAllLocalizationTimezones {
			name
			offset
		}
	}
`;

/**
 * __useGetAllLocalizationTimezonesQuery__
 *
 * To run a query within a React component, call `useGetAllLocalizationTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocalizationTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocalizationTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocalizationTimezonesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export function useGetAllLocalizationTimezonesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export function useGetAllLocalizationTimezonesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationTimezonesQuery,
				GetAllLocalizationTimezonesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export type GetAllLocalizationTimezonesQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesQuery
>;
export type GetAllLocalizationTimezonesLazyQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesLazyQuery
>;
export type GetAllLocalizationTimezonesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesSuspenseQuery
>;
export type GetAllLocalizationTimezonesQueryResult = Apollo.QueryResult<
	GetAllLocalizationTimezonesQuery,
	GetAllLocalizationTimezonesQueryVariables
>;
export const GetAllLocalizationCountriesDocument = gql`
	query GetAllLocalizationCountries {
		getAllLocalizationCountries {
			code
			name
			currency
			defaultTimezone
			defaultMeasurementSystem
			hasStates
			isEU
			phonePrefix
			nativeName
			registrations {
				code
				label
				placeholder
				helpText
				isRequired
				vatDerivationPattern
			}
			addressFormat {
				postalCodeLabel
				stateLabel
				stateRequired
			}
		}
	}
`;

/**
 * __useGetAllLocalizationCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllLocalizationCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocalizationCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocalizationCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocalizationCountriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export function useGetAllLocalizationCountriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export function useGetAllLocalizationCountriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationCountriesQuery,
				GetAllLocalizationCountriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export type GetAllLocalizationCountriesQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesQuery
>;
export type GetAllLocalizationCountriesLazyQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesLazyQuery
>;
export type GetAllLocalizationCountriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesSuspenseQuery
>;
export type GetAllLocalizationCountriesQueryResult = Apollo.QueryResult<
	GetAllLocalizationCountriesQuery,
	GetAllLocalizationCountriesQueryVariables
>;
export const GetLocalizationCountryDocument = gql`
	query GetLocalizationCountry($countryCode: String!) {
		getLocalizationCountry(countryCode: $countryCode) {
			code
			name
			currency
			defaultTimezone
			defaultMeasurementSystem
			hasStates
			isEU
			phonePrefix
			nativeName
			registrations {
				code
				label
				placeholder
				helpText
				isRequired
				vatDerivationPattern
			}
			addressFormat {
				postalCodeLabel
				stateLabel
				stateRequired
			}
			states {
				code
				name
			}
		}
	}
`;

/**
 * __useGetLocalizationCountryQuery__
 *
 * To run a query within a React component, call `useGetLocalizationCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationCountryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetLocalizationCountryQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	> &
		({ variables: GetLocalizationCountryQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationCountryQuery, GetLocalizationCountryQueryVariables>(
		GetLocalizationCountryDocument,
		options
	);
}
export function useGetLocalizationCountryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationCountryQuery, GetLocalizationCountryQueryVariables>(
		GetLocalizationCountryDocument,
		options
	);
}
export function useGetLocalizationCountrySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationCountryQuery,
				GetLocalizationCountryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	>(GetLocalizationCountryDocument, options);
}
export type GetLocalizationCountryQueryHookResult = ReturnType<
	typeof useGetLocalizationCountryQuery
>;
export type GetLocalizationCountryLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationCountryLazyQuery
>;
export type GetLocalizationCountrySuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationCountrySuspenseQuery
>;
export type GetLocalizationCountryQueryResult = Apollo.QueryResult<
	GetLocalizationCountryQuery,
	GetLocalizationCountryQueryVariables
>;
export const GetLocalizationStatesDocument = gql`
	query GetLocalizationStates($countryCode: String!) {
		getLocalizationStates(countryCode: $countryCode) {
			code
			name
		}
	}
`;

/**
 * __useGetLocalizationStatesQuery__
 *
 * To run a query within a React component, call `useGetLocalizationStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationStatesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetLocalizationStatesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	> &
		({ variables: GetLocalizationStatesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export function useGetLocalizationStatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export function useGetLocalizationStatesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationStatesQuery,
				GetLocalizationStatesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export type GetLocalizationStatesQueryHookResult = ReturnType<typeof useGetLocalizationStatesQuery>;
export type GetLocalizationStatesLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationStatesLazyQuery
>;
export type GetLocalizationStatesSuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationStatesSuspenseQuery
>;
export type GetLocalizationStatesQueryResult = Apollo.QueryResult<
	GetLocalizationStatesQuery,
	GetLocalizationStatesQueryVariables
>;
export const ValidateCvrDocument = gql`
	query ValidateCVR($cvrNumber: String!) {
		validateCVR(cvrNumber: $cvrNumber) {
			valid
			companyInfo {
				name
				vat
				address {
					street
					zipcode
					city
					country
				}
				active
				startDate
				industryCode
				industryDescription
				employees
				phone
				email
			}
			error
		}
	}
`;

/**
 * __useValidateCvrQuery__
 *
 * To run a query within a React component, call `useValidateCvrQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCvrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCvrQuery({
 *   variables: {
 *      cvrNumber: // value for 'cvrNumber'
 *   },
 * });
 */
export function useValidateCvrQuery(
	baseOptions: Apollo.QueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables> &
		({ variables: ValidateCvrQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export function useValidateCvrLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export function useValidateCvrSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export type ValidateCvrQueryHookResult = ReturnType<typeof useValidateCvrQuery>;
export type ValidateCvrLazyQueryHookResult = ReturnType<typeof useValidateCvrLazyQuery>;
export type ValidateCvrSuspenseQueryHookResult = ReturnType<typeof useValidateCvrSuspenseQuery>;
export type ValidateCvrQueryResult = Apollo.QueryResult<
	ValidateCvrQuery,
	ValidateCvrQueryVariables
>;
export const ValidateBusinessRegistrationDocument = gql`
	query ValidateBusinessRegistration(
		$countryCode: String!
		$registrationType: String!
		$registrationNumber: String!
	) {
		validateBusinessRegistration(
			countryCode: $countryCode
			registrationType: $registrationType
			registrationNumber: $registrationNumber
		) {
			valid
			error
		}
	}
`;

/**
 * __useValidateBusinessRegistrationQuery__
 *
 * To run a query within a React component, call `useValidateBusinessRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBusinessRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBusinessRegistrationQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      registrationType: // value for 'registrationType'
 *      registrationNumber: // value for 'registrationNumber'
 *   },
 * });
 */
export function useValidateBusinessRegistrationQuery(
	baseOptions: Apollo.QueryHookOptions<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	> &
		(
			| { variables: ValidateBusinessRegistrationQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>(ValidateBusinessRegistrationDocument, options);
}
export function useValidateBusinessRegistrationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>(ValidateBusinessRegistrationDocument, options);
}
export function useValidateBusinessRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ValidateBusinessRegistrationQuery,
				ValidateBusinessRegistrationQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>(ValidateBusinessRegistrationDocument, options);
}
export type ValidateBusinessRegistrationQueryHookResult = ReturnType<
	typeof useValidateBusinessRegistrationQuery
>;
export type ValidateBusinessRegistrationLazyQueryHookResult = ReturnType<
	typeof useValidateBusinessRegistrationLazyQuery
>;
export type ValidateBusinessRegistrationSuspenseQueryHookResult = ReturnType<
	typeof useValidateBusinessRegistrationSuspenseQuery
>;
export type ValidateBusinessRegistrationQueryResult = Apollo.QueryResult<
	ValidateBusinessRegistrationQuery,
	ValidateBusinessRegistrationQueryVariables
>;
export const AddressAutocompleteDocument = gql`
	query AddressAutocomplete($input: String!, $countryCode: String, $sessionToken: String) {
		addressAutocomplete(input: $input, countryCode: $countryCode, sessionToken: $sessionToken) {
			placeId
			description
			mainText
			secondaryText
		}
	}
`;

/**
 * __useAddressAutocompleteQuery__
 *
 * To run a query within a React component, call `useAddressAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *      countryCode: // value for 'countryCode'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useAddressAutocompleteQuery(
	baseOptions: Apollo.QueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	> &
		({ variables: AddressAutocompleteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export function useAddressAutocompleteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export function useAddressAutocompleteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				AddressAutocompleteQuery,
				AddressAutocompleteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export type AddressAutocompleteQueryHookResult = ReturnType<typeof useAddressAutocompleteQuery>;
export type AddressAutocompleteLazyQueryHookResult = ReturnType<
	typeof useAddressAutocompleteLazyQuery
>;
export type AddressAutocompleteSuspenseQueryHookResult = ReturnType<
	typeof useAddressAutocompleteSuspenseQuery
>;
export type AddressAutocompleteQueryResult = Apollo.QueryResult<
	AddressAutocompleteQuery,
	AddressAutocompleteQueryVariables
>;
export const GetPlaceDetailsDocument = gql`
	query GetPlaceDetails($placeId: String!, $sessionToken: String) {
		getPlaceDetails(placeId: $placeId, sessionToken: $sessionToken) {
			placeId
			formattedAddress
			streetNumber
			streetName
			city
			state
			stateCode
			postalCode
			country
			countryCode
			latitude
			longitude
			timezone
		}
	}
`;

/**
 * __useGetPlaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceDetailsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetPlaceDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables> &
		({ variables: GetPlaceDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export function useGetPlaceDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export function useGetPlaceDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export type GetPlaceDetailsQueryHookResult = ReturnType<typeof useGetPlaceDetailsQuery>;
export type GetPlaceDetailsLazyQueryHookResult = ReturnType<typeof useGetPlaceDetailsLazyQuery>;
export type GetPlaceDetailsSuspenseQueryHookResult = ReturnType<
	typeof useGetPlaceDetailsSuspenseQuery
>;
export type GetPlaceDetailsQueryResult = Apollo.QueryResult<
	GetPlaceDetailsQuery,
	GetPlaceDetailsQueryVariables
>;
export const ValidateAddressDocument = gql`
	query ValidateAddress($placeId: String!) {
		validateAddress(placeId: $placeId) {
			valid
			errors
			warnings
		}
	}
`;

/**
 * __useValidateAddressQuery__
 *
 * To run a query within a React component, call `useValidateAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAddressQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useValidateAddressQuery(
	baseOptions: Apollo.QueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables> &
		({ variables: ValidateAddressQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(
		ValidateAddressDocument,
		options
	);
}
export function useValidateAddressLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(
		ValidateAddressDocument,
		options
	);
}
export function useValidateAddressSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(
		ValidateAddressDocument,
		options
	);
}
export type ValidateAddressQueryHookResult = ReturnType<typeof useValidateAddressQuery>;
export type ValidateAddressLazyQueryHookResult = ReturnType<typeof useValidateAddressLazyQuery>;
export type ValidateAddressSuspenseQueryHookResult = ReturnType<
	typeof useValidateAddressSuspenseQuery
>;
export type ValidateAddressQueryResult = Apollo.QueryResult<
	ValidateAddressQuery,
	ValidateAddressQueryVariables
>;
export const GetLocalizationDefaultsDocument = gql`
	query GetLocalizationDefaults($placeId: String!) {
		getLocalizationDefaults(placeId: $placeId) {
			countryCode
			currency
			measurementSystem
			timezone
		}
	}
`;

/**
 * __useGetLocalizationDefaultsQuery__
 *
 * To run a query within a React component, call `useGetLocalizationDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationDefaultsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useGetLocalizationDefaultsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	> &
		({ variables: GetLocalizationDefaultsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationDefaultsQuery, GetLocalizationDefaultsQueryVariables>(
		GetLocalizationDefaultsDocument,
		options
	);
}
export function useGetLocalizationDefaultsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationDefaultsQuery, GetLocalizationDefaultsQueryVariables>(
		GetLocalizationDefaultsDocument,
		options
	);
}
export function useGetLocalizationDefaultsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationDefaultsQuery,
				GetLocalizationDefaultsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	>(GetLocalizationDefaultsDocument, options);
}
export type GetLocalizationDefaultsQueryHookResult = ReturnType<
	typeof useGetLocalizationDefaultsQuery
>;
export type GetLocalizationDefaultsLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationDefaultsLazyQuery
>;
export type GetLocalizationDefaultsSuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationDefaultsSuspenseQuery
>;
export type GetLocalizationDefaultsQueryResult = Apollo.QueryResult<
	GetLocalizationDefaultsQuery,
	GetLocalizationDefaultsQueryVariables
>;
export const GenerateVatFromRegistrationDocument = gql`
	query GenerateVATFromRegistration(
		$countryCode: String!
		$registrationNumber: String!
		$registrationType: String!
	) {
		generateVATFromRegistration(
			countryCode: $countryCode
			registrationNumber: $registrationNumber
			registrationType: $registrationType
		)
	}
`;

/**
 * __useGenerateVatFromRegistrationQuery__
 *
 * To run a query within a React component, call `useGenerateVatFromRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateVatFromRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateVatFromRegistrationQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      registrationNumber: // value for 'registrationNumber'
 *      registrationType: // value for 'registrationType'
 *   },
 * });
 */
export function useGenerateVatFromRegistrationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	> &
		(
			| { variables: GenerateVatFromRegistrationQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export function useGenerateVatFromRegistrationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export function useGenerateVatFromRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GenerateVatFromRegistrationQuery,
				GenerateVatFromRegistrationQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export type GenerateVatFromRegistrationQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationQuery
>;
export type GenerateVatFromRegistrationLazyQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationLazyQuery
>;
export type GenerateVatFromRegistrationSuspenseQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationSuspenseQuery
>;
export type GenerateVatFromRegistrationQueryResult = Apollo.QueryResult<
	GenerateVatFromRegistrationQuery,
	GenerateVatFromRegistrationQueryVariables
>;
export const GetAllLoggingAuditLogDocument = gql`
	query GetAllLoggingAuditLog($input: GetAllLoggingAuditLogInput!) {
		getAllLoggingAuditLog(input: $input) {
			data {
				id
				action
				changes
				createdAt
				description
				organizationId
				resource
				resourceId
				serviceName
				status
				updatedAt
				userId
				metadata
			}
			pageInfo {
				currentPage
				hasNextPage
				hasPreviousPage
				totalCount
				totalPages
			}
		}
	}
`;

/**
 * __useGetAllLoggingAuditLogQuery__
 *
 * To run a query within a React component, call `useGetAllLoggingAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLoggingAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLoggingAuditLogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllLoggingAuditLogQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllLoggingAuditLogQuery,
		GetAllLoggingAuditLogQueryVariables
	> &
		({ variables: GetAllLoggingAuditLogQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>(
		GetAllLoggingAuditLogDocument,
		options
	);
}
export function useGetAllLoggingAuditLogLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLoggingAuditLogQuery,
		GetAllLoggingAuditLogQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>(
		GetAllLoggingAuditLogDocument,
		options
	);
}
export function useGetAllLoggingAuditLogSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLoggingAuditLogQuery,
				GetAllLoggingAuditLogQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>(
		GetAllLoggingAuditLogDocument,
		options
	);
}
export type GetAllLoggingAuditLogQueryHookResult = ReturnType<typeof useGetAllLoggingAuditLogQuery>;
export type GetAllLoggingAuditLogLazyQueryHookResult = ReturnType<
	typeof useGetAllLoggingAuditLogLazyQuery
>;
export type GetAllLoggingAuditLogSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLoggingAuditLogSuspenseQuery
>;
export type GetAllLoggingAuditLogQueryResult = Apollo.QueryResult<
	GetAllLoggingAuditLogQuery,
	GetAllLoggingAuditLogQueryVariables
>;
export const GetAllLoggingLoginLogDocument = gql`
	query GetAllLoggingLoginLog($input: GetAllLoggingLoginLogInput!) {
		getAllLoggingLoginLog(input: $input) {
			data {
				id
				browser
				createdAt
				failureReason
				ipAddress
				method
				os
				referenceId
				serviceId
				status
				updatedAt
				userAgent
				userId
				user {
					id
					email
					organizationUser {
						id
						firstName
						lastName
					}
				}
			}
			pageInfo {
				currentPage
				hasNextPage
				hasPreviousPage
				totalCount
				totalPages
			}
		}
	}
`;

/**
 * __useGetAllLoggingLoginLogQuery__
 *
 * To run a query within a React component, call `useGetAllLoggingLoginLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLoggingLoginLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLoggingLoginLogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllLoggingLoginLogQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllLoggingLoginLogQuery,
		GetAllLoggingLoginLogQueryVariables
	> &
		({ variables: GetAllLoggingLoginLogQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>(
		GetAllLoggingLoginLogDocument,
		options
	);
}
export function useGetAllLoggingLoginLogLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLoggingLoginLogQuery,
		GetAllLoggingLoginLogQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>(
		GetAllLoggingLoginLogDocument,
		options
	);
}
export function useGetAllLoggingLoginLogSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLoggingLoginLogQuery,
				GetAllLoggingLoginLogQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>(
		GetAllLoggingLoginLogDocument,
		options
	);
}
export type GetAllLoggingLoginLogQueryHookResult = ReturnType<typeof useGetAllLoggingLoginLogQuery>;
export type GetAllLoggingLoginLogLazyQueryHookResult = ReturnType<
	typeof useGetAllLoggingLoginLogLazyQuery
>;
export type GetAllLoggingLoginLogSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLoggingLoginLogSuspenseQuery
>;
export type GetAllLoggingLoginLogQueryResult = Apollo.QueryResult<
	GetAllLoggingLoginLogQuery,
	GetAllLoggingLoginLogQueryVariables
>;
export const GetAllManufacturersDocument = gql`
	query GetAllManufacturers($input: GetAllManufacturerInput!) {
		getAllManufacturer(input: $input) {
			data {
				id
				name
				country
				description
				website
				logoUrl
				isActive
				createdAt
				updatedAt
				vetterEntity {
					id
					name
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllManufacturersQuery__
 *
 * To run a query within a React component, call `useGetAllManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllManufacturersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllManufacturersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllManufacturersQuery,
		GetAllManufacturersQueryVariables
	> &
		({ variables: GetAllManufacturersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(
		GetAllManufacturersDocument,
		options
	);
}
export function useGetAllManufacturersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllManufacturersQuery,
		GetAllManufacturersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(
		GetAllManufacturersDocument,
		options
	);
}
export function useGetAllManufacturersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllManufacturersQuery,
				GetAllManufacturersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllManufacturersQuery, GetAllManufacturersQueryVariables>(
		GetAllManufacturersDocument,
		options
	);
}
export type GetAllManufacturersQueryHookResult = ReturnType<typeof useGetAllManufacturersQuery>;
export type GetAllManufacturersLazyQueryHookResult = ReturnType<
	typeof useGetAllManufacturersLazyQuery
>;
export type GetAllManufacturersSuspenseQueryHookResult = ReturnType<
	typeof useGetAllManufacturersSuspenseQuery
>;
export type GetAllManufacturersQueryResult = Apollo.QueryResult<
	GetAllManufacturersQuery,
	GetAllManufacturersQueryVariables
>;
export const GetManufacturerDocument = gql`
	query GetManufacturer($id: ID!) {
		getManufacturer(id: $id) {
			id
			name
			country
			description
			website
			logoUrl
			isActive
			createdAt
			updatedAt
			vetterEntity {
				id
				name
				description
				isActive
			}
		}
	}
`;

/**
 * __useGetManufacturerQuery__
 *
 * To run a query within a React component, call `useGetManufacturerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManufacturerQuery(
	baseOptions: Apollo.QueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables> &
		({ variables: GetManufacturerQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(
		GetManufacturerDocument,
		options
	);
}
export function useGetManufacturerLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(
		GetManufacturerDocument,
		options
	);
}
export function useGetManufacturerSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetManufacturerQuery, GetManufacturerQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetManufacturerQuery, GetManufacturerQueryVariables>(
		GetManufacturerDocument,
		options
	);
}
export type GetManufacturerQueryHookResult = ReturnType<typeof useGetManufacturerQuery>;
export type GetManufacturerLazyQueryHookResult = ReturnType<typeof useGetManufacturerLazyQuery>;
export type GetManufacturerSuspenseQueryHookResult = ReturnType<
	typeof useGetManufacturerSuspenseQuery
>;
export type GetManufacturerQueryResult = Apollo.QueryResult<
	GetManufacturerQuery,
	GetManufacturerQueryVariables
>;
export const GetOrderStatsV2Document = gql`
	query GetOrderStatsV2($currency: CurrencyEnum, $dateRange: DateRangeInput) {
		getOrderStatsV2(currency: $currency, dateRange: $dateRange) {
			totalOrders
			totalOrderAmount
			averageOrderAmount
			medianOrderAmount
			averageDeliveryAmount
			medianDeliveryAmount
			averageMargin
			medianMargin
			organizationId
		}
	}
`;

/**
 * __useGetOrderStatsV2Query__
 *
 * To run a query within a React component, call `useGetOrderStatsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatsV2Query({
 *   variables: {
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetOrderStatsV2Query(
	baseOptions?: Apollo.QueryHookOptions<GetOrderStatsV2Query, GetOrderStatsV2QueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderStatsV2Query, GetOrderStatsV2QueryVariables>(
		GetOrderStatsV2Document,
		options
	);
}
export function useGetOrderStatsV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrderStatsV2Query, GetOrderStatsV2QueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderStatsV2Query, GetOrderStatsV2QueryVariables>(
		GetOrderStatsV2Document,
		options
	);
}
export function useGetOrderStatsV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrderStatsV2Query, GetOrderStatsV2QueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrderStatsV2Query, GetOrderStatsV2QueryVariables>(
		GetOrderStatsV2Document,
		options
	);
}
export type GetOrderStatsV2QueryHookResult = ReturnType<typeof useGetOrderStatsV2Query>;
export type GetOrderStatsV2LazyQueryHookResult = ReturnType<typeof useGetOrderStatsV2LazyQuery>;
export type GetOrderStatsV2SuspenseQueryHookResult = ReturnType<
	typeof useGetOrderStatsV2SuspenseQuery
>;
export type GetOrderStatsV2QueryResult = Apollo.QueryResult<
	GetOrderStatsV2Query,
	GetOrderStatsV2QueryVariables
>;
export const GetOrderStatsByStatusV2Document = gql`
	query GetOrderStatsByStatusV2(
		$currency: CurrencyEnum
		$dateRange: DateRangeInput
		$vetterEntityIds: [ID!]
	) {
		getOrderStatsByStatusV2(
			currency: $currency
			dateRange: $dateRange
			vetterEntityIds: $vetterEntityIds
		) {
			total
			totalAmount
			organizationId
			statusBreakdown {
				status
				count
				percentage
				totalAmount
			}
		}
	}
`;

/**
 * __useGetOrderStatsByStatusV2Query__
 *
 * To run a query within a React component, call `useGetOrderStatsByStatusV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatsByStatusV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatsByStatusV2Query({
 *   variables: {
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetOrderStatsByStatusV2Query(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrderStatsByStatusV2Query,
		GetOrderStatsByStatusV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderStatsByStatusV2Query, GetOrderStatsByStatusV2QueryVariables>(
		GetOrderStatsByStatusV2Document,
		options
	);
}
export function useGetOrderStatsByStatusV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderStatsByStatusV2Query,
		GetOrderStatsByStatusV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderStatsByStatusV2Query, GetOrderStatsByStatusV2QueryVariables>(
		GetOrderStatsByStatusV2Document,
		options
	);
}
export function useGetOrderStatsByStatusV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderStatsByStatusV2Query,
				GetOrderStatsByStatusV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderStatsByStatusV2Query,
		GetOrderStatsByStatusV2QueryVariables
	>(GetOrderStatsByStatusV2Document, options);
}
export type GetOrderStatsByStatusV2QueryHookResult = ReturnType<
	typeof useGetOrderStatsByStatusV2Query
>;
export type GetOrderStatsByStatusV2LazyQueryHookResult = ReturnType<
	typeof useGetOrderStatsByStatusV2LazyQuery
>;
export type GetOrderStatsByStatusV2SuspenseQueryHookResult = ReturnType<
	typeof useGetOrderStatsByStatusV2SuspenseQuery
>;
export type GetOrderStatsByStatusV2QueryResult = Apollo.QueryResult<
	GetOrderStatsByStatusV2Query,
	GetOrderStatsByStatusV2QueryVariables
>;
export const GetOrganizationSettingDocument = gql`
	query GetOrganizationSetting($organizationId: ID!) {
		getOrganizationSetting(organizationId: $organizationId) {
			id
			measurementSystem
			currency
			timezone
			stripeCheckoutLimit
			invoiceMinimumThreshold
			productPaymentMode
			samplePaymentMode
		}
	}
`;

/**
 * __useGetOrganizationSettingQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationSettingQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	> &
		({ variables: GetOrganizationSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>(
		GetOrganizationSettingDocument,
		options
	);
}
export function useGetOrganizationSettingLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>(
		GetOrganizationSettingDocument,
		options
	);
}
export function useGetOrganizationSettingSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationSettingQuery,
				GetOrganizationSettingQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>(GetOrganizationSettingDocument, options);
}
export type GetOrganizationSettingQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingQuery
>;
export type GetOrganizationSettingLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingLazyQuery
>;
export type GetOrganizationSettingSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingSuspenseQuery
>;
export type GetOrganizationSettingQueryResult = Apollo.QueryResult<
	GetOrganizationSettingQuery,
	GetOrganizationSettingQueryVariables
>;
export const GetOrganizationApprovalAndMarginDocument = gql`
	query GetOrganizationApprovalAndMargin($organizationId: ID!) {
		getOrganizationApprovalAndMargin(organizationId: $organizationId) {
			organizationId
			defaultApproval
			defaultMargin
		}
	}
`;

/**
 * __useGetOrganizationApprovalAndMarginQuery__
 *
 * To run a query within a React component, call `useGetOrganizationApprovalAndMarginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationApprovalAndMarginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationApprovalAndMarginQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationApprovalAndMarginQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	> &
		(
			| { variables: GetOrganizationApprovalAndMarginQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export function useGetOrganizationApprovalAndMarginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export function useGetOrganizationApprovalAndMarginSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationApprovalAndMarginQuery,
				GetOrganizationApprovalAndMarginQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export type GetOrganizationApprovalAndMarginQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginQuery
>;
export type GetOrganizationApprovalAndMarginLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginLazyQuery
>;
export type GetOrganizationApprovalAndMarginSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginSuspenseQuery
>;
export type GetOrganizationApprovalAndMarginQueryResult = Apollo.QueryResult<
	GetOrganizationApprovalAndMarginQuery,
	GetOrganizationApprovalAndMarginQueryVariables
>;
export const GetAllOrganizationUserDocument = gql`
	query GetAllOrganizationUser($input: GetAllOrganizationUserInput!) {
		getAllOrganizationUser(input: $input) {
			data {
				id
				firstName
				lastName
				jobPosition
				avatar
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					lastActive
				}
				authorizationUserRoles {
					id
					userId
					authorizationRoleId
					authorizationRole {
						id
						name
						description
					}
				}
			}
			pageInfo {
				...PageInfoFragment
			}
			errors {
				...ResponseErrorFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
	${ResponseErrorFragmentFragmentDoc}
`;

/**
 * __useGetAllOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	> &
		({ variables: GetAllOrganizationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>(
		GetAllOrganizationUserDocument,
		options
	);
}
export function useGetAllOrganizationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>(
		GetAllOrganizationUserDocument,
		options
	);
}
export function useGetAllOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationUserQuery,
				GetAllOrganizationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>(GetAllOrganizationUserDocument, options);
}
export type GetAllOrganizationUserQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserQuery
>;
export type GetAllOrganizationUserLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserLazyQuery
>;
export type GetAllOrganizationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserSuspenseQuery
>;
export type GetAllOrganizationUserQueryResult = Apollo.QueryResult<
	GetAllOrganizationUserQuery,
	GetAllOrganizationUserQueryVariables
>;
export const GetOrganizationUserDocument = gql`
	query GetOrganizationUser($userId: ID!) {
		getOrganizationUser(userId: $userId) {
			id
			firstName
			lastName
			jobPosition
			authenticationUser {
				id
				email
				role
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationUserQuery,
		GetOrganizationUserQueryVariables
	> &
		({ variables: GetOrganizationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(
		GetOrganizationUserDocument,
		options
	);
}
export function useGetOrganizationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserQuery,
		GetOrganizationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(
		GetOrganizationUserDocument,
		options
	);
}
export function useGetOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserQuery,
				GetOrganizationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(
		GetOrganizationUserDocument,
		options
	);
}
export type GetOrganizationUserQueryHookResult = ReturnType<typeof useGetOrganizationUserQuery>;
export type GetOrganizationUserLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserLazyQuery
>;
export type GetOrganizationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserSuspenseQuery
>;
export type GetOrganizationUserQueryResult = Apollo.QueryResult<
	GetOrganizationUserQuery,
	GetOrganizationUserQueryVariables
>;
export const GetOrganizationDocument = gql`
	query GetOrganization($id: ID!) {
		getOrganization(id: $id) {
			id
			name
			logo
			websiteUrl
			organizationIndustryId
			organizationIndustry {
				id
				name
				isPublished
			}
			createdAt
			updatedAt
			addresses {
				id
				addressLine1
				addressLine2
				addressType
				city
				countryCode
				postalCode
				stateCode
				isPrimary
				name
				googlePlaceId
				latitude
				longitude
			}
		}
	}
`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> &
		({ variables: GetOrganizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export function useGetOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export function useGetOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSuspenseQuery
>;
export type GetOrganizationQueryResult = Apollo.QueryResult<
	GetOrganizationQuery,
	GetOrganizationQueryVariables
>;
export const GetAllOrganizationDocument = gql`
	query GetAllOrganization($input: GetAllOrganizationInput!) {
		getAllOrganization(input: $input) {
			data {
				id
				name
				logo
				websiteUrl
				organizationIndustryId
				organizationIndustry {
					id
					name
					isPublished
				}
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	> &
		({ variables: GetAllOrganizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export function useGetAllOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export function useGetAllOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export type GetAllOrganizationQueryHookResult = ReturnType<typeof useGetAllOrganizationQuery>;
export type GetAllOrganizationLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationLazyQuery
>;
export type GetAllOrganizationSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationSuspenseQuery
>;
export type GetAllOrganizationQueryResult = Apollo.QueryResult<
	GetAllOrganizationQuery,
	GetAllOrganizationQueryVariables
>;
export const GetOrganizationWithSettingsDocument = gql`
	query GetOrganizationWithSettings($organizationId: ID!) {
		getOrganization(id: $organizationId) {
			id
			name
			logo
			websiteUrl
			organizationIndustryId
			organizationIndustry {
				id
				name
				isPublished
			}
			createdAt
			updatedAt
			organizationSetting {
				id
				measurementSystem
				currency
				timezone
			}
			addresses {
				id
				addressLine1
				addressLine2
				addressType
				city
				countryCode
				postalCode
				stateCode
				isPrimary
				name
				googlePlaceId
				latitude
				longitude
			}
		}
	}
`;

/**
 * __useGetOrganizationWithSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationWithSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationWithSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationWithSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationWithSettingsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	> &
		(
			| { variables: GetOrganizationWithSettingsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>(GetOrganizationWithSettingsDocument, options);
}
export function useGetOrganizationWithSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>(GetOrganizationWithSettingsDocument, options);
}
export function useGetOrganizationWithSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationWithSettingsQuery,
				GetOrganizationWithSettingsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>(GetOrganizationWithSettingsDocument, options);
}
export type GetOrganizationWithSettingsQueryHookResult = ReturnType<
	typeof useGetOrganizationWithSettingsQuery
>;
export type GetOrganizationWithSettingsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationWithSettingsLazyQuery
>;
export type GetOrganizationWithSettingsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationWithSettingsSuspenseQuery
>;
export type GetOrganizationWithSettingsQueryResult = Apollo.QueryResult<
	GetOrganizationWithSettingsQuery,
	GetOrganizationWithSettingsQueryVariables
>;
export const GetOrganizationAddressesDocument = gql`
	query GetOrganizationAddresses($organizationId: ID) {
		getOrganizationAddresses(organizationId: $organizationId) {
			id
			name
			addressLine1
			addressLine2
			city
			stateCode
			postalCode
			countryCode
			addressType
			isPrimary
		}
	}
`;

/**
 * __useGetOrganizationAddressesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationAddressesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(
		GetOrganizationAddressesDocument,
		options
	);
}
export function useGetOrganizationAddressesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>(GetOrganizationAddressesDocument, options);
}
export function useGetOrganizationAddressesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationAddressesQuery,
				GetOrganizationAddressesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>(GetOrganizationAddressesDocument, options);
}
export type GetOrganizationAddressesQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesQuery
>;
export type GetOrganizationAddressesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesLazyQuery
>;
export type GetOrganizationAddressesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesSuspenseQuery
>;
export type GetOrganizationAddressesQueryResult = Apollo.QueryResult<
	GetOrganizationAddressesQuery,
	GetOrganizationAddressesQueryVariables
>;
export const GetOrganizationCompliancesDocument = gql`
	query GetOrganizationCompliances($input: OrganizationComplianceListInput!) {
		getOrganizationCompliances(input: $input) {
			data {
				id
				name
				description
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetOrganizationCompliancesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCompliancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCompliancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCompliancesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationCompliancesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationCompliancesQuery,
		GetOrganizationCompliancesQueryVariables
	> &
		(
			| { variables: GetOrganizationCompliancesQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationCompliancesQuery,
		GetOrganizationCompliancesQueryVariables
	>(GetOrganizationCompliancesDocument, options);
}
export function useGetOrganizationCompliancesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationCompliancesQuery,
		GetOrganizationCompliancesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationCompliancesQuery,
		GetOrganizationCompliancesQueryVariables
	>(GetOrganizationCompliancesDocument, options);
}
export function useGetOrganizationCompliancesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationCompliancesQuery,
				GetOrganizationCompliancesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationCompliancesQuery,
		GetOrganizationCompliancesQueryVariables
	>(GetOrganizationCompliancesDocument, options);
}
export type GetOrganizationCompliancesQueryHookResult = ReturnType<
	typeof useGetOrganizationCompliancesQuery
>;
export type GetOrganizationCompliancesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationCompliancesLazyQuery
>;
export type GetOrganizationCompliancesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationCompliancesSuspenseQuery
>;
export type GetOrganizationCompliancesQueryResult = Apollo.QueryResult<
	GetOrganizationCompliancesQuery,
	GetOrganizationCompliancesQueryVariables
>;
export const GetOrganizationSourcingPreferencesDocument = gql`
	query GetOrganizationSourcingPreferences($input: OrganizationSourcingPreferenceListInput!) {
		getOrganizationSourcingPreferences(input: $input) {
			data {
				id
				name
				description
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetOrganizationSourcingPreferencesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSourcingPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSourcingPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSourcingPreferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationSourcingPreferencesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationSourcingPreferencesQuery,
		GetOrganizationSourcingPreferencesQueryVariables
	> &
		(
			| { variables: GetOrganizationSourcingPreferencesQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationSourcingPreferencesQuery,
		GetOrganizationSourcingPreferencesQueryVariables
	>(GetOrganizationSourcingPreferencesDocument, options);
}
export function useGetOrganizationSourcingPreferencesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationSourcingPreferencesQuery,
		GetOrganizationSourcingPreferencesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationSourcingPreferencesQuery,
		GetOrganizationSourcingPreferencesQueryVariables
	>(GetOrganizationSourcingPreferencesDocument, options);
}
export function useGetOrganizationSourcingPreferencesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationSourcingPreferencesQuery,
				GetOrganizationSourcingPreferencesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationSourcingPreferencesQuery,
		GetOrganizationSourcingPreferencesQueryVariables
	>(GetOrganizationSourcingPreferencesDocument, options);
}
export type GetOrganizationSourcingPreferencesQueryHookResult = ReturnType<
	typeof useGetOrganizationSourcingPreferencesQuery
>;
export type GetOrganizationSourcingPreferencesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationSourcingPreferencesLazyQuery
>;
export type GetOrganizationSourcingPreferencesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSourcingPreferencesSuspenseQuery
>;
export type GetOrganizationSourcingPreferencesQueryResult = Apollo.QueryResult<
	GetOrganizationSourcingPreferencesQuery,
	GetOrganizationSourcingPreferencesQueryVariables
>;
export const GetAllOrganizationIndustriesDocument = gql`
	query GetAllOrganizationIndustries {
		getAllOrganizationIndustries {
			id
			name
			isPublished
			createdByOrganizationId
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetAllOrganizationIndustriesQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganizationIndustriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>(GetAllOrganizationIndustriesDocument, options);
}
export function useGetAllOrganizationIndustriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>(GetAllOrganizationIndustriesDocument, options);
}
export function useGetAllOrganizationIndustriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationIndustriesQuery,
				GetAllOrganizationIndustriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationIndustriesQuery,
		GetAllOrganizationIndustriesQueryVariables
	>(GetAllOrganizationIndustriesDocument, options);
}
export type GetAllOrganizationIndustriesQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesQuery
>;
export type GetAllOrganizationIndustriesLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesLazyQuery
>;
export type GetAllOrganizationIndustriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesSuspenseQuery
>;
export type GetAllOrganizationIndustriesQueryResult = Apollo.QueryResult<
	GetAllOrganizationIndustriesQuery,
	GetAllOrganizationIndustriesQueryVariables
>;
export const GetAllOrganizationIndustriesAdminDocument = gql`
	query GetAllOrganizationIndustriesAdmin {
		getAllOrganizationIndustriesAdmin {
			id
			name
			isPublished
			createdByOrganizationId
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetAllOrganizationIndustriesAdminQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationIndustriesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationIndustriesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationIndustriesAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganizationIndustriesAdminQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>(GetAllOrganizationIndustriesAdminDocument, options);
}
export function useGetAllOrganizationIndustriesAdminLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>(GetAllOrganizationIndustriesAdminDocument, options);
}
export function useGetAllOrganizationIndustriesAdminSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationIndustriesAdminQuery,
				GetAllOrganizationIndustriesAdminQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationIndustriesAdminQuery,
		GetAllOrganizationIndustriesAdminQueryVariables
	>(GetAllOrganizationIndustriesAdminDocument, options);
}
export type GetAllOrganizationIndustriesAdminQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesAdminQuery
>;
export type GetAllOrganizationIndustriesAdminLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesAdminLazyQuery
>;
export type GetAllOrganizationIndustriesAdminSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationIndustriesAdminSuspenseQuery
>;
export type GetAllOrganizationIndustriesAdminQueryResult = Apollo.QueryResult<
	GetAllOrganizationIndustriesAdminQuery,
	GetAllOrganizationIndustriesAdminQueryVariables
>;
export const GetOrganizationPreferencesDocument = gql`
	query GetOrganizationPreferences($organizationId: ID!) {
		getOrganizationProductInterests(
			input: { organizationId: $organizationId, pagination: { currentPage: 1, limit: 100 } }
		) {
			data {
				id
				organizationId
				productTagId
			}
		}
		getOrganizationSourcingPreferenceConnections(
			input: { organizationId: $organizationId, pagination: { currentPage: 1, limit: 100 } }
		) {
			data {
				id
				organizationId
				organizationSourcingPreferenceId
				organizationSourcingPreference {
					id
					name
					description
				}
				priority
				notes
			}
		}
		getOrganizationComplianceConnections(
			input: { organizationId: $organizationId, pagination: { currentPage: 1, limit: 100 } }
		) {
			data {
				id
				organizationId
				organizationComplianceId
				organizationCompliance {
					id
					name
					description
				}
				certificationNumber
				issueDate
				expiryDate
				certifyingBody
			}
		}
	}
`;

/**
 * __useGetOrganizationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationPreferencesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationPreferencesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationPreferencesQuery,
		GetOrganizationPreferencesQueryVariables
	> &
		(
			| { variables: GetOrganizationPreferencesQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationPreferencesQuery,
		GetOrganizationPreferencesQueryVariables
	>(GetOrganizationPreferencesDocument, options);
}
export function useGetOrganizationPreferencesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationPreferencesQuery,
		GetOrganizationPreferencesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationPreferencesQuery,
		GetOrganizationPreferencesQueryVariables
	>(GetOrganizationPreferencesDocument, options);
}
export function useGetOrganizationPreferencesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationPreferencesQuery,
				GetOrganizationPreferencesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationPreferencesQuery,
		GetOrganizationPreferencesQueryVariables
	>(GetOrganizationPreferencesDocument, options);
}
export type GetOrganizationPreferencesQueryHookResult = ReturnType<
	typeof useGetOrganizationPreferencesQuery
>;
export type GetOrganizationPreferencesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationPreferencesLazyQuery
>;
export type GetOrganizationPreferencesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationPreferencesSuspenseQuery
>;
export type GetOrganizationPreferencesQueryResult = Apollo.QueryResult<
	GetOrganizationPreferencesQuery,
	GetOrganizationPreferencesQueryVariables
>;
export const GetOrganizationProductInterestsDocument = gql`
	query GetOrganizationProductInterests($input: OrganizationProductInterestListInput!) {
		getOrganizationProductInterests(input: $input) {
			data {
				id
				organizationId
				productTagId
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetOrganizationProductInterestsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProductInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProductInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProductInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationProductInterestsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationProductInterestsQuery,
		GetOrganizationProductInterestsQueryVariables
	> &
		(
			| { variables: GetOrganizationProductInterestsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationProductInterestsQuery,
		GetOrganizationProductInterestsQueryVariables
	>(GetOrganizationProductInterestsDocument, options);
}
export function useGetOrganizationProductInterestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationProductInterestsQuery,
		GetOrganizationProductInterestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationProductInterestsQuery,
		GetOrganizationProductInterestsQueryVariables
	>(GetOrganizationProductInterestsDocument, options);
}
export function useGetOrganizationProductInterestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationProductInterestsQuery,
				GetOrganizationProductInterestsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationProductInterestsQuery,
		GetOrganizationProductInterestsQueryVariables
	>(GetOrganizationProductInterestsDocument, options);
}
export type GetOrganizationProductInterestsQueryHookResult = ReturnType<
	typeof useGetOrganizationProductInterestsQuery
>;
export type GetOrganizationProductInterestsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationProductInterestsLazyQuery
>;
export type GetOrganizationProductInterestsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationProductInterestsSuspenseQuery
>;
export type GetOrganizationProductInterestsQueryResult = Apollo.QueryResult<
	GetOrganizationProductInterestsQuery,
	GetOrganizationProductInterestsQueryVariables
>;
export const GetOrganizationUserAvatarDownloadUrlDocument = gql`
	query GetOrganizationUserAvatarDownloadUrl($input: GetDownloadUrlInput!) {
		getOrganizationUserAvatarDownloadUrl(input: $input) {
			success
			message
			downloadUrl
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;

/**
 * __useGetOrganizationUserAvatarDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserAvatarDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserAvatarDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserAvatarDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationUserAvatarDownloadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	> &
		(
			| { variables: GetOrganizationUserAvatarDownloadUrlQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>(GetOrganizationUserAvatarDownloadUrlDocument, options);
}
export function useGetOrganizationUserAvatarDownloadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>(GetOrganizationUserAvatarDownloadUrlDocument, options);
}
export function useGetOrganizationUserAvatarDownloadUrlSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserAvatarDownloadUrlQuery,
				GetOrganizationUserAvatarDownloadUrlQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>(GetOrganizationUserAvatarDownloadUrlDocument, options);
}
export type GetOrganizationUserAvatarDownloadUrlQueryHookResult = ReturnType<
	typeof useGetOrganizationUserAvatarDownloadUrlQuery
>;
export type GetOrganizationUserAvatarDownloadUrlLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserAvatarDownloadUrlLazyQuery
>;
export type GetOrganizationUserAvatarDownloadUrlSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserAvatarDownloadUrlSuspenseQuery
>;
export type GetOrganizationUserAvatarDownloadUrlQueryResult = Apollo.QueryResult<
	GetOrganizationUserAvatarDownloadUrlQuery,
	GetOrganizationUserAvatarDownloadUrlQueryVariables
>;
export const GetAllProductsDocument = gql`
	query GetAllProducts($input: GetAllProductInput!) {
		getAllProduct(input: $input) {
			data {
				id
				name
				description
				sku
				weight
				status
				dimensions {
					length
					width
					height
					unit
				}
				images {
					id
					url
					name
					isPrimary
					altText
					sortOrder
					mimeType
					size
					uploadedAt
				}
				tags {
					id
					name
					color
				}
				recommendations {
					id
					productId
					type
					title
					description
					actionLabel
					actionUrl
					status
				}
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllProductsQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables> &
		({ variables: GetAllProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(
		GetAllProductsDocument,
		options
	);
}
export function useGetAllProductsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(
		GetAllProductsDocument,
		options
	);
}
export function useGetAllProductsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(
		GetAllProductsDocument,
		options
	);
}
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllProductsSuspenseQuery
>;
export type GetAllProductsQueryResult = Apollo.QueryResult<
	GetAllProductsQuery,
	GetAllProductsQueryVariables
>;
export const GetProductDocument = gql`
	query GetProduct($id: ID!) {
		getProduct(id: $id) {
			id
			name
			description
			sku
			brandId
			weight
			metadata {
				isAIGenerated
				createdFromProject
			}
			dimensions {
				length
				width
				height
				unit
			}
			images {
				id
				url
				name
				type
				isPrimary
				altText
				mimeType
				sortOrder
				metadata {
					type
					x
					y
					width
					height
					points {
						x
						y
					}
					comment
					canvasWidth
					canvasHeight
					attachments {
						fileName
						contentType
						size
						url
					}
				}
			}
			brand {
				id
				name
				brandFiles {
					id
					name
					url
					type
					mimeType
					size
					uploadedAt
				}
			}
			recommendations {
				id
				productId
				type
				title
				description
				actionLabel
				actionUrl
				status
			}
			studioFileId
			studioFile {
				id
				name
				currentVersion {
					id
					imageUrls
					versionNumber
				}
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(
	baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> &
		({ variables: GetProductQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
}
export function useGetProductLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(
		GetProductDocument,
		options
	);
}
export function useGetProductSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(
		GetProductDocument,
		options
	);
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetAllProductTagsDocument = gql`
	query GetAllProductTags($input: GetAllProductTagInput!) {
		getAllProductTag(input: $input) {
			data {
				id
				name
				parentId
				color
				createdAt
				updatedAt
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllProductTagsQuery__
 *
 * To run a query within a React component, call `useGetAllProductTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllProductTagsQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllProductTagsQuery, GetAllProductTagsQueryVariables> &
		({ variables: GetAllProductTagsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllProductTagsQuery, GetAllProductTagsQueryVariables>(
		GetAllProductTagsDocument,
		options
	);
}
export function useGetAllProductTagsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllProductTagsQuery,
		GetAllProductTagsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllProductTagsQuery, GetAllProductTagsQueryVariables>(
		GetAllProductTagsDocument,
		options
	);
}
export function useGetAllProductTagsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllProductTagsQuery, GetAllProductTagsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllProductTagsQuery, GetAllProductTagsQueryVariables>(
		GetAllProductTagsDocument,
		options
	);
}
export type GetAllProductTagsQueryHookResult = ReturnType<typeof useGetAllProductTagsQuery>;
export type GetAllProductTagsLazyQueryHookResult = ReturnType<typeof useGetAllProductTagsLazyQuery>;
export type GetAllProductTagsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllProductTagsSuspenseQuery
>;
export type GetAllProductTagsQueryResult = Apollo.QueryResult<
	GetAllProductTagsQuery,
	GetAllProductTagsQueryVariables
>;
export const GetProjectDocument = gql`
	query GetProject($id: ID!) {
		getProject(id: $id) {
			id
			name
			description
			startDate
			endDate
			createdAt
			updatedAt
			organization {
				id
				name
			}
			brand {
				id
				name
			}
			projectProducts {
				id
				name
				type
				imageUrls
				inspirationImageUrls
				remixPrompt
				productId
				studioFileId
				studioFile {
					id
					name
					currentVersion {
						id
						imageUrls
						versionNumber
					}
				}
				product {
					id
					name
					images {
						url
						isPrimary
					}
				}
				isProductCreated
				isStudioFileCreated
			}
		}
	}
`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(
	baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> &
		({ variables: GetProjectQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
}
export function useGetProjectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(
		GetProjectDocument,
		options
	);
}
export function useGetProjectSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(
		GetProjectDocument,
		options
	);
}
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetQuoteItemOffersStatsV2Document = gql`
	query GetQuoteItemOffersStatsV2($quoteItemV2Id: ID!) {
		getQuoteItemOffersStatsV2(quoteItemV2Id: $quoteItemV2Id) {
			quoteItemV2Id
			totalOffers
			draftOffers
			submittedOffers
			pendingOffers
			acceptedOffers
			rejectedOffers
			cancelledOffers
		}
	}
`;

/**
 * __useGetQuoteItemOffersStatsV2Query__
 *
 * To run a query within a React component, call `useGetQuoteItemOffersStatsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteItemOffersStatsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteItemOffersStatsV2Query({
 *   variables: {
 *      quoteItemV2Id: // value for 'quoteItemV2Id'
 *   },
 * });
 */
export function useGetQuoteItemOffersStatsV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteItemOffersStatsV2Query,
		GetQuoteItemOffersStatsV2QueryVariables
	> &
		({ variables: GetQuoteItemOffersStatsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteItemOffersStatsV2Query, GetQuoteItemOffersStatsV2QueryVariables>(
		GetQuoteItemOffersStatsV2Document,
		options
	);
}
export function useGetQuoteItemOffersStatsV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteItemOffersStatsV2Query,
		GetQuoteItemOffersStatsV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuoteItemOffersStatsV2Query,
		GetQuoteItemOffersStatsV2QueryVariables
	>(GetQuoteItemOffersStatsV2Document, options);
}
export function useGetQuoteItemOffersStatsV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteItemOffersStatsV2Query,
				GetQuoteItemOffersStatsV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteItemOffersStatsV2Query,
		GetQuoteItemOffersStatsV2QueryVariables
	>(GetQuoteItemOffersStatsV2Document, options);
}
export type GetQuoteItemOffersStatsV2QueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersStatsV2Query
>;
export type GetQuoteItemOffersStatsV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersStatsV2LazyQuery
>;
export type GetQuoteItemOffersStatsV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersStatsV2SuspenseQuery
>;
export type GetQuoteItemOffersStatsV2QueryResult = Apollo.QueryResult<
	GetQuoteItemOffersStatsV2Query,
	GetQuoteItemOffersStatsV2QueryVariables
>;
export const GetAllQuoteItemsOffersStatsV2Document = gql`
	query GetAllQuoteItemsOffersStatsV2($quoteV2Id: ID!, $releasedToClient: Boolean) {
		getAllQuoteItemsOffersStatsV2(quoteV2Id: $quoteV2Id, releasedToClient: $releasedToClient) {
			quoteItemV2Id
			totalOffers
			draftOffers
			submittedOffers
			pendingOffers
			acceptedOffers
			rejectedOffers
			cancelledOffers
		}
	}
`;

/**
 * __useGetAllQuoteItemsOffersStatsV2Query__
 *
 * To run a query within a React component, call `useGetAllQuoteItemsOffersStatsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuoteItemsOffersStatsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQuoteItemsOffersStatsV2Query({
 *   variables: {
 *      quoteV2Id: // value for 'quoteV2Id'
 *      releasedToClient: // value for 'releasedToClient'
 *   },
 * });
 */
export function useGetAllQuoteItemsOffersStatsV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetAllQuoteItemsOffersStatsV2Query,
		GetAllQuoteItemsOffersStatsV2QueryVariables
	> &
		(
			| { variables: GetAllQuoteItemsOffersStatsV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllQuoteItemsOffersStatsV2Query,
		GetAllQuoteItemsOffersStatsV2QueryVariables
	>(GetAllQuoteItemsOffersStatsV2Document, options);
}
export function useGetAllQuoteItemsOffersStatsV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllQuoteItemsOffersStatsV2Query,
		GetAllQuoteItemsOffersStatsV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllQuoteItemsOffersStatsV2Query,
		GetAllQuoteItemsOffersStatsV2QueryVariables
	>(GetAllQuoteItemsOffersStatsV2Document, options);
}
export function useGetAllQuoteItemsOffersStatsV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllQuoteItemsOffersStatsV2Query,
				GetAllQuoteItemsOffersStatsV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllQuoteItemsOffersStatsV2Query,
		GetAllQuoteItemsOffersStatsV2QueryVariables
	>(GetAllQuoteItemsOffersStatsV2Document, options);
}
export type GetAllQuoteItemsOffersStatsV2QueryHookResult = ReturnType<
	typeof useGetAllQuoteItemsOffersStatsV2Query
>;
export type GetAllQuoteItemsOffersStatsV2LazyQueryHookResult = ReturnType<
	typeof useGetAllQuoteItemsOffersStatsV2LazyQuery
>;
export type GetAllQuoteItemsOffersStatsV2SuspenseQueryHookResult = ReturnType<
	typeof useGetAllQuoteItemsOffersStatsV2SuspenseQuery
>;
export type GetAllQuoteItemsOffersStatsV2QueryResult = Apollo.QueryResult<
	GetAllQuoteItemsOffersStatsV2Query,
	GetAllQuoteItemsOffersStatsV2QueryVariables
>;
export const GetQuoteItemOffersV2Document = gql`
	query GetQuoteItemOffersV2(
		$quoteItemV2Id: ID!
		$statusFilter: [QuoteOfferStatusV2!]
		$inCurrency: CurrencyEnum
		$releasedToClient: Boolean
	) {
		getQuoteItemOffersV2(
			quoteItemV2Id: $quoteItemV2Id
			statusFilter: $statusFilter
			releasedToClient: $releasedToClient
		) {
			id
			name
			status
			submittedAt
			acceptDeadline
			manufacturerId
			vetterId
			quoteOfferBatchV2Id
			batch {
				id
				name
				status
				acceptDeadlineType
				vetterId
				manufacturerId
				manufacturer {
					id
					name
				}
				vetter {
					id
					firstName
					lastName
				}
			}
			items {
				id
				quoteItemV2Id
				variations(releasedToClient: $releasedToClient) {
					id
					name
					description
					releasedToClient
					attachments {
						id
						name
						url
						size
						mimeType
					}
					adjustments {
						id
						name
						description
						type
						calculationType
						value(inCurrency: $inCurrency)
						createdByType
					}
					sampleChoice {
						id
						choice
						sample {
							id
							adminPrice(inCurrency: $inCurrency)
							baseSamplePrice(inCurrency: $inCurrency)
							baseShippingPrice(inCurrency: $inCurrency)
							deliveryDaysMin
							deliveryDaysMax
							minProductionDays
							maxProductionDays
						}
					}
					quantities(releasedToClient: $releasedToClient) {
						id
						quoteItemQuantityV2Id
						quantity
						releasedToClient
						baseUnitPrice(inCurrency: $inCurrency)
						unitPrice(inCurrency: $inCurrency)
						marginAmount(inCurrency: $inCurrency)
						marginPercentage
						minProductionDays
						maxProductionDays
						deliveries {
							id
							quantity
							basePrice(inCurrency: $inCurrency)
							totalPrice(inCurrency: $inCurrency)
							deliveryDaysMin
							deliveryDaysMax
							shippingMethod
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteItemOffersV2Query__
 *
 * To run a query within a React component, call `useGetQuoteItemOffersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteItemOffersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteItemOffersV2Query({
 *   variables: {
 *      quoteItemV2Id: // value for 'quoteItemV2Id'
 *      statusFilter: // value for 'statusFilter'
 *      inCurrency: // value for 'inCurrency'
 *      releasedToClient: // value for 'releasedToClient'
 *   },
 * });
 */
export function useGetQuoteItemOffersV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteItemOffersV2Query,
		GetQuoteItemOffersV2QueryVariables
	> &
		({ variables: GetQuoteItemOffersV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteItemOffersV2Query, GetQuoteItemOffersV2QueryVariables>(
		GetQuoteItemOffersV2Document,
		options
	);
}
export function useGetQuoteItemOffersV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteItemOffersV2Query,
		GetQuoteItemOffersV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteItemOffersV2Query, GetQuoteItemOffersV2QueryVariables>(
		GetQuoteItemOffersV2Document,
		options
	);
}
export function useGetQuoteItemOffersV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteItemOffersV2Query,
				GetQuoteItemOffersV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetQuoteItemOffersV2Query, GetQuoteItemOffersV2QueryVariables>(
		GetQuoteItemOffersV2Document,
		options
	);
}
export type GetQuoteItemOffersV2QueryHookResult = ReturnType<typeof useGetQuoteItemOffersV2Query>;
export type GetQuoteItemOffersV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersV2LazyQuery
>;
export type GetQuoteItemOffersV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersV2SuspenseQuery
>;
export type GetQuoteItemOffersV2QueryResult = Apollo.QueryResult<
	GetQuoteItemOffersV2Query,
	GetQuoteItemOffersV2QueryVariables
>;
export const GetQuoteOffersForCheckoutV2Document = gql`
	query GetQuoteOffersForCheckoutV2($ids: [ID!]!, $inCurrency: CurrencyEnum) {
		getQuoteOffersV2(ids: $ids) {
			id
			name
			items {
				id
				variations {
					id
					name
					adjustments {
						id
						name
						type
						calculationType
						value(inCurrency: $inCurrency)
					}
					sampleChoice {
						id
						choice
						sample {
							id
							adminPrice(inCurrency: $inCurrency)
						}
					}
					quantities {
						id
						quantity
						baseUnitPrice(inCurrency: $inCurrency)
						unitPrice(inCurrency: $inCurrency)
						totalPrice(inCurrency: $inCurrency)
						adjustedTotalPrice(inCurrency: $inCurrency)
						deliveries {
							id
							totalPrice(inCurrency: $inCurrency)
							shippingMethod
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteOffersForCheckoutV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOffersForCheckoutV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOffersForCheckoutV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOffersForCheckoutV2Query({
 *   variables: {
 *      ids: // value for 'ids'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetQuoteOffersForCheckoutV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOffersForCheckoutV2Query,
		GetQuoteOffersForCheckoutV2QueryVariables
	> &
		(
			| { variables: GetQuoteOffersForCheckoutV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetQuoteOffersForCheckoutV2Query,
		GetQuoteOffersForCheckoutV2QueryVariables
	>(GetQuoteOffersForCheckoutV2Document, options);
}
export function useGetQuoteOffersForCheckoutV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOffersForCheckoutV2Query,
		GetQuoteOffersForCheckoutV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuoteOffersForCheckoutV2Query,
		GetQuoteOffersForCheckoutV2QueryVariables
	>(GetQuoteOffersForCheckoutV2Document, options);
}
export function useGetQuoteOffersForCheckoutV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteOffersForCheckoutV2Query,
				GetQuoteOffersForCheckoutV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteOffersForCheckoutV2Query,
		GetQuoteOffersForCheckoutV2QueryVariables
	>(GetQuoteOffersForCheckoutV2Document, options);
}
export type GetQuoteOffersForCheckoutV2QueryHookResult = ReturnType<
	typeof useGetQuoteOffersForCheckoutV2Query
>;
export type GetQuoteOffersForCheckoutV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteOffersForCheckoutV2LazyQuery
>;
export type GetQuoteOffersForCheckoutV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOffersForCheckoutV2SuspenseQuery
>;
export type GetQuoteOffersForCheckoutV2QueryResult = Apollo.QueryResult<
	GetQuoteOffersForCheckoutV2Query,
	GetQuoteOffersForCheckoutV2QueryVariables
>;
export const GetAllQuoteOrdersV2Document = gql`
	query GetAllQuoteOrdersV2($input: GetAllQuoteOrdersV2Input!, $inCurrency: CurrencyEnum) {
		getAllQuoteOrdersV2(input: $input) {
			data {
				id
				orderNumber
				name
				description
				totalAmount(inCurrency: $inCurrency)
				baseTotalAmount(inCurrency: $inCurrency)
				adjustedTotalAmount(inCurrency: $inCurrency)
				marginTotal(inCurrency: $inCurrency)
				status
				createdAt
				completedAt
				confirmedAt
				acceptDeadline
				organizationId
				quote {
					id
					name
					organization {
						id
						name
					}
				}
				items {
					id
					quantity
				}
			}
			pageInfo {
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllQuoteOrdersV2Query__
 *
 * To run a query within a React component, call `useGetAllQuoteOrdersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuoteOrdersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQuoteOrdersV2Query({
 *   variables: {
 *      input: // value for 'input'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetAllQuoteOrdersV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetAllQuoteOrdersV2Query,
		GetAllQuoteOrdersV2QueryVariables
	> &
		({ variables: GetAllQuoteOrdersV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllQuoteOrdersV2Query, GetAllQuoteOrdersV2QueryVariables>(
		GetAllQuoteOrdersV2Document,
		options
	);
}
export function useGetAllQuoteOrdersV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllQuoteOrdersV2Query,
		GetAllQuoteOrdersV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllQuoteOrdersV2Query, GetAllQuoteOrdersV2QueryVariables>(
		GetAllQuoteOrdersV2Document,
		options
	);
}
export function useGetAllQuoteOrdersV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllQuoteOrdersV2Query,
				GetAllQuoteOrdersV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllQuoteOrdersV2Query, GetAllQuoteOrdersV2QueryVariables>(
		GetAllQuoteOrdersV2Document,
		options
	);
}
export type GetAllQuoteOrdersV2QueryHookResult = ReturnType<typeof useGetAllQuoteOrdersV2Query>;
export type GetAllQuoteOrdersV2LazyQueryHookResult = ReturnType<
	typeof useGetAllQuoteOrdersV2LazyQuery
>;
export type GetAllQuoteOrdersV2SuspenseQueryHookResult = ReturnType<
	typeof useGetAllQuoteOrdersV2SuspenseQuery
>;
export type GetAllQuoteOrdersV2QueryResult = Apollo.QueryResult<
	GetAllQuoteOrdersV2Query,
	GetAllQuoteOrdersV2QueryVariables
>;
export const GetQuoteOrderV2Document = gql`
	query GetQuoteOrderV2($id: ID!, $inCurrency: CurrencyEnum) {
		getQuoteOrderV2(id: $id) {
			id
			orderNumber
			name
			description
			totalAmount(inCurrency: $inCurrency)
			baseTotalAmount(inCurrency: $inCurrency)
			adjustedTotalAmount(inCurrency: $inCurrency)
			marginTotal(inCurrency: $inCurrency)
			status
			createdAt
			updatedAt
			completedAt
			confirmedAt
			acceptDeadline
			organizationId
			stripeCheckoutLimit
			invoiceMinimum
			productPaymentMode
			samplePaymentMode
			invoiceRecipientOrgUserId
			invoiceRecipientEmail
			quote {
				id
				name
				description
				deadline
				deliveryAddress {
					addressLine1
					addressLine2
					city
					stateCode
					postalCode
					countryCode
				}
				organization {
					id
					name
				}
			}
			items {
				id
				quantity
				baseUnitPrice(inCurrency: $inCurrency)
				unitPrice(inCurrency: $inCurrency)
				baseTotalPrice(inCurrency: $inCurrency)
				totalPrice(inCurrency: $inCurrency)
				adjustedTotalPrice(inCurrency: $inCurrency)
				marginAmount(inCurrency: $inCurrency)
				marginPercentage
				notes
				sortOrder
				status
				sampleChoice
				productionStartedAt
				productionCompletedAt
				snapshotAdjustments
				snapshotAttachments
				manufacturerId
				vetterId
				isProductPaymentPaid
				deliveries {
					id
					quantity
					shippingMethod
					deliveryDaysMin
					deliveryDaysMax
					basePrice(inCurrency: $inCurrency)
					adminFee(inCurrency: $inCurrency)
					totalPrice(inCurrency: $inCurrency)
					status
					carrier
					trackingNumber
					estimatedDeliveryDate
					shippedAt
					actualDeliveryDate
					deliveryGroupId
					deliveryGroupName
					offerDelivery {
						id
						variationQuantity {
							id
							minProductionDays
							maxProductionDays
						}
					}
				}
				samples {
					id
					sampleChoice
					sampleRound
					status
					isDeductible
					deliveryMethod
					carrier
					trackingNumber
					estimatedDeliveryDate
					shippedAt
					actualDeliveryDate
					virtualDeliverySubmittedAt
					virtualDelivery {
						sampleId
						submittedAt
						notes
						attachments {
							fileId
							fileName
							fileType
							fileSize
							caption
							uploadedAt
							downloadUrl
							expiresAt
						}
					}
					productionStartedAt
					productionCompletedAt
					samplePrice(inCurrency: $inCurrency)
					shippingPrice(inCurrency: $inCurrency)
					totalSampleCost(inCurrency: $inCurrency)
					adminPrice(inCurrency: $inCurrency)
					adminPriceDkk
					samplePayment {
						id
						createdAt
						description
						samplePrice
						shippingPrice
						totalPrice
						currency
						paidAt
						paymentStatus
						invoice {
							id
							status
							economicBookedInvoiceNumber
						}
					}
					paymentStatus
					currentApproval {
						id
						decision
						approvedAt
						approvalNotes
						requestNewSample
						newSampleRequestStatus
						nextSampleChoice
						reviewedAt
						reviewedByUserId
						reviewHistory {
							at
							actor
							action
							notes
							userId
						}
						rejectionAttachments {
							fileId
							fileName
							fileType
							fileSize
							caption
							uploadedAt
							downloadUrl
							expiresAt
						}
					}
					approvals {
						id
						createdAt
						decision
						approvedAt
						approvalNotes
						requestNewSample
						newSampleRequestStatus
						nextSampleChoice
						reviewedAt
						reviewedByUserId
						approvedByUserId
						reviewHistory {
							at
							actor
							action
							notes
							userId
						}
						rejectionAttachments {
							fileId
							fileName
							fileType
							fileSize
							caption
							uploadedAt
							downloadUrl
							expiresAt
						}
					}
				}
				variationQuantity {
					id
					quantity
					minProductionDays
					maxProductionDays
					variation {
						id
						name
						description
						offerItem {
							id
							quoteOffer {
								id
								name
								manufacturer {
									id
									name
									logoUrl
								}
								vetter {
									id
									firstName
									lastName
								}
							}
							quoteItem {
								id
								deadline
								product {
									id
									name
									sku
									description
									images {
										id
										url
										name
										mimeType
										sortOrder
									}
									brand {
										id
										name
										logo {
											url
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteOrderV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOrderV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOrderV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOrderV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetQuoteOrderV2Query(
	baseOptions: Apollo.QueryHookOptions<GetQuoteOrderV2Query, GetQuoteOrderV2QueryVariables> &
		({ variables: GetQuoteOrderV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteOrderV2Query, GetQuoteOrderV2QueryVariables>(
		GetQuoteOrderV2Document,
		options
	);
}
export function useGetQuoteOrderV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteOrderV2Query, GetQuoteOrderV2QueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteOrderV2Query, GetQuoteOrderV2QueryVariables>(
		GetQuoteOrderV2Document,
		options
	);
}
export function useGetQuoteOrderV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetQuoteOrderV2Query, GetQuoteOrderV2QueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetQuoteOrderV2Query, GetQuoteOrderV2QueryVariables>(
		GetQuoteOrderV2Document,
		options
	);
}
export type GetQuoteOrderV2QueryHookResult = ReturnType<typeof useGetQuoteOrderV2Query>;
export type GetQuoteOrderV2LazyQueryHookResult = ReturnType<typeof useGetQuoteOrderV2LazyQuery>;
export type GetQuoteOrderV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOrderV2SuspenseQuery
>;
export type GetQuoteOrderV2QueryResult = Apollo.QueryResult<
	GetQuoteOrderV2Query,
	GetQuoteOrderV2QueryVariables
>;
export const GetOrderCheckoutLimitV2Document = gql`
	query GetOrderCheckoutLimitV2($orderId: ID!) {
		getOrderCheckoutLimitV2(orderId: $orderId) {
			limit
			invoiceMinimum
			source
		}
	}
`;

/**
 * __useGetOrderCheckoutLimitV2Query__
 *
 * To run a query within a React component, call `useGetOrderCheckoutLimitV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderCheckoutLimitV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderCheckoutLimitV2Query({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderCheckoutLimitV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderCheckoutLimitV2Query,
		GetOrderCheckoutLimitV2QueryVariables
	> &
		({ variables: GetOrderCheckoutLimitV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderCheckoutLimitV2Query, GetOrderCheckoutLimitV2QueryVariables>(
		GetOrderCheckoutLimitV2Document,
		options
	);
}
export function useGetOrderCheckoutLimitV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderCheckoutLimitV2Query,
		GetOrderCheckoutLimitV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderCheckoutLimitV2Query, GetOrderCheckoutLimitV2QueryVariables>(
		GetOrderCheckoutLimitV2Document,
		options
	);
}
export function useGetOrderCheckoutLimitV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderCheckoutLimitV2Query,
				GetOrderCheckoutLimitV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderCheckoutLimitV2Query,
		GetOrderCheckoutLimitV2QueryVariables
	>(GetOrderCheckoutLimitV2Document, options);
}
export type GetOrderCheckoutLimitV2QueryHookResult = ReturnType<
	typeof useGetOrderCheckoutLimitV2Query
>;
export type GetOrderCheckoutLimitV2LazyQueryHookResult = ReturnType<
	typeof useGetOrderCheckoutLimitV2LazyQuery
>;
export type GetOrderCheckoutLimitV2SuspenseQueryHookResult = ReturnType<
	typeof useGetOrderCheckoutLimitV2SuspenseQuery
>;
export type GetOrderCheckoutLimitV2QueryResult = Apollo.QueryResult<
	GetOrderCheckoutLimitV2Query,
	GetOrderCheckoutLimitV2QueryVariables
>;
export const GetProductPaymentPreviewV2Document = gql`
	query GetProductPaymentPreviewV2($orderItemIds: [ID!]!, $currency: String!) {
		getProductPaymentPreviewV2(orderItemIds: $orderItemIds, currency: $currency) {
			currency
			grandTotal
			items {
				orderItemId
				label
				productsAmount
				feesAmount
				fees {
					name
					amount
				}
				deliveryAmount
				deliveries {
					method
					amount
				}
				deductibleAmount
				deductibleSampleCount
				lineSubtotal
				lineNetAmount
			}
		}
	}
`;

/**
 * __useGetProductPaymentPreviewV2Query__
 *
 * To run a query within a React component, call `useGetProductPaymentPreviewV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPaymentPreviewV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPaymentPreviewV2Query({
 *   variables: {
 *      orderItemIds: // value for 'orderItemIds'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetProductPaymentPreviewV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetProductPaymentPreviewV2Query,
		GetProductPaymentPreviewV2QueryVariables
	> &
		(
			| { variables: GetProductPaymentPreviewV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetProductPaymentPreviewV2Query,
		GetProductPaymentPreviewV2QueryVariables
	>(GetProductPaymentPreviewV2Document, options);
}
export function useGetProductPaymentPreviewV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetProductPaymentPreviewV2Query,
		GetProductPaymentPreviewV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetProductPaymentPreviewV2Query,
		GetProductPaymentPreviewV2QueryVariables
	>(GetProductPaymentPreviewV2Document, options);
}
export function useGetProductPaymentPreviewV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetProductPaymentPreviewV2Query,
				GetProductPaymentPreviewV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetProductPaymentPreviewV2Query,
		GetProductPaymentPreviewV2QueryVariables
	>(GetProductPaymentPreviewV2Document, options);
}
export type GetProductPaymentPreviewV2QueryHookResult = ReturnType<
	typeof useGetProductPaymentPreviewV2Query
>;
export type GetProductPaymentPreviewV2LazyQueryHookResult = ReturnType<
	typeof useGetProductPaymentPreviewV2LazyQuery
>;
export type GetProductPaymentPreviewV2SuspenseQueryHookResult = ReturnType<
	typeof useGetProductPaymentPreviewV2SuspenseQuery
>;
export type GetProductPaymentPreviewV2QueryResult = Apollo.QueryResult<
	GetProductPaymentPreviewV2Query,
	GetProductPaymentPreviewV2QueryVariables
>;
export const GetOrderTransactionsV2Document = gql`
	query GetOrderTransactionsV2($orderId: ID!) {
		getOrderTransactionsV2(orderId: $orderId) {
			key
			kind
			date
			descriptions {
				text
				sampleRound
			}
			totalPrice
			currency
			status
			paidAt
			method
			invoiceNumber
			isHistory
			paymentTransactionId
		}
	}
`;

/**
 * __useGetOrderTransactionsV2Query__
 *
 * To run a query within a React component, call `useGetOrderTransactionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderTransactionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderTransactionsV2Query({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderTransactionsV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetOrderTransactionsV2Query,
		GetOrderTransactionsV2QueryVariables
	> &
		({ variables: GetOrderTransactionsV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrderTransactionsV2Query, GetOrderTransactionsV2QueryVariables>(
		GetOrderTransactionsV2Document,
		options
	);
}
export function useGetOrderTransactionsV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrderTransactionsV2Query,
		GetOrderTransactionsV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrderTransactionsV2Query, GetOrderTransactionsV2QueryVariables>(
		GetOrderTransactionsV2Document,
		options
	);
}
export function useGetOrderTransactionsV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrderTransactionsV2Query,
				GetOrderTransactionsV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrderTransactionsV2Query,
		GetOrderTransactionsV2QueryVariables
	>(GetOrderTransactionsV2Document, options);
}
export type GetOrderTransactionsV2QueryHookResult = ReturnType<
	typeof useGetOrderTransactionsV2Query
>;
export type GetOrderTransactionsV2LazyQueryHookResult = ReturnType<
	typeof useGetOrderTransactionsV2LazyQuery
>;
export type GetOrderTransactionsV2SuspenseQueryHookResult = ReturnType<
	typeof useGetOrderTransactionsV2SuspenseQuery
>;
export type GetOrderTransactionsV2QueryResult = Apollo.QueryResult<
	GetOrderTransactionsV2Query,
	GetOrderTransactionsV2QueryVariables
>;
export const GetQuoteOrderTimelineV2Document = gql`
	query GetQuoteOrderTimelineV2($orderId: ID!) {
		getQuoteOrderTimelineV2(orderId: $orderId) {
			orderEvents {
				id
				type
				category
				title
				description
				date
				metadata {
					trackingNumber
					carrier
					shippingMethod
					sampleRound
					deliveryMethod
					approvalDecision
					approvalNotes
					deliveryGroupName
				}
			}
			itemGroups {
				orderItemId
				itemName
				sortOrder
				events {
					id
					type
					category
					title
					description
					date
					metadata {
						trackingNumber
						carrier
						shippingMethod
						sampleRound
						deliveryMethod
						approvalDecision
						approvalNotes
						deliveryGroupName
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteOrderTimelineV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOrderTimelineV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOrderTimelineV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOrderTimelineV2Query({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetQuoteOrderTimelineV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOrderTimelineV2Query,
		GetQuoteOrderTimelineV2QueryVariables
	> &
		({ variables: GetQuoteOrderTimelineV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteOrderTimelineV2Query, GetQuoteOrderTimelineV2QueryVariables>(
		GetQuoteOrderTimelineV2Document,
		options
	);
}
export function useGetQuoteOrderTimelineV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOrderTimelineV2Query,
		GetQuoteOrderTimelineV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteOrderTimelineV2Query, GetQuoteOrderTimelineV2QueryVariables>(
		GetQuoteOrderTimelineV2Document,
		options
	);
}
export function useGetQuoteOrderTimelineV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteOrderTimelineV2Query,
				GetQuoteOrderTimelineV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteOrderTimelineV2Query,
		GetQuoteOrderTimelineV2QueryVariables
	>(GetQuoteOrderTimelineV2Document, options);
}
export type GetQuoteOrderTimelineV2QueryHookResult = ReturnType<
	typeof useGetQuoteOrderTimelineV2Query
>;
export type GetQuoteOrderTimelineV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteOrderTimelineV2LazyQuery
>;
export type GetQuoteOrderTimelineV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOrderTimelineV2SuspenseQuery
>;
export type GetQuoteOrderTimelineV2QueryResult = Apollo.QueryResult<
	GetQuoteOrderTimelineV2Query,
	GetQuoteOrderTimelineV2QueryVariables
>;
export const GetInvoiceableItemsForOrgV2Document = gql`
	query GetInvoiceableItemsForOrgV2($organizationId: ID!, $currency: String!) {
		getInvoiceableItemsForOrgV2(organizationId: $organizationId, currency: $currency) {
			currency
			orders {
				orderId
				orderNumber
				orderName
				productPaymentMode
				samplePaymentMode
				items {
					orderItemId
					orderItem {
						id
						variationQuantity {
							variation {
								offerItem {
									quoteItem {
										product {
											images {
												url
												sortOrder
											}
										}
									}
								}
							}
						}
					}
					description
					quantity
					productAmount
					feesAmount
					fees {
						name
						amount
					}
					deliveryAmount
					deliveries {
						method
						amount
					}
					deductibleAmount
					deductibleSampleCount
					lineSubtotal
					lineNetAmount
					productStatus
					productDraftId
					productEconomicInvoiceNumber
					samples {
						sampleId
						sampleRound
						amount
						isDeductible
						status
						draftId
						economicInvoiceNumber
					}
				}
			}
		}
	}
`;

/**
 * __useGetInvoiceableItemsForOrgV2Query__
 *
 * To run a query within a React component, call `useGetInvoiceableItemsForOrgV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceableItemsForOrgV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceableItemsForOrgV2Query({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetInvoiceableItemsForOrgV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetInvoiceableItemsForOrgV2Query,
		GetInvoiceableItemsForOrgV2QueryVariables
	> &
		(
			| { variables: GetInvoiceableItemsForOrgV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetInvoiceableItemsForOrgV2Query,
		GetInvoiceableItemsForOrgV2QueryVariables
	>(GetInvoiceableItemsForOrgV2Document, options);
}
export function useGetInvoiceableItemsForOrgV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetInvoiceableItemsForOrgV2Query,
		GetInvoiceableItemsForOrgV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetInvoiceableItemsForOrgV2Query,
		GetInvoiceableItemsForOrgV2QueryVariables
	>(GetInvoiceableItemsForOrgV2Document, options);
}
export function useGetInvoiceableItemsForOrgV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetInvoiceableItemsForOrgV2Query,
				GetInvoiceableItemsForOrgV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetInvoiceableItemsForOrgV2Query,
		GetInvoiceableItemsForOrgV2QueryVariables
	>(GetInvoiceableItemsForOrgV2Document, options);
}
export type GetInvoiceableItemsForOrgV2QueryHookResult = ReturnType<
	typeof useGetInvoiceableItemsForOrgV2Query
>;
export type GetInvoiceableItemsForOrgV2LazyQueryHookResult = ReturnType<
	typeof useGetInvoiceableItemsForOrgV2LazyQuery
>;
export type GetInvoiceableItemsForOrgV2SuspenseQueryHookResult = ReturnType<
	typeof useGetInvoiceableItemsForOrgV2SuspenseQuery
>;
export type GetInvoiceableItemsForOrgV2QueryResult = Apollo.QueryResult<
	GetInvoiceableItemsForOrgV2Query,
	GetInvoiceableItemsForOrgV2QueryVariables
>;
export const GetQuoteOrganizationV2Document = gql`
	query GetQuoteOrganizationV2($id: ID!) {
		getQuoteV2(id: $id) {
			id
			name
			description
			deadline
			purpose
			purposeOther
			status
			organizationId
			contactUserIds
			createdAt
			updatedAt
			organization {
				id
				name
			}
			deliveryAddress {
				...DeliveryAddressV2Fragment
			}
			items {
				id
				productId
				sortOrder
				deadline
				product {
					...ProductQuoteFragment
				}
				quantities {
					id
					quantity
					sortOrder
				}
			}
		}
	}
	${DeliveryAddressV2FragmentFragmentDoc}
	${ProductQuoteFragmentFragmentDoc}
`;

/**
 * __useGetQuoteOrganizationV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOrganizationV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOrganizationV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOrganizationV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteOrganizationV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOrganizationV2Query,
		GetQuoteOrganizationV2QueryVariables
	> &
		({ variables: GetQuoteOrganizationV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteOrganizationV2Query, GetQuoteOrganizationV2QueryVariables>(
		GetQuoteOrganizationV2Document,
		options
	);
}
export function useGetQuoteOrganizationV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOrganizationV2Query,
		GetQuoteOrganizationV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteOrganizationV2Query, GetQuoteOrganizationV2QueryVariables>(
		GetQuoteOrganizationV2Document,
		options
	);
}
export function useGetQuoteOrganizationV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteOrganizationV2Query,
				GetQuoteOrganizationV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteOrganizationV2Query,
		GetQuoteOrganizationV2QueryVariables
	>(GetQuoteOrganizationV2Document, options);
}
export type GetQuoteOrganizationV2QueryHookResult = ReturnType<
	typeof useGetQuoteOrganizationV2Query
>;
export type GetQuoteOrganizationV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteOrganizationV2LazyQuery
>;
export type GetQuoteOrganizationV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOrganizationV2SuspenseQuery
>;
export type GetQuoteOrganizationV2QueryResult = Apollo.QueryResult<
	GetQuoteOrganizationV2Query,
	GetQuoteOrganizationV2QueryVariables
>;
export const GetQuoteOfferBatchesOrganizationV2Document = gql`
	query GetQuoteOfferBatchesOrganizationV2(
		$quoteV2Id: ID!
		$statusFilter: [QuoteOfferStatusV2!]
		$inCurrency: CurrencyEnum
	) {
		getQuoteOfferBatchesV2(quoteV2Id: $quoteV2Id, statusFilter: $statusFilter) {
			id
			name
			status
			acceptDeadline
			acceptDeadlineType
			submittedAt
			sentToClientAt
			manufacturerId
			manufacturer {
				id
				name
			}
			createdAt
			updatedAt
			offers {
				id
				items {
					id
					quoteItemV2Id
					variations(releasedToClient: true) {
						id
						name
						description
						attachments {
							id
							name
							url
							size
							mimeType
						}
						adjustments {
							id
							name
							description
							type
							calculationType
							value(inCurrency: $inCurrency)
							createdByType
						}
						sampleChoice {
							id
							choice
							sample {
								id
								adminPrice(inCurrency: $inCurrency)
								totalSamplePrice(inCurrency: $inCurrency)
								deliveryDaysMin
								deliveryDaysMax
								minProductionDays
								maxProductionDays
							}
						}
						quantities(releasedToClient: true) {
							id
							quoteItemQuantityV2Id
							quantity
							unitPrice(inCurrency: $inCurrency)
							totalPrice(inCurrency: $inCurrency)
							minProductionDays
							maxProductionDays
							deliveries {
								id
								quantity
								totalPrice(inCurrency: $inCurrency)
								deliveryDaysMin
								deliveryDaysMax
								shippingMethod
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteOfferBatchesOrganizationV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOfferBatchesOrganizationV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOfferBatchesOrganizationV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOfferBatchesOrganizationV2Query({
 *   variables: {
 *      quoteV2Id: // value for 'quoteV2Id'
 *      statusFilter: // value for 'statusFilter'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetQuoteOfferBatchesOrganizationV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOfferBatchesOrganizationV2Query,
		GetQuoteOfferBatchesOrganizationV2QueryVariables
	> &
		(
			| { variables: GetQuoteOfferBatchesOrganizationV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetQuoteOfferBatchesOrganizationV2Query,
		GetQuoteOfferBatchesOrganizationV2QueryVariables
	>(GetQuoteOfferBatchesOrganizationV2Document, options);
}
export function useGetQuoteOfferBatchesOrganizationV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOfferBatchesOrganizationV2Query,
		GetQuoteOfferBatchesOrganizationV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuoteOfferBatchesOrganizationV2Query,
		GetQuoteOfferBatchesOrganizationV2QueryVariables
	>(GetQuoteOfferBatchesOrganizationV2Document, options);
}
export function useGetQuoteOfferBatchesOrganizationV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteOfferBatchesOrganizationV2Query,
				GetQuoteOfferBatchesOrganizationV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteOfferBatchesOrganizationV2Query,
		GetQuoteOfferBatchesOrganizationV2QueryVariables
	>(GetQuoteOfferBatchesOrganizationV2Document, options);
}
export type GetQuoteOfferBatchesOrganizationV2QueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchesOrganizationV2Query
>;
export type GetQuoteOfferBatchesOrganizationV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchesOrganizationV2LazyQuery
>;
export type GetQuoteOfferBatchesOrganizationV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchesOrganizationV2SuspenseQuery
>;
export type GetQuoteOfferBatchesOrganizationV2QueryResult = Apollo.QueryResult<
	GetQuoteOfferBatchesOrganizationV2Query,
	GetQuoteOfferBatchesOrganizationV2QueryVariables
>;
export const GetQuoteItemOffersOrganizationV2Document = gql`
	query GetQuoteItemOffersOrganizationV2(
		$quoteItemV2Id: ID!
		$statusFilter: [QuoteOfferStatusV2!]
		$inCurrency: CurrencyEnum
	) {
		getQuoteItemOffersV2(
			quoteItemV2Id: $quoteItemV2Id
			statusFilter: $statusFilter
			releasedToClient: true
		) {
			id
			name
			status
			acceptDeadline
			submittedAt
			sentToClientAt
			quoteOfferBatchV2Id
			batch {
				id
				name
				acceptDeadlineType
			}
			manufacturerId
			manufacturer {
				id
				name
				logoUrl
			}
			createdAt
			updatedAt
			items {
				id
				quoteItemV2Id
				variations(releasedToClient: true) {
					id
					name
					description
					attachments {
						id
						name
						url
						size
						mimeType
					}
					adjustments {
						id
						name
						description
						type
						calculationType
						value(inCurrency: $inCurrency)
						createdByType
					}
					sampleChoice {
						id
						choice
						sample {
							id
							adminPrice(inCurrency: $inCurrency)
							totalSamplePrice(inCurrency: $inCurrency)
							deliveryDaysMin
							deliveryDaysMax
							minProductionDays
							maxProductionDays
						}
					}
					quantities(releasedToClient: true) {
						id
						quoteItemQuantityV2Id
						quantity
						unitPrice(inCurrency: $inCurrency)
						totalPrice(inCurrency: $inCurrency)
						minProductionDays
						maxProductionDays
						deliveries {
							id
							quantity
							totalPrice(inCurrency: $inCurrency)
							deliveryDaysMin
							deliveryDaysMax
							shippingMethod
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteItemOffersOrganizationV2Query__
 *
 * To run a query within a React component, call `useGetQuoteItemOffersOrganizationV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteItemOffersOrganizationV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteItemOffersOrganizationV2Query({
 *   variables: {
 *      quoteItemV2Id: // value for 'quoteItemV2Id'
 *      statusFilter: // value for 'statusFilter'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetQuoteItemOffersOrganizationV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteItemOffersOrganizationV2Query,
		GetQuoteItemOffersOrganizationV2QueryVariables
	> &
		(
			| { variables: GetQuoteItemOffersOrganizationV2QueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetQuoteItemOffersOrganizationV2Query,
		GetQuoteItemOffersOrganizationV2QueryVariables
	>(GetQuoteItemOffersOrganizationV2Document, options);
}
export function useGetQuoteItemOffersOrganizationV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteItemOffersOrganizationV2Query,
		GetQuoteItemOffersOrganizationV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuoteItemOffersOrganizationV2Query,
		GetQuoteItemOffersOrganizationV2QueryVariables
	>(GetQuoteItemOffersOrganizationV2Document, options);
}
export function useGetQuoteItemOffersOrganizationV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteItemOffersOrganizationV2Query,
				GetQuoteItemOffersOrganizationV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteItemOffersOrganizationV2Query,
		GetQuoteItemOffersOrganizationV2QueryVariables
	>(GetQuoteItemOffersOrganizationV2Document, options);
}
export type GetQuoteItemOffersOrganizationV2QueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersOrganizationV2Query
>;
export type GetQuoteItemOffersOrganizationV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersOrganizationV2LazyQuery
>;
export type GetQuoteItemOffersOrganizationV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteItemOffersOrganizationV2SuspenseQuery
>;
export type GetQuoteItemOffersOrganizationV2QueryResult = Apollo.QueryResult<
	GetQuoteItemOffersOrganizationV2Query,
	GetQuoteItemOffersOrganizationV2QueryVariables
>;
export const GetQuoteV2Document = gql`
	query GetQuoteV2($id: ID!) {
		getQuoteV2(id: $id) {
			id
			name
			description
			deadline
			purpose
			purposeOther
			status
			organizationId
			contactUserIds
			isCurrentForMe
			createdAt
			updatedAt
			vetterEntityIds
			organization {
				id
				name
			}
			deliveryAddress {
				...DeliveryAddressV2Fragment
			}
			items {
				id
				productId
				sortOrder
				deadline
				product {
					...ProductQuoteFragment
				}
				quantities {
					id
					quantity
					sortOrder
				}
			}
		}
	}
	${DeliveryAddressV2FragmentFragmentDoc}
	${ProductQuoteFragmentFragmentDoc}
`;

/**
 * __useGetQuoteV2Query__
 *
 * To run a query within a React component, call `useGetQuoteV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteV2Query(
	baseOptions: Apollo.QueryHookOptions<GetQuoteV2Query, GetQuoteV2QueryVariables> &
		({ variables: GetQuoteV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteV2Query, GetQuoteV2QueryVariables>(GetQuoteV2Document, options);
}
export function useGetQuoteV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteV2Query, GetQuoteV2QueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteV2Query, GetQuoteV2QueryVariables>(
		GetQuoteV2Document,
		options
	);
}
export function useGetQuoteV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetQuoteV2Query, GetQuoteV2QueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetQuoteV2Query, GetQuoteV2QueryVariables>(
		GetQuoteV2Document,
		options
	);
}
export type GetQuoteV2QueryHookResult = ReturnType<typeof useGetQuoteV2Query>;
export type GetQuoteV2LazyQueryHookResult = ReturnType<typeof useGetQuoteV2LazyQuery>;
export type GetQuoteV2SuspenseQueryHookResult = ReturnType<typeof useGetQuoteV2SuspenseQuery>;
export type GetQuoteV2QueryResult = Apollo.QueryResult<GetQuoteV2Query, GetQuoteV2QueryVariables>;
export const GetCurrentQuoteV2Document = gql`
	query GetCurrentQuoteV2 {
		getCurrentQuoteV2 {
			id
			name
			description
			deadline
			status
			organizationId
			isCurrentForMe
			createdAt
			updatedAt
			items {
				id
				productId
				sortOrder
				deadline
				product {
					...ProductBasicFragment
				}
				quantities {
					id
					quantity
					sortOrder
				}
			}
		}
	}
	${ProductBasicFragmentFragmentDoc}
`;

/**
 * __useGetCurrentQuoteV2Query__
 *
 * To run a query within a React component, call `useGetCurrentQuoteV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentQuoteV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentQuoteV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentQuoteV2Query(
	baseOptions?: Apollo.QueryHookOptions<GetCurrentQuoteV2Query, GetCurrentQuoteV2QueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetCurrentQuoteV2Query, GetCurrentQuoteV2QueryVariables>(
		GetCurrentQuoteV2Document,
		options
	);
}
export function useGetCurrentQuoteV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetCurrentQuoteV2Query,
		GetCurrentQuoteV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetCurrentQuoteV2Query, GetCurrentQuoteV2QueryVariables>(
		GetCurrentQuoteV2Document,
		options
	);
}
export function useGetCurrentQuoteV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetCurrentQuoteV2Query, GetCurrentQuoteV2QueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetCurrentQuoteV2Query, GetCurrentQuoteV2QueryVariables>(
		GetCurrentQuoteV2Document,
		options
	);
}
export type GetCurrentQuoteV2QueryHookResult = ReturnType<typeof useGetCurrentQuoteV2Query>;
export type GetCurrentQuoteV2LazyQueryHookResult = ReturnType<typeof useGetCurrentQuoteV2LazyQuery>;
export type GetCurrentQuoteV2SuspenseQueryHookResult = ReturnType<
	typeof useGetCurrentQuoteV2SuspenseQuery
>;
export type GetCurrentQuoteV2QueryResult = Apollo.QueryResult<
	GetCurrentQuoteV2Query,
	GetCurrentQuoteV2QueryVariables
>;
export const GetCurrentQuoteV2CountDocument = gql`
	query GetCurrentQuoteV2Count {
		getCurrentQuoteV2 {
			id
			organizationId
			items {
				id
				productId
				product {
					...ProductBasicFragment
				}
			}
		}
	}
	${ProductBasicFragmentFragmentDoc}
`;

/**
 * __useGetCurrentQuoteV2CountQuery__
 *
 * To run a query within a React component, call `useGetCurrentQuoteV2CountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentQuoteV2CountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentQuoteV2CountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentQuoteV2CountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetCurrentQuoteV2CountQuery,
		GetCurrentQuoteV2CountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetCurrentQuoteV2CountQuery, GetCurrentQuoteV2CountQueryVariables>(
		GetCurrentQuoteV2CountDocument,
		options
	);
}
export function useGetCurrentQuoteV2CountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetCurrentQuoteV2CountQuery,
		GetCurrentQuoteV2CountQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetCurrentQuoteV2CountQuery, GetCurrentQuoteV2CountQueryVariables>(
		GetCurrentQuoteV2CountDocument,
		options
	);
}
export function useGetCurrentQuoteV2CountSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetCurrentQuoteV2CountQuery,
				GetCurrentQuoteV2CountQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetCurrentQuoteV2CountQuery,
		GetCurrentQuoteV2CountQueryVariables
	>(GetCurrentQuoteV2CountDocument, options);
}
export type GetCurrentQuoteV2CountQueryHookResult = ReturnType<
	typeof useGetCurrentQuoteV2CountQuery
>;
export type GetCurrentQuoteV2CountLazyQueryHookResult = ReturnType<
	typeof useGetCurrentQuoteV2CountLazyQuery
>;
export type GetCurrentQuoteV2CountSuspenseQueryHookResult = ReturnType<
	typeof useGetCurrentQuoteV2CountSuspenseQuery
>;
export type GetCurrentQuoteV2CountQueryResult = Apollo.QueryResult<
	GetCurrentQuoteV2CountQuery,
	GetCurrentQuoteV2CountQueryVariables
>;
export const GetAllQuotesV2Document = gql`
	query GetAllQuotesV2($input: GetAllQuotesV2Input!) {
		getAllQuotesV2(input: $input) {
			data {
				id
				name
				description
				deadline
				status
				organizationId
				organization {
					id
					name
				}
				isCurrentForMe
				createdAt
				updatedAt
				items {
					id
					deadline
				}
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
			}
		}
	}
`;

/**
 * __useGetAllQuotesV2Query__
 *
 * To run a query within a React component, call `useGetAllQuotesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuotesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQuotesV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllQuotesV2Query(
	baseOptions: Apollo.QueryHookOptions<GetAllQuotesV2Query, GetAllQuotesV2QueryVariables> &
		({ variables: GetAllQuotesV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllQuotesV2Query, GetAllQuotesV2QueryVariables>(
		GetAllQuotesV2Document,
		options
	);
}
export function useGetAllQuotesV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllQuotesV2Query, GetAllQuotesV2QueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllQuotesV2Query, GetAllQuotesV2QueryVariables>(
		GetAllQuotesV2Document,
		options
	);
}
export function useGetAllQuotesV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllQuotesV2Query, GetAllQuotesV2QueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllQuotesV2Query, GetAllQuotesV2QueryVariables>(
		GetAllQuotesV2Document,
		options
	);
}
export type GetAllQuotesV2QueryHookResult = ReturnType<typeof useGetAllQuotesV2Query>;
export type GetAllQuotesV2LazyQueryHookResult = ReturnType<typeof useGetAllQuotesV2LazyQuery>;
export type GetAllQuotesV2SuspenseQueryHookResult = ReturnType<
	typeof useGetAllQuotesV2SuspenseQuery
>;
export type GetAllQuotesV2QueryResult = Apollo.QueryResult<
	GetAllQuotesV2Query,
	GetAllQuotesV2QueryVariables
>;
export const GetQuoteOfferBatchesV2Document = gql`
	query GetQuoteOfferBatchesV2(
		$quoteV2Id: ID!
		$statusFilter: [QuoteOfferStatusV2!]
		$inCurrency: CurrencyEnum
	) {
		getQuoteOfferBatchesV2(quoteV2Id: $quoteV2Id, statusFilter: $statusFilter) {
			id
			name
			status
			acceptDeadline
			acceptDeadlineType
			submittedAt
			sentToClientAt
			totalVariationsCount
			releasedVariationsCount
			manufacturerId
			manufacturer {
				id
				name
			}
			vetterId
			vetter {
				id
				firstName
				lastName
			}
			createdAt
			updatedAt
			offers {
				id
				items {
					id
					quoteItemV2Id
					variations {
						id
						name
						description
						attachments {
							id
							name
							url
							size
							mimeType
						}
						adjustments {
							id
							name
							description
							type
							calculationType
							value(inCurrency: $inCurrency)
							createdByType
						}
						sampleChoice {
							id
							choice
							sample {
								id
								baseSamplePrice(inCurrency: $inCurrency)
								baseShippingPrice(inCurrency: $inCurrency)
								deliveryDaysMin
								deliveryDaysMax
								minProductionDays
								maxProductionDays
							}
						}
						quantities {
							id
							quoteItemQuantityV2Id
							quantity
							baseUnitPrice(inCurrency: $inCurrency)
							unitPrice(inCurrency: $inCurrency)
							totalPrice(inCurrency: $inCurrency)
							marginAmount(inCurrency: $inCurrency)
							marginPercentage
							minProductionDays
							maxProductionDays
							deliveries {
								id
								quantity
								basePrice(inCurrency: $inCurrency)
								deliveryDaysMin
								deliveryDaysMax
								shippingMethod
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteOfferBatchesV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOfferBatchesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOfferBatchesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOfferBatchesV2Query({
 *   variables: {
 *      quoteV2Id: // value for 'quoteV2Id'
 *      statusFilter: // value for 'statusFilter'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetQuoteOfferBatchesV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOfferBatchesV2Query,
		GetQuoteOfferBatchesV2QueryVariables
	> &
		({ variables: GetQuoteOfferBatchesV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteOfferBatchesV2Query, GetQuoteOfferBatchesV2QueryVariables>(
		GetQuoteOfferBatchesV2Document,
		options
	);
}
export function useGetQuoteOfferBatchesV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOfferBatchesV2Query,
		GetQuoteOfferBatchesV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteOfferBatchesV2Query, GetQuoteOfferBatchesV2QueryVariables>(
		GetQuoteOfferBatchesV2Document,
		options
	);
}
export function useGetQuoteOfferBatchesV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteOfferBatchesV2Query,
				GetQuoteOfferBatchesV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteOfferBatchesV2Query,
		GetQuoteOfferBatchesV2QueryVariables
	>(GetQuoteOfferBatchesV2Document, options);
}
export type GetQuoteOfferBatchesV2QueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchesV2Query
>;
export type GetQuoteOfferBatchesV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchesV2LazyQuery
>;
export type GetQuoteOfferBatchesV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchesV2SuspenseQuery
>;
export type GetQuoteOfferBatchesV2QueryResult = Apollo.QueryResult<
	GetQuoteOfferBatchesV2Query,
	GetQuoteOfferBatchesV2QueryVariables
>;
export const GetQuoteOfferBatchV2Document = gql`
	query GetQuoteOfferBatchV2($id: ID!, $inCurrency: CurrencyEnum) {
		getQuoteOfferBatchV2(id: $id) {
			id
			name
			status
			acceptDeadline
			acceptDeadlineType
			manufacturerId
			vetterId
			quoteV2Id
			offers {
				id
				items {
					id
					quoteItemV2Id
					variations {
						id
						name
						description
						releasedToClient
						attachments {
							id
							name
							url
							size
							mimeType
						}
						adjustments {
							id
							name
							description
							type
							calculationType
							value(inCurrency: $inCurrency)
							createdByType
						}
						sampleChoice {
							id
							choice
							sample {
								id
								baseSamplePrice(inCurrency: $inCurrency)
								baseShippingPrice(inCurrency: $inCurrency)
								deliveryDaysMin
								deliveryDaysMax
								minProductionDays
								maxProductionDays
							}
						}
						quantities {
							id
							quoteItemQuantityV2Id
							quantity
							releasedToClient
							baseUnitPrice(inCurrency: $inCurrency)
							minProductionDays
							maxProductionDays
							deliveries {
								id
								quantity
								basePrice(inCurrency: $inCurrency)
								deliveryDaysMin
								deliveryDaysMax
								shippingMethod
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * __useGetQuoteOfferBatchV2Query__
 *
 * To run a query within a React component, call `useGetQuoteOfferBatchV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteOfferBatchV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteOfferBatchV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      inCurrency: // value for 'inCurrency'
 *   },
 * });
 */
export function useGetQuoteOfferBatchV2Query(
	baseOptions: Apollo.QueryHookOptions<
		GetQuoteOfferBatchV2Query,
		GetQuoteOfferBatchV2QueryVariables
	> &
		({ variables: GetQuoteOfferBatchV2QueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteOfferBatchV2Query, GetQuoteOfferBatchV2QueryVariables>(
		GetQuoteOfferBatchV2Document,
		options
	);
}
export function useGetQuoteOfferBatchV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteOfferBatchV2Query,
		GetQuoteOfferBatchV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteOfferBatchV2Query, GetQuoteOfferBatchV2QueryVariables>(
		GetQuoteOfferBatchV2Document,
		options
	);
}
export function useGetQuoteOfferBatchV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteOfferBatchV2Query,
				GetQuoteOfferBatchV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetQuoteOfferBatchV2Query, GetQuoteOfferBatchV2QueryVariables>(
		GetQuoteOfferBatchV2Document,
		options
	);
}
export type GetQuoteOfferBatchV2QueryHookResult = ReturnType<typeof useGetQuoteOfferBatchV2Query>;
export type GetQuoteOfferBatchV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchV2LazyQuery
>;
export type GetQuoteOfferBatchV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteOfferBatchV2SuspenseQuery
>;
export type GetQuoteOfferBatchV2QueryResult = Apollo.QueryResult<
	GetQuoteOfferBatchV2Query,
	GetQuoteOfferBatchV2QueryVariables
>;
export const GetRecentQuotesSharedV2Document = gql`
	query GetRecentQuotesSharedV2(
		$limit: Int
		$currency: CurrencyEnum
		$dateRange: DateRangeInput
		$vetterEntityIds: [ID!]
	) {
		getRecentQuotesV2(
			limit: $limit
			currency: $currency
			dateRange: $dateRange
			vetterEntityIds: $vetterEntityIds
		) {
			id
			name
			status
			createdAt
			organization {
				id
				name
			}
			items {
				product {
					name
					images {
						url
						name
						isPrimary
					}
				}
			}
		}
	}
`;

/**
 * __useGetRecentQuotesSharedV2Query__
 *
 * To run a query within a React component, call `useGetRecentQuotesSharedV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentQuotesSharedV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentQuotesSharedV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetRecentQuotesSharedV2Query(
	baseOptions?: Apollo.QueryHookOptions<
		GetRecentQuotesSharedV2Query,
		GetRecentQuotesSharedV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetRecentQuotesSharedV2Query, GetRecentQuotesSharedV2QueryVariables>(
		GetRecentQuotesSharedV2Document,
		options
	);
}
export function useGetRecentQuotesSharedV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetRecentQuotesSharedV2Query,
		GetRecentQuotesSharedV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetRecentQuotesSharedV2Query, GetRecentQuotesSharedV2QueryVariables>(
		GetRecentQuotesSharedV2Document,
		options
	);
}
export function useGetRecentQuotesSharedV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetRecentQuotesSharedV2Query,
				GetRecentQuotesSharedV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetRecentQuotesSharedV2Query,
		GetRecentQuotesSharedV2QueryVariables
	>(GetRecentQuotesSharedV2Document, options);
}
export type GetRecentQuotesSharedV2QueryHookResult = ReturnType<
	typeof useGetRecentQuotesSharedV2Query
>;
export type GetRecentQuotesSharedV2LazyQueryHookResult = ReturnType<
	typeof useGetRecentQuotesSharedV2LazyQuery
>;
export type GetRecentQuotesSharedV2SuspenseQueryHookResult = ReturnType<
	typeof useGetRecentQuotesSharedV2SuspenseQuery
>;
export type GetRecentQuotesSharedV2QueryResult = Apollo.QueryResult<
	GetRecentQuotesSharedV2Query,
	GetRecentQuotesSharedV2QueryVariables
>;
export const GetRecentOrdersSharedV2Document = gql`
	query GetRecentOrdersSharedV2(
		$limit: Int
		$currency: CurrencyEnum
		$dateRange: DateRangeInput
		$vetterEntityIds: [ID!]
	) {
		getRecentOrdersV2(
			limit: $limit
			currency: $currency
			dateRange: $dateRange
			vetterEntityIds: $vetterEntityIds
		) {
			id
			name
			status
			createdAt
			totalAmount(inCurrency: $currency)
			quote {
				id
				name
				items {
					product {
						name
						images {
							url
							name
							isPrimary
						}
					}
				}
			}
			organization {
				id
				name
			}
		}
	}
`;

/**
 * __useGetRecentOrdersSharedV2Query__
 *
 * To run a query within a React component, call `useGetRecentOrdersSharedV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentOrdersSharedV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentOrdersSharedV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetRecentOrdersSharedV2Query(
	baseOptions?: Apollo.QueryHookOptions<
		GetRecentOrdersSharedV2Query,
		GetRecentOrdersSharedV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetRecentOrdersSharedV2Query, GetRecentOrdersSharedV2QueryVariables>(
		GetRecentOrdersSharedV2Document,
		options
	);
}
export function useGetRecentOrdersSharedV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetRecentOrdersSharedV2Query,
		GetRecentOrdersSharedV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetRecentOrdersSharedV2Query, GetRecentOrdersSharedV2QueryVariables>(
		GetRecentOrdersSharedV2Document,
		options
	);
}
export function useGetRecentOrdersSharedV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetRecentOrdersSharedV2Query,
				GetRecentOrdersSharedV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetRecentOrdersSharedV2Query,
		GetRecentOrdersSharedV2QueryVariables
	>(GetRecentOrdersSharedV2Document, options);
}
export type GetRecentOrdersSharedV2QueryHookResult = ReturnType<
	typeof useGetRecentOrdersSharedV2Query
>;
export type GetRecentOrdersSharedV2LazyQueryHookResult = ReturnType<
	typeof useGetRecentOrdersSharedV2LazyQuery
>;
export type GetRecentOrdersSharedV2SuspenseQueryHookResult = ReturnType<
	typeof useGetRecentOrdersSharedV2SuspenseQuery
>;
export type GetRecentOrdersSharedV2QueryResult = Apollo.QueryResult<
	GetRecentOrdersSharedV2Query,
	GetRecentOrdersSharedV2QueryVariables
>;
export const GetQuoteStatsByStatusV2Document = gql`
	query GetQuoteStatsByStatusV2(
		$currency: CurrencyEnum
		$dateRange: DateRangeInput
		$vetterEntityIds: [ID!]
	) {
		getQuoteStatsByStatusV2(
			currency: $currency
			dateRange: $dateRange
			vetterEntityIds: $vetterEntityIds
		) {
			total
			totalClients
			organizationId
			statusBreakdown {
				status
				count
				percentage
				clientCount
			}
		}
	}
`;

/**
 * __useGetQuoteStatsByStatusV2Query__
 *
 * To run a query within a React component, call `useGetQuoteStatsByStatusV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteStatsByStatusV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteStatsByStatusV2Query({
 *   variables: {
 *      currency: // value for 'currency'
 *      dateRange: // value for 'dateRange'
 *      vetterEntityIds: // value for 'vetterEntityIds'
 *   },
 * });
 */
export function useGetQuoteStatsByStatusV2Query(
	baseOptions?: Apollo.QueryHookOptions<
		GetQuoteStatsByStatusV2Query,
		GetQuoteStatsByStatusV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetQuoteStatsByStatusV2Query, GetQuoteStatsByStatusV2QueryVariables>(
		GetQuoteStatsByStatusV2Document,
		options
	);
}
export function useGetQuoteStatsByStatusV2LazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuoteStatsByStatusV2Query,
		GetQuoteStatsByStatusV2QueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetQuoteStatsByStatusV2Query, GetQuoteStatsByStatusV2QueryVariables>(
		GetQuoteStatsByStatusV2Document,
		options
	);
}
export function useGetQuoteStatsByStatusV2SuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuoteStatsByStatusV2Query,
				GetQuoteStatsByStatusV2QueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuoteStatsByStatusV2Query,
		GetQuoteStatsByStatusV2QueryVariables
	>(GetQuoteStatsByStatusV2Document, options);
}
export type GetQuoteStatsByStatusV2QueryHookResult = ReturnType<
	typeof useGetQuoteStatsByStatusV2Query
>;
export type GetQuoteStatsByStatusV2LazyQueryHookResult = ReturnType<
	typeof useGetQuoteStatsByStatusV2LazyQuery
>;
export type GetQuoteStatsByStatusV2SuspenseQueryHookResult = ReturnType<
	typeof useGetQuoteStatsByStatusV2SuspenseQuery
>;
export type GetQuoteStatsByStatusV2QueryResult = Apollo.QueryResult<
	GetQuoteStatsByStatusV2Query,
	GetQuoteStatsByStatusV2QueryVariables
>;
export const GetSourcingPreferencesDocument = gql`
	query GetSourcingPreferences($input: OrganizationSourcingPreferenceListInput!) {
		getOrganizationSourcingPreferences(input: $input) {
			data {
				id
				name
				description
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetSourcingPreferencesQuery__
 *
 * To run a query within a React component, call `useGetSourcingPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingPreferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSourcingPreferencesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetSourcingPreferencesQuery,
		GetSourcingPreferencesQueryVariables
	> &
		({ variables: GetSourcingPreferencesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSourcingPreferencesQuery, GetSourcingPreferencesQueryVariables>(
		GetSourcingPreferencesDocument,
		options
	);
}
export function useGetSourcingPreferencesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSourcingPreferencesQuery,
		GetSourcingPreferencesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSourcingPreferencesQuery, GetSourcingPreferencesQueryVariables>(
		GetSourcingPreferencesDocument,
		options
	);
}
export function useGetSourcingPreferencesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSourcingPreferencesQuery,
				GetSourcingPreferencesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetSourcingPreferencesQuery,
		GetSourcingPreferencesQueryVariables
	>(GetSourcingPreferencesDocument, options);
}
export type GetSourcingPreferencesQueryHookResult = ReturnType<
	typeof useGetSourcingPreferencesQuery
>;
export type GetSourcingPreferencesLazyQueryHookResult = ReturnType<
	typeof useGetSourcingPreferencesLazyQuery
>;
export type GetSourcingPreferencesSuspenseQueryHookResult = ReturnType<
	typeof useGetSourcingPreferencesSuspenseQuery
>;
export type GetSourcingPreferencesQueryResult = Apollo.QueryResult<
	GetSourcingPreferencesQuery,
	GetSourcingPreferencesQueryVariables
>;
export const GetSourcingPreferenceConnectionsDocument = gql`
	query GetSourcingPreferenceConnections(
		$input: OrganizationSourcingPreferenceConnectionListInput!
	) {
		getOrganizationSourcingPreferenceConnections(input: $input) {
			data {
				id
				organizationId
				organizationSourcingPreferenceId
				organizationSourcingPreference {
					id
					name
					description
				}
				priority
				notes
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetSourcingPreferenceConnectionsQuery__
 *
 * To run a query within a React component, call `useGetSourcingPreferenceConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingPreferenceConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingPreferenceConnectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSourcingPreferenceConnectionsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetSourcingPreferenceConnectionsQuery,
		GetSourcingPreferenceConnectionsQueryVariables
	> &
		(
			| { variables: GetSourcingPreferenceConnectionsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetSourcingPreferenceConnectionsQuery,
		GetSourcingPreferenceConnectionsQueryVariables
	>(GetSourcingPreferenceConnectionsDocument, options);
}
export function useGetSourcingPreferenceConnectionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSourcingPreferenceConnectionsQuery,
		GetSourcingPreferenceConnectionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetSourcingPreferenceConnectionsQuery,
		GetSourcingPreferenceConnectionsQueryVariables
	>(GetSourcingPreferenceConnectionsDocument, options);
}
export function useGetSourcingPreferenceConnectionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSourcingPreferenceConnectionsQuery,
				GetSourcingPreferenceConnectionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetSourcingPreferenceConnectionsQuery,
		GetSourcingPreferenceConnectionsQueryVariables
	>(GetSourcingPreferenceConnectionsDocument, options);
}
export type GetSourcingPreferenceConnectionsQueryHookResult = ReturnType<
	typeof useGetSourcingPreferenceConnectionsQuery
>;
export type GetSourcingPreferenceConnectionsLazyQueryHookResult = ReturnType<
	typeof useGetSourcingPreferenceConnectionsLazyQuery
>;
export type GetSourcingPreferenceConnectionsSuspenseQueryHookResult = ReturnType<
	typeof useGetSourcingPreferenceConnectionsSuspenseQuery
>;
export type GetSourcingPreferenceConnectionsQueryResult = Apollo.QueryResult<
	GetSourcingPreferenceConnectionsQuery,
	GetSourcingPreferenceConnectionsQueryVariables
>;
export const GetProductInterestsDocument = gql`
	query GetProductInterests($input: OrganizationProductInterestListInput!) {
		getOrganizationProductInterests(input: $input) {
			data {
				id
				organizationId
				productTagId
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetProductInterestsQuery__
 *
 * To run a query within a React component, call `useGetProductInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductInterestsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetProductInterestsQuery,
		GetProductInterestsQueryVariables
	> &
		({ variables: GetProductInterestsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetProductInterestsQuery, GetProductInterestsQueryVariables>(
		GetProductInterestsDocument,
		options
	);
}
export function useGetProductInterestsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetProductInterestsQuery,
		GetProductInterestsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetProductInterestsQuery, GetProductInterestsQueryVariables>(
		GetProductInterestsDocument,
		options
	);
}
export function useGetProductInterestsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetProductInterestsQuery,
				GetProductInterestsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetProductInterestsQuery, GetProductInterestsQueryVariables>(
		GetProductInterestsDocument,
		options
	);
}
export type GetProductInterestsQueryHookResult = ReturnType<typeof useGetProductInterestsQuery>;
export type GetProductInterestsLazyQueryHookResult = ReturnType<
	typeof useGetProductInterestsLazyQuery
>;
export type GetProductInterestsSuspenseQueryHookResult = ReturnType<
	typeof useGetProductInterestsSuspenseQuery
>;
export type GetProductInterestsQueryResult = Apollo.QueryResult<
	GetProductInterestsQuery,
	GetProductInterestsQueryVariables
>;
export const GetComplianceOptionsDocument = gql`
	query GetComplianceOptions($input: OrganizationComplianceListInput!) {
		getOrganizationCompliances(input: $input) {
			data {
				id
				name
				description
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetComplianceOptionsQuery__
 *
 * To run a query within a React component, call `useGetComplianceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComplianceOptionsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetComplianceOptionsQuery,
		GetComplianceOptionsQueryVariables
	> &
		({ variables: GetComplianceOptionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetComplianceOptionsQuery, GetComplianceOptionsQueryVariables>(
		GetComplianceOptionsDocument,
		options
	);
}
export function useGetComplianceOptionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetComplianceOptionsQuery,
		GetComplianceOptionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetComplianceOptionsQuery, GetComplianceOptionsQueryVariables>(
		GetComplianceOptionsDocument,
		options
	);
}
export function useGetComplianceOptionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetComplianceOptionsQuery,
				GetComplianceOptionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetComplianceOptionsQuery, GetComplianceOptionsQueryVariables>(
		GetComplianceOptionsDocument,
		options
	);
}
export type GetComplianceOptionsQueryHookResult = ReturnType<typeof useGetComplianceOptionsQuery>;
export type GetComplianceOptionsLazyQueryHookResult = ReturnType<
	typeof useGetComplianceOptionsLazyQuery
>;
export type GetComplianceOptionsSuspenseQueryHookResult = ReturnType<
	typeof useGetComplianceOptionsSuspenseQuery
>;
export type GetComplianceOptionsQueryResult = Apollo.QueryResult<
	GetComplianceOptionsQuery,
	GetComplianceOptionsQueryVariables
>;
export const GetComplianceConnectionsDocument = gql`
	query GetComplianceConnections($input: OrganizationComplianceConnectionListInput!) {
		getOrganizationComplianceConnections(input: $input) {
			data {
				id
				organizationId
				organizationComplianceId
				organizationCompliance {
					id
					name
					description
				}
				certificationNumber
				issueDate
				expiryDate
				certifyingBody
				createdAt
				updatedAt
			}
			pageInfo {
				totalCount
				currentPage
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetComplianceConnectionsQuery__
 *
 * To run a query within a React component, call `useGetComplianceConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceConnectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComplianceConnectionsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetComplianceConnectionsQuery,
		GetComplianceConnectionsQueryVariables
	> &
		({ variables: GetComplianceConnectionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetComplianceConnectionsQuery, GetComplianceConnectionsQueryVariables>(
		GetComplianceConnectionsDocument,
		options
	);
}
export function useGetComplianceConnectionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetComplianceConnectionsQuery,
		GetComplianceConnectionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetComplianceConnectionsQuery,
		GetComplianceConnectionsQueryVariables
	>(GetComplianceConnectionsDocument, options);
}
export function useGetComplianceConnectionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetComplianceConnectionsQuery,
				GetComplianceConnectionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetComplianceConnectionsQuery,
		GetComplianceConnectionsQueryVariables
	>(GetComplianceConnectionsDocument, options);
}
export type GetComplianceConnectionsQueryHookResult = ReturnType<
	typeof useGetComplianceConnectionsQuery
>;
export type GetComplianceConnectionsLazyQueryHookResult = ReturnType<
	typeof useGetComplianceConnectionsLazyQuery
>;
export type GetComplianceConnectionsSuspenseQueryHookResult = ReturnType<
	typeof useGetComplianceConnectionsSuspenseQuery
>;
export type GetComplianceConnectionsQueryResult = Apollo.QueryResult<
	GetComplianceConnectionsQuery,
	GetComplianceConnectionsQueryVariables
>;
export const GetStudioFileChatsDocument = gql`
	query GetStudioFileChats($studioFileId: ID!) {
		getStudioFileChats(studioFileId: $studioFileId) {
			id
			content
			role
			chatType
			status
			createdAt
			referenceImages
			maskImage
			maskImagePreview
			updatedAt
			studioFileId
			toolCalls {
				tool
				arguments
				result
				timestamp
			}
		}
	}
`;

/**
 * __useGetStudioFileChatsQuery__
 *
 * To run a query within a React component, call `useGetStudioFileChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioFileChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioFileChatsQuery({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useGetStudioFileChatsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetStudioFileChatsQuery,
		GetStudioFileChatsQueryVariables
	> &
		({ variables: GetStudioFileChatsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioFileChatsQuery, GetStudioFileChatsQueryVariables>(
		GetStudioFileChatsDocument,
		options
	);
}
export function useGetStudioFileChatsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetStudioFileChatsQuery,
		GetStudioFileChatsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetStudioFileChatsQuery, GetStudioFileChatsQueryVariables>(
		GetStudioFileChatsDocument,
		options
	);
}
export function useGetStudioFileChatsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetStudioFileChatsQuery, GetStudioFileChatsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetStudioFileChatsQuery, GetStudioFileChatsQueryVariables>(
		GetStudioFileChatsDocument,
		options
	);
}
export type GetStudioFileChatsQueryHookResult = ReturnType<typeof useGetStudioFileChatsQuery>;
export type GetStudioFileChatsLazyQueryHookResult = ReturnType<
	typeof useGetStudioFileChatsLazyQuery
>;
export type GetStudioFileChatsSuspenseQueryHookResult = ReturnType<
	typeof useGetStudioFileChatsSuspenseQuery
>;
export type GetStudioFileChatsQueryResult = Apollo.QueryResult<
	GetStudioFileChatsQuery,
	GetStudioFileChatsQueryVariables
>;
export const GetStudioFileDocument = gql`
	query GetStudioFile($id: ID!) {
		getStudioFile(id: $id) {
			id
			status
			isGenerating
			organizationId
			createdAt
			updatedAt
			name
			productId
			versions {
				id
				name
				slug
				imageUrls
				versionNumber
				changeNotes
				createdAt
				createdBy
				metadata {
					id
					x
					y
					width
					height
					comment
					canvasWidth
					canvasHeight
					type
					points {
						x
						y
					}
					attachments {
						fileName
						contentType
						size
						url
					}
					createdAt
				}
				specifications {
					id
					elementName
					elementType
					colors
					material
					secondaryMaterials
					dimensions {
						width
						height
						depth
						diameter
						unit
					}
					weight {
						value
						unit
					}
					capacity {
						value
						unit
					}
					finish
					textureDescription
					features
					confidence
					generatedAt
				}
				techPack {
					id
					additionalNotes
					colorways {
						name
						code
						pantoneReferences
						fabricColors
						trimColors
					}
					construction {
						stitchTypes {
							type
							location
							stitchesPerInch
							threadColor
						}
						seamAllowances {
							location
							allowance
						}
						specialInstructions
					}
					dimensions {
						sizeChart {
							size
							measurements
						}
						measurements {
							name
							value
							tolerance
						}
					}
					labeling {
						mainLabel {
							type
							placement
							content
						}
						careLabel {
							placement
							content
							symbols
						}
						additionalLabels {
							type
							placement
							content
						}
					}
					materials {
						fabric {
							type
							composition
							weight
							width
							code
							supplier
						}
						trims {
							type
							description
							placement
							code
							supplier
						}
						hardware {
							type
							description
							quantity
							code
							supplier
						}
					}
					packaging {
						type
						materials
						instructions
						labeling
					}
					qualityControl {
						inspectionPoints
						testingRequirements
						acceptableDefects
					}
				}
			}
		}
	}
`;

/**
 * __useGetStudioFileQuery__
 *
 * To run a query within a React component, call `useGetStudioFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStudioFileQuery(
	baseOptions: Apollo.QueryHookOptions<GetStudioFileQuery, GetStudioFileQueryVariables> &
		({ variables: GetStudioFileQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioFileQuery, GetStudioFileQueryVariables>(
		GetStudioFileDocument,
		options
	);
}
export function useGetStudioFileLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetStudioFileQuery, GetStudioFileQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetStudioFileQuery, GetStudioFileQueryVariables>(
		GetStudioFileDocument,
		options
	);
}
export function useGetStudioFileSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetStudioFileQuery, GetStudioFileQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetStudioFileQuery, GetStudioFileQueryVariables>(
		GetStudioFileDocument,
		options
	);
}
export type GetStudioFileQueryHookResult = ReturnType<typeof useGetStudioFileQuery>;
export type GetStudioFileLazyQueryHookResult = ReturnType<typeof useGetStudioFileLazyQuery>;
export type GetStudioFileSuspenseQueryHookResult = ReturnType<typeof useGetStudioFileSuspenseQuery>;
export type GetStudioFileQueryResult = Apollo.QueryResult<
	GetStudioFileQuery,
	GetStudioFileQueryVariables
>;
export const GetAllStudioFilesDocument = gql`
	query GetAllStudioFiles($input: GetAllStudioFileInput!) {
		getAllStudioFile(input: $input) {
			data {
				id
				organizationId
				status
				isGenerating
				createdAt
				updatedAt
				name
				type
				productId
				currentVersion {
					id
					name
					slug
					imageUrls
					versionNumber
				}
				versions {
					id
					name
					imageUrls
					versionNumber
				}
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllStudioFilesQuery__
 *
 * To run a query within a React component, call `useGetAllStudioFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStudioFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStudioFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllStudioFilesQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllStudioFilesQuery, GetAllStudioFilesQueryVariables> &
		({ variables: GetAllStudioFilesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllStudioFilesQuery, GetAllStudioFilesQueryVariables>(
		GetAllStudioFilesDocument,
		options
	);
}
export function useGetAllStudioFilesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllStudioFilesQuery,
		GetAllStudioFilesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllStudioFilesQuery, GetAllStudioFilesQueryVariables>(
		GetAllStudioFilesDocument,
		options
	);
}
export function useGetAllStudioFilesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllStudioFilesQuery, GetAllStudioFilesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllStudioFilesQuery, GetAllStudioFilesQueryVariables>(
		GetAllStudioFilesDocument,
		options
	);
}
export type GetAllStudioFilesQueryHookResult = ReturnType<typeof useGetAllStudioFilesQuery>;
export type GetAllStudioFilesLazyQueryHookResult = ReturnType<typeof useGetAllStudioFilesLazyQuery>;
export type GetAllStudioFilesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllStudioFilesSuspenseQuery
>;
export type GetAllStudioFilesQueryResult = Apollo.QueryResult<
	GetAllStudioFilesQuery,
	GetAllStudioFilesQueryVariables
>;
export const GetStudioFileLockDocument = gql`
	query GetStudioFileLock($studioFileId: ID!) {
		getStudioFileLock(studioFileId: $studioFileId) {
			studioFileId
			userId
			lockedAt
			expiresAt
		}
	}
`;

/**
 * __useGetStudioFileLockQuery__
 *
 * To run a query within a React component, call `useGetStudioFileLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioFileLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioFileLockQuery({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useGetStudioFileLockQuery(
	baseOptions: Apollo.QueryHookOptions<GetStudioFileLockQuery, GetStudioFileLockQueryVariables> &
		({ variables: GetStudioFileLockQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioFileLockQuery, GetStudioFileLockQueryVariables>(
		GetStudioFileLockDocument,
		options
	);
}
export function useGetStudioFileLockLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetStudioFileLockQuery,
		GetStudioFileLockQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetStudioFileLockQuery, GetStudioFileLockQueryVariables>(
		GetStudioFileLockDocument,
		options
	);
}
export function useGetStudioFileLockSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetStudioFileLockQuery, GetStudioFileLockQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetStudioFileLockQuery, GetStudioFileLockQueryVariables>(
		GetStudioFileLockDocument,
		options
	);
}
export type GetStudioFileLockQueryHookResult = ReturnType<typeof useGetStudioFileLockQuery>;
export type GetStudioFileLockLazyQueryHookResult = ReturnType<typeof useGetStudioFileLockLazyQuery>;
export type GetStudioFileLockSuspenseQueryHookResult = ReturnType<
	typeof useGetStudioFileLockSuspenseQuery
>;
export type GetStudioFileLockQueryResult = Apollo.QueryResult<
	GetStudioFileLockQuery,
	GetStudioFileLockQueryVariables
>;
export const GetStudioFileVersionsDocument = gql`
	query GetStudioFileVersions($studioFileId: ID!) {
		getStudioFileVersions(studioFileId: $studioFileId) {
			id
			name
			slug
			imageUrls
			studioFileId
			versionNumber
			changeNotes
			createdAt
			createdBy
			metadata {
				id
				x
				y
				width
				height
				comment
				canvasWidth
				canvasHeight
				type
				points {
					x
					y
				}
				attachments {
					fileName
					contentType
					size
					url
				}
				createdAt
			}
			techPack {
				id
				additionalNotes
				colorways {
					name
					code
					pantoneReferences
					fabricColors
					trimColors
				}
				construction {
					stitchTypes {
						type
						location
						stitchesPerInch
						threadColor
					}
					seamAllowances {
						location
						allowance
					}
					specialInstructions
				}
				dimensions {
					sizeChart {
						size
						measurements
					}
					measurements {
						name
						value
						tolerance
					}
				}
				labeling {
					mainLabel {
						type
						placement
						content
					}
					careLabel {
						placement
						content
						symbols
					}
					additionalLabels {
						type
						placement
						content
					}
				}
				materials {
					fabric {
						type
						composition
						weight
						width
						code
						supplier
					}
					trims {
						type
						description
						placement
						code
						supplier
					}
					hardware {
						type
						description
						quantity
						code
						supplier
					}
				}
				packaging {
					type
					materials
					instructions
					labeling
				}
				qualityControl {
					inspectionPoints
					testingRequirements
					acceptableDefects
				}
			}
		}
	}
`;

/**
 * __useGetStudioFileVersionsQuery__
 *
 * To run a query within a React component, call `useGetStudioFileVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioFileVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioFileVersionsQuery({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useGetStudioFileVersionsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetStudioFileVersionsQuery,
		GetStudioFileVersionsQueryVariables
	> &
		({ variables: GetStudioFileVersionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioFileVersionsQuery, GetStudioFileVersionsQueryVariables>(
		GetStudioFileVersionsDocument,
		options
	);
}
export function useGetStudioFileVersionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetStudioFileVersionsQuery,
		GetStudioFileVersionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetStudioFileVersionsQuery, GetStudioFileVersionsQueryVariables>(
		GetStudioFileVersionsDocument,
		options
	);
}
export function useGetStudioFileVersionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetStudioFileVersionsQuery,
				GetStudioFileVersionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetStudioFileVersionsQuery, GetStudioFileVersionsQueryVariables>(
		GetStudioFileVersionsDocument,
		options
	);
}
export type GetStudioFileVersionsQueryHookResult = ReturnType<typeof useGetStudioFileVersionsQuery>;
export type GetStudioFileVersionsLazyQueryHookResult = ReturnType<
	typeof useGetStudioFileVersionsLazyQuery
>;
export type GetStudioFileVersionsSuspenseQueryHookResult = ReturnType<
	typeof useGetStudioFileVersionsSuspenseQuery
>;
export type GetStudioFileVersionsQueryResult = Apollo.QueryResult<
	GetStudioFileVersionsQuery,
	GetStudioFileVersionsQueryVariables
>;
export const GetStudioPromptTemplatesDocument = gql`
	query GetStudioPromptTemplates($agentType: StudioAgentType) {
		getStudioPromptTemplates(agentType: $agentType) {
			id
			key
			content
			description
			agentType
			category
			isActive
			provider
			variables
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetStudioPromptTemplatesQuery__
 *
 * To run a query within a React component, call `useGetStudioPromptTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioPromptTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioPromptTemplatesQuery({
 *   variables: {
 *      agentType: // value for 'agentType'
 *   },
 * });
 */
export function useGetStudioPromptTemplatesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetStudioPromptTemplatesQuery,
		GetStudioPromptTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioPromptTemplatesQuery, GetStudioPromptTemplatesQueryVariables>(
		GetStudioPromptTemplatesDocument,
		options
	);
}
export function useGetStudioPromptTemplatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetStudioPromptTemplatesQuery,
		GetStudioPromptTemplatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetStudioPromptTemplatesQuery,
		GetStudioPromptTemplatesQueryVariables
	>(GetStudioPromptTemplatesDocument, options);
}
export function useGetStudioPromptTemplatesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetStudioPromptTemplatesQuery,
				GetStudioPromptTemplatesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetStudioPromptTemplatesQuery,
		GetStudioPromptTemplatesQueryVariables
	>(GetStudioPromptTemplatesDocument, options);
}
export type GetStudioPromptTemplatesQueryHookResult = ReturnType<
	typeof useGetStudioPromptTemplatesQuery
>;
export type GetStudioPromptTemplatesLazyQueryHookResult = ReturnType<
	typeof useGetStudioPromptTemplatesLazyQuery
>;
export type GetStudioPromptTemplatesSuspenseQueryHookResult = ReturnType<
	typeof useGetStudioPromptTemplatesSuspenseQuery
>;
export type GetStudioPromptTemplatesQueryResult = Apollo.QueryResult<
	GetStudioPromptTemplatesQuery,
	GetStudioPromptTemplatesQueryVariables
>;
export const GetStudioPromptTemplateDocument = gql`
	query GetStudioPromptTemplate($id: ID!) {
		getStudioPromptTemplate(id: $id) {
			id
			key
			content
			description
			agentType
			category
			isActive
			provider
			variables
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetStudioPromptTemplateQuery__
 *
 * To run a query within a React component, call `useGetStudioPromptTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioPromptTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioPromptTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStudioPromptTemplateQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetStudioPromptTemplateQuery,
		GetStudioPromptTemplateQueryVariables
	> &
		({ variables: GetStudioPromptTemplateQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioPromptTemplateQuery, GetStudioPromptTemplateQueryVariables>(
		GetStudioPromptTemplateDocument,
		options
	);
}
export function useGetStudioPromptTemplateLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetStudioPromptTemplateQuery,
		GetStudioPromptTemplateQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetStudioPromptTemplateQuery, GetStudioPromptTemplateQueryVariables>(
		GetStudioPromptTemplateDocument,
		options
	);
}
export function useGetStudioPromptTemplateSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetStudioPromptTemplateQuery,
				GetStudioPromptTemplateQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetStudioPromptTemplateQuery,
		GetStudioPromptTemplateQueryVariables
	>(GetStudioPromptTemplateDocument, options);
}
export type GetStudioPromptTemplateQueryHookResult = ReturnType<
	typeof useGetStudioPromptTemplateQuery
>;
export type GetStudioPromptTemplateLazyQueryHookResult = ReturnType<
	typeof useGetStudioPromptTemplateLazyQuery
>;
export type GetStudioPromptTemplateSuspenseQueryHookResult = ReturnType<
	typeof useGetStudioPromptTemplateSuspenseQuery
>;
export type GetStudioPromptTemplateQueryResult = Apollo.QueryResult<
	GetStudioPromptTemplateQuery,
	GetStudioPromptTemplateQueryVariables
>;
export const GetStudioAgentToolsDocument = gql`
	query GetStudioAgentTools($agentType: StudioAgentType!) {
		getStudioAgentTools(agentType: $agentType) {
			name
			description
			parameters
			supportedProviders
		}
	}
`;

/**
 * __useGetStudioAgentToolsQuery__
 *
 * To run a query within a React component, call `useGetStudioAgentToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioAgentToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioAgentToolsQuery({
 *   variables: {
 *      agentType: // value for 'agentType'
 *   },
 * });
 */
export function useGetStudioAgentToolsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetStudioAgentToolsQuery,
		GetStudioAgentToolsQueryVariables
	> &
		({ variables: GetStudioAgentToolsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetStudioAgentToolsQuery, GetStudioAgentToolsQueryVariables>(
		GetStudioAgentToolsDocument,
		options
	);
}
export function useGetStudioAgentToolsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetStudioAgentToolsQuery,
		GetStudioAgentToolsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetStudioAgentToolsQuery, GetStudioAgentToolsQueryVariables>(
		GetStudioAgentToolsDocument,
		options
	);
}
export function useGetStudioAgentToolsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetStudioAgentToolsQuery,
				GetStudioAgentToolsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetStudioAgentToolsQuery, GetStudioAgentToolsQueryVariables>(
		GetStudioAgentToolsDocument,
		options
	);
}
export type GetStudioAgentToolsQueryHookResult = ReturnType<typeof useGetStudioAgentToolsQuery>;
export type GetStudioAgentToolsLazyQueryHookResult = ReturnType<
	typeof useGetStudioAgentToolsLazyQuery
>;
export type GetStudioAgentToolsSuspenseQueryHookResult = ReturnType<
	typeof useGetStudioAgentToolsSuspenseQuery
>;
export type GetStudioAgentToolsQueryResult = Apollo.QueryResult<
	GetStudioAgentToolsQuery,
	GetStudioAgentToolsQueryVariables
>;
export const GetSubscriptionTierConfigsDocument = gql`
	query GetSubscriptionTierConfigs {
		getSubscriptionTierConfigs {
			tier
			monthlyPrice
			currency
			kickbackRate
			aiTokenRatePerMillion
			stripePriceId
			isActive
			updatedAt
		}
	}
`;

/**
 * __useGetSubscriptionTierConfigsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionTierConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionTierConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionTierConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionTierConfigsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>(GetSubscriptionTierConfigsDocument, options);
}
export function useGetSubscriptionTierConfigsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>(GetSubscriptionTierConfigsDocument, options);
}
export function useGetSubscriptionTierConfigsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSubscriptionTierConfigsQuery,
				GetSubscriptionTierConfigsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetSubscriptionTierConfigsQuery,
		GetSubscriptionTierConfigsQueryVariables
	>(GetSubscriptionTierConfigsDocument, options);
}
export type GetSubscriptionTierConfigsQueryHookResult = ReturnType<
	typeof useGetSubscriptionTierConfigsQuery
>;
export type GetSubscriptionTierConfigsLazyQueryHookResult = ReturnType<
	typeof useGetSubscriptionTierConfigsLazyQuery
>;
export type GetSubscriptionTierConfigsSuspenseQueryHookResult = ReturnType<
	typeof useGetSubscriptionTierConfigsSuspenseQuery
>;
export type GetSubscriptionTierConfigsQueryResult = Apollo.QueryResult<
	GetSubscriptionTierConfigsQuery,
	GetSubscriptionTierConfigsQueryVariables
>;
export const GetMySubscriptionDocument = gql`
	query GetMySubscription {
		getMySubscription {
			id
			organizationId
			tier
			status
			stripeCustomerId
			stripeSubscriptionId
			stripePriceId
			currentPeriodStart
			currentPeriodEnd
			cancelAtPeriodEnd
			canceledAt
			trialEnd
			pendingTier
			pendingTierEffectiveAt
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetMySubscriptionQuery__
 *
 * To run a query within a React component, call `useGetMySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubscriptionQuery(
	baseOptions?: Apollo.QueryHookOptions<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>(
		GetMySubscriptionDocument,
		options
	);
}
export function useGetMySubscriptionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMySubscriptionQuery,
		GetMySubscriptionQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>(
		GetMySubscriptionDocument,
		options
	);
}
export function useGetMySubscriptionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetMySubscriptionQuery, GetMySubscriptionQueryVariables>(
		GetMySubscriptionDocument,
		options
	);
}
export type GetMySubscriptionQueryHookResult = ReturnType<typeof useGetMySubscriptionQuery>;
export type GetMySubscriptionLazyQueryHookResult = ReturnType<typeof useGetMySubscriptionLazyQuery>;
export type GetMySubscriptionSuspenseQueryHookResult = ReturnType<
	typeof useGetMySubscriptionSuspenseQuery
>;
export type GetMySubscriptionQueryResult = Apollo.QueryResult<
	GetMySubscriptionQuery,
	GetMySubscriptionQueryVariables
>;
export const GetMyKickbackTransactionsDocument = gql`
	query GetMyKickbackTransactions($limit: Int, $offset: Int) {
		getMyKickbackTransactions(limit: $limit, offset: $offset) {
			id
			organizationId
			orderId
			type
			amount
			description
			createdAt
		}
	}
`;

/**
 * __useGetMyKickbackTransactionsQuery__
 *
 * To run a query within a React component, call `useGetMyKickbackTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyKickbackTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyKickbackTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMyKickbackTransactionsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetMyKickbackTransactionsQuery,
		GetMyKickbackTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetMyKickbackTransactionsQuery, GetMyKickbackTransactionsQueryVariables>(
		GetMyKickbackTransactionsDocument,
		options
	);
}
export function useGetMyKickbackTransactionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyKickbackTransactionsQuery,
		GetMyKickbackTransactionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetMyKickbackTransactionsQuery,
		GetMyKickbackTransactionsQueryVariables
	>(GetMyKickbackTransactionsDocument, options);
}
export function useGetMyKickbackTransactionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMyKickbackTransactionsQuery,
				GetMyKickbackTransactionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetMyKickbackTransactionsQuery,
		GetMyKickbackTransactionsQueryVariables
	>(GetMyKickbackTransactionsDocument, options);
}
export type GetMyKickbackTransactionsQueryHookResult = ReturnType<
	typeof useGetMyKickbackTransactionsQuery
>;
export type GetMyKickbackTransactionsLazyQueryHookResult = ReturnType<
	typeof useGetMyKickbackTransactionsLazyQuery
>;
export type GetMyKickbackTransactionsSuspenseQueryHookResult = ReturnType<
	typeof useGetMyKickbackTransactionsSuspenseQuery
>;
export type GetMyKickbackTransactionsQueryResult = Apollo.QueryResult<
	GetMyKickbackTransactionsQuery,
	GetMyKickbackTransactionsQueryVariables
>;
export const GetSystemSettingsDocument = gql`
	query GetSystemSettings {
		getSystemSettings {
			id
			defaultApproval
			defaultMargin
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetSystemSettingsQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemSettingsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export function useGetSystemSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSystemSettingsQuery,
		GetSystemSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export function useGetSystemSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export type GetSystemSettingsQueryHookResult = ReturnType<typeof useGetSystemSettingsQuery>;
export type GetSystemSettingsLazyQueryHookResult = ReturnType<typeof useGetSystemSettingsLazyQuery>;
export type GetSystemSettingsSuspenseQueryHookResult = ReturnType<
	typeof useGetSystemSettingsSuspenseQuery
>;
export type GetSystemSettingsQueryResult = Apollo.QueryResult<
	GetSystemSettingsQuery,
	GetSystemSettingsQueryVariables
>;
export const GetOrganizationUserDetailsDocument = gql`
	query GetOrganizationUserDetails($userId: ID!) {
		getOrganizationUser(userId: $userId) {
			id
			firstName
			lastName
			jobPosition
			avatar
			createdAt
			updatedAt
			organizationId
			userId
			roles
			authenticationUser {
				id
				email
				language
				role
				mfaEnabled
				mfaMethod
				lockReason
				lockedAt
				createdAt
				updatedAt
			}
			organization {
				id
				name
				organizationIndustryId
				organizationIndustry {
					id
					name
				}
				websiteUrl
				logo
			}
			authorizationUserRoles {
				id
				authorizationRoleId
				createdAt
				authorizationRole {
					id
					name
					description
					scope
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationUserDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	> &
		(
			| { variables: GetOrganizationUserDetailsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>(GetOrganizationUserDetailsDocument, options);
}
export function useGetOrganizationUserDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>(GetOrganizationUserDetailsDocument, options);
}
export function useGetOrganizationUserDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserDetailsQuery,
				GetOrganizationUserDetailsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>(GetOrganizationUserDetailsDocument, options);
}
export type GetOrganizationUserDetailsQueryHookResult = ReturnType<
	typeof useGetOrganizationUserDetailsQuery
>;
export type GetOrganizationUserDetailsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserDetailsLazyQuery
>;
export type GetOrganizationUserDetailsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserDetailsSuspenseQuery
>;
export type GetOrganizationUserDetailsQueryResult = Apollo.QueryResult<
	GetOrganizationUserDetailsQuery,
	GetOrganizationUserDetailsQueryVariables
>;
export const UpdateOrganizationUserDocument = gql`
	mutation UpdateOrganizationUser($input: OrganizationUserUpdateInput!) {
		updateOrganizationUser(input: $input) {
			success
			message
			messageKey
		}
	}
`;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<
	UpdateOrganizationUserMutation,
	UpdateOrganizationUserMutationVariables
>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationUserMutation,
		UpdateOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationUserMutation,
		UpdateOrganizationUserMutationVariables
	>(UpdateOrganizationUserDocument, options);
}
export type UpdateOrganizationUserMutationHookResult = ReturnType<
	typeof useUpdateOrganizationUserMutation
>;
export type UpdateOrganizationUserMutationResult =
	Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationUserMutation,
	UpdateOrganizationUserMutationVariables
>;
export const GetUserAuditLogsDocument = gql`
	query GetUserAuditLogs($input: GetAllLoggingAuditLogInput!) {
		getAllLoggingAuditLog(input: $input) {
			data {
				id
				action
				resource
				resourceId
				description
				status
				serviceName
				changes
				metadata
				createdAt
				userId
				organizationId
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetUserAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetUserAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserAuditLogsQuery(
	baseOptions: Apollo.QueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables> &
		({ variables: GetUserAuditLogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>(
		GetUserAuditLogsDocument,
		options
	);
}
export function useGetUserAuditLogsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>(
		GetUserAuditLogsDocument,
		options
	);
}
export function useGetUserAuditLogsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>(
		GetUserAuditLogsDocument,
		options
	);
}
export type GetUserAuditLogsQueryHookResult = ReturnType<typeof useGetUserAuditLogsQuery>;
export type GetUserAuditLogsLazyQueryHookResult = ReturnType<typeof useGetUserAuditLogsLazyQuery>;
export type GetUserAuditLogsSuspenseQueryHookResult = ReturnType<
	typeof useGetUserAuditLogsSuspenseQuery
>;
export type GetUserAuditLogsQueryResult = Apollo.QueryResult<
	GetUserAuditLogsQuery,
	GetUserAuditLogsQueryVariables
>;
export const GetUserLoginLogsDocument = gql`
	query GetUserLoginLogs($input: GetAllLoggingLoginLogInput!) {
		getAllLoggingLoginLog(input: $input) {
			data {
				id
				method
				status
				failureReason
				ipAddress
				userAgent
				browser
				os
				createdAt
				userId
				referenceId
				serviceId
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetUserLoginLogsQuery__
 *
 * To run a query within a React component, call `useGetUserLoginLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLoginLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLoginLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserLoginLogsQuery(
	baseOptions: Apollo.QueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables> &
		({ variables: GetUserLoginLogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>(
		GetUserLoginLogsDocument,
		options
	);
}
export function useGetUserLoginLogsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>(
		GetUserLoginLogsDocument,
		options
	);
}
export function useGetUserLoginLogsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>(
		GetUserLoginLogsDocument,
		options
	);
}
export type GetUserLoginLogsQueryHookResult = ReturnType<typeof useGetUserLoginLogsQuery>;
export type GetUserLoginLogsLazyQueryHookResult = ReturnType<typeof useGetUserLoginLogsLazyQuery>;
export type GetUserLoginLogsSuspenseQueryHookResult = ReturnType<
	typeof useGetUserLoginLogsSuspenseQuery
>;
export type GetUserLoginLogsQueryResult = Apollo.QueryResult<
	GetUserLoginLogsQuery,
	GetUserLoginLogsQueryVariables
>;
export const GetUserPreferencesDocument = gql`
	query GetUserPreferences {
		getUserPreferences {
			userId
			preferredLanguage
		}
	}
`;

/**
 * __useGetUserPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferencesQuery(
	baseOptions?: Apollo.QueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(
		GetUserPreferencesDocument,
		options
	);
}
export function useGetUserPreferencesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetUserPreferencesQuery,
		GetUserPreferencesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(
		GetUserPreferencesDocument,
		options
	);
}
export function useGetUserPreferencesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(
		GetUserPreferencesDocument,
		options
	);
}
export type GetUserPreferencesQueryHookResult = ReturnType<typeof useGetUserPreferencesQuery>;
export type GetUserPreferencesLazyQueryHookResult = ReturnType<
	typeof useGetUserPreferencesLazyQuery
>;
export type GetUserPreferencesSuspenseQueryHookResult = ReturnType<
	typeof useGetUserPreferencesSuspenseQuery
>;
export type GetUserPreferencesQueryResult = Apollo.QueryResult<
	GetUserPreferencesQuery,
	GetUserPreferencesQueryVariables
>;
export const GetAllVetterEntitiesDocument = gql`
	query GetAllVetterEntities($input: GetAllVetterEntityInput!) {
		getAllVetterEntity(input: $input) {
			data {
				id
				name
				description
				isActive
				vetterUsers {
					id
					userId
					firstName
					lastName
				}
			}
			pageInfo {
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllVetterEntitiesQuery__
 *
 * To run a query within a React component, call `useGetAllVetterEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVetterEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVetterEntitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllVetterEntitiesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllVetterEntitiesQuery,
		GetAllVetterEntitiesQueryVariables
	> &
		({ variables: GetAllVetterEntitiesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllVetterEntitiesQuery, GetAllVetterEntitiesQueryVariables>(
		GetAllVetterEntitiesDocument,
		options
	);
}
export function useGetAllVetterEntitiesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllVetterEntitiesQuery,
		GetAllVetterEntitiesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllVetterEntitiesQuery, GetAllVetterEntitiesQueryVariables>(
		GetAllVetterEntitiesDocument,
		options
	);
}
export function useGetAllVetterEntitiesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllVetterEntitiesQuery,
				GetAllVetterEntitiesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllVetterEntitiesQuery, GetAllVetterEntitiesQueryVariables>(
		GetAllVetterEntitiesDocument,
		options
	);
}
export type GetAllVetterEntitiesQueryHookResult = ReturnType<typeof useGetAllVetterEntitiesQuery>;
export type GetAllVetterEntitiesLazyQueryHookResult = ReturnType<
	typeof useGetAllVetterEntitiesLazyQuery
>;
export type GetAllVetterEntitiesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllVetterEntitiesSuspenseQuery
>;
export type GetAllVetterEntitiesQueryResult = Apollo.QueryResult<
	GetAllVetterEntitiesQuery,
	GetAllVetterEntitiesQueryVariables
>;
export const GetVetterEntityDocument = gql`
	query GetVetterEntity($id: ID!) {
		getVetterEntity(id: $id) {
			id
			name
			description
			isActive
			createdAt
			updatedAt
			vetterUsers {
				id
				firstName
				lastName
				userId
				authenticationUser {
					id
					email
				}
			}
			manufacturers {
				id
				name
				country
				description
				website
				logoUrl
				isActive
				createdAt
				updatedAt
			}
		}
	}
`;

/**
 * __useGetVetterEntityQuery__
 *
 * To run a query within a React component, call `useGetVetterEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetterEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetterEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVetterEntityQuery(
	baseOptions: Apollo.QueryHookOptions<GetVetterEntityQuery, GetVetterEntityQueryVariables> &
		({ variables: GetVetterEntityQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetVetterEntityQuery, GetVetterEntityQueryVariables>(
		GetVetterEntityDocument,
		options
	);
}
export function useGetVetterEntityLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetVetterEntityQuery, GetVetterEntityQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetVetterEntityQuery, GetVetterEntityQueryVariables>(
		GetVetterEntityDocument,
		options
	);
}
export function useGetVetterEntitySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetVetterEntityQuery, GetVetterEntityQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetVetterEntityQuery, GetVetterEntityQueryVariables>(
		GetVetterEntityDocument,
		options
	);
}
export type GetVetterEntityQueryHookResult = ReturnType<typeof useGetVetterEntityQuery>;
export type GetVetterEntityLazyQueryHookResult = ReturnType<typeof useGetVetterEntityLazyQuery>;
export type GetVetterEntitySuspenseQueryHookResult = ReturnType<
	typeof useGetVetterEntitySuspenseQuery
>;
export type GetVetterEntityQueryResult = Apollo.QueryResult<
	GetVetterEntityQuery,
	GetVetterEntityQueryVariables
>;
export const GetAllVetterUserDocument = gql`
	query GetAllVetterUser($input: GetAllVetterUserInput!) {
		getAllVetterUser(input: $input) {
			data {
				id
				userId
				firstName
				lastName
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					mfaEnabled
					language
					lastActive
				}
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllVetterUserQuery__
 *
 * To run a query within a React component, call `useGetAllVetterUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVetterUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVetterUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllVetterUserQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllVetterUserQuery, GetAllVetterUserQueryVariables> &
		({ variables: GetAllVetterUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllVetterUserQuery, GetAllVetterUserQueryVariables>(
		GetAllVetterUserDocument,
		options
	);
}
export function useGetAllVetterUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllVetterUserQuery, GetAllVetterUserQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllVetterUserQuery, GetAllVetterUserQueryVariables>(
		GetAllVetterUserDocument,
		options
	);
}
export function useGetAllVetterUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllVetterUserQuery, GetAllVetterUserQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllVetterUserQuery, GetAllVetterUserQueryVariables>(
		GetAllVetterUserDocument,
		options
	);
}
export type GetAllVetterUserQueryHookResult = ReturnType<typeof useGetAllVetterUserQuery>;
export type GetAllVetterUserLazyQueryHookResult = ReturnType<typeof useGetAllVetterUserLazyQuery>;
export type GetAllVetterUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllVetterUserSuspenseQuery
>;
export type GetAllVetterUserQueryResult = Apollo.QueryResult<
	GetAllVetterUserQuery,
	GetAllVetterUserQueryVariables
>;
export const OnMessageAddedDocument = gql`
	subscription OnMessageAdded($contextId: ID!) {
		messageAdded(contextId: $contextId) {
			id
			content
			contextId
			senderId
			senderType
			messageType
			metadata
			isRead
			readAt
			translations {
				da
				en
				zh
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useOnMessageAddedSubscription__
 *
 * To run a query within a React component, call `useOnMessageAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageAddedSubscription({
 *   variables: {
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useOnMessageAddedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnMessageAddedSubscription,
		OnMessageAddedSubscriptionVariables
	> &
		({ variables: OnMessageAddedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<OnMessageAddedSubscription, OnMessageAddedSubscriptionVariables>(
		OnMessageAddedDocument,
		options
	);
}
export type OnMessageAddedSubscriptionHookResult = ReturnType<typeof useOnMessageAddedSubscription>;
export type OnMessageAddedSubscriptionResult =
	Apollo.SubscriptionResult<OnMessageAddedSubscription>;
export const OnMessageDeletedDocument = gql`
	subscription OnMessageDeleted($contextId: ID!) {
		messageDeleted(contextId: $contextId)
	}
`;

/**
 * __useOnMessageDeletedSubscription__
 *
 * To run a query within a React component, call `useOnMessageDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageDeletedSubscription({
 *   variables: {
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useOnMessageDeletedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnMessageDeletedSubscription,
		OnMessageDeletedSubscriptionVariables
	> &
		({ variables: OnMessageDeletedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnMessageDeletedSubscription,
		OnMessageDeletedSubscriptionVariables
	>(OnMessageDeletedDocument, options);
}
export type OnMessageDeletedSubscriptionHookResult = ReturnType<
	typeof useOnMessageDeletedSubscription
>;
export type OnMessageDeletedSubscriptionResult =
	Apollo.SubscriptionResult<OnMessageDeletedSubscription>;
export const OnMessageUpdatedDocument = gql`
	subscription OnMessageUpdated($contextId: ID!) {
		messageUpdated(contextId: $contextId) {
			id
			content
			contextId
			senderId
			senderType
			messageType
			metadata
			isRead
			readAt
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useOnMessageUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnMessageUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageUpdatedSubscription({
 *   variables: {
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useOnMessageUpdatedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnMessageUpdatedSubscription,
		OnMessageUpdatedSubscriptionVariables
	> &
		({ variables: OnMessageUpdatedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnMessageUpdatedSubscription,
		OnMessageUpdatedSubscriptionVariables
	>(OnMessageUpdatedDocument, options);
}
export type OnMessageUpdatedSubscriptionHookResult = ReturnType<
	typeof useOnMessageUpdatedSubscription
>;
export type OnMessageUpdatedSubscriptionResult =
	Apollo.SubscriptionResult<OnMessageUpdatedSubscription>;
export const OnUnreadCountChangedDocument = gql`
	subscription OnUnreadCountChanged($userId: ID!) {
		unreadCountChanged(userId: $userId) {
			contextId
			unreadCount
			userId
		}
	}
`;

/**
 * __useOnUnreadCountChangedSubscription__
 *
 * To run a query within a React component, call `useOnUnreadCountChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUnreadCountChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUnreadCountChangedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOnUnreadCountChangedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnUnreadCountChangedSubscription,
		OnUnreadCountChangedSubscriptionVariables
	> &
		(
			| { variables: OnUnreadCountChangedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnUnreadCountChangedSubscription,
		OnUnreadCountChangedSubscriptionVariables
	>(OnUnreadCountChangedDocument, options);
}
export type OnUnreadCountChangedSubscriptionHookResult = ReturnType<
	typeof useOnUnreadCountChangedSubscription
>;
export type OnUnreadCountChangedSubscriptionResult =
	Apollo.SubscriptionResult<OnUnreadCountChangedSubscription>;
export const OnStudioChatUpdatedDocument = gql`
	subscription OnStudioChatUpdated($studioFileId: ID!) {
		studioChatUpdated(studioFileId: $studioFileId) {
			id
			content
			role
			chatType
			status
			createdAt
			referenceImages
			maskImage
			maskImagePreview
			updatedAt
			studioFileId
			toolCalls {
				tool
				arguments
				result
				timestamp
			}
		}
	}
`;

/**
 * __useOnStudioChatUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnStudioChatUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStudioChatUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStudioChatUpdatedSubscription({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useOnStudioChatUpdatedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnStudioChatUpdatedSubscription,
		OnStudioChatUpdatedSubscriptionVariables
	> &
		(
			| { variables: OnStudioChatUpdatedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnStudioChatUpdatedSubscription,
		OnStudioChatUpdatedSubscriptionVariables
	>(OnStudioChatUpdatedDocument, options);
}
export type OnStudioChatUpdatedSubscriptionHookResult = ReturnType<
	typeof useOnStudioChatUpdatedSubscription
>;
export type OnStudioChatUpdatedSubscriptionResult =
	Apollo.SubscriptionResult<OnStudioChatUpdatedSubscription>;
export const OnStudioLockChangedDocument = gql`
	subscription OnStudioLockChanged($studioFileId: ID!) {
		studioLockChanged(studioFileId: $studioFileId) {
			studioFileId
			userId
			lockedAt
			expiresAt
		}
	}
`;

/**
 * __useOnStudioLockChangedSubscription__
 *
 * To run a query within a React component, call `useOnStudioLockChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStudioLockChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStudioLockChangedSubscription({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useOnStudioLockChangedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnStudioLockChangedSubscription,
		OnStudioLockChangedSubscriptionVariables
	> &
		(
			| { variables: OnStudioLockChangedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnStudioLockChangedSubscription,
		OnStudioLockChangedSubscriptionVariables
	>(OnStudioLockChangedDocument, options);
}
export type OnStudioLockChangedSubscriptionHookResult = ReturnType<
	typeof useOnStudioLockChangedSubscription
>;
export type OnStudioLockChangedSubscriptionResult =
	Apollo.SubscriptionResult<OnStudioLockChangedSubscription>;
export const OnStudioFileVersionAddedDocument = gql`
	subscription OnStudioFileVersionAdded($studioFileId: ID!) {
		studioFileVersionAdded(studioFileId: $studioFileId) {
			id
			name
			versionNumber
			imageUrls
			imageDescription
			changeNotes
			createdAt
			createdBy
			metadata {
				id
				x
				y
				width
				height
				type
				comment
				points {
					x
					y
				}
				canvasWidth
				canvasHeight
				createdAt
			}
			specifications {
				id
				elementName
				elementType
				colors
				material
				secondaryMaterials
				dimensions {
					width
					height
					depth
					diameter
					unit
				}
				weight {
					value
					unit
				}
				capacity {
					value
					unit
				}
				finish
				textureDescription
				features
			}
		}
	}
`;

/**
 * __useOnStudioFileVersionAddedSubscription__
 *
 * To run a query within a React component, call `useOnStudioFileVersionAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnStudioFileVersionAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnStudioFileVersionAddedSubscription({
 *   variables: {
 *      studioFileId: // value for 'studioFileId'
 *   },
 * });
 */
export function useOnStudioFileVersionAddedSubscription(
	baseOptions: Apollo.SubscriptionHookOptions<
		OnStudioFileVersionAddedSubscription,
		OnStudioFileVersionAddedSubscriptionVariables
	> &
		(
			| { variables: OnStudioFileVersionAddedSubscriptionVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSubscription<
		OnStudioFileVersionAddedSubscription,
		OnStudioFileVersionAddedSubscriptionVariables
	>(OnStudioFileVersionAddedDocument, options);
}
export type OnStudioFileVersionAddedSubscriptionHookResult = ReturnType<
	typeof useOnStudioFileVersionAddedSubscription
>;
export type OnStudioFileVersionAddedSubscriptionResult =
	Apollo.SubscriptionResult<OnStudioFileVersionAddedSubscription>;
